(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.jJ.c3 === region.h3.c3)
	{
		return 'on line ' + region.jJ.c3;
	}
	return 'on lines ' + region.jJ.c3 + ' through ' + region.h3.c3;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

var _Json_decodeInt = { $: 2 };
var _Json_decodeBool = { $: 3 };
var _Json_decodeFloat = { $: 4 };
var _Json_decodeValue = { $: 5 };
var _Json_decodeString = { $: 6 };

function _Json_decodeList(decoder) { return { $: 7, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 8, b: decoder }; }

function _Json_decodeNull(value) { return { $: 9, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 10,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 11,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 12,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 13,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 14,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 15,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 3:
			return (typeof value === 'boolean')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a BOOL', value);

		case 2:
			if (typeof value !== 'number') {
				return _Json_expecting('an INT', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return $elm$core$Result$Ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return $elm$core$Result$Ok(value);
			}

			return _Json_expecting('an INT', value);

		case 4:
			return (typeof value === 'number')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a FLOAT', value);

		case 6:
			return (typeof value === 'string')
				? $elm$core$Result$Ok(value)
				: (value instanceof String)
					? $elm$core$Result$Ok(value + '')
					: _Json_expecting('a STRING', value);

		case 9:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 5:
			return $elm$core$Result$Ok(_Json_wrap(value));

		case 7:
			if (!Array.isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 8:
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 10:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 11:
			var index = decoder.e;
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 12:
			if (typeof value !== 'object' || value === null || Array.isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 13:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 14:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 15:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 3:
		case 2:
		case 4:
		case 6:
		case 5:
			return true;

		case 9:
			return x.c === y.c;

		case 7:
		case 8:
		case 12:
			return _Json_equality(x.b, y.b);

		case 10:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 11:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 13:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 14:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 15:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nC,
		impl.mV,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		lT: func(record.lT),
		gM: record.gM,
		gn: record.gn
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.lT;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.gM;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.gn) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nC,
		impl.mV,
		function(sendToApp, initialModel) {
			var view = impl.j7;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lB,
		impl.nC,
		impl.mV,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.gD && impl.gD(sendToApp)
			var view = impl.j7;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.kx);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.nb) && (_VirtualDom_doc.title = title = doc.nb);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.l7;
	var onUrlRequest = impl.l8;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		gD: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jr === next.jr
							&& curr.$9 === next.$9
							&& curr.jj.a === next.jj.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lB: function(flags)
		{
			return A3(impl.lB, flags, _Browser_getUrl(), key);
		},
		j7: impl.j7,
		nC: impl.nC,
		mV: impl.mV
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { ls: 'hidden', kK: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { ls: 'mozHidden', kK: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { ls: 'msHidden', kK: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { ls: 'webkitHidden', kK: 'webkitvisibilitychange' }
		: { ls: 'hidden', kK: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jC: _Browser_getScene(),
		j8: {
			ab: _Browser_window.pageXOffset,
			ad: _Browser_window.pageYOffset,
			kc: _Browser_doc.documentElement.clientWidth,
			im: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		kc: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		im: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jC: {
				kc: node.scrollWidth,
				im: node.scrollHeight
			},
			j8: {
				ab: node.scrollLeft,
				ad: node.scrollTop,
				kc: node.clientWidth,
				im: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jC: _Browser_getScene(),
			j8: {
				ab: x,
				ad: y,
				kc: _Browser_doc.documentElement.clientWidth,
				im: _Browser_doc.documentElement.clientHeight
			},
			k7: {
				ab: x + rect.left,
				ad: y + rect.top,
				kc: rect.width,
				im: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F2(function(request, maybeProgress)
{
	return _Scheduler_binding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		_Http_configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_Scheduler_fail($elm$http$Http$NetworkError));
		});
		xhr.addEventListener('timeout', function() {
			callback(_Scheduler_fail($elm$http$Http$Timeout));
		});
		xhr.addEventListener('load', function() {
			callback(_Http_handleResponse(xhr, request.h9.a));
		});

		try
		{
			xhr.open(request.lV, request.nD, true);
		}
		catch (e)
		{
			return callback(_Scheduler_fail($elm$http$Http$BadUrl(request.nD)));
		}

		_Http_configureRequest(xhr, request);

		var body = request.kx;
		xhr.send($elm$http$Http$Internal$isStringBody(body)
			? (xhr.setRequestHeader('Content-Type', body.a), body.b)
			: body.a
		);

		return function() { xhr.abort(); };
	});
});

function _Http_configureProgress(xhr, maybeProgress)
{
	if (!$elm$core$Maybe$isJust(maybeProgress))
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_Scheduler_rawSpawn(maybeProgress.a({
			kE: event.loaded,
			kF: event.total
		}));
	});
}

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.il; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}

	xhr.responseType = request.h9.b;
	xhr.withCredentials = request.nM;

	$elm$core$Maybe$isJust(request.jX) && (xhr.timeout = request.jX.a);
}


// RESPONSES

function _Http_handleResponse(xhr, responseToResult)
{
	var response = _Http_toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _Scheduler_fail($elm$http$Http$BadStatus(response));
	}

	var result = responseToResult(response);

	if ($elm$core$Result$isOk(result))
	{
		return _Scheduler_succeed(result.a);
	}
	else
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(A2($elm$http$Http$BadPayload, result.a, response));
	}
}

function _Http_toResponse(xhr)
{
	return {
		nD: xhr.responseURL,
		K: { kM: xhr.status, lT: xhr.statusText },
		il: _Http_parseHeaders(xhr.getAllResponseHeaders()),
		kx: xhr.response
	};
}

function _Http_parseHeaders(rawHeaders)
{
	var headers = $elm$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function _Http_expectStringResponse(responseToResult)
{
	return {
		$: 0,
		b: 'text',
		a: responseToResult
	};
}

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		b: expect.b,
		a: function(response) {
			var convertedResponse = expect.a(response);
			return A2($elm$core$Result$map, func, convertedResponse);
		}
	};
});


// BODY

function _Http_multipart(parts)
{


	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}

	return $elm$http$Http$Internal$FormDataBody(formData);
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.i4) { flags += 'm'; }
	if (options.hw) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.l) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.n),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.n);
		} else {
			var treeLen = builder.l * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.l);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.n) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.n);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{p: nodeList, l: (len / $elm$core$Array$branchFactor) | 0, n: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ih: fragment, $9: host, gl: path, jj: port_, jr: protocol, js: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$LandingSite$Page$Home = {$: 0};
var $author$project$LandingSite$Main$SetTimeZone = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandingSite$Main$Tick = function (a) {
	return {$: 1, a: a};
};
var $author$project$Eth$Config$BasicConfig = F5(
	function (contracts, cTokensRaw, tokens, interestModels, blocks) {
		return {dH: blocks, hu: cTokensRaw, hN: contracts, lD: interestModels, nk: tokens};
	});
var $author$project$Eth$Ethereum$Contract = $elm$core$Basics$identity;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Eth$Decoders$decodeContractAddress = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string));
var $author$project$Eth$Config$InterestRateModelConfig = F2(
	function (contract, address) {
		return {hd: address, kW: contract};
	});
var $author$project$Eth$Config$decodeInterestRateModel = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Eth$Config$InterestRateModelConfig,
	A2($elm$json$Json$Decode$field, 'contract', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress));
var $author$project$Eth$Config$RawCTokenConfig = F5(
	function (name, symbol, decimals, address, underlying) {
		return {hd: address, aL: decimals, i5: name, jS: symbol, cy: underlying};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Eth$Config$decodeRawCToken = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Eth$Config$RawCTokenConfig,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress),
	A2($elm$json$Json$Decode$field, 'underlying', $author$project$Eth$Decoders$decodeContractAddress));
var $author$project$Eth$Config$TokenConfig = F6(
	function (name, symbol, decimals, address, supported, reader) {
		return {hd: address, aL: decimals, i5: name, ju: reader, jR: supported, jS: symbol};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Eth$Config$decodeToken = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Eth$Config$TokenConfig,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'supported', $elm$json$Json$Decode$bool)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'reader', $author$project$Eth$Decoders$decodeContractAddress)));
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Eth$Config$basicConfigDecoder = $elm$json$Json$Decode$dict(
	$elm$json$Json$Decode$maybe(
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$Eth$Config$BasicConfig,
			A2(
				$elm$json$Json$Decode$field,
				'Contracts',
				$elm$json$Json$Decode$dict($author$project$Eth$Decoders$decodeContractAddress)),
			A2(
				$elm$json$Json$Decode$field,
				'cTokens',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeRawCToken)),
			A2(
				$elm$json$Json$Decode$field,
				'Tokens',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeToken)),
			A2(
				$elm$json$Json$Decode$field,
				'InterestRateModel',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeInterestRateModel)),
			A2(
				$elm$json$Json$Decode$field,
				'Blocks',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)))));
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Governance$AccountProfile$Loading = {$: 2};
var $author$project$Governance$AccountProfile$emptyState = {aK: $author$project$Governance$AccountProfile$Loading, bO: 1, h6: _List_Nil, ee: $elm$core$Maybe$Nothing, ef: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, eh: $elm$core$Maybe$Nothing, dA: $elm$core$Dict$empty};
var $author$project$Governance$Home$Loading = {$: 2};
var $author$project$Governance$Home$emptyState = {h6: _List_Nil, bW: $author$project$Governance$Home$Loading, c0: $author$project$Governance$Home$Loading, ds: $author$project$Governance$Home$Loading};
var $author$project$Governance$Leaderboard$Loading = {$: 2};
var $author$project$Governance$Leaderboard$emptyState = {h6: _List_Nil, dr: $author$project$Governance$Leaderboard$Loading};
var $author$project$Governance$ProposalDetail$Loading = {$: 2};
var $author$project$Governance$ProposalDetail$emptyState = {bH: $author$project$Governance$ProposalDetail$Loading, h6: _List_Nil, bT: $author$project$Governance$ProposalDetail$Loading, aa: $author$project$Governance$ProposalDetail$Loading, es: $author$project$Governance$ProposalDetail$Loading, dh: $elm$core$Maybe$Nothing};
var $author$project$Governance$ProposalOverview$Loading = {$: 2};
var $author$project$Governance$ProposalOverview$emptyState = {bN: 1, h6: _List_Nil, ci: $elm$core$Dict$empty, cw: $author$project$Governance$ProposalOverview$Loading};
var $author$project$LandingSite$About$emptyState = {h6: _List_Nil, d6: $elm$core$Maybe$Nothing};
var $author$project$Strings$Translations$En = 0;
var $author$project$Utils$CompoundHtmlAttributes$External = 2;
var $author$project$LandingSite$Page$Markets = {$: 7};
var $author$project$Utils$CompoundHtmlAttributes$PageNavigation = 0;
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Strings$Translations$can_i_transfer = function (lang) {
	switch (lang) {
		case 0:
			return 'Can I transfer cTokens?';
		case 1:
			return '¿Puedo transferir cTokens?';
		case 2:
			return 'cToken可以转账吗？';
		case 3:
			return 'Puis-je transférer des cTokens?';
		default:
			return 'cToken을 양도 할 수 있습니까?';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Yes, but exercise caution! By transferring cTokens, you’re transferring your balance of the underlying asset inside the Compound protocol. If you send a cToken to your friend, your balance (viewable in the ';
		case 1:
			return 'Sí, ¡pero ten cuidado! Al transferir cTokens, está transfiriendo su saldo del activo subyacente dentro del Protocolo Compound. Si envía un cToken a su amigo, su saldo (visible en el';
		case 2:
			return '是的，但请谨慎行事！通过转移cTokens，您将在复合协议中转移基础资产的余额。如果您将cToken发送给您的朋友，您的余额（可在以下位置查看）';
		case 3:
			return 'Oui, mais soyez prudent! En transférant des cTokens, vous transférez votre solde de l\'actif sous-jacent à l\'intérieur du protocole composé. Si vous envoyez un cToken à votre ami, votre solde (visible dans le';
		default:
			return '네,하지만 조심하세요! cToken을 전송하면 Compound 프로토콜 내에서 기본 자산의 잔액이 전송됩니다. cToken을 친구에게 보내면 잔액 (';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_end = function (lang) {
	switch (lang) {
		case 0:
			return ') will decline, and your friend will see their balance increase.';
		case 1:
			return ') disminuirá y su amigo verá aumentar su saldo.';
		case 2:
			return '）会下降，你的朋友会看到他们的余额增加。';
		case 3:
			return ') diminuera et votre ami verra son solde augmenter.';
		default:
			return ')가 거부되고 친구의 잔액이 증가합니다.';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Interface';
		case 1:
			return 'Interfaz de Compound';
		case 2:
			return 'Compound 界面';
		case 3:
			return 'Interface composée';
		default:
			return '복합 인터페이스';
	}
};
var $author$project$Strings$Translations$can_you_walk_me = function (lang) {
	switch (lang) {
		case 0:
			return 'Can you walk me through an example?';
		case 1:
			return '¿Puedes guiarme a través de un ejemplo?';
		case 2:
			return '举个例子？';
		case 3:
			return 'Pouvez-vous me montrer un exemple?';
		default:
			return '예를 들어보실 수 있습니까?';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Let’s say you supply 1,000 DAI to the Compound protocol, when the exchange rate is 0.020070; you would receive 49,825.61 cDAI (1,000/0.020070).';
		case 1:
			return 'Supongamos que suministra 1,000 DAI al Protocolo Compound, cuando el tipo de cambio es 0.020070; recibirías 49,825.61 cDAI (1,000 / 0.020070).';
		case 2:
			return '假设您在Compound协议中提供1,000 DAI，当汇率为0.020070时;你会得到49,825.61 cDAI（1,000 / 0.020070）。';
		case 3:
			return 'Supposons que vous fournissiez 1 000 DAI au protocole composé, lorsque le taux de change est de 0,020070; vous recevrez 49 825,61 cDAI (1 000 / 0,020070).';
		default:
			return '환율이 0.020070 일 때 화합물 프로토콜에 1,000 개의 DAI를 공급한다고 가정합니다. 49,825.61 cDAI (1,000 / 0.020070)를 받게됩니다.';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'A few months later, you decide it’s time to withdraw your DAI from the protocol; the exchange rate is now 0.021591:';
		case 1:
			return 'Unos meses después, decide que es hora de retirar su DAI del protocolo; el tipo de cambio ahora es 0.021591:';
		case 2:
			return '几个月后，您决定归还cDAI，取出DAI; 汇率现在是0.021591：';
		case 3:
			return 'Quelques mois plus tard, vous décidez qu\'il est temps de retirer votre DAI du protocole; le taux de change est désormais 0,021591:';
		default:
			return '몇 달 후, 귀하는 프로토콜에서 DAI를 철회 할 때가되었습니다. 환율은 현재 0.021591입니다.';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Your 49,825.61 cDAI is now equal to 1,075.78 DAI (49,825.61 * 0.021591)';
		case 1:
			return 'Su 49,825.61 cDAI ahora es igual a 1,075.78 DAI (49,825.61 * 0.021591)';
		case 2:
			return '您的49,825.61 cDAI现在等于1,075.78 DAI（49,825.61 * 0.021591）';
		case 3:
			return 'Votre 49825,61 cDAI est maintenant égal à 1075,78 DAI (49825,61 * 0,021591)';
		default:
			return '귀하의 49,825.61 cDAI는 이제 1,075.78 DAI (49,825.61 * 0.021591)와 같습니다.';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_4 = function (lang) {
	switch (lang) {
		case 0:
			return 'You could withdraw 1,075.78 DAI, which would redeem all 49,825.61 cDAI';
		case 1:
			return 'Puede retirar 1,075.78 DAI, lo que redimiría todos los 49,825.61 cDAI';
		case 2:
			return '您可以归还所有的49,825.61 cDAI，便可取出1,075.78 DAI。';
		case 3:
			return 'Vous pouvez retirer 1075,78 DAI, ce qui rachèterait les 49825,61 cDAI';
		default:
			return '1,075.78 DAI를 인출하여 49,825.61 cDAI를 모두 사용할 수 있습니다';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_5 = function (lang) {
	switch (lang) {
		case 0:
			return 'Or, you could withdraw a portion, such as your original 1,000 DAI, which would redeem 46,315.59 cDAI (keeping 3,510.01 cDAI in your wallet)';
		case 1:
			return 'O bien, puede retirar una parte, como su 1,000 DAI original, que redimiría 46,315.59 cDAI (manteniendo 3,510.01 cDAI en su billetera)';
		case 2:
			return '或者，您可以归还一部分cDAI，比如46,315.59 cDAI，得到1,000 DAI，在钱包中依然可以保留3,510.01 cDAI。';
		case 3:
			return 'Vous pouvez également retirer une partie, comme votre 1 000 DAI d\'origine, qui rapporterait 46 315,59 cDAI (en conservant 3 510,01 cDAI dans votre portefeuille)';
		default:
			return '또는 원래 1,000 DAI와 같은 일부를 인출하여 46,315.59 cDAI를 교환 할 수 있습니다 (지갑에 3,510.01 cDAI 유지)';
	}
};
var $author$project$Strings$Translations$do_i_need = function (lang) {
	switch (lang) {
		case 0:
			return 'Do I need to calculate the cToken exchange rate?';
		case 1:
			return '¿Necesito calcular el tipo de cambio de cToken?';
		case 2:
			return '我需要计算cToken的汇率吗？';
		case 3:
			return 'Dois-je calculer le taux de change cToken?';
		default:
			return 'cToken 환율을 계산해야합니까?';
	}
};
var $author$project$Strings$Translations$do_i_need_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'When a market is launched, the cToken exchange rate (how much ETH one cETH is worth) begins at 0.020000 — and increases at a rate equal to the compounding market interest rate. For example, after one year, the exchange rate might equal 0.021591.';
		case 1:
			return 'Cuando se lanza un mercado, el tipo de cambio cToken (cuánto vale ETH un cETH) comienza en 0.020000 y aumenta a un tipo igual al tipo de interés compuesto del mercado. Por ejemplo, después de un año, el tipo de cambio podría ser igual a 0.021591.';
		case 2:
			return '当一个市场启动时，cToken汇率（一个cETH兑换多少ETH）开始于0.020000，然后以复合市场的利率增加。 例如，一年后，汇率可能等于0.021591。';
		case 3:
			return 'Lorsqu\'un marché est lancé, le taux de change cToken (combien ETH vaut un ETC) commence à 0,020000 - et augmente à un taux égal au taux d\'intérêt du marché composé. Par exemple, après un an, le taux de change peut être égal à 0,021591.';
		default:
			return '시장이 시작되면 cToken 환율 (1 cETH의 가치가있는 ETH 금액)은 0.020000에서 시작하여 복합 시장 이자율과 동일한 비율로 증가합니다. 예를 들어, 1 년 후 환율은 0.021591이 될 수 있습니다.';
	}
};
var $author$project$Strings$Translations$do_i_need_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each user has the same cToken exchange rate; there’s nothing unique to your wallet that you have to worry about.';
		case 1:
			return 'Cada usuario tiene el mismo tipo de cambio cToken; No hay nada único en su billetera de lo que deba preocuparse.';
		case 2:
			return '可以保证每个用户的cToken汇率是相同的；无需担心。';
		case 3:
			return 'Chaque utilisateur a le même taux de change cToken; il n\'y a rien d\'unique à votre portefeuille dont vous devez vous soucier.';
		default:
			return '각 사용자는 동일한 cToken 환율을 갖습니다. 걱정할만한 지갑은 없습니다.';
	}
};
var $author$project$LandingSite$Page$getHrefUrl = function (page) {
	switch (page.$) {
		case 0:
			return '/';
		case 1:
			var fragment = page.a;
			var subsection = function () {
				if (!fragment.$) {
					var s = fragment.a;
					return '#' + s;
				} else {
					return '';
				}
			}();
			var base = '/about';
			return _Utils_ap(base, subsection);
		case 2:
			return '/governance/comp';
		case 3:
			return '/ctokens';
		case 4:
			return '/developers';
		case 5:
			var subPage = page.a;
			var fragment = page.b;
			var subsection = function () {
				if (!fragment.$) {
					var s = fragment.a;
					return '#' + s;
				} else {
					return '';
				}
			}();
			var section = function () {
				switch (subPage) {
					case 0:
						return '';
					case 1:
						return '/ctokens';
					case 2:
						return '/comptroller';
					case 3:
						return '/governance';
					case 4:
						return '/prices';
					case 5:
						return '/api';
					default:
						return '/security';
				}
			}();
			var base = '/docs';
			return _Utils_ap(
				base,
				_Utils_ap(section, subsection));
		case 6:
			var networkString = page.a;
			var contractName = page.b;
			return '/docs/abi/' + (networkString + ('/' + contractName));
		case 7:
			return '/markets';
		case 8:
			var underlyingSymbol = page.a;
			return '/markets/' + underlyingSymbol;
		case 9:
			var address = page.a;
			return '/governance/address/' + address;
		case 10:
			return '/governance';
		case 11:
			var proposalId = page.a;
			return '/governance/proposals/' + $elm$core$String$fromInt(proposalId);
		case 12:
			return '/governance/proposals';
		case 13:
			return '/governance/leaderboard';
		default:
			return '/prices';
	}
};
var $author$project$Strings$Translations$how_do_cTokens = function (lang) {
	switch (lang) {
		case 0:
			return 'How do cTokens earn interest?';
		case 1:
			return '¿Cómo ganan intereses los cTokens?';
		case 2:
			return 'cTokens 如何赚取利息？';
		case 3:
			return 'Comment les cTokens génèrent-ils des intérêts?';
		default:
			return 'cToken은 어떻게이자를 얻습니까?';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Each ';
		case 1:
			return 'Cada';
		case 2:
			return '每个';
		case 3:
			return 'Chaque';
		default:
			return '마다';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_end = function (lang) {
	switch (lang) {
		case 0:
			return ' has its own Supply interest rate (APR). Interest isn\'t distributed; instead, simply by holding cTokens, you\'ll earn interest.';
		case 1:
			return 'tiene su propia tasa de interés de suministro (APR). El interés no se distribuye; en cambio, simplemente manteniendo cTokens, ganarás intereses.';
		case 2:
			return '有自己的供应利率（APR）。利息不分配；相反，只需持有cTokens，您就可以获得利息。';
		case 3:
			return 'a son propre taux d\'intérêt d\'approvisionnement (APR). L\'intérêt n\'est pas distribué; au lieu de cela, simplement en détenant cTokens, vous gagnerez de l\'intérêt.';
		default:
			return '자체 공급 금리 (APR)가 있습니다. 이자는 분배되지 않습니다. 대신, 단순히 cToken을 보유함으로써 관심을 얻게됩니다.';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_link = function (lang) {
	switch (lang) {
		case 0:
			return 'market';
		case 1:
			return 'mercado';
		case 2:
			return '市场';
		case 3:
			return 'marché';
		default:
			return '마켓';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens accumulates interest through their exchange rate — over time, each cToken becomes convertible into an increasing amount of it\'s underlying asset, even while the number of cTokens in your wallet stays the same.';
		case 1:
			return 'cTokens acumula intereses a través de su tipo de cambio: con el tiempo, cada cToken se convierte en una cantidad creciente de su activo subyacente, incluso mientras el número de cTokens en su billetera se mantiene igual.';
		case 2:
			return 'cToken通过汇率累积利息 - 随着时间的推移，每个cToken对应的底层（被抵押）资产数量会增加，即使你钱包中的cToken数量保持不变。';
		case 3:
			return 'Les cTokens accumulent des intérêts grâce à leur taux de change - au fil du temps, chaque cToken devient convertible en une quantité croissante de son actif sous-jacent, même si le nombre de cTokens dans votre portefeuille reste le même.';
		default:
			return 'cTokens는 환율을 통해이자를 누적합니다. 시간이 지남에 따라 각 cToken은 증가하는 양의 기본 자산으로 전환 할 수있게됩니다. 지갑의 cToken 수는 동일하게 유지됩니다.';
	}
};
var $author$project$Strings$Translations$how_do_i = function (lang) {
	switch (lang) {
		case 0:
			return 'How do I view my cTokens?';
		case 1:
			return '¿Cómo veo mis cTokens?';
		case 2:
			return '如何查看我的cToken?';
		case 3:
			return 'Comment visualiser mes cTokens?';
		default:
			return 'cToken을 어떻게 봅니까?';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Each cToken is visible on ';
		case 1:
			return 'Cada cToken es visible en';
		case 2:
			return '每个cToken都可见';
		case 3:
			return 'Chaque cToken est visible sur';
		default:
			return '각 cToken은';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_end = function (lang) {
	switch (lang) {
		case 0:
			return ', and you should be able to view them in the list of tokens associated with your address';
		case 1:
			return ', y debería poder verlos en la lista de tokens asociados con su dirección';
		case 2:
			return '，您应该能够在与您的地址相关联的代币列表中查看它们';
		case 3:
			return ', et vous devriez pouvoir les afficher dans la liste des jetons associés à votre adresse';
		default:
			return '주소와 연결된 토큰 목록에서 해당 토큰을 볼 수 있어야합니다';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Etherscan';
		case 1:
			return 'Etherscan';
		case 2:
			return 'Etherscan';
		case 3:
			return 'Etherscan';
		default:
			return 'Etherscan';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'cToken balances have been integrated into ';
		case 1:
			return 'Los saldos de cToken se han integrado en';
		case 2:
			return 'cToken余额已整合到';
		case 3:
			return 'Les soldes cToken ont été intégrés dans';
		default:
			return 'c 토큰 잔액이';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_end = function (lang) {
	switch (lang) {
		case 0:
			return ' and MetaMask; other wallets may add cToken support';
		case 1:
			return 'y MetaMask; otras billeteras pueden agregar soporte cToken';
		case 2:
			return '和MetaMask；其他钱包可能会添加cToken支持';
		case 3:
			return 'et MetaMask; d\'autres portefeuilles peuvent ajouter le support de cToken';
		default:
			return '및 메타 마스크; 다른 지갑은 cToken 지원을 추가 할 수 있습니다';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Coinbase Wallet';
		case 1:
			return 'Coinbase Wallet';
		case 2:
			return 'Coinbase钱包';
		case 3:
			return 'Portefeuille Coinbase';
		default:
			return 'Coinbase Wallet';
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Utils$CompoundHtmlAttributes$href = F2(
	function (linkType, linkString) {
		var relAttributes = function () {
			switch (linkType) {
				case 1:
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'rel', 'internal')
						]);
				case 2:
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'rel', 'external')
						]);
				default:
					return _List_Nil;
			}
		}();
		return _Utils_ap(
			relAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'href', linkString)
				]));
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Utils$CompoundHtmlAttributes$target = function (targetName) {
	return A2($elm$html$Html$Attributes$attribute, 'target', targetName);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$LandingSite$CTokens$accordianData = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Strings$Translations$how_do_cTokens(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_1_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_cTokens_description_1_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_1_end(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$do_i_need(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$do_i_need_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$do_i_need_description_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$can_you_walk_me(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_you_walk_me_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_you_walk_me_description_2(userLanguage))
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_3(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_4(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_5(userLanguage))
										]))
								]))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$how_do_i(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_1_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://etherscan.io/tokens/label/compound')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_i_description_1_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_1_end(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_2_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://itunes.apple.com/us/app/coinbase-wallet/id1278383455')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_i_description_2_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_2_end(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$can_i_transfer(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_i_transfer_description_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$can_i_transfer_description_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_i_transfer_description_end(userLanguage))
						]))
				]))
		]);
};
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$LandingSite$CTokens$emptyState = {
	dB: 0,
	cP: false,
	h6: _List_Nil,
	bd: A2(
		$elm$core$Array$repeat,
		$elm$core$List$length(
			$author$project$LandingSite$CTokens$accordianData(0)),
		false),
	b_: $elm$core$Maybe$Nothing,
	cm: $elm$core$Maybe$Nothing
};
var $author$project$LandingSite$CommonViews$emptyState = {bp: false};
var $author$project$LandingSite$Page$GovernanceAccountProfile = function (a) {
	return {$: 9, a: a};
};
var $author$project$Strings$Translations$comp_faq_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'What is COMP, and why is it being distributed?';
		case 1:
			return '¿Qué es COMP y por qué se distribuye?';
		case 2:
			return 'COMP是什么，为什么要分发释放这个通证？';
		case 3:
			return 'Qu\'est-ce que COMP et pourquoi est-il distribué?';
		default:
			return 'COMP란 무엇이며 왜 분배되고 있나요?';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_link_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'delegates';
		case 1:
			return 'delegados';
		case 2:
			return '代表';
		case 3:
			return 'délégués';
		default:
			return '투표 대리인';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_link_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'propose';
		case 1:
			return 'proponer';
		case 2:
			return '提出';
		case 3:
			return 'proposer';
		default:
			return '제안';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_link_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'vote';
		case 1:
			return 'votar';
		case 2:
			return '投票';
		case 3:
			return 'voter';
		default:
			return '투표';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_part_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound (COMP) is an ERC-20 asset that empowers community governance of the Compound protocol; COMP token-holders and their ';
		case 1:
			return 'Compuesto (COMP) es un activo ERC-20 que potencia la gobernanza comunitaria del protocolo Compuesto; Titulares de tokens COMP y sus';
		case 2:
			return '复合（COMP）是ERC-20资产，可增强对复合协议的社区治理； COMP代币持有者及其';
		case 3:
			return 'Compound (COMP) est un atout ERC-20 qui renforce la gouvernance communautaire du protocole Compound; Les détenteurs de jetons COMP et leurs';
		default:
			return 'Compound (COMP)는 ERC-20 자산이며 Compound 프로토콜에 대한 커뮤니티 거버넌스 도구입니다. COMP 토큰 보유자와 ';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_part_2 = function (lang) {
	switch (lang) {
		case 0:
			return ' debate, ';
		case 1:
			return 'debate,';
		case 2:
			return '辩论，';
		case 3:
			return 'débat,';
		default:
			return ' 토론,';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_part_3 = function (lang) {
	switch (lang) {
		case 0:
			return ', and ';
		case 1:
			return 'y';
		case 2:
			return '和';
		case 3:
			return ', et';
		default:
			return ',';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_part_4 = function (lang) {
	switch (lang) {
		case 0:
			return ' on all changes to the protocol.';
		case 1:
			return 'en todos los cambios al protocolo.';
		case 2:
			return '对协议的所有更改。';
		case 3:
			return 'sur toutes les modifications apportées au protocole.';
		default:
			return ' 등 프로토콜 변경과 관련된 모든 곳에서 사용됩니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_1_description_part_5 = function (lang) {
	switch (lang) {
		case 0:
			return 'By placing COMP directly into the hands of users and applications, an increasingly large ecosystem will be able to upgrade the protocol, and will be incentivized to collectively steward the protocol into the future with good governance.';
		case 1:
			return 'Al colocar COMP directamente en manos de los usuarios y las aplicaciones, un ecosistema cada vez más grande podrá actualizar el protocolo y se le incentivará para administrar colectivamente el protocolo hacia el futuro con un buen gobierno.';
		case 2:
			return '通过直接将COMP交到用户和应用程序手中，一个越来越大的生态系统将能够升级该协议，并且将受到激励，通过良好的管理集体将协议推向未来。';
		case 3:
			return 'En plaçant COMP directement entre les mains des utilisateurs et des applications, un écosystème de plus en plus vaste sera en mesure de mettre à niveau le protocole et sera incité à gérer collectivement le protocole à l\'avenir avec une bonne gouvernance.';
		default:
			return 'COMP를 Compound 이용자와 애플리케이션에게 직접 제공하면, 프로토콜 업그레이드에 참여하는 생태계 참가자는 더욱 많아질 것이며, 좋은 거버넌스를 가진 프로토콜로 발전시키는데 동기 부여가 될 것으로 기대하고 있습니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'How does the distribution work?';
		case 1:
			return '¿Cómo funciona la distribución?';
		case 2:
			return 'COMP通证是如何释放给用户的？';
		case 3:
			return 'Comment fonctionne la distribution?';
		default:
			return '분배는 어떤 방식으로 진행되나요?';
	}
};
var $author$project$Strings$Translations$comp_faq_2_description_part_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each day, approximately 2,880 COMP will be distributed to users of the protocol; the distribution is allocated to each market (ETH, USDC, DAI…), proportional to borrowing demand in that market.';
		case 1:
			return 'Cada día, se distribuirán aproximadamente 2.880 COMP a los usuarios del protocolo; la distribución se asigna a cada mercado (ETH, USDC, DAI ...), proporcional a la demanda de préstamos en ese mercado.';
		case 2:
			return '每天，将向该协议的用户分发约2880个COMP。分配分配给每个市场（ETH，USDC，DAI…），与该市场的借贷需求成比例。';
		case 3:
			return 'Chaque jour, environ 2 880 COMP seront distribués aux utilisateurs du protocole; la distribution est allouée à chaque marché (ETH, USDC, DAI…), proportionnelle à la demande d\'emprunt sur ce marché.';
		default:
			return '매일 약 2,880 개의 COMP가 프로토콜 이용자에게 분배될 것입니다. 분배 수량은 각각의 마켓(ETH, USDC, DAI 등)에서 발생한 대출 수요에 비례하여 할당됩니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_2_description_part_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Within each market, 50% of the distribution is earned by suppliers, and 50% by borrowers; these allocations are shown in the Market Distribution table above.';
		case 1:
			return 'Dentro de cada mercado, el 50% de la distribución es ganada por los proveedores y el 50% por los prestatarios; estas asignaciones se muestran en la tabla de Distribución del mercado anterior.';
		case 2:
			return '在每个市场中，存款人(supplier) 获得了50％的收益，借款人(borrower) 获得了50％的收益； 以上分配数量显示在本页的“市场分布”表中。';
		case 3:
			return 'Au sein de chaque marché, 50% de la distribution est gagnée par les fournisseurs et 50% par les emprunteurs; ces allocations sont présentées dans le tableau Distribution du marché ci-dessus.';
		default:
			return '각각의 마켓 내에서 분배 수량의 50%는 공급자에게 돌아가고, 나머지 50%는 대출자에게 제공됩니다. 분배 현황은 상단의 마켓 분배 현황 테이블에서 확인하실 수 있습니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'As a user, what do I need to do to receive COMP?';
		case 1:
			return 'Como usuario, ¿qué debo hacer para recibir COMP?';
		case 2:
			return '作为用户，我如何得到COMP?';
		case 3:
			return 'En tant qu\'utilisateur, que dois-je faire pour recevoir COMP?';
		default:
			return '이용자가 COMP를 받으려면 어떻게 해야하나요?';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_link_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'withdraw';
		case 1:
			return 'retirar';
		case 2:
			return '退出';
		case 3:
			return 'se désister';
		default:
			return '받기 요청';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_link_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'here\'s the profile';
		case 1:
			return 'aquí está el perfil';
		case 2:
			return '这是个人资料';
		case 3:
			return 'voici le profil';
		default:
			return '이 프로필은 ';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_part_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each time you interact with a Compound market (by supplying, borrowing, withdraw, or repaying the asset), COMP will be automatically transferred into your wallet, if you\'ve accrued at least .001 COMP; at any time, you can manually ';
		case 1:
			return 'Cada vez que interactúa con un mercado Compuesto (al suministrar, pedir prestado, retirar o pagar el activo), COMP se transferirá automáticamente a su billetera, si ha acumulado al menos 0,001 COMP; en cualquier momento, puedes';
		case 2:
			return '每次您与复合市场互动（通过提供，借入，提取或偿还资产）时，如果您累积了至少.001 COMP，COMP就会自动转入您的钱包。您随时可以手动';
		case 3:
			return 'Chaque fois que vous interagissez avec un marché composé (en fournissant, empruntant, retirant ou remboursant l\'actif), COMP sera automatiquement transféré dans votre portefeuille, si vous avez accumulé au moins 0,001 COMP; à tout moment, vous pouvez manuellement';
		default:
			return '자산 공급, 대출, 출금, 상환 등 Compound 마켓과 상호 작용할 때마다 이용자의 지갑으로 COMP가 자동 전송될 것입니다. 자동 전송은 0.001 이상의 COMP가 누적될 때마다 발생합니다. 이용자 앞으로 누적된 COMP는 언제든지 ';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_part_2 = function (lang) {
	switch (lang) {
		case 0:
			return ' all undistributed COMP.';
		case 1:
			return 'todos los COMP no distribuidos';
		case 2:
			return '所有未分配的COMP。';
		case 3:
			return 'tous non distribués COMP.';
		default:
			return '을 할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_part_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'You can view the all time accrued COMP per wallet address, by searching the Compound Governance Explorer profile pages. As an example, ';
		case 1:
			return 'Puede ver el COMP acumulado de todos los tiempos por dirección de billetera, buscando en las páginas de perfil de Compound Governance Explorer. Como ejemplo,';
		case 2:
			return '您可以通过搜索Compound Governance Explorer配置文件页面查看每个钱包地址的所有时间累计COMP。举个例子，';
		case 3:
			return 'Vous pouvez afficher le COMP cumulé de tous les temps par adresse de portefeuille, en recherchant les pages de profil de Compound Governance Explorer. Par exemple,';
		default:
			return 'Compound 거버넌스 탐색기 프로필 페이지를 통해 지갑 주소별로 누적된 COMP를 확인할 수 있습니다. 예를 들어, ';
	}
};
var $author$project$Strings$Translations$comp_faq_3_description_part_4 = function (lang) {
	switch (lang) {
		case 0:
			return ' of the first community member to create a successful proposal.';
		case 1:
			return 'del primer miembro de la comunidad en crear una propuesta exitosa.';
		case 2:
			return '首位成功创建提案的社区成员。';
		case 3:
			return 'du premier membre de la communauté à créer une proposition réussie.';
		default:
			return '성공적인 제안을 작성한 최초의 커뮤니티 구성원에 대한 프로필입니다.';
	}
};
var $author$project$Strings$Translations$comp_faq_4 = function (lang) {
	switch (lang) {
		case 0:
			return 'I\'m building an application; how should I design for the distribution?';
		case 1:
			return 'Estoy construyendo una aplicación; ¿Cómo debo diseñar para la distribución?';
		case 2:
			return '我在开发一个Application，该如何实现给我的用户分配COMP token?';
		case 3:
			return 'Je crée une application; comment dois-je concevoir pour la distribution?';
		default:
			return '애플리케이션을 작성 중입니다. COMP 분배를 받으려면 어떻게 설계해야 하나요?';
	}
};
var $author$project$Strings$Translations$comp_faq_4_description = function (lang) {
	switch (lang) {
		case 0:
			return 'COMP is designed to be distributed only to the address that has accrued the COMP. Your user’s wallets need to be able to send COMP from the same address that is interacting with Compound. This can be done a myriad of ways, but is important to solve for, otherwise COMP will be unclaimed, inaccessible, and forever lost. If you have questions, join our Discord and ask us.';
		case 1:
			return 'COMP está diseñado para distribuirse solo a la dirección que ha acumulado el COMP. Las billeteras de sus usuarios deben poder enviar COMP desde la misma dirección que está interactuando con Compound. Esto se puede hacer de muchas maneras, pero es importante resolverlo; de lo contrario, COMP no se reclamará, será inaccesible y se perderá para siempre. Si tiene preguntas, únase a nuestro Discord y pregúntenos.';
		case 2:
			return '系统设计是这样，COMP只能分配给计息钱包地址。要获得计息的Comp通证，用户必须能够控制那个特定的与Compound协议对接的钱包。虽然实现方法很多，但这很重要请务必重视，否则COMP通证将永远丢失，无法领取，无法使用。如有问题，请在Discord上和我们联系。';
		case 3:
			return 'COMP est conçu pour être distribué uniquement à l\'adresse qui a accumulé le COMP. Les portefeuilles de vos utilisateurs doivent pouvoir envoyer COMP à partir de la même adresse qui interagit avec Composé. Cela peut être fait d\'une multitude de façons, mais il est important de le résoudre, sinon le COMP sera non réclamé, inaccessible et définitivement perdu. Si vous avez des questions, rejoignez notre Discord et demandez-nous.';
		default:
			return 'COMP는 COMP가 누적되는 주소에만 COMP가 분배되는 구조로 설계되었습니다. 사용자의 지갑은 COMP를 전송할 수 있어야 하며, Compound와 상호 작용하는 지갑 주소와 사용자의 지갑 주소는 같아야 합니다. 이 작업은 다양한 방법으로 목표를 달성할 수 있습니다. 위의 조건에 부합하지 않으면, COMP에 대한 클레임 요청을 할 수 없으며, 접근할 수도 없고, 영원히 잃게 됩니다. 이와 관련해 궁금한 점이 있다면 Compound Discord에 문의해주세요.';
	}
};
var $author$project$LandingSite$Comp$accordianData = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Strings$Translations$comp_faq_1(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_1_description_part_1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.comradery.io/post/1464')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$comp_faq_1_description_link_1(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_1_description_part_2(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.comradery.io/post/1469')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$comp_faq_1_description_link_2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_1_description_part_3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.comradery.io/post/1449')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$comp_faq_1_description_link_3(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_1_description_part_4(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_1_description_part_5(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$comp_faq_2(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_2_description_part_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_2_description_part_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$comp_faq_3(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_3_description_part_1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/vote')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$comp_faq_3_description_link_1(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_3_description_part_2(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_3_description_part_3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										$author$project$LandingSite$Page$GovernanceAccountProfile('0x54a37d93e57c5da659f508069cf65a381b61e189')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$comp_faq_3_description_link_2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_3_description_part_4(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$comp_faq_4(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comp_faq_4_description(userLanguage))
						]))
				]))
		]);
};
var $author$project$LandingSite$Comp$emptyState = {
	h6: _List_Nil,
	bd: A2(
		$elm$core$Array$repeat,
		$elm$core$List$length(
			$author$project$LandingSite$Comp$accordianData(0)),
		false),
	ee: $elm$core$Maybe$Nothing
};
var $author$project$LandingSite$DevelopersMarketing$emptyState = {h6: _List_Nil};
var $author$project$Network$MainNet = 1;
var $author$project$Bootstrap$Carousel$Paused = 0;
var $author$project$Bootstrap$Carousel$Active = 1;
var $author$project$Bootstrap$Carousel$defaultStateOptions = {
	ai: 1,
	b2: $elm$core$Maybe$Just(5000),
	c_: true,
	gm: true,
	gL: 0,
	bE: true
};
var $author$project$Bootstrap$Carousel$IgnoreHover = 2;
var $author$project$Bootstrap$Carousel$NotAnimating = {$: 2};
var $author$project$Bootstrap$Carousel$NotHovered = 1;
var $author$project$Bootstrap$Carousel$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Bootstrap$Carousel$initialStateWithOptions = function (options) {
	return A2(
		$author$project$Bootstrap$Carousel$State,
		$author$project$Bootstrap$Carousel$NotAnimating,
		{
			a9: options.gL,
			ai: options.ai,
			cY: options.gm ? 1 : 2,
			b2: A2($elm$core$Maybe$withDefault, 0, options.b2),
			c_: options.c_,
			by: 2,
			bE: options.bE
		});
};
var $author$project$LandingSite$Docs$emptyState = {
	c7: false,
	aS: $author$project$Bootstrap$Carousel$initialStateWithOptions(
		_Utils_update(
			$author$project$Bootstrap$Carousel$defaultStateOptions,
			{
				ai: 0,
				b2: $elm$core$Maybe$Just(0)
			})),
	de: $elm$core$Dict$empty,
	ev: 1
};
var $author$project$LandingSite$Home$Institutions = 2;
var $author$project$LandingSite$Home$emptyState = {
	bL: $author$project$Bootstrap$Carousel$initialStateWithOptions(
		_Utils_update(
			$author$project$Bootstrap$Carousel$defaultStateOptions,
			{ai: 0, gm: false})),
	h6: _List_Nil,
	aY: $author$project$Bootstrap$Carousel$initialStateWithOptions(
		_Utils_update(
			$author$project$Bootstrap$Carousel$defaultStateOptions,
			{
				ai: 0,
				b2: $elm$core$Maybe$Just(0)
			})),
	ew: 2
};
var $author$project$LandingSite$MarketDetail$SupplyTab = 0;
var $author$project$LandingSite$MarketDetail$emptyState = {bG: 0, cF: _List_Nil, cG: $elm$core$Dict$empty, bb: $elm$core$Maybe$Nothing, aP: $elm$core$Maybe$Nothing, b1: $elm$core$Maybe$Nothing, ee: $elm$core$Maybe$Nothing, eg: $elm$core$Maybe$Nothing, cc: $elm$core$Maybe$Nothing, ex: $elm$core$Maybe$Nothing, dj: _List_Nil, dk: $elm$core$Dict$empty, dx: _List_Nil};
var $author$project$LandingSite$Markets$emptyState = {h6: _List_Nil, lu: $elm$core$Maybe$Nothing, ax: $elm$core$Maybe$Nothing};
var $author$project$LandingSite$Prices$NoPrices = {$: 2};
var $author$project$LandingSite$Page$Docs = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$LandingSite$Page$OpenPriceFeed = 4;
var $author$project$Strings$Translations$price_faq_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'What is the Open Price Feed?';
		case 1:
			return '¿Quién puede publicar precios?';
		case 2:
			return '谁可以发布价格？';
		case 3:
			return 'Qui peut afficher les prix?';
		default:
			return '누가 가격을 게시 할 수 있습니까?';
	}
};
var $author$project$Strings$Translations$price_faq_1_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The Open Price Feed is a decentralized price oracle built on Ethereum. It’s made up of Reporters, Posters, and a View to read accepted prices. Anyone with access to reliable price data can post and store their price data on-chain. Any developer can configure a View Contract to their liking, however, the Reporters in the Compound View Contract may only be approved through Compound Governance.';
		case 1:
			return 'Open Price Feed es un oráculo de precios descentralizado construido en Ethereum. Está compuesto por reporteros, carteles y una vista para leer los precios aceptados. Cualquier persona con acceso a datos de precios confiables puede publicar y almacenar sus datos de precios en la cadena. Cualquier desarrollador puede configurar un Contrato de Vista a su gusto, sin embargo, los Reporteros en el Contrato de Vista Compuesto solo pueden ser aprobados a través del Gobierno Compuesto.';
		case 2:
			return 'Open Price Feed是基于以太坊的去中心化价格预言。它由记者，海报和查看已接受价格的视图组成。任何有权访问可靠价格数据的人都可以在链上发布和存储其价格数据。任何开发人员都可以根据自己的喜好配置“查看合同”，但是，“复合视图合同”中的报告者只能通过“复合治理”来批准。';
		case 3:
			return 'L\'Open Price Feed est un oracle de prix décentralisé construit sur Ethereum. Il est composé de reporters, d\'affiches et d\'une vue pour lire les prix acceptés. Toute personne ayant accès à des données de prix fiables peut publier et stocker ses données de prix en chaîne. Tout développeur peut configurer un contrat de vue à son goût, cependant, les rapporteurs dans le contrat de vue composée ne peuvent être approuvés que par le biais de la gouvernance composée.';
		default:
			return 'Open Price Feed는 이더 리움에 구축 된 탈 중앙화 가격 오라클입니다. 수락 된 가격을 읽는 리포터, 포스터 및보기로 구성되어 있습니다. 신뢰할 수있는 가격 데이터에 액세스 할 수있는 사람은 누구나 가격 데이터를 체인에 게시하고 저장할 수 있습니다. 모든 개발자는 원하는대로 뷰 계약을 구성 할 수 있지만 복합 뷰 계약의 리포터는 복합 거버넌스를 통해서만 승인 될 수 있습니다.';
	}
};
var $author$project$Strings$Translations$price_faq_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'What are Reporters?';
		case 1:
			return '¿Como funciona?';
		case 2:
			return '它是如何工作的？';
		case 3:
			return 'Comment ça marche?';
		default:
			return '어떻게 작동합니까?';
	}
};
var $author$project$Strings$Translations$price_faq_2_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Reporters can be exchanges, DeFi projects, applications, OTC trading desks, hobbyists, etc. — basically, anybody with access to price data. Reporters sign a message with a private key and make this signed data available to the public.';
		case 1:
			return 'Los reporteros pueden ser intercambios, proyectos DeFi, aplicaciones, mesas de negociación OTC, aficionados, etc., básicamente, cualquier persona con acceso a datos de precios. Los reporteros firman un mensaje con una clave privada y ponen estos datos firmados a disposición del público.';
		case 2:
			return '记者可以是交易所，DeFi项目，应用程序，场外交易柜台，业余爱好者等，基本上，是任何有权访问价格数据的人。记者使用私钥在邮件上签名，并将签名后的数据公开。';
		case 3:
			return 'Les journalistes peuvent être des bourses, des projets DeFi, des applications, des bureaux de négociation OTC, des amateurs, etc. - en gros, toute personne ayant accès aux données sur les prix. Les journalistes signent un message avec une clé privée et mettent ces données signées à la disposition du public.';
		default:
			return '리포터는 기본적으로 가격 데이터에 액세스 할 수있는 사람이라면 누구나 교환, DeFi 프로젝트, 응용 프로그램, OTC 트레이딩 데스크, 애호가 등이 될 수 있습니다. 기자는 개인 키로 메시지에 서명하고이 서명 된 데이터를 공개 할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$price_faq_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'What are Posters';
		case 1:
			return '¿Puedo registrarme para publicar precios?';
		case 2:
			return '我可以注册发布价格吗？';
		case 3:
			return 'Puis-je m\'inscrire pour afficher les prix?';
		default:
			return '가격을 게시하기 위해 가입 할 수 있습니까?';
	}
};
var $author$project$Strings$Translations$price_faq_3_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Anyone with gas (ETH) and a web3 connection has the ability to post the signed data (from Reporters) on-chain. A crypto exchange may have an extremely accurate and reputable price for a trading pair, but lack the technical capacity (or incentive) to post the data on chain reliably. This responsibility is shared among many Posters.';
		case 1:
			return 'Cualquier persona con gas (ETH) y una conexión web3 tiene la capacidad de publicar los datos firmados (de Reporteros) en la cadena. Un intercambio de cifrado puede tener un precio extremadamente preciso y de buena reputación para un par comercial, pero carece de la capacidad técnica (o incentivo) para publicar los datos en la cadena de manera confiable. Esta responsabilidad se comparte entre muchos carteles.';
		case 2:
			return '具有gas（ETH）和web3连接的任何人都可以将签名的数据（来自Reporters）发布到链上。加密货币交易所的交易对价格可能非常准确且信誉良好，但缺乏将数据可靠地发布到链上的技术能力（或激励措施）。许多海报者分担这项责任。';
		case 3:
			return 'Toute personne disposant de gaz (ETH) et d\'une connexion Web3 a la possibilité de publier les données signées (de Reporters) sur la chaîne. Un échange cryptographique peut avoir un prix extrêmement précis et réputé pour une paire de négociation, mais n\'a pas la capacité technique (ou l\'incitation) pour publier les données sur la chaîne de manière fiable. Cette responsabilité est partagée entre de nombreuses affiches.';
		default:
			return '가스 (ETH) 및 web3 연결이있는 사람은 서명 된 데이터 (리포터의)를 체인에 게시 할 수 있습니다. 암호화 거래소는 거래 쌍에 대해 매우 정확하고 평판이 좋은 가격을 가질 수 있지만 체인에 데이터를 안정적으로 게시 할 기술적 역량 (또는 인센티브)이 부족합니다. 이 책임은 많은 포스터에서 공유됩니다.';
	}
};
var $author$project$Strings$Translations$price_faq_4 = function (lang) {
	switch (lang) {
		case 0:
			return 'What are View Contracts?';
		case 1:
			return '¿Cómo puedo integrar el feed de precios en mi aplicación?';
		case 2:
			return '如何将价格Feed集成到我的应用中？';
		case 3:
			return 'Comment puis-je intégrer le flux de prix dans mon application?';
		default:
			return '가격 피드를 앱에 통합하려면 어떻게해야합니까?';
	}
};
var $author$project$Strings$Translations$price_faq_4_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'View contracts are any combination of Reporters compiled into a single view. For example, The Compound protocol uses a View Contract which incorporates a single Reporter (Coinbase Pro), with an anchoring mechanism inside the View. With enough reporters (approved through Governance), a median price can be used, without relying on an anchor. In the meantime, we believe Coinbase prices anchored by Uniswap to be a robust data source.';
		case 1:
			return 'Los contratos de vista son cualquier combinación de Reporteros compilados en una sola vista. Por ejemplo, el protocolo Compuesto utiliza un Contrato de Vista que incorpora un solo Reportero (Coinbase Pro), con un mecanismo de anclaje dentro de la Vista. Con suficientes reporteros (aprobados a través de Governance), se puede usar un precio medio, sin depender de un ancla. Mientras tanto, creemos que los precios de Coinbase anclados por Uniswap son una fuente de datos sólida.';
		case 2:
			return '查看合同是将Reporters编译为单个视图的任意组合。例如，复合协议使用了一个View Contract，该合同包含一个Reporter（Coinbase Pro），并在View内部具有锚定机制。如果有足够的报告者（通过治理批准），则可以使用中间价格，而无需依赖锚点。同时，我们认为由Uniswap定位的Coinbase价格将成为一个有力的数据来源。';
		case 3:
			return 'Les contrats de vue sont une combinaison de Reporters compilée en une seule vue. Par exemple, le protocole composé utilise un contrat de vue qui incorpore un seul rapporteur (Coinbase Pro), avec un mécanisme d\'ancrage à l\'intérieur de la vue. Avec suffisamment de journalistes (approuvés par la gouvernance), un prix médian peut être utilisé, sans compter sur une ancre. En attendant, nous pensons que les prix Coinbase ancrés par Uniswap sont une source de données robuste.';
		default:
			return '보기 계약은 단일보기로 컴파일 된 Reporter 조합입니다. 예를 들어, 컴파운드 프로토콜은 뷰 내부에 고정 메커니즘이있는 단일 리포터 (Coinbase Pro)를 통합하는 뷰 계약을 사용합니다. 거버넌스를 통해 승인 된 기자가 많으면 앵커에 의존하지 않고 중간 가격을 사용할 수 있습니다. 한편, Uniswap에 의해 고정 된 Coinbase 가격은 강력한 데이터 소스라고 생각합니다.';
	}
};
var $author$project$Strings$Translations$price_faq_4_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Other developers may deploy their own View contracts with whatever combination of Reporters that suits their application best.';
		case 1:
			return 'Otros desarrolladores pueden implementar sus propios contratos de View con cualquier combinación de Reporteros que mejor se adapte a su aplicación.';
		case 2:
			return '其他开发人员可以使用最适合其应用程序的Reporter组合来部署自己的View合同。';
		case 3:
			return 'D\'autres développeurs peuvent déployer leurs propres contrats View avec la combinaison de Reporters qui convient le mieux à leur application.';
		default:
			return '다른 개발자는 자신의 애플리케이션에 가장 적합한 Reporter 조합과 함께 자체 View 계약을 배포 할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$price_faq_5 = function (lang) {
	switch (lang) {
		case 0:
			return 'How can I access the Open Price Feed?';
		case 1:
			return '¿Cómo puedo acceder al feed de precios abiertos?';
		case 2:
			return '如何访问公开价格供稿？';
		case 3:
			return 'Comment puis-je accéder au flux Open Price?';
		default:
			return '공개 가격 피드에 액세스하려면 어떻게합니까?';
	}
};
var $author$project$Strings$Translations$price_faq_5_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Any developer or application can contribute to the Open Price Feed by being a Reporter, Poster, or even by configuring their own View Contract for themselves or others to use. The Open Price Feed is designed to be a foundation that anybody can build on, extend, and improve. The number of Reporters, Posters, and Views can scale over time, as the ecosystem develops. Head to our ';
		case 1:
			return 'Cualquier desarrollador o aplicación puede contribuir al Open Price Feed al ser un reportero, póster o incluso configurando su propio contrato de visualización para que lo usen ellos mismos u otros. El Open Price Feed está diseñado para ser una base sobre la cual cualquiera puede construir, ampliar y mejorar. La cantidad de reporteros, carteles y vistas puede aumentar con el tiempo, a medida que se desarrolla el ecosistema. Dirígete a nuestro';
		case 2:
			return '任何开发人员或应用程序都可以通过成为报告者，海报甚至通过配置自己的查看合同供自己或他人使用来为公开价格供稿做出贡献。公开价格供稿旨在为任何人都可以建立，扩展和改进的基础。随着生态系统的发展，记者，海报和观点的数量可以随着时间而扩展。前往我们的';
		case 3:
			return 'Tout développeur ou application peut contribuer à l\'Open Price Feed en étant un journaliste, un poster ou même en configurant son propre contrat de vue pour lui-même ou pour d\'autres. L\'Open Price Feed est conçu pour être une base sur laquelle n\'importe qui peut s\'appuyer, étendre et améliorer. Le nombre de reporters, d\'affiches et de vues peut évoluer au fil du temps, à mesure que l\'écosystème se développe. Dirigez-vous vers notre';
		default:
			return '모든 개발자 또는 애플리케이션은 리포터, 포스터가되거나 자신 또는 다른 사람이 사용할 수 있도록 자체 뷰 계약을 구성하여 공개 가격 피드에 기여할 수 있습니다. 공개 가격 피드는 누구나 구축, 확장 및 개선 할 수있는 기반이되도록 설계되었습니다. 생태계가 발전함에 따라 리포터, 포스터 및 뷰의 수는 시간이 지남에 따라 확장 될 수 있습니다. 우리에게';
	}
};
var $author$project$Strings$Translations$price_faq_5_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return ' for more information.';
		case 1:
			return 'para más información.';
		case 2:
			return '想要查询更多的信息。';
		case 3:
			return 'pour plus d\'informations.';
		default:
			return '자세한 내용은.';
	}
};
var $author$project$Strings$Translations$price_faq_5_link_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Developer Docs';
		case 1:
			return 'Documentos de desarrollador';
		case 2:
			return '开发人员文档';
		case 3:
			return 'Documents du développeur';
		default:
			return '개발자 문서';
	}
};
var $author$project$LandingSite$Prices$accordianData = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Strings$Translations$price_faq_1(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_1_description(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$price_faq_2(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_2_description(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$price_faq_3(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_3_description(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$price_faq_4(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_4_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_4_description_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$price_faq_5(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_5_description_1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2($author$project$LandingSite$Page$Docs, 4, $elm$core$Maybe$Nothing)))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$price_faq_5_link_1(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$price_faq_5_description_2(userLanguage))
						]))
				]))
		]);
};
var $author$project$LandingSite$Prices$emptyState = {
	h6: _List_Nil,
	bd: A2(
		$elm$core$Array$repeat,
		$elm$core$List$length(
			$author$project$LandingSite$Prices$accordianData(0)),
		false),
	cX: $author$project$LandingSite$Prices$NoPrices,
	lJ: $author$project$LandingSite$Prices$NoPrices
};
var $author$project$Strings$Translations$Es = 1;
var $author$project$Strings$Translations$Fr = 3;
var $author$project$Strings$Translations$Ko = 4;
var $author$project$Strings$Translations$Zh = 2;
var $author$project$Strings$Translations$getLnFromCode = function (code) {
	switch (code) {
		case 'en':
			return 0;
		case 'es':
			return 1;
		case 'zh':
			return 2;
		case 'fr':
			return 3;
		case 'ko':
			return 4;
		default:
			return 0;
	}
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Utils$Graph$emptyState = {ky: $elm$core$Dict$empty, h6: _List_Nil, lf: $elm$core$Dict$empty, fD: $elm$core$Maybe$Nothing, jm: $elm$core$Dict$empty, mX: $elm$core$Dict$empty, nm: $elm$core$Dict$empty, nn: $elm$core$Dict$empty};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Utils$Graph$init = _Utils_Tuple2($author$project$Utils$Graph$emptyState, $elm$core$Platform$Cmd$none);
var $author$project$Network$Goerli = 5;
var $author$project$Network$Kovan = 7;
var $author$project$Network$Rinkeby = 4;
var $author$project$Network$Ropsten = 3;
var $author$project$Network$networkFromName = function (name) {
	var _v0 = $elm$core$String$toLower(name);
	switch (_v0) {
		case 'mainnet':
			return 1;
		case 'ropsten':
			return 3;
		case 'goerli':
			return 5;
		case 'kovan':
			return 7;
		case 'rinkeby':
			return 4;
		default:
			return 1;
	}
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Preferences$USD = 1;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Preferences$askStoredPreferencesPort = _Platform_outgoingPort(
	'askStoredPreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(_List_Nil);
	});
var $author$project$Preferences$askStoredPreferences = $author$project$Preferences$askStoredPreferencesPort(
	{});
var $author$project$Preferences$preferencesInit = function (initialLanguage) {
	return _Utils_Tuple2(
		{bJ: true, k4: 1, cr: true, aB: initialLanguage},
		$author$project$Preferences$askStoredPreferences);
};
var $author$project$LandingSite$Main$DelayScroll = function (a) {
	return {$: 23, a: a};
};
var $author$project$LandingSite$Page$GovernanceHome = {$: 10};
var $author$project$LandingSite$Page$GovernanceLeaderboard = {$: 13};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Functions$demaybeify = function (maybeMaybeVal) {
	if (!maybeMaybeVal.$) {
		var val = maybeMaybeVal.a;
		return val;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$Eth$Ethereum$areContractsEqual = F2(
	function (_v0, _v1) {
		var addressA = _v0;
		var addressB = _v1;
		return _Utils_eq(
			$elm$core$String$toLower(addressA),
			$elm$core$String$toLower(addressB));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $author$project$Functions$dictFilterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Functions$andMap = F2(
	function (f, x) {
		return A2(
			$elm$core$Maybe$andThen,
			function (x_) {
				return A2(
					$elm$core$Maybe$andThen,
					function (f_) {
						return $elm$core$Maybe$Just(
							f_(x_));
					},
					f);
			},
			x);
	});
var $author$project$Functions$map2 = F3(
	function (m0, m1, f) {
		var _v0 = _Utils_Tuple2(m0, m1);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var v0 = _v0.a.a;
			var v1 = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(f, v0, v1));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Functions$map3 = F4(
	function (m0, m1, m2, f) {
		var r = A3($author$project$Functions$map2, m0, m1, f);
		return A2($author$project$Functions$andMap, r, m2);
	});
var $author$project$Functions$map4 = F5(
	function (m0, m1, m2, m3, f) {
		var r = A4($author$project$Functions$map3, m0, m1, m2, f);
		return A2($author$project$Functions$andMap, r, m3);
	});
var $author$project$Functions$map5 = F6(
	function (m0, m1, m2, m3, m4, f) {
		var r = A5($author$project$Functions$map4, m0, m1, m2, m3, f);
		return A2($author$project$Functions$andMap, r, m4);
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Eth$Config$loadConfig = F2(
	function (networkName, basicConfig) {
		var contracts = basicConfig.hN;
		var cTokensRaw = basicConfig.hu;
		var tokens = basicConfig.nk;
		var blocks = basicConfig.dH;
		var maybeUSDCAssetAddress = A2(
			$elm$core$Maybe$andThen,
			function (tokenConfig) {
				return $elm$core$Maybe$Just(tokenConfig.hd);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (tokenConfig) {
						return tokenConfig.jS === 'USDC';
					},
					$elm$core$Dict$values(tokens))));
		var maybeTimelock = A2($elm$core$Dict$get, 'Timelock', contracts);
		var maybeReservoir = A2($elm$core$Dict$get, 'Reservoir', contracts);
		var maybePriceOracle = A2($elm$core$Dict$get, 'PriceOracleProxy', contracts);
		var maybePriceFeed = A2($elm$core$Dict$get, 'PriceFeed', contracts);
		var maybeMaximillion = A2($elm$core$Dict$get, 'Maximillion', contracts);
		var maybeLiquidator = A2($elm$core$Dict$get, 'Liquidator', contracts);
		var maybeGovernor = A2($elm$core$Dict$get, 'GovernorAlpha', contracts);
		var maybeFauceteer = A2($elm$core$Dict$get, 'Fauceteer', contracts);
		var maybeComptrollerG3 = A2($elm$core$Dict$get, 'StdComptrollerG3', contracts);
		var maybeComptroller = A2($elm$core$Dict$get, 'Comptroller', contracts);
		var maybeCompoundLens = A2($elm$core$Dict$get, 'CompoundLens', contracts);
		var maybeCompToken = A2($elm$core$Dict$get, 'COMP', tokens);
		var maybeCEtherToken = A2($elm$core$Dict$get, 'cETH', tokens);
		var maybeCErc20Delegate = A2($elm$core$Dict$get, 'cErc20Delegate', contracts);
		var maybeCDaiDelegate = A2($elm$core$Dict$get, 'cDaiDelegate', contracts);
		var cTokensWithoutCEth = A2(
			$author$project$Functions$dictFilterMap,
			F2(
				function (key, rawCTokenConfig) {
					return A2(
						$elm$core$Maybe$andThen,
						function (tokenConfig) {
							var underlyingRebrandTokenConfig = function () {
								switch (networkName) {
									case 'mainnet':
										return A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.hd, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643') ? _Utils_update(
											tokenConfig,
											{i5: 'Dai'}) : (A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.hd, '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359') ? _Utils_update(
											tokenConfig,
											{i5: 'Sai (Legacy DAI)'}) : tokenConfig);
									case 'kovan':
										return A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.hd, '0xe7bc397DBd069fC7d0109C0636d06888bb50668c') ? _Utils_update(
											tokenConfig,
											{i5: 'Dai'}) : (A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.hd, '0x63c344BF8651222346DD870be254D4347c9359f7') ? _Utils_update(
											tokenConfig,
											{i5: 'Sai (Legacy DAI)'}) : tokenConfig);
									default:
										return tokenConfig;
								}
							}();
							var underlyingTetherRebrandTokenConfig = ((underlyingRebrandTokenConfig.jS === 'USDT') && (underlyingRebrandTokenConfig.i5 === 'USDT')) ? _Utils_update(
								underlyingRebrandTokenConfig,
								{i5: 'Tether'}) : underlyingRebrandTokenConfig;
							return $elm$core$Maybe$Just(
								{hd: rawCTokenConfig.hd, aL: rawCTokenConfig.aL, i5: rawCTokenConfig.i5, jS: rawCTokenConfig.jS, cy: underlyingTetherRebrandTokenConfig});
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (tokenConfig) {
									return _Utils_eq(tokenConfig.hd, rawCTokenConfig.cy);
								},
								$elm$core$Dict$values(tokens))));
				}),
			cTokensRaw);
		var cTokens = function () {
			if (!maybeCEtherToken.$) {
				var cEtherTokenConfig = maybeCEtherToken.a;
				var dummyEthConfig = {
					hd: cEtherTokenConfig.hd,
					aL: 18,
					i5: 'Ether',
					ju: $elm$core$Maybe$Nothing,
					jR: $elm$core$Maybe$Just(true),
					jS: 'ETH'
				};
				var actualCEtherTokenConfig = {hd: cEtherTokenConfig.hd, aL: cEtherTokenConfig.aL, i5: cEtherTokenConfig.i5, jS: cEtherTokenConfig.jS, cy: dummyEthConfig};
				return A3($elm$core$Dict$insert, cEtherTokenConfig.jS, actualCEtherTokenConfig, cTokensWithoutCEth);
			} else {
				return cTokensWithoutCEth;
			}
		}();
		return A6(
			$author$project$Functions$map5,
			maybeComptroller,
			maybePriceOracle,
			maybeCEtherToken,
			maybeMaximillion,
			maybeCompoundLens,
			F5(
				function (comptroller, priceOracle, cEtherToken, maximillion, compoundLens) {
					return {hp: basicConfig, dH: blocks, hs: cEtherToken, ht: cTokens, hL: compoundLens, hM: comptroller, iP: maximillion, iQ: maybeCDaiDelegate, iR: maybeCErc20Delegate, iS: maybeCompToken, iT: maybeComptrollerG3, iU: maybeFauceteer, iV: maybeGovernor, iW: maybeUSDCAssetAddress, iX: maybeLiquidator, iY: maybePriceFeed, iZ: maybeReservoir, i_: maybeTimelock, jk: priceOracle};
				}));
	});
var $author$project$Network$networkName = function (network) {
	switch (network) {
		case 0:
			return 'Olympic';
		case 1:
			return 'Mainnet';
		case 2:
			return 'Morden';
		case 3:
			return 'Ropsten';
		case 4:
			return 'Rinkeby';
		case 5:
			return 'Goerli';
		case 6:
			return 'Ubiq';
		case 7:
			return 'Kovan';
		case 8:
			return 'Sokol';
		case 9:
			return 'Core';
		case 10:
			return 'Development';
		default:
			return 'unknown';
	}
};
var $author$project$LandingSite$Main$getConfig = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Eth$Config$loadConfig('mainnet'),
		$author$project$Functions$demaybeify(
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(
					$author$project$Network$networkName(model.bo)),
				model.dT)));
};
var $author$project$LandingSite$Page$MarketDetail = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {be: frag, bq: params, a4: unvisited, cA: value, bC: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.a4;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.cA);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.cA);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.gl),
					$elm$url$Url$Parser$prepareQuery(url.js),
					url.ih,
					$elm$core$Basics$identity)));
	});
var $author$project$LandingSite$Page$API = 5;
var $author$project$LandingSite$Page$About = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$Page$CTokens = {$: 3};
var $author$project$LandingSite$Page$Comp = {$: 2};
var $author$project$LandingSite$Page$Comptroller = 2;
var $author$project$LandingSite$Page$Developers = {$: 4};
var $author$project$LandingSite$Page$DocsABIView = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$LandingSite$Page$DocsCTokens = 1;
var $author$project$LandingSite$Page$GettingStarted = 0;
var $author$project$LandingSite$Page$Governance = 3;
var $author$project$LandingSite$Page$GovernanceProposalDetail = function (a) {
	return {$: 11, a: a};
};
var $author$project$LandingSite$Page$GovernanceProposalOverview = {$: 12};
var $author$project$LandingSite$Page$Prices = {$: 14};
var $author$project$LandingSite$Page$Security = 6;
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.bC;
		var unvisited = _v0.a4;
		var params = _v0.bq;
		var frag = _v0.be;
		var value = _v0.cA;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bC;
			var unvisited = _v0.a4;
			var params = _v0.bq;
			var frag = _v0.be;
			var value = _v0.cA;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bC;
		var unvisited = _v0.a4;
		var params = _v0.bq;
		var frag = _v0.be;
		var value = _v0.cA;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bC;
			var unvisited = _v1.a4;
			var params = _v1.bq;
			var frag = _v1.be;
			var value = _v1.cA;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bC;
		var unvisited = _v0.a4;
		var params = _v0.bq;
		var frag = _v0.be;
		var value = _v0.cA;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$LandingSite$Page$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$LandingSite$Page$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Markets,
			$elm$url$Url$Parser$s('markets')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$MarketDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('markets'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$About,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('about'),
				$elm$url$Url$Parser$fragment($elm$core$Basics$identity))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Comp,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				$elm$url$Url$Parser$s('comp'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$CTokens,
			$elm$url$Url$Parser$s('ctokens')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers,
			$elm$url$Url$Parser$s('developers')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(0),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				$elm$url$Url$Parser$fragment($elm$core$Basics$identity))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(1),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ctokens'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(2),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('comptroller'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(3),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('governance'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(4),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('prices'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(5),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('api'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Docs(6),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('security'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$DocsABIView,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('docs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('abi'),
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceAccountProfile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('address'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceHome,
			$elm$url$Url$Parser$s('governance')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceProposalDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('proposals'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceProposalOverview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				$elm$url$Url$Parser$s('proposals'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceLeaderboard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				$elm$url$Url$Parser$s('leaderboard'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Prices,
			$elm$url$Url$Parser$s('prices'))
		]));
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$LandingSite$Page$getLandingPage = F2(
	function (maybeConfig, location) {
		var maybeDesiredPage = A2($elm$url$Url$Parser$parse, $author$project$LandingSite$Page$parser, location);
		var actualPage = function () {
			if ((!maybeDesiredPage.$) && (maybeDesiredPage.a.$ === 8)) {
				var underlyingSymbol = maybeDesiredPage.a.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Just($author$project$LandingSite$Page$Markets),
					A2(
						$elm$core$Maybe$map,
						function (config) {
							var uppercaseUnderlyingSymbol = $elm$core$String$toUpper(underlyingSymbol);
							return _Utils_eq(
								A2($elm$core$Dict$get, 'c' + uppercaseUnderlyingSymbol, config.ht),
								$elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just($author$project$LandingSite$Page$Markets) : $elm$core$Maybe$Just(
								$author$project$LandingSite$Page$MarketDetail(uppercaseUnderlyingSymbol));
						},
						maybeConfig));
			} else {
				return maybeDesiredPage;
			}
		}();
		return A2($elm$core$Maybe$withDefault, $author$project$LandingSite$Page$Home, actualPage);
	});
var $author$project$LandingSite$Main$GovernanceAccountProfileMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$LandingSite$Main$GovernanceHomeMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$LandingSite$Main$GovernanceLeaderboardMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$LandingSite$Main$GovernanceProposalDetailMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$LandingSite$Main$GovernanceProposalOverviewMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$LandingSite$Main$LandingCompMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Governance$ProposalDetail$AgainstVoteReceiptsResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$ProposalDetail$ForVoteReceiptsResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$ProposalDetail$ProposalsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize = 100;
var $elm$http$Http$Internal$EmptyBody = {$: 0};
var $elm$http$Http$emptyBody = $elm$http$Http$Internal$EmptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Internal$FormDataBody = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$Internal$isStringBody = function (body) {
	if (body.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$http$Http$expectStringResponse = _Http_expectStringResponse;
var $elm$http$Http$expectJson = function (decoder) {
	return $elm$http$Http$expectStringResponse(
		function (response) {
			var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, response.kx);
			if (_v0.$ === 1) {
				var decodeError = _v0.a;
				return $elm$core$Result$Err(
					$elm$json$Json$Decode$errorToString(decodeError));
			} else {
				var value = _v0.a;
				return $elm$core$Result$Ok(value);
			}
		});
};
var $elm$http$Http$Internal$Request = $elm$core$Basics$identity;
var $elm$http$Http$request = $elm$core$Basics$identity;
var $elm$http$Http$get = F2(
	function (url, decoder) {
		return $elm$http$Http$request(
			{
				kx: $elm$http$Http$emptyBody,
				h9: $elm$http$Http$expectJson(decoder),
				il: _List_Nil,
				lV: 'GET',
				jX: $elm$core$Maybe$Nothing,
				nD: url,
				nM: false
			});
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptRequest = F6(
	function (proposal_id, account, support, with_proposal_data, page_size, page_number) {
		return {kh: account, mg: page_number, mh: page_size, gq: proposal_id, gO: support, nP: with_proposal_data};
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptResponse = F4(
	function (request, pagination_summary, proposal_vote_receipts, error) {
		return {h5: error, jf: pagination_summary, mp: proposal_vote_receipts, jw: request};
	});
var $author$project$CompoundApi$Common$Models$API_Error = F2(
	function (error_code, message) {
		return {lc: error_code, lT: message};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$CompoundApi$Common$Decoders$apiErrorDecoder = $elm$json$Json$Decode$nullable(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$CompoundApi$Common$Models$API_Error,
		A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map4 = _Json_map4;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$CompoundApi$Common$Models$PaginationSummary = F4(
	function (page_number, page_size, total_entries, total_pages) {
		return {mg: page_number, mh: page_size, nu: total_entries, nv: total_pages};
	});
var $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Common$Models$PaginationSummary,
	A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_entries', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_pages', $elm$json$Json$Decode$int));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$createProposalVoteReceipt = F5(
	function (id, displayAccount, support, votes, proposal) {
		return {jp: proposal, gq: id, gO: support, j9: displayAccount, nI: votes};
	});
var $author$project$CompoundApi$Governance$Common$Models$createDisplayAccount = F4(
	function (address, display_name, image_url, account_url) {
		return {g9: account_url, hd: address, h_: display_name, is: image_url};
	});
var $author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$Common$Models$createDisplayAccount,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'display_name',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'image_url',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'account_url',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)));
var $author$project$CompoundApi$Governance$ProposalService$Models$createProposal = F6(
	function (id, title, description, states, for_votes, against_votes) {
		return {hh: against_votes, hY: description, $8: for_votes, ir: id, jM: states, nb: title};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalState = F4(
	function (state, start_time, end_time, trx_hash) {
		return {lb: end_time, mL: start_time, jL: state, nz: trx_hash};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$Active = 1;
var $author$project$CompoundApi$Governance$ProposalService$Models$Canceled = 6;
var $author$project$CompoundApi$Governance$ProposalService$Models$Executed = 5;
var $author$project$CompoundApi$Governance$ProposalService$Models$Expired = 7;
var $author$project$CompoundApi$Governance$ProposalService$Models$Failed = 3;
var $author$project$CompoundApi$Governance$ProposalService$Models$Pending = 0;
var $author$project$CompoundApi$Governance$ProposalService$Models$Queued = 4;
var $author$project$CompoundApi$Governance$ProposalService$Models$Succeeded = 2;
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder = function () {
	var proposalStateStringDecoder = function (stateString) {
		switch (stateString) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'active':
				return $elm$json$Json$Decode$succeed(1);
			case 'succeeded':
				return $elm$json$Json$Decode$succeed(2);
			case 'defeated':
				return $elm$json$Json$Decode$succeed(3);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			case 'queued':
				return $elm$json$Json$Decode$succeed(4);
			case 'executed':
				return $elm$json$Json$Decode$succeed(5);
			case 'canceled':
				return $elm$json$Json$Decode$succeed(6);
			case 'expired':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Unrecognized proposal state: ' + stateString);
		}
	};
	return A2($elm$json$Json$Decode$andThen, proposalStateStringDecoder, $elm$json$Json$Decode$string);
}();
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'trx_hash',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'end_time',
		$elm$json$Json$Decode$nullable(
			A2(
				$elm$json$Json$Decode$map,
				$elm$time$Time$millisToPosix,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$mul(1000),
					$elm$json$Json$Decode$int))),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_time',
			A2(
				$elm$json$Json$Decode$map,
				$elm$time$Time$millisToPosix,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$mul(1000),
					$elm$json$Json$Decode$int)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder,
				$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$ProposalState)))));
var $author$project$Eth$Decoders$forceMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var val = maybe.a;
			return $elm$json$Json$Decode$succeed(val);
		} else {
			return $elm$json$Json$Decode$fail(err);
		}
	});
var $author$project$Decimal$Decimal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Maybe$map2($elm$core$List$cons),
	$elm$core$Maybe$Just(_List_Nil));
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$emptyZero = function (_v0) {
	var xs = _v0;
	var _v1 = A2(
		$elm_community$list_extra$List$Extra$dropWhile,
		$elm$core$Basics$eq(0),
		xs);
	if (!_v1.b) {
		return _List_Nil;
	} else {
		return xs;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeL, $cmditch$elm_bigint$BigInt$emptyZero, $elm$core$Basics$identity),
		$elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2($elm$core$Basics$composeR, $elm$core$String$fromList, $elm$core$String$toInt)),
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					$cmditch$elm_bigint$Constants$maxDigitMagnitude,
					$elm$core$List$reverse(x)))));
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $cmditch$elm_bigint$BigInt$fromString = function (x) {
	var _v0 = $elm$core$String$toList(
		$elm$core$String$toLower(x));
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		switch (_v0.a) {
			case '-':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(1),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(0),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _v0;
				return A2(
					$elm$core$Maybe$map,
					$cmditch$elm_bigint$BigInt$mkBigInt(0),
					$cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Decimal$fromString = function (s) {
	var stringToDecimal = function (targetString) {
		var stringIntToDecimal = F2(
			function (s_, e) {
				var _v8 = $cmditch$elm_bigint$BigInt$fromString(s_);
				if (_v8.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var a = _v8.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Decimal$Decimal, a, e));
				}
			});
		var _v6 = A2($elm$core$String$split, '.', targetString);
		_v6$2:
		while (true) {
			if (_v6.b) {
				if (_v6.b.b) {
					if (!_v6.b.b.b) {
						var a = _v6.a;
						var _v7 = _v6.b;
						var b = _v7.a;
						return A2(
							stringIntToDecimal,
							_Utils_ap(a, b),
							-$elm$core$String$length(b));
					} else {
						break _v6$2;
					}
				} else {
					var a = _v6.a;
					return A2(stringIntToDecimal, a, 0);
				}
			} else {
				break _v6$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var makeMantissa = function (targetString) {
		var _v4 = A2($elm$core$String$split, '.', targetString);
		_v4$2:
		while (true) {
			if (_v4.b) {
				if (!_v4.b.b) {
					var s1 = _v4.a;
					return stringToDecimal(s1);
				} else {
					if (!_v4.b.b.b) {
						var s1 = _v4.a;
						var _v5 = _v4.b;
						var s2 = _v5.a;
						return stringToDecimal(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[s1, s2])));
					} else {
						break _v4$2;
					}
				}
			} else {
				break _v4$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var splitMantissaExponent = function (targetString) {
		var _v2 = A2(
			$elm$core$String$split,
			'e',
			$elm$core$String$toLower(targetString));
		_v2$2:
		while (true) {
			if (_v2.b) {
				if (!_v2.b.b) {
					var s1 = _v2.a;
					return _Utils_Tuple2(
						stringToDecimal(s1),
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v2.b.b.b) {
						var s1 = _v2.a;
						var _v3 = _v2.b;
						var s2 = _v3.a;
						return _Utils_Tuple2(
							stringToDecimal(s1),
							$elm$core$String$toInt(s2));
					} else {
						break _v2$2;
					}
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	};
	var _v0 = splitMantissaExponent(s);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var m = _v1.a;
		var a = _v1.b;
		var e = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Decimal$Decimal, m, e + a));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eth$Decoders$stringDecimal = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Eth$Decoders$forceMaybe('invalid float'),
	A2($elm$json$Json$Decode$map, $author$project$Decimal$fromString, $elm$json$Json$Decode$string));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'against_votes',
	$author$project$Eth$Decoders$stringDecimal,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'for_votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'states',
			$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$createProposal)))))));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'proposal',
	$elm$json$Json$Decode$nullable($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'support',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'voter',
				$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposal_id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$createProposalVoteReceipt))))));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page_number',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'page_size',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'with_proposal_data',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'support',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'account',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'proposal_id',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptRequest)))))))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposal_vote_receipts',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$CompoundApi$Common$Url$buildApiUrl = F4(
	function (apiBaseUrlMap, network, apiEndpoint, endpointQueryParams) {
		var shouldAddNetworkQueryParam = function () {
			switch (network) {
				case 1:
					return true;
				case 3:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				case 7:
					return true;
				default:
					return false;
			}
		}();
		var lowercaseNetworkName = $elm$core$String$toLower(
			$author$project$Network$networkName(network));
		var finalQueryParams = shouldAddNetworkQueryParam ? _Utils_ap(
			endpointQueryParams,
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'network', lowercaseNetworkName)
				])) : endpointQueryParams;
		return A2(
			$elm$core$Maybe$map,
			function (apiBaseUrl) {
				return _Utils_ap(
					apiBaseUrl,
					A2(
						$elm$url$Url$Builder$relative,
						_List_fromArray(
							[apiEndpoint]),
						finalQueryParams));
			},
			A2($elm$core$Dict$get, lowercaseNetworkName, apiBaseUrlMap));
	});
var $author$project$CompoundApi$Governance$ProposalService$Encoders$encodeProposalStateEnum = function (stateEnum) {
	switch (stateEnum) {
		case 0:
			return 'pending';
		case 1:
			return 'active';
		case 2:
			return 'succeeded';
		case 3:
			return 'defeated';
		case 4:
			return 'queued';
		case 5:
			return 'executed';
		case 6:
			return 'canceled';
		default:
			return 'expired';
	}
};
var $author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl = F3(
	function (apiBaseUrlMap, network, proposalRequest) {
		var requiredQueryParams = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'page_size',
				$elm$core$String$fromInt(proposalRequest.mh)),
				A2(
				$elm$url$Url$Builder$string,
				'page_number',
				$elm$core$String$fromInt(proposalRequest.mg))
			]);
		var intermediateQueryParams = _Utils_ap(
			requiredQueryParams,
			_Utils_ap(
				function () {
					var _v1 = proposalRequest.mo;
					if (!_v1.b) {
						return _List_Nil;
					} else {
						var proposalIdsList = _v1;
						var proposalsQueryArg = A2(
							$elm$core$String$join,
							',',
							A2($elm$core$List$map, $elm$core$String$fromInt, proposalIdsList));
						return _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'proposal_ids', proposalsQueryArg)
							]);
					}
				}(),
				function () {
					var _v2 = proposalRequest.nN;
					if (!_v2.$) {
						if (_v2.a) {
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'with_detail', 'true')
								]);
						} else {
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'with_detail', 'false')
								]);
						}
					} else {
						return _List_Nil;
					}
				}()));
		var finalQueryParams = function () {
			var _v0 = proposalRequest.jL;
			if (!_v0.$) {
				var actualStateFilter = _v0.a;
				return _Utils_ap(
					intermediateQueryParams,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'state',
							$author$project$CompoundApi$Governance$ProposalService$Encoders$encodeProposalStateEnum(actualStateFilter))
						]));
			} else {
				return intermediateQueryParams;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/proposals', finalQueryParams);
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest = F5(
	function (proposal_ids, state, page_size, page_number, with_detail) {
		return {mg: page_number, mh: page_size, mo: proposal_ids, jL: state, nN: with_detail};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsWithDetailResponse = F4(
	function (request, pagination_summary, proposals, error) {
		return {h5: error, jf: pagination_summary, jq: proposals, jw: request};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$createProposalWithDetail = F8(
	function (id, title, description, proposer, actions, states, for_votes, against_votes) {
		return {ki: actions, hh: against_votes, hY: description, $8: for_votes, ir: id, ms: proposer, jM: states, nb: title};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalAction = F5(
	function (title, target, value, signature, data) {
		return {kZ: data, mI: signature, m6: target, nb: title, cA: value};
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalActionDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalAction,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'signature', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalWithDetailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'against_votes',
	$author$project$Eth$Decoders$stringDecimal,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'for_votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'states',
			$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'actions',
				$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalActionDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposer',
					$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$createProposalWithDetail)))))))));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsWithDetailResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsWithDetailResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest,
			A2(
				$elm$json$Json$Decode$field,
				'proposal_ids',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'state',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$field,
				'with_detail',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposals',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalWithDetailDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$http$Http$toTask = function (_v0) {
	var request_ = _v0;
	return A2(_Http_toTask, request_, $elm$core$Maybe$Nothing);
};
var $elm$http$Http$send = F2(
	function (resultToMessage, request_) {
		return A2(
			$elm$core$Task$attempt,
			resultToMessage,
			$elm$http$Http$toTask(request_));
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl = F3(
	function (apiBaseUrlMap, network, request) {
		var requiredQueryParams = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'page_size',
				$elm$core$String$fromInt(request.mh)),
				A2(
				$elm$url$Url$Builder$string,
				'page_number',
				$elm$core$String$fromInt(request.mg))
			]);
		var finalQueryParams = _Utils_ap(
			requiredQueryParams,
			_Utils_ap(
				function () {
					var _v0 = request.gO;
					if (!_v0.$) {
						var support = _v0.a;
						return support ? _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'support', 'true')
							]) : _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'support', 'false')
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v1 = request.gq;
						if (!_v1.$) {
							var id = _v1.a;
							return _List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'proposal_id',
									$elm$core$String$fromInt(id))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = request.kh;
							if (!_v2.$) {
								var accountAddress = _v2.a;
								return _List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'account', accountAddress)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						request.nP ? _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'with_proposal_data', 'true')
							]) : _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'with_proposal_data', 'false')
							])))));
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/proposal_vote_receipts', finalQueryParams);
	});
var $author$project$Governance$ProposalDetail$attempToLoadProposalId = F3(
	function (apiBaseUrlMap, network, proposalId) {
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				mg: 1,
				mh: 1,
				mo: _List_fromArray(
					[proposalId]),
				jL: $elm$core$Maybe$Nothing,
				nN: $elm$core$Maybe$Just(true)
			});
		var maybeRequestForVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				kh: $elm$core$Maybe$Nothing,
				mg: 1,
				mh: $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize,
				gq: $elm$core$Maybe$Just(proposalId),
				gO: $elm$core$Maybe$Just(true),
				nP: false
			});
		var maybeRequestAgainstVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				kh: $elm$core$Maybe$Nothing,
				mg: 1,
				mh: $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize,
				gq: $elm$core$Maybe$Just(proposalId),
				gO: $elm$core$Maybe$Just(false),
				nP: false
			});
		var apiRequestCmds = $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$cons,
				function () {
					if (!maybeRequestProposalsUrl.$) {
						var requestProposalsUrl = maybeRequestProposalsUrl.a;
						return A2(
							$elm$http$Http$send,
							$author$project$Governance$ProposalDetail$ProposalsResponse,
							A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsWithDetailResponseDecoder));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}(),
				function () {
					var _v1 = _Utils_Tuple2(maybeRequestForVoteReceiptsUrl, maybeRequestAgainstVoteReceiptsUrl);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var requestForVoteReceiptsUrl = _v1.a.a;
						var requestAgainstVoteReceiptsUrl = _v1.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalDetail$ForVoteReceiptsResponse,
								A2($elm$http$Http$get, requestForVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder)),
								A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalDetail$AgainstVoteReceiptsResponse,
								A2($elm$http$Http$get, requestAgainstVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return _Utils_Tuple2($author$project$Governance$ProposalDetail$emptyState, apiRequestCmds);
	});
var $author$project$LandingSite$About$AllJobsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$About$ForSelf = $elm$core$Basics$identity;
var $author$project$LeverJobsApi$Models$Job = F3(
	function (categories, title, url) {
		return {kI: categories, nb: title, nD: url};
	});
var $author$project$LeverJobsApi$Models$JobCategories = function (location) {
	return {lO: location};
};
var $author$project$LeverJobsApi$Decoders$jobCategoriesDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$LeverJobsApi$Models$JobCategories,
	A2($elm$json$Json$Decode$field, 'location', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$LeverJobsApi$Decoders$jobDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$LeverJobsApi$Models$Job,
	A2($elm$json$Json$Decode$field, 'categories', $author$project$LeverJobsApi$Decoders$jobCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'hostedUrl', $elm$json$Json$Decode$string));
var $author$project$LeverJobsApi$Decoders$jobsResponseDecoder = $elm$json$Json$Decode$list($author$project$LeverJobsApi$Decoders$jobDecoder);
var $author$project$LandingSite$About$loadJobs = function () {
	var jobsRequestHttpGet = A2($elm$http$Http$get, 'https://api.lever.co/v0/postings/compound-2?mode=json', $author$project$LeverJobsApi$Decoders$jobsResponseDecoder);
	return A2(
		$elm$http$Http$send,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$About$AllJobsResponse),
		jobsRequestHttpGet);
}();
var $author$project$LandingSite$About$init = _Utils_Tuple2($author$project$LandingSite$About$emptyState, $author$project$LandingSite$About$loadJobs);
var $author$project$Utils$ProtoDoc$File = F4(
	function (name, enums, messages, services) {
		return {d$: enums, i$: messages, i5: name, jF: services};
	});
var $author$project$Utils$ProtoDoc$Enum = F4(
	function (name, longName, fullName, values) {
		return {bU: fullName, fU: longName, i5: name, nG: values};
	});
var $author$project$Utils$ProtoDoc$EnumValue = F3(
	function (name, number, description) {
		return {hY: description, i5: name, l2: number};
	});
var $author$project$Utils$ProtoDoc$decodeEnumValue = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Utils$ProtoDoc$EnumValue,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'number', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeEnum = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$Enum,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'values',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeEnumValue)));
var $author$project$Utils$ProtoDoc$Message = F5(
	function (name, longName, fullName, description, fields) {
		return {hY: description, d1: fields, bU: fullName, fU: longName, i5: name};
	});
var $author$project$Utils$ProtoDoc$Field = F4(
	function (name, description, fieldType, fullType) {
		return {hY: description, d0: fieldType, cU: fullType, i5: name};
	});
var $author$project$Utils$ProtoDoc$decodeField = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$Field,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullType', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeMessage = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Message,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeField)));
var $author$project$Utils$ProtoDoc$Service = F5(
	function (name, longName, fullName, description, methods) {
		return {hY: description, bU: fullName, fU: longName, lW: methods, i5: name};
	});
var $author$project$Utils$ProtoDoc$Method = F5(
	function (name, description, requestFullType, responseFullType, rules) {
		return {hY: description, i5: name, jx: requestFullType, jz: responseFullType, mC: rules};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Utils$ProtoDoc$Rule = F2(
	function (method, pattern) {
		return {lV: method, mi: pattern};
	});
var $author$project$Utils$ProtoDoc$decodeRule = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Utils$ProtoDoc$Rule,
	A2($elm$json$Json$Decode$field, 'method', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'pattern', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeMethod = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Method,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'requestFullType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'responseFullType', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['options', 'google.api.http', 'rules']),
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeRule)));
var $author$project$Utils$ProtoDoc$decodeService = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Service,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'methods',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeMethod),
					$elm$json$Json$Decode$succeed(_List_Nil)
				]))));
var $author$project$Utils$ProtoDoc$decodeFile = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$File,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'enums',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeEnum)),
	A2(
		$elm$json$Json$Decode$field,
		'messages',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeMessage)),
	A2(
		$elm$json$Json$Decode$field,
		'services',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeService)));
var $author$project$Utils$ProtoDoc$toDict = F2(
	function (els, fn) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (el) {
					return _Utils_Tuple2(
						fn(el),
						el);
				},
				els));
	});
var $author$project$Utils$ProtoDoc$fileToProtoDoc = function (_v0) {
	var name = _v0.i5;
	var enums = _v0.d$;
	var messages = _v0.i$;
	var services = _v0.jF;
	return _Utils_Tuple2(
		name,
		{
			d$: A2(
				$author$project$Utils$ProtoDoc$toDict,
				enums,
				function ($) {
					return $.bU;
				}),
			i$: A2(
				$author$project$Utils$ProtoDoc$toDict,
				messages,
				function ($) {
					return $.bU;
				}),
			jF: A2(
				$author$project$Utils$ProtoDoc$toDict,
				services,
				function ($) {
					return $.bU;
				})
		});
};
var $author$project$Utils$ProtoDoc$decodeProtoDoc = function (val) {
	return A2(
		$elm$core$Result$map,
		$elm$core$Dict$fromList,
		A2(
			$elm$core$Result$map,
			$elm$core$List$map($author$project$Utils$ProtoDoc$fileToProtoDoc),
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					'files',
					$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeFile)),
				val)));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Utils$Highlighter$highlightScroll = _Platform_outgoingPort(
	'highlightScroll',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$LandingSite$Docs$init = function (protoDocJson) {
	var protoDoc = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		$author$project$Utils$ProtoDoc$decodeProtoDoc(protoDocJson));
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$LandingSite$Docs$emptyState,
			{de: protoDoc}),
		$author$project$Utils$Highlighter$highlightScroll(
			_Utils_Tuple2('.side-navigation a', 'section[id],.function[id]')));
};
var $author$project$LandingSite$Main$LandingAboutMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$LandingSite$About$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingAboutTranslator = $author$project$LandingSite$About$translator(
	{ja: $author$project$LandingSite$Main$LandingAboutMsg});
var $author$project$LandingSite$Main$LandingCTokensMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$LandingSite$Main$WrappedGraphMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$LandingSite$CTokens$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var onWrappedGraphMsg = _v0.jc;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var graphMsg = msg.a;
			return onWrappedGraphMsg(graphMsg);
		}
	});
var $author$project$LandingSite$Main$landingCTokensTranslator = $author$project$LandingSite$CTokens$translator(
	{ja: $author$project$LandingSite$Main$LandingCTokensMsg, jc: $author$project$LandingSite$Main$WrappedGraphMsg});
var $author$project$LandingSite$Main$LandingDocsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$LandingSite$Docs$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingDocsTranslator = $author$project$LandingSite$Docs$translator(
	{ja: $author$project$LandingSite$Main$LandingDocsMsg});
var $author$project$LandingSite$Main$LandingMarketDetailMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$LandingSite$MarketDetail$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var onWrappedGraphMsg = _v0.jc;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var graphMsg = msg.a;
			return onWrappedGraphMsg(graphMsg);
		}
	});
var $author$project$LandingSite$Main$landingMarketDetailTranslator = $author$project$LandingSite$MarketDetail$translator(
	{ja: $author$project$LandingSite$Main$LandingMarketDetailMsg, jc: $author$project$LandingSite$Main$WrappedGraphMsg});
var $author$project$Governance$AccountProfile$CompDistributionResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$AccountProfile$GovAccountResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$AccountProfile$PresidioAccountsResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Governance$AccountProfile$RecentVoteReceiptsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$CompoundApi$Governance$CompService$Models$AccountCompDistributionRequest = function (address) {
	return {hd: address};
};
var $author$project$CompoundApi$Governance$CompService$Models$AccountCompDistributionResponse = F2(
	function (markets, request) {
		return {iN: markets, jw: request};
	});
var $author$project$CompoundApi$Governance$CompService$Models$AccountCompDistibution = function (address) {
	return function (comp_allocated) {
		return function (comp_borrow_index) {
			return function (comp_distributed) {
				return function (comp_supply_index) {
					return function (daily_comp) {
						return function (name) {
							return function (symbol) {
								return function (underlying_address) {
									return function (underlying_name) {
										return function (underlying_symbol) {
											return {hd: address, hH: comp_allocated, hI: comp_borrow_index, hJ: comp_distributed, hK: comp_supply_index, hR: daily_comp, i5: name, jS: symbol, j1: underlying_address, j2: underlying_name, j4: underlying_symbol};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CompoundApi$Governance$CompService$Decoders$acccountCompDistributionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'underlying_symbol',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'underlying_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'underlying_address',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'symbol',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'daily_comp',
						$author$project$Eth$Decoders$stringDecimal,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'comp_supply_index',
							$author$project$Eth$Decoders$stringDecimal,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'comp_distributed',
								$author$project$Eth$Decoders$stringDecimal,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'comp_borrow_index',
									$author$project$Eth$Decoders$stringDecimal,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'comp_allocated',
										$author$project$Eth$Decoders$stringDecimal,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'address',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$CompService$Models$AccountCompDistibution))))))))))));
var $author$project$CompoundApi$Governance$CompService$Decoders$accountCompDistributionResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$CompoundApi$Governance$CompService$Models$AccountCompDistributionResponse,
	A2(
		$elm$json$Json$Decode$field,
		'markets',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$CompService$Decoders$acccountCompDistributionDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$CompoundApi$Governance$CompService$Models$AccountCompDistributionRequest,
			A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string))));
var $author$project$CompoundApi$Governance$CompService$Urls$accountCompDistributionUrl = F3(
	function (apiBaseUrlMap, network, accountRequest) {
		var queryParams = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'address', accountRequest.hd)
			]);
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/comp/account', queryParams);
	});
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $elm$core$Basics$pow = _Basics_pow;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$compare, x, y);
	});
var $elm$core$Basics$not = _Basics_not;
var $cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$lt, x, y);
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Decimal$insert_decimal_period = F2(
	function (pos, s) {
		var extra_zeros = pos - $elm$core$String$length(s);
		var padded_s = (extra_zeros >= 0) ? _Utils_ap(
			A2($elm$core$String$repeat, extra_zeros + 1, '0'),
			s) : s;
		var before = A2($elm$core$String$dropRight, pos, padded_s);
		var after = A2($elm$core$String$right, pos, padded_s);
		return before + ('.' + after);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $cmditch$elm_bigint$BigInt$fillZeroes = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$String$padLeft, $cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	$elm$core$String$fromInt);
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $author$project$Decimal$toString = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var sign = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? '' : '-';
	var add_zeros = function (n) {
		return A2($elm$core$String$repeat, n, '0');
	};
	var abs_m = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? m : $cmditch$elm_bigint$BigInt$negate(m);
	var s = $cmditch$elm_bigint$BigInt$toString(abs_m);
	var _v1 = A2($elm$core$Basics$compare, e, 0);
	switch (_v1) {
		case 1:
			return _Utils_ap(sign, s);
		case 2:
			return _Utils_ap(
				sign,
				_Utils_ap(
					s,
					add_zeros(e)));
		default:
			return _Utils_ap(
				sign,
				A2($author$project$Decimal$insert_decimal_period, 0 - e, s));
	}
};
var $author$project$CompoundApi$Presidio$Accounts$Urls$accountsRequestUrl = F3(
	function (apiBaseUrlMap, network, accountsRequest) {
		var requiredQueryParams = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'page_size',
				$elm$core$String$fromInt(accountsRequest.mh)),
				A2(
				$elm$url$Url$Builder$string,
				'page_number',
				$elm$core$String$fromInt(accountsRequest.mg)),
				A2(
				$elm$url$Url$Builder$string,
				'block_number',
				$elm$core$String$fromInt(accountsRequest.ku))
			]);
		var intermediateQueryParams = _Utils_ap(
			requiredQueryParams,
			function () {
				var _v2 = accountsRequest.km;
				if (!_v2.b) {
					return _List_Nil;
				} else {
					var addressList = _v2;
					var addressesQueryArg = A2($elm$core$String$join, ',', addressList);
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'addresses', addressesQueryArg)
						]);
				}
			}());
		var finalQueryParams = _Utils_ap(
			intermediateQueryParams,
			_Utils_ap(
				function () {
					var _v0 = accountsRequest.lX;
					if (!_v0.$) {
						var minBorrowValueEth = _v0.a;
						return _List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'min_borrow_value_in_eth[value]',
								$author$project$Decimal$toString(minBorrowValueEth))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				function () {
					var _v1 = accountsRequest.lR;
					if (!_v1.$) {
						var maxHealth = _v1.a;
						return _List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'max_health[value]',
								$author$project$Decimal$toString(maxHealth))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/account', finalQueryParams);
	});
var $author$project$CompoundApi$Presidio$Accounts$Models$AccountRequest = F6(
	function (addresses, min_borrow_value_in_eth, max_health, block_number, page_size, page_number) {
		return {km: addresses, ku: block_number, lR: max_health, lX: min_borrow_value_in_eth, mg: page_number, mh: page_size};
	});
var $author$project$CompoundApi$Presidio$Accounts$Models$AccountResponse = F4(
	function (request, pagination_summary, accounts, error) {
		return {ha: accounts, h5: error, jf: pagination_summary, jw: request};
	});
var $author$project$CompoundApi$Presidio$Accounts$Models$Account = F6(
	function (address, total_collateral_value_in_eth, total_borrow_value_in_eth, health, block_updated, tokens) {
		return {hd: address, kw: block_updated, lq: health, nk: tokens, no: total_borrow_value_in_eth, nq: total_collateral_value_in_eth};
	});
var $author$project$CompoundApi$Presidio$Accounts$Models$AccountCToken = F6(
	function (address, symbol, supply_balance_underlying, borrow_balance_underlying, lifetime_supply_interest_accrued, lifetime_borrow_interest_accrued) {
		return {hd: address, kz: borrow_balance_underlying, lM: lifetime_borrow_interest_accrued, lN: lifetime_supply_interest_accrued, mY: supply_balance_underlying, jS: symbol};
	});
var $author$project$CompoundApi$Common$Decoders$apiPrecise = A2($elm$json$Json$Decode$field, 'value', $author$project$Eth$Decoders$stringDecimal);
var $author$project$CompoundApi$Presidio$Accounts$Decoders$accountCTokenDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$CompoundApi$Presidio$Accounts$Models$AccountCToken,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'symbol',
		$elm$json$Json$Decode$succeed('NOPE')),
	A2($elm$json$Json$Decode$field, 'supply_balance_underlying', $author$project$CompoundApi$Common$Decoders$apiPrecise),
	A2($elm$json$Json$Decode$field, 'borrow_balance_underlying', $author$project$CompoundApi$Common$Decoders$apiPrecise),
	A2(
		$elm$json$Json$Decode$field,
		'lifetime_supply_interest_accrued',
		$elm$json$Json$Decode$nullable($author$project$CompoundApi$Common$Decoders$apiPrecise)),
	A2(
		$elm$json$Json$Decode$field,
		'lifetime_borrow_interest_accrued',
		$elm$json$Json$Decode$nullable($author$project$CompoundApi$Common$Decoders$apiPrecise)));
var $author$project$Decimal$fromIntWithExponent = F2(
	function (n, e) {
		return A2(
			$author$project$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$fromInt(n),
			e);
	});
var $author$project$Decimal$fromInt = function (n) {
	return A2($author$project$Decimal$fromIntWithExponent, n, 0);
};
var $author$project$Decimal$zero = $author$project$Decimal$fromInt(0);
var $author$project$CompoundApi$Presidio$Accounts$Decoders$accountDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$CompoundApi$Presidio$Accounts$Models$Account,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'total_collateral_value_in_eth', $author$project$CompoundApi$Common$Decoders$apiPrecise),
	A2($elm$json$Json$Decode$field, 'total_borrow_value_in_eth', $author$project$CompoundApi$Common$Decoders$apiPrecise),
	A2(
		$elm$json$Json$Decode$field,
		'health',
		$elm$json$Json$Decode$succeed($author$project$Decimal$zero)),
	A2(
		$elm$json$Json$Decode$field,
		'block_updated',
		$elm$json$Json$Decode$succeed(0)),
	A2(
		$elm$json$Json$Decode$field,
		'tokens',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Presidio$Accounts$Decoders$accountCTokenDecoder)));
var $author$project$CompoundApi$Presidio$Accounts$Decoders$accountsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Presidio$Accounts$Models$AccountResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A7(
			$elm$json$Json$Decode$map6,
			$author$project$CompoundApi$Presidio$Accounts$Models$AccountRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'min_borrow_value_in_eth',
				$elm$json$Json$Decode$nullable($author$project$CompoundApi$Common$Decoders$apiPrecise)),
			A2(
				$elm$json$Json$Decode$field,
				'max_health',
				$elm$json$Json$Decode$nullable($author$project$CompoundApi$Common$Decoders$apiPrecise)),
			A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'accounts',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Presidio$Accounts$Decoders$accountDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Governance$AccountProfile$desiredPageSize = 5;
var $author$project$CompoundApi$Governance$AccountService$Encoders$encodeAccountFilterEnum = function (accountFilterEnum) {
	switch (accountFilterEnum) {
		case 0:
			return 'votes';
		case 1:
			return 'balance';
		default:
			return 'proposals_created';
	}
};
var $author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl = F3(
	function (apiBaseUrlMap, network, accountRequest) {
		var requiredQueryParams = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'page_size',
					$elm$core$String$fromInt(accountRequest.mh)),
					A2(
					$elm$url$Url$Builder$string,
					'page_number',
					$elm$core$String$fromInt(accountRequest.mg))
				]),
			accountRequest.nO ? _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'with_history', 'true')
				]) : _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'with_history', 'false')
				]));
		var intermediateQueryParams = _Utils_ap(
			requiredQueryParams,
			function () {
				var _v1 = accountRequest.km;
				if (!_v1.b) {
					return _List_Nil;
				} else {
					var addressList = _v1;
					var addressesQueryArg = A2($elm$core$String$join, ',', addressList);
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'addresses', addressesQueryArg)
						]);
				}
			}());
		var finalQueryParams = function () {
			var _v0 = accountRequest.mb;
			if (!_v0.$) {
				var actualOrderBy = _v0.a;
				return _Utils_ap(
					intermediateQueryParams,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'order_by',
							$author$project$CompoundApi$Governance$AccountService$Encoders$encodeAccountFilterEnum(actualOrderBy))
						]));
			} else {
				return intermediateQueryParams;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/accounts', finalQueryParams);
	});
var $author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountRequest = F5(
	function (addresses, order_by, page_size, page_number, with_history) {
		return {km: addresses, mb: order_by, mg: page_number, mh: page_size, nO: with_history};
	});
var $author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountResponse = F4(
	function (request, pagination_summary, accounts, error) {
		return {ha: accounts, h5: error, jf: pagination_summary, jw: request};
	});
var $author$project$CompoundApi$Governance$AccountService$Models$Balance = 1;
var $author$project$CompoundApi$Governance$AccountService$Models$ProposalsCreated = 2;
var $author$project$CompoundApi$Governance$AccountService$Models$Votes = 0;
var $author$project$CompoundApi$Governance$AccountService$Decoders$accountFilterByDecoder = function () {
	var accountFilterStringDecoder = function (accountFilterString) {
		switch (accountFilterString) {
			case 'votes':
				return $elm$json$Json$Decode$succeed(0);
			case 'balance':
				return $elm$json$Json$Decode$succeed(1);
			case 'proposals_created':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unrecognized account filter option: ' + accountFilterString);
		}
	};
	return A2($elm$json$Json$Decode$andThen, accountFilterStringDecoder, $elm$json$Json$Decode$string);
}();
var $author$project$CompoundApi$Governance$Common$Models$CompAccountTransaction = F4(
	function (title, timestamp, trx_hash, delta) {
		return {k2: delta, na: timestamp, nb: title, nz: trx_hash};
	});
var $author$project$CompoundApi$Governance$Common$Decoders$compAccountTransactionDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$Common$Models$CompAccountTransaction,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$time$Time$millisToPosix,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$mul(1000),
			A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$int))),
	A2($elm$json$Json$Decode$field, 'trx_hash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'delta', $author$project$Eth$Decoders$stringDecimal));
var $author$project$CompoundApi$Governance$Common$Models$createCompAccount = function (address) {
	return function (display_name) {
		return function (image_url) {
			return function (account_url) {
				return function (balance) {
					return function (votes) {
						return function (vote_weight) {
							return function (proposals_created) {
								return function (proposals_voted) {
									return function (delegate) {
										return function (rank) {
											return function (transactions) {
												return function (total_delegates) {
													return {g9: account_url, hd: address, kr: balance, k$: delegate, h_: display_name, is: image_url, mq: proposals_created, mr: proposals_voted, mt: rank, nt: total_delegates, ny: transactions, nH: vote_weight, nI: votes};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CompoundApi$Governance$Common$Decoders$compAccountDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_delegates',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'transactions',
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$Common$Decoders$compAccountTransactionDecoder)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rank',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'delegate',
				$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposals_voted',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'proposals_created',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vote_weight',
							$author$project$Eth$Decoders$stringDecimal,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'votes',
								$author$project$Eth$Decoders$stringDecimal,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'balance',
									$author$project$Eth$Decoders$stringDecimal,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'account_url',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'image_url',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'display_name',
												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'address',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$Common$Models$createCompAccount))))))))))))));
var $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'order_by',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$AccountService$Decoders$accountFilterByDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'with_history', $elm$json$Json$Decode$bool))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'accounts',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$Common$Decoders$compAccountDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Governance$AccountProfile$loadAccountDetails = F3(
	function (apiBaseUrlMap, network, accountAddress) {
		var maybeRequestRecentVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				kh: $elm$core$Maybe$Just(accountAddress),
				mg: 1,
				mh: $author$project$Governance$AccountProfile$desiredPageSize,
				gq: $elm$core$Maybe$Nothing,
				gO: $elm$core$Maybe$Nothing,
				nP: true
			});
		var maybeRequestGovAccountUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{
				km: _List_fromArray(
					[accountAddress]),
				mb: $elm$core$Maybe$Nothing,
				mg: 1,
				mh: 1,
				nO: true
			});
		var maybeRequestCompDistributionUrl = A3(
			$author$project$CompoundApi$Governance$CompService$Urls$accountCompDistributionUrl,
			apiBaseUrlMap,
			network,
			{hd: accountAddress});
		var maybeAccountsUrl = A3(
			$author$project$CompoundApi$Presidio$Accounts$Urls$accountsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				km: _List_fromArray(
					[accountAddress]),
				ku: 0,
				lR: $elm$core$Maybe$Nothing,
				lX: $elm$core$Maybe$Nothing,
				mg: 1,
				mh: 1
			});
		var requestCmds = function () {
			var _v0 = _Utils_Tuple2(
				_Utils_Tuple2(maybeRequestGovAccountUrl, maybeRequestRecentVoteReceiptsUrl),
				_Utils_Tuple2(maybeAccountsUrl, maybeRequestCompDistributionUrl));
			if ((((!_v0.a.a.$) && (!_v0.a.b.$)) && (!_v0.b.a.$)) && (!_v0.b.b.$)) {
				var _v1 = _v0.a;
				var requestGovAccountUrl = _v1.a.a;
				var requestRecentVoteReceiptsUrl = _v1.b.a;
				var _v2 = _v0.b;
				var accountsUrl = _v2.a.a;
				var requestCompDistributionUrl = _v2.b.a;
				var recentVoteReceiptsRequest = A2($elm$http$Http$get, requestRecentVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder);
				var govAccountRequest = A2($elm$http$Http$get, requestGovAccountUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
				var compDistributionRequest = A2($elm$http$Http$get, requestCompDistributionUrl, $author$project$CompoundApi$Governance$CompService$Decoders$accountCompDistributionResponseDecoder);
				var accountsRequestHttpGet = A2($elm$http$Http$get, accountsUrl, $author$project$CompoundApi$Presidio$Accounts$Decoders$accountsResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$GovAccountResponse, govAccountRequest),
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$RecentVoteReceiptsResponse, recentVoteReceiptsRequest),
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$PresidioAccountsResponse, accountsRequestHttpGet),
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$CompDistributionResponse, compDistributionRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Governance$AccountProfile$emptyState,
				{aK: $author$project$Governance$AccountProfile$Loading}),
			$elm$core$Platform$Cmd$batch(requestCmds));
	});
var $author$project$LandingSite$Comp$CompDistributionResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$CompoundApi$Governance$CompService$Models$MarketCompDistributionRequest = function (addresses) {
	return {km: addresses};
};
var $author$project$CompoundApi$Governance$CompService$Models$MarketCompDistributionResponse = F6(
	function (comp_rate, daily_comp, markets, request, total_comp_allocated, total_comp_distributed) {
		return {kR: comp_rate, hR: daily_comp, iN: markets, jw: request, nr: total_comp_allocated, ns: total_comp_distributed};
	});
var $author$project$CompoundApi$Governance$CompService$Models$MarketCompDistibution = function (address) {
	return function (borrower_daily_comp) {
		return function (comp_allocated) {
			return function (comp_borrow_index) {
				return function (comp_distributed) {
					return function (comp_speed) {
						return function (comp_supply_index) {
							return function (name) {
								return function (supplier_daily_comp) {
									return function (symbol) {
										return function (underlying_address) {
											return function (underlying_name) {
												return function (underlying_symbol) {
													return {hd: address, kB: borrower_daily_comp, hH: comp_allocated, hI: comp_borrow_index, hJ: comp_distributed, kS: comp_speed, hK: comp_supply_index, i5: name, mW: supplier_daily_comp, jS: symbol, j1: underlying_address, j2: underlying_name, j4: underlying_symbol};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CompoundApi$Governance$CompService$Decoders$marketCompDistributionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'underlying_symbol',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'underlying_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'underlying_address',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'symbol',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'supplier_daily_comp',
					$author$project$Eth$Decoders$stringDecimal,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'comp_supply_index',
							$author$project$Eth$Decoders$stringDecimal,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'comp_speed',
								$author$project$Eth$Decoders$stringDecimal,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'comp_distributed',
									$author$project$Eth$Decoders$stringDecimal,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'comp_borrow_index',
										$author$project$Eth$Decoders$stringDecimal,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'comp_allocated',
											$author$project$Eth$Decoders$stringDecimal,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'borrower_daily_comp',
												$author$project$Eth$Decoders$stringDecimal,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'address',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$CompService$Models$MarketCompDistibution))))))))))))));
var $author$project$CompoundApi$Governance$CompService$Decoders$marketCompDistributionResponseDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$CompoundApi$Governance$CompService$Models$MarketCompDistributionResponse,
	A2($elm$json$Json$Decode$field, 'comp_rate', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'daily_comp', $author$project$Eth$Decoders$stringDecimal),
	A2(
		$elm$json$Json$Decode$field,
		'markets',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$CompService$Decoders$marketCompDistributionDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$CompoundApi$Governance$CompService$Models$MarketCompDistributionRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))),
	A2($elm$json$Json$Decode$field, 'total_comp_allocated', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'total_comp_distributed', $author$project$Eth$Decoders$stringDecimal));
var $author$project$CompoundApi$Governance$CompService$Urls$marketCompDistributionUrl = F3(
	function (apiBaseUrlMap, network, marketRequest) {
		var queryParams = function () {
			var _v0 = marketRequest.km;
			if (!_v0.b) {
				return _List_Nil;
			} else {
				var addressList = _v0;
				var addressesQueryArg = A2($elm$core$String$join, ',', addressList);
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'addresses', addressesQueryArg)
					]);
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/comp', queryParams);
	});
var $author$project$LandingSite$Comp$loadCompDetails = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestCompDistributionUrl = A3(
			$author$project$CompoundApi$Governance$CompService$Urls$marketCompDistributionUrl,
			apiBaseUrlMap,
			network,
			{km: _List_Nil});
		var requestCmds = function () {
			if (!maybeRequestCompDistributionUrl.$) {
				var requestCompDistributionUrl = maybeRequestCompDistributionUrl.a;
				var compDistributionRequest = A2($elm$http$Http$get, requestCompDistributionUrl, $author$project$CompoundApi$Governance$CompService$Decoders$marketCompDistributionResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$LandingSite$Comp$CompDistributionResponse, compDistributionRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return _Utils_Tuple2(
			$author$project$LandingSite$Comp$emptyState,
			$elm$core$Platform$Cmd$batch(requestCmds));
	});
var $author$project$Governance$Home$HistoricalDataResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Home$LatestProposalsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Home$TopDelegatesResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$CompoundApi$Governance$HistoryService$Urls$governanceHistoryRequestUrl = F3(
	function (apiBaseUrlMap, network, _v0) {
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/history', _List_Nil);
	});
var $author$project$CompoundApi$Governance$HistoryService$Models$GovernanceHistoryResponse = F6(
	function (error, proposals_created, token_holders, total_comp_allocated, votes_delegated, voting_addresses) {
		return {h5: error, mq: proposals_created, nj: token_holders, nr: total_comp_allocated, nJ: votes_delegated, nK: voting_addresses};
	});
var $author$project$CompoundApi$Governance$HistoryService$Decoders$governanceHistoryResponseDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$CompoundApi$Governance$HistoryService$Models$GovernanceHistoryResponse,
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder),
	A2($elm$json$Json$Decode$field, 'proposals_created', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'token_holders', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_comp_allocated', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'votes_delegated', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'voting_addresses', $elm$json$Json$Decode$int));
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsResponse = F4(
	function (request, pagination_summary, proposals, error) {
		return {h5: error, jf: pagination_summary, jq: proposals, jw: request};
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest,
			A2(
				$elm$json$Json$Decode$field,
				'proposal_ids',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'state',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$field,
				'with_detail',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposals',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Governance$Home$loadDashboard = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestTopDelegatesUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{
				km: _List_Nil,
				mb: $elm$core$Maybe$Just(0),
				mg: 1,
				mh: 5,
				nO: false
			});
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				mg: 1,
				mh: 3,
				mo: _List_Nil,
				jL: $elm$core$Maybe$Nothing,
				nN: $elm$core$Maybe$Just(false)
			});
		var maybeRequestHistoryUrl = A3(
			$author$project$CompoundApi$Governance$HistoryService$Urls$governanceHistoryRequestUrl,
			apiBaseUrlMap,
			network,
			{});
		var requestCmds = function () {
			var _v0 = _Utils_Tuple3(maybeRequestHistoryUrl, maybeRequestProposalsUrl, maybeRequestTopDelegatesUrl);
			if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
				var requestHistoryUrl = _v0.a.a;
				var requestProposalsUrl = _v0.b.a;
				var requestTopDelegatesUrl = _v0.c.a;
				var topDelegatesRequest = A2($elm$http$Http$get, requestTopDelegatesUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
				var latestProposalsRequest = A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder);
				var historyRequest = A2($elm$http$Http$get, requestHistoryUrl, $author$project$CompoundApi$Governance$HistoryService$Decoders$governanceHistoryResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$Governance$Home$LatestProposalsResponse, latestProposalsRequest),
						A2($elm$http$Http$send, $author$project$Governance$Home$TopDelegatesResponse, topDelegatesRequest),
						A2($elm$http$Http$send, $author$project$Governance$Home$HistoricalDataResponse, historyRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return $elm$core$Platform$Cmd$batch(requestCmds);
	});
var $author$project$LandingSite$CTokens$ForParent = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$CTokens$WrappedGraphMsg = $elm$core$Basics$identity;
var $author$project$Eth$Ethereum$getContractAddressString = function (contractAddress) {
	var addressString = contractAddress;
	return addressString;
};
var $author$project$Utils$Graph$graphBuckets = 30;
var $author$project$Utils$Graph$graphLengthSeconds = ((60 * 60) * 24) * 30;
var $author$project$Utils$Graph$GetInterestRateHistoryGraphResponse = $elm$core$Basics$identity;
var $author$project$Console$log = _Platform_outgoingPort('log', $elm$json$Json$Encode$string);
var $author$project$Console$error = function (err) {
	return $author$project$Console$log('Error: ' + err);
};
var $author$project$Utils$Graph$API_MarketTotal = F3(
	function (block_number, block_timestamp, total) {
		return {ku: block_number, kv: block_timestamp, gT: total};
	});
var $author$project$Utils$Graph$API_Price = F3(
	function (block_number, block_timestamp, price) {
		return {ku: block_number, kv: block_timestamp, mk: price};
	});
var $author$project$Utils$Graph$API_Rate = F3(
	function (block_number, block_timestamp, rate) {
		return {ku: block_number, kv: block_timestamp, jt: rate};
	});
var $author$project$Utils$Graph$InterestRateHistoryGraph = F7(
	function (assetAddress, supplyRateData, borrowRateData, exchangeRateData, totalSupplyData, totalBorrowsData, pricesUsdData) {
		return {kp: assetAddress, hr: borrowRateData, h8: exchangeRateData, jl: pricesUsdData, jQ: supplyRateData, jZ: totalBorrowsData, j_: totalSupplyData};
	});
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $author$project$Decimal$mul = F2(
	function (_v0, _v1) {
		var ma = _v0.a;
		var ea = _v0.b;
		var mb = _v1.a;
		var eb = _v1.b;
		return A2(
			$author$project$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$mul, ma, mb),
			ea + eb);
	});
var $author$project$Eth$Decoders$encodedDecimal = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var man = _v0.a;
		var exp = _v0.b;
		var expDec = A2($author$project$Decimal$fromIntWithExponent, 1, (-1) * exp);
		return A2($author$project$Decimal$mul, man, expDec);
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2($elm$json$Json$Decode$field, 'man', $author$project$Eth$Decoders$stringDecimal),
		A2($elm$json$Json$Decode$field, 'exp', $elm$json$Json$Decode$int)));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Decimal$fromFloat = function (f) {
	return $author$project$Decimal$fromString(
		$elm$core$String$fromFloat(f));
};
var $author$project$Eth$Decoders$floatDecimal = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Eth$Decoders$forceMaybe('invalid float'),
	A2($elm$json$Json$Decode$map, $author$project$Decimal$fromFloat, $elm$json$Json$Decode$float));
var $author$project$Eth$Decoders$decimal = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Eth$Decoders$floatDecimal, $author$project$Eth$Decoders$stringDecimal, $author$project$Eth$Decoders$encodedDecimal]));
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Utils$Graph$getInterestRateHistoryGraphResponseDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Utils$Graph$InterestRateHistoryGraph,
	A2($elm$json$Json$Decode$field, 'asset', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'supply_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'borrow_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'exchange_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'total_supply_history',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_MarketTotal,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'total', $author$project$CompoundApi$Common$Decoders$apiPrecise)))),
	A2(
		$elm$json$Json$Decode$field,
		'total_borrows_history',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_MarketTotal,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'total', $author$project$CompoundApi$Common$Decoders$apiPrecise)))),
	A2(
		$elm$json$Json$Decode$field,
		'prices_usd',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Price,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'price', $author$project$CompoundApi$Common$Decoders$apiPrecise)))));
var $author$project$Utils$Graph$getInterestRateHistoryGraphUrl = F3(
	function (apiBaseUrlMap, network, graphRequest) {
		var requiredQueryParams = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'asset', graphRequest.dD),
				A2(
				$elm$url$Url$Builder$string,
				'min_block_timestamp',
				$elm$core$String$fromInt(graphRequest.f0)),
				A2(
				$elm$url$Url$Builder$string,
				'max_block_timestamp',
				$elm$core$String$fromInt(graphRequest.fX)),
				A2(
				$elm$url$Url$Builder$string,
				'num_buckets',
				$elm$core$String$fromInt(graphRequest.f6))
			]);
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/market_history/graph', requiredQueryParams);
	});
var $author$project$Utils$Graph$loadInterestRateHistoryGraphWithBuckets = F6(
	function (assetAddress, minTime, maxTime, buckets, apiBaseUrlMap, network) {
		var maybeGetInterestRateHistoryGraphUrl = A3(
			$author$project$Utils$Graph$getInterestRateHistoryGraphUrl,
			apiBaseUrlMap,
			network,
			{dD: assetAddress, fX: maxTime, f0: minTime, f6: buckets});
		if (!maybeGetInterestRateHistoryGraphUrl.$) {
			var interestRateHistoryGraphUrl = maybeGetInterestRateHistoryGraphUrl.a;
			return A2(
				$elm$http$Http$send,
				$elm$core$Basics$identity,
				A2($elm$http$Http$get, interestRateHistoryGraphUrl, $author$project$Utils$Graph$getInterestRateHistoryGraphResponseDecoder));
		} else {
			return $author$project$Console$error(
				'UNSUPPORTED GRAPH API NETWORK' + $author$project$Network$networkName(network));
		}
	});
var $author$project$Utils$Graph$loadInterestRateHistoryGraph = F4(
	function (assetAddress, time, apiBaseUrlMap, network) {
		return A6($author$project$Utils$Graph$loadInterestRateHistoryGraphWithBuckets, assetAddress, time - $author$project$Utils$Graph$graphLengthSeconds, time, $author$project$Utils$Graph$graphBuckets, apiBaseUrlMap, network);
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Utils$Time$posixToSeconds = function (time) {
	var ms = $elm$time$Time$posixToMillis(time);
	var msFloat = ms / 1000;
	return $elm$core$Basics$floor(msFloat);
};
var $author$project$LandingSite$CTokens$loadGraphCmd = F4(
	function (apiBaseUrlMap, network, maybeCurrentTime, maybeCToken) {
		var _v0 = _Utils_Tuple2(maybeCurrentTime, maybeCToken);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var currentTime = _v0.a.a;
			var token = _v0.b.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$LandingSite$CTokens$ForParent, $elm$core$Basics$identity),
				A4(
					$author$project$Utils$Graph$loadInterestRateHistoryGraph,
					$author$project$Eth$Ethereum$getContractAddressString(token.hd),
					$author$project$Utils$Time$posixToSeconds(currentTime),
					apiBaseUrlMap,
					network));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$LandingSite$MarketDetail$CompDistributionResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$LandingSite$MarketDetail$ForParent = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$MarketDetail$ForSelf = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$MarketDetail$WrappedGraphMsg = $elm$core$Basics$identity;
var $author$project$LandingSite$MarketDetailHelper$RateModelDataPoint = F2(
	function (utilizationPercent, rate) {
		return {jt: rate, aC: utilizationPercent};
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Decimal$addDecimals = F2(
	function (i, _v0) {
		addDecimals:
		while (true) {
			var m = _v0.a;
			var e = _v0.b;
			var mul10 = function (x) {
				return A2(
					$cmditch$elm_bigint$BigInt$mul,
					x,
					$cmditch$elm_bigint$BigInt$fromInt(10));
			};
			if (!i) {
				return A2($author$project$Decimal$Decimal, m, e);
			} else {
				if (i > 0) {
					var $temp$i = i - 1,
						$temp$_v0 = A2(
						$author$project$Decimal$Decimal,
						mul10(m),
						e - 1);
					i = $temp$i;
					_v0 = $temp$_v0;
					continue addDecimals;
				} else {
					return A2($author$project$Decimal$Decimal, m, e);
				}
			}
		}
	});
var $author$project$Decimal$toExponent = F2(
	function (e, _v0) {
		var md = _v0.a;
		var ed = _v0.b;
		return A2(
			$author$project$Decimal$addDecimals,
			ed - e,
			A2($author$project$Decimal$Decimal, md, ed));
	});
var $author$project$Decimal$toCommonExponent = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var _v1 = b;
	var mb = _v1.a;
	var eb = _v1.b;
	var _v2 = a;
	var ma = _v2.a;
	var ea = _v2.b;
	var exponent = A2($elm$core$Basics$min, ea, eb);
	return _Utils_Tuple2(
		A2($author$project$Decimal$toExponent, exponent, a),
		A2($author$project$Decimal$toExponent, exponent, b));
};
var $author$project$Decimal$add = F2(
	function (a, b) {
		var _v0 = $author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var ra = _v0.a;
		var rb = _v0.b;
		var _v1 = rb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = ra;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2(
			$author$project$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$add, ma, mb),
			ea);
	});
var $author$project$Decimal$compare = F2(
	function (a, b) {
		var _v0 = $author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var fa = _v0.a;
		var fb = _v0.b;
		var _v1 = fb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = fa;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2($cmditch$elm_bigint$BigInt$compare, ma, mb);
	});
var $author$project$Decimal$lt = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (!_v0) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Functions$decimalMin = F2(
	function (a, b) {
		return A2($author$project$Decimal$lt, a, b) ? a : b;
	});
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Decimal$toFloat = function (d) {
	var _v0 = $elm$core$String$toFloat(
		$author$project$Decimal$toString(d));
	if (!_v0.$) {
		var a = _v0.a;
		return a;
	} else {
		return 42.0;
	}
};
var $author$project$Decimal$fastdiv = F2(
	function (a, b) {
		var fb = $author$project$Decimal$toFloat(b);
		var fa = $author$project$Decimal$toFloat(a);
		var res = fa / fb;
		return $author$project$Decimal$fromFloat(res);
	});
var $author$project$Decimal$negate = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	return A2(
		$author$project$Decimal$Decimal,
		$cmditch$elm_bigint$BigInt$negate(m),
		e);
};
var $author$project$Decimal$sub = F2(
	function (a, b) {
		return A2(
			$author$project$Decimal$add,
			a,
			$author$project$Decimal$negate(b));
	});
var $author$project$LandingSite$MarketDetailHelper$computeUtilizationRate = function (selectedToken) {
	return 100 * $author$project$Decimal$toFloat(
		A2(
			$author$project$Functions$decimalMin,
			$author$project$Decimal$fromInt(100),
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Decimal$zero,
				A2(
					$author$project$Decimal$fastdiv,
					selectedToken.np,
					function (cashPlusBorrows) {
						return A2($author$project$Decimal$sub, cashPlusBorrows, selectedToken.my);
					}(
						A2($author$project$Decimal$add, selectedToken.kH, selectedToken.np))))));
};
var $author$project$LandingSite$MarketDetailHelper$JumpRateModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$MarketDetailHelper$RegularRateModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$MarketDetailHelper$getFormula = F2(
	function (network, underlyingSymbol) {
		if (network === 1) {
			switch (underlyingSymbol) {
				case 'USDC':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope1000bps', F: 0.05, J: 0.1});
				case 'DAI':
					return $author$project$LandingSite$MarketDetailHelper$JumpRateModel(
						{A: 0.0, fA: 1.09, fB: 0.8, i5: 'DAIInterestRateModelV3', F: 0.05, J: 0.05});
				case 'USDT':
					return $author$project$LandingSite$MarketDetailHelper$JumpRateModel(
						{A: 0.0, fA: 1.09, fB: 0.8, i5: 'JumpRateModelV2', F: 0.2, J: 0.05});
				case 'BAT':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope3000bps', F: 0.5, J: 0.3});
				case 'ETH':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope1000bps', F: 0.1, J: 0.1});
				case 'SAI':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.05, i5: 'Base500bps_Slope1200bps', F: 1.0, J: 0.12});
				case 'REP':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope3000bps', F: 1.0, J: 0.3});
				case 'ZRX':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope3000bps', F: 0.5, J: 0.3});
				case 'WBTC':
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.02, i5: 'Base200bps_Slope3000bps', F: 0.1, J: 0.3});
				default:
					return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
						{A: 0.0, i5: 'Unkown Model', F: 0.0, J: 0.0});
			}
		} else {
			return $author$project$LandingSite$MarketDetailHelper$RegularRateModel(
				{A: 0.0, i5: 'Unkown Model', F: 0.0, J: 0.0});
		}
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$LandingSite$MarketDetailHelper$injectComputedValue = F2(
	function (_v0, listOfPoints) {
		var xValue = _v0.a;
		var yValue = _v0.b;
		var _v1 = A2(
			$elm_community$list_extra$List$Extra$splitAt,
			$elm$core$Basics$floor(xValue) + 1,
			listOfPoints);
		var firstPart = _v1.a;
		var lastPart = _v1.b;
		return _Utils_ap(
			firstPart,
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$LandingSite$MarketDetailHelper$RateModelDataPoint, xValue, yValue)
					]),
				lastPart));
	});
var $author$project$LandingSite$MarketDetailHelper$jumpRateModel = F6(
	function (reserveFactor, base, slope, kink, jump, utilizationPercent) {
		var utilizationScaledDown = utilizationPercent / 100.0;
		var _v0 = function () {
			if (_Utils_cmp(utilizationScaledDown, kink) < 0) {
				var borrowRate = base + (slope * utilizationScaledDown);
				var rateToPool = borrowRate * (1 - reserveFactor);
				var supplyRate = utilizationScaledDown * rateToPool;
				return _Utils_Tuple2(supplyRate, borrowRate);
			} else {
				var normalRate = (kink * slope) + base;
				var excessUtil = utilizationScaledDown - kink;
				var borrowRate = (excessUtil * jump) + normalRate;
				var rateToPool = borrowRate * (1 - reserveFactor);
				var supplyRate = utilizationScaledDown * rateToPool;
				return _Utils_Tuple2(supplyRate, borrowRate);
			}
		}();
		var supplyAPR = _v0.a;
		var borrowAPR = _v0.b;
		var _v1 = _Utils_Tuple2(supplyAPR / 365.0, borrowAPR / 365.0);
		var supplyDailyRate = _v1.a;
		var borrowDailyRate = _v1.b;
		var _v2 = _Utils_Tuple2(
			A2($elm$core$Basics$pow, 1.0 + supplyDailyRate, 365) - 1,
			A2($elm$core$Basics$pow, 1.0 + borrowDailyRate, 365) - 1);
		var supplyAPY = _v2.a;
		var borrowAPY = _v2.b;
		return _Utils_Tuple2(supplyAPY * 100, borrowAPY * 100);
	});
var $author$project$LandingSite$MarketDetailHelper$regularRateModel = F4(
	function (reserveFactor, base, slope, utilizationPercent) {
		var utilizationScaledDown = utilizationPercent / 100;
		var borrowAPR = base + (slope * utilizationScaledDown);
		var rateToPool = borrowAPR * (1 - reserveFactor);
		var supplyAPR = utilizationScaledDown * rateToPool;
		var _v0 = _Utils_Tuple2(supplyAPR / 365.0, borrowAPR / 365.0);
		var supplyDailyRate = _v0.a;
		var borrowDailyRate = _v0.b;
		var _v1 = _Utils_Tuple2(
			A2($elm$core$Basics$pow, 1.0 + supplyDailyRate, 365) - 1,
			A2($elm$core$Basics$pow, 1.0 + borrowDailyRate, 365) - 1);
		var supplyAPY = _v1.a;
		var borrowAPY = _v1.b;
		return _Utils_Tuple2(supplyAPY * 100, borrowAPY * 100);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$LandingSite$MarketDetailHelper$generateInterestRateModelPoints = F3(
	function (network, underlyingSymbol, maybeSelectedToken) {
		if (!maybeSelectedToken.$) {
			var selectedToken = maybeSelectedToken.a;
			var referenceList = A2($elm$core$List$range, 0, 100);
			var rateModelFormula = function () {
				var _v4 = A2($author$project$LandingSite$MarketDetailHelper$getFormula, network, underlyingSymbol);
				if (!_v4.$) {
					var reserveFactor = _v4.a.F;
					var base = _v4.a.A;
					var slope = _v4.a.J;
					return A3($author$project$LandingSite$MarketDetailHelper$regularRateModel, reserveFactor, base, slope);
				} else {
					var reserveFactor = _v4.a.F;
					var base = _v4.a.A;
					var slope = _v4.a.J;
					var kink = _v4.a.fB;
					var jump = _v4.a.fA;
					return A5($author$project$LandingSite$MarketDetailHelper$jumpRateModel, reserveFactor, base, slope, kink, jump);
				}
			}();
			var highestRate = function (rate) {
				return rate + (rate * 0.18);
			}(
				rateModelFormula(100).b);
			var utilizationRateYValue = (highestRate === 0.0) ? 5.0 : highestRate;
			var utilizationRates = A2(
				$elm$core$List$map,
				function (i) {
					return A2($author$project$LandingSite$MarketDetailHelper$RateModelDataPoint, i, utilizationRateYValue);
				},
				referenceList);
			var computedUtilizationRate = $author$project$LandingSite$MarketDetailHelper$computeUtilizationRate(selectedToken);
			var finalUtilizationRates = A2(
				$author$project$LandingSite$MarketDetailHelper$injectComputedValue,
				_Utils_Tuple2(computedUtilizationRate, utilizationRateYValue),
				utilizationRates);
			var allRates = A2(
				$elm$core$List$map,
				function (i) {
					var iFloat = i;
					var _v3 = rateModelFormula(iFloat);
					var supplyRate = _v3.a;
					var borrowRate = _v3.b;
					return _Utils_Tuple2(
						A2($author$project$LandingSite$MarketDetailHelper$RateModelDataPoint, iFloat, supplyRate),
						A2($author$project$LandingSite$MarketDetailHelper$RateModelDataPoint, iFloat, borrowRate));
				},
				referenceList);
			var _v1 = rateModelFormula(computedUtilizationRate);
			var computedSupplyRate = _v1.a;
			var computedBorrowRate = _v1.b;
			var _v2 = $elm$core$List$unzip(allRates);
			var supplyRates = _v2.a;
			var borrowRates = _v2.b;
			var finalBorrowRates = A2(
				$author$project$LandingSite$MarketDetailHelper$injectComputedValue,
				_Utils_Tuple2(computedUtilizationRate, computedBorrowRate),
				borrowRates);
			var finalSupplyRates = A2(
				$author$project$LandingSite$MarketDetailHelper$injectComputedValue,
				_Utils_Tuple2(computedUtilizationRate, computedSupplyRate),
				supplyRates);
			return _Utils_Tuple3(finalUtilizationRates, finalBorrowRates, finalSupplyRates);
		} else {
			return _Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil);
		}
	});
var $author$project$LandingSite$MarketDetail$loadMarketDetails = F7(
	function (apiBaseUrlMap, network, maybeCurrentTime, maybeConfig, maybeLatestTokens, selectedUnderlyingSymbol, oldModel) {
		var maybeSelectedCToken = $author$project$Functions$demaybeify(
			A2(
				$elm$core$Maybe$map,
				function (tokens) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (cToken) {
								return _Utils_eq(cToken.j4, selectedUnderlyingSymbol);
							},
							tokens.kG));
				},
				maybeLatestTokens));
		var maybeCToken = A2(
			$elm$core$Maybe$andThen,
			function (config) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (cToken) {
							return _Utils_eq(cToken.cy.jS, selectedUnderlyingSymbol);
						},
						$elm$core$Dict$values(config.ht)));
			},
			maybeConfig);
		var loadCompDistributionCmd = _Utils_eq(oldModel.ee, $elm$core$Maybe$Nothing) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (requestCompDistributionUrl) {
					var compDistributionRequest = A2($elm$http$Http$get, requestCompDistributionUrl, $author$project$CompoundApi$Governance$CompService$Decoders$marketCompDistributionResponseDecoder);
					return A2(
						$elm$http$Http$send,
						A2($elm$core$Basics$composeL, $author$project$LandingSite$MarketDetail$ForSelf, $author$project$LandingSite$MarketDetail$CompDistributionResponse),
						compDistributionRequest);
				},
				A3(
					$author$project$CompoundApi$Governance$CompService$Urls$marketCompDistributionUrl,
					apiBaseUrlMap,
					network,
					{km: _List_Nil}))) : $elm$core$Platform$Cmd$none;
		var buckets = 64;
		var loadGraphCmd = function () {
			var _v3 = _Utils_Tuple2(maybeCurrentTime, maybeCToken);
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var currentTime = _v3.a.a;
				var token = _v3.b.a;
				var maxTime = $author$project$Utils$Time$posixToSeconds(currentTime);
				var minTime = maxTime - (((60 * 60) * 24) * buckets);
				return A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, $author$project$LandingSite$MarketDetail$ForParent, $elm$core$Basics$identity),
					A6(
						$author$project$Utils$Graph$loadInterestRateHistoryGraphWithBuckets,
						$author$project$Eth$Ethereum$getContractAddressString(token.hd),
						minTime,
						maxTime,
						buckets,
						apiBaseUrlMap,
						network));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = A3($author$project$LandingSite$MarketDetailHelper$generateInterestRateModelPoints, network, selectedUnderlyingSymbol, maybeSelectedCToken);
		var utilizationReferenceData = _v0.a;
		var borrowRateData = _v0.b;
		var supplyRateData = _v0.c;
		var updatedBorrowRatesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v2) {
					var utilizationPercent = _v2.aC;
					var rate = _v2.jt;
					return _Utils_Tuple2(utilizationPercent, rate);
				},
				borrowRateData));
		var updatedSupplyRatesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var utilizationPercent = _v1.aC;
					var rate = _v1.jt;
					return _Utils_Tuple2(utilizationPercent, rate);
				},
				supplyRateData));
		return _Utils_Tuple2(
			_Utils_update(
				oldModel,
				{
					bG: 0,
					cF: borrowRateData,
					cG: updatedBorrowRatesDict,
					bb: $elm$core$Maybe$Nothing,
					b1: $elm$core$Maybe$Nothing,
					eg: maybeSelectedCToken,
					cc: $elm$core$Maybe$Just(selectedUnderlyingSymbol),
					dj: supplyRateData,
					dk: updatedSupplyRatesDict,
					dx: utilizationReferenceData
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[loadGraphCmd, loadCompDistributionCmd])));
	});
var $author$project$Governance$ProposalOverview$AllProposalsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalOverview$desiredPageSize = 25;
var $author$project$Governance$ProposalOverview$loadProposals = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				mg: 1,
				mh: $author$project$Governance$ProposalOverview$desiredPageSize,
				mo: _List_Nil,
				jL: $elm$core$Maybe$Nothing,
				nN: $elm$core$Maybe$Just(false)
			});
		var requestCmd = function () {
			if (!maybeRequestProposalsUrl.$) {
				var requestProposalsUrl = maybeRequestProposalsUrl.a;
				var allProposalsRequest = A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder);
				return A2($elm$http$Http$send, $author$project$Governance$ProposalOverview$AllProposalsResponse, allProposalsRequest);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return requestCmd;
	});
var $author$project$Governance$Leaderboard$TopDelegatesResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Leaderboard$loadTop100Delegates = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestTopDelegatesUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{km: _List_Nil, mb: $elm$core$Maybe$Nothing, mg: 1, mh: 100, nO: false});
		if (!maybeRequestTopDelegatesUrl.$) {
			var requestTopDelegatesUrl = maybeRequestTopDelegatesUrl.a;
			var topDelegatesRequest = A2($elm$http$Http$get, requestTopDelegatesUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
			return A2($elm$http$Http$send, $author$project$Governance$Leaderboard$TopDelegatesResponse, topDelegatesRequest);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$LandingSite$Main$handlePageUpdates = F2(
	function (newPage, oldModel) {
		switch (newPage.$) {
			case 1:
				var _v1 = $author$project$LandingSite$About$init;
				var landingModel = _v1.a;
				var landingCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{b6: landingModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingAboutTranslator, landingCmd));
			case 2:
				var _v2 = A2($author$project$LandingSite$Comp$loadCompDetails, oldModel.o, oldModel.bo);
				var updatedCompModel = _v2.a;
				var compCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{bl: updatedCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$LandingCompMsg, compCmd));
			case 3:
				var oldLandingCTokensModel = oldModel.av;
				var maybeConfig = $author$project$LandingSite$Main$getConfig(oldModel);
				var maybeCToken = function () {
					if (!maybeConfig.$) {
						var config = maybeConfig.a;
						return A2($elm$core$Dict$get, 'cUSDC', config.ht);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var landingCTokensModel = _Utils_update(
					oldLandingCTokensModel,
					{cm: maybeCToken});
				var landingCTokensCmd = A4($author$project$LandingSite$CTokens$loadGraphCmd, oldModel.o, oldModel.bo, oldModel.t, maybeCToken);
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{av: landingCTokensModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCTokensTranslator, landingCTokensCmd));
			case 5:
				var _v4 = $author$project$LandingSite$Docs$init(oldModel.cj);
				var landingModel = _v4.a;
				var landingCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{bm: landingModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingDocsTranslator, landingCmd));
			case 6:
				var networkString = newPage.a;
				var contractName = newPage.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{
							cO: $elm$core$Maybe$Just(
								_Utils_Tuple2(networkString, contractName))
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var accountAddress = newPage.a;
				var _v5 = A3($author$project$Governance$AccountProfile$loadAccountDetails, oldModel.o, oldModel.bo, accountAddress);
				var updatedAccountProfileModel = _v5.a;
				var accountProfileCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{bf: updatedAccountProfileModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceAccountProfileMsg, accountProfileCmd));
			case 10:
				return _Utils_Tuple2(
					oldModel,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$LandingSite$Main$GovernanceHomeMsg,
						A2($author$project$Governance$Home$loadDashboard, oldModel.o, oldModel.bo)));
			case 11:
				var proposalId = newPage.a;
				var _v6 = A3($author$project$Governance$ProposalDetail$attempToLoadProposalId, oldModel.o, oldModel.bo, proposalId);
				var updatedProposalDetailModel = _v6.a;
				var proposalDetailCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{bh: updatedProposalDetailModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalDetailMsg, proposalDetailCmd));
			case 12:
				return _Utils_Tuple2(
					oldModel,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$LandingSite$Main$GovernanceProposalOverviewMsg,
						A2($author$project$Governance$ProposalOverview$loadProposals, oldModel.o, oldModel.bo)));
			case 13:
				return _Utils_Tuple2(
					oldModel,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$LandingSite$Main$GovernanceLeaderboardMsg,
						A2($author$project$Governance$Leaderboard$loadTop100Delegates, oldModel.o, oldModel.bo)));
			case 8:
				var underlyingSymbol = newPage.a;
				var maybeConfig = $author$project$LandingSite$Main$getConfig(oldModel);
				var _v7 = A7($author$project$LandingSite$MarketDetail$loadMarketDetails, oldModel.o, oldModel.bo, oldModel.t, maybeConfig, oldModel.ax, underlyingSymbol, oldModel.aj);
				var updatedLandingMarketDetailModel = _v7.a;
				var landingMarketDetailCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						oldModel,
						{aj: updatedLandingMarketDetailModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingMarketDetailTranslator, landingMarketDetailCmd));
			default:
				return _Utils_Tuple2(oldModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Strings$Translations$landing_site_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound is an algorithmic, autonomous interest rate protocol built for developers, to unlock a universe of open financial applications.';
		case 1:
			return 'Compuesto es un protocolo algorítmico de tasa de interés autónomo creado para desarrolladores, para desbloquear un universo de aplicaciones financieras abiertas.';
		case 2:
			return '复合是为开发人员构建的一种算法性，自主利率协议，用于解锁一系列开放式金融应用程序。';
		case 3:
			return 'Compound est un protocole algorithmique et autonome de taux d\'intérêt conçu pour les développeurs afin de déverrouiller un univers d\'applications financières ouvertes.';
		default:
			return 'Compound는 개방형 금융 애플리케이션에 대한 개발자의 접근성을 높이기 위해 구축된 알고리즘 방식의 자율 이자율 프로토콜입니다.';
	}
};
var $author$project$Strings$Translations$landing_site_governance_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound is managed by a decentralized community of COMP token-holders and their delegates, who propose and vote on upgrades to the protocol.';
		case 1:
			return 'El compuesto es administrado por una comunidad descentralizada de poseedores de tokens COMP y sus delegados, quienes proponen y votan sobre las actualizaciones del protocolo.';
		case 2:
			return 'Compound由COMP token持有人及其代表的去中心化社区管理，他们对协议的升级提出建议并进行投票。';
		case 3:
			return 'Compound est géré par une communauté décentralisée de détenteurs de jetons COMP et de leurs délégués, qui proposent et votent les mises à niveau du protocole.';
		default:
			return 'Compound는 COMP 토큰 보유자와 그들의 대리인으로 구성된 탈중앙화된 커뮤니티에 의해 운영되며, 이들은 프로토콜 업그레이드를 제안하고 투표에 참여합니다.';
	}
};
var $author$project$Strings$Translations$landing_site_markets_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound protocol supports 9 markets; ETH, DAI, USDC, BAT, ZRX, REP, WBTC, USDT, SAI.';
		case 1:
			return 'El protocolo compuesto admite 9 mercados; ETH, DAI, USDC, BAT, ZRX, REP, WBTC, USDT, SAI.';
		case 2:
			return '复合协议支持9个市场； ETH，DAI，USDC，BAT，ZRX，REP，WBTC，USDT，SAI。';
		case 3:
			return 'Le protocole composé prend en charge 9 marchés; ETH, DAI, USDC, BAT, ZRX, REP, WBTC, USDT, SAI.';
		default:
			return 'Compound 프로토콜은 9 개의 마켓을 지원합니다: ETH, DAI, USDC, BAT, ZRX, REP, WBTC, USDT, SAI.';
	}
};
var $author$project$LandingSite$Page$metaDescription = F2(
	function (userLanguage, page) {
		switch (page.$) {
			case 7:
				return $author$project$Strings$Translations$landing_site_markets_description(userLanguage);
			case 8:
				return $author$project$Strings$Translations$landing_site_markets_description(userLanguage);
			case 9:
				var accountAddress = page.a;
				return $author$project$Strings$Translations$landing_site_governance_description(userLanguage);
			case 10:
				return $author$project$Strings$Translations$landing_site_governance_description(userLanguage);
			case 11:
				return $author$project$Strings$Translations$landing_site_governance_description(userLanguage);
			case 12:
				return $author$project$Strings$Translations$landing_site_governance_description(userLanguage);
			case 13:
				return $author$project$Strings$Translations$landing_site_governance_description(userLanguage);
			default:
				return $author$project$Strings$Translations$landing_site_description(userLanguage);
		}
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$LandingSite$Main$pageTransition = _Platform_outgoingPort(
	'pageTransition',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$LandingSite$Main$setTitleAndDescription = _Platform_outgoingPort(
	'setTitleAndDescription',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Strings$Translations$site_title = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound';
		case 1:
			return 'Compound';
		case 2:
			return 'Compound';
		case 3:
			return 'Composé';
		default:
			return 'Compound';
	}
};
var $author$project$LandingSite$Page$buildTitle = F2(
	function (userLanguage, subTitle) {
		if (subTitle.$ === 1) {
			return $author$project$Strings$Translations$site_title(userLanguage);
		} else {
			var s = subTitle.a;
			return $author$project$Strings$Translations$site_title(userLanguage) + (' | ' + s);
		}
	});
var $author$project$Strings$Translations$site_title_abi = function (lang) {
	switch (lang) {
		case 0:
			return 'ABI';
		case 1:
			return 'ABI';
		case 2:
			return '阿比';
		case 3:
			return 'ABI';
		default:
			return 'ABI';
	}
};
var $author$project$Strings$Translations$site_title_about = function (lang) {
	switch (lang) {
		case 0:
			return 'About';
		case 1:
			return 'Acerca de';
		case 2:
			return '关于';
		case 3:
			return 'Sur';
		default:
			return '소개';
	}
};
var $author$project$Strings$Translations$site_title_comp = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Governance Token';
		case 1:
			return 'Token de gobierno compuesto';
		case 2:
			return '复合治理令牌';
		case 3:
			return 'Jeton de gouvernance composé';
		default:
			return 'Compound 거버넌스 토큰';
	}
};
var $author$project$Strings$Translations$site_title_ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens';
		case 1:
			return 'cTokens';
		case 2:
			return 'cTokens';
		case 3:
			return 'cTokens';
		default:
			return 'cTokens';
	}
};
var $author$project$Strings$Translations$site_title_developers = function (lang) {
	switch (lang) {
		case 0:
			return 'Developers';
		case 1:
			return 'Desarrolladores';
		case 2:
			return '开发者';
		case 3:
			return 'Développeurs';
		default:
			return '개발자';
	}
};
var $author$project$Strings$Translations$site_title_docs_api = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - API';
		case 1:
			return 'Documentos: API';
		case 2:
			return '文档-API';
		case 3:
			return 'Docs - API';
		default:
			return '문서 - API';
	}
};
var $author$project$Strings$Translations$site_title_docs_comptroller = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - Comptroller';
		case 1:
			return 'Docs - Contralor';
		case 2:
			return '文档-主计长';
		case 3:
			return 'Docs - Contrôleur';
		default:
			return '문서 - Comptroller';
	}
};
var $author$project$Strings$Translations$site_title_docs_ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - cTokens';
		case 1:
			return 'Documentos - cTokens';
		case 2:
			return '文档-cTokens';
		case 3:
			return 'Documents - cTokens';
		default:
			return '문서 - cTokens';
	}
};
var $author$project$Strings$Translations$site_title_docs_getting_started = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - Getting Started';
		case 1:
			return 'Documentos: cómo comenzar';
		case 2:
			return '文档-入门';
		case 3:
			return 'Docs - Prise en main';
		default:
			return '문서 - 시작하기';
	}
};
var $author$project$Strings$Translations$site_title_docs_governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - Governance';
		case 1:
			return 'Docs - Gobernanza';
		case 2:
			return '文档-治理';
		case 3:
			return 'Docs - Gouvernance';
		default:
			return '문서 - 거버넌스';
	}
};
var $author$project$Strings$Translations$site_title_docs_open_price_feed = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - Open Price Feed';
		case 1:
			return 'Documentos: feed de precios abiertos';
		case 2:
			return '文件-公开报价';
		case 3:
			return 'Docs - Flux de prix ouvert';
		default:
			return '문서-공개 가격 피드';
	}
};
var $author$project$Strings$Translations$site_title_docs_security = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs - Security';
		case 1:
			return 'Docs - Seguridad';
		case 2:
			return '文档-安全性';
		case 3:
			return 'Docs - Sécurité';
		default:
			return '문서 - 보안';
	}
};
var $author$project$Strings$Translations$site_title_governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance';
		case 1:
			return 'Gobernancia';
		case 2:
			return '治理';
		case 3:
			return 'La gouvernance';
		default:
			return '거버넌스';
	}
};
var $author$project$Strings$Translations$site_title_leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Leaderboard';
		case 1:
			return 'Tabla de clasificación';
		case 2:
			return '排行榜';
		case 3:
			return 'Classement';
		default:
			return '순위표';
	}
};
var $author$project$Strings$Translations$site_title_market_detail = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Detail';
		case 1:
			return 'Detalle del mercado';
		case 2:
			return '市场细节';
		case 3:
			return 'Détail du marché';
		default:
			return '마켓 세부 사항';
	}
};
var $author$project$Strings$Translations$site_title_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Markets';
		case 1:
			return 'Mercados';
		case 2:
			return '市场';
		case 3:
			return 'Marchés';
		default:
			return '마켓';
	}
};
var $author$project$Strings$Translations$site_title_prices = function (lang) {
	switch (lang) {
		case 0:
			return 'Prices';
		case 1:
			return 'Precios';
		case 2:
			return '价格';
		case 3:
			return 'Des prix';
		default:
			return '물가';
	}
};
var $author$project$Strings$Translations$site_title_profile = F2(
	function (lang, name) {
		switch (lang) {
			case 0:
				return 'Profile - ' + (name + '');
			case 1:
				return 'Nombre de perfil}}';
			case 2:
				return '个人资料-' + (name + '');
			case 3:
				return 'Nom de profil}}';
			default:
				return '프로필 - ' + (name + '');
		}
	});
var $author$project$Strings$Translations$site_title_proposal_detail = F2(
	function (lang, id) {
		switch (lang) {
			case 0:
				return 'Proposal Detail - ' + (id + '');
			case 1:
				return 'Detalle de la propuesta - ' + (id + '');
			case 2:
				return '投标详细信息-' + (id + '');
			case 3:
				return 'Détail de la proposition - ' + (id + '');
			default:
				return '제안서 세부 사항 - ' + (id + '');
		}
	});
var $author$project$Strings$Translations$site_title_proposal_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposal Overview';
		case 1:
			return 'Resumen de la propuesta';
		case 2:
			return '提案概述';
		case 3:
			return 'Aperçu de la proposition';
		default:
			return '제안서 개요';
	}
};
var $author$project$LandingSite$Page$title = F2(
	function (userLanguage, page) {
		switch (page.$) {
			case 0:
				return A2($author$project$LandingSite$Page$buildTitle, userLanguage, $elm$core$Maybe$Nothing);
			case 1:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_about(userLanguage)));
			case 2:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_comp(userLanguage)));
			case 3:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_ctokens(userLanguage)));
			case 4:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_developers(userLanguage)));
			case 5:
				switch (page.a) {
					case 0:
						var _v1 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_getting_started(userLanguage)));
					case 1:
						var _v2 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_ctokens(userLanguage)));
					case 2:
						var _v3 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_comptroller(userLanguage)));
					case 3:
						var _v4 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_governance(userLanguage)));
					case 4:
						var _v5 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_open_price_feed(userLanguage)));
					case 5:
						var _v6 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_api(userLanguage)));
					default:
						var _v7 = page.a;
						return A2(
							$author$project$LandingSite$Page$buildTitle,
							userLanguage,
							$elm$core$Maybe$Just(
								$author$project$Strings$Translations$site_title_docs_security(userLanguage)));
				}
			case 6:
				var network = page.a;
				var contract = page.b;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$elm$core$String$toUpper(network) + (' ' + (contract + (' ' + $author$project$Strings$Translations$site_title_abi(userLanguage))))));
			case 7:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_markets(userLanguage)));
			case 8:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_market_detail(userLanguage)));
			case 9:
				var accountAddress = page.a;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2($author$project$Strings$Translations$site_title_profile, userLanguage, accountAddress)));
			case 10:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_governance(userLanguage)));
			case 11:
				var proposalId = page.a;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2(
							$author$project$Strings$Translations$site_title_proposal_detail,
							userLanguage,
							$elm$core$String$fromInt(proposalId))));
			case 12:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_proposal_overview(userLanguage)));
			case 13:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_leaderboard(userLanguage)));
			default:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_prices(userLanguage)));
		}
	});
var $author$project$LandingSite$Main$transitionPage = F2(
	function (model, url) {
		var maybeConfig = $author$project$LandingSite$Main$getConfig(model);
		var abiResetModel = _Utils_update(
			model,
			{cO: $elm$core$Maybe$Nothing});
		var _v0 = function () {
			if (!url.$) {
				var location = url.a;
				var newPage_ = A2($author$project$LandingSite$Page$getLandingPage, maybeConfig, location);
				var newPages_ = function () {
					var _v2 = $elm$core$List$head(model.aV);
					if (!_v2.$) {
						var prevHead = _v2.a;
						return _Utils_eq(prevHead, newPage_) ? A2($elm$core$List$drop, 1, model.aV) : A2($elm$core$List$cons, model._, model.aV);
					} else {
						var _v3 = _Utils_Tuple2(model._, newPage_);
						_v3$2:
						while (true) {
							switch (_v3.b.$) {
								case 9:
									if (!_v3.a.$) {
										var _v4 = _v3.a;
										return _List_fromArray(
											[$author$project$LandingSite$Page$GovernanceLeaderboard]);
									} else {
										break _v3$2;
									}
								case 10:
									var _v5 = _v3.b;
									return _List_Nil;
								default:
									break _v3$2;
							}
						}
						return _List_fromArray(
							[$author$project$LandingSite$Page$GovernanceHome]);
					}
				}();
				return _Utils_Tuple2(newPage_, newPages_);
			} else {
				return _Utils_Tuple2($author$project$LandingSite$Page$Home, model.aV);
			}
		}();
		var newPage = _v0.a;
		var newPages = _v0.b;
		var maybeScrollCmd = A2(
			$elm$core$Task$perform,
			$author$project$LandingSite$Main$DelayScroll,
			A2(
				$elm$core$Task$andThen,
				function (_v7) {
					return $elm$core$Task$succeed(newPage);
				},
				$elm$core$Process$sleep(25)));
		var pageTransitionCmd = $author$project$LandingSite$Main$pageTransition(
			_Utils_Tuple2(
				$author$project$LandingSite$Page$getHrefUrl(model._),
				$author$project$LandingSite$Page$getHrefUrl(newPage)));
		var _v6 = (!_Utils_eq(abiResetModel._, newPage)) ? A2($author$project$LandingSite$Main$handlePageUpdates, newPage, abiResetModel) : _Utils_Tuple2(abiResetModel, $elm$core$Platform$Cmd$none);
		var newModel = _v6.a;
		var newCmd = _v6.b;
		return _Utils_Tuple2(
			_Utils_update(
				newModel,
				{_: newPage, aV: newPages}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						pageTransitionCmd,
						maybeScrollCmd,
						$author$project$LandingSite$Main$setTitleAndDescription(
						_Utils_Tuple2(
							A2($author$project$LandingSite$Page$title, model.aB, newPage),
							A2($author$project$LandingSite$Page$metaDescription, model.aB, newPage))),
						newCmd
					])));
	});
var $author$project$LandingSite$Main$transitionTo = F2(
	function (url, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2($author$project$LandingSite$Main$transitionPage, model, url);
		var newModel = _v1.a;
		var pageCmd = _v1.b;
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[pageCmd, cmd])));
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$LandingSite$Main$init = function (_v0) {
	var path = _v0.gl;
	var configAbiFiles = _v0.eX;
	var configurations = _v0.eZ;
	var apiBaseUrlMap = _v0.o;
	var language = _v0.fC;
	var protoDocJson = _v0.cj;
	var targetNetwork = _v0.gP;
	var decodedApiBaseUrlMap = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			apiBaseUrlMap));
	var configs = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		A2($elm$json$Json$Decode$decodeValue, $author$project$Eth$Config$basicConfigDecoder, configurations));
	var _v1 = $author$project$Preferences$preferencesInit(
		$author$project$Strings$Translations$getLnFromCode(language));
	var initPreferences = _v1.a;
	var _v2 = $author$project$Utils$Graph$init;
	var initGraphModel = _v2.a;
	return A2(
		$author$project$LandingSite$Main$transitionTo,
		$elm$url$Url$fromString(path),
		_Utils_Tuple2(
			{
				o: decodedApiBaseUrlMap,
				eY: configAbiFiles,
				dT: configs,
				t: $elm$core$Maybe$Nothing,
				ba: $elm$time$Time$utc,
				cO: $elm$core$Maybe$Nothing,
				h6: _List_Nil,
				bf: $author$project$Governance$AccountProfile$emptyState,
				bX: $author$project$Governance$Home$emptyState,
				bY: $author$project$Governance$Leaderboard$emptyState,
				bh: $author$project$Governance$ProposalDetail$emptyState,
				bZ: $author$project$Governance$ProposalOverview$emptyState,
				bi: initGraphModel,
				b6: $author$project$LandingSite$About$emptyState,
				av: $author$project$LandingSite$CTokens$emptyState,
				b7: $author$project$LandingSite$CommonViews$emptyState,
				bl: $author$project$LandingSite$Comp$emptyState,
				c$: $author$project$LandingSite$DevelopersMarketing$emptyState,
				bm: $author$project$LandingSite$Docs$emptyState,
				aw: $author$project$LandingSite$Home$emptyState,
				aj: $author$project$LandingSite$MarketDetail$emptyState,
				ak: $author$project$LandingSite$Markets$emptyState,
				al: $author$project$LandingSite$Prices$emptyState,
				ax: $elm$core$Maybe$Nothing,
				c6: false,
				bo: $author$project$Network$networkFromName(targetNetwork),
				_: $author$project$LandingSite$Page$Home,
				aV: _List_Nil,
				eq: initPreferences,
				cj: protoDocJson,
				aB: initPreferences.aB
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$LandingSite$Main$Tick, $elm$time$Time$now),
						A2($elm$core$Task$perform, $author$project$LandingSite$Main$SetTimeZone, $elm$time$Time$here)
					]))));
};
var $author$project$LandingSite$Main$UrlChange = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {jo: processes, jU: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.jo;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.jU);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$LandingSite$Main$LandingHomeMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$LandingSite$Home$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingHomeTranslator = $author$project$LandingSite$Home$translator(
	{ja: $author$project$LandingSite$Main$LandingHomeMsg});
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$LandingSite$Main$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
var $author$project$Utils$Time$seconds = 1;
var $author$project$LandingSite$Docs$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Docs$NetworkCarouselMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Bootstrap$Carousel$Hovered = 0;
var $author$project$Bootstrap$Carousel$Next = {$: 0};
var $author$project$Bootstrap$Carousel$SetAnimating = {$: 3};
var $author$project$Bootstrap$Carousel$StartTransition = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {f7: oldTime, jw: request, jO: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.jw;
		var oldTime = _v0.f7;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.jO;
		var oldTime = _v0.f7;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $author$project$Bootstrap$Carousel$subscriptions = F2(
	function (model, toMsg) {
		switch (model.a.$) {
			case 2:
				var _v1 = model.a;
				var interval = model.b.b2;
				var cycling = model.b.ai;
				var wrap = model.b.bE;
				var currentIndex = model.b.a9;
				var hovering = model.b.cY;
				var size = model.b.by;
				var atEnd = (!wrap) && _Utils_eq(currentIndex, size - 1);
				return ((cycling === 1) && ((!(!hovering)) && ((!(!interval)) && (!atEnd)))) ? A2(
					$elm$time$Time$every,
					interval,
					function (_v2) {
						return toMsg(
							$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Next));
					}) : $elm$core$Platform$Sub$none;
			case 0:
				var transition = model.a.a;
				return $elm$browser$Browser$Events$onAnimationFrame(
					function (_v3) {
						return toMsg($author$project$Bootstrap$Carousel$SetAnimating);
					});
			default:
				var transition = model.a.a;
				return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$LandingSite$Docs$subscriptions = function (model) {
	return A2(
		$author$project$Bootstrap$Carousel$subscriptions,
		model.aS,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Docs$NetworkCarouselMsg));
};
var $author$project$LandingSite$Home$CarouselMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$Home$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Home$ProjectsCarouselMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandingSite$Home$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Bootstrap$Carousel$subscriptions,
				model.bL,
				A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$CarouselMsg)),
				A2(
				$author$project$Bootstrap$Carousel$subscriptions,
				model.aY,
				A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$ProjectsCarouselMsg))
			]));
};
var $author$project$LandingSite$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, (1000.0 * 1.0) * $author$project$Utils$Time$seconds, $author$project$LandingSite$Main$Tick),
				$author$project$LandingSite$Main$onUrlChange(
				A2($elm$core$Basics$composeR, $elm$url$Url$fromString, $author$project$LandingSite$Main$UrlChange)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$LandingSite$Main$landingHomeTranslator,
				$author$project$LandingSite$Home$subscriptions(model.aw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$LandingSite$Main$landingDocsTranslator,
				$author$project$LandingSite$Docs$subscriptions(model.bm))
			]));
};
var $author$project$LandingSite$Main$LandingPricesMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$LandingSite$Main$WrappedPreferencesMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$MarketDetail$handleLatestTokensUpdate = F3(
	function (network, latestTokens, oldModel) {
		var maybeSelectedCToken = $author$project$Functions$demaybeify(
			A2(
				$elm$core$Maybe$map,
				function (underlyingSymbol) {
					return $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (cToken) {
								return _Utils_eq(cToken.j4, underlyingSymbol);
							},
							latestTokens.kG));
				},
				oldModel.cc));
		var _v0 = function () {
			var _v1 = oldModel.cc;
			if (!_v1.$) {
				var selectedUnderlyingSymbol = _v1.a;
				return A3($author$project$LandingSite$MarketDetailHelper$generateInterestRateModelPoints, network, selectedUnderlyingSymbol, maybeSelectedCToken);
			} else {
				return _Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil);
			}
		}();
		var utilizationReferenceData = _v0.a;
		var borrowRateData = _v0.b;
		var supplyRateData = _v0.c;
		var updatedBorrowRatesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var utilizationPercent = _v3.aC;
					var rate = _v3.jt;
					return _Utils_Tuple2(utilizationPercent, rate);
				},
				borrowRateData));
		var updatedSupplyRatesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v2) {
					var utilizationPercent = _v2.aC;
					var rate = _v2.jt;
					return _Utils_Tuple2(utilizationPercent, rate);
				},
				supplyRateData));
		return _Utils_update(
			oldModel,
			{cF: borrowRateData, cG: updatedBorrowRatesDict, eg: maybeSelectedCToken, dj: supplyRateData, dk: updatedSupplyRatesDict, dx: utilizationReferenceData});
	});
var $author$project$LandingSite$Main$LandingCommonMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$LandingSite$Main$LandingCommonParentMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$LandingSite$CommonViews$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var onParentMsg = _v0.jb;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var parentMsg = msg.a;
			return onParentMsg(parentMsg);
		}
	});
var $author$project$LandingSite$Main$landingCommonTranslator = $author$project$LandingSite$CommonViews$translator(
	{ja: $author$project$LandingSite$Main$LandingCommonMsg, jb: $author$project$LandingSite$Main$LandingCommonParentMsg});
var $author$project$LandingSite$Comp$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingCompTranslator = $author$project$LandingSite$Comp$translator(
	{ja: $author$project$LandingSite$Main$LandingCompMsg, jc: $author$project$LandingSite$Main$WrappedGraphMsg});
var $author$project$LandingSite$Main$LandingDevelopersMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$LandingSite$DevelopersMarketing$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingDevelopersTranslator = $author$project$LandingSite$DevelopersMarketing$translator(
	{ja: $author$project$LandingSite$Main$LandingDevelopersMsg});
var $author$project$LandingSite$Main$LandingMarketsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$LandingSite$Markets$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var onWrappedPreferencesMsg = _v0.jd;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var preferencesMsg = msg.a;
			return onWrappedPreferencesMsg(preferencesMsg);
		}
	});
var $author$project$LandingSite$Main$landingMarketsTranslator = $author$project$LandingSite$Markets$translator(
	{ja: $author$project$LandingSite$Main$LandingMarketsMsg, jd: $author$project$LandingSite$Main$WrappedPreferencesMsg});
var $author$project$LandingSite$Prices$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var onWrappedPreferencesMsg = _v0.jd;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingPricesTranslator = $author$project$LandingSite$Prices$translator(
	{ja: $author$project$LandingSite$Main$LandingPricesMsg, jd: $author$project$LandingSite$Main$WrappedPreferencesMsg});
var $author$project$LandingSite$Main$AllCTokensHistoricalStatsResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$LandingSite$Main$AllCTokensLatestStatsResponse = function (a) {
	return {$: 5, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl = F3(
	function (apiBaseUrlMap, network, requestOptions) {
		var queryMeta = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'meta',
				A2(
					$elm$json$Json$Encode$encode,
					0,
					$elm$json$Json$Encode$bool(requestOptions.iu)))
			]);
		var queryFinal = function () {
			var _v0 = requestOptions.kv;
			if (!_v0.$) {
				var timestamp = _v0.a;
				return _Utils_ap(
					queryMeta,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'block_timestamp',
							$elm$core$String$fromInt(timestamp))
						]));
			} else {
				return queryMeta;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/ctoken', queryFinal);
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest = F3(
	function (addresses, block_number, block_timestamp) {
		return {km: addresses, ku: block_number, kv: block_timestamp};
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse = F4(
	function (request, cToken, error, meta) {
		return {kG: cToken, h5: error, lU: meta, jw: request};
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$Metadata = F2(
	function (unique_borrowers, unique_suppliers) {
		return {nA: unique_borrowers, nB: unique_suppliers};
	});
var $author$project$CompoundApi$Presidio$CTokens$Decoders$apiErrorDecoder = $elm$json$Json$Decode$nullable(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$CompoundApi$Common$Models$API_Error,
		A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $author$project$CompoundApi$Presidio$CTokens$Models$CToken = function (borrow_rate) {
	return function (cash) {
		return function (collateral_factor) {
			return function (exchange_rate) {
				return function (interest_rate_model_address) {
					return function (name) {
						return function (number_of_borrowers) {
							return function (number_of_suppliers) {
								return function (reserves) {
									return function (reserve_factor) {
										return function (supply_rate) {
											return function (symbol) {
												return function (token_address) {
													return function (total_borrows) {
														return function (total_supply) {
															return function (underlying_address) {
																return function (underlying_name) {
																	return function (underlying_price) {
																		return function (underlying_symbol) {
																			return function (total_supply_value_in_eth) {
																				return function (total_borrow_value_in_eth) {
																					return {kA: borrow_rate, kH: cash, kN: collateral_factor, lg: exchange_rate, lE: interest_rate_model_address, i5: name, l3: number_of_borrowers, l4: number_of_suppliers, mx: reserve_factor, my: reserves, mZ: supply_rate, jS: symbol, jY: token_address, no: total_borrow_value_in_eth, np: total_borrows, nw: total_supply, nx: total_supply_value_in_eth, j1: underlying_address, j2: underlying_name, j3: underlying_price, j4: underlying_symbol};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$DecoderHelper$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow = function (_v0) {
	var total_borrows = _v0.np;
	var underlying_price = _v0.j3;
	return A2($author$project$Decimal$mul, underlying_price, total_borrows);
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply = function (_v0) {
	var total_supply = _v0.nw;
	var exchange_rate = _v0.lg;
	var underlying_price = _v0.j3;
	return A2(
		$author$project$Decimal$mul,
		underlying_price,
		A2($author$project$Decimal$mul, exchange_rate, total_supply));
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$renameDaiNameToSaiLegacyDecoder = function (apiToken) {
	var _v0 = (A2($author$project$Eth$Ethereum$areContractsEqual, apiToken.jY, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643') && A2(
		$author$project$Eth$Ethereum$areContractsEqual,
		A2($elm$core$Maybe$withDefault, '', apiToken.j1),
		'0x6B175474E89094C44Da98b954EedeAC495271d0F')) ? _Utils_Tuple2('Dai', apiToken.j4) : ((A2($author$project$Eth$Ethereum$areContractsEqual, apiToken.jY, '0xF5DCe57282A584D2746FaF1593d3121Fcac444dC') && A2(
		$author$project$Eth$Ethereum$areContractsEqual,
		A2($elm$core$Maybe$withDefault, '', apiToken.j1),
		'0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359')) ? _Utils_Tuple2('Sai (Legacy DAI)', 'SAI') : _Utils_Tuple2(apiToken.j2, apiToken.j4));
	var underlyingName = _v0.a;
	var underlyingSymbol = _v0.b;
	return $elm$json$Json$Decode$succeed(
		_Utils_update(
			apiToken,
			{j2: underlyingName, j4: underlyingSymbol}));
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$renameUsdtToTetherDecoder = function (apiToken) {
	var _v0 = ((apiToken.j4 === 'USDT') && (apiToken.j2 === 'USDT')) ? _Utils_Tuple2('Tether', apiToken.j4) : _Utils_Tuple2(apiToken.j2, apiToken.j4);
	var underlyingName = _v0.a;
	var underlyingSymbol = _v0.b;
	return $elm$json$Json$Decode$succeed(
		_Utils_update(
			apiToken,
			{j2: underlyingName, j4: underlyingSymbol}));
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder = function () {
	var addEthValues = function (apiToken) {
		var supplyValue = $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply(apiToken);
		var borrowValue = $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow(apiToken);
		return $elm$json$Json$Decode$succeed(
			_Utils_update(
				apiToken,
				{no: borrowValue, nx: supplyValue}));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$CompoundApi$Presidio$CTokens$Decoders$renameUsdtToTetherDecoder,
		A2(
			$elm$json$Json$Decode$andThen,
			$author$project$CompoundApi$Presidio$CTokens$Decoders$renameDaiNameToSaiLegacyDecoder,
			A2(
				$elm$json$Json$Decode$andThen,
				addEthValues,
				A2(
					$author$project$Utils$DecoderHelper$andMap,
					$elm$json$Json$Decode$succeed($author$project$Decimal$zero),
					A2(
						$author$project$Utils$DecoderHelper$andMap,
						$elm$json$Json$Decode$succeed($author$project$Decimal$zero),
						A2(
							$author$project$Utils$DecoderHelper$andMap,
							A2($elm$json$Json$Decode$field, 'underlying_symbol', $elm$json$Json$Decode$string),
							A2(
								$author$project$Utils$DecoderHelper$andMap,
								A2($elm$json$Json$Decode$field, 'underlying_price', $author$project$CompoundApi$Common$Decoders$apiPrecise),
								A2(
									$author$project$Utils$DecoderHelper$andMap,
									A2($elm$json$Json$Decode$field, 'underlying_name', $elm$json$Json$Decode$string),
									A2(
										$author$project$Utils$DecoderHelper$andMap,
										A2(
											$elm$json$Json$Decode$field,
											'underlying_address',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
										A2(
											$author$project$Utils$DecoderHelper$andMap,
											A2($elm$json$Json$Decode$field, 'total_supply', $author$project$CompoundApi$Common$Decoders$apiPrecise),
											A2(
												$author$project$Utils$DecoderHelper$andMap,
												A2($elm$json$Json$Decode$field, 'total_borrows', $author$project$CompoundApi$Common$Decoders$apiPrecise),
												A2(
													$author$project$Utils$DecoderHelper$andMap,
													A2($elm$json$Json$Decode$field, 'token_address', $elm$json$Json$Decode$string),
													A2(
														$author$project$Utils$DecoderHelper$andMap,
														A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
														A2(
															$author$project$Utils$DecoderHelper$andMap,
															A2($elm$json$Json$Decode$field, 'supply_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
															A2(
																$author$project$Utils$DecoderHelper$andMap,
																A2($elm$json$Json$Decode$field, 'reserve_factor', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																A2(
																	$author$project$Utils$DecoderHelper$andMap,
																	A2($elm$json$Json$Decode$field, 'reserves', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																	A2(
																		$author$project$Utils$DecoderHelper$andMap,
																		A2($elm$json$Json$Decode$field, 'number_of_suppliers', $elm$json$Json$Decode$int),
																		A2(
																			$author$project$Utils$DecoderHelper$andMap,
																			A2($elm$json$Json$Decode$field, 'number_of_borrowers', $elm$json$Json$Decode$int),
																			A2(
																				$author$project$Utils$DecoderHelper$andMap,
																				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
																				A2(
																					$author$project$Utils$DecoderHelper$andMap,
																					A2($elm$json$Json$Decode$field, 'interest_rate_model_address', $elm$json$Json$Decode$string),
																					A2(
																						$author$project$Utils$DecoderHelper$andMap,
																						A2($elm$json$Json$Decode$field, 'exchange_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																						A2(
																							$author$project$Utils$DecoderHelper$andMap,
																							A2($elm$json$Json$Decode$field, 'collateral_factor', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																							A2(
																								$author$project$Utils$DecoderHelper$andMap,
																								A2($elm$json$Json$Decode$field, 'cash', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																								A2(
																									$author$project$Utils$DecoderHelper$andMap,
																									A2($elm$json$Json$Decode$field, 'borrow_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																									$elm$json$Json$Decode$succeed($author$project$CompoundApi$Presidio$CTokens$Models$CToken)))))))))))))))))))))))));
}();
var $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'block_number',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'block_timestamp',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
	A2(
		$elm$json$Json$Decode$field,
		'cToken',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Presidio$CTokens$Decoders$apiErrorDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'meta',
		$elm$json$Json$Decode$nullable(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$CompoundApi$Presidio$CTokens$Models$Metadata,
				A2($elm$json$Json$Decode$field, 'unique_borrowers', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'unique_suppliers', $elm$json$Json$Decode$int)))));
var $elm$core$Basics$round = _Basics_round;
var $author$project$LandingSite$Main$loadMarkets = F3(
	function (currentTime, apiBaseUrlMap, network) {
		var maybeCTokenLatestUrl = A3(
			$author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl,
			apiBaseUrlMap,
			network,
			{kv: $elm$core$Maybe$Nothing, iu: true});
		var historyTime = A2(
			$elm$core$Maybe$andThen,
			function (timeToDie) {
				return $elm$core$Maybe$Just(
					$elm$core$Basics$round(
						function (millis) {
							return millis / 1000;
						}(
							(-86400000) + $elm$time$Time$posixToMillis(timeToDie))));
			},
			currentTime);
		var maybeCTokenHistoricalUrl = A3(
			$author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl,
			apiBaseUrlMap,
			network,
			{kv: historyTime, iu: true});
		var cTokensRequestCmds = function () {
			var _v0 = _Utils_Tuple2(maybeCTokenHistoricalUrl, maybeCTokenLatestUrl);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var cTokenHistoricalUrl = _v0.a.a;
				var cTokenLatestUrl = _v0.b.a;
				var cTokenLatestRequest = A2($elm$http$Http$get, cTokenLatestUrl, $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				var cTokenHistoricRequest = A2($elm$http$Http$get, cTokenHistoricalUrl, $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$LandingSite$Main$AllCTokensLatestStatsResponse, cTokenLatestRequest),
						A2($elm$http$Http$send, $author$project$LandingSite$Main$AllCTokensHistoricalStatsResponse, cTokenHistoricRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return $elm$core$Platform$Cmd$batch(cTokensRequestCmds);
	});
var $author$project$LandingSite$Prices$HistoricalPricesResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$Prices$LatestPricesResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$Prices$Loading = {$: 1};
var $author$project$CompoundApi$Prices$Urls$pricesRequestUrl = F3(
	function (apiBaseUrlMap, network, requestOptions) {
		var queryFinal = function () {
			var _v0 = requestOptions.kv;
			if (!_v0.$) {
				var timestamp = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'block_timestamp',
						$elm$core$String$fromInt(timestamp))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/prices', queryFinal);
	});
var $author$project$CompoundApi$Prices$Models$PricesRequest = F3(
	function (addresses, block_number, block_timestamp) {
		return {km: addresses, ku: block_number, kv: block_timestamp};
	});
var $author$project$CompoundApi$Prices$Models$PricesResponse = F3(
	function (request, tokens, error) {
		return {h5: error, jw: request, nk: tokens};
	});
var $author$project$CompoundApi$Prices$Models$Token = F6(
	function (address, name, symbol, price, price_block_number, price_timestamp) {
		return {hd: address, i5: name, mk: price, ml: price_block_number, mm: price_timestamp, jS: symbol};
	});
var $author$project$CompoundApi$Prices$Decoders$tokenDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$CompoundApi$Prices$Models$Token,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $author$project$Eth$Decoders$stringDecimal),
	A2(
		$elm$json$Json$Decode$field,
		'price_block_number',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'price_timestamp',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)));
var $author$project$CompoundApi$Prices$Decoders$pricesResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$CompoundApi$Prices$Models$PricesResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$CompoundApi$Prices$Models$PricesRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'block_number',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'block_timestamp',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
	A2(
		$elm$json$Json$Decode$field,
		'tokens',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Prices$Decoders$tokenDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Utils$Time$subtractMilliFromPosixAsSeconds = F2(
	function (startTime, subtractAmountMilli) {
		var timeMs = $elm$time$Time$posixToMillis(startTime);
		var newTimeMs = timeMs - subtractAmountMilli;
		return $elm$core$Basics$round(
			function (millis) {
				return millis / 1000;
			}(newTimeMs));
	});
var $author$project$LandingSite$Prices$loadPrices = F4(
	function (currentTime, apiBaseUrlMap, network, model) {
		var maybePricesUrl = A3(
			$author$project$CompoundApi$Prices$Urls$pricesRequestUrl,
			apiBaseUrlMap,
			network,
			{kv: $elm$core$Maybe$Nothing});
		var historyTime = A2(
			$elm$core$Maybe$andThen,
			function (time) {
				return $elm$core$Maybe$Just(
					A2($author$project$Utils$Time$subtractMilliFromPosixAsSeconds, time, 86400000));
			},
			currentTime);
		var maybeHistoricPricesUrl = A3(
			$author$project$CompoundApi$Prices$Urls$pricesRequestUrl,
			apiBaseUrlMap,
			network,
			{kv: historyTime});
		var pricesRequestCmds = function () {
			var _v0 = _Utils_Tuple2(maybeHistoricPricesUrl, maybePricesUrl);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var historicalPricesUrl = _v0.a.a;
				var pricesUrl = _v0.b.a;
				var pricesRequest = A2($elm$http$Http$get, pricesUrl, $author$project$CompoundApi$Prices$Decoders$pricesResponseDecoder);
				var historicPricesRequest = A2($elm$http$Http$get, historicalPricesUrl, $author$project$CompoundApi$Prices$Decoders$pricesResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$LandingSite$Prices$LatestPricesResponse, pricesRequest),
						A2($elm$http$Http$send, $author$project$LandingSite$Prices$HistoricalPricesResponse, historicPricesRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cX: $author$project$LandingSite$Prices$Loading, lJ: $author$project$LandingSite$Prices$Loading}),
			$elm$core$Platform$Cmd$batch(pricesRequestCmds));
	});
var $author$project$LandingSite$Main$scrollIntoView = _Platform_outgoingPort('scrollIntoView', $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$LandingSite$Main$scrollTop = _Platform_outgoingPort(
	'scrollTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$LandingSite$Main$maybeScroll = function (page) {
	_v0$2:
	while (true) {
		switch (page.$) {
			case 1:
				if (!page.a.$) {
					var fragment = page.a.a;
					return $author$project$LandingSite$Main$scrollIntoView(fragment);
				} else {
					break _v0$2;
				}
			case 5:
				if (!page.b.$) {
					var fragment = page.b.a;
					return $author$project$LandingSite$Main$scrollIntoView(fragment);
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$LandingSite$Main$scrollTop(0);
};
var $author$project$Preferences$askClearPreferencesPort = _Platform_outgoingPort(
	'askClearPreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(_List_Nil);
	});
var $author$project$Preferences$askClearPreferences = $author$project$Preferences$askClearPreferencesPort(
	{});
var $author$project$Preferences$displayCurrencyToString = function (displayCurrency) {
	switch (displayCurrency) {
		case 0:
			return 'Ether';
		case 1:
			return 'USD';
		case 2:
			return 'GBP';
		default:
			return 'EUR';
	}
};
var $author$project$Preferences$savedLanguageToString = function (userLanguage) {
	switch (userLanguage) {
		case 0:
			return 'en';
		case 1:
			return 'es';
		case 2:
			return 'zh';
		case 3:
			return 'fr';
		default:
			return 'ko';
	}
};
var $author$project$Preferences$storePreferencesPort = _Platform_outgoingPort(
	'storePreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'borrowPaneOpen',
					$elm$json$Json$Encode$bool($.bJ)),
					_Utils_Tuple2(
					'displayCurrency',
					$elm$json$Json$Encode$string($.k4)),
					_Utils_Tuple2(
					'supplyPaneOpen',
					$elm$json$Json$Encode$bool($.cr)),
					_Utils_Tuple2(
					'userLanguage',
					$elm$json$Json$Encode$string($.aB))
				]));
	});
var $author$project$Preferences$storePreferences = function (_v0) {
	var displayCurrency = _v0.k4;
	var userLanguage = _v0.aB;
	var supplyPaneOpen = _v0.cr;
	var borrowPaneOpen = _v0.bJ;
	return $author$project$Preferences$storePreferencesPort(
		{
			bJ: borrowPaneOpen,
			k4: $author$project$Preferences$displayCurrencyToString(displayCurrency),
			cr: supplyPaneOpen,
			aB: $author$project$Preferences$savedLanguageToString(userLanguage)
		});
};
var $author$project$Preferences$preferencesUpdate = F2(
	function (msg, state) {
		switch (msg.$) {
			case 0:
				var displayCurrency = msg.a;
				var updatedState = _Utils_update(
					state,
					{k4: displayCurrency});
				return _Utils_Tuple2(
					updatedState,
					$author$project$Preferences$storePreferences(updatedState));
			case 1:
				var userLanguage = msg.a;
				var updatedState = _Utils_update(
					state,
					{aB: userLanguage});
				return _Utils_Tuple2(
					updatedState,
					$author$project$Preferences$storePreferences(updatedState));
			case 2:
				var isOpen = msg.a;
				var updatedState = _Utils_update(
					state,
					{cr: isOpen});
				return _Utils_Tuple2(
					updatedState,
					$author$project$Preferences$storePreferences(updatedState));
			case 3:
				var isOpen = msg.a;
				var updatedState = _Utils_update(
					state,
					{bJ: isOpen});
				return _Utils_Tuple2(
					updatedState,
					$author$project$Preferences$storePreferences(updatedState));
			case 4:
				var preferences = msg.a;
				return _Utils_Tuple2(preferences, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, $author$project$Preferences$askClearPreferences);
		}
	});
var $author$project$Utils$Http$showError = function (err) {
	switch (err.$) {
		case 0:
			var url = err.a;
			return 'BadUrl: ' + url;
		case 1:
			return 'Timeout';
		case 2:
			return 'NetworkError';
		case 3:
			var resp = err.a;
			return 'BadStatus ' + resp.K.lT;
		default:
			var info = err.a;
			var resp = err.b;
			return 'BadPayload: ' + (info + ('; ' + resp.K.lT));
	}
};
var $author$project$LandingSite$Page$titleForProfile = F3(
	function (userLanguage, page, compAccount) {
		if (page.$ === 9) {
			var accountAddress = page.a;
			if (_Utils_eq(
				$elm$core$String$toLower(accountAddress),
				$elm$core$String$toLower(compAccount.hd))) {
				var friendlyDisplayName = A2($elm$core$Maybe$withDefault, compAccount.hd, compAccount.h_);
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2($author$project$Strings$Translations$site_title_profile, userLanguage, friendlyDisplayName)));
			} else {
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2($author$project$Strings$Translations$site_title_profile, userLanguage, accountAddress)));
			}
		} else {
			return A2($author$project$LandingSite$Page$title, userLanguage, page);
		}
	});
var $author$project$Governance$AccountProfile$AccountFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$AccountProfile$NoAccountFound = {$: 1};
var $author$project$Utils$Copy$copy = _Platform_outgoingPort('copy', $elm$json$Json$Encode$string);
var $author$project$LandingSite$Port$handleImageError = _Platform_outgoingPort(
	'handleImageError',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elementId',
					$elm$json$Json$Encode$string($.h2)),
					_Utils_Tuple2(
					'imgSrc',
					$elm$json$Json$Encode$string($.it))
				]));
	});
var $author$project$LandingSite$Port$imageError = F2(
	function (elementId, imgSrc) {
		var data = {h2: elementId, it: imgSrc};
		return $author$project$LandingSite$Port$handleImageError(data);
	});
var $author$project$Governance$AccountProfile$update = F4(
	function (apiBaseUrlMap, network, internalMsg, model) {
		var currentVoteReceiptPageNumber = model.bO;
		var voteReceiptsPageMap = model.dA;
		switch (internalMsg.$) {
			case 2:
				var result = internalMsg.a;
				if (!result.$) {
					var compDistributionResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ee: $elm$core$Maybe$Just(compDistributionResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov COMP Distribution API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var accountResponse = result.a;
					var targetCompAccount = $elm$core$List$head(accountResponse.ha);
					var nextCompAccountState = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Governance$AccountProfile$NoAccountFound,
						A2($elm$core$Maybe$map, $author$project$Governance$AccountProfile$AccountFound, targetCompAccount));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aK: nextCompAccountState}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov Account Profile API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 3:
				var result = internalMsg.a;
				if (!result.$) {
					var presidioResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ef: $elm$core$Maybe$Just(presidioResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Presdio Account API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var receiptReceiptsResponse = result.a;
					var voteReceiptsMapUpdate = A3($elm$core$Dict$insert, receiptReceiptsResponse.jf.mg, receiptReceiptsResponse.mp, voteReceiptsPageMap);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fY: $elm$core$Maybe$Just(receiptReceiptsResponse.mp),
								eh: $elm$core$Maybe$Just(receiptReceiptsResponse.jf.nu),
								dA: voteReceiptsMapUpdate
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from For Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bO: currentVoteReceiptPageNumber - 1}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var loadNextPageCmd = function () {
					var _v5 = _Utils_Tuple2(
						model.aK,
						A2($elm$core$Dict$get, currentVoteReceiptPageNumber + 1, voteReceiptsPageMap));
					if ((!_v5.a.$) && (_v5.b.$ === 1)) {
						var compAccount = _v5.a.a;
						var _v6 = _v5.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (requestVoteReceiptsUrl) {
									return A2(
										$elm$http$Http$send,
										$author$project$Governance$AccountProfile$RecentVoteReceiptsResponse,
										A2($elm$http$Http$get, requestVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder));
								},
								A3(
									$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
									apiBaseUrlMap,
									network,
									{
										kh: $elm$core$Maybe$Just(compAccount.hd),
										mg: currentVoteReceiptPageNumber + 1,
										mh: $author$project$Governance$AccountProfile$desiredPageSize,
										gq: $elm$core$Maybe$Nothing,
										gO: $elm$core$Maybe$Nothing,
										nP: true
									})));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bO: currentVoteReceiptPageNumber + 1}),
					loadNextPageCmd);
			case 6:
				var copyText = internalMsg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$Copy$copy(copyText));
			case 7:
				var elementId = internalMsg.a;
				var imgSrc = internalMsg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$LandingSite$Port$imageError, elementId, imgSrc));
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$Home$Found = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Home$NotFound = {$: 1};
var $author$project$Governance$Home$update = F2(
	function (internalMsg, model) {
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var governanceHistory = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bW: $author$project$Governance$Home$Found(governanceHistory)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bW: $author$project$Governance$Home$NotFound}),
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var latestProposalsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c0: $author$project$Governance$Home$Found(latestProposalsResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c0: $author$project$Governance$Home$NotFound}),
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				var result = internalMsg.a;
				if (!result.$) {
					var topDelegatesResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ds: $author$project$Governance$Home$Found(topDelegatesResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ds: $author$project$Governance$Home$NotFound}),
						$author$project$Console$error(
							'Error from Comp Accounts API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 3:
				var elementId = internalMsg.a;
				var imgSrc = internalMsg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$LandingSite$Port$imageError, elementId, imgSrc));
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$Leaderboard$AccountsFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Leaderboard$NoAccountsFound = {$: 1};
var $author$project$Governance$Leaderboard$update = F2(
	function (internalMsg, model) {
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var topDelegatesResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dr: $author$project$Governance$Leaderboard$AccountsFound(topDelegatesResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dr: $author$project$Governance$Leaderboard$NoAccountsFound}),
						$author$project$Console$error(
							'Error from Comp Accounts API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var elementId = internalMsg.a;
				var imgSrc = internalMsg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$LandingSite$Port$imageError, elementId, imgSrc));
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$ProposalDetail$Found = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalDetail$NotFound = {$: 1};
var $author$project$Governance$ProposalDetail$ProposerGovAccountResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$ProposalDetail$update = F4(
	function (apiBaseUrlMap, network, internalMsg, model) {
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var proposalsResponse = result.a;
					var _v2 = $elm$core$List$head(proposalsResponse.jq);
					if (!_v2.$) {
						var firstProposalDetail = _v2.a;
						var maybeRequestProposerAccountCmd = A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (requestGovAccountUrl) {
									return A2(
										$elm$http$Http$send,
										$author$project$Governance$ProposalDetail$ProposerGovAccountResponse,
										A2($elm$http$Http$get, requestGovAccountUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder));
								},
								A3(
									$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
									apiBaseUrlMap,
									network,
									{
										km: _List_fromArray(
											[firstProposalDetail.ms.hd]),
										mb: $elm$core$Maybe$Nothing,
										mg: 1,
										mh: 1,
										nO: false
									})));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aa: $author$project$Governance$ProposalDetail$Found(firstProposalDetail)
								}),
							maybeRequestProposerAccountCmd);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aa: $author$project$Governance$ProposalDetail$NotFound}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aa: $author$project$Governance$ProposalDetail$NotFound}),
						$author$project$Console$error(
							'Error from Gov Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var accountResponse = result.a;
					var targetCompAccount = $elm$core$List$head(accountResponse.ha);
					var nextCompAccountState = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Governance$ProposalDetail$NotFound,
						A2($elm$core$Maybe$map, $author$project$Governance$ProposalDetail$Found, targetCompAccount));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{es: nextCompAccountState}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov Account Profile API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				var result = internalMsg.a;
				if (!result.$) {
					var forVoteReceiptsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bT: $author$project$Governance$ProposalDetail$Found(
									{cx: forVoteReceiptsResponse.jf.nu, a5: forVoteReceiptsResponse.mp})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bT: $author$project$Governance$ProposalDetail$NotFound}),
						$author$project$Console$error(
							'Error from For Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 3:
				var result = internalMsg.a;
				if (!result.$) {
					var againstVoteReceiptsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bH: $author$project$Governance$ProposalDetail$Found(
									{cx: againstVoteReceiptsResponse.jf.nu, a5: againstVoteReceiptsResponse.mp})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bH: $author$project$Governance$ProposalDetail$NotFound}),
						$author$project$Console$error(
							'Error from Against Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 4:
				var showForVotes = internalMsg.a;
				var votesModalContent = function () {
					var _v6 = _Utils_Tuple3(model.aa, model.bT, model.bH);
					if (((!_v6.a.$) && (!_v6.b.$)) && (!_v6.c.$)) {
						var proposalDetail = _v6.a.a;
						var forVotes = _v6.b.a;
						var againstVotes = _v6.c.a;
						return $elm$core$Maybe$Just(
							{
								gp: proposalDetail,
								gE: showForVotes,
								g4: showForVotes ? forVotes : againstVotes
							});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dh: votesModalContent}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dh: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var elementId = internalMsg.a;
				var imgSrc = internalMsg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$LandingSite$Port$imageError, elementId, imgSrc));
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$ProposalOverview$Found = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalOverview$NotFound = {$: 1};
var $author$project$Governance$ProposalOverview$update = F4(
	function (apiBaseUrlMap, network, internalMsg, model) {
		var currentPageNumber = model.bN;
		var proposalsPageMap = model.ci;
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var allProposalsResponse = result.a;
					var proposalMapUpdate = A3($elm$core$Dict$insert, allProposalsResponse.jf.mg, allProposalsResponse.jq, proposalsPageMap);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ci: proposalMapUpdate,
								cw: $author$project$Governance$ProposalOverview$Found(allProposalsResponse.jf.nu)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cw: $author$project$Governance$ProposalOverview$NotFound}),
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: currentPageNumber - 1}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var loadNextPageCmd = _Utils_eq(
					A2($elm$core$Dict$get, currentPageNumber + 1, proposalsPageMap),
					$elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (requestProposalsUrl) {
							return A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalOverview$AllProposalsResponse,
								A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder));
						},
						A3(
							$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
							apiBaseUrlMap,
							network,
							{
								mg: currentPageNumber + 1,
								mh: $author$project$Governance$ProposalOverview$desiredPageSize,
								mo: _List_Nil,
								jL: $elm$core$Maybe$Nothing,
								nN: $elm$core$Maybe$Just(false)
							}))) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: currentPageNumber + 1}),
					loadNextPageCmd);
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$LandingSite$About$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var error = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						h6: A2($elm$core$List$cons, error, model.h6)
					}),
				$author$project$Console$error(error));
		} else {
			var result = msg.a;
			if (!result.$) {
				var jobsResponse = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d6: $elm$core$Maybe$Just(jobsResponse)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var errMsg = result.a;
				return _Utils_Tuple2(
					model,
					$author$project$Console$error(
						'Error from hire.withgoogle.com , ' + $author$project$Utils$Http$showError(errMsg)));
			}
		}
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$LandingSite$CTokens$update = F5(
	function (apiBaseUrlMap, network, maybeCurrentTime, msg, model) {
		switch (msg.$) {
			case 0:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
			case 1:
				var points = msg.a;
				var maybeXPoint = $elm$core$List$isEmpty(points) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.kv;
					},
					$elm$core$List$head(points));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b_: maybeXPoint}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var dropdownState = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cP: dropdownState}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var index = msg.a;
				var oldStateAtIndex = A2($elm$core$Array$get, index, model.bd);
				var newFaqAccordianState = function () {
					if (!oldStateAtIndex.$) {
						var oldState = oldStateAtIndex.a;
						return A3($elm$core$Array$set, index, !oldState, model.bd);
					} else {
						return model.bd;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: newFaqAccordianState}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dB: index}),
					$elm$core$Platform$Cmd$none);
			default:
				var token = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cm: $elm$core$Maybe$Just(token)
						}),
					A4(
						$author$project$LandingSite$CTokens$loadGraphCmd,
						apiBaseUrlMap,
						network,
						maybeCurrentTime,
						$elm$core$Maybe$Just(token)));
		}
	});
var $author$project$LandingSite$CommonViews$update = F2(
	function (msg, model) {
		var dropdownState = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bp: dropdownState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$LandingSite$Comp$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var oldStateAtIndex = A2($elm$core$Array$get, index, model.bd);
				var newFaqAccordianState = function () {
					if (!oldStateAtIndex.$) {
						var oldState = oldStateAtIndex.a;
						return A3($elm$core$Array$set, index, !oldState, model.bd);
					} else {
						return model.bd;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: newFaqAccordianState}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var copyText = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$Copy$copy(copyText));
			default:
				var result = msg.a;
				if (!result.$) {
					var compDistributionResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ee: $elm$core$Maybe$Just(compDistributionResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov Account Profile API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
		}
	});
var $author$project$LandingSite$DevelopersMarketing$update = F2(
	function (msg, model) {
		var error = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					h6: A2($elm$core$List$cons, error, model.h6)
				}),
			$author$project$Console$error(error));
	});
var $author$project$Bootstrap$Carousel$Number = function (a) {
	return {$: 2, a: a};
};
var $author$project$Bootstrap$Carousel$Animating = function (a) {
	return {$: 1, a: a};
};
var $author$project$Bootstrap$Carousel$Start = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Bootstrap$Carousel$nextIndex = F3(
	function (stage, currentIndex, size) {
		var helper = function (transition) {
			switch (transition.$) {
				case 0:
					return A2($elm$core$Basics$modBy, size, currentIndex + 1);
				case 1:
					return A2($elm$core$Basics$modBy, size, currentIndex - 1);
				default:
					var m = transition.a;
					return A2($elm$core$Basics$modBy, size, m);
			}
		};
		switch (stage.$) {
			case 0:
				var transition = stage.a;
				return helper(transition);
			case 1:
				var transition = stage.a;
				return helper(transition);
			default:
				return currentIndex;
		}
	});
var $author$project$Bootstrap$Carousel$update = F2(
	function (message, model) {
		var tstage = model.a;
		var settings = model.b;
		var currentIndex = settings.a9;
		var size = settings.by;
		switch (message.$) {
			case 1:
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{ai: 0}));
			case 0:
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{ai: 1}));
			case 5:
				var hovering = message.a;
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{cY: hovering}));
			case 2:
				var transition = message.a;
				var newSettings = function () {
					var _v2 = settings.ai;
					if (_v2 === 2) {
						return _Utils_update(
							settings,
							{ai: 1});
					} else {
						return settings;
					}
				}();
				if (tstage.$ === 2) {
					return (!_Utils_eq(
						A3(
							$author$project$Bootstrap$Carousel$nextIndex,
							$author$project$Bootstrap$Carousel$Start(transition),
							currentIndex,
							size),
						currentIndex)) ? A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$Start(transition),
						newSettings) : A2($author$project$Bootstrap$Carousel$State, tstage, newSettings);
				} else {
					return A2($author$project$Bootstrap$Carousel$State, tstage, newSettings);
				}
			case 3:
				switch (tstage.$) {
					case 2:
						return model;
					case 0:
						var transition = tstage.a;
						return A2(
							$author$project$Bootstrap$Carousel$State,
							$author$project$Bootstrap$Carousel$Animating(transition),
							settings);
					default:
						var transition = tstage.a;
						return A2(
							$author$project$Bootstrap$Carousel$State,
							$author$project$Bootstrap$Carousel$Animating(transition),
							settings);
				}
			default:
				var size_ = message.a;
				if (tstage.$ === 2) {
					return A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$NotAnimating,
						_Utils_update(
							settings,
							{by: size_}));
				} else {
					return A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$NotAnimating,
						_Utils_update(
							settings,
							{
								a9: A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size),
								by: size
							}));
				}
		}
	});
var $author$project$LandingSite$Docs$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var network = msg.a;
				var index = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aS: A2(
								$author$project$Bootstrap$Carousel$update,
								$author$project$Bootstrap$Carousel$StartTransition(
									$author$project$Bootstrap$Carousel$Number(index)),
								model.aS),
							ev: network
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aS: A2($author$project$Bootstrap$Carousel$update, subMsg, model.aS)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var copyText = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$Copy$copy(copyText));
			default:
				var status = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c7: status}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$LandingSite$Home$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
			case 1:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bL: A2($author$project$Bootstrap$Carousel$update, subMsg, model.bL)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2($author$project$Bootstrap$Carousel$update, subMsg, model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var projectCategory = msg.a;
				var index = function () {
					switch (projectCategory) {
						case 2:
							return 0;
						case 0:
							return 1;
						default:
							return 2;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2(
								$author$project$Bootstrap$Carousel$update,
								$author$project$Bootstrap$Carousel$StartTransition(
									$author$project$Bootstrap$Carousel$Number(index)),
								model.aY),
							ew: projectCategory
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$LandingSite$MarketDetail$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var hoverBarTime = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bb: $elm$core$Maybe$Just(hoverBarTime)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var hoverBarTime = msg.a;
				var updatedDoubleGraphHoverTime = A2(
					$elm$core$Maybe$andThen,
					function (existingHoverBarTime) {
						return _Utils_eq(hoverBarTime, existingHoverBarTime) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(existingHoverBarTime);
					},
					model.bb);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bb: updatedDoubleGraphHoverTime}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var maybeRateModelPoint = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aP: maybeRateModelPoint}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var maybeRateModelPoint = msg.a;
				return (!_Utils_eq(model.aP, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{aP: maybeRateModelPoint}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 5:
				var maybeRateModelPoint = msg.a;
				var updatedDefaultPoint = function () {
					var _v1 = _Utils_Tuple2(maybeRateModelPoint, model.aP);
					if (!_v1.a.$) {
						var rateModelPoint = _v1.a.a;
						return $elm$core$Maybe$Just(rateModelPoint.aC);
					} else {
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							var dragPoint = _v1.b.a;
							return $elm$core$Maybe$Just(dragPoint.aC);
						} else {
							return model.b1;
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aP: $elm$core$Maybe$Nothing, b1: updatedDefaultPoint}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var newTab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bG: newTab}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var activeTab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ex: $elm$core$Maybe$Just(activeTab)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ex: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (!result.$) {
					var compDistributionResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ee: $elm$core$Maybe$Just(compDistributionResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Comp Distribution API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
		}
	});
var $author$project$LandingSite$Markets$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ax: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lu: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$LandingSite$Prices$Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$Prices$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var pricesResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								lJ: $author$project$LandingSite$Prices$Loaded(pricesResponse.nk)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Prices API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var pricesResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cX: $author$project$LandingSite$Prices$Loaded(pricesResponse.nk)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Prices API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				var index = msg.a;
				var oldStateAtIndex = A2($elm$core$Array$get, index, model.bd);
				var newFaqAccordianState = function () {
					if (!oldStateAtIndex.$) {
						var oldState = oldStateAtIndex.a;
						return A3($elm$core$Array$set, index, !oldState, model.bd);
					} else {
						return model.bd;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: newFaqAccordianState}),
					$elm$core$Platform$Cmd$none);
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							h6: A2($elm$core$List$cons, error, model.h6)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Console$errorExt = F2(
	function (info, err) {
		return $author$project$Console$log('Error ' + (info + (': ' + err)));
	});
var $author$project$Utils$Graph$update = F3(
	function (maybeTime, msg, model) {
		var result = msg;
		if (!result.$) {
			var assetAddress = result.a.kp;
			var supplyRateData = result.a.jQ;
			var exchangeRateData = result.a.h8;
			var borrowRateData = result.a.hr;
			var totalSupplyData = result.a.j_;
			var totalBorrowsData = result.a.jZ;
			var pricesUsdData = result.a.jl;
			var updatedTotalSupplyData = A3(
				$elm$core$List$foldl,
				function (api_total) {
					return A2($elm$core$Dict$insert, api_total.kv, api_total.gT);
				},
				$elm$core$Dict$empty,
				totalSupplyData);
			var updatedTotalBorrowsData = A3(
				$elm$core$List$foldl,
				function (api_total) {
					return A2($elm$core$Dict$insert, api_total.kv, api_total.gT);
				},
				$elm$core$Dict$empty,
				totalBorrowsData);
			var updatedSupplyRateData = A3(
				$elm$core$List$foldl,
				function (api_rate) {
					return A2($elm$core$Dict$insert, api_rate.kv, api_rate.jt);
				},
				$elm$core$Dict$empty,
				supplyRateData);
			var updatedPricesData = A3(
				$elm$core$List$foldl,
				function (price) {
					return A2($elm$core$Dict$insert, price.kv, price.mk);
				},
				$elm$core$Dict$empty,
				pricesUsdData);
			var updatedExchangeRateData = A3(
				$elm$core$List$foldl,
				function (api_rate) {
					return A2($elm$core$Dict$insert, api_rate.kv, api_rate.jt);
				},
				$elm$core$Dict$empty,
				exchangeRateData);
			var updatedBorrowRateData = A3(
				$elm$core$List$foldl,
				function (api_rate) {
					return A2($elm$core$Dict$insert, api_rate.kv, api_rate.jt);
				},
				$elm$core$Dict$empty,
				borrowRateData);
			var newTotalSupplyMap = A3($elm$core$Dict$insert, assetAddress, updatedTotalSupplyData, model.nn);
			var newTotalBorrowsMap = A3($elm$core$Dict$insert, assetAddress, updatedTotalBorrowsData, model.nm);
			var newSupplyRateMap = A3($elm$core$Dict$insert, assetAddress, updatedSupplyRateData, model.mX);
			var newPricesMap = A3($elm$core$Dict$insert, assetAddress, updatedPricesData, model.jm);
			var newExchangeRateMap = A3($elm$core$Dict$insert, assetAddress, updatedExchangeRateData, model.lf);
			var newBorrowRateMap = A3($elm$core$Dict$insert, assetAddress, updatedBorrowRateData, model.ky);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ky: newBorrowRateMap, lf: newExchangeRateMap, fD: maybeTime, jm: newPricesMap, mX: newSupplyRateMap, nm: newTotalBorrowsMap, nn: newTotalSupplyMap}),
				$elm$core$Platform$Cmd$none);
		} else {
			var errorMsg = result.a;
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$Console$errorExt,
					'Graph Error getting graph data from Market Data API',
					$author$project$Utils$Http$showError(errorMsg)));
		}
	});
var $author$project$LandingSite$Main$update = F2(
	function (msg, model) {
		var page = model._;
		var apiBaseUrlMap = model.o;
		var graphModel = model.bi;
		var landingCTokensModel = model.av;
		var network = model.bo;
		switch (msg.$) {
			case 0:
				var location = msg.a;
				return A2($author$project$LandingSite$Main$transitionPage, model, location);
			case 1:
				var time = msg.a;
				var loadMarketsCmd = _Utils_eq(model.t, $elm$core$Maybe$Nothing) ? A3(
					$author$project$LandingSite$Main$loadMarkets,
					$elm$core$Maybe$Just(time),
					apiBaseUrlMap,
					network) : $elm$core$Platform$Cmd$none;
				var loadGraphCmd = function () {
					if (_Utils_eq(model.t, $elm$core$Maybe$Nothing)) {
						switch (page.$) {
							case 3:
								var selectedCToken = landingCTokensModel.cm;
								return A2(
									$elm$core$Platform$Cmd$map,
									$author$project$LandingSite$Main$landingCTokensTranslator,
									A4(
										$author$project$LandingSite$CTokens$loadGraphCmd,
										apiBaseUrlMap,
										network,
										$elm$core$Maybe$Just(time),
										selectedCToken));
							case 8:
								var underlyingSymbol = page.a;
								var maybeConfig = $author$project$LandingSite$Main$getConfig(model);
								var _v5 = A7(
									$author$project$LandingSite$MarketDetail$loadMarketDetails,
									apiBaseUrlMap,
									network,
									$elm$core$Maybe$Just(time),
									maybeConfig,
									model.ax,
									underlyingSymbol,
									model.aj);
								var landingMarketDetailCmd = _v5.b;
								return A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingMarketDetailTranslator, landingMarketDetailCmd);
							default:
								return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v1 = function () {
					if (_Utils_eq(model.t, $elm$core$Maybe$Nothing) || _Utils_eq(model.al.lJ, $author$project$LandingSite$Prices$NoPrices)) {
						if (page.$ === 14) {
							var _v3 = A4(
								$author$project$LandingSite$Prices$loadPrices,
								$elm$core$Maybe$Just(time),
								model.o,
								model.bo,
								model.al);
							var pricesModel_ = _v3.a;
							var pricesCmd = _v3.b;
							return _Utils_Tuple2(
								pricesModel_,
								A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$LandingPricesMsg, pricesCmd));
						} else {
							return _Utils_Tuple2(model.al, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model.al, $elm$core$Platform$Cmd$none);
					}
				}();
				var pricesModel = _v1.a;
				var loadPricesCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							t: $elm$core$Maybe$Just(time),
							al: pricesModel
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[loadMarketsCmd, loadGraphCmd, loadPricesCmd])));
			case 2:
				var timeZone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ba: timeZone}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var preferencesMsg = msg.a;
				var _v6 = A2($author$project$Preferences$preferencesUpdate, preferencesMsg, model.eq);
				var updatedPreferences = _v6.a;
				var preferencesCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eq: updatedPreferences}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$WrappedPreferencesMsg, preferencesCmd));
			case 4:
				var graphMsg = msg.a;
				var _v7 = A3($author$project$Utils$Graph$update, model.t, graphMsg, graphModel);
				var updatedGraphModel = _v7.a;
				var graphCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: updatedGraphModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$WrappedGraphMsg, graphCmd));
			case 5:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					var updatedMarketDetailModel = A3($author$project$LandingSite$MarketDetail$handleLatestTokensUpdate, network, cTokenResponse, model.aj);
					var oldMarketsModel = model.ak;
					var updatedMarketsModel = _Utils_update(
						oldMarketsModel,
						{
							ax: $elm$core$Maybe$Just(cTokenResponse)
						});
					var oldLandingHomeModel = model.aw;
					var newLandingHomeModel = _Utils_update(
						oldLandingHomeModel,
						{
							bL: $author$project$Bootstrap$Carousel$initialStateWithOptions(
								_Utils_update(
									$author$project$Bootstrap$Carousel$defaultStateOptions,
									{ai: 1, gm: false}))
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aw: newLandingHomeModel,
								aj: updatedMarketDetailModel,
								ak: updatedMarketsModel,
								ax: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 6:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					var oldMarketsModel = model.ak;
					var updatedMarketsModel = _Utils_update(
						oldMarketsModel,
						{
							lu: $elm$core$Maybe$Just(cTokenResponse)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ak: updatedMarketsModel}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 7:
				if (!msg.a.$) {
					var newMobileMenuShowing = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c6: newMobileMenuShowing}),
						$elm$core$Platform$Cmd$none);
				} else {
					var newNetwork = msg.a.a;
					return A2(
						$author$project$LandingSite$Main$handlePageUpdates,
						model._,
						_Utils_update(
							model,
							{t: $elm$core$Maybe$Nothing, bf: $author$project$Governance$AccountProfile$emptyState, bX: $author$project$Governance$Home$emptyState, bY: $author$project$Governance$Leaderboard$emptyState, bh: $author$project$Governance$ProposalDetail$emptyState, bZ: $author$project$Governance$ProposalOverview$emptyState, bi: $author$project$Utils$Graph$init.a, av: $author$project$LandingSite$CTokens$emptyState, b7: $author$project$LandingSite$CommonViews$emptyState, bl: $author$project$LandingSite$Comp$emptyState, aw: $author$project$LandingSite$Home$emptyState, ak: $author$project$LandingSite$Markets$emptyState, ax: $elm$core$Maybe$Nothing, c6: false, bo: newNetwork}));
				}
			case 8:
				var landingCommonMsg = msg.a;
				var _v10 = A2($author$project$LandingSite$CommonViews$update, landingCommonMsg, model.b7);
				var updatedLandingCommonModel = _v10.a;
				var landingCommonCmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b7: updatedLandingCommonModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCommonTranslator, landingCommonCmd));
			case 9:
				var landingCompMsg = msg.a;
				var _v11 = A2($author$project$LandingSite$Comp$update, landingCompMsg, model.bl);
				var updatedLandingCompModel = _v11.a;
				var landingCompCmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bl: updatedLandingCompModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCompTranslator, landingCompCmd));
			case 10:
				var landingCTokensMsg = msg.a;
				var _v12 = A5($author$project$LandingSite$CTokens$update, apiBaseUrlMap, network, model.t, landingCTokensMsg, model.av);
				var updatedLandingCTokensModel = _v12.a;
				var landingCTokensCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{av: updatedLandingCTokensModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCTokensTranslator, landingCTokensCmd));
			case 11:
				var landingHomeMsg = msg.a;
				var _v13 = A2($author$project$LandingSite$Home$update, landingHomeMsg, model.aw);
				var updatedlandingHomeModel = _v13.a;
				var landingHomeCmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aw: updatedlandingHomeModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingHomeTranslator, landingHomeCmd));
			case 12:
				var landingAboutMsg = msg.a;
				var _v14 = A2($author$project$LandingSite$About$update, landingAboutMsg, model.b6);
				var updatedlandingAboutModel = _v14.a;
				var landingAboutCmd = _v14.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b6: updatedlandingAboutModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingAboutTranslator, landingAboutCmd));
			case 13:
				var landingMarketDetailMsg = msg.a;
				var _v15 = A2($author$project$LandingSite$MarketDetail$update, landingMarketDetailMsg, model.aj);
				var updatedLandingMarketDetailModel = _v15.a;
				var landingMarketDetailCmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aj: updatedLandingMarketDetailModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingMarketDetailTranslator, landingMarketDetailCmd));
			case 14:
				var landingMarketsMsg = msg.a;
				var _v16 = A2($author$project$LandingSite$Markets$update, landingMarketsMsg, model.ak);
				var updatedLandingMarketsModel = _v16.a;
				var landingMarketsCmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: updatedLandingMarketsModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingMarketsTranslator, landingMarketsCmd));
			case 15:
				var landingPricesMsg = msg.a;
				var _v17 = A2($author$project$LandingSite$Prices$update, landingPricesMsg, model.al);
				var updatedLandingPricesModel = _v17.a;
				var landingPricesCmd = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{al: updatedLandingPricesModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingPricesTranslator, landingPricesCmd));
			case 16:
				var landingDevelopersMsg = msg.a;
				var _v18 = A2($author$project$LandingSite$DevelopersMarketing$update, landingDevelopersMsg, model.c$);
				var updatedLandingDevelopersModel = _v18.a;
				var landingDevelopersCmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c$: updatedLandingDevelopersModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingDevelopersTranslator, landingDevelopersCmd));
			case 17:
				var landingDocsMsg = msg.a;
				var _v19 = A2($author$project$LandingSite$Docs$update, landingDocsMsg, model.bm);
				var updatedLandingDocsModel = _v19.a;
				var landingDocsCmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bm: updatedLandingDocsModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingDocsTranslator, landingDocsCmd));
			case 18:
				var accountProfilePageMsg = msg.a;
				var _v20 = A4($author$project$Governance$AccountProfile$update, apiBaseUrlMap, network, accountProfilePageMsg, model.bf);
				var updatedGovAccountProfileModel = _v20.a;
				var govAccountProfilePageCmd = _v20.b;
				var updatePageTitleCmd = function () {
					var _v21 = updatedGovAccountProfileModel.aK;
					if (!_v21.$) {
						var compAccount = _v21.a;
						return $author$project$LandingSite$Main$setTitleAndDescription(
							_Utils_Tuple2(
								A3($author$project$LandingSite$Page$titleForProfile, model.aB, page, compAccount),
								A2($author$project$LandingSite$Page$metaDescription, model.aB, page)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bf: updatedGovAccountProfileModel}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceAccountProfileMsg, govAccountProfilePageCmd),
								updatePageTitleCmd
							])));
			case 19:
				var homePageMsg = msg.a;
				var _v22 = A2($author$project$Governance$Home$update, homePageMsg, model.bX);
				var updatedGovHomeModel = _v22.a;
				var govHomePageCmd = _v22.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: updatedGovHomeModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceHomeMsg, govHomePageCmd));
			case 20:
				var proposalDetailPageMsg = msg.a;
				var _v23 = A4($author$project$Governance$ProposalDetail$update, model.o, model.bo, proposalDetailPageMsg, model.bh);
				var updatedProposalDetailPageModel = _v23.a;
				var proposalDetailPageCmd = _v23.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bh: updatedProposalDetailPageModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalDetailMsg, proposalDetailPageCmd));
			case 21:
				var proposalOverviewPageMsg = msg.a;
				var _v24 = A4($author$project$Governance$ProposalOverview$update, model.o, model.bo, proposalOverviewPageMsg, model.bZ);
				var updatedProposalOverviewModel = _v24.a;
				var proposalOverviewPageCmd = _v24.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bZ: updatedProposalOverviewModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalOverviewMsg, proposalOverviewPageCmd));
			case 22:
				var leaderboardPageMsg = msg.a;
				var _v25 = A2($author$project$Governance$Leaderboard$update, leaderboardPageMsg, model.bY);
				var updatedLeaderboardModel = _v25.a;
				var leaderboardPageCmd = _v25.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bY: updatedLeaderboardModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceLeaderboardMsg, leaderboardPageCmd));
			case 23:
				var page_ = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$LandingSite$Main$maybeScroll(page_));
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h6: model.h6}),
					$author$project$Console$log(error));
		}
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Utils$CompoundHtmlAttributes$id = function (idName) {
	return A2($elm$html$Html$Attributes$attribute, 'id', idName);
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$LandingSite$CommonViews$ForSelf = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$CommonViews$ToggleNetworkDropdown = $elm$core$Basics$identity;
var $author$project$Strings$Translations$about = function (lang) {
	switch (lang) {
		case 0:
			return 'About';
		case 1:
			return 'Acerca de';
		case 2:
			return '关于';
		case 3:
			return 'Sur';
		default:
			return '소개';
	}
};
var $author$project$Strings$Translations$app = function (lang) {
	switch (lang) {
		case 0:
			return 'App';
		case 1:
			return 'Aplicación';
		case 2:
			return 'App';
		case 3:
			return 'App';
		default:
			return '앱';
	}
};
var $author$project$Strings$Translations$careers = function (lang) {
	switch (lang) {
		case 0:
			return 'Careers';
		case 1:
			return 'Carreras';
		case 2:
			return '招贤纳士';
		case 3:
			return 'Carrières';
		default:
			return '채용';
	}
};
var $author$project$Utils$CompoundHtmlAttributes$class = function (className) {
	return A2($elm$html$Html$Attributes$attribute, 'class', className);
};
var $author$project$Strings$Translations$comp = function (lang) {
	switch (lang) {
		case 0:
			return 'COMP';
		case 1:
			return 'COMP';
		case 2:
			return 'COMP';
		case 3:
			return 'COMP';
		default:
			return 'COMP';
	}
};
var $author$project$Strings$Translations$company = function (lang) {
	switch (lang) {
		case 0:
			return 'Company';
		case 1:
			return 'Empresa';
		case 2:
			return '公司';
		case 3:
			return 'Entreprise';
		default:
			return '회사';
	}
};
var $author$project$Strings$Translations$copyright = function (lang) {
	switch (lang) {
		case 0:
			return '© 2020 Compound Labs, Inc.';
		case 1:
			return '© 2020 Compound Labs, Inc.';
		case 2:
			return '©2020 Compound Labs，Inc.';
		case 3:
			return '© 2020 Compound Labs, Inc.';
		default:
			return '© 2020 Compound Labs, Inc.';
	}
};
var $author$project$Strings$Translations$developers = function (lang) {
	switch (lang) {
		case 0:
			return 'Developers';
		case 1:
			return 'Desarrolladores';
		case 2:
			return '开发者';
		case 3:
			return 'Développeurs';
		default:
			return '개발자';
	}
};
var $author$project$Strings$Translations$docs = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs';
		case 1:
			return 'Docs';
		case 2:
			return '文档';
		case 3:
			return 'Documents';
		default:
			return '문서';
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Strings$Translations$forums = function (lang) {
	switch (lang) {
		case 0:
			return 'Forums';
		case 1:
			return 'El';
		case 2:
			return '论坛';
		case 3:
			return 'Les forums';
		default:
			return '포럼';
	}
};
var $author$project$LandingSite$Page$getForumsUrl = 'https://www.comp.xyz/';
var $author$project$Strings$Translations$governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance';
		case 1:
			return 'Gobernancia';
		case 2:
			return '治理';
		case 3:
			return 'La gouvernance';
		default:
			return '거버넌스';
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Strings$Translations$leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Leaderboard';
		case 1:
			return 'Tabla de clasificación';
		case 2:
			return '排行榜';
		case 3:
			return 'Classement';
		default:
			return '순위표';
	}
};
var $author$project$Strings$Translations$markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Markets';
		case 1:
			return 'Mercados';
		case 2:
			return '市场';
		case 3:
			return 'Marchés';
		default:
			return '마켓';
	}
};
var $author$project$LandingSite$CommonViews$ForParent = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$CommonViews$SetNetwork = function (a) {
	return {$: 1, a: a};
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{lT: msg, gn: true, gM: true}));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Strings$Translations$unsupported = function (lang) {
	switch (lang) {
		case 0:
			return 'Unsupported';
		case 1:
			return 'Sin soporte';
		case 2:
			return '不支援';
		case 3:
			return 'Non pris en charge';
		default:
			return '지원하지 않음';
	}
};
var $author$project$LandingSite$CommonViews$networkSelectorView = F3(
	function (userLanguage, network, model) {
		var isSupportedNetwork = function () {
			switch (network) {
				case 1:
					return true;
				case 3:
					return true;
				case 7:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				default:
					return false;
			}
		}();
		var selectedNetworkText = isSupportedNetwork ? $author$project$Network$networkName(network) : $author$project$Strings$Translations$unsupported(userLanguage);
		var iconClassFoNetwork = function (targetNetwork) {
			switch (targetNetwork) {
				case 1:
					return 'dot-indicator green';
				case 3:
					return 'dot-indicator ropsten';
				case 7:
					return 'dot-indicator kovan';
				case 4:
					return 'dot-indicator rinkeby';
				case 5:
					return 'dot-indicator goerli';
				default:
					return 'dot-indicator';
			}
		};
		var _v0 = model.bp ? _Utils_Tuple2(
			' active',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option dropdown__option--dark2'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
							A2($elm$core$Basics$composeL, $author$project$LandingSite$CommonViews$ForParent, $author$project$LandingSite$CommonViews$SetNetwork)(1))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(1))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small language')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Network$networkName(1))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option dropdown__option--dark2'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
							A2($elm$core$Basics$composeL, $author$project$LandingSite$CommonViews$ForParent, $author$project$LandingSite$CommonViews$SetNetwork)(3))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(3))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small language')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Network$networkName(3))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option dropdown__option--dark2'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
							A2($elm$core$Basics$composeL, $author$project$LandingSite$CommonViews$ForParent, $author$project$LandingSite$CommonViews$SetNetwork)(7))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(7))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small language')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Network$networkName(7))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option dropdown__option--dark2'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
							A2($elm$core$Basics$composeL, $author$project$LandingSite$CommonViews$ForParent, $author$project$LandingSite$CommonViews$SetNetwork)(4))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(4))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small language')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Network$networkName(4))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option dropdown__option--dark2'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
							A2($elm$core$Basics$composeL, $author$project$LandingSite$CommonViews$ForParent, $author$project$LandingSite$CommonViews$SetNetwork)(5))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(5))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small language')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Network$networkName(5))
								]))
						]))
				])) : _Utils_Tuple2('', _List_Nil);
		var dropdownActiveClass = _v0.a;
		var optionsContent = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('dropdown dropdown--network'),
					$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
					$author$project$LandingSite$CommonViews$ForSelf(!model.bp))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__selected dropdown__selected--dark2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class(
									iconClassFoNetwork(network))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(selectedNetworkText)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('dropdown__options dropdown__options--network dropdown__selected--dark2 ' + dropdownActiveClass)
						]),
					optionsContent)
				]));
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Strings$Translations$overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Overview';
		case 1:
			return 'Visión general';
		case 2:
			return '总览';
		case 3:
			return 'Aperçu';
		default:
			return '개요';
	}
};
var $author$project$Strings$Translations$prices_title = function (lang) {
	switch (lang) {
		case 0:
			return 'Prices';
		case 1:
			return 'Precios';
		case 2:
			return '价格';
		case 3:
			return 'Des prix';
		default:
			return '물가';
	}
};
var $author$project$Strings$Translations$protocol = function (lang) {
	switch (lang) {
		case 0:
			return 'Protocol';
		case 1:
			return 'Protocolo';
		case 2:
			return '协议';
		case 3:
			return 'Protocole';
		default:
			return '프로토콜';
	}
};
var $author$project$LandingSite$CommonViews$pageFooter = F3(
	function (userLanguage, network, model) {
		var languageSelectorCover = model.bp ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('cover clear active'),
					$elm$html$Html$Events$onClick(
					$author$project$LandingSite$CommonViews$ForSelf(false))
				]),
			_List_Nil) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$footer,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('footer'),
					$author$project$Utils$CompoundHtmlAttributes$class('landing')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('container-large')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('row top')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 logo mobile-hide')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$append,
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('mark')
													])),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 logo mobile-only')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$append,
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('brand')
													])),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 col-xs-12 row links-holder')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6 links')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$protocol(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$markets(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Prices)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$prices_title(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Developers)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$developers(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl(
															A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing))),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$docs(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6 links')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$governance(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$overview(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Comp)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$comp(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceLeaderboard)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$leaderboard(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 2, $author$project$LandingSite$Page$getForumsUrl),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$forums(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6 links')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$company(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl(
															$author$project$LandingSite$Page$About($elm$core$Maybe$Nothing))),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$about(userLanguage))
														])),
													A2(
													$elm$html$Html$a,
													A2(
														$author$project$Utils$CompoundHtmlAttributes$href,
														0,
														$author$project$LandingSite$Page$getHrefUrl(
															$author$project$LandingSite$Page$About(
																$elm$core$Maybe$Just('jobs')))),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$careers(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide col-xs-2 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class('dapp button'),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$app(userLanguage))
												]))
										]))
								])),
							languageSelectorCover,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('bottom')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('small')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$copyright(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('social')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('icn discord'),
														$author$project$Utils$CompoundHtmlAttributes$target('_blank')
													]),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.finance/discord')),
											_List_Nil),
											A2(
											$elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('icn github'),
														$author$project$Utils$CompoundHtmlAttributes$target('_blank')
													]),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-protocol')),
											_List_Nil),
											A2(
											$elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('icn medium'),
														$author$project$Utils$CompoundHtmlAttributes$target('_blank')
													]),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance')),
											_List_Nil),
											A2(
											$elm$html$Html$a,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('icn twitter'),
														$author$project$Utils$CompoundHtmlAttributes$target('_blank')
													]),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://twitter.com/compoundfinance')),
											_List_Nil),
											A3($author$project$LandingSite$CommonViews$networkSelectorView, userLanguage, network, model)
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$CommonViews$ToggleMobileNavMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Strings$Translations$home = function (lang) {
	switch (lang) {
		case 0:
			return 'Home';
		case 1:
			return 'Casa';
		case 2:
			return '主页';
		case 3:
			return 'Accueil';
		default:
			return '홈페이지';
	}
};
var $author$project$LandingSite$CommonViews$pageHeader = F3(
	function (userLanguage, page, shouldShowMobileMenu) {
		var mobileHeaderClass = shouldShowMobileMenu ? 'active' : '';
		var headerClass = function () {
			switch (page.$) {
				case 2:
					return '';
				case 4:
					return ' dark-2';
				case 9:
					return '';
				case 10:
					return '';
				case 11:
					return '';
				case 12:
					return '';
				case 13:
					return '';
				case 0:
					return '';
				case 8:
					return '';
				case 7:
					return '';
				case 14:
					return '';
				default:
					return ' light';
			}
		}();
		var _v0 = function () {
			var emptyClasses = {fb: '', fe: '', bg: '', ec: '', go: ''};
			switch (page.$) {
				case 8:
					return _Utils_update(
						emptyClasses,
						{ec: 'active'});
				case 7:
					return _Utils_update(
						emptyClasses,
						{ec: 'active'});
				case 9:
					return _Utils_update(
						emptyClasses,
						{bg: 'active'});
				case 10:
					return _Utils_update(
						emptyClasses,
						{bg: 'active'});
				case 11:
					return _Utils_update(
						emptyClasses,
						{bg: 'active'});
				case 12:
					return _Utils_update(
						emptyClasses,
						{bg: 'active'});
				case 13:
					return _Utils_update(
						emptyClasses,
						{bg: 'active'});
				case 4:
					return _Utils_update(
						emptyClasses,
						{fb: 'active'});
				case 14:
					return _Utils_update(
						emptyClasses,
						{go: 'active'});
				case 5:
					return _Utils_update(
						emptyClasses,
						{fe: 'active'});
				default:
					return emptyClasses;
			}
		}();
		var marketsClass = _v0.ec;
		var governanceClass = _v0.bg;
		var developersClass = _v0.fb;
		var pricesClass = _v0.go;
		var docsClass = _v0.fe;
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('header'),
					$author$project$Utils$CompoundHtmlAttributes$class('landing ' + headerClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('container-large')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-10 logo')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$append,
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('brand'),
														$elm$html$Html$Events$onClick(
														$author$project$LandingSite$CommonViews$ForParent(
															$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false)))
													])),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide col-xs-6 text-center links')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(marketsClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$markets(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(governanceClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$governance(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(developersClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Developers))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$developers(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(pricesClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Prices))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$prices_title(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(docsClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl(
														A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide col-xs-3 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class('dapp button hollow'),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$app(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-only col-xs-2 hamburger ' + mobileHeaderClass),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$CommonViews$ForParent(
												$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(!shouldShowMobileMenu)))
										]),
									_List_fromArray(
										[
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('mobile-header ' + (mobileHeaderClass + (' ' + headerClass)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('links')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/')),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$home(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$markets(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$governance(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Developers))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$developers(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Prices))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$prices_title(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$LandingSite$CommonViews$ForParent(
														$author$project$LandingSite$CommonViews$ToggleMobileNavMsg(false))),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl(
														A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$docs(userLanguage))
																]))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$class('dapp button hollow'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$app(userLanguage))
								]))
						]))
				]));
	});
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Utils$CompoundHtmlAttributes$style = F2(
	function (styleName, styleValue) {
		return A2($elm$html$Html$Attributes$style, styleName, styleValue);
	});
var $author$project$LandingSite$AbiViewer$view = F3(
	function (networkName, contractName, abiFilesRaw) {
		var contractAbiText = function () {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					networkName,
					A2($elm$json$Json$Decode$field, contractName, $elm$json$Json$Decode$value)),
				abiFilesRaw);
			if (!_v0.$) {
				var decodedAbi = _v0.a;
				return A2($elm$json$Json$Encode$encode, 4, decodedAbi);
			} else {
				var error = _v0.a;
				return '{\"error\": \"unknown abi\"}';
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_fromArray(
				[
					A2($author$project$Utils$CompoundHtmlAttributes$style, 'word-wrap', 'break-word')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(contractAbiText)
				]));
	});
var $author$project$Governance$AccountProfile$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$accountProfileTranslator = $author$project$Governance$AccountProfile$translator(
	{ja: $author$project$LandingSite$Main$GovernanceAccountProfileMsg});
var $author$project$Governance$Home$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$governanceHomeTranslator = $author$project$Governance$Home$translator(
	{ja: $author$project$LandingSite$Main$GovernanceHomeMsg});
var $author$project$Governance$Leaderboard$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$governanceLeaderboardTranslator = $author$project$Governance$Leaderboard$translator(
	{ja: $author$project$LandingSite$Main$GovernanceLeaderboardMsg});
var $author$project$Governance$ProposalDetail$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$proposalDetailTranslator = $author$project$Governance$ProposalDetail$translator(
	{ja: $author$project$LandingSite$Main$GovernanceProposalDetailMsg});
var $author$project$Governance$ProposalOverview$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.ja;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$proposalOverviewTranslator = $author$project$Governance$ProposalOverview$translator(
	{ja: $author$project$LandingSite$Main$GovernanceProposalOverviewMsg});
var $author$project$Eth$Ethereum$zeroAddress = '0x0000000000000000000000000000000000000000';
var $author$project$Governance$AccountProfile$compAccountNotFound = function (targetAddress) {
	return $author$project$CompoundApi$Governance$Common$Models$createCompAccount(targetAddress)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)($author$project$Decimal$zero)($author$project$Decimal$zero)($author$project$Decimal$zero)(0)(0)(
		A4($author$project$CompoundApi$Governance$Common$Models$createDisplayAccount, $author$project$Eth$Ethereum$zeroAddress, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))($elm$core$Maybe$Nothing)($elm$core$Maybe$Nothing)(0);
};
var $author$project$Strings$Translations$comp_distribution = function (lang) {
	switch (lang) {
		case 0:
			return 'COMP Distribution';
		case 1:
			return 'Distribución COMP';
		case 2:
			return 'COMP分配';
		case 3:
			return 'Distribution COMP';
		default:
			return 'COMP 분배';
	}
};
var $author$project$Strings$Translations$current_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Current Borrow';
		case 1:
			return 'Préstamo actual';
		case 2:
			return '目前借用';
		case 3:
			return 'Emprunt actuel';
		default:
			return '현재 차용';
	}
};
var $author$project$Strings$Translations$current_supply = function (lang) {
	switch (lang) {
		case 0:
			return 'Current Supply';
		case 1:
			return 'Suministro de corriente';
		case 2:
			return '供电';
		case 3:
			return 'Offre actuelle';
		default:
			return '전류 공급';
	}
};
var $author$project$Strings$Translations$earned = function (lang) {
	switch (lang) {
		case 0:
			return 'Earned';
		case 1:
			return 'Ganado';
		case 2:
			return '获得';
		case 3:
			return 'Gagné';
		default:
			return '획득';
	}
};
var $author$project$Decimal$gt = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (_v0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Strings$Translations$market = function (lang) {
	switch (lang) {
		case 0:
			return 'Market';
		case 1:
			return 'Mercado';
		case 2:
			return '市场';
		case 3:
			return 'Marché';
		default:
			return '마켓';
	}
};
var $author$project$Functions$default = F2(
	function (maybeVal, defaultVal) {
		if (!maybeVal.$) {
			var val = maybeVal.a;
			return val;
		} else {
			return defaultVal;
		}
	});
var $author$project$Utils$NumberFormatter$dropRight = F2(
	function (dropChar, string) {
		var reducer = F2(
			function (nextChar, res) {
				if (res.$ === 1) {
					return _Utils_eq(nextChar, dropChar) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$fromChar(nextChar));
				} else {
					var str = res.a;
					return $elm$core$Maybe$Just(
						A2($elm$core$String$cons, nextChar, str));
				}
			});
		return A2(
			$author$project$Functions$default,
			A3($elm$core$String$foldr, reducer, $elm$core$Maybe$Nothing, string),
			'');
	});
var $author$project$Utils$NumberFormatter$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $author$project$Utils$NumberFormatter$formatToDecimalPlaces = F3(
	function (decimalPlaces, dropZeros, decimalValue) {
		var floatString = $author$project$Decimal$toString(decimalValue);
		var dropper = dropZeros ? $author$project$Utils$NumberFormatter$dropRight('0') : function (i) {
			return i;
		};
		var _v0 = function () {
			var _v1 = A2($elm$core$String$split, '.', floatString);
			if (!_v1.b) {
				return _Utils_Tuple2('', '');
			} else {
				if (!_v1.b.b) {
					var headValue = _v1.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$String$join,
							',',
							$author$project$Utils$NumberFormatter$splitThousands(headValue)),
						'');
				} else {
					if (!_v1.b.b.b) {
						var headValue = _v1.a;
						var _v2 = _v1.b;
						var tailValue = _v2.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$String$join,
								',',
								$author$project$Utils$NumberFormatter$splitThousands(headValue)),
							A2(
								$elm$core$String$left,
								decimalPlaces,
								dropper(tailValue)));
					} else {
						return _Utils_Tuple2('', '');
					}
				}
			}
		}();
		var digitString = _v0.a;
		var decimalString = _v0.b;
		var _v3 = $elm$core$String$isEmpty(decimalString);
		if (_v3) {
			return digitString;
		} else {
			return digitString + ('.' + decimalString);
		}
	});
var $author$project$Decimal$abs = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var _v1 = A2(
		$cmditch$elm_bigint$BigInt$compare,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0));
	if (!_v1) {
		return A2(
			$author$project$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$negate(m),
			e);
	} else {
		return A2($author$project$Decimal$Decimal, m, e);
	}
};
var $author$project$Utils$NumberFormatter$getSignAndAbsValue = function (decimalValue) {
	var signString = A2($author$project$Decimal$lt, decimalValue, $author$project$Decimal$zero) ? '- ' : '';
	return _Utils_Tuple2(
		signString,
		$author$project$Decimal$abs(decimalValue));
};
var $author$project$Decimal$getDigit = F2(
	function (n, d) {
		var decimalAsString = $author$project$Decimal$toString(d);
		var toInt = function (targetDecimal) {
			switch (targetDecimal) {
				case '1':
					return 1;
				case '2':
					return 2;
				case '3':
					return 3;
				case '4':
					return 4;
				case '5':
					return 5;
				case '6':
					return 6;
				case '7':
					return 7;
				case '8':
					return 8;
				case '9':
					return 9;
				case '0':
					return 0;
				case '':
					return 0;
				default:
					return -1;
			}
		};
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$split, '.', decimalAsString),
			A2($elm$core$Basics$compare, n, 0));
		_v0$6:
		while (true) {
			if (_v0.a.b) {
				if (!_v0.a.b.b) {
					switch (_v0.b) {
						case 2:
							var _v1 = _v0.a;
							var a = _v1.a;
							var _v2 = _v0.b;
							return toInt(
								A2(
									$elm$core$String$right,
									1,
									A2($elm$core$String$dropRight, n, a)));
						case 1:
							var _v3 = _v0.a;
							var a = _v3.a;
							var _v4 = _v0.b;
							return toInt(
								A2($elm$core$String$right, 1, a));
						default:
							var _v5 = _v0.a;
							var a = _v5.a;
							var _v6 = _v0.b;
							return 0;
					}
				} else {
					if (!_v0.a.b.b.b) {
						switch (_v0.b) {
							case 2:
								var _v7 = _v0.a;
								var a = _v7.a;
								var _v8 = _v7.b;
								var b = _v8.a;
								var _v9 = _v0.b;
								return toInt(
									A2(
										$elm$core$String$right,
										1,
										A2($elm$core$String$dropRight, n, a)));
							case 1:
								var _v10 = _v0.a;
								var a = _v10.a;
								var _v11 = _v10.b;
								var b = _v11.a;
								var _v12 = _v0.b;
								return toInt(
									A2($elm$core$String$right, 1, a));
							default:
								var _v13 = _v0.a;
								var a = _v13.a;
								var _v14 = _v13.b;
								var b = _v14.a;
								var _v15 = _v0.b;
								return toInt(
									A2(
										$elm$core$String$left,
										1,
										A2($elm$core$String$dropLeft, (-n) - 1, b)));
						}
					} else {
						break _v0$6;
					}
				}
			} else {
				break _v0$6;
			}
		}
		return -13;
	});
var $author$project$Decimal$signAsInt = function (d) {
	var _v0 = A2($author$project$Decimal$compare, d, $author$project$Decimal$zero);
	switch (_v0) {
		case 0:
			return -1;
		case 1:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Decimal$truncate = F2(
	function (n, d) {
		var decimalAsString = $author$project$Decimal$toString(d);
		var toDecimal = function (s) {
			var _v7 = $author$project$Decimal$fromString(s);
			if (!_v7.$) {
				var a = _v7.a;
				return a;
			} else {
				return $author$project$Decimal$zero;
			}
		};
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$split, '.', decimalAsString),
			n >= 0);
		_v0$4:
		while (true) {
			if (_v0.a.b) {
				if (!_v0.a.b.b) {
					if (_v0.b) {
						var _v1 = _v0.a;
						var a = _v1.a;
						return toDecimal(
							_Utils_ap(
								A2($elm$core$String$dropRight, n, a),
								A2($elm$core$String$repeat, n, '0')));
					} else {
						var _v2 = _v0.a;
						var a = _v2.a;
						return toDecimal(a);
					}
				} else {
					if (!_v0.a.b.b.b) {
						if (_v0.b) {
							var _v3 = _v0.a;
							var a = _v3.a;
							var _v4 = _v3.b;
							var b = _v4.a;
							return toDecimal(
								_Utils_ap(
									A2($elm$core$String$dropRight, n, a),
									A2($elm$core$String$repeat, n, '0')));
						} else {
							var _v5 = _v0.a;
							var a = _v5.a;
							var _v6 = _v5.b;
							var b = _v6.a;
							return toDecimal(
								a + ('.' + A2($elm$core$String$left, -n, b)));
						}
					} else {
						break _v0$4;
					}
				}
			} else {
				break _v0$4;
			}
		}
		return $author$project$Decimal$zero;
	});
var $author$project$Decimal$round = F2(
	function (n, d) {
		var to_increment = A2(
			$author$project$Decimal$fromIntWithExponent,
			$author$project$Decimal$signAsInt(d),
			n);
		var t = A2($author$project$Decimal$truncate, n, d);
		var next_digit = A2($author$project$Decimal$getDigit, n - 1, d);
		return (next_digit >= 5) ? A2($author$project$Decimal$add, t, to_increment) : t;
	});
var $author$project$Utils$NumberFormatter$formatCompAndVoteBalance = function (decimalValue) {
	var roundedValue = A2($author$project$Decimal$round, -8, decimalValue);
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return _Utils_ap(
		signString,
		A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 8, false, absoluteDecimalValue));
};
var $author$project$DappInterface$CommonViews$compOrVoteBalanceSpan = F2(
	function (_v0, balance) {
		var significantSpanClass = _v0.a;
		var insignificantSpanClass = _v0.b;
		var fullBalanceString = $author$project$Utils$NumberFormatter$formatCompAndVoteBalance(balance);
		var insignificantPart = A2($elm$core$String$right, 4, fullBalanceString);
		var significantPart = A3($elm$core$String$slice, 0, -4, fullBalanceString);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class(significantSpanClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(significantPart)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class(insignificantSpanClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(insignificantPart)
					]))
			]);
	});
var $author$project$Decimal$eq = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (_v0 === 1) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Governance$AccountProfile$marketRow = F6(
	function (symbol, market, supply, borrow, compPerDay, totalCompDistributed) {
		var totalCompDistributedStyled = A2(
			$author$project$DappInterface$CommonViews$compOrVoteBalanceSpan,
			_Utils_Tuple2('', 'markets-panel__market-row__text--light'),
			totalCompDistributed);
		var currentSupply = A2($author$project$Decimal$eq, supply, $author$project$Decimal$zero) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__text--light')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('–')
				])) : $elm$html$Html$text(
			A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 2, false, supply) + (' ' + symbol));
		var currentBorrow = A2($author$project$Decimal$eq, borrow, $author$project$Decimal$zero) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__text--light')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('–')
				])) : $elm$html$Html$text(
			A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 2, false, borrow) + (' ' + symbol));
		var compPerDayStyled = A2(
			$author$project$DappInterface$CommonViews$compOrVoteBalanceSpan,
			_Utils_Tuple2('', 'markets-panel__market-row__text--light'),
			compPerDay);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__icon icon ' + symbol)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(market)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[currentSupply])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[currentBorrow])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					compPerDayStyled),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					totalCompDistributedStyled)
				]));
	});
var $author$project$Strings$Translations$per_day = function (lang) {
	switch (lang) {
		case 0:
			return 'Per Day';
		case 1:
			return 'Por día';
		case 2:
			return '每天';
		case 3:
			return 'Par jour';
		default:
			return '하루';
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Utils$CompoundHtmlAttributes$src = function (srcName) {
	return A2($elm$html$Html$Attributes$attribute, 'src', srcName);
};
var $author$project$Governance$AccountProfile$compDistributionPanel = F2(
	function (userLanguage, _v0) {
		var maybeCompDistributionResponse = _v0.ee;
		var maybePresidioAccountResponse = _v0.ef;
		var _v1 = _Utils_Tuple2(maybePresidioAccountResponse, maybeCompDistributionResponse);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var presidioAccount = _v1.a.a;
			var compDistribution = _v1.b.a;
			var accountBalances = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.nk;
					},
					$elm$core$List$head(presidioAccount.ha)));
			var markets = A2(
				$elm$core$List$map,
				function (market) {
					var totalComp = market.hH;
					var maybeBalances = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (token) {
								return _Utils_eq(market.hd, token.hd);
							},
							accountBalances));
					var dailyComp = market.hR;
					var currentSupply = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.mY;
							},
							maybeBalances));
					var currentBorrow = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.kz;
							},
							maybeBalances));
					return A6($author$project$Governance$AccountProfile$marketRow, market.j4, market.j2, currentSupply, currentBorrow, dailyComp, totalComp);
				},
				A2(
					$elm$core$List$sortBy,
					function (market) {
						return market.j2;
					},
					A2(
						$elm$core$List$filter,
						function (market) {
							return A2($author$project$Decimal$gt, market.hH, $author$project$Decimal$zero);
						},
						compDistribution.iN)));
			return ($elm$core$List$length(markets) > 0) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel markets-panel')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$comp_distribution(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$market(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$current_supply(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$current_borrow(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right comp-column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$per_day(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right comp-column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$earned(userLanguage))
												]))
										]))
								]))
						]),
					markets)) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Eth$Ethereum$EtherscanAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Strings$Translations$action = function (lang) {
	switch (lang) {
		case 0:
			return 'Action';
		case 1:
			return 'Acción';
		case 2:
			return '行动';
		case 3:
			return 'action';
		default:
			return '활동';
	}
};
var $author$project$Strings$Translations$age = function (lang) {
	switch (lang) {
		case 0:
			return 'Age';
		case 1:
			return 'Años';
		case 2:
			return '年龄';
		case 3:
			return 'Âge';
		default:
			return '발생 시간';
	}
};
var $author$project$Utils$Time$differenceInSeconds = F2(
	function (end, start) {
		return $author$project$Utils$Time$posixToSeconds(end) - $author$project$Utils$Time$posixToSeconds(start);
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Strings$Translations$day = function (lang) {
	switch (lang) {
		case 0:
			return 'day';
		case 1:
			return 'día';
		case 2:
			return '天';
		case 3:
			return 'journée';
		default:
			return '일';
	}
};
var $author$project$Strings$Translations$days = function (lang) {
	switch (lang) {
		case 0:
			return 'days';
		case 1:
			return 'dias';
		case 2:
			return '天';
		case 3:
			return 'journées';
		default:
			return '일';
	}
};
var $author$project$Strings$Translations$hour = function (lang) {
	switch (lang) {
		case 0:
			return 'hr';
		case 1:
			return 'hora';
		case 2:
			return '小时';
		case 3:
			return 'heure';
		default:
			return '시간';
	}
};
var $author$project$Strings$Translations$hours = function (lang) {
	switch (lang) {
		case 0:
			return 'hrs';
		case 1:
			return 'horas';
		case 2:
			return '小时';
		case 3:
			return 'heures';
		default:
			return '시간';
	}
};
var $author$project$Strings$Translations$minute = function (lang) {
	switch (lang) {
		case 0:
			return 'min';
		case 1:
			return 'minuto';
		case 2:
			return '分钟';
		case 3:
			return 'minute';
		default:
			return '분';
	}
};
var $author$project$Strings$Translations$minutes = function (lang) {
	switch (lang) {
		case 0:
			return 'mins';
		case 1:
			return 'minutos';
		case 2:
			return '分钟';
		case 3:
			return 'minutes';
		default:
			return '분';
	}
};
var $author$project$Strings$Translations$second = function (lang) {
	switch (lang) {
		case 0:
			return 'second';
		case 1:
			return 'segundo';
		case 2:
			return '第二';
		case 3:
			return 'seconde';
		default:
			return '초';
	}
};
var $author$project$Strings$Translations$seconds = function (lang) {
	switch (lang) {
		case 0:
			return 'seconds';
		case 1:
			return 'segundos';
		case 2:
			return '秒';
		case 3:
			return 'secondes';
		default:
			return '초';
	}
};
var $author$project$Strings$Translations$year = function (lang) {
	switch (lang) {
		case 0:
			return 'year';
		case 1:
			return 'año';
		case 2:
			return '年';
		case 3:
			return 'année';
		default:
			return '년';
	}
};
var $author$project$Strings$Translations$years = function (lang) {
	switch (lang) {
		case 0:
			return 'years';
		case 1:
			return 'años';
		case 2:
			return '年份';
		case 3:
			return 'ans';
		default:
			return '년';
	}
};
var $author$project$Utils$Time$timeElements = function (userLanguage) {
	return _List_fromArray(
		[
			{
			bn: ((60 * 60) * 24) * 365,
			bs: $author$project$Strings$Translations$years(userLanguage),
			bx: $author$project$Strings$Translations$year(userLanguage)
		},
			{
			bn: (60 * 60) * 24,
			bs: $author$project$Strings$Translations$days(userLanguage),
			bx: $author$project$Strings$Translations$day(userLanguage)
		},
			{
			bn: 60 * 60,
			bs: $author$project$Strings$Translations$hours(userLanguage),
			bx: $author$project$Strings$Translations$hour(userLanguage)
		},
			{
			bn: 60,
			bs: $author$project$Strings$Translations$minutes(userLanguage),
			bx: $author$project$Strings$Translations$minute(userLanguage)
		},
			{
			bn: 1,
			bs: $author$project$Strings$Translations$seconds(userLanguage),
			bx: $author$project$Strings$Translations$second(userLanguage)
		}
		]);
};
var $author$project$Strings$Translations$time_ago = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return '' + (time + ' ago');
			case 1:
				return 'hace ' + (time + '');
			case 2:
				return '{{过去';
			case 3:
				return 'Il y a ' + (time + '');
			default:
				return '' + (time + ' 전');
		}
	});
var $author$project$Utils$Time$distanceTimeInWords = F2(
	function (userLanguage, time) {
		var str = A3(
			$elm$core$List$foldl,
			$elm$core$Basics$append,
			'',
			A2(
				$elm$core$List$intersperse,
				', ',
				A3(
					$elm$core$List$foldl,
					F2(
						function (_v0, _v1) {
							var singleName = _v0.bx;
							var pluralName = _v0.bs;
							var len = _v0.bn;
							var currEls = _v1.a;
							var remaining = _v1.b;
							if ((_Utils_cmp(remaining, len) > 0) && ($elm$core$List$length(currEls) < 2)) {
								var amt = (remaining / len) | 0;
								var name = (amt === 1) ? singleName : pluralName;
								var el = $elm$core$String$fromInt(amt) + (' ' + name);
								return _Utils_Tuple2(
									A2($elm$core$List$cons, el, currEls),
									remaining - (amt * len));
							} else {
								return _Utils_Tuple2(currEls, remaining);
							}
						}),
					_Utils_Tuple2(
						_List_Nil,
						$elm$core$Basics$abs(time)),
					$author$project$Utils$Time$timeElements(userLanguage)).a));
		return (time < 0) ? A2($author$project$Strings$Translations$time_ago, userLanguage, str) : str;
	});
var $author$project$Governance$AccountProfile$emptyTransactionRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row transactions-panel__transaction-row--empty')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__action transactions-panel__transaction-row__action--empty')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('—')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-5 col-sm-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time transactions-panel__transaction-row__time--empty')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('—')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 col-sm-4 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--empty')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('—')
						]))
				]))
		]));
var $author$project$Eth$Ethereum$etherscanUrl = F2(
	function (network, urlValue) {
		var _v0 = function () {
			switch (urlValue.$) {
				case 0:
					var suffix = urlValue.a;
					return _Utils_Tuple2('tx', suffix);
				case 1:
					var suffix = urlValue.a;
					return _Utils_Tuple2('token', suffix);
				default:
					var suffix = urlValue.a;
					return _Utils_Tuple2('address', suffix);
			}
		}();
		var linkType = _v0.a;
		var linkValue = _v0.b;
		switch (network) {
			case 1:
				return $elm$core$Maybe$Just('https://etherscan.io/' + (linkType + ('/' + linkValue)));
			case 4:
				return $elm$core$Maybe$Just('https://rinkeby.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 7:
				return $elm$core$Maybe$Just('https://kovan.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 3:
				return $elm$core$Maybe$Just('https://ropsten.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 5:
				return $elm$core$Maybe$Just('https://goerli.etherscan.io/' + (linkType + ('/' + linkValue)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Eth$Ethereum$etherscanLink = F3(
	function (maybeNetwork, value, attributes) {
		if (!maybeNetwork.$) {
			var network = maybeNetwork.a;
			var _v1 = A2($author$project$Eth$Ethereum$etherscanUrl, network, value);
			if (!_v1.$) {
				var etherscanLinkVal = _v1.a;
				return $elm$html$Html$a(
					A2(
						$elm$core$List$cons,
						$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
						_Utils_ap(
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, etherscanLinkVal),
							attributes)));
			} else {
				return $elm$html$Html$a(attributes);
			}
		} else {
			return $elm$html$Html$a(attributes);
		}
	});
var $author$project$Governance$AccountProfile$loadingTransactionRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row transactions-panel__transaction-row--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__action transactions-panel__transaction-row__action--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-5 col-sm-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time transactions-panel__transaction-row__time--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 col-sm-4 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--loading')
						]),
					_List_Nil)
				]))
		]));
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Strings$Translations$result = function (lang) {
	switch (lang) {
		case 0:
			return 'Result';
		case 1:
			return 'Resultado';
		case 2:
			return '结果';
		case 3:
			return 'Résultat';
		default:
			return '결과';
	}
};
var $ryannhg$date_format$DateFormat$AmPmLowercase = {$: 23};
var $ryannhg$date_format$DateFormat$amPmLowercase = $ryannhg$date_format$DateFormat$AmPmLowercase;
var $ryannhg$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryannhg$date_format$DateFormat$dayOfMonthSuffix = $ryannhg$date_format$DateFormat$DayOfMonthSuffix;
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {nc: toAmPm, nd: toMonthAbbreviation, ne: toMonthName, cv: toOrdinalSuffix, ng: toWeekdayAbbreviation, nh: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.jJ, posixMinutes) < 0) {
					return posixMinutes + era.i8;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.nc(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		hT: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		i1: month,
		ke: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hT;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).i1;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ke;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.nd(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.ne(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.ng(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.nh(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.cv(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$HourNumber = {$: 26};
var $ryannhg$date_format$DateFormat$hourNumber = $ryannhg$date_format$DateFormat$HourNumber;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $ryannhg$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryannhg$date_format$DateFormat$monthNameFull = $ryannhg$date_format$DateFormat$MonthNameFull;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $author$project$Eth$Transaction$transactionDateFormatter = function (timeZone) {
	return A2(
		$ryannhg$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryannhg$date_format$DateFormat$monthNameFull,
				$ryannhg$date_format$DateFormat$text(' '),
				$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
				$ryannhg$date_format$DateFormat$text(', '),
				$ryannhg$date_format$DateFormat$hourNumber,
				$ryannhg$date_format$DateFormat$text(':'),
				$ryannhg$date_format$DateFormat$minuteFixed,
				$ryannhg$date_format$DateFormat$amPmLowercase
			]),
		timeZone);
};
var $author$project$Eth$Ethereum$TransactionHash = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$AccountProfile$transactionRow = F5(
	function (network, title, time, delta, trxHash) {
		var deltaSection = A2($author$project$Decimal$eq, $author$project$Decimal$zero, delta) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--no-change')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('0.00')
				])) : (A2($author$project$Decimal$lt, delta, $author$project$Decimal$zero) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--decrease')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
						2,
						false,
						$author$project$Decimal$abs(delta)))
				])) : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--increase')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 2, false, delta))
				])));
		return A4(
			$author$project$Eth$Ethereum$etherscanLink,
			$elm$core$Maybe$Just(network),
			$author$project$Eth$Ethereum$TransactionHash(trxHash),
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-5 col-sm-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(time)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 col-sm-4 text-right')
						]),
					_List_fromArray(
						[deltaSection]))
				]));
	});
var $author$project$Strings$Translations$transactions = function (lang) {
	switch (lang) {
		case 0:
			return 'Transactions';
		case 1:
			return 'Actas';
		case 2:
			return '交易次数';
		case 3:
			return 'Transactions';
		default:
			return '트랜잭션';
	}
};
var $author$project$Strings$Translations$view_more = function (lang) {
	switch (lang) {
		case 0:
			return 'View More';
		case 1:
			return 'Ver más';
		case 2:
			return '查看更多';
		case 3:
			return 'Voir plus';
		default:
			return '더 보기';
	}
};
var $author$project$Governance$AccountProfile$compTransactionsPanel = F5(
	function (userLanguage, timezone, maybeCurrentTime, network, model) {
		var _v0 = function () {
			var _v1 = model.aK;
			switch (_v1.$) {
				case 0:
					var compAccount = _v1.a;
					return _Utils_Tuple3(
						compAccount.hd,
						A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
									]),
								A2($elm$core$List$repeat, 4, $author$project$Governance$AccountProfile$emptyTransactionRow)),
							A2(
								$elm$core$Maybe$map,
								function (transactionDeltas) {
									var transactionsToShow = A2(
										$elm$core$List$take,
										4,
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (_v2) {
													var title = _v2.nb;
													var timestamp = _v2.na;
													var trx_hash = _v2.nz;
													var delta = _v2.k2;
													var timeString = A2(
														$elm$core$Maybe$withDefault,
														A2($author$project$Eth$Transaction$transactionDateFormatter, timezone, timestamp),
														A2(
															$elm$core$Maybe$map,
															function (currentTime) {
																return A2(
																	$author$project$Utils$Time$distanceTimeInWords,
																	userLanguage,
																	A2($author$project$Utils$Time$differenceInSeconds, timestamp, currentTime));
															},
															maybeCurrentTime));
													return A5($author$project$Governance$AccountProfile$transactionRow, network, title, timeString, delta, trx_hash);
												},
												A2($elm$core$List$take, 4, transactionDeltas)),
											A2($elm$core$List$repeat, 4, $author$project$Governance$AccountProfile$emptyTransactionRow)));
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
											]),
										transactionsToShow);
								},
								compAccount.ny)),
						A2($elm$core$Maybe$withDefault, _List_Nil, compAccount.ny));
				case 1:
					return _Utils_Tuple3(
						'',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
								]),
							A2($elm$core$List$repeat, 4, $author$project$Governance$AccountProfile$emptyTransactionRow)),
						_List_Nil);
				default:
					return _Utils_Tuple3(
						'',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
								]),
							A2($elm$core$List$repeat, 4, $author$project$Governance$AccountProfile$loadingTransactionRow)),
						_List_Nil);
			}
		}();
		var address = _v0.a;
		var compTransactions = _v0.b;
		var allTransactions = _v0.c;
		var viewAllRow = ($elm$core$List$length(allTransactions) > 4) ? A4(
			$author$project$Eth$Ethereum$etherscanLink,
			$elm$core$Maybe$Just(network),
			$author$project$Eth$Ethereum$EtherscanAddress(address),
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Strings$Translations$view_more(userLanguage))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer governance-panel__footer--disabled')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Strings$Translations$view_more(userLanguage))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$transactions(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 text-left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$action(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-5 col-sm-5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$age(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 col-sm-3 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$result(userLanguage))
										]))
								]))
						])),
					compTransactions,
					viewAllRow
				]));
	});
var $author$project$Strings$Translations$address = function (lang) {
	switch (lang) {
		case 0:
			return 'Address';
		case 1:
			return 'Habla a';
		case 2:
			return '地址';
		case 3:
			return 'Adresse';
		default:
			return '주소';
	}
};
var $author$project$Strings$Translations$details = function (lang) {
	switch (lang) {
		case 0:
			return 'Details';
		case 1:
			return 'Detalles';
		case 2:
			return '细节';
		case 3:
			return 'Détails';
		default:
			return '세부 사항';
	}
};
var $author$project$Strings$Translations$proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposals';
		case 1:
			return 'Propuestas';
		case 2:
			return '提案';
		case 3:
			return 'Les propositions';
		default:
			return '제안서';
	}
};
var $author$project$LandingSite$Page$getInPageBackTitleHref = F2(
	function (userLanguage, previousPage) {
		switch (previousPage.$) {
			case 13:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$leaderboard(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceLeaderboard));
			case 12:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$proposals(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceProposalOverview));
			case 11:
				var proposalId = previousPage.a;
				return _Utils_Tuple2(
					$author$project$Strings$Translations$details(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceProposalDetail(proposalId)));
			case 9:
				var address = previousPage.a;
				return _Utils_Tuple2(
					$author$project$Strings$Translations$address(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(address)));
			default:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$overview(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome));
		}
	});
var $author$project$Strings$Translations$comp_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Comp Balance';
		case 1:
			return 'Balance de compensación';
		case 2:
			return 'Comp偿余额';
		case 3:
			return 'Balance de comp';
		default:
			return '보상 잔액';
	}
};
var $author$project$Strings$Translations$delegating_to = function (lang) {
	switch (lang) {
		case 0:
			return 'Delegating To';
		case 1:
			return 'Delegar a';
		case 2:
			return '委托给';
		case 3:
			return 'Délégation à';
		default:
			return '투표권 대리인';
	}
};
var $author$project$Utils$NumberFormatter$interestRateAsPercentage = function (interestRate) {
	return A2(
		$author$project$Decimal$round,
		-2,
		A2(
			$author$project$Decimal$mul,
			interestRate,
			$author$project$Decimal$fromInt(100)));
};
var $author$project$Utils$NumberFormatter$formatPercentage = function (decimalValue) {
	return A3(
		$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		2,
		false,
		$author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue)) + '%';
};
var $author$project$Utils$NumberFormatter$tokenDecimalPlaces = 4;
var $author$project$Utils$NumberFormatter$formatTokenBalance = function (decimalValue) {
	var roundedValue = A2($author$project$Decimal$round, -$author$project$Utils$NumberFormatter$tokenDecimalPlaces, decimalValue);
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return _Utils_ap(
		signString,
		A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, $author$project$Utils$NumberFormatter$tokenDecimalPlaces, true, absoluteDecimalValue));
};
var $author$project$Strings$Translations$holdings = function (lang) {
	switch (lang) {
		case 0:
			return 'Holdings';
		case 1:
			return 'Valores en cartera';
		case 2:
			return '控股公司';
		case 3:
			return 'Exploitations';
		default:
			return '보유 현황';
	}
};
var $author$project$Strings$Translations$learn_more = function (lang) {
	switch (lang) {
		case 0:
			return 'Learn more';
		case 1:
			return 'Aprende más';
		case 2:
			return '学到更多';
		case 3:
			return 'Apprendre encore plus';
		default:
			return '자세히 알아보기';
	}
};
var $author$project$Strings$Translations$self = function (lang) {
	switch (lang) {
		case 0:
			return 'Self';
		case 1:
			return 'Yo';
		case 2:
			return '自';
		case 3:
			return 'Soi';
		default:
			return '본인';
	}
};
var $author$project$Eth$Ethereum$shortenedAddressString = F3(
	function (numberOfDigitsLeft, numberOfDigitsRight, address) {
		return A2($elm$core$String$left, numberOfDigitsLeft + 2, address) + ('...' + A2($elm$core$String$right, numberOfDigitsRight, address));
	});
var $author$project$Strings$Translations$undelegated = function (lang) {
	switch (lang) {
		case 0:
			return 'Undelegated';
		case 1:
			return 'No delegado';
		case 2:
			return '未授权';
		case 3:
			return 'Non déléguée';
		default:
			return '위임하지 않음';
	}
};
var $author$project$Strings$Translations$votes = function (lang) {
	switch (lang) {
		case 0:
			return 'Votes';
		case 1:
			return 'Votos';
		case 2:
			return '投票数';
		case 3:
			return 'Votes';
		default:
			return '투표 수';
	}
};
var $author$project$Strings$Translations$votes_received_description = function (lang) {
	switch (lang) {
		case 0:
			return 'If you have over 100,000 votes, you are able to create a proposal.';
		case 1:
			return 'Si tiene más de 100,000 votos, puede crear una propuesta.';
		case 2:
			return '如果您的投票数超过100,000，则可以创建提案。';
		case 3:
			return 'Si vous avez plus de 100 000 votes, vous pouvez créer une proposition.';
		default:
			return '투표권이 10 만 개 이상이면 제안서를 작성할 수 있습니다.';
	}
};
var $author$project$Governance$AccountProfile$holdingsPanel = F2(
	function (userLanguage, compAccount) {
		var votes = $author$project$Utils$NumberFormatter$formatTokenBalance(compAccount.nI);
		var proposalThreshold = $author$project$Decimal$fromInt(100000);
		var voteWeight = A2($author$project$Decimal$gt, compAccount.nI, proposalThreshold) ? '100%' : $author$project$Utils$NumberFormatter$formatPercentage(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Decimal$zero,
				A2($author$project$Decimal$fastdiv, compAccount.nI, proposalThreshold)));
		var votesBar = function () {
			var formattedVotes = A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, compAccount.nI);
			var formattedThreshold = A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, proposalThreshold);
			var docsUrl = $author$project$LandingSite$Page$getHrefUrl(
				A2($author$project$LandingSite$Page$Docs, 3, $elm$core$Maybe$Nothing));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('tooltip')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight__fill'),
										A2($author$project$Utils$CompoundHtmlAttributes$style, 'width', voteWeight)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text__headline')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(formattedVotes),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight__separator')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(' / ')
													])),
												$elm$html$Html$text(formattedThreshold)
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text__subtext holdings-panel__holdings__row__vote-weight__tooltip')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$votes_received_description(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text__link'),
													$author$project$Utils$CompoundHtmlAttributes$target('__blank')
												]),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, docsUrl)),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$learn_more(userLanguage))
											]))
									]))
							]))
					]));
		}();
		var delegateDisplayName = _Utils_eq(compAccount.k$.hd, $author$project$Eth$Ethereum$zeroAddress) ? $author$project$Strings$Translations$undelegated(userLanguage) : (_Utils_eq(compAccount.hd, compAccount.k$.hd) ? $author$project$Strings$Translations$self(userLanguage) : A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, compAccount.k$.hd),
			compAccount.k$.h_));
		var balance = $author$project$Utils$NumberFormatter$formatTokenBalance(compAccount.kr);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 holdings-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$holdings(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$comp_balance(userLanguage))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(balance)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__votes-label')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$votes(userLanguage))
														])),
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__votes-label__icon'),
															$author$project$Utils$CompoundHtmlAttributes$src('/images/icon-avatar.svg')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(compAccount.nt))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(votes)
												])),
											votesBar
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$delegating_to(userLanguage))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(delegateDisplayName)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Governance$AccountProfile$loadingHoldingsPanel = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 holdings-panel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$holdings(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label holdings-panel__holdings__row__label--loading')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value holdings-panel__holdings__row__value--loading')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label holdings-panel__holdings__row__label--loading')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value holdings-panel__holdings__row__value--loading')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight holdings-panel__holdings__row__vote-weight--loading')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label holdings-panel__holdings__row__label--loading')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value holdings-panel__holdings__row__value--loading')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$Governance$AccountProfile$loadingProfileHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('profile-header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image gov-profile-image--large gov-profile-image--loading')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__display-name profile-header__details__display-name--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__address profile-header__details__address--loading')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Governance$CommonViews$pageHeader = F4(
	function (backText, backUrl, headerView, maybeDetailsSection) {
		var detailsSection = function () {
			if (!maybeDetailsSection.$) {
				var detailSection_ = maybeDetailsSection.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('page-header__detail-section')
						]),
					_List_fromArray(
						[detailSection_]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('page-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section__back'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 0, backUrl)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('small page-header__main-section__back__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(backText)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section__title')
								]),
							_List_fromArray(
								[headerView]))
						])),
					detailsSection
				]));
	});
var $author$project$Governance$AccountProfile$CopyMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Governance$AccountProfile$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$AccountProfile$ImageError = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Utils$GovProfileImageHelper$Large = 2;
var $author$project$Decimal$gte = F2(
	function (a, b) {
		return A2($author$project$Decimal$gt, a, b) || A2($author$project$Decimal$eq, a, b);
	});
var $author$project$Utils$GovProfileImageHelper$ProfileImageError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$GovProfileImageHelper$Small = 0;
var $author$project$Utils$CompoundHtmlAttributes$onError = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'error',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Utils$GovProfileImageHelper$profileImage = function (_v0) {
	var maybeProfileImageUrl = _v0.lS;
	var address = _v0.hd;
	var size = _v0.by;
	var showProposerIcon = _v0.mH;
	var useLightStyle = _v0.nE;
	var proposerIcon = function () {
		if (showProposerIcon) {
			var extraProposerIconSizeClass = (!size) ? ' gov-profile-image__proposer-icon--small' : '';
			var extraProposerIconLightClass = useLightStyle ? ' gov-profile-image__proposer-icon--light' : '';
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image__proposer-icon' + (extraProposerIconSizeClass + extraProposerIconLightClass))
					]),
				_List_Nil);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var profileImageUrl = A2($elm$core$Maybe$withDefault, '/images/icn-default-avatar-large.svg', maybeProfileImageUrl);
	var extraClass = function () {
		switch (size) {
			case 0:
				return ' gov-profile-image--small';
			case 1:
				return '';
			default:
				return ' gov-profile-image--large';
		}
	}();
	var elementId = 'img-' + address;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image' + extraClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id(elementId),
						$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image__raw-image'),
						$author$project$Utils$CompoundHtmlAttributes$src(profileImageUrl),
						$author$project$Utils$CompoundHtmlAttributes$onError(
						A2($author$project$Utils$GovProfileImageHelper$ProfileImageError, elementId, '/images/icn-default-avatar-large.svg'))
					]),
				_List_Nil),
				proposerIcon
			]));
};
var $author$project$Governance$AccountProfile$profileHeader = F5(
	function (address, maybeDisplayName, maybeImageUrl, maybeOrgUrl, votes) {
		var profileImageComponent = A2(
			$elm$html$Html$map,
			function (profileImageMsg) {
				var profileElementId = profileImageMsg.a;
				var defaultImage = profileImageMsg.b;
				return A2($author$project$Governance$AccountProfile$ImageError, profileElementId, defaultImage);
			},
			$author$project$Utils$GovProfileImageHelper$profileImage(
				{
					hd: address,
					lS: maybeImageUrl,
					mH: A2(
						$author$project$Decimal$gte,
						votes,
						$author$project$Decimal$fromInt(100000)),
					by: 2,
					nE: false
				}));
		var orgUrlButton = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (orgUrl) {
					return A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link'),
									$author$project$Utils$CompoundHtmlAttributes$target('_blank')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, orgUrl)),
						_List_Nil);
				},
				maybeOrgUrl));
		var displayName = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, address),
			maybeDisplayName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('profile-header')
				]),
			_List_fromArray(
				[
					profileImageComponent,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__display-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(displayName),
									orgUrlButton
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__address')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(address),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--copy mobile-hide'),
											$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
											$author$project$Governance$AccountProfile$CopyMsg(address))
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$rank = function (lang) {
	switch (lang) {
		case 0:
			return 'Rank';
		case 1:
			return 'Rango';
		case 2:
			return '排名';
		case 3:
			return 'Rang';
		default:
			return '순위';
	}
};
var $author$project$Governance$AccountProfile$rankPane = F2(
	function (userLanguage, maybeRank) {
		return A2(
			$elm$core$Maybe$map,
			function (rank) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('rank-pane')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('rank-pane__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('rank-pane__number')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(rank))
								]))
						]));
			},
			maybeRank);
	});
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Governance$AccountProfile$VoteReceiptsPagerNext = {$: 5};
var $author$project$Governance$AccountProfile$VoteReceiptsPagerPrevious = {$: 4};
var $author$project$Strings$Translations$next = function (lang) {
	switch (lang) {
		case 0:
			return 'Next';
		case 1:
			return 'próximo';
		case 2:
			return '下一个';
		case 3:
			return 'Prochain';
		default:
			return '다음';
	}
};
var $author$project$Strings$Translations$prev = function (lang) {
	switch (lang) {
		case 0:
			return 'Prev';
		case 1:
			return 'Anterior';
		case 2:
			return '上一个';
		case 3:
			return 'Précédent';
		default:
			return '이전';
	}
};
var $author$project$Strings$Translations$against = function (lang) {
	switch (lang) {
		case 0:
			return 'Against';
		case 1:
			return 'En contra';
		case 2:
			return '反对';
		case 3:
			return 'Contre';
		default:
			return '반대';
	}
};
var $author$project$Strings$Translations$for = function (lang) {
	switch (lang) {
		case 0:
			return 'For';
		case 1:
			return 'Por';
		case 2:
			return '赞成';
		case 3:
			return 'Pour';
		default:
			return '찬성';
	}
};
var $author$project$Strings$Translations$canceled_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Canceled ' + (time + '');
			case 1:
				return 'Cancelado ' + (time + '');
			case 2:
				return '已取消' + (time + '');
			case 3:
				return 'Annulé ' + (time + '');
			default:
				return '취소: ' + (time + '');
		}
	});
var $author$project$Strings$Translations$ends_on = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Ends on ' + (time + '');
			case 1:
				return 'Finaliza el ' + (time + '');
			case 2:
				return '于' + (time + '结束');
			case 3:
				return 'Se termine le ' + (time + '');
			default:
				return '종료 시간: ' + (time + '');
		}
	});
var $author$project$Strings$Translations$executed_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Executed ' + (time + '');
			case 1:
				return 'Ejecutado ' + (time + '');
			case 2:
				return '已执行' + (time + '');
			case 3:
				return 'Exécuté ' + (time + '');
			default:
				return '실행: ' + (time + '');
		}
	});
var $author$project$Strings$Translations$expired_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Expired ' + (time + '');
			case 1:
				return 'Cancelado ' + (time + '');
			case 2:
				return '已取消' + (time + '');
			case 3:
				return 'Temps expiré}}';
			default:
				return '만료: ' + (time + '');
		}
	});
var $author$project$Strings$Translations$failed_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Failed ' + (time + '');
			case 1:
				return 'Falló ' + (time + '');
			case 2:
				return '' + (time + '失败');
			case 3:
				return 'Échec ' + (time + '');
			default:
				return '부결: ' + (time + '');
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Strings$Translations$proposal_state_active = function (lang) {
	switch (lang) {
		case 0:
			return 'Active';
		case 1:
			return 'Activo';
		case 2:
			return '活性';
		case 3:
			return 'actif';
		default:
			return '활성화';
	}
};
var $author$project$Strings$Translations$proposal_state_failed = function (lang) {
	switch (lang) {
		case 0:
			return 'Failed';
		case 1:
			return 'Ha fallado';
		case 2:
			return '失败的';
		case 3:
			return 'Échoué';
		default:
			return '부결';
	}
};
var $author$project$Strings$Translations$proposal_state_passed = function (lang) {
	switch (lang) {
		case 0:
			return 'Passed';
		case 1:
			return 'Pasado';
		case 2:
			return '已通过';
		case 3:
			return 'Réussi';
		default:
			return '가결';
	}
};
var $author$project$Strings$Translations$proposal_state_pending = function (lang) {
	switch (lang) {
		case 0:
			return 'Pending';
		case 1:
			return 'Pendiente';
		case 2:
			return '待定';
		case 3:
			return 'En attente';
		default:
			return '보류';
	}
};
var $author$project$Strings$Translations$queued_time = F2(
	function (lang, time_queued) {
		switch (lang) {
			case 0:
				return 'Queued ' + (time_queued + '');
			case 1:
				return 'En cola ' + (time_queued + '');
			case 2:
				return '已排队' + (time_queued + '');
			case 3:
				return 'Mis en file d\'attente ' + (time_queued + '');
			default:
				return '대기: ' + (time_queued + '');
		}
	});
var $author$project$Strings$Translations$succeeded_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Succeeded ' + (time + '');
			case 1:
				return 'Sucedido ' + (time + '');
			case 2:
				return '成功' + (time + '');
			case 3:
				return 'Réussi ' + (time + '');
			default:
				return '성공: ' + (time + '');
		}
	});
var $author$project$Strings$Translations$time_left = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return '' + (time + ' left');
			case 1:
				return '' + (time + ' restante');
			case 2:
				return '{{剩下的时间';
			case 3:
				return '{{temps restant';
			default:
				return '' + (time + ' 남음');
		}
	});
var $ryannhg$date_format$DateFormat$YearNumber = {$: 16};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $author$project$Governance$CommonViews$proposalContentView = F5(
	function (userLanguage, timezone, maybeCurrentTime, _v0, asHeader) {
		var id = _v0.ir;
		var title = _v0.nb;
		var states = _v0.jM;
		var stateTimeFormatter = A2(
			$ryannhg$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryannhg$date_format$DateFormat$monthNameFull,
					$ryannhg$date_format$DateFormat$text(' '),
					$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
					$ryannhg$date_format$DateFormat$text(', '),
					$ryannhg$date_format$DateFormat$yearNumber
				]),
			timezone);
		var maybeCurrentState = $elm$core$List$head(
			$elm$core$List$reverse(states));
		var _v1 = asHeader ? _Utils_Tuple3(' proposal__content--header', ' proposal__content__description__title--header', ' proposal__content__description__details--large') : _Utils_Tuple3('', '', '');
		var headerContentClass = _v1.a;
		var headerTitleClass = _v1.b;
		var headerDetailsClass = _v1.c;
		if (!maybeCurrentState.$) {
			var currentState = maybeCurrentState.a;
			var prependZeros = function (value) {
				return ($elm$core$String$length(value) < 3) ? prependZeros(
					A2($elm$core$String$cons, '0', value)) : value;
			};
			var _v3 = function () {
				var _v4 = currentState.jL;
				if (_v4 === 1) {
					var timeString = function () {
						var _v5 = _Utils_Tuple2(maybeCurrentTime, currentState.lb);
						if (!_v5.b.$) {
							if (!_v5.a.$) {
								var currentTime = _v5.a.a;
								var endTime = _v5.b.a;
								var difference = A2($author$project$Utils$Time$differenceInSeconds, endTime, currentTime);
								return A2(
									$author$project$Strings$Translations$time_left,
									userLanguage,
									A2($author$project$Utils$Time$distanceTimeInWords, userLanguage, difference));
							} else {
								var endTime = _v5.b.a;
								return A2(
									$author$project$Strings$Translations$ends_on,
									userLanguage,
									stateTimeFormatter(endTime));
							}
						} else {
							return '';
						}
					}();
					var pulse = asHeader ? $elm$html$Html$text('') : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('pulsating-dot proposal__content__pulsating-dot mobile-hide')
							]),
						_List_Nil);
					return _Utils_Tuple3(
						pulse,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposal_state_active(userLanguage))
								])),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text proposal__content__description__details__text--active')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											prependZeros(
												$elm$core$String$fromInt(id)))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('•')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(timeString)
										]))
								])));
				} else {
					var states_ = A2(
						$elm$core$List$map,
						function ($) {
							return $.jL;
						},
						states);
					var tag_ = A2($elm$core$List$member, 2, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_passed(userLanguage))
							])) : (A2($elm$core$List$member, 3, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_failed(userLanguage))
							])) : (A2($elm$core$List$member, 6, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_failed(userLanguage))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_pending(userLanguage))
							]))));
					var detailsText_ = function () {
						var _v6 = currentState.jL;
						switch (_v6) {
							case 0:
								if (!maybeCurrentTime.$) {
									var currentTime = maybeCurrentTime.a;
									var difference = A2($author$project$Utils$Time$differenceInSeconds, currentState.mL, currentTime);
									return A2(
										$author$project$Strings$Translations$time_left,
										userLanguage,
										A2($author$project$Utils$Time$distanceTimeInWords, userLanguage, difference));
								} else {
									return A2(
										$author$project$Strings$Translations$ends_on,
										userLanguage,
										stateTimeFormatter(currentState.mL));
								}
							case 2:
								return A2(
									$author$project$Strings$Translations$succeeded_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							case 3:
								return A2(
									$author$project$Strings$Translations$failed_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							case 4:
								return A2(
									$author$project$Strings$Translations$queued_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							case 5:
								return A2(
									$author$project$Strings$Translations$executed_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							case 6:
								return A2(
									$author$project$Strings$Translations$canceled_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							case 7:
								return A2(
									$author$project$Strings$Translations$expired_time,
									userLanguage,
									stateTimeFormatter(currentState.mL));
							default:
								return '';
						}
					}();
					return _Utils_Tuple3(
						$elm$html$Html$text(''),
						tag_,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text proposal__content__description__details__text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											prependZeros(
												$elm$core$String$fromInt(id)))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('•')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(detailsText_)
										]))
								])));
				}
			}();
			var pulsatingDot = _v3.a;
			var tag = _v3.b;
			var detailsText = _v3.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__content' + headerContentClass)
					]),
				_List_fromArray(
					[
						pulsatingDot,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__title' + headerTitleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details' + headerDetailsClass)
									]),
								_List_fromArray(
									[tag, detailsText]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Utils$NumberFormatter$formatPercentageToNearestWhole = function (decimalValue) {
	return A3(
		$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		0,
		false,
		$author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue)) + '%';
};
var $author$project$Governance$CommonViews$proposalReceiptVoteTallies = function (_v0) {
	var for_votes = _v0.$8;
	var against_votes = _v0.hh;
	var totalVotes = A2($author$project$Decimal$add, for_votes, against_votes);
	var forPercent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Decimal$zero,
		A2($author$project$Decimal$fastdiv, for_votes, totalVotes));
	var againstPercent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Decimal$zero,
		A2($author$project$Decimal$fastdiv, against_votes, totalVotes));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes mobile-hide')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar__fill proposal__receipt-votes__row__vote-bar__fill--for'),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(forPercent))
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar__fill proposal__receipt-votes__row__vote-bar__fill--against'),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(againstPercent))
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Governance$CommonViews$proposalReceiptRow = F4(
	function (userLanguage, timezone, maybeCurrentTime, proposalVoteReceipt) {
		var _v0 = proposalVoteReceipt.jp;
		if (!_v0.$) {
			var proposal = _v0.a;
			var detailView = proposalVoteReceipt.gO ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support proposal__receipt-support--for')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support__text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$for(userLanguage))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support proposal__receipt-support--against')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support__text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$against(userLanguage))
							]))
					]));
			return A2(
				$elm$html$Html$a,
				A2(
					$elm$core$List$cons,
					$author$project$Utils$CompoundHtmlAttributes$class('proposal'),
					A2(
						$author$project$Utils$CompoundHtmlAttributes$href,
						0,
						$author$project$LandingSite$Page$getHrefUrl(
							$author$project$LandingSite$Page$GovernanceProposalDetail(proposal.ir)))),
				_List_fromArray(
					[
						A5($author$project$Governance$CommonViews$proposalContentView, userLanguage, timezone, maybeCurrentTime, proposal, false),
						$author$project$Governance$CommonViews$proposalReceiptVoteTallies(proposal),
						detailView
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Strings$Translations$voting_history = function (lang) {
	switch (lang) {
		case 0:
			return 'Voting History';
		case 1:
			return 'Historial de votación';
		case 2:
			return '投票历史';
		case 3:
			return 'Historique du vote';
		default:
			return '투표 내역';
	}
};
var $author$project$Governance$AccountProfile$votingHistoryPanel = F4(
	function (userLanguage, timezone, maybeCurrentTime, _v0) {
		var compAccountState = _v0.aK;
		var currentVoteReceiptPageNumber = _v0.bO;
		var maybeTotalVoteReceipts = _v0.eh;
		var voteReceiptsPageMap = _v0.dA;
		if (!compAccountState.$) {
			var voteReceiptsForPage = function () {
				var _v2 = A2($elm$core$Dict$get, currentVoteReceiptPageNumber, voteReceiptsPageMap);
				if (!_v2.$) {
					var voteReceipts = _v2.a;
					return A2(
						$elm$core$List$map,
						A3($author$project$Governance$CommonViews$proposalReceiptRow, userLanguage, timezone, maybeCurrentTime),
						voteReceipts);
				} else {
					return _List_Nil;
				}
			}();
			var totalPages = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (totalVoteReceipts) {
						return $elm$core$Basics$ceiling(totalVoteReceipts / $author$project$Governance$AccountProfile$desiredPageSize);
					},
					maybeTotalVoteReceipts));
			var pagerFooter = function () {
				if (totalPages > 1) {
					var prevButton = (currentVoteReceiptPageNumber > 1) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__previous'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$AccountProfile$VoteReceiptsPagerPrevious)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$prev(userLanguage))
									]))
							])) : A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]));
					var pagerIndicator = A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator')
							]),
						A2(
							$elm$core$List$map,
							function (i) {
								var activeClass = _Utils_eq(currentVoteReceiptPageNumber, i) ? ' governance-panel__pager__indicator__text--active' : '';
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator__text' + activeClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(i))
										]));
							},
							A2($elm$core$List$range, 1, totalPages)));
					var nextButton = (_Utils_cmp(currentVoteReceiptPageNumber, totalPages) < 0) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__next'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$AccountProfile$VoteReceiptsPagerNext)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$next(userLanguage))
									]))
							])) : A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]));
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager')
							]),
						_List_fromArray(
							[prevButton, pagerIndicator, nextButton]));
				} else {
					return $elm$html$Html$text('');
				}
			}();
			return ($elm$core$List$length(voteReceiptsForPage) > 0) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$voting_history(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposals')
							]),
						voteReceiptsForPage),
						pagerFooter
					])) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Governance$AccountProfile$view = F7(
	function (userLanguage, backPage, targetAccountAddress, timezone, maybeCurrentTime, network, model) {
		var _v0 = A2($author$project$LandingSite$Page$getInPageBackTitleHref, userLanguage, backPage);
		var inPageHeaderTitle = _v0.a;
		var inPageHeaderHref = _v0.b;
		var _v1 = function () {
			var _v2 = model.aK;
			switch (_v2.$) {
				case 0:
					var compAccount = _v2.a;
					var address = compAccount.hd;
					var display_name = compAccount.h_;
					var image_url = compAccount.is;
					var account_url = compAccount.g9;
					var rank = compAccount.mt;
					var votes = compAccount.nI;
					return _Utils_Tuple3(
						A5($author$project$Governance$AccountProfile$profileHeader, address, display_name, image_url, account_url, votes),
						A2($author$project$Governance$AccountProfile$rankPane, userLanguage, rank),
						A2($author$project$Governance$AccountProfile$holdingsPanel, userLanguage, compAccount));
				case 1:
					return _Utils_Tuple3(
						A5($author$project$Governance$AccountProfile$profileHeader, targetAccountAddress, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $author$project$Decimal$zero),
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Governance$AccountProfile$holdingsPanel,
							userLanguage,
							$author$project$Governance$AccountProfile$compAccountNotFound(targetAccountAddress)));
				default:
					return _Utils_Tuple3(
						$author$project$Governance$AccountProfile$loadingProfileHeader,
						$elm$core$Maybe$Nothing,
						$author$project$Governance$AccountProfile$loadingHoldingsPanel(userLanguage));
			}
		}();
		var profileHeaderView = _v1.a;
		var rankPaneView = _v1.b;
		var holdingsPanelView = _v1.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Account-Profile')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A4($author$project$Governance$CommonViews$pageHeader, inPageHeaderTitle, inPageHeaderHref, profileHeaderView, rankPaneView)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('account-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											holdingsPanelView,
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 transactions-panel')
												]),
											_List_fromArray(
												[
													A5($author$project$Governance$AccountProfile$compTransactionsPanel, userLanguage, timezone, maybeCurrentTime, network, model)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 voting-history-panel')
												]),
											_List_fromArray(
												[
													A4($author$project$Governance$AccountProfile$votingHistoryPanel, userLanguage, timezone, maybeCurrentTime, model)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 comp-distribution-panel')
												]),
											_List_fromArray(
												[
													A2($author$project$Governance$AccountProfile$compDistributionPanel, userLanguage, model)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$compound_governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Governance';
		case 1:
			return 'Gobierno compuesto';
		case 2:
			return 'Compound 治理';
		case 3:
			return 'Gouvernance composée';
		default:
			return 'Compound 거버넌스';
	}
};
var $author$project$Strings$Translations$compound_governance_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound is managed by a decentralized community of COMP token-holders and their delegates, who propose and vote on upgrades to the protocol.';
		case 1:
			return 'El compuesto es administrado por una comunidad descentralizada de poseedores de tokens COMP y sus delegados, quienes proponen y votan sobre las actualizaciones del protocolo.';
		case 2:
			return 'Compound由COMP token持有人及其代表的去中心化社区管理，他们对协议的升级提出建议并进行投票。';
		case 3:
			return 'Compound est géré par une communauté décentralisée de détenteurs de jetons COMP et de leurs délégués, qui proposent et votent les mises à niveau du protocole.';
		default:
			return 'Compound는 COMP 토큰 보유자와 그들의 대리인으로 구성된 탈중앙화된 커뮤니티에 의해 운영되며, 이들은 프로토콜 업그레이드를 제안하고 투표에 참여합니다.';
	}
};
var $author$project$Governance$Home$educationalOverviewContent = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('educational-overview')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('gov-description'),
								$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$compound_governance(userLanguage))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$compound_governance_overview(userLanguage))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										A2(
											$elm$core$List$cons,
											$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/compound-governance-5531f524cf68')),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$learn_more(userLanguage))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
												$author$project$Utils$CompoundHtmlAttributes$class('arrow')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('gov-image'),
								$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$id('gov-illo')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Strings$Translations$governance_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance Overview';
		case 1:
			return 'Resumen de gobernanza';
		case 2:
			return '治理概况';
		case 3:
			return 'Aperçu de la gouvernance';
		default:
			return '거버넌스 개요';
	}
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Governance$CommonViews$loadingProposalRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('proposal proposal--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposal__content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__title proposal__content__description__title--loading')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details proposal__content__description__details--loading')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--loading')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text__time--loading')
												]),
											_List_Nil)
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--loading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text--loading')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Strings$Translations$no_active_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'No proposals have been created.';
		case 1:
			return 'No se han creado propuestas.';
		case 2:
			return '尚未创建提案。';
		case 3:
			return 'Aucune proposition n\'a été créée.';
		default:
			return '신규 제안서가 없습니다.';
	}
};
var $author$project$Governance$CommonViews$noProposalsRow = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal proposal--empty')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$no_active_proposals(userLanguage))
					]))
			]));
};
var $author$project$Decimal$one = $author$project$Decimal$fromInt(1);
var $author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions = F2(
	function (currencySymbol, decimalValue) {
		var thousandsValue = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2(
				$author$project$Decimal$fastdiv,
				decimalValue,
				$author$project$Decimal$fromInt(1000)));
		var millionsValue = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2(
				$author$project$Decimal$fastdiv,
				decimalValue,
				$author$project$Decimal$fromInt(1000000)));
		var _v0 = A2($author$project$Decimal$gt, millionsValue, $author$project$Decimal$one) ? _Utils_Tuple3(millionsValue, 2, 'M') : _Utils_Tuple3(thousandsValue, 0, 'k');
		var scaledValueToUse = _v0.a;
		var roundedDecimals = _v0.b;
		var valueSuffix = _v0.c;
		var _v1 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(scaledValueToUse);
		var signString = _v1.a;
		var absoluteRoundedValue = _v1.b;
		return _Utils_ap(
			signString,
			_Utils_ap(
				currencySymbol,
				_Utils_ap(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, roundedDecimals, false, absoluteRoundedValue),
					valueSuffix)));
	});
var $author$project$Governance$CommonViews$proposalActiveTalliesView = F2(
	function (_v0, _v1) {
		var for_votes = _v1.$8;
		var against_votes = _v1.hh;
		var totalVotes = A2($author$project$Decimal$add, for_votes, against_votes);
		var forPercent = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, for_votes, totalVotes));
		var againstPercent = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, against_votes, totalVotes));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar__fill proposal__active-votes__row__vote-bar__fill--for'),
											A2(
											$author$project$Utils$CompoundHtmlAttributes$style,
											'width',
											$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(forPercent))
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '', for_votes))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar__fill proposal__active-votes__row__vote-bar__fill--against'),
											A2(
											$author$project$Utils$CompoundHtmlAttributes$style,
											'width',
											$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(againstPercent))
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '', against_votes))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$proposal_state_canceled = function (lang) {
	switch (lang) {
		case 0:
			return 'Canceled';
		case 1:
			return 'Cancelado';
		case 2:
			return '取消';
		case 3:
			return 'Annulé';
		default:
			return '취소';
	}
};
var $author$project$Strings$Translations$proposal_state_executed = function (lang) {
	switch (lang) {
		case 0:
			return 'Executed';
		case 1:
			return 'Ejecutado';
		case 2:
			return '已执行';
		case 3:
			return 'Réalisé';
		default:
			return '실행';
	}
};
var $author$project$Strings$Translations$proposal_state_expired = function (lang) {
	switch (lang) {
		case 0:
			return 'Expired';
		case 1:
			return 'Caducado';
		case 2:
			return '已过期';
		case 3:
			return 'Expiré';
		default:
			return '만료';
	}
};
var $author$project$Strings$Translations$proposal_state_queued = function (lang) {
	switch (lang) {
		case 0:
			return 'Queued';
		case 1:
			return 'Puesto en cola';
		case 2:
			return '排队';
		case 3:
			return 'En file d\'attente';
		default:
			return '대기';
	}
};
var $author$project$Governance$CommonViews$proposalRow = F4(
	function (userLanguage, timezone, maybeCurrentTime, proposal) {
		var maybeCurrentState = $elm$core$List$head(
			$elm$core$List$reverse(proposal.jM));
		var detailView = function () {
			if (!maybeCurrentState.$) {
				var currentState = maybeCurrentState.a;
				var _v1 = currentState.jL;
				switch (_v1) {
					case 0:
						return $elm$html$Html$text('');
					case 1:
						return A2($author$project$Governance$CommonViews$proposalActiveTalliesView, userLanguage, proposal);
					case 2:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_passed(userLanguage))
												]))
										]))
								]));
					case 3:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_failed(userLanguage))
												]))
										]))
								]));
					case 4:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_queued(userLanguage))
												]))
										]))
								]));
					case 5:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_executed(userLanguage))
												]))
										]))
								]));
					case 6:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_canceled(userLanguage))
												]))
										]))
								]));
					default:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_expired(userLanguage))
												]))
										]))
								]));
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('proposal'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceProposalDetail(proposal.ir)))),
			_List_fromArray(
				[
					A5($author$project$Governance$CommonViews$proposalContentView, userLanguage, timezone, maybeCurrentTime, proposal, false),
					detailView
				]));
	});
var $author$project$Strings$Translations$recent_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Recent Proposals';
		case 1:
			return 'Propuestas activas';
		case 2:
			return '最新提案';
		case 3:
			return 'Propositions récentes';
		default:
			return '최근 제안서';
	}
};
var $author$project$Strings$Translations$view_all_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'View All Proposals';
		case 1:
			return 'Ver todas las propuestas';
		case 2:
			return '查看所有提案';
		case 3:
			return 'Voir toutes les propositions';
		default:
			return '모든 제안서 보기';
	}
};
var $author$project$Governance$Home$importantProposalsPane = F4(
	function (userLanguage, timezone, maybeCurrentTime, model) {
		var latestProposalsAndViewAll = function () {
			var _v0 = model.c0;
			switch (_v0.$) {
				case 0:
					var proposals = _v0.a.jq;
					if (!proposals.b) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposals')
									]),
								_List_fromArray(
									[
										$author$project$Governance$CommonViews$noProposalsRow(userLanguage)
									]))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposals')
									]),
								A2(
									$elm$core$List$map,
									function (proposal) {
										return A4($author$project$Governance$CommonViews$proposalRow, userLanguage, timezone, maybeCurrentTime, proposal);
									},
									proposals)),
								A2(
								$elm$html$Html$a,
								A2(
									$elm$core$List$cons,
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
									A2(
										$author$project$Utils$CompoundHtmlAttributes$href,
										0,
										$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceProposalOverview))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$view_all_proposals(userLanguage))
									]))
							]);
					}
				case 2:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposals')
								]),
							A2($elm$core$List$repeat, 3, $author$project$Governance$CommonViews$loadingProposalRow)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer  governance-panel__footer--disabled')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$view_all_proposals(userLanguage))
								]))
						]);
				default:
					return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('important-proposals-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$recent_proposals(userLanguage))
										]))
								])),
						latestProposalsAndViewAll))
				]));
	});
var $author$project$Strings$Translations$comp_distributed = function (lang) {
	switch (lang) {
		case 0:
			return 'COMP Distributed';
		case 1:
			return 'COMP distribuido';
		case 2:
			return 'COMP分布式';
		case 3:
			return 'COMP distribué';
		default:
			return '분배된 COMP';
	}
};
var $author$project$Strings$Translations$comp_remaining = function (lang) {
	switch (lang) {
		case 0:
			return 'COMP Remaining';
		case 1:
			return 'COMP restante';
		case 2:
			return '剩余COMP';
		case 3:
			return 'COMP Restant';
		default:
			return '미분배 COMP 수량';
	}
};
var $author$project$Strings$Translations$view = function (lang) {
	switch (lang) {
		case 0:
			return 'View';
		case 1:
			return 'Ver';
		case 2:
			return '视图';
		case 3:
			return 'Vue';
		default:
			return '보기';
	}
};
var $author$project$Governance$Home$compDistributionPanel = F2(
	function (userLanguage, model) {
		var content = function () {
			var _v0 = model.bW;
			switch (_v0.$) {
				case 0:
					var govHistory = _v0.a;
					var initialComp = $author$project$Decimal$fromInt(4229949);
					var remainingComp = A2($author$project$Decimal$sub, initialComp, govHistory.nr);
					var remainingCompPercentage = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2($author$project$Decimal$fastdiv, remainingComp, initialComp));
					return A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$id('comp-distribution-panel'),
									$author$project$Utils$CompoundHtmlAttributes$class('content'),
									$author$project$Utils$CompoundHtmlAttributes$target('_blank')
								]),
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Comp))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('headline')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, remainingComp))
											])),
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$comp_remaining(userLanguage))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('comp-remaining-view')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('view-action')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('action-text')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$view(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
														$author$project$Utils$CompoundHtmlAttributes$class('arrow')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('comp-remaining__bar')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('comp-remaining__bar__fill'),
														A2(
														$author$project$Utils$CompoundHtmlAttributes$style,
														'width',
														$author$project$Utils$NumberFormatter$formatPercentage(remainingCompPercentage))
													]),
												_List_Nil)
											]))
									]))
							]));
				case 1:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('...')
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$comp_distributed(userLanguage))
									]))
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('headline headline--loading')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('panel__label panel__label--loading')
									]),
								_List_Nil)
							]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 col-xs-12')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Governance$Home$loadingOverviewHeaderPanel = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('headline headline--loading')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('panel__label panel__label--loading')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Governance$Home$overviewHeaderPanel = function (_v0) {
	var headlineText = _v0.a;
	var labelText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('headline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(headlineText)
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(labelText)
									]))
							]))
					]))
			]));
};
var $author$project$Strings$Translations$votes_delegated = function (lang) {
	switch (lang) {
		case 0:
			return 'Votes Delegated';
		case 1:
			return 'Voto delegado';
		case 2:
			return '委托投票';
		case 3:
			return 'Votes délégués';
		default:
			return '위임된 투표 수';
	}
};
var $author$project$Strings$Translations$voting_addresses = function (lang) {
	switch (lang) {
		case 0:
			return 'Voting Addresses';
		case 1:
			return 'Direcciones de votación';
		case 2:
			return '投票地址';
		case 3:
			return 'Adresses de vote';
		default:
			return '투표 주소';
	}
};
var $author$project$Governance$Home$overviewHeader = F2(
	function (userLanguage, model) {
		var panels = A2(
			$elm$core$List$cons,
			A2($author$project$Governance$Home$compDistributionPanel, userLanguage, model),
			function () {
				var _v0 = model.bW;
				switch (_v0.$) {
					case 0:
						var govHistory = _v0.a;
						return A2(
							$elm$core$List$map,
							$author$project$Governance$Home$overviewHeaderPanel,
							_List_fromArray(
								[
									_Utils_Tuple2(
									A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, true, govHistory.nJ),
									$author$project$Strings$Translations$votes_delegated(userLanguage)),
									_Utils_Tuple2(
									$elm$core$String$fromInt(govHistory.nK),
									$author$project$Strings$Translations$voting_addresses(userLanguage))
								]));
					case 1:
						return A2(
							$elm$core$List$map,
							$author$project$Governance$Home$overviewHeaderPanel,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'...',
									$author$project$Strings$Translations$votes_delegated(userLanguage)),
									_Utils_Tuple2(
									'...',
									$author$project$Strings$Translations$voting_addresses(userLanguage))
								]));
					default:
						return A2($elm$core$List$repeat, 2, $author$project$Governance$Home$loadingOverviewHeaderPanel);
				}
			}());
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('dashboard-overview'),
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			panels);
	});
var $author$project$Governance$CommonViews$DelegateSummary = F8(
	function (address, display_name, image_url, votes, vote_weight, proposals_created, proposals_voted, rank) {
		return {hd: address, h_: display_name, is: image_url, mq: proposals_created, mr: proposals_voted, mt: rank, nH: vote_weight, nI: votes};
	});
var $author$project$Governance$Home$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$Home$ImageError = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Governance$CommonViews$delegateSummaryRow = F3(
	function (_v0, onImageErrorMsg, delegateSummary) {
		var profileImageComponent = A2(
			$elm$html$Html$map,
			function (profileImageMsg) {
				var profileElementId = profileImageMsg.a;
				var defaultImage = profileImageMsg.b;
				return A2(onImageErrorMsg, profileElementId, defaultImage);
			},
			$author$project$Utils$GovProfileImageHelper$profileImage(
				{
					hd: delegateSummary.hd,
					lS: delegateSummary.is,
					mH: A2(
						$author$project$Decimal$gte,
						delegateSummary.nI,
						$author$project$Decimal$fromInt(100000)),
					by: 0,
					nE: true
				}));
		var mobileDisplayName = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, delegateSummary.hd),
			delegateSummary.h_);
		var displayName = A2($elm$core$Maybe$withDefault, delegateSummary.hd, delegateSummary.h_);
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(delegateSummary.hd)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__rank-view')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__rank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(delegateSummary.mt))
												]))
										])),
									profileImageComponent,
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name mobile-hide')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(displayName)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name delegatee-summary__details__display-name--mobile')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(mobileDisplayName)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatTokenBalance(delegateSummary.nI))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatPercentage(delegateSummary.nH))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(delegateSummary.mr))
						]))
				]));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Governance$CommonViews$loadingDelegateSummaryRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary delegatee-summary--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__rank-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__rank delegatee-summary__details__rank--loading')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image gov-profile-image--small gov-profile-image--loading')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name delegatee-summary__details__display-name--loading mobile-hide')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name delegatee-summary__details__display-name--loading delegatee-summary__details__display-name--mobile')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide delegatee-summary__votes-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__votes-view__votes--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right delegatee-summary__vote-weight-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__vote-weight-view__vote-weight--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide delegatee-summary__proposals-created-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__proposals-created-view__proposals-created--loading')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Strings$Translations$no_top_addresses = function (lang) {
	switch (lang) {
		case 0:
			return 'No votes have been delegated.';
		case 1:
			return 'No se han delegado votos.';
		case 2:
			return '没有投票被委派。';
		case 3:
			return 'Aucun vote n\'a été délégué.';
		default:
			return '위임된 투표가 없습니다.';
	}
};
var $author$project$Governance$CommonViews$noDelegateSummaryRow = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary delegatee-summary--empty')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$no_top_addresses(userLanguage))
					]))
			]));
};
var $author$project$Strings$Translations$proposals_voted = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposals Voted';
		case 1:
			return 'Propuestas Votadas';
		case 2:
			return '提案已投票';
		case 3:
			return 'Propositions votées';
		default:
			return '투표 참여 횟수';
	}
};
var $author$project$Strings$Translations$top_addresses_by_voting_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Top Addresses by Voting Weight';
		case 1:
			return 'Direcciones principales por peso de votación';
		case 2:
			return '投票权重排序';
		case 3:
			return 'Principales adresses par poids de vote';
		default:
			return '투표 가중치 별 상위 주소';
	}
};
var $author$project$Strings$Translations$view_leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'View Leaderboard';
		case 1:
			return 'Ver tabla de clasificación';
		case 2:
			return '查看排行榜';
		case 3:
			return 'Afficher le classement';
		default:
			return '순위표 보기';
	}
};
var $author$project$Strings$Translations$vote_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Vote Weight';
		case 1:
			return 'Peso del voto';
		case 2:
			return '投票权重';
		case 3:
			return 'Poids du vote';
		default:
			return '투표 가중치';
	}
};
var $author$project$Governance$Home$topAddressesPane = F2(
	function (userLanguage, model) {
		var topFiveAddressRowsAndViewAll = function () {
			var _v0 = model.ds;
			switch (_v0.$) {
				case 0:
					var topDelegates = _v0.a;
					var onImageErrorMsg = F2(
						function (elementId, imgSrc) {
							return A2($author$project$Governance$Home$ImageError, elementId, imgSrc);
						});
					var importantDelegates = A2(
						$elm$core$List$map,
						A2($author$project$Governance$CommonViews$delegateSummaryRow, userLanguage, onImageErrorMsg),
						A2(
							$elm$core$List$filterMap,
							function (compAccount) {
								var _v1 = compAccount.mt;
								if (!_v1.$) {
									var actualRank = _v1.a;
									return $elm$core$Maybe$Just(
										A8($author$project$Governance$CommonViews$DelegateSummary, compAccount.hd, compAccount.h_, compAccount.is, compAccount.nI, compAccount.nH, compAccount.mq, compAccount.mr, actualRank));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							topDelegates.ha));
					return ($elm$core$List$length(importantDelegates) > 0) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
								]),
							importantDelegates),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceLeaderboard))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$view_leaderboard(userLanguage))
								]))
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
								]),
							_List_fromArray(
								[
									$author$project$Governance$CommonViews$noDelegateSummaryRow(userLanguage)
								]))
						]);
				case 2:
					return _Utils_ap(
						A2($elm$core$List$repeat, 5, $author$project$Governance$CommonViews$loadingDelegateSummaryRow),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer governance-panel__footer--disabled')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$view_leaderboard(userLanguage))
									]))
							]));
				default:
					return _List_Nil;
			}
		}();
		var columnHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$vote_weight(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposals_voted(userLanguage))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('top-addresses-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$top_addresses_by_voting_weight(userLanguage))
											]))
									])),
								columnHeaders
							]),
						topFiveAddressRowsAndViewAll))
				]));
	});
var $author$project$Governance$Home$view = F4(
	function (userLanguage, timezone, maybeCurrentTime, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$governance_overview(userLanguage))
										])),
									A2($author$project$Governance$Home$overviewHeader, userLanguage, model)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A4($author$project$Governance$Home$importantProposalsPane, userLanguage, timezone, maybeCurrentTime, model),
											A2($author$project$Governance$Home$topAddressesPane, userLanguage, model),
											$author$project$Governance$Home$educationalOverviewContent(userLanguage)
										]))
								]))
						]))
				]));
	});
var $author$project$Governance$Leaderboard$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$Leaderboard$ImageError = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Strings$Translations$addresses_by_voting_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Addresses by Voting Weight';
		case 1:
			return 'Direcciones por peso de votación';
		case 2:
			return '投票权重排序';
		case 3:
			return 'Adresses par poids de vote';
		default:
			return '투표 가중치 기준 주소 정렬';
	}
};
var $author$project$Governance$Leaderboard$leaderboardAddressesPane = F2(
	function (userLanguage, model) {
		var onImageErrorMsg = F2(
			function (elementId, imgSrc) {
				return A2($author$project$Governance$Leaderboard$ImageError, elementId, imgSrc);
			});
		var delegateeAddressRows = function () {
			var _v0 = model.dr;
			switch (_v0.$) {
				case 0:
					var topDelegates = _v0.a;
					return A2(
						$elm$core$List$map,
						A2($author$project$Governance$CommonViews$delegateSummaryRow, userLanguage, onImageErrorMsg),
						A2(
							$elm$core$List$filterMap,
							function (compAccount) {
								var _v1 = compAccount.mt;
								if (!_v1.$) {
									var actualRank = _v1.a;
									return $elm$core$Maybe$Just(
										A8($author$project$Governance$CommonViews$DelegateSummary, compAccount.hd, compAccount.h_, compAccount.is, compAccount.nI, compAccount.nH, compAccount.mq, compAccount.mr, actualRank));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							topDelegates.ha));
				case 2:
					return A2($elm$core$List$repeat, 15, $author$project$Governance$CommonViews$loadingDelegateSummaryRow);
				default:
					return _List_Nil;
			}
		}();
		var columnHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$vote_weight(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposals_voted(userLanguage))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('top-addresses-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$addresses_by_voting_weight(userLanguage))
										]))
								])),
							columnHeaders,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
								]),
							delegateeAddressRows)
						]))
				]));
	});
var $author$project$Governance$Leaderboard$view = F2(
	function (userLanguage, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Leaderboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									$author$project$Strings$Translations$overview(userLanguage),
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome),
									A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$leaderboard(userLanguage))
											])),
									$elm$core$Maybe$Nothing)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2($author$project$Governance$Leaderboard$leaderboardAddressesPane, userLanguage, model)
										]))
								]))
						]))
				]));
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.mB) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.mn)));
};
var $author$project$Governance$ProposalDetail$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.i5;
				var value = _v0.cA;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v1) {
			var rawDecoder = _v1;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (tagName, attributes, children) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	kt: $elm$html$Html$blockquote(_List_Nil),
	hA: function (_v0) {
		var body = _v0.kx;
		var language = _v0.fC;
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	hB: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	k9: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	lo: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	lp: function (_v1) {
		var level = _v1.lL;
		var children = _v1.kL;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	lv: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	lw: function (imageInfo) {
		var _v3 = imageInfo.nb;
		if (!_v3.$) {
			var title = _v3.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.mJ),
						$elm$html$Html$Attributes$alt(imageInfo.eI),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.mJ),
						$elm$html$Html$Attributes$alt(imageInfo.eI)
					]),
				_List_Nil);
		}
	},
	iM: F2(
		function (link, content) {
			var _v4 = link.nb;
			if (!_v4.$) {
				var title = _v4.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.hZ),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.hZ)
						]),
					content);
			}
		}),
	mc: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	jg: $elm$html$Html$p(_List_Nil),
	mN: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	m0: $elm$html$Html$table(_List_Nil),
	m1: $elm$html$Html$tbody(_List_Nil),
	m2: $elm$html$Html$td(_List_Nil),
	m3: $elm$html$Html$thead(_List_Nil),
	m4: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	m5: $elm$html$Html$tr(_List_Nil),
	m8: $elm$html$Html$text,
	m9: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	j5: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 10, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$Body = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return _Utils_update(
			state,
			{
				c4: A2($elm$core$List$cons, linkRef, state.c4)
			});
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 9};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.mJ);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.i8, offset) < 0,
					0,
					{hC: col, d: s0.d, j: s0.j, i8: offset, mB: row, mJ: s0.mJ});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.i8, s.mB, s.hC, s);
	};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $dillonkearns$elm_markdown$Helpers$isSpaceOrTab = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {hC: col, kV: contextStack, mn: problem, mB: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.mB, s.hC, x, s.d));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.i8, s.mB, s.hC, s.mJ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{hC: newCol, d: s.d, j: s.j, i8: newOffset, mB: newRow, mJ: s.mJ});
	};
};
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return $dillonkearns$elm_markdown$Helpers$isSpaceOrTab(c);
				})),
		$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'\n',
				$elm$parser$Parser$Expecting('\\n')))));
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.i8, s.mJ);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hC: 1, d: s.d, j: s.j, i8: s.i8 + 1, mB: s.mB + 1, mJ: s.mJ}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hC: s.hC + 1, d: s.d, j: s.j, i8: newOffset, mB: s.mB, mJ: s.mJ}));
		};
	});
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.i8, s.mB, s.hC, s.mJ);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.mJ) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.i8, adjustedOffset) < 0,
			0,
			{hC: newCol, d: s.d, j: s.j, i8: adjustedOffset, mB: newRow, mJ: s.mJ});
	};
};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.mJ),
			s.i8) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.i8, s1.i8, s0.mJ),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $dillonkearns$elm_markdown$Helpers$isNewline = function (character) {
	if ('\n' === character) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'   > ',
						$elm$parser$Parser$Expecting('   > '))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  > ',
						$elm$parser$Parser$Expecting('  > '))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' > ',
						$elm$parser$Parser$Expecting(' > '))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'> ',
						$elm$parser$Parser$Expecting('> '))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'   >',
						$elm$parser$Parser$Expecting('   >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting('>')))
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Problem('Expecting end')),
					A2(
					$elm$parser$Parser$Advanced$chompIf,
					$dillonkearns$elm_markdown$Helpers$isNewline,
					$elm$parser$Parser$Problem('Expecting newline'))
				]))));
var $dillonkearns$elm_markdown$Markdown$Parser$combine = function (list) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (parser, listParser) {
				return A2(
					$elm$parser$Parser$Advanced$andThen,
					function (soFar) {
						return A2(
							$elm$parser$Parser$Advanced$map,
							function (a) {
								return A2($elm$core$List$cons, a, soFar);
							},
							parser);
					},
					listParser);
			}),
		$elm$parser$Parser$Advanced$succeed(_List_Nil),
		list);
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$String$endsWith = _String_endsWith;
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Parser$dropTrailingHashes = function (headingString) {
	return A2($elm$core$String$endsWith, '#', headingString) ? $dillonkearns$elm_markdown$Markdown$Parser$dropTrailingHashes(
		$elm$core$String$trimRight(
			A2($elm$core$String$dropRight, 1, headingString))) : headingString;
};
var $dillonkearns$elm_markdown$Helpers$isSpacebar = function (c) {
	if (' ' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$Markdown$Parser$heading = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'#',
					$elm$parser$Parser$Expecting('#')))),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				function (additionalHashes) {
					var level = $elm$core$String$length(additionalHashes) + 1;
					return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
						$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
				},
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$elm$parser$Parser$Advanced$chompWhile(
							function (c) {
								if ('#' === c) {
									return true;
								} else {
									return false;
								}
							})))),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Helpers$isSpacebar))),
	A2(
		$elm$parser$Parser$Advanced$andThen,
		function (headingText) {
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$Parser$dropTrailingHashes(headingText));
		},
		$elm$parser$Parser$Advanced$getChompedString(
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				$elm$parser$Parser$Advanced$chompUntilEndOr('\n')))));
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Attribute = F2(
	function (name, value) {
		return {i5: name, cA: value};
	});
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {hC: col, d: context, mB: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {hC: s.hC, d: newContext, j: s.j, i8: s.i8, mB: s.mB, mJ: s.mJ};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.mB, s0.hC, context),
						s0.d),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.d, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$isUninteresting = function (c) {
	switch (c) {
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000D':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $elm$parser$Parser$BadRepeat = {$: 13};
var $dillonkearns$elm_markdown$HtmlParser$keep = F2(
	function (count, predicate) {
		var n = count;
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (str) {
				return (_Utils_cmp(
					n,
					$elm$core$String$length(str)) < 1) ? $elm$parser$Parser$Advanced$succeed(str) : $elm$parser$Parser$Advanced$problem($elm$parser$Parser$BadRepeat);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(0),
					$elm$parser$Parser$Advanced$chompWhile(predicate))));
	});
var $dillonkearns$elm_markdown$HtmlParser$AtLeast = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$HtmlParser$oneOrMore = 1;
var $dillonkearns$elm_markdown$HtmlParser$attributeName = A2(
	$elm$parser$Parser$Advanced$inContext,
	'attributeName',
	A2(
		$dillonkearns$elm_markdown$HtmlParser$keep,
		$dillonkearns$elm_markdown$HtmlParser$oneOrMore,
		function (c) {
			return (!$dillonkearns$elm_markdown$HtmlParser$isWhitespace(c)) && $dillonkearns$elm_markdown$HtmlParser$isUninteresting(c);
		}));
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$notSemiColon = function (c) {
	if (';' === c) {
		return false;
	} else {
		return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'escapedChar',
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (s) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$andThen,
							function (_v0) {
								var _v1 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(s);
								if (!_v1.$) {
									var c = _v1.a;
									return $elm$parser$Parser$Advanced$succeed(c);
								} else {
									var e = _v1.a;
									return $elm$parser$Parser$Advanced$problem(e);
								}
							},
							$dillonkearns$elm_markdown$HtmlParser$symbol(';')),
							$dillonkearns$elm_markdown$HtmlParser$fail('Entities must end_ with \";\": &' + s)
						]));
			},
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
				A2(
					$dillonkearns$elm_markdown$HtmlParser$keep,
					$dillonkearns$elm_markdown$HtmlParser$oneOrMore,
					function (c) {
						return (!_Utils_eq(c, end_)) && $dillonkearns$elm_markdown$HtmlParser$notSemiColon(c);
					}))));
};
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $dillonkearns$elm_markdown$HtmlParser$notAmpersand = function (c) {
	if ('&' === c) {
		return false;
	} else {
		return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$zeroOrMore = 0;
var $dillonkearns$elm_markdown$HtmlParser$textString = function (end_) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'textString',
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (s) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed(
									F2(
										function (c, t) {
											return _Utils_ap(
												s,
												A2($elm$core$String$cons, c, t));
										})),
								$dillonkearns$elm_markdown$HtmlParser$escapedChar(end_)),
							$elm$parser$Parser$Advanced$lazy(
								function (_v0) {
									return $dillonkearns$elm_markdown$HtmlParser$textString(end_);
								})),
							$elm$parser$Parser$Advanced$succeed(s)
						]));
			},
			A2(
				$dillonkearns$elm_markdown$HtmlParser$keep,
				$dillonkearns$elm_markdown$HtmlParser$zeroOrMore,
				function (c) {
					return (!_Utils_eq(c, end_)) && $dillonkearns$elm_markdown$HtmlParser$notAmpersand(c);
				})));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = A2(
	$elm$parser$Parser$Advanced$inContext,
	'attributeValue',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
					$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$textString('\''),
					$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
			])));
var $dillonkearns$elm_markdown$HtmlParser$ignore = F2(
	function (count, predicate) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return 0;
			},
			A2($dillonkearns$elm_markdown$HtmlParser$keep, count, predicate));
	});
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = A2($dillonkearns$elm_markdown$HtmlParser$ignore, $dillonkearns$elm_markdown$HtmlParser$zeroOrMore, $dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attribute = A2(
	$elm$parser$Parser$Advanced$inContext,
	'attribute',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Attribute),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
					$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$dillonkearns$elm_markdown$HtmlParser$attributeValue));
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $dillonkearns$elm_markdown$HtmlParser$attributes = function (keys) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (attrs) {
			return A2(
				$elm$core$List$map,
				function (attr) {
					return {
						i5: $elm$core$String$toLower(attr.i5),
						cA: attr.cA
					};
				},
				attrs);
		},
		A2(
			$elm$parser$Parser$Advanced$inContext,
			'attributes',
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$andThen,
						function (attr) {
							return A2($elm$core$Set$member, attr.i5, keys) ? $dillonkearns$elm_markdown$HtmlParser$fail('attribute ' + (attr.i5 + ' is duplicated')) : A2(
								$elm$parser$Parser$Advanced$keeper,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(
										$elm$core$List$cons(attr)),
									$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
								$dillonkearns$elm_markdown$HtmlParser$attributes(
									A2($elm$core$Set$insert, attr.i5, keys)));
						},
						$dillonkearns$elm_markdown$HtmlParser$attribute),
						$elm$parser$Parser$Advanced$succeed(_List_Nil)
					]))));
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$inContext,
	'cdata',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
			$dillonkearns$elm_markdown$HtmlParser$symbol(']]>'))));
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$map,
	function (name) {
		return $elm$core$String$toLower(name);
	},
	A2(
		$elm$parser$Parser$Advanced$inContext,
		'tagName',
		A2(
			$dillonkearns$elm_markdown$HtmlParser$keep,
			$dillonkearns$elm_markdown$HtmlParser$oneOrMore,
			function (c) {
				return (!$dillonkearns$elm_markdown$HtmlParser$isWhitespace(c)) && $dillonkearns$elm_markdown$HtmlParser$isUninteresting(c);
			})));
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'closingTag',
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed(0),
							$dillonkearns$elm_markdown$HtmlParser$symbol('</')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
					A2(
						$elm$parser$Parser$Advanced$andThen,
						function (endTagName) {
							return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
						},
						$dillonkearns$elm_markdown$HtmlParser$tagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = A2(
	$dillonkearns$elm_markdown$HtmlParser$keep,
	$dillonkearns$elm_markdown$HtmlParser$oneOrMore,
	function (c) {
		return $elm$core$Char$isUpper(c);
	});
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2($dillonkearns$elm_markdown$HtmlParser$ignore, $dillonkearns$elm_markdown$HtmlParser$oneOrMore, $dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$inContext,
	'declaration',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
				$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
			$dillonkearns$elm_markdown$HtmlParser$symbol('>'))));
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$inContext,
	'processingInstruction',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
			$dillonkearns$elm_markdown$HtmlParser$symbol('?>'))));
function $dillonkearns$elm_markdown$HtmlParser$cyclic$textNodeString() {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'textNodeString',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F2(
								function (s, maybeString) {
									return $elm$core$Maybe$Just(
										_Utils_ap(
											s,
											A2($elm$core$Maybe$withDefault, '', maybeString)));
								})),
						A2(
							$dillonkearns$elm_markdown$HtmlParser$keep,
							$dillonkearns$elm_markdown$HtmlParser$oneOrMore,
							function (c) {
								switch (c) {
									case '<':
										return false;
									case '&':
										return false;
									default:
										return true;
								}
							})),
					$elm$parser$Parser$Advanced$lazy(
						function (_v1) {
							return $dillonkearns$elm_markdown$HtmlParser$cyclic$textNodeString();
						})),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F2(
								function (c, maybeString) {
									return $elm$core$Maybe$Just(
										A2(
											$elm$core$String$cons,
											c,
											A2($elm$core$Maybe$withDefault, '', maybeString)));
								})),
						$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
					$elm$parser$Parser$Advanced$lazy(
						function (_v2) {
							return $dillonkearns$elm_markdown$HtmlParser$cyclic$textNodeString();
						})),
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
				])));
}
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $dillonkearns$elm_markdown$HtmlParser$cyclic$textNodeString();
$dillonkearns$elm_markdown$HtmlParser$cyclic$textNodeString = function () {
	return $dillonkearns$elm_markdown$HtmlParser$textNodeString;
};
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'children',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(_List_Nil),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
					A2(
					$elm$parser$Parser$Advanced$andThen,
					function (maybeString) {
						if (!maybeString.$) {
							var s = maybeString.a;
							return A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed(
									function (rest) {
										return A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$HtmlParser$Text(s),
											rest);
									}),
								$dillonkearns$elm_markdown$HtmlParser$children(startTagName));
						} else {
							return A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(_List_Nil),
								$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName));
						}
					},
					$dillonkearns$elm_markdown$HtmlParser$textNodeString),
					$elm$parser$Parser$Advanced$lazy(
					function (_v2) {
						return A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$keeper,
								$elm$parser$Parser$Advanced$succeed($elm$core$List$cons),
								$dillonkearns$elm_markdown$HtmlParser$cyclic$html()),
							$dillonkearns$elm_markdown$HtmlParser$children(startTagName));
					})
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'element',
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
			A2(
				$elm$parser$Parser$Advanced$andThen,
				function (startTagName) {
					return A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(
									$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
								$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$dillonkearns$elm_markdown$HtmlParser$attributes($elm$core$Set$empty),
								$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(_List_Nil),
									$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
									A2(
									$elm$parser$Parser$Advanced$keeper,
									A2(
										$elm$parser$Parser$Advanced$ignorer,
										$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
										$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
									$elm$parser$Parser$Advanced$lazy(
										function (_v0) {
											return $dillonkearns$elm_markdown$HtmlParser$children(startTagName);
										}))
								])));
				},
				$dillonkearns$elm_markdown$HtmlParser$tagName)));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'    ',
						$elm$parser$Parser$ExpectingSymbol('Indentation'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'\t',
						$elm$parser$Parser$ExpectingSymbol('Indentation')))
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'\n',
						$elm$parser$Parser$ExpectingSymbol('\\n'))),
					$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('End of input'))
				]))));
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			if (_v0.b === '') {
				return $elm$core$String$concat(
					_List_fromArray(
						[string1, string2]));
			} else {
				return $elm$core$String$concat(
					_List_fromArray(
						[string1, string2]));
			}
		} else {
			if (_v0.b === '') {
				return $elm$core$String$concat(
					_List_fromArray(
						[string1, string2]));
			} else {
				return $elm$core$String$concat(
					_List_fromArray(
						[string1, joinWith, string2]));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return $elm$core$String$concat(
			_List_fromArray(
				[string1, '\n', string2]));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$just = function (value) {
	return $elm$parser$Parser$Advanced$succeed(
		$elm$core$Maybe$Just(value));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$levelParser = function (level) {
	switch (level) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		case 5:
			return $elm$parser$Parser$Advanced$succeed(4);
		case 6:
			return $elm$parser$Parser$Advanced$succeed(5);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_markdown$Parser$Extra$oneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed(0),
		$dillonkearns$elm_markdown$Parser$Extra$oneOrMore($elm$core$Char$isDigit)));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Markdown$OrderedList$listMarkerParser = function () {
	var markerOption = function (marker) {
		return $elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					marker,
					$elm$parser$Parser$ExpectingSymbol(marker))));
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed($elm$core$Tuple$pair),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					markerOption('.'),
					markerOption(')')
				])));
}();
var $dillonkearns$elm_markdown$Markdown$OrderedList$openingItemParser = function (lastBlock) {
	var validateStartsWith1 = function (parsed) {
		if (parsed.a === 1) {
			return $elm$parser$Parser$Advanced$succeed(parsed);
		} else {
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
		}
	};
	var validateStartsWith1IfInParagraph = function (parsed) {
		if ((!lastBlock.$) && (lastBlock.a.$ === 1)) {
			return validateStartsWith1(parsed);
		} else {
			return $elm$parser$Parser$Advanced$succeed(parsed);
		}
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (_v0, item) {
						var startingIndex = _v0.a;
						var marker = _v0.b;
						return _Utils_Tuple3(startingIndex, marker, item);
					})),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					A2($elm$parser$Parser$Advanced$andThen, validateStartsWith1IfInParagraph, $dillonkearns$elm_markdown$Markdown$OrderedList$listMarkerParser)),
				$dillonkearns$elm_markdown$Parser$Extra$oneOrMore($dillonkearns$elm_markdown$Helpers$isSpacebar))),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'\n',
					$elm$parser$Parser$ExpectingSymbol('\n')))));
};
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.i8, s);
};
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$itemBody = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Parser$Extra$oneOrMore($dillonkearns$elm_markdown$Helpers$isSpacebar))),
				$elm$parser$Parser$Advanced$commit('')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$getChompedString(
					$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$elm$parser$Parser$Advanced$symbol(
							A2(
								$elm$parser$Parser$Advanced$Token,
								'\n',
								$elm$parser$Parser$ExpectingSymbol('\\n'))),
							$elm$parser$Parser$Advanced$end(
							$elm$parser$Parser$Expecting('End of input'))
						])))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(''),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'\n',
					$elm$parser$Parser$ExpectingSymbol('\\n'))))
		]));
var $dillonkearns$elm_markdown$Markdown$OrderedList$singleItemParser = function (listMarker) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Parser$Extra$positiveInteger,
					$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							listMarker,
							$elm$parser$Parser$ExpectingSymbol(listMarker)))))),
		$dillonkearns$elm_markdown$Markdown$OrderedList$itemBody);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp = F3(
	function (listMarker, firstItem, revStmts) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$keeper,
							$elm$parser$Parser$Advanced$succeed(
								F3(
									function (offsetBefore, stmt, offsetAfter) {
										return $elm$parser$Parser$Advanced$Loop(
											A2($elm$core$List$cons, stmt, revStmts));
									})),
							$elm$parser$Parser$Advanced$getOffset),
						$dillonkearns$elm_markdown$Markdown$OrderedList$singleItemParser(listMarker)),
					$elm$parser$Parser$Advanced$getOffset),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							A2(
								$elm$core$List$cons,
								firstItem,
								$elm$core$List$reverse(revStmts)));
					},
					$elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (lastBlock) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (_v0) {
			var startingIndex = _v0.a;
			var listMarker = _v0.b;
			var firstItem = _v0.c;
			return A2(
				$elm$parser$Parser$Advanced$map,
				function (items) {
					return _Utils_Tuple2(startingIndex, items);
				},
				A2(
					$elm$parser$Parser$Advanced$loop,
					_List_Nil,
					A2($dillonkearns$elm_markdown$Markdown$OrderedList$statementsHelp, listMarker, firstItem)));
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$openingItemParser(lastBlock));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (lastBlock) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var startingIndex = _v0.a;
			var unparsedLines = _v0.b;
			return A2(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
				startingIndex,
				A2($elm$core$List$map, $elm$core$Basics$identity, unparsedLines));
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(lastBlock));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$initParser = F2(
	function (refs, rawText) {
		return {b: _List_Nil, y: rawText, gt: refs, nk: _List_Nil};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.X;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.m8);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.m8);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.b));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.b));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		default:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.b));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return _Utils_update(
			childMatch,
			{h3: childMatch.h3 - parentMatch.ao, jJ: childMatch.jJ - parentMatch.ao, cs: childMatch.cs - parentMatch.ao, ao: childMatch.ao - parentMatch.ao});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return _Utils_update(
			parentMatch,
			{
				b: A2(
					$elm$core$List$cons,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
					parentMatch.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatch = F2(
	function (_v0, matches) {
		var match = _v0;
		if (!matches.b) {
			return _List_fromArray(
				[match]);
		} else {
			var prevMatch = matches.a;
			var matchesTail = matches.b;
			return (_Utils_cmp(prevMatch.h3, match.jJ) < 1) ? A2($elm$core$List$cons, match, matches) : (((_Utils_cmp(prevMatch.jJ, match.jJ) < 0) && (_Utils_cmp(prevMatch.h3, match.h3) > 0)) ? A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
				matchesTail) : matches);
		}
	});
function $dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy(
			function (_v0) {
				var match = _v0;
				return match.jJ;
			}),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatch, _List_Nil),
			$elm$core$List$map(
				function (_v1) {
					var match = _v1;
					return _Utils_update(
						match,
						{
							b: $dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches()(match.b)
						});
				})));
}
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = $dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches();
$dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$organizeMatches = function () {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeParserMatches = function (model) {
	return _Utils_update(
		model,
		{
			b: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(model.b)
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {a: index, fV: match, l2: number, gN: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hw: false, i4: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.fV,
		A2(
			$elm$core$Maybe$map,
			$dillonkearns$elm_markdown$Markdown$Entity$validUnicode,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.gN)))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.fV,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2($elm$core$Dict$get, a, $dillonkearns$elm_markdown$Markdown$Entity$entities);
				},
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					$elm$core$List$head(match.gN)))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.gN;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.fV;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toList,
		A2(
			$elm$core$List$foldl,
			F2(
				function (hexDigit, _int) {
					return ((_int * 16) + A2(
						$elm$core$Basics$modBy,
						39,
						$elm$core$Char$toCode(hexDigit))) - 9;
				}),
			0)));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	return A2(
		$elm$core$Maybe$withDefault,
		match.fV,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Entity$hexToInt, $dillonkearns$elm_markdown$Markdown$Entity$validUnicode),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				$elm$core$List$head(match.gN))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	return $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(
				$dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		h3: 0,
		b: _List_Nil,
		jJ: 0,
		m8: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		cs: 0,
		ao: 0,
		X: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = _Utils_update(
			matchModel,
			{
				b: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.m8, _List_Nil, matchModel.b)
			});
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.h3, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			return _Utils_eq(matchHead.X, $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : (_Utils_eq(matchModel.h3, matchHead.jJ) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.h3, matchHead.jJ) < 0) ? A2(
				$elm$core$List$cons,
				updtMatch,
				A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
						A3($elm$core$String$slice, matchModel.h3, matchHead.jJ, rawText)),
					parsedMatches)) : parsedMatches));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.jJ > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.jJ, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseText = function (model) {
	return _Utils_update(
		model,
		{
			b: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, model.y, _List_Nil, model.b)
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$CharToken = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.gN;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				a: regMatch.a + backslashesLength,
				fH: 1,
				e: $dillonkearns$elm_markdown$Markdown$InlineParser$CharToken('<')
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$RightAngleBracket = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.gN;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				a: regMatch.a + backslashesLength,
				fH: 1,
				e: $dillonkearns$elm_markdown$Markdown$InlineParser$RightAngleBracket(
					!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $dillonkearns$elm_markdown$Markdown$InlineParser$punctuationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[!-#%-\\*,-/:;\\?@\\[-\\]_\\{\\}]'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = $elm$regex$Regex$contains($dillonkearns$elm_markdown$Markdown$InlineParser$punctuationRegex);
var $dillonkearns$elm_markdown$Markdown$InlineParser$spaceRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\s'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = $elm$regex$Regex$contains($dillonkearns$elm_markdown$Markdown$InlineParser$spaceRegex);
var $dillonkearns$elm_markdown$Markdown$InlineParser$charFringeRank = function (_char) {
	var string = $elm$core$String$fromChar(_char);
	return $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$maybeCharFringeRank = function (maybeChar) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$InlineParser$charFringeRank, maybeChar));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$uncons,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$core$Tuple$first),
				$dillonkearns$elm_markdown$Markdown$InlineParser$maybeCharFringeRank))),
	$elm$core$Maybe$withDefault(0));
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.gN;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var leftFringeLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeLeftFringe));
			var mLeftFringe = ((!(!regMatch.a)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.a - 1, regMatch.a, rawText)) : maybeLeftFringe;
			var backslashesLength = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || _Utils_eq(
				mLeftFringe,
				$elm$core$Maybe$Just('\\'));
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var fringeRank = _Utils_Tuple2(
				isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe),
				$dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe));
			var index = ((regMatch.a + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
			return ((delimiterLength <= 0) || ((_char === '_') && _Utils_eq(
				fringeRank,
				_Utils_Tuple2(2, 2)))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{
					a: index,
					fH: delimiterLength,
					e: A2($dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken, _char, fringeRank)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.gN;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				a: regMatch.a + backslashesLength,
				fH: $elm$core$String$length(backtick),
				e: $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(
					!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.gN;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{a: (regMatch.a + backslashesLength) - 1, fH: 2, e: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							a: regMatch.a,
							fH: $elm$core$String$length(regMatch.fV),
							e: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.gN;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{a: regMatch.a + backslashesLength, fH: 1, e: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{a: (regMatch.a + backslashesLength) - 1, fH: 2, e: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							a: regMatch.a,
							fH: $elm$core$String$length(regMatch.fV),
							e: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.gN;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{
				a: regMatch.a + backslashesLength,
				fH: 1,
				e: $dillonkearns$elm_markdown$Markdown$InlineParser$CharToken(']')
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.gN;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var delimiter = _v2.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = (regMatch.a + backslashesLength) + ((isEscaped && _Utils_eq(
			maybeImageOpen,
			$elm$core$Maybe$Just('!'))) ? 1 : 0);
		var meaning = isEscaped ? A2(
			$elm$core$Maybe$map,
			function (_v3) {
				return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(true);
			},
			maybeImageOpen) : $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				$dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(true),
				A2(
					$elm$core$Maybe$map,
					function (_v4) {
						return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken;
					},
					maybeImageOpen)));
		var length = _Utils_eq(
			meaning,
			$elm$core$Maybe$Just($dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken)) ? 2 : 1;
		var toModel = function (m) {
			return {a: index, fH: length, e: m};
		};
		return A2($elm$core$Maybe$map, toModel, meaning);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (model) {
	return _Utils_update(
		model,
		{
			nk: A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.a;
				},
				_Utils_ap(
					$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(model.y),
					_Utils_ap(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(model.y),
						_Utils_ap(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(model.y),
							_Utils_ap(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(model.y),
								_Utils_ap(
									$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(model.y),
									_Utils_ap(
										$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(model.y),
										_Utils_ap(
											$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(model.y),
											$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(model.y)))))))))
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$addMatch = F2(
	function (model, match) {
		return _Utils_update(
			model,
			{
				b: A2($elm$core$List$cons, match, model.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addToken = F2(
	function (model, token) {
		return _Utils_update(
			model,
			{
				nk: A2($elm$core$List$cons, token, model.nk)
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM = F2(
	function (finderFunction, model) {
		return finderFunction(
			_Utils_Tuple2(
				model.nk,
				_Utils_update(
					model,
					{nk: _List_Nil})));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.fV,
				$elm$url$Url$percentDecode(match.fV));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.m8) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				X: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.m8,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.m8)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = function (_v0) {
	var rawUrl = _v0.a;
	var maybeTitle = _v0.b;
	return _Utils_Tuple2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
			$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
		A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
};
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F3(
	function (matchModel, model, regexMatch) {
		var _v0 = regexMatch.gN;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						h3: matchModel.h3 + $elm$core$String$length(regexMatch.fV),
						X: function () {
							var _v5 = matchModel.X;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							$dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(
								_Utils_Tuple2(rawUrl, maybeTitle)))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(remainText, tempMatch, model),
		A2(
			$elm$core$Maybe$map,
			$dillonkearns$elm_markdown$Markdown$InlineParser$addMatch(model),
			A2(
				$elm$core$Maybe$andThen,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, model),
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText)))));
};
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, model, maybeRegexMatch) {
		var regexMatchLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fV;
					},
					$elm$core$String$length),
				maybeRegexMatch));
		var toMatch = function (urlTitle) {
			return _Utils_update(
				matchModel,
				{
					h3: matchModel.h3 + regexMatchLength,
					X: function () {
						var _v0 = matchModel.X;
						if (_v0.$ === 5) {
							return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
						} else {
							return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
						}
					}()(
						$dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle(urlTitle))
				});
		};
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.m8 : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.m8,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.gN;
								},
								$elm$core$List$head),
							maybeRegexMatch)))));
		var maybeRefItem = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			model.gt);
		return A2($elm$core$Maybe$map, toMatch, maybeRefItem);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType = function (_v0) {
	var remainText = _v0.a;
	var tempMatch = _v0.b;
	var model = _v0.c;
	return A2(
		$elm$core$Result$fromMaybe,
		_Utils_Tuple3(remainText, tempMatch, model),
		A2(
			$elm$core$Maybe$map,
			$dillonkearns$elm_markdown$Markdown$InlineParser$addMatch(model),
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
				tempMatch,
				model,
				$elm$core$List$head(
					A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText)))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = function (parser) {
	var _v0 = parser.b;
	if (!_v0.b) {
		return $elm$core$Result$Err(0);
	} else {
		var match = _v0.a;
		var remainMatches = _v0.b;
		var overlappingMatches = A2(
			$elm$core$List$filter,
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.h3, testMatch.jJ) > 0) && (_Utils_cmp(match.h3, testMatch.h3) < 0);
			},
			remainMatches);
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(overlappingMatches)) ? $elm$core$Result$Ok(parser) : $elm$core$Result$Err(0);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.m8) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				X: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.m8,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.m8)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$filterTokens = F2(
	function (filter, model) {
		return _Utils_update(
			model,
			{
				nk: A2($elm$core$List$filter, filter, model.nk)
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		var search = F2(
			function (token, _v2) {
				var maybeToken = _v2.a;
				var innerTokens = _v2.b;
				var remainTokens = _v2.c;
				if (maybeToken.$ === 1) {
					return isToken(token) ? _Utils_Tuple3(
						$elm$core$Maybe$Just(token),
						innerTokens,
						_List_Nil) : _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, token, innerTokens),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						maybeToken,
						innerTokens,
						A2($elm$core$List$cons, token, remainTokens));
				}
			});
		var _return = function (_v0) {
			var maybeToken = _v0.a;
			var innerTokens = _v0.b;
			var remainTokens = _v0.c;
			return A2(
				$elm$core$Maybe$map,
				function (token) {
					return _Utils_Tuple3(
						token,
						$elm$core$List$reverse(innerTokens),
						$elm$core$List$reverse(remainTokens));
				},
				maybeToken);
		};
		return _return(
			A3(
				$elm$core$List$foldl,
				search,
				_Utils_Tuple3($elm$core$Maybe$Nothing, _List_Nil, _List_Nil),
				tokens));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$log = F2(
	function (label, value) {
		return value;
	});
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{hC: 1, d: _List_Nil, j: 1, i8: 0, mB: 1, mJ: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlFromRegex = F2(
	function (model, match) {
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {ip: htmlTag, fH: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$log,
				'dropped',
				A2(
					$elm$core$String$dropLeft,
					match.jJ,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$log, 'rawText', model.y))));
		var _v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$log, 'match', match);
		if (!parsed.$) {
			var htmlTag = parsed.a.ip;
			var length = parsed.a.fH;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, false, htmlTag);
			return $elm$core$Maybe$Just(
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$addToken,
					model,
					{a: match.jJ, fH: length, e: htmlToken}));
		} else {
			var error = parsed.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$log, 'error', error);
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (model, _v0) {
		var match = _v0;
		return A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlFromRegex, model, match);
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		return false;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.e;
		if (!_v0.$) {
			var isEscaped = _v0.a;
			return isEscaped ? _Utils_eq(openToken.fH - 1, closeToken.fH) : _Utils_eq(openToken.fH, closeToken.fH);
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.e;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.e;
		if (_v0.$ === 6) {
			var openChar = _v0.a;
			var _v1 = _v0.b;
			var openLR = _v1.a;
			var openRR = _v1.b;
			var _v2 = closeToken.e;
			if (_v2.$ === 6) {
				var closeChar = _v2.a;
				var _v3 = _v2.b;
				var closeLR = _v3.a;
				var closeRR = _v3.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(openLR, openRR) || _Utils_eq(closeLR, closeRR)) ? (!(!A2($elm$core$Basics$modBy, 3, closeToken.fH + openToken.fH))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isVoidTag = function (htmlModel) {
	return false;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$SoftLineBreakToken = {$: 7};
var $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens = function (model) {
	return _Utils_update(
		model,
		{
			nk: $elm$core$List$reverse(model.nk)
		});
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {h3: token.a + token.fH, b: _List_Nil, jJ: token.a, m8: '', cs: 0, ao: 0, X: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = function (_v0) {
	lineBreakTTM:
	while (true) {
		var tokens = _v0.a;
		var model = _v0.b;
		if (!tokens.b) {
			return $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			if (_Utils_eq(token.e, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken) || (_Utils_eq(token.e, $dillonkearns$elm_markdown$Markdown$InlineParser$SoftLineBreakToken) && $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak)) {
				return $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						_Utils_update(
							model,
							{
								b: A2(
									$elm$core$List$cons,
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
									model.b)
							})));
			} else {
				var $temp$_v0 = _Utils_Tuple2(
					tokensTail,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v0 = $temp$_v0;
				continue lineBreakTTM;
			}
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (tokensTail, parser) {
		var _v0 = parser.b;
		if (!_v0.b) {
			return _Utils_Tuple2(tokensTail, parser);
		} else {
			var match = _v0.a;
			return _Utils_Tuple2(
				A2(
					$elm$core$List$filter,
					function (token) {
						return _Utils_cmp(token.a, match.h3) > -1;
					},
					tokensTail),
				parser);
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F4(
	function (closeToken, isEscaped, model, _v24) {
		var openToken = _v24.a;
		var remainTokens = _v24.c;
		return function (result) {
			if (result.$ === 1) {
				var tempMatch = result.a;
				return (!isEscaped) ? A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken,
					_Utils_update(
						model,
						{nk: remainTokens}),
					tempMatch) : $elm$core$Result$toMaybe(result);
			} else {
				return $elm$core$Result$toMaybe(result);
			}
		}(
			A2(
				$elm$core$Result$map,
				function (newMatch) {
					return _Utils_update(
						model,
						{
							b: A2($elm$core$List$cons, newMatch, model.b),
							nk: remainTokens
						});
				},
				A2(
					$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
					$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
						A6(
							$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
							openToken,
							closeToken,
							_List_Nil)))));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = function (_v21) {
	codeAutolinkTypeHtmlTagTTM:
	while (true) {
		var tokens = _v21.a;
		var model = _v21.b;
		if (!tokens.b) {
			return $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v23 = token.e;
			switch (_v23.$) {
				case 0:
					var isEscaped = _v23.a;
					return $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$elm$core$Maybe$withDefault,
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token),
								A2(
									$elm$core$Maybe$map,
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, model),
									A2(
										$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
										$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
										model.nk)))));
				case 4:
					var isEscaped = _v23.a;
					return $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM(
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$filterTokens,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.e;
									},
									$elm$core$Basics$neq(
										$dillonkearns$elm_markdown$Markdown$InlineParser$CharToken('<'))),
								A2(
									$elm$core$Maybe$withDefault,
									model,
									A2(
										$elm$core$Maybe$andThen,
										A3($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, model),
										A2(
											$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.e;
												},
												$elm$core$Basics$eq(
													$dillonkearns$elm_markdown$Markdown$InlineParser$CharToken('<'))),
											model.nk))))));
				default:
					var $temp$_v21 = _Utils_Tuple2(
						tokensTail,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
					_v21 = $temp$_v21;
					continue codeAutolinkTypeHtmlTagTTM;
			}
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F3(
	function (closeToken, model, _v20) {
		var openToken = _v20.a;
		var remainTokens = _v20.c;
		var updtOpenToken = _Utils_eq(
			openToken.e,
			$dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(true)) ? _Utils_update(
			openToken,
			{a: openToken.a + 1, fH: openToken.fH - 1}) : openToken;
		return _Utils_update(
			model,
			{
				b: A2(
					$elm$core$List$cons,
					A6($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, model, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updtOpenToken, closeToken, _List_Nil),
					model.b),
				nk: remainTokens
			});
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = function (_v16) {
	emphasisTTM:
	while (true) {
		var tokens = _v16.a;
		var model = _v16.b;
		if (!tokens.b) {
			return $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v18 = token.e;
			if (_v18.$ === 6) {
				var _char = _v18.a;
				var _v19 = _v18.b;
				var leftRank = _v19.a;
				var rightRank = _v19.b;
				if (_Utils_eq(leftRank, rightRank)) {
					if ((!(!rightRank)) && ((_char !== '_') || (rightRank === 1))) {
						return $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									tokensTail,
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token)),
								A2(
									$elm$core$Maybe$map,
									A3($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
										$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.nk))));
					} else {
						var $temp$_v16 = _Utils_Tuple2(tokensTail, model);
						_v16 = $temp$_v16;
						continue emphasisTTM;
					}
				} else {
					if (_Utils_cmp(leftRank, rightRank) < 0) {
						var $temp$_v16 = _Utils_Tuple2(
							tokensTail,
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
						_v16 = $temp$_v16;
						continue emphasisTTM;
					} else {
						return $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM(
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(tokensTail, model),
								A2(
									$elm$core$Maybe$map,
									A3($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, token, tokensTail, model),
									A2(
										$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
										$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
										model.nk))));
					}
				}
			} else {
				var $temp$_v16 = _Utils_Tuple2(
					tokensTail,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v16 = $temp$_v16;
				continue emphasisTTM;
			}
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F4(
	function (closeToken, tokensTail, model, _v15) {
		var openToken = _v15.a;
		var innerTokens = _v15.b;
		var remainTokens = _v15.c;
		var remainLength = openToken.fH - closeToken.fH;
		var updt = (!remainLength) ? {dQ: closeToken, c9: openToken, et: remainTokens, eA: tokensTail} : ((remainLength > 0) ? {
			dQ: closeToken,
			c9: _Utils_update(
				openToken,
				{a: openToken.a + remainLength, fH: closeToken.fH}),
			et: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{fH: remainLength}),
				remainTokens),
			eA: tokensTail
		} : {
			dQ: _Utils_update(
				closeToken,
				{fH: openToken.fH}),
			c9: openToken,
			et: remainTokens,
			eA: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{a: closeToken.a + openToken.fH, fH: -remainLength}),
				tokensTail)
		});
		var match = A6(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			model,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.c9.fH),
			updt.c9,
			updt.dQ,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple2(
			updt.eA,
			_Utils_update(
				model,
				{
					b: A2($elm$core$List$cons, match, model.b),
					nk: updt.et
				}));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = function (_v12) {
	htmlElementTTM:
	while (true) {
		var tokens = _v12.a;
		var model = _v12.b;
		if (!tokens.b) {
			return $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v14 = token.e;
			if (_v14.$ === 5) {
				var isOpen = _v14.a;
				var htmlModel = _v14.b;
				return ($dillonkearns$elm_markdown$Markdown$InlineParser$isVoidTag(htmlModel) || (!isOpen)) ? $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					function (b) {
						return _Utils_Tuple2(tokensTail, b);
					}(
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$addMatch,
							model,
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel))))) : $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM(
					A2(
						$elm$core$Maybe$withDefault,
						function (b) {
							return _Utils_Tuple2(tokensTail, b);
						}(
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$addMatch,
								model,
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)))),
						A2(
							$elm$core$Maybe$map,
							A3($dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementToMatch, token, model, htmlModel),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
								tokensTail))));
			} else {
				var $temp$_v12 = _Utils_Tuple2(
					tokensTail,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v12 = $temp$_v12;
				continue htmlElementTTM;
			}
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementToMatch = F4(
	function (openToken, model, htmlModel, _v11) {
		var closeToken = _v11.a;
		var innerTokens = _v11.b;
		var remainTokens = _v11.c;
		return _Utils_Tuple2(
			remainTokens,
			_Utils_update(
				model,
				{
					b: A2(
						$elm$core$List$cons,
						A6(
							$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
							model,
							function (s) {
								return s;
							},
							$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
							openToken,
							closeToken,
							innerTokens),
						model.b)
				}));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = function (_v8) {
	linkImageTypeTTM:
	while (true) {
		var tokens = _v8.a;
		var model = _v8.b;
		if (!tokens.b) {
			return $dillonkearns$elm_markdown$Markdown$InlineParser$reverseTokens(model);
		} else {
			var token = tokens.a;
			var tokensTail = tokens.b;
			var _v10 = token.e;
			if ((_v10.$ === 3) && (']' === _v10.a)) {
				return $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM(
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(tokensTail, model),
						A2(
							$elm$core$Maybe$andThen,
							A3($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, model),
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, model.nk))));
			} else {
				var $temp$_v8 = _Utils_Tuple2(
					tokensTail,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$addToken, model, token));
				_v8 = $temp$_v8;
				continue linkImageTypeTTM;
			}
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F4(
	function (closeToken, tokensTail, model, _v1) {
		var openToken = _v1.a;
		var innerTokens = _v1.b;
		var remainTokens = _v1.c;
		var tempMatch = function (isLinkType) {
			return A6(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				model,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var removeOpenToken = _Utils_Tuple2(
			tokensTail,
			_Utils_update(
				model,
				{
					nk: _Utils_ap(innerTokens, remainTokens)
				}));
		var remainText = A2($elm$core$String$dropLeft, closeToken.a + 1, model.y);
		var linkOpenTokenToInactive = function (model_) {
			var process = function (token) {
				var _v7 = token.e;
				if (_v7.$ === 1) {
					return _Utils_update(
						token,
						{
							e: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(false)
						});
				} else {
					return token;
				}
			};
			return _Utils_update(
				model_,
				{
					nk: A2($elm$core$List$map, process, model_.nk)
				});
		};
		var args = function (isLinkType) {
			return _Utils_Tuple3(
				remainText,
				tempMatch(isLinkType),
				_Utils_update(
					model,
					{nk: remainTokens}));
		};
		var _v2 = openToken.e;
		switch (_v2.$) {
			case 2:
				return $elm$core$Result$toMaybe(
					A2(
						$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
						function (_v4) {
							return $elm$core$Result$Ok(removeOpenToken);
						},
						A2(
							$elm$core$Result$map,
							$dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
							A2(
								$elm$core$Result$andThen,
								$dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
								A2(
									$elm$core$Result$mapError,
									function (_v3) {
										return 0;
									},
									A2(
										$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
										$dillonkearns$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
										$dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
											args(false))))))));
			case 1:
				if (_v2.a) {
					return $elm$core$Result$toMaybe(
						A2(
							$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
							function (_v6) {
								return $elm$core$Result$Ok(removeOpenToken);
							},
							A2(
								$elm$core$Result$map,
								$dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens(tokensTail),
								A2(
									$elm$core$Result$map,
									linkOpenTokenToInactive,
									A2(
										$elm$core$Result$andThen,
										$dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping,
										A2(
											$elm$core$Result$mapError,
											function (_v5) {
												return 0;
											},
											A2(
												$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
												$dillonkearns$elm_markdown$Markdown$InlineParser$checkForRefLinkTypeOrImageType,
												$dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType(
													args(true)))))))));
				} else {
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F6(
	function (model, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.a + openToken.fH;
		var textEnd = closeToken.a;
		var start = openToken.a;
		var end = closeToken.a + closeToken.fH;
		var match = {
			h3: end,
			b: _List_Nil,
			jJ: start,
			m8: processText(
				A3($elm$core$String$slice, textStart, textEnd, model.y)),
			cs: textEnd,
			ao: textStart,
			X: type_
		};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches()(
				_Utils_update(
					model,
					{b: _List_Nil, nk: innerTokens})).b);
		return _Utils_update(
			match,
			{b: matches});
	});
function $dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches() {
	return A2(
		$elm$core$Basics$composeR,
		$dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM),
		A2(
			$elm$core$Basics$composeR,
			$dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM($dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM),
			A2(
				$elm$core$Basics$composeR,
				$dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM($dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM),
				A2(
					$elm$core$Basics$composeR,
					$dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM),
					$dillonkearns$elm_markdown$Markdown$InlineParser$applyTTM($dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM)))));
}
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = $dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches();
$dillonkearns$elm_markdown$Markdown$InlineParser$cyclic$tokensToMatches = function () {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches;
};
var $elm$core$String$trim = _String_trim;
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText) {
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			$dillonkearns$elm_markdown$Markdown$InlineParser$parseText(
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeParserMatches(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches(
						$dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$initParser,
								refs,
								$elm$core$String$trim(rawText)))))).b);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$endOfLineOrFile = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompUntilEndOr('\n'),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'\n',
					$elm$parser$Parser$ExpectingSymbol('\\n'))),
				$elm$parser$Parser$Advanced$end(
				$elm$parser$Parser$Expecting('End of input'))
			])));
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$map,
		function (rawLine) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Body(rawLine);
		},
		$elm$parser$Parser$Advanced$getChompedString(
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$elm$parser$Parser$Advanced$token(
							A2(
								$elm$parser$Parser$Advanced$Token,
								'<',
								$elm$parser$Parser$Expecting('<')))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Markdown$Parser$endOfLineOrFile))));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.i8, s.mB, s.hC, s.mJ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.d)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.i8, newOffset) < 0,
			0,
			{hC: newCol, d: s.d, j: s.j, i8: newOffset, mB: newRow, mJ: s.mJ});
	};
};
var $dillonkearns$elm_markdown$Helpers$isEmptyString = function (string) {
	if (string === '') {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parserHelp = function (delimeter) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					F2(
						function (language, body) {
							return {
								kx: body,
								fC: $dillonkearns$elm_markdown$Helpers$isEmptyString(language) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(language)
							};
						})),
				$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						delimeter,
						$elm$parser$Parser$ExpectingSymbol(delimeter)))),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$getChompedString(
					$elm$parser$Parser$Advanced$chompUntil(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\n',
							$elm$parser$Parser$Problem('Expecting newline')))),
				$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'\n',
						$elm$parser$Parser$ExpectingSymbol('\n'))))),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompUntilEndOr('\n' + delimeter)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'\n' + delimeter,
					$elm$parser$Parser$ExpectingSymbol(delimeter)))));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$Markdown$CodeBlock$parserHelp('```'),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$parserHelp('~~~')
		]));
var $dillonkearns$elm_markdown$Helpers$isGfmWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\u000D':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$token(
						$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('<'))),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
					$elm$parser$Parser$Advanced$token(
						$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('>')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F2(
							function (first, second) {
								return _Utils_ap(first, second);
							})),
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							function (c) {
								return !$dillonkearns$elm_markdown$Helpers$isGfmWhitespace(c);
							},
							$elm$parser$Parser$Expecting('non-whitespace character')))),
				$elm$parser$Parser$Advanced$getChompedString(
					$elm$parser$Parser$Advanced$chompWhile(
						function (c) {
							return !$dillonkearns$elm_markdown$Helpers$isGfmWhitespace(c);
						})))
			])));
var $dillonkearns$elm_markdown$LineEnding$CanHaveLineEnding = 0;
var $dillonkearns$elm_markdown$LineEnding$CannotHaveLineEnding = 1;
var $dillonkearns$elm_markdown$LineEnding$carriageReturn = '\u000D';
var $dillonkearns$elm_markdown$LineEnding$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$LineEnding$lineEnding = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$LineEnding$toToken('\n')),
			$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$LineEnding$toToken($dillonkearns$elm_markdown$LineEnding$carriageReturn + '\n')),
			$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$LineEnding$toToken($dillonkearns$elm_markdown$LineEnding$carriageReturn))
		]));
var $dillonkearns$elm_markdown$LineEnding$statementsHelp = function (state) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$andThen,
				function (_v0) {
					if (!state) {
						return $elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Loop(1));
					} else {
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem('Can\'t have more than one line ending character.'));
					}
				},
				$dillonkearns$elm_markdown$LineEnding$lineEnding),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Loop(state)),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$dillonkearns$elm_markdown$Helpers$isGfmWhitespace,
					$elm$parser$Parser$Expecting('Whitespace'))),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(0))
			]));
};
var $dillonkearns$elm_markdown$LineEnding$optionalWhitespaceUpToOneLineEnding = A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$LineEnding$statementsHelp);
var $dillonkearns$elm_markdown$Helpers$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed(0),
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			$dillonkearns$elm_markdown$Helpers$isGfmWhitespace,
			$elm$parser$Parser$Expecting('whitespace'))),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Helpers$isGfmWhitespace));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'title',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$dillonkearns$elm_markdown$Helpers$requiredWhitespace),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
								$elm$parser$Parser$Advanced$token(
									$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('\"'))),
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$getChompedString(
									$elm$parser$Parser$Advanced$chompUntilEndOr('\"')),
								$elm$parser$Parser$Advanced$token(
									$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('\"')))),
							A2(
							$elm$parser$Parser$Advanced$keeper,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
								$elm$parser$Parser$Advanced$token(
									$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('\''))),
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$getChompedString(
									$elm$parser$Parser$Advanced$chompUntilEndOr('\'')),
								$elm$parser$Parser$Advanced$token(
									$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('\'')))),
							$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
						]))),
				$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
			])));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(label),
									{hZ: destination, nb: title});
							})),
					$elm$parser$Parser$Advanced$token(
						$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken('['))),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$getChompedString(
							$elm$parser$Parser$Advanced$chompUntilEndOr(']')),
						$elm$parser$Parser$Advanced$token(
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$toToken(']:'))),
					$dillonkearns$elm_markdown$LineEnding$optionalWhitespaceUpToOneLineEnding)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$NoMatchYet = {$: 3};
var $dillonkearns$elm_markdown$ThematicBreak$Asterisk = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$ThematicBreak$Dash = 1;
var $dillonkearns$elm_markdown$ThematicBreak$Finished = 3;
var $dillonkearns$elm_markdown$ThematicBreak$Hyphen = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$ThematicBreak$Star = 0;
var $dillonkearns$elm_markdown$ThematicBreak$TokenUnderscore = 2;
var $dillonkearns$elm_markdown$ThematicBreak$Underscore = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$ThematicBreak$Whitespace = 4;
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$succeedIfEnough = function (occurences) {
	return (occurences > 2) ? $elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0)) : $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('...?'));
};
var $elm$core$Debug$toString = _Debug_toString;
var $dillonkearns$elm_markdown$Parser$Extra$tokenHelp = function (_char) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			_char,
			$elm$parser$Parser$Expecting(_char)));
};
var $dillonkearns$elm_markdown$ThematicBreak$statementsHelp = function (state) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (thematicToken) {
			var _v6 = _Utils_Tuple2(thematicToken, state);
			_v6$11:
			while (true) {
				switch (_v6.a) {
					case 3:
						switch (_v6.b.$) {
							case 3:
								var _v7 = _v6.a;
								var _v8 = _v6.b;
								return $elm$parser$Parser$Advanced$problem(
									$elm$parser$Parser$Expecting('TODO'));
							case 0:
								var _v9 = _v6.a;
								var occurrences = _v6.b.a;
								return $dillonkearns$elm_markdown$ThematicBreak$succeedIfEnough(occurrences);
							case 1:
								var _v10 = _v6.a;
								var occurrences = _v6.b.a;
								return $dillonkearns$elm_markdown$ThematicBreak$succeedIfEnough(occurrences);
							default:
								var _v11 = _v6.a;
								var occurrences = _v6.b.a;
								return $dillonkearns$elm_markdown$ThematicBreak$succeedIfEnough(occurrences);
						}
					case 2:
						switch (_v6.b.$) {
							case 2:
								var _v14 = _v6.a;
								var occurrences = _v6.b.a;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Underscore(occurrences + 1)));
							case 3:
								var _v15 = _v6.a;
								var _v16 = _v6.b;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Underscore(1)));
							default:
								break _v6$11;
						}
					case 0:
						switch (_v6.b.$) {
							case 0:
								var _v12 = _v6.a;
								var occurrences = _v6.b.a;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Asterisk(occurrences + 1)));
							case 3:
								var _v17 = _v6.a;
								var _v18 = _v6.b;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Asterisk(1)));
							default:
								break _v6$11;
						}
					case 1:
						switch (_v6.b.$) {
							case 1:
								var _v13 = _v6.a;
								var occurrences = _v6.b.a;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Hyphen(occurrences + 1)));
							case 3:
								var _v19 = _v6.a;
								var _v20 = _v6.b;
								return $elm$parser$Parser$Advanced$succeed(
									$elm$parser$Parser$Advanced$Loop(
										$dillonkearns$elm_markdown$ThematicBreak$Hyphen(1)));
							default:
								break _v6$11;
						}
					default:
						var _v21 = _v6.a;
						return $elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Loop(state));
				}
			}
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting(
					$elm$core$Debug$toString(state)));
		},
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return 1;
					},
					$dillonkearns$elm_markdown$Parser$Extra$tokenHelp('-')),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v1) {
						return 0;
					},
					$dillonkearns$elm_markdown$Parser$Extra$tokenHelp('*')),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v2) {
						return 2;
					},
					$dillonkearns$elm_markdown$Parser$Extra$tokenHelp('_')),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v3) {
						return 3;
					},
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end'))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v4) {
						return 3;
					},
					$dillonkearns$elm_markdown$Parser$Extra$tokenHelp('\n')),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v5) {
						return 4;
					},
					A2(
						$elm$parser$Parser$Advanced$chompIf,
						function (c) {
							return c === ' ';
						},
						$elm$parser$Parser$Expecting('Space')))
				])));
};
var $dillonkearns$elm_markdown$ThematicBreak$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$chompIf,
							function (c) {
								return c === ' ';
							},
							$elm$parser$Parser$Expecting('Space')),
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$chompIf,
						function (c) {
							return c === ' ';
						},
						$elm$parser$Parser$Expecting('Space')),
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$chompIf,
					function (c) {
						return c === ' ';
					},
					$elm$parser$Parser$Expecting('Space')),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2($elm$parser$Parser$Advanced$loop, $dillonkearns$elm_markdown$ThematicBreak$NoMatchYet, $dillonkearns$elm_markdown$ThematicBreak$statementsHelp));
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				function (c) {
					return !$dillonkearns$elm_markdown$Helpers$isNewline(c);
				},
				$elm$parser$Parser$Expecting('Not newline.'))),
		$elm$parser$Parser$Advanced$chompUntilEndOr('\n')));
var $dillonkearns$elm_markdown$Markdown$Parser$plainLine = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (rawLine) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Body(rawLine);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser,
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$chompIf,
					$dillonkearns$elm_markdown$Helpers$isNewline,
					$elm$parser$Parser$Expecting('A single non-newline char.')),
					$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('End'))
				]))));
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$listMarkerParser = function () {
	var markerOption = function (marker) {
		return $elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					marker,
					$elm$parser$Parser$ExpectingSymbol(marker))));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				markerOption('-'),
				markerOption('+'),
				markerOption('*')
			]));
}();
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$zeroOrMore = function (condition) {
	return $elm$parser$Parser$Advanced$chompWhile(condition);
};
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$dillonkearns$elm_markdown$Parser$Extra$zeroOrMore($dillonkearns$elm_markdown$Helpers$isSpacebar))),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$getChompedString(
					$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$elm$parser$Parser$Advanced$symbol(
							A2(
								$elm$parser$Parser$Advanced$Token,
								'\n',
								$elm$parser$Parser$ExpectingSymbol('\\n'))),
							$elm$parser$Parser$Advanced$end(
							$elm$parser$Parser$Expecting('End of input'))
						])))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$getChompedString(
					$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$elm$parser$Parser$Advanced$symbol(
							A2(
								$elm$parser$Parser$Advanced$Token,
								'\n',
								$elm$parser$Parser$ExpectingSymbol('\\n'))),
							$elm$parser$Parser$Advanced$end(
							$elm$parser$Parser$Expecting('End of input'))
						]))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$openingItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		$elm$parser$Parser$Advanced$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$listMarkerParser),
			$dillonkearns$elm_markdown$Parser$Extra$oneOrMore($dillonkearns$elm_markdown$Helpers$isSpacebar))),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$itemBody = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Parser$Extra$oneOrMore($dillonkearns$elm_markdown$Helpers$isSpacebar))),
				$elm$parser$Parser$Advanced$commit('')),
			$dillonkearns$elm_markdown$Markdown$ListItem$parser),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$ListItem$PlainItem('')),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'\n',
					$elm$parser$Parser$ExpectingSymbol('\\n'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$singleItemParser = function (listMarker) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						listMarker,
						$elm$parser$Parser$ExpectingSymbol(listMarker))))),
		$dillonkearns$elm_markdown$Markdown$UnorderedList$itemBody);
};
var $dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp = F3(
	function (listMarker, firstItem, revStmts) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						function (stmt) {
							return $elm$parser$Parser$Advanced$Loop(
								A2($elm$core$List$cons, stmt, revStmts));
						}),
					$dillonkearns$elm_markdown$Markdown$UnorderedList$singleItemParser(listMarker)),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							A2(
								$elm$core$List$cons,
								firstItem,
								$elm$core$List$reverse(revStmts)));
					},
					$elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (_v0) {
		var listMarker = _v0.a;
		var firstItem = _v0.b;
		return A2(
			$elm$parser$Parser$Advanced$loop,
			_List_Nil,
			A2($dillonkearns$elm_markdown$Markdown$UnorderedList$statementsHelp, listMarker, firstItem));
	},
	$dillonkearns$elm_markdown$Markdown$UnorderedList$openingItemParser);
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = A2(
	$elm$parser$Parser$Advanced$map,
	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
	A2(
		$elm$parser$Parser$Advanced$map,
		$elm$core$List$map(
			function (unparsedListItem) {
				if (!unparsedListItem.$) {
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						kx: body,
						gQ: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				} else {
					var body = unparsedListItem.a;
					return {kx: body, gQ: $elm$core$Maybe$Nothing};
				}
			}),
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser));
var $dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks = F2(
	function (state, updatedRawBlocks) {
		return _Utils_update(
			state,
			{a_: updatedRawBlocks});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToParser = function (node) {
	switch (node.$) {
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			return A2(
				$elm$parser$Parser$Advanced$andThen,
				function (childrenAsBlocks) {
					return $elm$parser$Parser$Advanced$succeed(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
								A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks))
							]));
				},
				$dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksParser(children));
		case 1:
			var innerText = node.a;
			var _v24 = A2(
				$elm$parser$Parser$Advanced$run,
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$multiParser2(),
				innerText);
			if (!_v24.$) {
				var value = _v24.a;
				return $elm$parser$Parser$Advanced$succeed(value);
			} else {
				var error = _v24.a;
				return $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting(
						A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
			}
		case 2:
			var string = node.a;
			return $elm$parser$Parser$Advanced$succeed(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string))
					]));
		case 3:
			var string = node.a;
			return $elm$parser$Parser$Advanced$succeed(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						$dillonkearns$elm_markdown$Markdown$Block$Cdata(string))
					]));
		case 4:
			var string = node.a;
			return $elm$parser$Parser$Advanced$succeed(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string))
					]));
		default:
			var declarationType = node.a;
			var content = node.b;
			return $elm$parser$Parser$Advanced$succeed(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content))
					]));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$combineBlocks = F3(
	function (linkReferences, rawBlock, soFar) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (parsedBlocks) {
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (maybeNewParsedBlock) {
						if (!maybeNewParsedBlock.$) {
							var newParsedBlock = maybeNewParsedBlock.a;
							return A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						} else {
							return parsedBlocks;
						}
					},
					A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, linkReferences, rawBlock));
			},
			soFar);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v20) {
		var unparsedInlines = _v20;
		var referencesDict2 = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v21) {
						var destination = _v21.hZ;
						var title = _v21.nb;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, referencesDict2, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		default:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
			}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			var innerText = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parsedChildren = $elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (child) {
						if (child.$ === 1) {
							var text = child.a;
							return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
						} else {
							return _List_fromArray(
								[
									$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
									$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
								]);
						}
					},
					children));
			return A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren);
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksParser = function (children) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		$elm$core$List$concat,
		$dillonkearns$elm_markdown$Markdown$Parser$combine(
			A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$childToParser, children)));
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3(
		$elm$core$List$foldl,
		$dillonkearns$elm_markdown$Markdown$Parser$combineBlocks(state.c4),
		$elm$parser$Parser$Advanced$succeed(_List_Nil),
		state.a_);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				return A2(
					$elm$parser$Parser$Advanced$andThen,
					function (parsedLevel) {
						return function (styledLine) {
							return $dillonkearns$elm_markdown$Markdown$Parser$just(
								A2($dillonkearns$elm_markdown$Markdown$Block$Heading, parsedLevel, styledLine));
						}(
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
					},
					$dillonkearns$elm_markdown$Markdown$Parser$levelParser(level));
			case 1:
				var unparsedInlines = rawBlock.a;
				return function (styledLine) {
					return $dillonkearns$elm_markdown$Markdown$Parser$just(
						$dillonkearns$elm_markdown$Markdown$Block$Paragraph(styledLine));
				}(
					A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$just(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var unparsedItems = rawBlock.a;
				return A2(
					$elm$parser$Parser$Advanced$map,
					$elm$core$Maybe$Just,
					A2(
						$elm$parser$Parser$Advanced$map,
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$combine(
							A2(
								$elm$core$List$map,
								function (unparsedItem) {
									return A2(
										$elm$parser$Parser$Advanced$map,
										function (parsedInlines) {
											var task = function () {
												var _v11 = unparsedItem.gQ;
												if (!_v11.$) {
													if (!_v11.a) {
														return 1;
													} else {
														return 2;
													}
												} else {
													return 0;
												}
											}();
											return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, task, parsedInlines);
										},
										A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, unparsedItem.kx));
								},
								unparsedItems))));
			case 4:
				var startingIndex = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				return A2(
					$elm$parser$Parser$Advanced$map,
					$elm$core$Maybe$Just,
					A2(
						$elm$parser$Parser$Advanced$map,
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList(startingIndex),
						$dillonkearns$elm_markdown$Markdown$Parser$combine(
							A2(
								$elm$core$List$map,
								A2($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity),
								unparsedInlines))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$just(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$just($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 9:
				return $elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing);
			case 10:
				var rawBlocks = rawBlock.a;
				var _v12 = A2(
					$elm$parser$Parser$Advanced$run,
					$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
					rawBlocks);
				if (!_v12.$) {
					var value = _v12.a;
					return A2(
						$elm$parser$Parser$Advanced$map,
						function (parsedBlocks) {
							return $elm$core$Maybe$Just(
								$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
						},
						$dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(value));
				} else {
					var error = _v12.a;
					return $elm$parser$Parser$Advanced$problem(
						$elm$parser$Parser$Problem(
							$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$just(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{kx: codeBlockBody, fC: $elm$core$Maybe$Nothing}));
			default:
				var _v13 = rawBlock.a;
				var header = _v13.a;
				var rows = _v13.b;
				var parsedHeader = $dillonkearns$elm_markdown$Markdown$Parser$combine(
					A2(
						$elm$core$List$map,
						function (_v14) {
							var label = _v14.iD;
							var alignment = _v14.kn;
							return A3(
								$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
								linkReferences,
								function (parsedHeaderLabel) {
									return {kn: alignment, iD: parsedHeaderLabel};
								},
								label);
						},
						header));
				return A2(
					$elm$parser$Parser$Advanced$andThen,
					function (headerThing) {
						return $dillonkearns$elm_markdown$Markdown$Parser$just(
							A2($dillonkearns$elm_markdown$Markdown$Block$Table, headerThing, _List_Nil));
					},
					parsedHeader);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return $elm$parser$Parser$Advanced$succeed(
			function (styledLine) {
				return wrap(styledLine);
			}(
				A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$statementsHelp2 = function (revStmts) {
	var keepLooping = function (parser) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (newRawBlock) {
				var _v4 = _Utils_Tuple2(newRawBlock, revStmts.a_);
				_v4$5:
				while (true) {
					if (_v4.b.b) {
						switch (_v4.a.$) {
							case 5:
								if (_v4.b.a.$ === 5) {
									var block1 = _v4.a.a;
									var _v5 = _v4.b;
									var block2 = _v5.a.a;
									var rest = _v5.b;
									return $elm$parser$Parser$Advanced$Loop(
										A2(
											$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
											revStmts,
											A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
													{
														kx: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.kx, block1.kx),
														fC: $elm$core$Maybe$Nothing
													}),
												rest)));
								} else {
									break _v4$5;
								}
							case 6:
								if (_v4.b.a.$ === 6) {
									var block1 = _v4.a.a;
									var _v6 = _v4.b;
									var block2 = _v6.a.a;
									var rest = _v6.b;
									return $elm$parser$Parser$Advanced$Loop(
										A2(
											$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
											revStmts,
											A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
													A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
												rest)));
								} else {
									break _v4$5;
								}
							case 10:
								if (_v4.b.a.$ === 10) {
									var body1 = _v4.a.a;
									var _v8 = _v4.b;
									var body2 = _v8.a.a;
									var rest = _v8.b;
									return $elm$parser$Parser$Advanced$Loop(
										A2(
											$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
											revStmts,
											A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
													A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
												rest)));
								} else {
									break _v4$5;
								}
							case 1:
								switch (_v4.b.a.$) {
									case 10:
										var body1 = _v4.a.a;
										var _v7 = _v4.b;
										var body2 = _v7.a.a;
										var rest = _v7.b;
										return $elm$parser$Parser$Advanced$Loop(
											A2(
												$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
												revStmts,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
													rest)));
									case 1:
										var body1 = _v4.a.a;
										var _v9 = _v4.b;
										var body2 = _v9.a.a;
										var rest = _v9.b;
										return $elm$parser$Parser$Advanced$Loop(
											A2(
												$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
												revStmts,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$Body(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
													rest)));
									default:
										break _v4$5;
								}
							default:
								break _v4$5;
						}
					} else {
						break _v4$5;
					}
				}
				return $elm$parser$Parser$Advanced$Loop(
					A2(
						$dillonkearns$elm_markdown$Markdown$Parser$updateRawBlocks,
						revStmts,
						A2($elm$core$List$cons, newRawBlock, revStmts.a_)));
			},
			parser);
	};
	var indentedCodeParser = function () {
		var _v3 = revStmts.a_;
		if (_v3.b && (_v3.a.$ === 1)) {
			return $elm$parser$Parser$Advanced$oneOf(_List_Nil);
		} else {
			return keepLooping($dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock);
		}
	}();
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('End'))),
				keepLooping($dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (linkReference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, linkReference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				keepLooping($dillonkearns$elm_markdown$Markdown$Parser$blankLine),
				keepLooping($dillonkearns$elm_markdown$Markdown$Parser$blockQuote),
				keepLooping(
				A2(
					$elm$parser$Parser$Advanced$map,
					$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
					$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser))),
				indentedCodeParser,
				keepLooping(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v2) {
						return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
					},
					$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser))),
				keepLooping($dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock),
				keepLooping(
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(
					$elm$core$List$head(revStmts.a_))),
				keepLooping(
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$heading)),
				keepLooping(
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()),
				keepLooping($dillonkearns$elm_markdown$Markdown$Parser$plainLine)
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$parser$Parser$Advanced$run,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$multiParser2(),
			textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (parser) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (xmlNode) {
			switch (xmlNode.$) {
				case 1:
					var innerText = xmlNode.a;
					return $elm$parser$Parser$Advanced$succeed(
						$dillonkearns$elm_markdown$Markdown$RawBlock$Body(innerText));
				case 0:
					var tag = xmlNode.a;
					var attributes = xmlNode.b;
					var children = xmlNode.c;
					return A2(
						$elm$parser$Parser$Advanced$andThen,
						function (parsedChildren) {
							return $elm$parser$Parser$Advanced$succeed(
								$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
									A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
						},
						$dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksParser(children));
				case 2:
					var string = xmlNode.a;
					return $elm$parser$Parser$Advanced$succeed(
						$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
				case 3:
					var string = xmlNode.a;
					return $elm$parser$Parser$Advanced$succeed(
						$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
				case 4:
					var string = xmlNode.a;
					return $elm$parser$Parser$Advanced$succeed(
						$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
				default:
					var declarationType = xmlNode.a;
					var content = xmlNode.b;
					return $elm$parser$Parser$Advanced$succeed(
						$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
			}
		},
		parser);
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode($dillonkearns$elm_markdown$HtmlParser$html);
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$multiParser2() {
	return A2(
		$elm$parser$Parser$Advanced$map,
		$elm$core$List$filter(
			function (item) {
				if ((item.$ === 5) && (!item.a.b)) {
					return false;
				} else {
					return true;
				}
			}),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			$dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
				$elm$parser$Parser$Advanced$succeed($elm$parser$Parser$Advanced$end))));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		{c4: _List_Nil, a_: _List_Nil},
		$dillonkearns$elm_markdown$Markdown$Parser$statementsHelp2);
}
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$multiParser2 = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$multiParser2();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$multiParser2 = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$multiParser2;
};
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	return A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$Parser$multiParser2, input);
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var listItems = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var _int = block.a;
						var lists = block.b;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var items = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var task = _v4.a;
						var inlines = _v4.b;
						return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
					},
					items));
		case 2:
			var _int = block.a;
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText, items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var headingLevel = block.a;
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.iD;
								},
								header)),
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineText, rows)
						])));
		case 7:
			var body = block.a.kx;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 7:
				return text + ' ';
			case 5:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v7 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v7.$) {
			var inline = _v7.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.lp(
								{
									kL: children,
									lL: level,
									y: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.jg,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var items = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.j5,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										function (renderedBody) {
											return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, task, renderedBody);
										},
										A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, children));
								},
								items))));
			case 2:
				var startingIndex = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.mc(startingIndex),
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.hA(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.m9));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.kt,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v6) {
							var label = _v6.iD;
							var alignment = _v6.kn;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (h) {
							return renderer.m0(
								_List_fromArray(
									[h]));
						},
						A2(
							$elm$core$Result$map,
							function (listListView) {
								return renderer.m3(
									A2(
										$elm$core$List$map,
										function (_v5) {
											var maybeAlignment = _v5.a;
											var item = _v5.b;
											return A2(renderer.m4, maybeAlignment, item);
										},
										listListView));
							},
							renderedHeaderCells)));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.lv,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.mN,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.k9,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.lw(
							{
								eI: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								mJ: src,
								nb: title
							})));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.m8(string)));
			case 5:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.hB(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.iM,
									{hZ: destination, nb: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 7:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.lo));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $author$project$Governance$ProposalDetail$actionRow = F2(
	function (actionNumber, title) {
		var renderer = _Utils_update(
			$dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer,
			{
				iM: F2(
					function (link, content) {
						return A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('details-panel__link'),
										$author$project$Utils$CompoundHtmlAttributes$target('__blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, link.hZ)),
							content);
					}),
				jg: $elm$html$Html$div(
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__title')
						]))
			});
		var markdownTitle = function () {
			var _v0 = A2(
				$elm$core$Result$andThen,
				function (ast) {
					return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, renderer, ast);
				},
				A2(
					$elm$core$Result$mapError,
					$author$project$Governance$ProposalDetail$deadEndsToString,
					$dillonkearns$elm_markdown$Markdown$Parser$parse(title)));
			if (!_v0.$) {
				var rendered = _v0.a;
				return rendered;
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__number')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(actionNumber))
						])),
				markdownTitle));
	});
var $author$project$Governance$ProposalDetail$loadingActionRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__number details-panel__action-row__number--loading')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__title details-panel__action-row__title--loading')
				]),
			_List_Nil)
		]));
var $author$project$Governance$ProposalDetail$loadingParagraph = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph__line')
				]),
			_List_Nil)
		]));
var $author$project$Governance$ProposalDetail$detailsPanel = F2(
	function (userLanguage, _v0) {
		var proposalDetailState = _v0.aa;
		var renderer = _Utils_update(
			$dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer,
			{
				lp: function (_v4) {
					var level = _v4.lL;
					var children = _v4.kL;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__header')
							]),
						children);
				},
				iM: F2(
					function (link, content) {
						return A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('details-panel__link'),
										$author$project$Utils$CompoundHtmlAttributes$target('__blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, link.hZ)),
							content);
					}),
				jg: $elm$html$Html$div(
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph')
						]))
			});
		var _v1 = function () {
			if (!proposalDetailState.$) {
				var proposalDetail = proposalDetailState.a;
				var markdownDescription = function () {
					var _v3 = A2(
						$elm$core$Result$andThen,
						function (ast) {
							return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, renderer, ast);
						},
						A2(
							$elm$core$Result$mapError,
							$author$project$Governance$ProposalDetail$deadEndsToString,
							$dillonkearns$elm_markdown$Markdown$Parser$parse(proposalDetail.hY)));
					if (!_v3.$) {
						var rendered = _v3.a;
						return rendered;
					} else {
						return A2(
							$elm$core$List$map,
							function (pg) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(pg)
										]));
							},
							A2($elm$core$String$split, '\n', proposalDetail.hY));
					}
				}();
				return {
					ki: A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, action) {
								return A2($author$project$Governance$ProposalDetail$actionRow, index + 1, action.nb);
							}),
						proposalDetail.ki),
					gc: markdownDescription
				};
			} else {
				return {
					ki: A2($elm$core$List$repeat, 3, $author$project$Governance$ProposalDetail$loadingActionRow),
					gc: A2($elm$core$List$repeat, 1, $author$project$Governance$ProposalDetail$loadingParagraph)
				};
			}
		}();
		var paragraphs = _v1.gc;
		var actions = _v1.ki;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 details-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$details(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('details-panel__actions')
								]),
							actions),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description')
								]),
							paragraphs)
						]))
				]));
	});
var $author$project$Governance$CommonViews$loadingProposalContentViewHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('proposal__content')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__title proposal__content__description__title--header--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details proposal__content__description__details--loading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--loading--large')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text__time--loading proposal__content__description__details__text__time--loading--large')
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$Governance$ProposalDetail$loadingProposerPane = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('gov-profile-image gov-profile-image--loading')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__display-name proposer-pane__details__display-name--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__address proposer-pane__details__address--loading')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Governance$ProposalDetail$placeholderLoadingProposal = function (targetProposalId) {
	return {
		ki: _List_Nil,
		hh: $author$project$Decimal$zero,
		hY: '',
		$8: $author$project$Decimal$zero,
		ir: targetProposalId,
		ms: {
			g9: $elm$core$Maybe$Nothing,
			hd: ' ...',
			h_: $elm$core$Maybe$Just('...'),
			is: $elm$core$Maybe$Nothing
		},
		jM: _List_Nil,
		nb: 'Loading...'
	};
};
var $author$project$Strings$Translations$proposal_state_created = function (lang) {
	switch (lang) {
		case 0:
			return 'Created';
		case 1:
			return 'Creado';
		case 2:
			return '已建立';
		case 3:
			return 'Créé';
		default:
			return '생성됨';
	}
};
var $author$project$Strings$Translations$proposal_state_succeeded = function (lang) {
	switch (lang) {
		case 0:
			return 'Succeeded';
		case 1:
			return 'Triunfó';
		case 2:
			return '成功';
		case 3:
			return 'Réussi';
		default:
			return '성공';
	}
};
var $author$project$Governance$ProposalDetail$stateTimeFormatter = function (timezone) {
	return A2(
		$ryannhg$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryannhg$date_format$DateFormat$monthNameFull,
				$ryannhg$date_format$DateFormat$text(' '),
				$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
				$ryannhg$date_format$DateFormat$text(', '),
				$ryannhg$date_format$DateFormat$yearNumber,
				$ryannhg$date_format$DateFormat$text(' – '),
				$ryannhg$date_format$DateFormat$hourNumber,
				$ryannhg$date_format$DateFormat$text(':'),
				$ryannhg$date_format$DateFormat$minuteFixed,
				$ryannhg$date_format$DateFormat$amPmLowercase
			]),
		timezone);
};
var $author$project$Governance$ProposalDetail$historyStateRow = F5(
	function (userLanguage, timezone, network, maybeCurrentState, historyState) {
		var timestamp = A2($author$project$Governance$ProposalDetail$stateTimeFormatter, timezone, historyState.mL);
		var maybeState = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.jL;
			},
			maybeCurrentState);
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(historyState.jL, maybeState);
			switch (_v1.a) {
				case 0:
					if ((!_v1.b.$) && (!_v1.b.a)) {
						var _v2 = _v1.a;
						var _v3 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_pending(userLanguage),
							'active');
					} else {
						var _v4 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_created(userLanguage),
							'inactive-succeeded');
					}
				case 1:
					if ((!_v1.b.$) && (_v1.b.a === 1)) {
						var _v5 = _v1.a;
						var _v6 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_active(userLanguage),
							'active');
					} else {
						var _v7 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_active(userLanguage),
							'inactive-succeeded');
					}
				case 2:
					if ((!_v1.b.$) && (_v1.b.a === 6)) {
						var _v8 = _v1.a;
						var _v9 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_succeeded(userLanguage),
							'inactive-succeeded');
					} else {
						var _v10 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_succeeded(userLanguage),
							'active');
					}
				case 3:
					var _v11 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_failed(userLanguage),
						'failed');
				case 4:
					if ((!_v1.b.$) && (_v1.b.a === 6)) {
						var _v12 = _v1.a;
						var _v13 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_queued(userLanguage),
							'inactive-succeeded');
					} else {
						var _v14 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_queued(userLanguage),
							'active');
					}
				case 5:
					var _v15 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_executed(userLanguage),
						'active');
				case 6:
					var _v16 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_canceled(userLanguage),
						'failed');
				default:
					var _v17 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_expired(userLanguage),
						'failed');
			}
		}();
		var stateName = _v0.a;
		var pointClass = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point history-panel__time-line__point--' + pointClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__content')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(stateName)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__timestamp')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timestamp)
										]))
								])),
						function () {
							var _v18 = historyState.nz;
							if (!_v18.$) {
								var stateTrxHash = _v18.a;
								return _List_fromArray(
									[
										A4(
										$author$project$Eth$Ethereum$etherscanLink,
										$elm$core$Maybe$Just(network),
										$author$project$Eth$Ethereum$TransactionHash(stateTrxHash),
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('external-link')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link--green')
													]),
												_List_Nil)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()))
				]));
	});
var $author$project$Governance$ProposalDetail$loadingHistoryStateRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point history-panel__time-line__point--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__title history-panel__time-line__point__title--loading')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__timestamp history-panel__time-line__point__timestamp--loading')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Strings$Translations$proposal_history = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposal History';
		case 1:
			return 'Historial de propuestas';
		case 2:
			return '提案历史';
		case 3:
			return 'Historique de la proposition';
		default:
			return '제안서 내역';
	}
};
var $author$project$Governance$ProposalDetail$proposalHistoryPanel = F4(
	function (userLanguage, timezone, network, _v0) {
		var proposalDetailState = _v0.aa;
		var statePoints = function () {
			if (!proposalDetailState.$) {
				var states = proposalDetailState.a.jM;
				var currentState = $elm$core$List$head(
					$elm$core$List$reverse(states));
				return A2(
					$elm$core$List$map,
					A4($author$project$Governance$ProposalDetail$historyStateRow, userLanguage, timezone, network, currentState),
					states);
			} else {
				return A2($elm$core$List$repeat, 2, $author$project$Governance$ProposalDetail$loadingHistoryStateRow);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 history-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$proposal_history(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line ')
								]),
							statePoints)
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$ProposalDetail$ImageError = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Utils$GovProfileImageHelper$Medium = 1;
var $author$project$Governance$ProposalDetail$proposerPane = F3(
	function (_v0, targetProposalId, _v1) {
		var proposalDetailState = _v1.aa;
		var proposerCompAccountState = _v1.es;
		var hasProposerIconState = function () {
			if (!proposerCompAccountState.$) {
				var proposerCompAccount = proposerCompAccountState.a;
				return A2(
					$author$project$Decimal$gte,
					proposerCompAccount.nI,
					$author$project$Decimal$fromInt(100000));
			} else {
				return false;
			}
		}();
		var activeProposer = function () {
			if (!proposalDetailState.$) {
				var proposalDetail = proposalDetailState.a;
				return proposalDetail.ms;
			} else {
				return $author$project$Governance$ProposalDetail$placeholderLoadingProposal(targetProposalId).ms;
			}
		}();
		var friendlyDisplayName = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, activeProposer.hd),
			activeProposer.h_);
		var profileImageComponent = A2(
			$elm$html$Html$map,
			function (profileImageMsg) {
				var profileElementId = profileImageMsg.a;
				var defaultImage = profileImageMsg.b;
				return A2($author$project$Governance$ProposalDetail$ImageError, profileElementId, defaultImage);
			},
			$author$project$Utils$GovProfileImageHelper$profileImage(
				{hd: activeProposer.hd, lS: activeProposer.is, mH: hasProposerIconState, by: 1, nE: false}));
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(activeProposer.hd)))),
			_List_fromArray(
				[
					profileImageComponent,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__display-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(friendlyDisplayName)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__address')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, activeProposer.hd))
								]))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$ShowVotesModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$ProposalDetail$loadingVoteRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row votes-panel__vote-row--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__account votes-panel__vote-row__account--loading')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__votes votes-panel__vote-row__votes--loading')
				]),
			_List_Nil)
		]));
var $author$project$Strings$Translations$view_all = function (lang) {
	switch (lang) {
		case 0:
			return 'View All';
		case 1:
			return 'Ver todo';
		case 2:
			return '查看全部';
		case 3:
			return 'Voir tout';
		default:
			return '모두 보기';
	}
};
var $author$project$Governance$ProposalDetail$loadingVotePanel = F2(
	function (userLanguage, isForVotes) {
		var headerText = isForVotes ? $author$project$Strings$Translations$for(userLanguage) : $author$project$Strings$Translations$against(userLanguage);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6 votes-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header votes-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__title-bar')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(headerText)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__title-bar__percent--loading')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__vote-bar')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-left')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$address(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$votes(userLanguage))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-rows')
								]),
							A2($elm$core$List$repeat, 3, $author$project$Governance$ProposalDetail$loadingVoteRow)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer governance-panel__footer--disabled')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$view_all(userLanguage))
								]))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$loadingVoteOverview = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('row')
			]),
		_List_fromArray(
			[
				A2($author$project$Governance$ProposalDetail$loadingVotePanel, userLanguage, true),
				A2($author$project$Governance$ProposalDetail$loadingVotePanel, userLanguage, false)
			]));
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Strings$Translations$addresses = F2(
	function (lang, numberOfAddresses) {
		switch (lang) {
			case 0:
				return '' + (numberOfAddresses + ' Addresses');
			case 1:
				return '' + (numberOfAddresses + ' Direcciones');
			case 2:
				return '' + (numberOfAddresses + '个地址');
			case 3:
				return '' + (numberOfAddresses + ' Adresses');
			default:
				return '' + (numberOfAddresses + ' 주소');
		}
	});
var $author$project$Governance$ProposalDetail$emptyVoteRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row votes-panel__vote-row--empty')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__account votes-panel__vote-row__account--empty')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__votes votes-panel__vote-row__votes--empty')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				]))
		]));
var $author$project$Governance$ProposalDetail$voteRow = F3(
	function (name, address, votes) {
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(address)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__account')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row__votes')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatTokenBalance(votes))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$voteTotalsAndRowsContent = F7(
	function (userLanguage, forModal, votes, votesPercentage, numberOfVoters, isForVotes, voters) {
		var allVotersRows = A2(
			$elm$core$List$map,
			function (voteReceipt) {
				var friendlyDisplayName = A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, voteReceipt.j9.hd),
					voteReceipt.j9.h_);
				return A3($author$project$Governance$ProposalDetail$voteRow, friendlyDisplayName, voteReceipt.j9.hd, voteReceipt.nI);
			},
			A2(
				$elm$core$List$sortWith,
				F2(
					function (a, b) {
						return A2(
							$author$project$Decimal$compare,
							function ($) {
								return $.nI;
							}(b),
							function ($) {
								return $.nI;
							}(a));
					}),
				voters));
		var votersRows = forModal ? allVotersRows : A2(
			$elm$core$List$take,
			3,
			_Utils_ap(
				allVotersRows,
				A2($elm$core$List$repeat, 3, $author$project$Governance$ProposalDetail$emptyVoteRow)));
		var addressLabel = (numberOfVoters === 1) ? $author$project$Strings$Translations$address(userLanguage) : A2(
			$author$project$Strings$Translations$addresses,
			userLanguage,
			$elm$core$String$fromInt(numberOfVoters));
		var votePanelHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(addressLabel)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						]))
				]));
		var _v0 = isForVotes ? _Utils_Tuple2(
			$author$project$Strings$Translations$for(userLanguage),
			'--for') : _Utils_Tuple2(
			$author$project$Strings$Translations$against(userLanguage),
			'--against');
		var headerText = _v0.a;
		var barFillClass = _v0.b;
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header votes-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__title-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(headerText)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(votes)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__vote-bar__fill votes-panel__header__vote-bar__fill' + barFillClass),
											A2($author$project$Utils$CompoundHtmlAttributes$style, 'width', votesPercentage)
										]),
									_List_Nil)
								]))
						])),
					votePanelHeaders
				]),
			votersRows);
	});
var $author$project$Governance$ProposalDetail$votesSorter = F2(
	function (a, b) {
		return A2(
			$author$project$Decimal$compare,
			function ($) {
				return $.nI;
			}(b),
			function ($) {
				return $.nI;
			}(a));
	});
var $author$project$Governance$ProposalDetail$voteOverview = F2(
	function (userLanguage, _v0) {
		var proposalDetailState = _v0.aa;
		var forVoteReceiptsState = _v0.bT;
		var againstVoteReceiptsState = _v0.bH;
		var _v1 = _Utils_Tuple3(proposalDetailState, forVoteReceiptsState, againstVoteReceiptsState);
		if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
			var proposalDetail = _v1.a.a;
			var forVoteReceipts = _v1.b.a;
			var againstVoteReceipts = _v1.c.a;
			var _v2 = function () {
				var _v3 = _Utils_Tuple2(
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$sortWith, $author$project$Governance$ProposalDetail$votesSorter, forVoteReceipts.a5)),
					($elm$core$List$length(forVoteReceipts.a5) >= 3) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
								$author$project$Governance$ProposalDetail$ShowVotesModal(true))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer governance-panel__footer--disabled')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])));
				var forTop3 = _v3.a;
				var forVotesViewAll = _v3.b;
				var _v4 = _Utils_Tuple2(
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$sortWith, $author$project$Governance$ProposalDetail$votesSorter, againstVoteReceipts.a5)),
					($elm$core$List$length(againstVoteReceipts.a5) >= 3) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
								$author$project$Governance$ProposalDetail$ShowVotesModal(false))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer governance-panel__footer--disabled')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])));
				var againstTop3 = _v4.a;
				var againstVotesViewAll = _v4.b;
				return {
					hf: _List_fromArray(
						[againstVotesViewAll]),
					hg: againstTop3,
					id: _List_fromArray(
						[forVotesViewAll]),
					ie: forTop3
				};
			}();
			var forVotesTop3 = _v2.ie;
			var forVotesShowAll = _v2.id;
			var againstVotesTop3 = _v2.hg;
			var againstVotesShowAll = _v2.hf;
			var _v5 = function () {
				var totalVotes = A2($author$project$Decimal$add, proposalDetail.$8, proposalDetail.hh);
				return {
					he: $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.hh, totalVotes))),
					ic: $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.$8, totalVotes)))
				};
			}();
			var forVotesPercentage = _v5.ic;
			var againstVotesPercentage = _v5.he;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6 votes-panel')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
									]),
								_Utils_ap(
									A7(
										$author$project$Governance$ProposalDetail$voteTotalsAndRowsContent,
										userLanguage,
										false,
										A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, proposalDetail.$8),
										forVotesPercentage,
										forVoteReceipts.cx,
										true,
										forVotesTop3),
									forVotesShowAll))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6 votes-panel')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
									]),
								_Utils_ap(
									A7(
										$author$project$Governance$ProposalDetail$voteTotalsAndRowsContent,
										userLanguage,
										false,
										A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, proposalDetail.hh),
										againstVotesPercentage,
										againstVoteReceipts.cx,
										false,
										againstVotesTop3),
									againstVotesShowAll))
							]))
					]));
		} else {
			return $author$project$Governance$ProposalDetail$loadingVoteOverview(userLanguage);
		}
	});
var $author$project$Governance$ProposalDetail$DismissVotesModal = {$: 5};
var $author$project$Strings$Translations$against_votes = function (lang) {
	switch (lang) {
		case 0:
			return 'Against Votes';
		case 1:
			return 'Contra los votos';
		case 2:
			return '反对投票';
		case 3:
			return 'Contre les votes';
		default:
			return '반대 표';
	}
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Strings$Translations$for_votes = function (lang) {
	switch (lang) {
		case 0:
			return 'For Votes';
		case 1:
			return 'Para los votos';
		case 2:
			return '投票';
		case 3:
			return 'Pour les votes';
		default:
			return '찬성 표';
	}
};
var $author$project$Governance$ProposalDetail$votersModalView = F2(
	function (userLanguage, _v0) {
		var shownVotesModal = _v0.dh;
		if (!shownVotesModal.$) {
			var showForVotes = shownVotesModal.a.gE;
			var proposalDetail = shownVotesModal.a.gp;
			var votersList = shownVotesModal.a.g4;
			var totalVotes = A2($author$project$Decimal$add, proposalDetail.$8, proposalDetail.hh);
			var _v2 = function () {
				if (showForVotes) {
					var percentage = $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.$8, totalVotes)));
					return _Utils_Tuple3(
						$author$project$Strings$Translations$for_votes(userLanguage) + (' – ' + percentage),
						percentage,
						A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, proposalDetail.$8));
				} else {
					var percentage = $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.hh, totalVotes)));
					return _Utils_Tuple3(
						$author$project$Strings$Translations$against_votes(userLanguage) + (' – ' + percentage),
						percentage,
						A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, proposalDetail.hh));
				}
			}();
			var headerText = _v2.a;
			var votesPercentage = _v2.b;
			var votes = _v2.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('cover active'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalDetail$DismissVotesModal)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('accent neutral')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('panel')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(headerText)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('close-x')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalDetail$DismissVotesModal)
															]),
														_List_Nil)
													]))
											])),
									A7($author$project$Governance$ProposalDetail$voteTotalsAndRowsContent, userLanguage, true, votes, votesPercentage, votersList.cx, showForVotes, votersList.a5)))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Governance$ProposalDetail$view = F7(
	function (userLanguage, network, backPage, targetProposalId, timezone, maybeCurrentTime, model) {
		var proposalDetailState = model.aa;
		var _v0 = function () {
			switch (proposalDetailState.$) {
				case 0:
					var proposalDetail = proposalDetailState.a;
					return _Utils_Tuple2(
						A5($author$project$Governance$CommonViews$proposalContentView, userLanguage, timezone, maybeCurrentTime, proposalDetail, true),
						$elm$core$Maybe$Just(
							A3($author$project$Governance$ProposalDetail$proposerPane, userLanguage, targetProposalId, model)));
				case 2:
					return _Utils_Tuple2(
						$author$project$Governance$CommonViews$loadingProposalContentViewHeader,
						$elm$core$Maybe$Just($author$project$Governance$ProposalDetail$loadingProposerPane));
				default:
					return _Utils_Tuple2(
						A5(
							$author$project$Governance$CommonViews$proposalContentView,
							userLanguage,
							timezone,
							maybeCurrentTime,
							$author$project$Governance$ProposalDetail$placeholderLoadingProposal(targetProposalId),
							true),
						$elm$core$Maybe$Just($author$project$Governance$ProposalDetail$loadingProposerPane));
			}
		}();
		var proposalHeader = _v0.a;
		var maybeProposerPane = _v0.b;
		var _v2 = A2($author$project$LandingSite$Page$getInPageBackTitleHref, userLanguage, backPage);
		var inPageHeaderTitle = _v2.a;
		var inPageHeaderHref = _v2.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Proposal-Detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A4($author$project$Governance$CommonViews$pageHeader, inPageHeaderTitle, inPageHeaderHref, proposalHeader, maybeProposerPane)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal-detail')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2($author$project$Governance$ProposalDetail$voteOverview, userLanguage, model),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2($author$project$Governance$ProposalDetail$detailsPanel, userLanguage, model),
													A4($author$project$Governance$ProposalDetail$proposalHistoryPanel, userLanguage, timezone, network, model)
												]))
										]))
								]))
						])),
					A2($author$project$Governance$ProposalDetail$votersModalView, userLanguage, model)
				]));
	});
var $author$project$Governance$ProposalOverview$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$ProposalOverview$PagerNext = {$: 2};
var $author$project$Governance$ProposalOverview$PagerPrevious = {$: 1};
var $author$project$Strings$Translations$all_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'All Proposals';
		case 1:
			return 'Todas las propuestas';
		case 2:
			return '所有提案';
		case 3:
			return 'Toutes les propositions';
		default:
			return '모든 제안서';
	}
};
var $author$project$Governance$ProposalOverview$allProposalsPane = F4(
	function (userLanguage, timezone, maybeCurrentTime, _v0) {
		var currentPageNumber = _v0.bN;
		var totalProposalsState = _v0.cw;
		var proposalsPageMap = _v0.ci;
		var totalPages = function () {
			if (!totalProposalsState.$) {
				var totalProposals = totalProposalsState.a;
				return $elm$core$Basics$ceiling(totalProposals / $author$project$Governance$ProposalOverview$desiredPageSize);
			} else {
				return 0;
			}
		}();
		var proposalsForPage = function () {
			var _v1 = A2($elm$core$Dict$get, currentPageNumber, proposalsPageMap);
			if (!_v1.$) {
				var pageProposals = _v1.a;
				var proposalsToShow = A2(
					$elm$core$List$map,
					A3($author$project$Governance$CommonViews$proposalRow, userLanguage, timezone, maybeCurrentTime),
					pageProposals);
				return ($elm$core$List$length(proposalsToShow) > 0) ? proposalsToShow : _List_fromArray(
					[
						$author$project$Governance$CommonViews$noProposalsRow(userLanguage)
					]);
			} else {
				if (totalProposalsState.$ === 2) {
					return A2($elm$core$List$repeat, 10, $author$project$Governance$CommonViews$loadingProposalRow);
				} else {
					return _List_Nil;
				}
			}
		}();
		var pagerFooter = function () {
			if (totalPages > 1) {
				var prevButton = (currentPageNumber > 1) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__previous'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalOverview$PagerPrevious)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$prev(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				var pagerIndicator = A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator')
						]),
					A2(
						$elm$core$List$map,
						function (i) {
							var activeClass = _Utils_eq(currentPageNumber, i) ? ' governance-panel__pager__indicator__text--active' : '';
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator__text' + activeClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(i))
									]));
						},
						A2($elm$core$List$range, 1, totalPages)));
				var nextButton = (_Utils_cmp(currentPageNumber, totalPages) < 0) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__next'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalOverview$PagerNext)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$next(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager')
						]),
					_List_fromArray(
						[prevButton, pagerIndicator, nextButton]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$all_proposals(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposals')
						]),
					proposalsForPage),
					pagerFooter
				]));
	});
var $author$project$Strings$Translations$governance_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance Proposals';
		case 1:
			return 'Propuestas de gobierno';
		case 2:
			return '治理方案';
		case 3:
			return 'Propositions de gouvernance';
		default:
			return '거버넌스 제안서';
	}
};
var $author$project$Governance$ProposalOverview$overviewHeader = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal-overview')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal-overview__header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$governance_proposals(userLanguage))
					]))
			]));
};
var $author$project$Governance$ProposalOverview$ActiveProposal = 0;
var $author$project$Governance$ProposalOverview$FailedProposal = 2;
var $author$project$Governance$ProposalOverview$PassedProposal = 1;
var $author$project$Governance$ProposalOverview$buildDataset = F3(
	function (activeCount, passedCount, failedCount) {
		var total = (activeCount + passedCount) + failedCount;
		return _List_fromArray(
			[
				{cA: activeCount / total},
				{cA: passedCount / total},
				{cA: failedCount / total}
			]);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{p: nodeList, l: nodeListSize, n: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Charty$Color$defaultPalette = $elm$core$Array$fromList(
	_List_fromArray(
		['#9669ED', '#00D395', '#657786']));
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Charty$Color$assignDefaults = function (dataset) {
	var colorCount = $elm$core$Array$length($author$project$Charty$Color$defaultPalette);
	var color = function (index) {
		var _v0 = A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, colorCount, index),
			$author$project$Charty$Color$defaultPalette);
		if (_v0.$ === 1) {
			return '#00D395';
		} else {
			var x = _v0.a;
			return x;
		}
	};
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, series) {
				return _Utils_Tuple2(
					color(i),
					series);
			}),
		dataset);
};
var $author$project$Charty$PieChart$defaults = {
	hn: 'transparent',
	eU: $author$project$Charty$Color$assignDefaults,
	fW: $elm$core$Maybe$Just(8)
};
var $author$project$Governance$ProposalOverview$getOverviewStateForProposal = function (proposal) {
	var maybeCurrentState = $elm$core$List$head(
		$elm$core$List$reverse(proposal.jM));
	if (!maybeCurrentState.$) {
		var currentState = maybeCurrentState.a;
		var _v1 = currentState.jL;
		switch (_v1) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 1;
			case 5:
				return 1;
			case 6:
				return 2;
			default:
				return 2;
		}
	} else {
		return 2;
	}
};
var $author$project$Charty$PieChart$accumulateStart = F2(
	function (start, slices) {
		if (!slices.b) {
			return _List_Nil;
		} else {
			var s = slices.a;
			var ss = slices.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(start, s),
				A2($author$project$Charty$PieChart$accumulateStart, start + s.dd, ss));
		}
	});
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $author$project$Charty$PieChart$circumferencePoint = function (percentage) {
	var ang = (percentage * (2 * $elm$core$Basics$pi)) / 100;
	return _Utils_Tuple2(
		70 * (1 + $elm$core$Basics$sin(ang)),
		70 * (1 - $elm$core$Basics$cos(ang)));
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $author$project$Charty$PieChart$drawSlice = F3(
	function (config, start, slice) {
		var largeArc = (slice.dd <= 50) ? '0' : '1';
		var _v0 = $author$project$Charty$PieChart$circumferencePoint(
			start + A2($elm$core$Basics$min, 99.9999, slice.dd));
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $author$project$Charty$PieChart$circumferencePoint(start);
		var x1 = _v1.a;
		var y1 = _v1.b;
		var pathDefinition = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$concat,
			$elm$core$String$join(' '))(
			_List_fromArray(
				[
					_List_fromArray(
					['M 70 70']),
					_List_fromArray(
					[
						'L ',
						$elm$core$String$fromFloat(x1),
						$elm$core$String$fromFloat(y1)
					]),
					_List_fromArray(
					['A 70 70 0', largeArc, '1']),
					_List_fromArray(
					[
						$elm$core$String$fromFloat(x2),
						$elm$core$String$fromFloat(y2)
					]),
					_List_fromArray(
					['Z'])
				]));
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(pathDefinition),
					$elm$svg$Svg$Attributes$stroke('transparent'),
					$elm$svg$Svg$Attributes$fill(slice.eT)
				]),
			_List_Nil);
	});
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $author$project$Charty$PieChart$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Charty$PieChart$drawSlices = F2(
	function (config, slices) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 140 140'),
					$elm$svg$Svg$Attributes$width('100%')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Charty$PieChart$uncurry(
					$author$project$Charty$PieChart$drawSlice(config)),
				A2($author$project$Charty$PieChart$accumulateStart, 0, slices)));
	});
var $author$project$Charty$PieChart$sumValues = A2(
	$elm$core$List$foldr,
	F2(
		function (_v0, s) {
			var value = _v0.cA;
			return value + s;
		}),
	0);
var $author$project$Charty$PieChart$normalize = function (dataset) {
	var sum = $author$project$Charty$PieChart$sumValues(dataset);
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var value = _v0.cA;
			return {cA: (100 * value) / sum};
		},
		dataset);
};
var $author$project$Charty$PieChart$truncate = F2(
	function (maxGroupCount, dataset) {
		if (maxGroupCount.$ === 1) {
			return dataset;
		} else {
			var n = maxGroupCount.a;
			var _v1 = A2($elm$core$List$drop, n - 1, dataset);
			if (!_v1.b) {
				return dataset;
			} else {
				if (!_v1.b.b) {
					return dataset;
				} else {
					var rest = _v1;
					return _Utils_ap(
						A2($elm$core$List$take, n - 1, dataset),
						_List_fromArray(
							[
								{
								cA: $author$project$Charty$PieChart$sumValues(rest)
							}
							]));
				}
			}
		}
	});
var $author$project$Charty$PieChart$preprocess = F2(
	function (config, dataset) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var color = _v0.a;
				var value = _v0.b.cA;
				return {eT: color, dd: value};
			},
			config.eU(
				A2(
					$author$project$Charty$PieChart$truncate,
					config.fW,
					$author$project$Charty$PieChart$normalize(dataset))));
	});
var $author$project$Charty$PieChart$view = F2(
	function (config, dataset) {
		var slices = A2($author$project$Charty$PieChart$preprocess, config, dataset);
		return A2($author$project$Charty$PieChart$drawSlices, config, slices);
	});
var $author$project$Governance$ProposalOverview$proposalsPieChart = F2(
	function (userLanguage, _v0) {
		var totalProposalsState = _v0.cw;
		var proposalsPageMap = _v0.ci;
		var totalProposalsText = function () {
			if (!totalProposalsState.$) {
				var total = totalProposalsState.a;
				return $elm$core$String$fromInt(total);
			} else {
				return '...';
			}
		}();
		var pieChart = function () {
			var _v1 = _Utils_Tuple2(
				totalProposalsState,
				A2($elm$core$Dict$get, 1, proposalsPageMap));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var totalProposals = _v1.a.a;
				var firstPageProposals = _v1.b.a;
				if (_Utils_cmp(totalProposals, $author$project$Governance$ProposalOverview$desiredPageSize) < 1) {
					var filterFunction = F2(
						function (desiredOverviewState, proposal) {
							return _Utils_eq(
								$author$project$Governance$ProposalOverview$getOverviewStateForProposal(proposal),
								desiredOverviewState) ? $elm$core$Maybe$Just(proposal) : $elm$core$Maybe$Nothing;
						});
					var passedProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(1),
							firstPageProposals));
					var failedProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(2),
							firstPageProposals));
					var activeProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(0),
							firstPageProposals));
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-chart')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Charty$PieChart$view,
								$author$project$Charty$PieChart$defaults,
								A3($author$project$Governance$ProposalOverview$buildDataset, activeProposals, passedProposals, failedProposals))
							]));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-chart')
							]),
						_List_fromArray(
							[
								A2($author$project$Charty$PieChart$view, $author$project$Charty$PieChart$defaults, _List_Nil)
							]));
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-chart')
						]),
					_List_fromArray(
						[
							A2($author$project$Charty$PieChart$view, $author$project$Charty$PieChart$defaults, _List_Nil)
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-wrapper')
						]),
					_List_fromArray(
						[
							pieChart,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-description')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('headline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(totalProposalsText)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-labels')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposal_state_active(userLanguage))
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('passed')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposal_state_passed(userLanguage))
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('failed')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposal_state_failed(userLanguage))
								]))
						]))
				]));
	});
var $author$project$Governance$ProposalOverview$view = F4(
	function (userLanguage, timezone, maybeCurrentTime, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('ProposalOverview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									$author$project$Strings$Translations$overview(userLanguage),
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome),
									$author$project$Governance$ProposalOverview$overviewHeader(userLanguage),
									$elm$core$Maybe$Just(
										A2($author$project$Governance$ProposalOverview$proposalsPieChart, userLanguage, model)))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A4($author$project$Governance$ProposalOverview$allProposalsPane, userLanguage, timezone, maybeCurrentTime, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$about_page_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The majority of cryptocurrencies sit idle on exchanges and in wallets, without yielding interest. We\'re on a mission to change that.';
		case 1:
			return 'La mayoría de las criptomonedas permanecen inactivas en los intercambios y en las billeteras, sin generar interés. Estamos en una misión para cambiar eso.';
		case 2:
			return '大多数加密货币闲置在交易所与钱包中，没有利息。我们的使命就是改变这种状况。';
		case 3:
			return 'La majorité des crypto-monnaies restent inactives sur les échanges et dans les portefeuilles, sans susciter d\'intérêt. Nous avons pour mission de changer cela.';
		default:
			return '암호 화폐의 대부분은 거래소와 지갑에서 유휴 상태로 유지됩니다. 우리는 그것을 바꾸는 임무를 수행하고 있습니다.';
	}
};
var $author$project$Strings$Translations$adam_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously led developer relations at PubNub. Software engineer. Growth hacker.';
		case 1:
			return 'Anteriormente lideró las relaciones con los desarrolladores en PubNub. Ingeniero de software. Hacker de crecimiento.';
		case 2:
			return '曾在PubNub领导开发人员关系。软件工程师。成长型黑客。';
		case 3:
			return 'Auparavant, il a dirigé les relations avec les développeurs chez PubNub. Ingénieur logiciel. Pirate de croissance.';
		default:
			return 'PubNub에서 이전에 개발자 관계를 주도했습니다. 소프트웨어 엔지니어. 성장 해커.';
	}
};
var $author$project$Strings$Translations$application_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Application Lead';
		case 1:
			return 'Solicitud de plomo';
		case 2:
			return '应用程序主管';
		case 3:
			return 'Responsable de l\'application';
		default:
			return '응용 프로그램 리드';
	}
};
var $author$project$Strings$Translations$business_development = function (lang) {
	switch (lang) {
		case 0:
			return 'Business Development';
		case 1:
			return 'Desarrollo de negocios';
		case 2:
			return '业务发展';
		case 3:
			return 'Développement des affaires';
		default:
			return '사업 개발';
	}
};
var $author$project$Strings$Translations$calvin_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously analytics at Gusto, advisor to digital currency startups at Promontory, long-time crypto investor.';
		case 1:
			return 'Anteriormente analítica en Gusto, asesor de nuevas empresas de moneda digital en Promontory, inversor criptográfico de larga data.';
		case 2:
			return 'Gusto 的前分析师，是 Promontory 数字货币初创公司的顾问，长期从事数字资产的投资。';
		case 3:
			return 'Auparavant, analytique chez Gusto, conseiller pour les startups de monnaie numérique chez Promontory, investisseur de longue date en crypto.';
		default:
			return '이전에는 장기간 암호 투자자 인 Promontory의 디지털 통화 신생 기업 고문 인 Gusto의 분석.';
	}
};
var $author$project$Strings$Translations$ceo = function (lang) {
	switch (lang) {
		case 0:
			return 'CEO';
		case 1:
			return 'CEO';
		case 2:
			return 'CEO';
		case 3:
			return 'PDG';
		default:
			return '최고 경영자';
	}
};
var $author$project$Strings$Translations$coburn_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Experienced web stack engineer from The RealReal; previously an attorney.';
		case 1:
			return 'Ingeniero experimentado en web stack de The RealReal; Anteriormente un abogado.';
		case 2:
			return '来自 RealReal 的经验丰富的 web 堆栈工程师；以前是一位律师。';
		case 3:
			return 'Ingénieur de pile Web expérimenté de The RealReal; auparavant avocat.';
		default:
			return 'The RealReal의 숙련 된 웹 스택 엔지니어; 이전에는 변호사였습니다.';
	}
};
var $author$project$Strings$Translations$cto = function (lang) {
	switch (lang) {
		case 0:
			return 'CTO';
		case 1:
			return 'CTO';
		case 2:
			return 'CTO';
		case 3:
			return 'CTO';
		default:
			return 'CTO';
	}
};
var $author$project$Strings$Translations$date_february_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'February 2019';
		case 1:
			return 'Febrero 2019';
		case 2:
			return '2019 年 2 月';
		case 3:
			return 'Février 2019';
		default:
			return '2019 년 2 월';
	}
};
var $author$project$Strings$Translations$date_july_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'July 2019';
		case 1:
			return 'Julio 2019';
		case 2:
			return '2019 年 7 月';
		case 3:
			return 'Juillet 2019';
		default:
			return '2019 년 7 월';
	}
};
var $author$project$Strings$Translations$date_june_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'June 2019';
		case 1:
			return 'Junio 2019';
		case 2:
			return '2019 年 6 月';
		case 3:
			return 'Juin 2019';
		default:
			return '2019 년 6 월';
	}
};
var $author$project$Strings$Translations$date_may_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'May 2018';
		case 1:
			return 'Mayo 2018';
		case 2:
			return '2018 年 5 月';
		case 3:
			return 'Mai 2018';
		default:
			return '2018 년 5 월';
	}
};
var $author$project$Strings$Translations$date_nov_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'November 2018';
		case 1:
			return 'Noviembre 2018';
		case 2:
			return '2018 年 11 月';
		case 3:
			return 'Novembre 2018';
		default:
			return '2018 년 11 월';
	}
};
var $author$project$Strings$Translations$date_nov_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'November 2019';
		case 1:
			return 'Noviembre 2019';
		case 2:
			return '2019年十一月';
		case 3:
			return 'Novembre 2019';
		default:
			return '2019 년 11 월';
	}
};
var $author$project$Strings$Translations$date_september_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'September 2018';
		case 1:
			return 'Septiembre 2018';
		case 2:
			return '2018 年 9 月';
		case 3:
			return 'Septembre 2018';
		default:
			return '2018 년 9 월';
	}
};
var $author$project$Strings$Translations$developer_relations_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Developer Relations Lead';
		case 1:
			return 'Líder de Relaciones con Desarrolladores';
		case 2:
			return '开发人员关系主管';
		case 3:
			return 'Responsable des relations avec les développeurs';
		default:
			return '개발자 관계 담당';
	}
};
var $author$project$Strings$Translations$general_counsel = function (lang) {
	switch (lang) {
		case 0:
			return 'General Counsel';
		case 1:
			return 'Consejero general';
		case 2:
			return '法律顾问';
		case 3:
			return 'Avocat général';
		default:
			return '법률 고문';
	}
};
var $author$project$Strings$Translations$geoff_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Maintainer of Exthereum, technology founder of two startups, led Core Services at Postmates.';
		case 1:
			return 'Mantenedor de Exthereum, fundador de tecnología de dos nuevas empresas, dirigió Core Services en Postmates.';
		case 2:
			return 'Ethereum 的维护者，两家初创公司的技术创始人，领导着 Postmates 的核心服务。';
		case 3:
			return 'Mainteneur d\'Exthereum, fondateur de la technologie de deux startups, a dirigé les services de base chez Postmates.';
		default:
			return '두 스타트 업의 기술 창립자 인 Exthereum의 관리자는 Postmates의 핵심 서비스를 주도했습니다.';
	}
};
var $author$project$Strings$Translations$head_of_design = function (lang) {
	switch (lang) {
		case 0:
			return 'Head of Design';
		case 1:
			return 'Jefe de diseño';
		case 2:
			return '首席设计师';
		case 3:
			return 'Responsable Design';
		default:
			return '디자인 책임자';
	}
};
var $author$project$Strings$Translations$help_build = function (lang) {
	switch (lang) {
		case 0:
			return 'Help build the future of finance';
		case 1:
			return 'Ayuda a construir el futuro de las finanzas';
		case 2:
			return '帮助建设金融的未来';
		case 3:
			return 'Aidez à construire l\'avenir de la finance';
		default:
			return '금융의 미래를 건설하십시오';
	}
};
var $author$project$Strings$Translations$jake_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Lawyer. Twitter pro. Former litigator and compliance counsel at Kobre & Kim and Baker McKenzie.';
		case 1:
			return 'Abogado. Twitter pro. Ex abogado litigante y consejero de cumplimiento en Kobre &amp; Kim y Baker McKenzie.';
		case 2:
			return '律师。Twitter pro。曾在 Kobre & Kim & Baker McKenzie 担任诉讼律师和合规律师。';
		case 3:
			return 'Avocat. Twitter pro. Ancien avocat plaidant et conseiller en conformité chez Kobre & Kim et Baker McKenzie.';
		default:
			return '변호사. 트위터 프로. Kobre & Kim과 Baker McKenzie의 전 변호사 및 준법 고문';
	}
};
var $author$project$Strings$Translations$jared_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Diverse background in distributed systems; previously Nokia Research, AdRoll, Caffeine, et al.';
		case 1:
			return 'Diversos antecedentes en sistemas distribuidos; anteriormente Nokia Research, AdRoll, Caffeine, et al.';
		case 2:
			return '具有丰富分布式系统背景；前诺基亚研究员，AdRoll， Caffeine 等。';
		case 3:
			return 'Expérience diversifiée dans les systèmes distribués; auparavant Nokia Research, AdRoll, Caffeine, et al.';
		default:
			return '분산 시스템의 다양한 배경; 이전에 Nokia Research, AdRoll, Caffeine 등';
	}
};
var $author$project$Strings$Translations$jayson_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Led product design for Coinbase Pro and Coinbase Custody; previously Otto / Uber Freight, agencies.';
		case 1:
			return 'Diseño de producto dirigido para Coinbase Pro y Coinbase Custody; anteriormente Otto / Uber Freight, agencias.';
		case 2:
			return '为 Coinbase Pro 和 Coinbase 托管主导产品设计；前奥托/优步货运代理。';
		case 3:
			return 'Conception de produits LED pour Coinbase Pro et Coinbase Custody; auparavant Otto / Uber Freight, agences.';
		default:
			return 'Coinbase Pro 및 Coinbase Custody를위한 LED 제품 디자인; 이전에 Otto / Uber Freight, 대행사입니다.';
	}
};
var $author$project$Strings$Translations$join_us = function (lang) {
	switch (lang) {
		case 0:
			return 'Join us';
		case 1:
			return 'Únete a nosotros';
		case 2:
			return '加入我们';
		case 3:
			return 'Rejoignez-nous';
		default:
			return '우리와 함께';
	}
};
var $author$project$Strings$Translations$max_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Open finance enthusiast. Former co-founder of Marble Protocol. Economics at Stanford.';
		case 1:
			return 'Entusiasta de las finanzas abiertas. Ex cofundador de Marble Protocol. Economía en Stanford.';
		case 2:
			return '开放金融爱好者。Marble 协议的前联合创始人。斯坦福大学经济学。';
		case 3:
			return 'Passionné de finance ouverte. Ancien co-fondateur de Marble Protocol. Économie à Stanford.';
		default:
			return '열린 금융 애호가. Marble Protocol의 전 공동 설립자. 스탠포드 경제학.';
	}
};
var $author$project$Strings$Translations$mykel_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Full stack engineer. Former co-founder of Marble Protocol and Haywheel (YC S16).';
		case 1:
			return 'Ingeniero de pila completa. Ex cofundador de Marble Protocol y Haywheel (YC S16).';
		case 2:
			return '全栈工程师。Marble 协议和 Haywheel (YC S16) 的前联合创始人。';
		case 3:
			return 'Ingénieur full stack. Ancien co-fondateur de Marble Protocol et Haywheel (YC S16).';
		default:
			return '풀 스택 엔지니어. Marble Protocol and Haywheel (YC S16)의 공동 설립자.';
	}
};
var $author$project$Strings$Translations$nick_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously led business development and fundraising initiatives at Pantera Capital. Economics at UCSB.';
		case 1:
			return 'Anteriormente dirigió iniciativas de desarrollo de negocios y recaudación de fondos en Pantera Capital. Economía en UCSB.';
		case 2:
			return '曾在Pantera Capital领导业务发展和筹款计划。 UCSB经济学。';
		case 3:
			return 'Auparavant, il a dirigé des initiatives de développement commercial et de collecte de fonds chez Pantera Capital. Économie à UCSB.';
		default:
			return '판테라 캐피탈 (Pantera Capital)의 이전 사업 개발 및 모금 활동. UCSB의 경제학.';
	}
};
var $author$project$Strings$Translations$our_team = function (lang) {
	switch (lang) {
		case 0:
			return 'Our Team';
		case 1:
			return 'Nuestro equipo';
		case 2:
			return '我们的团队';
		case 3:
			return 'Notre équipe';
		default:
			return '우리 팀';
	}
};
var $author$project$Strings$Translations$press_compound_adds_wbtc = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound adds WBTC after users ‘overwhelmingly’ vote yes on the token';
		case 1:
			return 'Compound agrega WBTC después de que los usuarios voten &quot;abrumadoramente&quot; sí al token';
		case 2:
			return '在用户以压倒性优势对代币投赞成票后，Compound 添加了 WBTC';
		case 3:
			return 'Le composé ajoute le WBTC après que les utilisateurs ont massivement voté oui sur le jeton';
		default:
			return '컴파운드, 사용자가 토큰에 대해 압도적으로 투표 한 후 WBTC 추가';
	}
};
var $author$project$Strings$Translations$press_compound_lets_you_holdl_and_earn = function (lang) {
	switch (lang) {
		case 0:
			return 'Crypto Money Market Compound Lets You HODL and Earn';
		case 1:
			return 'Crypto Money Market Compound Lets You HODL and Earn ';
		case 2:
			return '加密货币市场 Compound 让您 HODL 和赚钱';
		case 3:
			return 'Composé du marché monétaire Crypto vous permet de HODL et de gagner';
		default:
			return 'Crypto Money Market Compound를 통해 HODL 및 적립 가능';
	}
};
var $author$project$Strings$Translations$press_compound_partners_for_v2_launch = function (lang) {
	switch (lang) {
		case 0:
			return 'DeFi Pioneer Compound Partners With Coinbase Wallet, Zerion for V2 Launch';
		case 1:
			return 'DeFi Pioneer Compound se asocia con Coinbase Wallet, Zerion para el lanzamiento de V2';
		case 2:
			return 'DeFi 先锋 Compound 与 Coinbase 钱包合作，为 V2 推出 Zerion';
		case 3:
			return 'DeFi Pioneer Compound s\'associe à Coinbase Wallet et Zerion pour le lancement de V2';
		default:
			return 'DeFi Pioneer Compound, Coinbase Wallet, Zerion for V2 출시 파트너';
	}
};
var $author$project$Strings$Translations$press_compound_the_block_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound, the decentralized money market protocol';
		case 1:
			return 'Compound, el protocolo descentralizado del mercado monetario';
		case 2:
			return 'Compound，去中心化货币市场协议';
		case 3:
			return 'Compound, le protocole du marché monétaire décentralisé';
		default:
			return 'Compound, 탈중앙형 머니 마켓 프로토콜';
	}
};
var $author$project$Strings$Translations$press_latest_threat_to_crypto_prices = function (lang) {
	switch (lang) {
		case 0:
			return 'The Latest Threat to Crypto Prices? The Federal Reserve';
		case 1:
			return '¿La última amenaza para los precios criptográficos? La reserva Federal';
		case 2:
			return '加密货币价格面临的最新威胁是什么？美国联邦储备理事会';
		case 3:
			return 'La dernière menace pour les prix de la cryptographie? La Réserve fédérale';
		default:
			return '암호 화폐 가격에 대한 최신 위협? 연방 준비금';
	}
};
var $author$project$Strings$Translations$press_money_markets_in_the_works = function (lang) {
	switch (lang) {
		case 0:
			return 'Money Markets for Crypto Assets Are in the Works';
		case 1:
			return 'Mercados de dinero para activos criptográficos están en proceso';
		case 2:
			return '加密资产的货币市场正在酝酿之中';
		case 3:
			return 'Les marchés monétaires pour les actifs cryptographiques sont en marche';
		default:
			return '암호화 자산의 머니 마켓이 작동합니다';
	}
};
var $author$project$Strings$Translations$press_put_your_bitcoins_in = function (lang) {
	switch (lang) {
		case 0:
			return 'Put Your Bitcoins in the Money Market';
		case 1:
			return 'Ponga sus Bitcoins en el mercado monetario';
		case 2:
			return '把你的比特币投入货币市场';
		case 3:
			return 'Mettez vos Bitcoins sur le marché monétaire';
		default:
			return '머니 마켓에 비트 코인 넣기';
	}
};
var $author$project$Strings$Translations$press_raises_25 = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Raises $25 Million to Expand Crypto Lending';
		case 1:
			return 'El compuesto recauda $ 25 millones para ampliar los préstamos criptográficos';
		case 2:
			return '复合筹集2500万美元以扩大加密贷款';
		case 3:
			return 'Compound lève 25 millions de dollars pour étendre les prêts cryptographiques';
		default:
			return '화합물, 2,500 만 달러로 암호화 대출 확대';
	}
};
var $author$project$Strings$Translations$press_why_stablecoins_standout = function (lang) {
	switch (lang) {
		case 0:
			return 'Why Stablecoins Stand Out in the Cryptocurrency World';
		case 1:
			return '¿Por qué Stablecoins se destaca en el mundo de las criptomonedas?';
		case 2:
			return '为什么稳定币在加密货币世界中脱颖而出';
		case 3:
			return 'Pourquoi les Stablecoins se distinguent dans le monde des crypto-monnaies';
		default:
			return 'Cryptocurrency 세계에서 Stablecoins가 탁월한 이유';
	}
};
var $author$project$Strings$Translations$recent_press = function (lang) {
	switch (lang) {
		case 0:
			return 'Recent Press';
		case 1:
			return 'Prensa reciente';
		case 2:
			return '近期新闻';
		case 3:
			return 'Presse récente';
		default:
			return '최근 소식';
	}
};
var $author$project$Strings$Translations$robert_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Chartered Financial Analyst, former economist, and founder of two software startups.';
		case 1:
			return 'Analista financiero colegiado, ex economista y fundador de dos nuevas empresas de software.';
		case 2:
			return '特许金融分析师，前经济学家，两家软件初创公司的创始人。';
		case 3:
			return 'Chartered Financial Analyst, ancien économiste et fondateur de deux startups logicielles.';
		default:
			return 'Chartered Financial Analyst, 전 경제학자, 두 소프트웨어 스타트 업 창립자.';
	}
};
var $author$project$Strings$Translations$senior_engineer = function (lang) {
	switch (lang) {
		case 0:
			return 'Senior Engineer';
		case 1:
			return 'Ingeniero senior';
		case 2:
			return '高级工程师';
		case 3:
			return 'Ingénieur senior';
		default:
			return '수석 엔지니어';
	}
};
var $author$project$Strings$Translations$software_engineer = function (lang) {
	switch (lang) {
		case 0:
			return 'Software Engineer';
		case 1:
			return 'Ingeniero de software';
		case 2:
			return '软件工程师';
		case 3:
			return 'Ingénieur logiciel';
		default:
			return '소프트웨어 엔지니어';
	}
};
var $author$project$Strings$Translations$strategy_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Strategy Lead';
		case 1:
			return 'Jefe de estrategia';
		case 2:
			return '战略主管';
		case 3:
			return 'Responsable de la stratégie';
		default:
			return '전략 책임자';
	}
};
var $author$project$LandingSite$About$teamMember = F4(
	function (imgSrc, name, title, description) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-12')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('member-img'),
									$author$project$Utils$CompoundHtmlAttributes$src(imgSrc)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$toni_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Blockchain & Backend engineering, formerly at ConsenSys, OTCXN.';
		case 1:
			return 'Ingeniería de blockchain y backend, anteriormente en ConsenSys, OTCXN.';
		case 2:
			return '区块链和后端工程，以前在OTCXN的ConsenSys工作。';
		case 3:
			return 'Blockchain & Backend engineering, anciennement chez ConsenSys, OTCXN.';
		default:
			return 'OTCXN의 ConsenSys에 있던 블록 체인 및 백엔드 엔지니어링.';
	}
};
var $author$project$Strings$Translations$torrey_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Led mobile development at Postmates, Kahuna, and Aha Mobile.';
		case 1:
			return 'Lideró el desarrollo móvil en Postmates, Kahuna y Aha Mobile.';
		case 2:
			return '负责 Postmates、Kahuna 和 Aha mobile 的移动端开发。';
		case 3:
			return 'A dirigé le développement mobile chez Postmates, Kahuna et Aha Mobile.';
		default:
			return 'Postmates, Kahuna 및 Aha Mobile에서 모바일 개발을 주도했습니다.';
	}
};
var $author$project$Strings$Translations$we_are_compound = function (lang) {
	switch (lang) {
		case 0:
			return 'We\'re Compound';
		case 1:
			return 'Somos Compound';
		case 2:
			return '我们是 Compound';
		case 3:
			return 'Nous sommes composés';
		default:
			return '우리는 Compound 입니다';
	}
};
var $author$project$Strings$Translations$zack_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Engineering & DevOps at MakerDAO, Wyre, and finance companies.';
		case 1:
			return 'Ingeniería y DevOps en MakerDAO, Wyre y compañías financieras.';
		case 2:
			return 'MakerDAO，Wyre和金融公司的Engineering＆DevOps。';
		case 3:
			return 'Ingénierie et DevOps chez MakerDAO, Wyre et sociétés financières.';
		default:
			return 'MakerDAO, Wyre 및 금융 회사의 엔지니어링 및 DevOps';
	}
};
var $author$project$LandingSite$About$view = F2(
	function (userLanguage, model) {
		var jobs = function () {
			var _v0 = model.d6;
			if (!_v0.$) {
				var responseJobs = _v0.a;
				return responseJobs;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('landing-overview'),
							$author$project$Utils$CompoundHtmlAttributes$class('light')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 text-left we-are-compound')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$we_are_compound(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$about_page_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('team')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('our-team')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$our_team(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row members')
										]),
									_List_fromArray(
										[
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_robert.jpg',
											'Robert Leshner',
											$author$project$Strings$Translations$ceo(userLanguage),
											$author$project$Strings$Translations$robert_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_geoff.jpg',
											'Geoffrey Hayes',
											$author$project$Strings$Translations$cto(userLanguage),
											$author$project$Strings$Translations$geoff_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_torrey.jpg',
											'Torrey Atcitty',
											$author$project$Strings$Translations$application_lead(userLanguage),
											$author$project$Strings$Translations$torrey_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_calvin.jpg',
											'Calvin Liu',
											$author$project$Strings$Translations$strategy_lead(userLanguage),
											$author$project$Strings$Translations$calvin_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_coburn.jpg',
											'Coburn Berry',
											$author$project$Strings$Translations$senior_engineer(userLanguage),
											$author$project$Strings$Translations$coburn_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jared.jpg',
											'Jared Flatow',
											$author$project$Strings$Translations$senior_engineer(userLanguage),
											$author$project$Strings$Translations$jared_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jayson.jpg',
											'Jayson Hobby',
											$author$project$Strings$Translations$head_of_design(userLanguage),
											$author$project$Strings$Translations$jayson_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jake.jpeg',
											'Jake Chervinsky',
											$author$project$Strings$Translations$general_counsel(userLanguage),
											$author$project$Strings$Translations$jake_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_max.jpg',
											'Max Wolff',
											$author$project$Strings$Translations$software_engineer(userLanguage),
											$author$project$Strings$Translations$max_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_mykel.jpg',
											'Mykel Pereira',
											$author$project$Strings$Translations$software_engineer(userLanguage),
											$author$project$Strings$Translations$mykel_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_adam.jpg',
											'Adam Bavosa',
											$author$project$Strings$Translations$developer_relations_lead(userLanguage),
											$author$project$Strings$Translations$adam_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_nick.jpg',
											'Nick Martitsch',
											$author$project$Strings$Translations$business_development(userLanguage),
											$author$project$Strings$Translations$nick_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_zack.jpeg',
											'Zachary Skolnik',
											$author$project$Strings$Translations$senior_engineer(userLanguage),
											$author$project$Strings$Translations$zack_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_toni.jpg',
											'Antonina Norair',
											$author$project$Strings$Translations$senior_engineer(userLanguage),
											$author$project$Strings$Translations$toni_description(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-left')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-right')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('jobs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-5 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$join_us(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$help_build(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 jobs')
												]),
											A2(
												$elm$core$List$concatMap,
												function (job) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('line')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('job-item'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, job.nD)),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('job-details-section')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h3,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('job-title')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(job.nb)
																				])),
																			A2(
																			$elm$html$Html$h3,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('job-location')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(job.kI.lO)
																				]))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow big green')
																		]),
																	_List_Nil)
																]))
														]);
												},
												A2(
													$elm$core$List$sortBy,
													function ($) {
														return $.nb;
													},
													jobs)))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('press')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('press-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$recent_press(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 col-xs-12')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://fortune.com/2019/11/14/crypto-interest-startup-compound-decentralized-finance/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_fortune.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_raises_25(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_nov_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://finance.yahoo.com/news/compound-adds-wbtc-users-overwhelmingly-231701877.html')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_yahoo.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_adds_wbtc(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_july_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.wsj.com/articles/why-stablecoins-stand-out-in-the-cryptocurrency-world-11560218460')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_wsj.jpg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_why_stablecoins_standout(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_june_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.theblockcrypto.com/2019/02/26/compound-the-decentralized-money-market-protocol/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_theblock.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_the_block_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_february_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'http://fortune.com/2018/11/03/crypto-interest-rates/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_fortune.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_latest_threat_to_crypto_prices(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_nov_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.coindesk.com/crypto-money-market-compound-lets-you-hodl-and-earn-interest/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_coindesk.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_lets_you_holdl_and_earn(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_september_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.coindesk.com/defi-pioneer-compound-partners-with-coinbase-wallet-zerion-for-v2-launch')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_coindesk.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_partners_for_v2_launch(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.bloomberg.com/view/articles/2018-05-17/put-your-bitcoins-in-the-money-market')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_bloomberg.jpeg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_put_your_bitcoins_in(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.wsj.com/articles/money-markets-for-crypto-assets-are-in-the-works-1526470201')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_wsj.jpg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_money_markets_in_the_works(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$CTokens$ForSelf = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$CTokens$SelectCToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$LandingSite$CTokens$SelectCodeSnippet = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$CTokens$ToggleAccordianAtIndex = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandingSite$CTokens$ToggleDropdown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Strings$Translations$api = function (lang) {
	switch (lang) {
		case 0:
			return 'API';
		case 1:
			return 'API';
		case 2:
			return 'API';
		case 3:
			return 'API';
		default:
			return 'API';
	}
};
var $author$project$Utils$Graph$buildGraphData = F3(
	function (cTokenAddress, interestRateDataMap, formatter) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Eth$Ethereum$getContractAddressString(cTokenAddress),
			interestRateDataMap);
		if (!_v0.$) {
			var interestRateData = _v0.a;
			var tupleFirstComparison = F2(
				function (a, b) {
					return A2($elm$core$Basics$compare, a.a, b.a);
				});
			return A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.a;
						var v = _v1.b;
						return _Utils_Tuple2(
							k,
							$author$project$Decimal$toFloat(
								formatter(v)));
					},
					$elm$core$Dict$toList(interestRateData)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Strings$Translations$build_with = function (lang) {
	switch (lang) {
		case 0:
			return 'Build with cTokens';
		case 1:
			return 'Construir con cTokens';
		case 2:
			return '使用 cTokens 构建';
		case 3:
			return 'Construire avec cTokens';
		default:
			return 'cToken으로 빌드';
	}
};
var $author$project$Strings$Translations$build_with_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Help create the new open financial system.';
		case 1:
			return 'Ayuda a crear el nuevo sistema financiero abierto.';
		case 2:
			return '帮助创建新的开放式金融系统。';
		case 3:
			return 'Aidez à créer le nouveau système financier ouvert.';
		default:
			return '새로운 개방형 금융 시스템을 만들 수 있습니다.';
	}
};
var $author$project$Strings$Translations$c_tokens_api_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The cToken API retrieves information for all cTokens. You can use this API to pull data about all cTokens:';
		case 1:
			return 'La API de cToken recupera información para todos los cTokens. Puede usar esta API para extraer datos sobre todos los cTokens:';
		case 2:
			return 'cToken API 检索所有 cTokens 的信息。您可以使用此 API 来提取有关所有 cTokens 的数据：';
		case 3:
			return 'L\'API cToken récupère des informations pour tous les cTokens. Vous pouvez utiliser cette API pour extraire des données sur tous les cTokens:';
		default:
			return 'cToken API는 모든 cToken에 대한 정보를 검색합니다. 이 API를 사용하여 모든 cToken에 대한 데이터를 가져올 수 있습니다.';
	}
};
var $author$project$Strings$Translations$erc_20 = function (lang) {
	switch (lang) {
		case 0:
			return 'ERC-20';
		case 1:
			return 'ERC-20';
		case 2:
			return 'ERC-20';
		case 3:
			return 'ERC-20';
		default:
			return 'ERC-20';
	}
};
var $author$project$Strings$Translations$erc_20_description = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens conform to the ERC-20 standard, and work just like other assets.';
		case 1:
			return 'Los cTokens cumplen con el estándar ERC-20 y funcionan igual que otros activos.';
		case 2:
			return 'cToken符合ERC-20标准';
		case 3:
			return 'Les cTokens sont conformes à la norme ERC-20 et fonctionnent comme les autres actifs.';
		default:
			return 'c 토큰은 ERC-20 표준을 준수하며 다른 자산과 동일하게 작동합니다.';
	}
};
var $author$project$Strings$Translations$error_code = function (lang) {
	switch (lang) {
		case 0:
			return 'Error Code.';
		case 1:
			return 'Código de error.';
		case 2:
			return '错误代码。';
		case 3:
			return 'Code d\'erreur.';
		default:
			return '에러 코드.';
	}
};
var $author$project$LandingSite$CTokens$Datum = F2(
	function (block_timestamp, rate) {
		return {kv: block_timestamp, jt: rate};
	});
var $author$project$LandingSite$CTokens$GraphPointHover = function (a) {
	return {$: 1, a: a};
};
var $author$project$LineChart$Container$Margin = F4(
	function (top, right, bottom, left) {
		return {kC: bottom, lK: left, mA: right, nl: top};
	});
var $author$project$Internal$Container$Config = $elm$core$Basics$identity;
var $author$project$Internal$Container$custom = $elm$core$Basics$identity;
var $author$project$LineChart$Container$custom = $author$project$Internal$Container$custom;
var $author$project$Internal$Container$Relative = 1;
var $author$project$Internal$Container$relative = 1;
var $author$project$LineChart$Container$relative = $author$project$Internal$Container$relative;
var $author$project$LandingSite$CTokens$containerConfig = $author$project$LineChart$Container$custom(
	{
		dE: _List_Nil,
		dF: _List_Nil,
		ir: 'line-chart-area',
		eb: A4($author$project$LineChart$Container$Margin, 15, -20, -10, -20),
		by: $author$project$LineChart$Container$relative
	});
var $author$project$Internal$Junk$Config = $elm$core$Basics$identity;
var $author$project$Internal$Junk$custom = function (func) {
	return F3(
		function (_v0, _v1, _v2) {
			return func;
		});
};
var $author$project$LineChart$Junk$custom = $author$project$Internal$Junk$custom;
var $author$project$Internal$Dots$Config = $elm$core$Basics$identity;
var $author$project$Internal$Dots$customAny = $elm$core$Basics$identity;
var $author$project$LineChart$Dots$customAny = $author$project$Internal$Dots$customAny;
var $author$project$LandingSite$CTokens$dotIsHovered = F2(
	function (maybeHoveredPointXValue, datum) {
		if (!maybeHoveredPointXValue.$) {
			var hoveredPointXValue = maybeHoveredPointXValue.a;
			return _Utils_eq(hoveredPointXValue, datum.kv);
		} else {
			return false;
		}
	});
var $author$project$Internal$Dots$Empty = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Dots$Style = $elm$core$Basics$identity;
var $author$project$Internal$Dots$style = F2(
	function (radius, variety) {
		return {gr: radius, g2: variety};
	});
var $author$project$Internal$Dots$empty = F2(
	function (radius, border) {
		return A2(
			$author$project$Internal$Dots$style,
			radius,
			$author$project$Internal$Dots$Empty(border));
	});
var $author$project$LineChart$Dots$empty = $author$project$Internal$Dots$empty;
var $author$project$LandingSite$CTokens$customDotsConfig = function (maybeHoveredPointXValue) {
	var styleHover = A2($author$project$LineChart$Dots$empty, 4, 2);
	var styleDefault = A2($author$project$LineChart$Dots$empty, 0, 0);
	var styleIndividual = function (datum) {
		return A2($author$project$LandingSite$CTokens$dotIsHovered, maybeHoveredPointXValue, datum) ? styleHover : styleDefault;
	};
	var styleLegend = function (data) {
		return A2(
			$elm$core$List$any,
			$author$project$LandingSite$CTokens$dotIsHovered(maybeHoveredPointXValue),
			data) ? styleHover : styleDefault;
	};
	return $author$project$LineChart$Dots$customAny(
		{fy: styleIndividual, fG: styleLegend});
};
var $author$project$Internal$Area$None = {$: 0};
var $author$project$Internal$Area$none = $author$project$Internal$Area$None;
var $author$project$LineChart$Area$default = $author$project$Internal$Area$none;
var $author$project$Internal$Axis$Intersection$Config = $elm$core$Basics$identity;
var $author$project$Internal$Data$Point = F2(
	function (x, y) {
		return {ab: x, ad: y};
	});
var $author$project$Internal$Axis$Intersection$custom = F2(
	function (toX, toY) {
		return function (_v0) {
			var x = _v0.ab;
			var y = _v0.ad;
			return A2(
				$author$project$Internal$Data$Point,
				toX(x),
				toY(y));
		};
	});
var $author$project$Internal$Axis$Intersection$default = A2(
	$author$project$Internal$Axis$Intersection$custom,
	function ($) {
		return $.ej;
	},
	function ($) {
		return $.ej;
	});
var $author$project$LineChart$Axis$Intersection$default = $author$project$Internal$Axis$Intersection$default;
var $author$project$Internal$Junk$Layers = F3(
	function (below, above, html) {
		return {eG: above, cE: below, lv: html};
	});
var $author$project$Internal$Junk$none = F4(
	function (_v0, _v1, _v2, _v3) {
		return A3($author$project$Internal$Junk$Layers, _List_Nil, _List_Nil, _List_Nil);
	});
var $author$project$LineChart$Junk$default = $author$project$Internal$Junk$none;
var $author$project$Internal$Grid$Dots = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Grid$dots = $author$project$Internal$Grid$Dots;
var $author$project$LineChart$Grid$dots = $author$project$Internal$Grid$dots;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {hT: d, i1: m, ke: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		f8: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		ke: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ke, 0, date.f8);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hT;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.i1;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.f8;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ka: 1 + (((rd - week1Day1) / 7) | 0),
		kb: wy,
		nL: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ka;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.kb;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.ek(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.f2(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ek(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.fa(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bD(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bD(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bD(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.g5(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bD(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bD(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {hC: col, mn: problem, mB: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.mB, p.hC, p.mn);
};
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	fa: $justinmimbs$date$Date$withOrdinalSuffix,
	f2: $justinmimbs$date$Date$monthToName,
	ek: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	g5: $justinmimbs$date$Date$weekdayToName,
	bD: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Internal$Events$Config = $elm$core$Basics$identity;
var $author$project$Internal$Events$custom = $elm$core$Basics$identity;
var $author$project$Internal$Events$Decoder = $elm$core$Basics$identity;
var $author$project$Internal$Coordinate$lengthX = function (system) {
	return A2($elm$core$Basics$max, 1, (system.d2.by.kc - system.d2.eb.lK) - system.d2.eb.mA);
};
var $author$project$Internal$Coordinate$reachX = function (system) {
	var diff = system.ab.ed - system.ab.ej;
	return (diff > 0) ? diff : 1;
};
var $author$project$LineChart$Coordinate$scaleSvgX = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$lengthX(system)) / $author$project$Internal$Coordinate$reachX(system);
	});
var $author$project$LineChart$Coordinate$toSvgX = F2(
	function (system, value) {
		return A2($author$project$LineChart$Coordinate$scaleSvgX, system, value - system.ab.ej) + system.d2.eb.lK;
	});
var $author$project$Internal$Events$distanceX = F3(
	function (system, searched, dot) {
		return $elm$core$Basics$abs(
			A2($author$project$LineChart$Coordinate$toSvgX, system, dot.ab) - A2($author$project$LineChart$Coordinate$toSvgX, system, searched.ab));
	});
var $author$project$Internal$Events$getNearestXHelp = F3(
	function (points, system, searched) {
		var distanceX_ = A2($author$project$Internal$Events$distanceX, system, searched);
		var getClosest = F2(
			function (point, allClosest) {
				var _v0 = $elm$core$List$head(allClosest);
				if (!_v0.$) {
					var closest = _v0.a;
					return _Utils_eq(closest.mj.ab, point.mj.ab) ? A2($elm$core$List$cons, point, allClosest) : ((_Utils_cmp(
						distanceX_(closest.mj),
						distanceX_(point.mj)) > 0) ? _List_fromArray(
						[point]) : allClosest);
				} else {
					return _List_fromArray(
						[point]);
				}
			});
		return A3($elm$core$List$foldl, getClosest, _List_Nil, points);
	});
var $author$project$LineChart$Coordinate$scaleDataX = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$reachX(system)) / $author$project$Internal$Coordinate$lengthX(system);
	});
var $author$project$LineChart$Coordinate$toDataX = F2(
	function (system, value) {
		return system.ab.ej + A2($author$project$LineChart$Coordinate$scaleDataX, system, value - system.d2.eb.lK);
	});
var $author$project$Internal$Coordinate$lengthY = function (system) {
	return A2($elm$core$Basics$max, 1, (system.d2.by.im - system.d2.eb.kC) - system.d2.eb.nl);
};
var $author$project$Internal$Coordinate$reachY = function (system) {
	var diff = system.ad.ed - system.ad.ej;
	return (diff > 0) ? diff : 1;
};
var $author$project$LineChart$Coordinate$scaleDataY = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$reachY(system)) / $author$project$Internal$Coordinate$lengthY(system);
	});
var $author$project$LineChart$Coordinate$toDataY = F2(
	function (system, value) {
		return system.ad.ed - A2($author$project$LineChart$Coordinate$scaleDataY, system, value - system.d2.eb.nl);
	});
var $author$project$LineChart$Coordinate$toData = F2(
	function (system, point) {
		return {
			ab: A2($author$project$LineChart$Coordinate$toDataX, system, point.ab),
			ad: A2($author$project$LineChart$Coordinate$toDataY, system, point.ad)
		};
	});
var $author$project$Internal$Events$getNearestX = F3(
	function (points, system, searchedSvg) {
		var searched = A2($author$project$LineChart$Coordinate$toData, system, searchedSvg);
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.nF;
			},
			A3($author$project$Internal$Events$getNearestXHelp, points, system, searched));
	});
var $author$project$Internal$Events$Event = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $author$project$Internal$Events$onMouseLeave = function (msg) {
	return A2(
		$author$project$Internal$Events$Event,
		false,
		F2(
			function (_v0, _v1) {
				return A2(
					$elm$svg$Svg$Events$on,
					'mouseleave',
					$elm$json$Json$Decode$succeed(msg));
			}));
};
var $author$project$Internal$Events$Options = F3(
	function (stopPropagation, preventDefault, catchOutsideChart) {
		return {hx: catchOutsideChart, gn: preventDefault, gM: stopPropagation};
	});
var $elm$svg$Svg$Events$custom = $elm$html$Html$Events$custom;
var $author$project$Internal$Events$map = F2(
	function (f, _v0) {
		var a = _v0;
		return F3(
			function (ps, s, p) {
				return f(
					A3(a, ps, s, p));
			});
	});
var $author$project$LineChart$Coordinate$Point = F2(
	function (x, y) {
		return {ab: x, ad: y};
	});
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$debois$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($debois$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$debois$elm_dom$DOM$scrollLeft,
				$debois$elm_dom$DOM$scrollTop,
				$debois$elm_dom$DOM$offsetLeft,
				$debois$elm_dom$DOM$offsetTop));
	});
var $debois$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {im: height, lK: x, nl: y, kc: width};
		}),
	A2($debois$elm_dom$DOM$position, 0, 0),
	$debois$elm_dom$DOM$offsetWidth,
	$debois$elm_dom$DOM$offsetHeight);
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
function $author$project$Internal$Events$cyclic$position() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$debois$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $debois$elm_dom$DOM$parentElement(
						$author$project$Internal$Events$cyclic$position());
				})
			]));
}
var $author$project$Internal$Events$position = $author$project$Internal$Events$cyclic$position();
$author$project$Internal$Events$cyclic$position = function () {
	return $author$project$Internal$Events$position;
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Internal$Events$toJsonDecoder = F4(
	function (options, data, system, _v0) {
		var decoder = _v0;
		var withOptions = function (msg) {
			return {lT: msg, gn: options.gn, gM: options.gM};
		};
		var handle = F3(
			function (mouseX, mouseY, _v1) {
				var left = _v1.lK;
				var top = _v1.nl;
				var height = _v1.im;
				var width = _v1.kc;
				var y = mouseY - top;
				var x = mouseX - left;
				var widthPercent = width / system.d2.by.kc;
				var newSize = {im: height, kc: width};
				var heightPercent = height / system.d2.by.im;
				var newMargin = {kC: system.d2.eb.kC * heightPercent, lK: system.d2.eb.lK * widthPercent, mA: system.d2.eb.mA * widthPercent, nl: system.d2.eb.nl * heightPercent};
				var newSystem = _Utils_update(
					system,
					{
						d2: {eb: newMargin, by: newSize}
					});
				return A3(
					decoder,
					data,
					newSystem,
					A2($author$project$LineChart$Coordinate$Point, x, y));
			});
		return A2(
			$elm$json$Json$Decode$map,
			withOptions,
			A4(
				$elm$json$Json$Decode$map3,
				handle,
				A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
				$debois$elm_dom$DOM$target($author$project$Internal$Events$position)));
	});
var $author$project$Internal$Events$on = F3(
	function (event, toMsg, decoder) {
		return A2(
			$author$project$Internal$Events$Event,
			false,
			F2(
				function (data, system) {
					var defaultOptions = A3($author$project$Internal$Events$Options, false, false, false);
					return A2(
						$elm$svg$Svg$Events$custom,
						event,
						A4(
							$author$project$Internal$Events$toJsonDecoder,
							defaultOptions,
							data,
							system,
							A2($author$project$Internal$Events$map, toMsg, decoder)));
				}));
	});
var $author$project$Internal$Events$onMouseMove = $author$project$Internal$Events$on('mousemove');
var $author$project$Internal$Events$hoverMany = function (msg) {
	return $author$project$Internal$Events$custom(
		_List_fromArray(
			[
				A2($author$project$Internal$Events$onMouseMove, msg, $author$project$Internal$Events$getNearestX),
				$author$project$Internal$Events$onMouseLeave(
				msg(_List_Nil))
			]));
};
var $author$project$LineChart$Events$hoverMany = $author$project$Internal$Events$hoverMany;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$LineChart$Colors$label = A3($avh4$elm_color$Color$rgb255, 144, 164, 174);
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $author$project$Internal$Svg$label = F2(
	function (color, string) {
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(color),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$tspan,
					_List_Nil,
					_List_fromArray(
						[
							$elm$svg$Svg$text(string)
						]))
				]));
	});
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$LineChart$Junk$label = function (color) {
	return $author$project$Internal$Svg$label(
		$avh4$elm_color$Color$toCssString(color));
};
var $author$project$Internal$Svg$Transfrom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$LineChart$Coordinate$scaleSvgY = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$lengthY(system)) / $author$project$Internal$Coordinate$reachY(system);
	});
var $author$project$LineChart$Coordinate$toSvgY = F2(
	function (system, value) {
		return A2($author$project$LineChart$Coordinate$scaleSvgY, system, system.ad.ed - value) + system.d2.eb.nl;
	});
var $author$project$Internal$Svg$move = F3(
	function (system, x, y) {
		return A2(
			$author$project$Internal$Svg$Transfrom,
			A2($author$project$LineChart$Coordinate$toSvgX, system, x),
			A2($author$project$LineChart$Coordinate$toSvgY, system, y));
	});
var $author$project$LineChart$Junk$move = $author$project$Internal$Svg$move;
var $author$project$Internal$Svg$offset = F2(
	function (x, y) {
		return A2($author$project$Internal$Svg$Transfrom, x, y);
	});
var $author$project$LineChart$Junk$offset = $author$project$Internal$Svg$offset;
var $author$project$Internal$Svg$addPosition = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var y = _v0.b;
		var xf = _v1.a;
		var yf = _v1.b;
		return A2($author$project$Internal$Svg$Transfrom, xf + x, yf + y);
	});
var $author$project$Internal$Svg$toPosition = A2(
	$elm$core$List$foldr,
	$author$project$Internal$Svg$addPosition,
	A2($author$project$Internal$Svg$Transfrom, 0, 0));
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$Internal$Svg$transform = function (translations) {
	var _v0 = $author$project$Internal$Svg$toPosition(translations);
	var x = _v0.a;
	var y = _v0.b;
	return $elm$svg$Svg$Attributes$transform(
		'translate(' + ($elm$core$String$fromFloat(x) + (', ' + ($elm$core$String$fromFloat(y) + ')'))));
};
var $author$project$LineChart$Junk$transform = $author$project$Internal$Svg$transform;
var $author$project$LineChart$Junk$labelAt = F8(
	function (system, x, y, xo, yo, anchor, color, text) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$LineChart$Junk$transform(
					_List_fromArray(
						[
							A3($author$project$LineChart$Junk$move, system, x, y),
							A2($author$project$LineChart$Junk$offset, xo, yo)
						])),
					$elm$svg$Svg$Attributes$style('text-anchor: ' + (anchor + ';'))
				]),
			_List_fromArray(
				[
					A2($author$project$LineChart$Junk$label, color, text)
				]));
	});
var $author$project$Internal$Interpolation$Linear = 0;
var $author$project$LineChart$Interpolation$linear = 0;
var $author$project$Internal$Axis$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$custom = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Ticks$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Ticks$custom = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Title$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Title$custom = F4(
	function (position, x, y, title) {
		return {
			i8: _Utils_Tuple2(x, y),
			ep: position,
			j7: title
		};
	});
var $author$project$Internal$Axis$Title$atPosition = F3(
	function (position, x, y) {
		return A2(
			$elm$core$Basics$composeL,
			A3($author$project$Internal$Axis$Title$custom, position, x, y),
			$author$project$Internal$Svg$label('inherit'));
	});
var $author$project$Internal$Axis$Title$atAxisMax = function () {
	var position = F2(
		function (data, range) {
			return range.ed;
		});
	return $author$project$Internal$Axis$Title$atPosition(position);
}();
var $author$project$Internal$Axis$Title$default = A2($author$project$Internal$Axis$Title$atAxisMax, 0, 0);
var $author$project$Internal$Axis$Line$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Line$custom = $elm$core$Basics$identity;
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $author$project$LineChart$Colors$transparent = A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0);
var $author$project$Internal$Axis$Line$none = $author$project$Internal$Axis$Line$custom(
	F2(
		function (_v0, _v1) {
			var min = _v1.ej;
			var max = _v1.ed;
			return {eT: $author$project$LineChart$Colors$transparent, h3: max, le: _List_Nil, jJ: min, kc: 0};
		}));
var $author$project$Internal$Axis$Range$Padded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Axis$Range$padded = $author$project$Internal$Axis$Range$Padded;
var $author$project$Internal$Axis$none = F2(
	function (pixels_, variable_) {
		return $author$project$Internal$Axis$custom(
			{
				aJ: $author$project$Internal$Axis$Line$none,
				br: pixels_,
				bv: A2($author$project$Internal$Axis$Range$padded, 20, 20),
				z: $author$project$Internal$Axis$Ticks$custom(
					F2(
						function (_v0, _v1) {
							return _List_Nil;
						})),
				nb: $author$project$Internal$Axis$Title$default(''),
				bB: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, variable_)
			});
	});
var $author$project$LineChart$Axis$none = $author$project$Internal$Axis$none;
var $author$project$Internal$Legends$None = {$: 0};
var $author$project$Internal$Legends$none = $author$project$Internal$Legends$None;
var $author$project$LineChart$Legends$none = $author$project$Internal$Legends$none;
var $author$project$Internal$Path$Line = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Path$Move = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Utils$concat = F3(
	function (first, second, third) {
		return _Utils_ap(
			first,
			_Utils_ap(second, third));
	});
var $author$project$LineChart$Colors$gray = A3($avh4$elm_color$Color$rgb255, 163, 163, 163);
var $author$project$Internal$Path$join = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $author$project$Internal$Path$bool = function (bool_) {
	return bool_ ? '1' : '0';
};
var $author$project$Internal$Path$point = function (point_) {
	return $elm$core$String$fromFloat(point_.ab) + (' ' + $elm$core$String$fromFloat(point_.ad));
};
var $author$project$Internal$Path$points = function (points_) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $author$project$Internal$Path$point, points_));
};
var $author$project$Internal$Path$toString = function (command) {
	switch (command.$) {
		case 9:
			return 'Z';
		case 0:
			var p = command.a;
			return 'M' + $author$project$Internal$Path$point(p);
		case 1:
			var p = command.a;
			return 'L' + $author$project$Internal$Path$point(p);
		case 2:
			var x = command.a;
			return 'H' + $elm$core$String$fromFloat(x);
		case 3:
			var y = command.a;
			return 'V' + $elm$core$String$fromFloat(y);
		case 4:
			var c1 = command.a;
			var c2 = command.b;
			var p = command.c;
			return 'C' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, c2, p]));
		case 5:
			var c1 = command.a;
			var p = command.b;
			return 'Q' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, p]));
		case 6:
			var c1 = command.a;
			var p = command.b;
			return 'Q' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, p]));
		case 7:
			var p = command.a;
			return 'T' + $author$project$Internal$Path$point(p);
		default:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var p = command.f;
			return 'A' + $author$project$Internal$Path$join(
				_List_fromArray(
					[
						$elm$core$String$fromFloat(rx),
						$elm$core$String$fromFloat(ry),
						$elm$core$String$fromInt(xAxisRotation),
						$author$project$Internal$Path$bool(largeArcFlag),
						$author$project$Internal$Path$bool(sweepFlag),
						$author$project$Internal$Path$point(p)
					]));
	}
};
var $author$project$Internal$Path$Arc = F6(
	function (a, b, c, d, e, f) {
		return {$: 8, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Internal$Path$Close = {$: 9};
var $author$project$Internal$Path$CubicBeziers = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Internal$Path$CubicBeziersShort = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Internal$Path$Horizontal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Path$QuadraticBeziers = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Internal$Path$QuadraticBeziersShort = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Path$Vertical = function (a) {
	return {$: 3, a: a};
};
var $author$project$LineChart$Coordinate$toSvg = F2(
	function (system, point) {
		return {
			ab: A2($author$project$LineChart$Coordinate$toSvgX, system, point.ab),
			ad: A2($author$project$LineChart$Coordinate$toSvgY, system, point.ad)
		};
	});
var $author$project$Internal$Path$translate = F2(
	function (system, command) {
		switch (command.$) {
			case 0:
				var p = command.a;
				return $author$project$Internal$Path$Move(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 1:
				var p = command.a;
				return $author$project$Internal$Path$Line(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 2:
				var x = command.a;
				return $author$project$Internal$Path$Horizontal(
					A2($author$project$LineChart$Coordinate$toSvgX, system, x));
			case 3:
				var y = command.a;
				return $author$project$Internal$Path$Vertical(
					A2($author$project$LineChart$Coordinate$toSvgY, system, y));
			case 4:
				var c1 = command.a;
				var c2 = command.b;
				var p = command.c;
				return A3(
					$author$project$Internal$Path$CubicBeziers,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, c2),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 5:
				var c1 = command.a;
				var p = command.b;
				return A2(
					$author$project$Internal$Path$CubicBeziersShort,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 6:
				var c1 = command.a;
				var p = command.b;
				return A2(
					$author$project$Internal$Path$QuadraticBeziers,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 7:
				var p = command.a;
				return $author$project$Internal$Path$QuadraticBeziersShort(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 8:
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var p = command.f;
				return A6(
					$author$project$Internal$Path$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			default:
				return $author$project$Internal$Path$Close;
		}
	});
var $author$project$Internal$Path$description = F2(
	function (system, commands) {
		return $author$project$Internal$Path$join(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Internal$Path$translate(system),
					$author$project$Internal$Path$toString),
				commands));
	});
var $author$project$Internal$Path$viewPath = function (attributes) {
	return A2($elm$svg$Svg$path, attributes, _List_Nil);
};
var $author$project$Internal$Path$view = F3(
	function (system, attributes, commands) {
		return $author$project$Internal$Path$viewPath(
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d(
						A2($author$project$Internal$Path$description, system, commands))
					])));
	});
var $author$project$Internal$Svg$vertical = F5(
	function (system, userAttributes, x, y1, y2) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A3(
			$author$project$Internal$Path$view,
			system,
			attributes,
			_List_fromArray(
				[
					$author$project$Internal$Path$Move(
					{ab: x, ad: y1}),
					$author$project$Internal$Path$Line(
					{ab: x, ad: y1}),
					$author$project$Internal$Path$Line(
					{ab: x, ad: y2})
				]));
	});
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $author$project$Internal$Utils$toChartAreaId = function (id) {
	return 'chart__chart-area--' + id;
};
var $author$project$Internal$Svg$withinChartArea = function (_v0) {
	var id = _v0.ir;
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($author$project$Internal$Utils$toChartAreaId(id) + ')'));
};
var $author$project$LineChart$Junk$withinChartArea = $author$project$Internal$Svg$withinChartArea;
var $author$project$LineChart$Junk$verticalWithTopMargin = F4(
	function (system, attributes, x, topMarginPercent) {
		var yCalculatedMax = system.ad.ed - ((system.ad.ed - system.ad.ej) * topMarginPercent);
		return A5(
			$author$project$Internal$Svg$vertical,
			system,
			A2(
				$elm$core$List$cons,
				$author$project$LineChart$Junk$withinChartArea(system),
				attributes),
			x,
			system.ad.ej,
			yCalculatedMax);
	});
var $author$project$Internal$Line$Config = $elm$core$Basics$identity;
var $author$project$Internal$Line$Style = $elm$core$Basics$identity;
var $author$project$Internal$Line$style = F2(
	function (width, color_) {
		return {eT: color_, kc: width};
	});
var $author$project$Internal$Line$wider = function (width) {
	return function (_v0) {
		return A2($author$project$Internal$Line$style, width, $elm$core$Basics$identity);
	};
};
var $author$project$LineChart$Line$wider = $author$project$Internal$Line$wider;
var $author$project$LandingSite$CTokens$chartConfig = function (model) {
	return {
		hl: $author$project$LineChart$Area$default,
		kT: $author$project$LandingSite$CTokens$containerConfig,
		k5: $author$project$LandingSite$CTokens$customDotsConfig(model.b_),
		le: $author$project$LineChart$Events$hoverMany(
			A2($elm$core$Basics$composeL, $author$project$LandingSite$CTokens$ForSelf, $author$project$LandingSite$CTokens$GraphPointHover)),
		bj: A2($author$project$LineChart$Grid$dots, 1, $author$project$LineChart$Colors$transparent),
		ix: $author$project$LineChart$Interpolation$linear,
		bk: $author$project$LineChart$Axis$Intersection$default,
		lI: function () {
			var _v0 = model.b_;
			if (_v0.$ === 1) {
				return $author$project$LineChart$Junk$default;
			} else {
				var actualHoverPointXValue = _v0.a;
				return $author$project$LineChart$Junk$custom(
					function (system) {
						var yMax = system.g7.ed;
						var xTimeString = A2(
							$justinmimbs$date$Date$format,
							'MMMM d, y',
							A2(
								$justinmimbs$date$Date$fromPosix,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(
									$elm$core$Basics$round(actualHoverPointXValue) * 1000)));
						var xTimeStringPixelHalfLength = $elm$core$String$length(xTimeString) * 3.8;
						var xRangeLength = system.g6.ed - system.g6.ej;
						var xHoverOriginDeltaPercent = (actualHoverPointXValue - system.g6.ej) / xRangeLength;
						var xHoverMaxDeltaPercent = (system.g6.ed - actualHoverPointXValue) / xRangeLength;
						var xOffset = (xHoverOriginDeltaPercent < 0.2) ? (((0.2 - xHoverOriginDeltaPercent) / 0.2) * xTimeStringPixelHalfLength) : ((xHoverMaxDeltaPercent < 0.2) ? ((-((0.2 - xHoverMaxDeltaPercent) / 0.2)) * xTimeStringPixelHalfLength) : 0);
						return {
							eG: _List_fromArray(
								[
									A8($author$project$LineChart$Junk$labelAt, system, actualHoverPointXValue, yMax, xOffset, -20, 'middle', $author$project$LineChart$Colors$label, xTimeString),
									A4($author$project$LineChart$Junk$verticalWithTopMargin, system, _List_Nil, actualHoverPointXValue, 0.015)
								]),
							cE: _List_Nil,
							lv: _List_Nil
						};
					});
			}
		}(),
		iG: $author$project$LineChart$Legends$none,
		c3: $author$project$LineChart$Line$wider(3),
		ab: A2(
			$author$project$LineChart$Axis$none,
			1093,
			function ($) {
				return $.kv;
			}),
		ad: A2(
			$author$project$LineChart$Axis$none,
			152,
			function ($) {
				return $.jt;
			})
	};
};
var $author$project$Internal$Dots$Circle = 1;
var $author$project$LineChart$Dots$circle = 1;
var $author$project$Internal$Line$Series = $elm$core$Basics$identity;
var $author$project$Internal$Line$SeriesConfig = F5(
	function (color, shape, dashing, label, data) {
		return {eT: color, hS: dashing, kZ: data, iD: label, jG: shape};
	});
var $author$project$Internal$Line$line = F4(
	function (color_, shape_, label_, data_) {
		return A5($author$project$Internal$Line$SeriesConfig, color_, shape_, _List_Nil, label_, data_);
	});
var $author$project$LineChart$line = $author$project$Internal$Line$line;
var $author$project$LineChart$Colors$supply = A3($avh4$elm_color$Color$rgb255, 0, 211, 149);
var $author$project$Internal$Junk$addBelow = F2(
	function (below, layers) {
		return _Utils_update(
			layers,
			{
				cE: _Utils_ap(below, layers.cE)
			});
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$LineChart$chartAreaAttributes = function (system) {
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$x(
			$elm$core$String$fromFloat(system.d2.eb.lK)),
			$elm$svg$Svg$Attributes$y(
			$elm$core$String$fromFloat(system.d2.eb.nl)),
			$elm$svg$Svg$Attributes$width(
			$elm$core$String$fromFloat(
				$author$project$Internal$Coordinate$lengthX(system))),
			$elm$svg$Svg$Attributes$height(
			$elm$core$String$fromFloat(
				$author$project$Internal$Coordinate$lengthY(system)))
		]);
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $author$project$Internal$Events$toChartAttributes = F3(
	function (data, system, _v0) {
		var events = _v0;
		var order = function (_v1) {
			var outside = _v1.a;
			var event = _v1.b;
			return outside ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(event, data, system));
		};
		return A2($elm$core$List$filterMap, order, events);
	});
var $author$project$LineChart$chartAreaPlatform = F3(
	function (config, data, system) {
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
					$author$project$LineChart$chartAreaAttributes(system),
					A3($author$project$Internal$Events$toChartAttributes, data, system, config.le)
				]));
		return A2($elm$svg$Svg$rect, attributes, _List_Nil);
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $author$project$LineChart$clipPath = function (system) {
	return A2(
		$elm$svg$Svg$clipPath,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id(
				$author$project$Internal$Utils$toChartAreaId(system.ir))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				$author$project$LineChart$chartAreaAttributes(system),
				_List_Nil)
			]));
};
var $author$project$Internal$Line$color = F3(
	function (_v0, _v1, data_) {
		var config = _v0;
		var line_ = _v1;
		var _v2 = config(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.nF;
				},
				data_));
		var style_ = _v2;
		return style_.eT(line_.eT);
	});
var $author$project$Internal$Container$properties = F2(
	function (f, _v0) {
		var properties_ = _v0;
		return f(properties_);
	});
var $author$project$Internal$Container$sizeStyles = F3(
	function (_v0, width, height) {
		var properties_ = _v0;
		var _v1 = properties_.by;
		if (!_v1) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromFloat(height) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(width) + 'px')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$LineChart$container = F4(
	function (config, _v0, junkHtml, plot) {
		var frame = _v0.d2;
		var userAttributes = A2(
			$author$project$Internal$Container$properties,
			function ($) {
				return $.dE;
			},
			config.kT);
		var sizeStyles = A3($author$project$Internal$Container$sizeStyles, config.kT, frame.by.kc, frame.by.im);
		var styles = A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$style, 'position', 'relative'),
			sizeStyles);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(styles, userAttributes),
			A2($elm$core$List$cons, plot, junkHtml));
	});
var $author$project$Internal$Line$data = function (_v0) {
	var config = _v0;
	return config.kZ;
};
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $author$project$Internal$Junk$getLayers = F5(
	function (series, toX, toY, system, _v0) {
		var toLayers = _v0;
		return A4(toLayers, series, toX, toY, system);
	});
var $author$project$Internal$Line$label = function (_v0) {
	var config = _v0;
	return config.iD;
};
var $author$project$Internal$Events$toContainerAttributes = F3(
	function (data, system, _v0) {
		var events = _v0;
		var order = function (_v1) {
			var outside = _v1.a;
			var event = _v1.b;
			return outside ? $elm$core$Maybe$Just(
				A2(event, data, system)) : $elm$core$Maybe$Nothing;
		};
		return A2($elm$core$List$filterMap, order, events);
	});
var $author$project$Internal$Data$Data = F3(
	function (user, point, isReal) {
		return {lH: isReal, mj: point, nF: user};
	});
var $author$project$LineChart$setY = F2(
	function (datum, y) {
		return A3(
			$author$project$Internal$Data$Data,
			datum.nF,
			A2($author$project$Internal$Data$Point, datum.mj.ab, y),
			datum.lH);
	});
var $author$project$LineChart$normalize = function (datasets) {
	if (datasets.b) {
		var highest = datasets.a;
		var belows = datasets.b;
		var toPercentage = F2(
			function (highest_, datum) {
				return A2($author$project$LineChart$setY, datum, (100 * datum.mj.ad) / highest_.mj.ad);
			});
		return A2(
			$elm$core$List$map,
			A2($elm$core$List$map2, toPercentage, highest),
			A2($elm$core$List$cons, highest, belows));
	} else {
		return datasets;
	}
};
var $author$project$Internal$Utils$withFirst = F2(
	function (stuff, process) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return $elm$core$Maybe$Just(
				A2(process, first, rest));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$LineChart$addBelows = F2(
	function (alldata, dataBelowAll) {
		var add = F2(
			function (below, datum) {
				return A2($author$project$LineChart$setY, below, below.mj.ad + datum.mj.ad);
			});
		var iterate = F4(
			function (datum0, dataTop, dataBelowTop, result) {
				iterate:
				while (true) {
					var _v0 = _Utils_Tuple2(dataTop, dataBelowTop);
					if (_v0.a.b) {
						if (_v0.b.b) {
							var _v1 = _v0.a;
							var datum1 = _v1.a;
							var data = _v1.b;
							var _v2 = _v0.b;
							var datumBelow = _v2.a;
							var dataBelow = _v2.b;
							if (_Utils_cmp(datum1.mj.ab, datumBelow.mj.ab) > 0) {
								if (datumBelow.lH) {
									var $temp$datum0 = datum0,
										$temp$dataTop = A2($elm$core$List$cons, datum1, data),
										$temp$dataBelowTop = dataBelow,
										$temp$result = A2(
										$elm$core$List$cons,
										A2(add, datumBelow, datum0),
										result);
									datum0 = $temp$datum0;
									dataTop = $temp$dataTop;
									dataBelowTop = $temp$dataBelowTop;
									result = $temp$result;
									continue iterate;
								} else {
									var breakdata = _Utils_update(
										datum0,
										{lH: false});
									var $temp$datum0 = datum0,
										$temp$dataTop = A2($elm$core$List$cons, datum1, data),
										$temp$dataBelowTop = dataBelow,
										$temp$result = A2(
										$elm$core$List$cons,
										A2(add, datumBelow, datum0),
										result);
									datum0 = $temp$datum0;
									dataTop = $temp$dataTop;
									dataBelowTop = $temp$dataBelowTop;
									result = $temp$result;
									continue iterate;
								}
							} else {
								var $temp$datum0 = datum1,
									$temp$dataTop = data,
									$temp$dataBelowTop = A2($elm$core$List$cons, datumBelow, dataBelow),
									$temp$result = result;
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							}
						} else {
							var _v4 = _v0.a;
							var datum1 = _v4.a;
							var data = _v4.b;
							return result;
						}
					} else {
						if (_v0.b.b) {
							var _v3 = _v0.b;
							var datumBelow = _v3.a;
							var dataBelow = _v3.b;
							if (_Utils_cmp(datum0.mj.ab, datumBelow.mj.ab) < 1) {
								var $temp$datum0 = datum0,
									$temp$dataTop = _List_Nil,
									$temp$dataBelowTop = dataBelow,
									$temp$result = A2(
									$elm$core$List$cons,
									A2(add, datumBelow, datum0),
									result);
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							} else {
								var $temp$datum0 = datum0,
									$temp$dataTop = _List_Nil,
									$temp$dataBelowTop = dataBelow,
									$temp$result = A2($elm$core$List$cons, datumBelow, result);
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							}
						} else {
							return result;
						}
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$author$project$Internal$Utils$withFirst,
					alldata,
					F2(
						function (first, rest) {
							return A4(iterate, first, rest, dataBelowAll, _List_Nil);
						}))));
	});
var $author$project$LineChart$stack = function (dataset) {
	var stackBelows = F2(
		function (dataset_, result) {
			if (dataset_.b) {
				var data = dataset_.a;
				var belows = dataset_.b;
				return A2(
					stackBelows,
					belows,
					A2(
						$elm$core$List$cons,
						A3($elm$core$List$foldl, $author$project$LineChart$addBelows, data, belows),
						result));
			} else {
				return result;
			}
		});
	return $elm$core$List$reverse(
		A2(stackBelows, dataset, _List_Nil));
};
var $author$project$Internal$Axis$variable = function (_v0) {
	var config = _v0;
	return config.bB;
};
var $author$project$LineChart$toDataPoints = F2(
	function (config, lines) {
		var y = $author$project$Internal$Axis$variable(config.ad);
		var x = $author$project$Internal$Axis$variable(config.ab);
		var addPoint = function (datum) {
			var _v1 = _Utils_Tuple2(
				x(datum),
				y(datum));
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var x_ = _v1.a.a;
					var y_ = _v1.b.a;
					return $elm$core$Maybe$Just(
						A3(
							$author$project$Internal$Data$Data,
							datum,
							A2($author$project$Internal$Data$Point, x_, y_),
							true));
				} else {
					var x_ = _v1.a.a;
					var _v2 = _v1.b;
					return $elm$core$Maybe$Just(
						A3(
							$author$project$Internal$Data$Data,
							datum,
							A2($author$project$Internal$Data$Point, x_, 0),
							false));
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var y_ = _v1.b.a;
					return $elm$core$Maybe$Nothing;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var data = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Internal$Line$data,
				$elm$core$List$filterMap(addPoint)),
			lines);
		var _v0 = config.hl;
		switch (_v0.$) {
			case 0:
				return data;
			case 1:
				return data;
			case 2:
				return $author$project$LineChart$stack(data);
			default:
				return $author$project$LineChart$normalize(
					$author$project$LineChart$stack(data));
		}
	});
var $author$project$Internal$Coordinate$Frame = F2(
	function (margin, size) {
		return {eb: margin, by: size};
	});
var $author$project$Internal$Coordinate$Size = F2(
	function (width, height) {
		return {im: height, kc: width};
	});
var $author$project$LineChart$Coordinate$Range = F2(
	function (min, max) {
		return {ed: max, ej: min};
	});
var $author$project$Internal$Axis$Range$applyX = F2(
	function (range, system) {
		switch (range.$) {
			case 0:
				var padMin = range.a;
				var padMax = range.b;
				var _v1 = system;
				var frame = _v1.d2;
				var _v2 = frame;
				var size = _v2.by;
				var system_ = _Utils_update(
					system,
					{
						d2: _Utils_update(
							frame,
							{
								by: _Utils_update(
									size,
									{
										kc: A2($elm$core$Basics$max, 1, (size.kc - padMin) - padMax)
									})
							})
					});
				var scale = $author$project$LineChart$Coordinate$scaleDataX(system_);
				return A2(
					$author$project$LineChart$Coordinate$Range,
					system.ab.ej - scale(padMin),
					system.ab.ed + scale(padMax));
			case 1:
				var min = range.a;
				var max = range.b;
				return A2($author$project$LineChart$Coordinate$Range, min, max);
			default:
				var toRange = range.a;
				return toRange(system.ab);
		}
	});
var $author$project$Internal$Axis$Range$applyY = F2(
	function (range, system) {
		switch (range.$) {
			case 0:
				var padMin = range.a;
				var padMax = range.b;
				var _v1 = system;
				var frame = _v1.d2;
				var _v2 = frame;
				var size = _v2.by;
				var system_ = _Utils_update(
					system,
					{
						d2: _Utils_update(
							frame,
							{
								by: _Utils_update(
									size,
									{
										im: A2($elm$core$Basics$max, 1, (size.im - padMin) - padMax)
									})
							})
					});
				var scale = $author$project$LineChart$Coordinate$scaleDataY(system_);
				return A2(
					$author$project$LineChart$Coordinate$Range,
					system.ad.ej - scale(padMin),
					system.ad.ed + scale(padMax));
			case 1:
				var min = range.a;
				var max = range.b;
				return A2($author$project$LineChart$Coordinate$Range, min, max);
			default:
				var toRange = range.a;
				return toRange(system.ad);
		}
	});
var $author$project$Internal$Coordinate$ground = function (range_) {
	return _Utils_update(
		range_,
		{
			ej: A2($elm$core$Basics$min, range_.ej, 0)
		});
};
var $author$project$Internal$Area$hasArea = function (config) {
	switch (config.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Internal$Axis$pixels = function (_v0) {
	var config = _v0;
	return config.br;
};
var $author$project$Internal$Axis$range = function (_v0) {
	var config = _v0;
	return config.bv;
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Coordinate$maximum = function (toValue) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(toValue),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$maximum,
			$elm$core$Maybe$withDefault(1)));
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Coordinate$minimum = function (toValue) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(toValue),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$minimum,
			$elm$core$Maybe$withDefault(0)));
};
var $author$project$Internal$Coordinate$range = F2(
	function (toValue, data) {
		var range_ = {
			ed: A2($author$project$Internal$Coordinate$maximum, toValue, data),
			ej: A2($author$project$Internal$Coordinate$minimum, toValue, data)
		};
		return _Utils_eq(range_.ej, range_.ed) ? _Utils_update(
			range_,
			{ed: range_.ed + 1}) : range_;
	});
var $author$project$LineChart$toSystem = F2(
	function (config, data) {
		var yRange = A2(
			$author$project$Internal$Coordinate$range,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mj;
				},
				function ($) {
					return $.ad;
				}),
			data);
		var xRange = A2(
			$author$project$Internal$Coordinate$range,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mj;
				},
				function ($) {
					return $.ab;
				}),
			data);
		var size = A2(
			$author$project$Internal$Coordinate$Size,
			$author$project$Internal$Axis$pixels(config.ab),
			$author$project$Internal$Axis$pixels(config.ad));
		var hasArea = $author$project$Internal$Area$hasArea(config.hl);
		var container_ = A2($author$project$Internal$Container$properties, $elm$core$Basics$identity, config.kT);
		var frame = A2($author$project$Internal$Coordinate$Frame, container_.eb, size);
		var adjustDomainRange = function (domain) {
			return hasArea ? $author$project$Internal$Coordinate$ground(domain) : domain;
		};
		var system = {
			d2: frame,
			ir: container_.ir,
			ab: xRange,
			g6: xRange,
			ad: adjustDomainRange(yRange),
			g7: yRange
		};
		return _Utils_update(
			system,
			{
				ab: A2(
					$author$project$Internal$Axis$Range$applyX,
					$author$project$Internal$Axis$range(config.ab),
					system),
				ad: A2(
					$author$project$Internal$Axis$Range$applyY,
					$author$project$Internal$Axis$range(config.ad),
					system)
			});
	});
var $author$project$Internal$Axis$ticks = function (_v0) {
	var config = _v0;
	return config.z;
};
var $author$project$Internal$Axis$Tick$properties = function (_v0) {
	var properties_ = _v0;
	return properties_;
};
var $author$project$Internal$Axis$Ticks$ticks = F3(
	function (dataRange, range, _v0) {
		var values = _v0;
		return A2(
			$elm$core$List$map,
			$author$project$Internal$Axis$Tick$properties,
			A2(values, dataRange, range));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Internal$Svg$gridDot = F3(
	function (radius, color, point) {
		return A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx(
					$elm$core$String$fromFloat(point.ab)),
					$elm$svg$Svg$Attributes$cy(
					$elm$core$String$fromFloat(point.ad)),
					$elm$svg$Svg$Attributes$r(
					$elm$core$String$fromFloat(radius)),
					$elm$svg$Svg$Attributes$fill(
					$avh4$elm_color$Color$toCssString(color))
				]),
			_List_Nil);
	});
var $author$project$Internal$Grid$viewDots = F5(
	function (system, verticals, horizontals, radius, color) {
		var dot = F2(
			function (x, y) {
				return A2(
					$author$project$LineChart$Coordinate$toSvg,
					system,
					A2($author$project$LineChart$Coordinate$Point, x, y));
			});
		var dots_ = function (g) {
			return A2(
				$elm$core$List$map,
				dot(g),
				horizontals);
		};
		var alldots = A2($elm$core$List$concatMap, dots_, verticals);
		return A2(
			$elm$core$List$map,
			A2($author$project$Internal$Svg$gridDot, radius, color),
			alldots);
	});
var $author$project$Internal$Svg$horizontal = F5(
	function (system, userAttributes, y, x1, x2) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A3(
			$author$project$Internal$Path$view,
			system,
			attributes,
			_List_fromArray(
				[
					$author$project$Internal$Path$Move(
					{ab: x1, ad: y}),
					$author$project$Internal$Path$Line(
					{ab: x1, ad: y}),
					$author$project$Internal$Path$Line(
					{ab: x2, ad: y})
				]));
	});
var $author$project$Internal$Svg$horizontalGrid = F3(
	function (system, userAttributes, y) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A5($author$project$Internal$Svg$horizontal, system, attributes, y, system.ab.ej, system.ab.ed);
	});
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Internal$Svg$verticalGrid = F3(
	function (system, userAttributes, x) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A5($author$project$Internal$Svg$vertical, system, attributes, x, system.ad.ej, system.ad.ed);
	});
var $author$project$Internal$Grid$viewLines = F5(
	function (system, verticals, horizontals, width, color) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(width)),
				$elm$svg$Svg$Attributes$stroke(
				$avh4$elm_color$Color$toCssString(color))
			]);
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				A2($author$project$Internal$Svg$horizontalGrid, system, attributes),
				horizontals),
			A2(
				$elm$core$List$map,
				A2($author$project$Internal$Svg$verticalGrid, system, attributes),
				verticals));
	});
var $author$project$Internal$Grid$view = F4(
	function (system, xAxis, yAxis, grid) {
		var hasGrid = function (tick) {
			return tick.bj ? $elm$core$Maybe$Just(tick.ep) : $elm$core$Maybe$Nothing;
		};
		var horizontals = A2(
			$elm$core$List$filterMap,
			hasGrid,
			A3(
				$author$project$Internal$Axis$Ticks$ticks,
				system.g7,
				system.ad,
				$author$project$Internal$Axis$ticks(yAxis)));
		var verticals = A2(
			$elm$core$List$filterMap,
			hasGrid,
			A3(
				$author$project$Internal$Axis$Ticks$ticks,
				system.g6,
				system.ab,
				$author$project$Internal$Axis$ticks(xAxis)));
		if (!grid.$) {
			var radius = grid.a;
			var color = grid.b;
			return A5($author$project$Internal$Grid$viewDots, system, verticals, horizontals, radius, color);
		} else {
			var width = grid.a;
			var color = grid.b;
			return A5($author$project$Internal$Grid$viewLines, system, verticals, horizontals, width, color);
		}
	});
var $author$project$Internal$Svg$End = 2;
var $author$project$Internal$Svg$Start = 0;
var $author$project$Internal$Svg$anchorStyle = function (anchor) {
	var anchorString = function () {
		switch (anchor) {
			case 0:
				return 'start';
			case 1:
				return 'middle';
			default:
				return 'end';
		}
	}();
	return $elm$svg$Svg$Attributes$style('text-anchor: ' + (anchorString + ';'));
};
var $author$project$Internal$Utils$viewMaybe = F2(
	function (a, view) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$svg$Svg$text(''),
			A2($elm$core$Maybe$map, view, a));
	});
var $author$project$Internal$Legends$viewFree = F5(
	function (system, placement, viewLabel, line, data) {
		var _v0 = function () {
			if (!placement) {
				return _Utils_Tuple3(data, 2, -10);
			} else {
				return _Utils_Tuple3(
					$elm$core$List$reverse(data),
					0,
					10);
			}
		}();
		var orderedPoints = _v0.a;
		var anchor = _v0.b;
		var xOffset = _v0.c;
		var transform = function (_v3) {
			var x = _v3.ab;
			var y = _v3.ad;
			return $author$project$Internal$Svg$transform(
				_List_fromArray(
					[
						A3($author$project$Internal$Svg$move, system, x, y),
						A2($author$project$Internal$Svg$offset, xOffset, 3)
					]));
		};
		var viewLegend = function (_v2) {
			var point = _v2.mj;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						transform(point),
						$author$project$Internal$Svg$anchorStyle(anchor)
					]),
				_List_fromArray(
					[
						viewLabel(
						$author$project$Internal$Line$label(line))
					]));
		};
		return A2(
			$author$project$Internal$Utils$viewMaybe,
			$elm$core$List$head(orderedPoints),
			viewLegend);
	});
var $author$project$Internal$Legends$viewFrees = F3(
	function (_v0, placement, view_) {
		var system = _v0.jT;
		var lines = _v0.fS;
		var data = _v0.kZ;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__legends')
				]),
			A3(
				$elm$core$List$map2,
				A3($author$project$Internal$Legends$viewFree, system, placement, view_),
				lines,
				data));
	});
var $author$project$Internal$Line$shape = function (_v0) {
	var config = _v0;
	return config.jG;
};
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $author$project$Internal$Dots$varietyAttributes = F2(
	function (color, variety) {
		switch (variety.$) {
			case 0:
				var width = variety.a;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke(
						$avh4$elm_color$Color$toCssString(color)),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$fill('white')
					]);
			case 2:
				var width = variety.a;
				var opacity = variety.b;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke(
						$avh4$elm_color$Color$toCssString(color)),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$strokeOpacity(
						$elm$core$String$fromFloat(opacity)),
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
			case 1:
				var width = variety.a;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('white'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
			default:
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
		}
	});
var $author$project$Internal$Dots$viewCircle = F5(
	function (events, variety, color, area, point) {
		var radius = $elm$core$Basics$sqrt(area / $elm$core$Basics$pi);
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$cx(
				$elm$core$String$fromFloat(point.ab)),
				$elm$svg$Svg$Attributes$cy(
				$elm$core$String$fromFloat(point.ad)),
				$elm$svg$Svg$Attributes$r(
				$elm$core$String$fromFloat(radius))
			]);
		return A2(
			$elm$svg$Svg$circle,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$pathPlus = F2(
	function (area, point) {
		var side = $elm$core$Basics$sqrt(area / 5);
		var r6 = side / 2;
		var r3 = side;
		var commands = _List_fromArray(
			[
				'M' + ($elm$core$String$fromFloat(point.ab - r6) + (' ' + $elm$core$String$fromFloat((point.ad - r3) - r6))),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(r3)
			]);
		return A2($elm$core$String$join, ' ', commands);
	});
var $author$project$Internal$Dots$viewCross = F5(
	function (events, variety, color, area, point) {
		var rotation = 'rotate(45 ' + ($elm$core$String$fromFloat(point.ab) + (' ' + ($elm$core$String$fromFloat(point.ad) + ')')));
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathPlus, area, point)),
				$elm$svg$Svg$Attributes$transform(rotation)
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewDiamond = F5(
	function (events, variety, color, area, point) {
		var side = $elm$core$Basics$sqrt(area);
		var rotation = 'rotate(45 ' + ($elm$core$String$fromFloat(point.ab) + (' ' + ($elm$core$String$fromFloat(point.ad) + ')')));
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(point.ab - (side / 2))),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(point.ad - (side / 2))),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$transform(rotation)
			]);
		return A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewPlus = F5(
	function (events, variety, color, area, point) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathPlus, area, point))
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewSquare = F5(
	function (events, variety, color, area, point) {
		var side = $elm$core$Basics$sqrt(area);
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(point.ab - (side / 2))),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(point.ad - (side / 2))),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(side))
			]);
		return A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$tan = _Basics_tan;
var $author$project$Internal$Dots$pathTriangle = F2(
	function (area, point) {
		var side = $elm$core$Basics$sqrt(
			(area * 4) / $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		var commands = _List_fromArray(
			[
				'M' + ($elm$core$String$fromFloat(point.ab) + (' ' + $elm$core$String$fromFloat(point.ad - fromMiddle))),
				'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
				'h' + $elm$core$String$fromFloat(side),
				'z'
			]);
		return A2($elm$core$String$join, ' ', commands);
	});
var $author$project$Internal$Dots$viewTriangle = F5(
	function (events, variety, color, area, point) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathTriangle, area, point))
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewShape = F5(
	function (system, _v0, shape, color, point) {
		var radius = _v0.gr;
		var variety = _v0.g2;
		var view_ = function () {
			switch (shape) {
				case 1:
					return $author$project$Internal$Dots$viewCircle;
				case 2:
					return $author$project$Internal$Dots$viewTriangle;
				case 3:
					return $author$project$Internal$Dots$viewSquare;
				case 4:
					return $author$project$Internal$Dots$viewDiamond;
				case 5:
					return $author$project$Internal$Dots$viewCross;
				case 6:
					return $author$project$Internal$Dots$viewPlus;
				default:
					return F5(
						function (_v2, _v3, _v4, _v5, _v6) {
							return $elm$svg$Svg$text('');
						});
			}
		}();
		var size = (2 * $elm$core$Basics$pi) * radius;
		var pointSvg = A2($author$project$LineChart$Coordinate$toSvg, system, point);
		return A5(view_, _List_Nil, variety, color, size, pointSvg);
	});
var $author$project$Internal$Dots$viewSample = F5(
	function (_v0, shape, color, system, data) {
		var config = _v0;
		var _v1 = config.fG(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.nF;
				},
				data));
		var style_ = _v1;
		return A4($author$project$Internal$Dots$viewShape, system, style_, shape, color);
	});
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $author$project$Internal$Area$opacity = function (config) {
	switch (config.$) {
		case 0:
			return 0;
		case 1:
			var opacity_ = config.a;
			return opacity_;
		case 2:
			var opacity_ = config.a;
			return opacity_;
		default:
			var opacity_ = config.a;
			return opacity_;
	}
};
var $author$project$Internal$Line$toAreaAttributes = F3(
	function (_v0, _v1, area) {
		var serie = _v0;
		var style_ = _v1;
		return _List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('chart__interpolation__area__fragment'),
				$elm$svg$Svg$Attributes$fill(
				$avh4$elm_color$Color$toCssString(
					style_.eT(serie.eT)))
			]);
	});
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $author$project$Internal$Line$toSeriesAttributes = F2(
	function (_v0, _v1) {
		var serie = _v0;
		var style_ = _v1;
		return _List_fromArray(
			[
				$elm$svg$Svg$Attributes$style('pointer-events: none;'),
				$elm$svg$Svg$Attributes$class('chart__interpolation__line__fragment'),
				$elm$svg$Svg$Attributes$stroke(
				$avh4$elm_color$Color$toCssString(
					style_.eT(serie.eT))),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(style_.kc)),
				$elm$svg$Svg$Attributes$strokeDasharray(
				A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, $elm$core$String$fromFloat, serie.hS))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
	});
var $author$project$Internal$Utils$viewIf = F2(
	function (condition, view) {
		return condition ? view(0) : $elm$svg$Svg$text('');
	});
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Internal$Line$viewSample = F5(
	function (_v0, line_, area, data_, sampleWidth) {
		var look = _v0;
		var style_ = look(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.nF;
				},
				data_));
		var sizeAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('0'),
				$elm$svg$Svg$Attributes$y1('0'),
				$elm$svg$Svg$Attributes$x2(
				$elm$core$String$fromFloat(sampleWidth)),
				$elm$svg$Svg$Attributes$y2('0')
			]);
		var rectangleAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0'),
				$elm$svg$Svg$Attributes$y('0'),
				$elm$svg$Svg$Attributes$height('9'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(sampleWidth))
			]);
		var lineAttributes = A2($author$project$Internal$Line$toSeriesAttributes, line_, style_);
		var areaAttributes = A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(
					$author$project$Internal$Area$opacity(area))),
			A3($author$project$Internal$Line$toAreaAttributes, line_, style_, area));
		var viewRectangle = function (_v1) {
			return A2(
				$elm$svg$Svg$rect,
				_Utils_ap(areaAttributes, rectangleAttributes),
				_List_Nil);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_Utils_ap(lineAttributes, sizeAttributes),
					_List_Nil),
					A2(
					$author$project$Internal$Utils$viewIf,
					$author$project$Internal$Area$hasArea(area),
					viewRectangle)
				]));
	});
var $author$project$Internal$Legends$viewSample = F4(
	function (_v0, sampleWidth, line, data) {
		var system = _v0.jT;
		var lineConfig = _v0.iL;
		var dotsConfig = _v0.h$;
		var area = _v0.hl;
		var shape = $author$project$Internal$Line$shape(line);
		var dotPosition = A2(
			$author$project$LineChart$Coordinate$toData,
			system,
			A2($author$project$Internal$Data$Point, sampleWidth / 2, 0));
		var color = A3($author$project$Internal$Line$color, lineConfig, line, data);
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__sample')
				]),
			_List_fromArray(
				[
					A5($author$project$Internal$Line$viewSample, lineConfig, line, area, data, sampleWidth),
					A6($author$project$Internal$Dots$viewSample, dotsConfig, shape, color, system, data, dotPosition)
				]));
	});
var $author$project$Internal$Legends$viewGrouped = F3(
	function (_arguments, sampleWidth, container) {
		var toLegend = F2(
			function (line, data) {
				return {
					iD: $author$project$Internal$Line$label(line),
					gy: A4($author$project$Internal$Legends$viewSample, _arguments, sampleWidth, line, data)
				};
			});
		var legends = A3($elm$core$List$map2, toLegend, _arguments.fS, _arguments.kZ);
		return A2(container, _arguments.jT, legends);
	});
var $author$project$Internal$Legends$view = function (_arguments) {
	var _v0 = _arguments.iG;
	switch (_v0.$) {
		case 1:
			var placement = _v0.a;
			var view_ = _v0.b;
			return A3($author$project$Internal$Legends$viewFrees, _arguments, placement, view_);
		case 2:
			var sampleWidth = _v0.a;
			var container = _v0.b;
			return A3(
				$author$project$Internal$Legends$viewGrouped,
				_arguments,
				sampleWidth,
				container(_arguments));
		default:
			return $elm$svg$Svg$text('');
	}
};
var $author$project$Internal$Area$opacityContainer = function (config) {
	switch (config.$) {
		case 0:
			return 1;
		case 1:
			var opacity_ = config.a;
			return 1;
		case 2:
			var opacity_ = config.a;
			return opacity_;
		default:
			var opacity_ = config.a;
			return opacity_;
	}
};
var $author$project$Internal$Utils$unzip3 = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var a = _v0.a;
			var b = _v0.b;
			var c = _v0.c;
			var aas = _v1.a;
			var bs = _v1.b;
			var cs = _v1.c;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, a, aas),
				A2($elm$core$List$cons, b, bs),
				A2($elm$core$List$cons, c, cs));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		pairs);
};
var $elm$core$List$map3 = _List_map3;
var $author$project$Internal$Line$viewNormal = function (_v0) {
	var areas = _v0.a;
	var lines = _v0.b;
	var dots = _v0.c;
	var view_ = F3(
		function (area_, line_, dots_) {
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__line')
					]),
				_List_fromArray(
					[area_, line_, dots_]));
		});
	return A4($elm$core$List$map3, view_, areas, lines, dots);
};
var $author$project$Internal$Data$isWithinRange = F2(
	function (system, point) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, system.ab.ej, system.ab.ed, point.ab),
			point.ab) && _Utils_eq(
			A3($elm$core$Basics$clamp, system.ad.ej, system.ad.ed, point.ad),
			point.ad);
	});
var $author$project$Internal$Utils$part = F4(
	function (isReal, points, current, parts) {
		part:
		while (true) {
			if (points.b) {
				var first = points.a;
				var rest = points.b;
				if (isReal(first)) {
					var $temp$isReal = isReal,
						$temp$points = rest,
						$temp$current = _Utils_ap(
						current,
						_List_fromArray(
							[first])),
						$temp$parts = parts;
					isReal = $temp$isReal;
					points = $temp$points;
					current = $temp$current;
					parts = $temp$parts;
					continue part;
				} else {
					var $temp$isReal = isReal,
						$temp$points = rest,
						$temp$current = _List_Nil,
						$temp$parts = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							current,
							$elm$core$Maybe$Just(first)),
						parts);
					isReal = $temp$isReal;
					points = $temp$points;
					current = $temp$current;
					parts = $temp$parts;
					continue part;
				}
			} else {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(current, $elm$core$Maybe$Nothing),
					parts);
			}
		}
	});
var $author$project$Internal$Interpolation$linear = $elm$core$List$map(
	$elm$core$List$map($author$project$Internal$Path$Line));
var $author$project$Internal$Interpolation$First = {$: 0};
var $author$project$Internal$Interpolation$Previous = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Interpolation$monotoneCurve = F4(
	function (point0, point1, tangent0, tangent1) {
		var dx = (point1.ab - point0.ab) / 3;
		return A3(
			$author$project$Internal$Path$CubicBeziers,
			{ab: point0.ab + dx, ad: point0.ad + (dx * tangent0)},
			{ab: point1.ab - dx, ad: point1.ad - (dx * tangent1)},
			point1);
	});
var $author$project$Internal$Interpolation$slope2 = F3(
	function (point0, point1, t) {
		var h = point1.ab - point0.ab;
		return (!(!h)) ? ((((3 * (point1.ad - point0.ad)) / h) - t) / 2) : t;
	});
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $author$project$Internal$Interpolation$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $author$project$Internal$Interpolation$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $author$project$Internal$Interpolation$slope3 = F3(
	function (point0, point1, point2) {
		var h1 = point2.ab - point1.ab;
		var h0 = point1.ab - point0.ab;
		var s0h = A2($author$project$Internal$Interpolation$toH, h0, h1);
		var s0 = (point1.ad - point0.ad) / s0h;
		var s1h = A2($author$project$Internal$Interpolation$toH, h1, h0);
		var s1 = (point2.ad - point1.ad) / s1h;
		var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
		var slope = ($author$project$Internal$Interpolation$sign(s0) + $author$project$Internal$Interpolation$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
		return $elm$core$Basics$isNaN(slope) ? 0 : slope;
	});
var $author$project$Internal$Interpolation$monotonePart = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var commands = _v0.b;
		var _v1 = _Utils_Tuple2(tangent, points);
		_v1$4:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var p0 = _v3.a;
						var _v4 = _v3.b;
						var p1 = _v4.a;
						var _v5 = _v4.b;
						var p2 = _v5.a;
						var rest = _v5.b;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p2);
						var t0 = A3($author$project$Internal$Interpolation$slope2, p0, p1, t1);
						return A2(
							$author$project$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$author$project$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var _v9 = _v1.a;
						var _v10 = _v1.b;
						var p0 = _v10.a;
						var _v11 = _v10.b;
						var p1 = _v11.a;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$author$project$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t1, t1),
										$author$project$Internal$Path$Line(p1)
									])));
					}
				} else {
					break _v1$4;
				}
			} else {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var t0 = _v1.a.a;
						var _v6 = _v1.b;
						var p0 = _v6.a;
						var _v7 = _v6.b;
						var p1 = _v7.a;
						var _v8 = _v7.b;
						var p2 = _v8.a;
						var rest = _v8.b;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p2);
						return A2(
							$author$project$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$author$project$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var t0 = _v1.a.a;
						var _v12 = _v1.b;
						var p0 = _v12.a;
						var _v13 = _v12.b;
						var p1 = _v13.a;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$author$project$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1),
										$author$project$Internal$Path$Line(p1)
									])));
					}
				} else {
					break _v1$4;
				}
			}
		}
		return _Utils_Tuple2(tangent, commands);
	});
var $author$project$Internal$Interpolation$monotoneSection = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var acc = _v0.b;
		var _v1 = function () {
			if (points.b) {
				var p0 = points.a;
				var rest = points.b;
				return A2(
					$author$project$Internal$Interpolation$monotonePart,
					A2($elm$core$List$cons, p0, rest),
					_Utils_Tuple2(
						tangent,
						_List_fromArray(
							[
								$author$project$Internal$Path$Line(p0)
							])));
			} else {
				return _Utils_Tuple2(tangent, _List_Nil);
			}
		}();
		var t0 = _v1.a;
		var commands = _v1.b;
		return _Utils_Tuple2(
			t0,
			A2($elm$core$List$cons, commands, acc));
	});
var $author$project$Internal$Interpolation$monotone = function (sections) {
	return A3(
		$elm$core$List$foldr,
		$author$project$Internal$Interpolation$monotoneSection,
		_Utils_Tuple2($author$project$Internal$Interpolation$First, _List_Nil),
		sections).b;
};
var $author$project$Internal$Interpolation$after = F2(
	function (a, b) {
		return _List_fromArray(
			[
				a,
				A2($author$project$Internal$Data$Point, b.ab, a.ad),
				b
			]);
	});
var $author$project$Internal$Interpolation$stepped = function (sections) {
	var expand = F2(
		function (result, section) {
			expand:
			while (true) {
				if (section.a.b) {
					if (section.a.b.b) {
						var _v1 = section.a;
						var a = _v1.a;
						var _v2 = _v1.b;
						var b = _v2.a;
						var rest = _v2.b;
						var broken = section.b;
						var $temp$result = _Utils_ap(
							result,
							A2($author$project$Internal$Interpolation$after, a, b)),
							$temp$section = _Utils_Tuple2(
							A2($elm$core$List$cons, b, rest),
							broken);
						result = $temp$result;
						section = $temp$section;
						continue expand;
					} else {
						if (!section.b.$) {
							var _v3 = section.a;
							var last = _v3.a;
							var broken = section.b.a;
							return _Utils_ap(
								result,
								_List_fromArray(
									[
										A2($author$project$Internal$Data$Point, broken.ab, last.ad)
									]));
						} else {
							var _v4 = section.a;
							var last = _v4.a;
							var _v5 = section.b;
							return result;
						}
					}
				} else {
					return result;
				}
			}
		});
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			expand(_List_Nil),
			$elm$core$List$map($author$project$Internal$Path$Line)),
		sections);
};
var $author$project$Internal$Interpolation$toCommands = F2(
	function (interpolation, data) {
		var pointsSections = $elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$mapFirst(
					$elm$core$List$map(
						function ($) {
							return $.mj;
						})),
				$elm$core$Tuple$mapSecond(
					$elm$core$Maybe$map(
						function ($) {
							return $.mj;
						}))));
		var points = $elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$List$map(
					function ($) {
						return $.mj;
					})));
		switch (interpolation) {
			case 0:
				return $author$project$Internal$Interpolation$linear(
					points(data));
			case 1:
				return $author$project$Internal$Interpolation$monotone(
					points(data));
			default:
				return $author$project$Internal$Interpolation$stepped(
					pointsSections(data));
		}
	});
var $author$project$Internal$Area$opacitySingle = function (config) {
	switch (config.$) {
		case 0:
			return 0;
		case 1:
			var opacity_ = config.a;
			return opacity_;
		case 2:
			var opacity_ = config.a;
			return 1;
		default:
			var opacity_ = config.a;
			return 1;
	}
};
var $author$project$Internal$Path$toPoint = function (command) {
	switch (command.$) {
		case 9:
			return A2($author$project$LineChart$Coordinate$Point, 0, 0);
		case 0:
			var p = command.a;
			return p;
		case 1:
			var p = command.a;
			return p;
		case 2:
			var x = command.a;
			return A2($author$project$LineChart$Coordinate$Point, x, 0);
		case 3:
			var y = command.a;
			return A2($author$project$LineChart$Coordinate$Point, 0, y);
		case 4:
			var c1 = command.a;
			var c2 = command.b;
			var p = command.c;
			return p;
		case 5:
			var c1 = command.a;
			var p = command.b;
			return p;
		case 6:
			var c1 = command.a;
			var p = command.b;
			return p;
		case 7:
			var p = command.a;
			return p;
		default:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var p = command.f;
			return p;
	}
};
var $author$project$Internal$Utils$towardsZero = function (_v0) {
	var max = _v0.ed;
	var min = _v0.ej;
	return A3($elm$core$Basics$clamp, min, max, 0);
};
var $author$project$Internal$Utils$last = function (list) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(list) - 1,
			list));
};
var $author$project$Internal$Utils$lastSafe = F2(
	function (first, rest) {
		return A2(
			$elm$core$Maybe$withDefault,
			first,
			$author$project$Internal$Utils$last(rest));
	});
var $author$project$Internal$Utils$viewWithEdges = F2(
	function (stuff, view) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return A3(
				view,
				first,
				rest,
				A2($author$project$Internal$Utils$lastSafe, first, rest));
		} else {
			return $elm$svg$Svg$text('');
		}
	});
var $author$project$Internal$Line$viewArea = F5(
	function (_v0, line_, style_, interpolation, data_) {
		var system = _v0.jT;
		var lineConfig = _v0.iL;
		var area = _v0.hl;
		var ground = function (point) {
			return A2(
				$author$project$Internal$Data$Point,
				point.ab,
				$author$project$Internal$Utils$towardsZero(system.ad));
		};
		var commands = F3(
			function (first, middle, last) {
				return A3(
					$author$project$Internal$Utils$concat,
					_List_fromArray(
						[
							$author$project$Internal$Path$Move(
							ground(
								$author$project$Internal$Path$toPoint(first))),
							$author$project$Internal$Path$Line(
							$author$project$Internal$Path$toPoint(first))
						]),
					interpolation,
					_List_fromArray(
						[
							$author$project$Internal$Path$Line(
							ground(
								$author$project$Internal$Path$toPoint(last)))
						]));
			});
		var attributes = A2(
			$elm$core$List$cons,
			$author$project$LineChart$Junk$withinChartArea(system),
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$fillOpacity(
					$elm$core$String$fromFloat(
						$author$project$Internal$Area$opacitySingle(area))),
				A3($author$project$Internal$Line$toAreaAttributes, line_, style_, area)));
		return A2(
			$author$project$Internal$Utils$viewWithEdges,
			interpolation,
			F3(
				function (first, middle, last) {
					return A3(
						$author$project$Internal$Path$view,
						system,
						attributes,
						A3(commands, first, middle, last));
				}));
	});
var $author$project$Internal$Dots$view = F2(
	function (_v0, data) {
		var system = _v0.jT;
		var dotsConfig = _v0.h$;
		var shape = _v0.jG;
		var color = _v0.eT;
		var _v1 = dotsConfig;
		var config = _v1;
		var _v2 = config.fy(data.nF);
		var style_ = _v2;
		return A5($author$project$Internal$Dots$viewShape, system, style_, shape, color, data.mj);
	});
var $author$project$Internal$Line$viewDot = F3(
	function (_arguments, _v0, _v1) {
		var lineConfig = _v0;
		var style_ = _v1;
		return $author$project$Internal$Dots$view(
			{
				eT: style_.eT(lineConfig.eT),
				h$: _arguments.h$,
				jG: lineConfig.jG,
				jT: _arguments.jT
			});
	});
var $author$project$Internal$Utils$viewWithFirst = F2(
	function (stuff, view) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return A2(view, first, rest);
		} else {
			return $elm$svg$Svg$text('');
		}
	});
var $author$project$Internal$Line$viewSeries = F5(
	function (_v0, line_, style_, interpolation, data_) {
		var system = _v0.jT;
		var lineConfig = _v0.iL;
		var attributes = A2(
			$elm$core$List$cons,
			$author$project$LineChart$Junk$withinChartArea(system),
			A2($author$project$Internal$Line$toSeriesAttributes, line_, style_));
		return A2(
			$author$project$Internal$Utils$viewWithFirst,
			data_,
			F2(
				function (first, _v1) {
					return A3(
						$author$project$Internal$Path$view,
						system,
						attributes,
						A2(
							$elm$core$List$cons,
							$author$project$Internal$Path$Move(first.mj),
							interpolation));
				}));
	});
var $author$project$Internal$Line$viewSingle = F3(
	function (_arguments, line_, data_) {
		var style_ = function (_v1) {
			var look = _v1;
			return look(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.nF;
					},
					data_));
		}(_arguments.iL);
		var sections = A4(
			$author$project$Internal$Utils$part,
			function ($) {
				return $.lH;
			},
			data_,
			_List_Nil,
			_List_Nil);
		var parts = A2($elm$core$List$map, $elm$core$Tuple$first, sections);
		var viewDots = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__dots')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Internal$Line$viewDot, _arguments, line_, style_),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Internal$Data$isWithinRange(_arguments.jT),
						function ($) {
							return $.mj;
						}),
					$elm$core$List$concat(parts))));
		var commands = A2($author$project$Internal$Interpolation$toCommands, _arguments.ix, sections);
		var viewAreas = function (_v0) {
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__interpolation__area')
					]),
				A3(
					$elm$core$List$map2,
					A3($author$project$Internal$Line$viewArea, _arguments, line_, style_),
					commands,
					parts));
		};
		var viewSeriess = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__interpolation__line')
				]),
			A3(
				$elm$core$List$map2,
				A3($author$project$Internal$Line$viewSeries, _arguments, line_, style_),
				commands,
				parts));
		return _Utils_Tuple3(
			A2(
				$author$project$Internal$Utils$viewIf,
				$author$project$Internal$Area$hasArea(_arguments.hl),
				viewAreas),
			viewSeriess,
			viewDots);
	});
var $author$project$Internal$Line$viewStacked = F2(
	function (area, _v0) {
		var areas = _v0.a;
		var lines = _v0.b;
		var dots = _v0.c;
		var toList = F2(
			function (l, d) {
				return _List_fromArray(
					[l, d]);
			});
		var opacity = 'opacity: ' + $elm$core$String$fromFloat(
			$author$project$Internal$Area$opacityContainer(area));
		var bottoms = $elm$core$List$concat(
			A3($elm$core$List$map2, toList, lines, dots));
		return _List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__bottoms'),
						$elm$svg$Svg$Attributes$style(opacity)
					]),
				areas),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__tops')
					]),
				bottoms)
			]);
	});
var $author$project$Internal$Line$view = F3(
	function (_arguments, lines, datas) {
		var container = $elm$svg$Svg$g(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__lines')
				]));
		var buildSeriesViews = ($author$project$Internal$Area$opacityContainer(_arguments.hl) < 1) ? $author$project$Internal$Line$viewStacked(_arguments.hl) : $author$project$Internal$Line$viewNormal;
		return container(
			buildSeriesViews(
				$author$project$Internal$Utils$unzip3(
					A3(
						$elm$core$List$map2,
						$author$project$Internal$Line$viewSingle(_arguments),
						lines,
						datas))));
	});
var $author$project$LineChart$viewBoxAttribute = function (_v0) {
	var frame = _v0.d2;
	return $elm$svg$Svg$Attributes$viewBox(
		'0 0 ' + ($elm$core$String$fromFloat(frame.by.kc) + (' ' + $elm$core$String$fromFloat(frame.by.im))));
};
var $author$project$Internal$Axis$Line$config = function (_v0) {
	var config_ = _v0;
	return config_;
};
var $author$project$Internal$Axis$Title$config = function (_v0) {
	var title = _v0;
	return title;
};
var $author$project$Internal$Axis$Intersection$getY = function (_v0) {
	var func = _v0;
	return A2(
		$elm$core$Basics$composeL,
		function ($) {
			return $.ad;
		},
		func);
};
var $author$project$Internal$Axis$attributesLine = F2(
	function (system, _v0) {
		var events = _v0.le;
		var width = _v0.kc;
		var color = _v0.eT;
		return _Utils_ap(
			events,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(width)),
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString(color)),
					$author$project$Internal$Svg$withinChartArea(system)
				]));
	});
var $author$project$Internal$Axis$viewHorizontalAxisLine = F3(
	function (system, axisPosition, config) {
		return A5(
			$author$project$Internal$Svg$horizontal,
			system,
			A2($author$project$Internal$Axis$attributesLine, system, config),
			axisPosition,
			config.jJ,
			config.h3);
	});
var $author$project$Internal$Axis$attributesTick = function (_v0) {
	var width = _v0.kc;
	var color = _v0.eT;
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$strokeWidth(
			$elm$core$String$fromFloat(width)),
			$elm$svg$Svg$Attributes$stroke(
			$avh4$elm_color$Color$toCssString(color))
		]);
};
var $author$project$Internal$Axis$Tick$isPositive = function (direction) {
	if (direction === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Internal$Axis$lengthOfTick = function (_v0) {
	var length = _v0.fH;
	var direction = _v0.fd;
	return $author$project$Internal$Axis$Tick$isPositive(direction) ? (-length) : length;
};
var $author$project$Internal$Svg$Middle = 1;
var $author$project$Internal$Axis$viewHorizontalLabel = F4(
	function (system, _v0, position, view) {
		var direction = _v0.fd;
		var length = _v0.fH;
		var yOffset = $author$project$Internal$Axis$Tick$isPositive(direction) ? ((-5) - length) : (15 + length);
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.ab, position.ad),
							A2($author$project$Internal$Svg$offset, 0, yOffset)
						])),
					$author$project$Internal$Svg$anchorStyle(1)
				]),
			_List_fromArray(
				[view]));
	});
var $author$project$Internal$Svg$xTick = F5(
	function (system, height, userAttributes, y, x) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray))
				]),
			userAttributes,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y))),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y) + height))
				]));
		return A2($elm$svg$Svg$line, attributes, _List_Nil);
	});
var $author$project$Internal$Axis$viewHorizontalTick = F3(
	function (system, point, tick) {
		var x = point.ab;
		var y = point.ad;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Internal$Svg$xTick,
					system,
					$author$project$Internal$Axis$lengthOfTick(tick),
					$author$project$Internal$Axis$attributesTick(tick),
					y,
					x),
					A2(
					$author$project$Internal$Utils$viewMaybe,
					tick.iD,
					A3($author$project$Internal$Axis$viewHorizontalLabel, system, tick, point))
				]));
	});
var $author$project$Internal$Axis$viewHorizontalTitle = F3(
	function (system, at, _v0) {
		var title = _v0.nb;
		var position = at(
			A2(title.ep, system.g6, system.ab));
		var _v1 = title.i8;
		var xOffset = _v1.a;
		var yOffset = _v1.b;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__title'),
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.ab, position.ad),
							A2($author$project$Internal$Svg$offset, xOffset + 15, yOffset + 5)
						])),
					$author$project$Internal$Svg$anchorStyle(0)
				]),
			_List_fromArray(
				[title.j7]));
	});
var $author$project$Internal$Axis$viewHorizontal = F3(
	function (system, intersection, _v0) {
		var config = _v0;
		var viewConfig = {
			bk: A2($author$project$Internal$Axis$Intersection$getY, intersection, system),
			c3: A3($author$project$Internal$Axis$Line$config, config.aJ, system.g6, system.ab),
			z: A3($author$project$Internal$Axis$Ticks$ticks, system.g6, system.ab, config.z),
			nb: $author$project$Internal$Axis$Title$config(config.nb)
		};
		var viewAxisLine = A2($author$project$Internal$Axis$viewHorizontalAxisLine, system, viewConfig.bk);
		var at = function (x) {
			return {ab: x, ad: viewConfig.bk};
		};
		var viewTick = function (tick) {
			return A3(
				$author$project$Internal$Axis$viewHorizontalTick,
				system,
				at(tick.ep),
				tick);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__axis--horizontal')
				]),
			_List_fromArray(
				[
					A3($author$project$Internal$Axis$viewHorizontalTitle, system, at, viewConfig),
					viewAxisLine(viewConfig.c3),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('chart__ticks')
						]),
					A2($elm$core$List$map, viewTick, viewConfig.z))
				]));
	});
var $author$project$Internal$Axis$Intersection$getX = function (_v0) {
	var func = _v0;
	return A2(
		$elm$core$Basics$composeL,
		function ($) {
			return $.ab;
		},
		func);
};
var $author$project$Internal$Axis$viewVerticalAxisLine = F3(
	function (system, axisPosition, config) {
		return A5(
			$author$project$Internal$Svg$vertical,
			system,
			A2($author$project$Internal$Axis$attributesLine, system, config),
			axisPosition,
			config.jJ,
			config.h3);
	});
var $author$project$Internal$Axis$viewVerticalLabel = F4(
	function (system, _v0, position, view) {
		var direction = _v0.fd;
		var length = _v0.fH;
		var xOffset = $author$project$Internal$Axis$Tick$isPositive(direction) ? (5 + length) : ((-5) - length);
		var anchor = $author$project$Internal$Axis$Tick$isPositive(direction) ? 0 : 2;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.ab, position.ad),
							A2($author$project$Internal$Svg$offset, xOffset, 5)
						])),
					$author$project$Internal$Svg$anchorStyle(anchor)
				]),
			_List_fromArray(
				[view]));
	});
var $author$project$Internal$Svg$yTick = F5(
	function (system, width, userAttributes, x, y) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick'),
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray))
				]),
			userAttributes,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x) - width)),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y))),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y)))
				]));
		return A2($elm$svg$Svg$line, attributes, _List_Nil);
	});
var $author$project$Internal$Axis$viewVerticalTick = F3(
	function (system, point, tick) {
		var x = point.ab;
		var y = point.ad;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Internal$Svg$yTick,
					system,
					$author$project$Internal$Axis$lengthOfTick(tick),
					$author$project$Internal$Axis$attributesTick(tick),
					x,
					y),
					A2(
					$author$project$Internal$Utils$viewMaybe,
					tick.iD,
					A3($author$project$Internal$Axis$viewVerticalLabel, system, tick, point))
				]));
	});
var $author$project$Internal$Axis$viewVerticalTitle = F3(
	function (system, at, _v0) {
		var title = _v0.nb;
		var position = at(
			A2(title.ep, system.g7, system.ad));
		var _v1 = title.i8;
		var xOffset = _v1.a;
		var yOffset = _v1.b;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__title'),
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.ab, position.ad),
							A2($author$project$Internal$Svg$offset, xOffset + 2, yOffset - 10)
						])),
					$author$project$Internal$Svg$anchorStyle(2)
				]),
			_List_fromArray(
				[title.j7]));
	});
var $author$project$Internal$Axis$viewVertical = F3(
	function (system, intersection, _v0) {
		var config = _v0;
		var viewConfig = {
			bk: A2($author$project$Internal$Axis$Intersection$getX, intersection, system),
			c3: A3($author$project$Internal$Axis$Line$config, config.aJ, system.g7, system.ad),
			z: A3($author$project$Internal$Axis$Ticks$ticks, system.g7, system.ad, config.z),
			nb: $author$project$Internal$Axis$Title$config(config.nb)
		};
		var viewAxisLine = A2($author$project$Internal$Axis$viewVerticalAxisLine, system, viewConfig.bk);
		var at = function (y) {
			return {ab: viewConfig.bk, ad: y};
		};
		var viewTick = function (tick) {
			return A3(
				$author$project$Internal$Axis$viewVerticalTick,
				system,
				at(tick.ep),
				tick);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__axis--vertical')
				]),
			_List_fromArray(
				[
					A3($author$project$Internal$Axis$viewVerticalTitle, system, at, viewConfig),
					viewAxisLine(viewConfig.c3),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('chart__ticks')
						]),
					A2($elm$core$List$map, viewTick, viewConfig.z))
				]));
	});
var $author$project$LineChart$viewCustom = F2(
	function (config, lines) {
		var junkLineInfo = function (line_) {
			return _Utils_Tuple3(
				A3($author$project$Internal$Line$color, config.c3, line_, _List_Nil),
				$author$project$Internal$Line$label(line_),
				$author$project$Internal$Line$data(line_));
		};
		var getJunk = A3(
			$author$project$Internal$Junk$getLayers,
			A2($elm$core$List$map, junkLineInfo, lines),
			$author$project$Internal$Axis$variable(config.ab),
			$author$project$Internal$Axis$variable(config.ad));
		var data = A2($author$project$LineChart$toDataPoints, config, lines);
		var dataAll = $elm$core$List$concat(data);
		var dataSafe = A2(
			$elm$core$List$map,
			$elm$core$List$filter(
				function ($) {
					return $.lH;
				}),
			data);
		var dataAllSafe = $elm$core$List$concat(dataSafe);
		var system = A2($author$project$LineChart$toSystem, config, dataAllSafe);
		var viewLines = $author$project$Internal$Line$view(
			{hl: config.hl, h$: config.k5, ix: config.ix, iL: config.c3, jT: system});
		var viewLegends = $author$project$Internal$Legends$view(
			{
				hl: config.hl,
				kZ: dataSafe,
				h$: config.k5,
				iG: config.iG,
				iL: config.c3,
				fS: lines,
				jT: system,
				ab: $author$project$Internal$Axis$variable(config.ab),
				ad: $author$project$Internal$Axis$variable(config.ad)
			});
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$author$project$Internal$Container$properties,
					function ($) {
						return $.dF;
					},
					config.kT),
					A3($author$project$Internal$Events$toContainerAttributes, dataAll, system, config.le),
					_List_fromArray(
					[
						$author$project$LineChart$viewBoxAttribute(system)
					])
				]));
		var addGrid = $author$project$Internal$Junk$addBelow(
			A4($author$project$Internal$Grid$view, system, config.ab, config.ad, config.bj));
		var junk = addGrid(
			A2(getJunk, system, config.lI));
		return A4(
			$author$project$LineChart$container,
			config,
			system,
			junk.lv,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$LineChart$clipPath(system)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('chart__junk--below')
							]),
						junk.cE),
						A2(viewLines, lines, data),
						A3($author$project$LineChart$chartAreaPlatform, config, dataAll, system),
						A3($author$project$Internal$Axis$viewHorizontal, system, config.bk, config.ab),
						A3($author$project$Internal$Axis$viewVertical, system, config.bk, config.ad),
						viewLegends,
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('chart__junk--above')
							]),
						junk.eG)
					])));
	});
var $author$project$LandingSite$CTokens$exchangeRateGraph = F3(
	function (graphModel, historicExchangeRates, model) {
		var exchangeData = A2(
			$elm$core$List$map,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return A2($author$project$LandingSite$CTokens$Datum, k, v);
			},
			historicExchangeRates);
		var chartLines = _List_fromArray(
			[
				A4($author$project$LineChart$line, $author$project$LineChart$Colors$supply, $author$project$LineChart$Dots$circle, 'Exchange', exchangeData)
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('chart')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$LineChart$viewCustom,
						$author$project$LandingSite$CTokens$chartConfig(model),
						chartLines)
					]))
			]);
	});
var $author$project$Strings$Translations$interest_unique = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest, unique to each asset';
		case 1:
			return 'Interés, único para cada activo';
		case 2:
			return '每种资产，计息各有千秋';
		case 3:
			return 'Intérêt unique à chaque actif';
		default:
			return '각 자산에 고유 한 관심';
	}
};
var $author$project$Strings$Translations$interest_unique_description = function (lang) {
	switch (lang) {
		case 0:
			return 'As a market earns interest, its cToken becomes convertible into an increasing quantity of the underlying asset.';
		case 1:
			return 'A medida que un mercado gana intereses, su cToken se convierte en una cantidad creciente del activo subyacente.';
		case 2:
			return '某资产类别的市场中产生计息，它的对应cToken可换得的底层（被抵押）资产数量就会增加。';
		case 3:
			return 'À mesure qu\'un marché génère des intérêts, son cToken devient convertible en une quantité croissante d\'actif sous-jacent.';
		default:
			return '시장이 관심을 가지면서 cToken은 증가하는 기초 자산으로 전환 할 수있게됩니다.';
	}
};
var $author$project$Strings$Translations$mint = function (lang) {
	switch (lang) {
		case 0:
			return 'Mint';
		case 1:
			return 'menta';
		case 2:
			return '铸币';
		case 3:
			return 'menthe';
		default:
			return '민트';
	}
};
var $author$project$Strings$Translations$mint_amount = function (lang) {
	switch (lang) {
		case 0:
			return 'mintAmount';
		case 1:
			return 'mintAmount';
		case 2:
			return 'mintAmount';
		case 3:
			return 'mintAmount';
		default:
			return '박하';
	}
};
var $author$project$Strings$Translations$mint_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - The amount supplied, in units of the underlying asset.';
		case 1:
			return '- El importe suministrado, en unidades del activo subyacente.';
		case 2:
			return '- 提供的金额，以标的资产为单位。';
		case 3:
			return '- Le montant fourni, en unités de l\'actif sous-jacent.';
		default:
			return '-기초 자산의 단위로 공급량.';
	}
};
var $author$project$Strings$Translations$mint_description = function (lang) {
	switch (lang) {
		case 0:
			return 'When you supply an asset to Compound, cTokens are minted. The number of cTokens minted is the amount of underlying asset being provided divided by the current Exchange Rate.';
		case 1:
			return 'Cuando suministra un activo a Compound, se emiten cTokens. El número de cTokens acuñados es la cantidad de activo subyacente que se proporciona dividido por el tipo de cambio actual.';
		case 2:
			return '当您向 Compound 供应资产时，cTokens 会被铸造。铸造的 cTokens 数量是提供的标的资产的数量除以当前的汇率。';
		case 3:
			return 'Lorsque vous fournissez un actif à Compound, les cTokens sont frappés. Le nombre de cTokens frappés est le montant de l\'actif sous-jacent fourni divisé par le taux de change actuel.';
		default:
			return '컴파운드에 자산을 제공하면 cToken이 발행됩니다. 발행 된 cToken의 수는 제공되는 기본 자산의 양을 현재 환율로 나눈 값입니다.';
	}
};
var $author$project$Strings$Translations$msg_sender = function (lang) {
	switch (lang) {
		case 0:
			return 'msg.sender';
		case 1:
			return 'msg.sender';
		case 2:
			return 'msg.sender';
		case 3:
			return 'msg.sender';
		default:
			return 'msg.sender';
	}
};
var $author$project$Strings$Translations$msg_sender_description_mint = function (lang) {
	switch (lang) {
		case 0:
			return ' - The account which supplies the asset and owns the cTokens.';
		case 1:
			return '- La cuenta que suministra el activo y posee los cTokens.';
		case 2:
			return '- 提供资产并拥有 cTokens 的帐户。';
		case 3:
			return '- Le compte qui fournit l\'actif et détient les cTokens.';
		default:
			return '-자산을 제공하고 cToken을 소유하는 계정.';
	}
};
var $author$project$Strings$Translations$msg_sender_description_redeem = function (lang) {
	switch (lang) {
		case 0:
			return ' - The account to which redeemed funds shall be transferred.';
		case 1:
			return '- La cuenta a la que se transferirán los fondos redimidos.';
		case 2:
			return '- 转换资金的账户。';
		case 3:
			return '- Le compte sur lequel les fonds rachetés seront virés.';
		default:
			return '-사용 된 자금이 이체 된 계좌.';
	}
};
var $author$project$Strings$Translations$need_help = function (lang) {
	switch (lang) {
		case 0:
			return 'Need help?';
		case 1:
			return '¿Necesitas ayuda?';
		case 2:
			return '需要帮助？';
		case 3:
			return 'Besoin d\'aide?';
		default:
			return '도움이 필요하세요?';
	}
};
var $author$project$Strings$Translations$need_help_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Frequently asked questions.';
		case 1:
			return 'Preguntas frecuentes.';
		case 2:
			return '常见问题。';
		case 3:
			return 'Questions fréquemment posées.';
		default:
			return '자주 묻는 질문';
	}
};
var $author$project$Strings$Translations$number_borrowers = function (lang) {
	switch (lang) {
		case 0:
			return '# of Borrowers';
		case 1:
			return '# Prestatarios';
		case 2:
			return '借款人数';
		case 3:
			return '# Emprunteurs';
		default:
			return '대출자';
	}
};
var $author$project$Strings$Translations$number_suppliers = function (lang) {
	switch (lang) {
		case 0:
			return '# of Suppliers';
		case 1:
			return '# Proveedores';
		case 2:
			return '存款人数';
		case 3:
			return '# Fournisseurs';
		default:
			return '공급자';
	}
};
var $author$project$Strings$Translations$redeem = function (lang) {
	switch (lang) {
		case 0:
			return 'Redeem';
		case 1:
			return 'Redimir';
		case 2:
			return '赎回';
		case 3:
			return 'Racheter';
		default:
			return '도로 사다';
	}
};
var $author$project$Strings$Translations$redeem_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The redeem function transfers the underlying asset from the money market to the user in exchange for previously minted cTokens. The amount of underlying redeemed is the number of cTokens multiplied by the current Exchange Rate. The amount redeemed must be less than the user\'s Account Liquidity and the market\'s available liquidity.';
		case 1:
			return 'La función de canje transfiere el activo subyacente del mercado monetario al usuario a cambio de cTokens previamente acuñados. La cantidad de canje subyacente es el número de cTokens multiplicado por el tipo de cambio actual. El monto redimido debe ser menor que la Liquidez de la cuenta del usuario y la liquidez disponible del mercado.';
		case 2:
			return '赎回功能将相关资产从货币市场转移给用户，以换取先前铸造的 cTokens。赎回的潜在金额是 cTokens 的数量乘以当前的汇率。兑换的金额必须低于用户的账户流动性和市场的可用流动性。';
		case 3:
			return 'La fonction de rachat transfère l\'actif sous-jacent du marché monétaire à l\'utilisateur en échange de cTokens précédemment émis. Le montant du sous-jacent racheté est le nombre de cTokens multiplié par le taux de change actuel. Le montant remboursé doit être inférieur à la liquidité du compte de l\'utilisateur et à la liquidité disponible sur le marché.';
		default:
			return '상환 기능은 이전에 발행 된 cToken과 교환하여 기초 자산을 머니 마켓에서 사용자에게 이전합니다. 사용 된 기본 금액은 cToken 수에 현재 환율을 곱한 값입니다. 상환 된 금액은 사용자의 계좌 유동성 및 시장의 이용 가능한 유동성보다 적어야합니다.';
	}
};
var $author$project$Strings$Translations$redeem_tokens = function (lang) {
	switch (lang) {
		case 0:
			return 'redeemTokens';
		case 1:
			return 'canjearTokens';
		case 2:
			return '赎回代币';
		case 3:
			return 'redeemTokens';
		default:
			return '교환 토큰';
	}
};
var $author$project$Strings$Translations$redeem_tokens_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - The number of cTokens to be redeemed.';
		case 1:
			return '- El número de cTokens para canjear.';
		case 2:
			return '- 要兑换的 cTokens 数量。';
		case 3:
			return '- Le nombre de cTokens à échanger.';
		default:
			return '-교환 할 cToken의 수입니다.';
	}
};
var $author$project$Strings$Translations$return = function (lang) {
	switch (lang) {
		case 0:
			return 'RETURN';
		case 1:
			return 'REGRESO';
		case 2:
			return '返回';
		case 3:
			return 'REVENIR';
		default:
			return '반환';
	}
};
var $author$project$Strings$Translations$return_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - 0 on success, otherwise an ';
		case 1:
			return '- 0 en caso de éxito, de lo contrario un';
		case 2:
			return '- 成功时为0，否则为';
		case 3:
			return '- 0 en cas de succès, sinon un';
		default:
			return '-성공하면 0, 그렇지 않으면';
	}
};
var $author$project$Strings$Translations$token_address = function (lang) {
	switch (lang) {
		case 0:
			return 'Token Address';
		case 1:
			return 'Dirección de token';
		case 2:
			return 'token地址';
		case 3:
			return 'Adresse de jeton';
		default:
			return '토큰 주소';
	}
};
var $author$project$Strings$Translations$tokenized_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Portable Balances';
		case 1:
			return 'Balance Tokenizado';
		case 2:
			return '资产随身行';
		case 3:
			return 'Balances portables';
		default:
			return '휴대용 저울';
	}
};
var $author$project$Strings$Translations$tokenized_balance_description = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens represent your balance in the protocol, and accrue interest over time.';
		case 1:
			return 'Los cTokens representan su saldo en el protocolo y generan intereses con el tiempo.';
		case 2:
			return 'cToken代表用户在协议中的资产余额，随时间增长自动计息';
		case 3:
			return 'Les cTokens représentent votre équilibre dans le protocole et génèrent des intérêts au fil du temps.';
		default:
			return 'c 토큰은 프로토콜의 균형을 나타내며 시간이 지남에 따라이자를 발생시킵니다.';
	}
};
var $author$project$Strings$Translations$total_supply = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Supply';
		case 1:
			return 'Suministro total';
		case 2:
			return '总存款';
		case 3:
			return 'Approvisionnement total';
		default:
			return '공급 합계';
	}
};
var $author$project$Strings$Translations$useful_collateral = function (lang) {
	switch (lang) {
		case 0:
			return 'Useful Collateral';
		case 1:
			return 'Colateral útil';
		case 2:
			return '有用的抵押品';
		case 3:
			return 'Garantie utile';
		default:
			return '유용한 담보';
	}
};
var $author$project$Strings$Translations$useful_collateral_description = function (lang) {
	switch (lang) {
		case 0:
			return 'By holding or receiving a cToken, you can borrow from the Compound protocol.';
		case 1:
			return 'Al mantener o recibir un cToken, puede tomar prestado del Protocolo Compound.';
		case 2:
			return '持有或者收到了cToken，你就可以向Compound协议借款。';
		case 3:
			return 'En détenant ou en recevant un cToken, vous pouvez emprunter à partir du protocole composé.';
		default:
			return 'cToken을 보유하거나 받으면 Compound 프로토콜에서 빌릴 수 있습니다.';
	}
};
var $author$project$Strings$Translations$view_all_faqs = function (lang) {
	switch (lang) {
		case 0:
			return 'View all faqs';
		case 1:
			return 'Ver todas las preguntas frecuentes';
		case 2:
			return '查看所有常见问题';
		case 3:
			return 'Voir toutes les FAQ';
		default:
			return '모든 FAQ보기';
	}
};
var $author$project$Strings$Translations$view_api_docs = function (lang) {
	switch (lang) {
		case 0:
			return 'View api docs';
		case 1:
			return 'Ver documentos de la API';
		case 2:
			return '查看 api 文档';
		case 3:
			return 'Afficher les documents de l\'API';
		default:
			return 'API 문서보기';
	}
};
var $author$project$Strings$Translations$your_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply assets, get cTokens.';
		case 1:
			return 'Tu saldo, tokenizado.';
		case 2:
			return '存入资产，得到cToken';
		case 3:
			return 'Fournissez des actifs, obtenez des cTokens.';
		default:
			return '자산을 공급하고 cToken을 얻으십시오.';
	}
};
var $author$project$LandingSite$CTokens$view = F5(
	function (userLanguage, maybeConfig, maybeLatestTokens, graphModel, model) {
		var latestTokens = function () {
			if (!maybeLatestTokens.$) {
				var tokens = maybeLatestTokens.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (cToken) {
							return _Utils_Tuple2(
								function ($) {
									return $.jY;
								}(cToken),
								cToken);
						},
						tokens.kG));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		var maybeCToken = function () {
			var _v16 = model.cm;
			if (!_v16.$) {
				var cTokenConfig = _v16.a;
				return A2(
					$elm$core$Dict$get,
					$author$project$Eth$Ethereum$getContractAddressString(cTokenConfig.hd),
					latestTokens);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var historicExchangeRates = function () {
			var _v15 = model.cm;
			if (!_v15.$) {
				var cToken = _v15.a;
				return A3(
					$author$project$Utils$Graph$buildGraphData,
					cToken.hd,
					graphModel.lf,
					function (v) {
						return v;
					});
			} else {
				return _List_Nil;
			}
		}();
		var historicExchangeRatesDict = $elm$core$Dict$fromList(historicExchangeRates);
		var maybeCurrentExchangeRate = $elm$core$List$head(
			$elm$core$List$reverse(historicExchangeRates));
		var scaledExchangeRates = A2(
			$elm$core$List$map,
			function (_v14) {
				var x = _v14.a;
				var y = _v14.b;
				return _Utils_Tuple2(x, y * 100000000.0);
			},
			historicExchangeRates);
		var loaderActive = (!$elm$core$List$length(scaledExchangeRates)) ? ' active' : '';
		var faqDisplayActive = function (index) {
			var faqState = A2($elm$core$Array$get, index, model.bd);
			var faqAccordianClass = function () {
				if ((!faqState.$) && faqState.a) {
					return ' active';
				} else {
					return '';
				}
			}();
			return faqAccordianClass;
		};
		var exchangeRate = function () {
			var _v10 = model.b_;
			if (!_v10.$) {
				var xValue = _v10.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Decimal$fromFloat,
					A2($elm$core$Dict$get, xValue, historicExchangeRatesDict));
			} else {
				if (!maybeCurrentExchangeRate.$) {
					var _v12 = maybeCurrentExchangeRate.a;
					var rate = _v12.b;
					return $author$project$Decimal$fromFloat(rate);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		var exchangeRateDisplay = function () {
			if (!exchangeRate.$) {
				var rate = exchangeRate.a;
				return A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 8, false, rate);
			} else {
				return '-';
			}
		}();
		var dropdownActiveClass = function () {
			var _v8 = model.cP;
			if (_v8) {
				return ' active';
			} else {
				return '';
			}
		}();
		var dates = A2(
			$elm$core$List$filterMap,
			function (_v7) {
				var index = _v7.a;
				var time = _v7.b;
				return ((!index) || (!A2($elm$core$Basics$modBy, 5, index + 1))) ? $elm$core$Maybe$Just(
					A2(
						$justinmimbs$date$Date$format,
						'MMMM d',
						A2(
							$justinmimbs$date$Date$fromPosix,
							$elm$time$Time$utc,
							$elm$time$Time$millisToPosix(
								$elm$core$Basics$round(time) * 1000)))) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, _v6) {
						var time = _v6.a;
						return _Utils_Tuple2(index, time);
					}),
				historicExchangeRates));
		var withMobileHideClass = function (index) {
			var total = $elm$core$List$length(dates);
			var halfTotal = (total / 2) | 0;
			return ((!index) || (_Utils_eq(index, halfTotal) || _Utils_eq(index, total - 1))) ? '' : ' mobile-hide';
		};
		var codeSnippetClass = function (index) {
			var activeClass = _Utils_eq(index, model.dB) ? ' active' : '';
			return activeClass;
		};
		var cTokens = function () {
			if (!maybeConfig.$) {
				var config = maybeConfig.a;
				return $elm$core$Dict$values(config.ht);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = function () {
			var _v1 = model.cm;
			if (!_v1.$) {
				var cToken = _v1.a;
				return {
					hd: $author$project$Eth$Ethereum$getContractAddressString(cToken.hd),
					i5: cToken.i5,
					jS: cToken.jS,
					g$: cToken.cy.jS
				};
			} else {
				return {hd: '', i5: '', jS: '', g$: ''};
			}
		}();
		var address = _v0.hd;
		var name = _v0.i5;
		var symbol = _v0.jS;
		var underlyingSymbol = _v0.g$;
		var cleanedAddress = A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, address);
		var _v2 = function () {
			if (!maybeCToken.$) {
				var cToken = maybeCToken.a;
				return _Utils_Tuple3(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, true, cToken.nw),
					$elm$core$String$fromInt(cToken.l3),
					$elm$core$String$fromInt(cToken.l4));
			} else {
				return _Utils_Tuple3('-', '-', '-');
			}
		}();
		var totalSupply = _v2.a;
		var numberOfBorrowers = _v2.b;
		var numberOfSuppliers = _v2.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$LandingSite$CTokens$ForSelf(
						$author$project$LandingSite$CTokens$ToggleDropdown(false)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-overview')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('pattern-header')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cDai')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cWbtc')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cEth')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cZrx')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cUsdc')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cRep')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-8 col-sm-3 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('overview-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$your_balance(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row cToken-points')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon token')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$tokenized_balance(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$tokenized_balance_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon eth')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$erc_20(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$erc_20_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon block')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$useful_collateral(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$useful_collateral_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$interest_unique(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('header-description')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$interest_unique_description(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('graph-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('cToken-graph')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('graph-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('graph-header')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--' + symbol)
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$h4,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('token-name')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(name)
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('dropdown'),
																			$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
																			$author$project$LandingSite$CTokens$ForSelf(
																				$author$project$LandingSite$CTokens$ToggleDropdown(!model.cP)))
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('dropdown__selected')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + symbol)
																						]),
																					_List_Nil),
																					A2(
																					$elm$html$Html$p,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('small')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(symbol)
																						]))
																				])),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('dropdown__options ' + dropdownActiveClass)
																				]),
																			A2(
																				$elm$core$List$map,
																				function (cToken) {
																					return A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option'),
																								$elm$html$Html$Events$onClick(
																								$author$project$LandingSite$CTokens$ForSelf(
																									$author$project$LandingSite$CTokens$SelectCToken(cToken)))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + cToken.jS)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$p,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('small')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(cToken.jS)
																									]))
																							]));
																				},
																				A2(
																					$elm$core$List$sortBy,
																					function ($) {
																						return $.jS;
																					},
																					cTokens)))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('chart-header')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('exchange-rate')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(exchangeRateDisplay)
																				])),
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(underlyingSymbol)
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('line-chart')
																]),
															_Utils_ap(
																_List_Nil,
																A3($author$project$LandingSite$CTokens$exchangeRateGraph, graphModel, scaledExchangeRates, model))),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('chart-footer')
																]),
															A2(
																$elm$core$List$indexedMap,
																F2(
																	function (index, date) {
																		return A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class(
																					'small' + withMobileHideClass(index))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(date)
																				]));
																	}),
																dates)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('graph-footer')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('total-supply')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$total_supply(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(totalSupply)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('suppliers')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$number_suppliers(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(numberOfSuppliers)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('borrowers')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$number_borrowers(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(numberOfBorrowers)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('smart-contract')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$token_address(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$a,
																			_Utils_ap(
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																					]),
																				A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://etherscan.io/token/' + address)),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$h4,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(cleanedAddress)
																						]))
																				]))
																		]))
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row faq-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('faq-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_all_faqs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 faqs')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$id('line')
															]),
														_List_Nil)
													]),
												$elm$core$List$concat(
													A2(
														$elm$core$List$indexedMap,
														F2(
															function (index, _v4) {
																var header = _v4.a;
																var content = _v4.b;
																return _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$class('faq-item')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class('faq-item-header'),
																						$elm$html$Html$Events$onClick(
																						$author$project$LandingSite$CTokens$ForSelf(
																							$author$project$LandingSite$CTokens$ToggleAccordianAtIndex(index)))
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$h3,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('faq-item-text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(header)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class(
																								'plus' + faqDisplayActive(index))
																							]),
																						_List_fromArray(
																							[
																								A2($elm$html$Html$span, _List_Nil, _List_Nil),
																								A2($elm$html$Html$span, _List_Nil, _List_Nil)
																							]))
																					])),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class(
																						'faq-item-description' + faqDisplayActive(index))
																					]),
																				content)
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$id('line')
																			]),
																		_List_Nil)
																	]);
															}),
														$author$project$LandingSite$CTokens$accordianData(userLanguage)))))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-build')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$build_with(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('build-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$build_with_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_api_docs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('illo-ctoken')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-0 col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-10 code-section')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('code-section-headers')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(0)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(0)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$mint(userLanguage))
																])),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(1)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(1)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$redeem(userLanguage))
																])),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(2)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(2)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$api(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('code-section-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(0))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$mint_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('function')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('mint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token argument')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('mintAmount')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('returns')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										]))
																								]))
																						]))
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code-values')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$ul,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender_description_mint(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$mint_amount(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$mint_amount_description(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return_description(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$a,
																									A2(
																										$author$project$Utils$CompoundHtmlAttributes$href,
																										0,
																										$author$project$LandingSite$Page$getHrefUrl(
																											A2(
																												$author$project$LandingSite$Page$Docs,
																												1,
																												$elm$core$Maybe$Just('ctoken-error-codes')))),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$error_code(userLanguage))
																										]))
																								]))
																						]))
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(1))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$redeem_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('function')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('redeem')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token argument')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('redeemTokens')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('returns')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										]))
																								]))
																						]))
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code-values')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$ul,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender_description_redeem(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$redeem_tokens(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$redeem_tokens_description(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return_description(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$a,
																									A2(
																										$author$project$Utils$CompoundHtmlAttributes$href,
																										0,
																										$author$project$LandingSite$Page$getHrefUrl(
																											A2(
																												$author$project$LandingSite$Page$Docs,
																												1,
																												$elm$core$Maybe$Just('ctoken-error-codes')))),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$error_code(userLanguage))
																										]))
																								]))
																						]))
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(2))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$c_tokens_api_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token comment')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('// Retreives list all cTokens')
																										]))
																								])),
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('fetch')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token string')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('\'https://api.compound.finance/api/v2/ctoken\'')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(';')
																										]))
																								]))
																						]))
																				]))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Comp$CopyMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$Comp$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Comp$ToggleAccordianAtIndex = function (a) {
	return {$: 0, a: a};
};
var $author$project$Eth$Ethereum$TokenAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Strings$Translations$apy = function (lang) {
	switch (lang) {
		case 0:
			return 'APY';
		case 1:
			return 'APY';
		case 2:
			return '亚太地区';
		case 3:
			return 'APY';
		default:
			return 'APY';
	}
};
var $author$project$Strings$Translations$borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow';
		case 1:
			return 'Pedir prestado';
		case 2:
			return '借贷';
		case 3:
			return 'Emprunter';
		default:
			return '대출';
	}
};
var $author$project$Eth$Oracle$getCompPriceUSD = $author$project$Decimal$fromInt(155);
var $author$project$Utils$CompHelper$calculateDistributionAPY = F3(
	function (etherPrice, cToken, marketCompDistribution) {
		var total_supply_value_in_usd = A2($author$project$Decimal$mul, etherPrice, cToken.nx);
		var total_borrow_value_in_usd = A2($author$project$Decimal$mul, etherPrice, cToken.no);
		var totalComp = marketCompDistribution.hH;
		var supplierDailyComp = marketCompDistribution.mW;
		var pow365 = function (num) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Decimal$zero,
				$author$project$Decimal$fromFloat(
					A2(
						$elm$core$Basics$pow,
						$author$project$Decimal$toFloat(num),
						365)));
		};
		var compPrice = $author$project$Eth$Oracle$getCompPriceUSD;
		var supplierDailyCompUsd = A2($author$project$Decimal$mul, compPrice, supplierDailyComp);
		var supplierDailyCompRate = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, supplierDailyCompUsd, total_supply_value_in_usd));
		var supplierCompApy = A2(
			$author$project$Functions$decimalMin,
			$author$project$Decimal$fromInt(100000),
			A2(
				$author$project$Decimal$sub,
				pow365(
					A2($author$project$Decimal$add, $author$project$Decimal$one, supplierDailyCompRate)),
				$author$project$Decimal$one));
		var borrowerDailyComp = marketCompDistribution.kB;
		var borrowerDailyCompUsd = A2($author$project$Decimal$mul, compPrice, borrowerDailyComp);
		var borrowerDailyCompRate = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, borrowerDailyCompUsd, total_borrow_value_in_usd));
		var borrowerCompApy = A2(
			$author$project$Functions$decimalMin,
			$author$project$Decimal$fromInt(100000),
			A2(
				$author$project$Decimal$sub,
				pow365(
					A2($author$project$Decimal$add, $author$project$Decimal$one, borrowerDailyCompRate)),
				$author$project$Decimal$one));
		return {hq: borrowerCompApy, jP: supplierCompApy};
	});
var $author$project$Strings$Translations$daily_distribution = function (lang) {
	switch (lang) {
		case 0:
			return 'Daily Distribution';
		case 1:
			return 'Distribución diaria';
		case 2:
			return '用户分布';
		case 3:
			return 'Distribution quotidienne';
		default:
			return '일일 분배 수량';
	}
};
var $author$project$LandingSite$Comp$loadingMarketRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row markets-panel__market-row--loading')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__icon markets-panel__market-row__market__icon--loading ')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__text markets-panel__market-row__market__text--loading')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 mobile-hide')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__interest markets-panel__market-row__interest--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 mobile-hide')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__total-comp markets-panel__market-row__total-comp--loading')
						]),
					_List_Nil)
				]))
		]));
var $author$project$LandingSite$Comp$marketRow = F7(
	function (symbol, market, supplierCompApy, borrowerCompApy, supplierCompPerDay, borrowerCompPerDay, totalCompDistributed) {
		var totalComp = A2($author$project$Decimal$eq, totalCompDistributed, $author$project$Decimal$zero) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__total-comp markets-panel__market-row__total-comp--empty')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				])) : $elm$html$Html$text(
			A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, totalCompDistributed));
		var supplierApy = $elm$html$Html$text(
			$author$project$Utils$NumberFormatter$formatPercentage(supplierCompApy));
		var dailyComp = function () {
			var total = A2($author$project$Decimal$add, supplierCompPerDay, borrowerCompPerDay);
			return A2($author$project$Decimal$eq, total, $author$project$Decimal$zero) ? A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--empty')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('—')
					])) : $elm$html$Html$text(
				A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 2, false, total));
		}();
		var borrowerApy = $elm$html$Html$text(
			$author$project$Utils$NumberFormatter$formatPercentage(borrowerCompApy));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__icon icon ' + symbol)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(market)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time')
								]),
							_List_fromArray(
								[dailyComp]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[supplierApy])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[borrowerApy])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					_List_fromArray(
						[totalComp]))
				]));
	});
var $author$project$Strings$Translations$market_distribution = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Distribution';
		case 1:
			return 'Distribución del mercado';
		case 2:
			return '市场分布';
		case 3:
			return 'Distribution sur le marché';
		default:
			return '마켓 분배 현황';
	}
};
var $author$project$Strings$Translations$network_does_not_have_comp = function (lang) {
	switch (lang) {
		case 0:
			return 'This network does not have a COMP token.';
		case 1:
			return 'Esta red no tiene un token COMP.';
		case 2:
			return '该网络没有COMP令牌。';
		case 3:
			return 'Ce réseau n\'a pas de jeton COMP.';
		default:
			return '이 네트워크에는 COMP 토큰이 없습니다.';
	}
};
var $author$project$LandingSite$Comp$noCompMarketRow = F2(
	function (symbol, market) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__icon icon ' + symbol)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__market__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(market)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--empty')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('—')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--empty')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('—')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--empty')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('—')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('markets-panel__market-row__comp markets-panel__market-row__comp--empty')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('—')
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$remaining = function (lang) {
	switch (lang) {
		case 0:
			return 'Remaining';
		case 1:
			return 'Restante';
		case 2:
			return '未释放';
		case 3:
			return 'Restant';
		default:
			return '남은 수량';
	}
};
var $author$project$Strings$Translations$supply = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply';
		case 1:
			return 'Suministro';
		case 2:
			return '供应';
		case 3:
			return 'Approvisionnement';
		default:
			return '공급';
	}
};
var $author$project$Strings$Translations$total_distributed = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Distributed';
		case 1:
			return 'Total distribuido';
		case 2:
			return '已释放总量';
		case 3:
			return 'Total distribué';
		default:
			return '총 분배 수량';
	}
};
var $author$project$Strings$Translations$user_distribution = function (lang) {
	switch (lang) {
		case 0:
			return 'User Distribution';
		case 1:
			return 'Distribución de usuarios';
		case 2:
			return '用户分布';
		case 3:
			return 'Distribution des utilisateurs';
		default:
			return '이용자 분배 현황';
	}
};
var $author$project$Strings$Translations$view_announcement = function (lang) {
	switch (lang) {
		case 0:
			return 'View Announcement';
		case 1:
			return 'Ver anuncio';
		case 2:
			return '查看公告';
		case 3:
			return 'Voir l\'annonce';
		default:
			return 'COMP 공지사항 보기';
	}
};
var $author$project$LandingSite$Comp$view = F5(
	function (userLanguage, network, maybeConfig, maybeLatestTokens, model) {
		var maybeComp = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.iS;
			},
			maybeConfig);
		var latestTokens = function () {
			var _v5 = _Utils_Tuple2(maybeLatestTokens, model.ee);
			if ((!_v5.a.$) && (!_v5.b.$)) {
				var tokens = _v5.a.a;
				var compDistribution = _v5.b.a;
				var etherPrice = function () {
					var ethPerUsd = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.j3;
							},
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (token) {
										return token.j4 === 'USDC';
									},
									tokens.kG))));
					return A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, ethPerUsd);
				}();
				return ($elm$core$List$length(compDistribution.iN) > 0) ? A2(
					$elm$core$List$map,
					function (market) {
						var totalComp = market.hH;
						var supplierDailyComp = market.mW;
						var maybeToken = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (token) {
									return _Utils_eq(token.jY, market.hd);
								},
								tokens.kG));
						var etherPriceOrZero = A2($elm$core$Maybe$withDefault, $author$project$Decimal$zero, etherPrice);
						var distributionAPYs = function () {
							if (!maybeToken.$) {
								var token = maybeToken.a;
								return A3($author$project$Utils$CompHelper$calculateDistributionAPY, etherPriceOrZero, token, market);
							} else {
								return {hq: $author$project$Decimal$zero, jP: $author$project$Decimal$zero};
							}
						}();
						var supplierCompApy = distributionAPYs.jP;
						var borrowerDailyComp = market.kB;
						var borrowerCompApy = distributionAPYs.hq;
						return A7($author$project$LandingSite$Comp$marketRow, market.j4, market.j2, supplierCompApy, borrowerCompApy, supplierDailyComp, borrowerDailyComp, totalComp);
					},
					A2(
						$elm$core$List$sortBy,
						function (market) {
							return market.j2;
						},
						A2(
							$elm$core$List$filter,
							function (market) {
								return A2($author$project$Decimal$gt, market.kS, $author$project$Decimal$zero);
							},
							compDistribution.iN))) : A2(
					$elm$core$List$map,
					function (market) {
						return A2($author$project$LandingSite$Comp$noCompMarketRow, market.j4, market.j2);
					},
					A2(
						$elm$core$List$sortBy,
						function (market) {
							return market.j2;
						},
						A2(
							$elm$core$List$filter,
							function (market) {
								return market.j4 !== 'SAI';
							},
							tokens.kG)));
			} else {
				return A2($elm$core$List$repeat, 8, $author$project$LandingSite$Comp$loadingMarketRow);
			}
		}();
		var faqDisplayActive = function (index) {
			var faqState = A2($elm$core$Array$get, index, model.bd);
			var faqAccordianClass = function () {
				if ((!faqState.$) && faqState.a) {
					return ' active';
				} else {
					return '';
				}
			}();
			return faqAccordianClass;
		};
		var compAddressRow = function () {
			if (!maybeComp.$) {
				var comp = maybeComp.a;
				var address = $author$project$Eth$Ethereum$getContractAddressString(comp.hd);
				return _List_fromArray(
					[
						$elm$html$Html$text(address),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--copy mobile-hide'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
								$author$project$LandingSite$Comp$CopyMsg(address))
							]),
						_List_Nil),
						A4(
						$author$project$Eth$Ethereum$etherscanLink,
						$elm$core$Maybe$Just(network),
						$author$project$Eth$Ethereum$TokenAddress(address),
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link--gray'),
								$author$project$Utils$CompoundHtmlAttributes$target('_blank')
							]),
						_List_Nil)
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$network_does_not_have_comp(userLanguage))
					]);
			}
		}();
		var _v0 = function () {
			var _v1 = model.ee;
			if (!_v1.$) {
				var compDistribution = _v1.a;
				var initialComp = $author$project$Decimal$fromInt(4229949);
				var remainingComp = A2($author$project$Decimal$sub, initialComp, compDistribution.nr);
				var remainingCompPercentage = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Decimal$zero,
					A2($author$project$Decimal$fastdiv, remainingComp, initialComp));
				return {
					eV: A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, remainingComp),
					eW: $author$project$Utils$NumberFormatter$formatPercentage(remainingCompPercentage),
					e9: A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, compDistribution.hR),
					gU: A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, compDistribution.nr)
				};
			} else {
				return {eV: '—', eW: '0%', e9: '—', gU: '—'};
			}
		}();
		var dailyDistribution = _v0.e9;
		var totalDistributed = _v0.gU;
		var compRemaining = _v0.eV;
		var compRemainingPercentage = _v0.eW;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Comp')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('comp-header')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('comp-header__img'),
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('comp-header__details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-header__details__display-name')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$user_distribution(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-header__details__address')
																		]),
																	compAddressRow)
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-0 col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-5')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$daily_distribution(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(dailyDistribution)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$total_distributed(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(totalDistributed)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$remaining(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__details__group__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(compRemaining)
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__bar')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('comp-dist-view__bar__fill'),
																			A2($author$project$Utils$CompoundHtmlAttributes$style, 'width', compRemainingPercentage)
																		]),
																	_List_Nil)
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('comp-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('governance-panel comp-markets-panel')
										]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Strings$Translations$market_distribution(userLanguage))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$market(userLanguage))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right comp-column')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$per_day(userLanguage))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide comp-column')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$supply(userLanguage))
																	])),
																A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$apy(userLanguage))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2 text-right mobile-hide comp-column')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$borrow(userLanguage))
																	])),
																A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$src('/images/comp-icn.svg')
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$apy(userLanguage))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-2 text-right')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Strings$Translations$total_distributed(userLanguage))
																	]))
															]))
													]))
											]),
										latestTokens)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row faq-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('faq-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/@rleshner/ce13fcd4fe36')),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_announcement(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 faqs')
												]),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
												$elm$core$List$concat(
													A2(
														$elm$core$List$indexedMap,
														F2(
															function (index, _v2) {
																var header = _v2.a;
																var content = _v2.b;
																return _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$class('accordian__item')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class('accordian__item__header'),
																						$elm$html$Html$Events$onClick(
																						$author$project$LandingSite$Comp$ToggleAccordianAtIndex(index))
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$h3,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('accordian__item__text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(header)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class(
																								'accordian__plus' + faqDisplayActive(index))
																							]),
																						_List_fromArray(
																							[
																								A2($elm$html$Html$span, _List_Nil, _List_Nil),
																								A2($elm$html$Html$span, _List_Nil, _List_Nil)
																							]))
																					])),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class(
																						'accordian__item__description' + faqDisplayActive(index))
																					]),
																				content)
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$id('line')
																			]),
																		_List_Nil)
																	]);
															}),
														$author$project$LandingSite$Comp$accordianData(userLanguage)))))
										]))
								]))
						]))
				]));
	});
var $author$project$Preferences$EthValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Strings$Translations$add_interest = function (lang) {
	switch (lang) {
		case 0:
			return 'Add interest';
		case 1:
			return 'Agregar interés';
		case 2:
			return '增加利息';
		case 3:
			return 'Ajouter un intérêt';
		default:
			return '이자 제공하기';
	}
};
var $author$project$Strings$Translations$add_interest_action = function (lang) {
	switch (lang) {
		case 0:
			return 'View Markets';
		case 1:
			return 'Ver mercados';
		case 2:
			return '查看市场';
		case 3:
			return 'Voir les marchés';
		default:
			return '마켓 보기';
	}
};
var $author$project$Strings$Translations$add_interest_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Balances held by your application can automatically earn the prevailing market rate. You can build interest directly into your product. Earn by the block.';
		case 1:
			return 'Los saldos mantenidos por su aplicación pueden ganar automáticamente la tasa de mercado vigente. Puede generar interés directamente en su producto. Gana por el bloque.';
		case 2:
			return 'Application内的余额可自动以市场利率获得收益。 收益根植于产品构建之中。系统时刻（按区块）计算收益。';
		case 3:
			return 'Les soldes détenus par votre application peuvent automatiquement gagner le taux du marché en vigueur. Vous pouvez susciter l\'intérêt directement dans votre produit. Gagnez par le bloc.';
		default:
			return '애플리케이션에 잔액을 보유하고 있으면 마켓 이자율이 적용된 이자 수익을 자동으로 얻을 수 있습니다. 여러분의 제품에 직접 이자 서비스를 구축할 수 있습니다. 블록 당 발생하는 이자 수익을 체험해보세요.';
	}
};
var $author$project$Strings$Translations$add_interest_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Higher returns, for you or your users';
		case 1:
			return 'Mayores retornos, para usted o sus usuarios.';
		case 2:
			return '更高的回报';
		case 3:
			return 'Des rendements plus élevés, pour vous ou vos utilisateurs';
		default:
			return '여러분 또는 여러분의 사용자에게 더 높은 수익을';
	}
};
var $author$project$Strings$Translations$asset_movement = function (lang) {
	switch (lang) {
		case 0:
			return 'Asset movement';
		case 1:
			return 'Movimiento de activos';
		case 2:
			return '资产可运转';
		case 3:
			return 'Mouvement d\'actifs';
		default:
			return '자산 이동';
	}
};
var $author$project$Strings$Translations$asset_movement_action = function (lang) {
	switch (lang) {
		case 0:
			return 'Learn about cTokens';
		case 1:
			return 'Aprenda sobre cTokens';
		case 2:
			return '了解cTokens';
		case 3:
			return 'En savoir plus sur cTokens';
		default:
			return 'cTokens에 대해 알아보기';
	}
};
var $author$project$Strings$Translations$asset_movement_description = function (lang) {
	switch (lang) {
		case 0:
			return 'You can tokenize balances. Withdraw assets any time, or transfer balances to cold storage, other users, etc.';
		case 1:
			return 'Puedes tokenizar saldos. Retirar activos en cualquier momento, o transferir saldos al almacenamiento en frío, a otros usuarios, etc.';
		case 2:
			return '可将余额通证化，随时提取资产，或将余额转移到冷储存，转给其他用户等';
		case 3:
			return 'Vous pouvez symboliser les soldes. Retirer des actifs à tout moment ou transférer des soldes vers une chambre froide, d\'autres utilisateurs, etc.';
		default:
			return '잔액을 토큰화할 수 있습니다. 자산은 언제든지 출금할 수 있으며, 콜드 저장소 또는 다른 사용자에게 잔액을 전송할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$asset_movement_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Expand functionality, without compromising liquidity';
		case 1:
			return 'Amplíe la funcionalidad, sin comprometer la liquidez.';
		case 2:
			return '在不影响流动性的情况下扩展功能';
		case 3:
			return 'Développez les fonctionnalités sans compromettre la liquidité';
		default:
			return '기능을 확장했습니다. 유동성은 걱정마세요.';
	}
};
var $author$project$Strings$Translations$available_liquidity = function (lang) {
	switch (lang) {
		case 0:
			return 'Available Liquidity';
		case 1:
			return 'Liquidez disponible';
		case 2:
			return '可用流动资金';
		case 3:
			return 'Liquidité disponible';
		default:
			return '사용 가능한 유동성';
	}
};
var $author$project$Strings$Translations$borrow_use_case = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow use case';
		case 1:
			return 'Pedir prestado caso de uso';
		case 2:
			return '用例：抵押借贷';
		case 3:
			return 'Emprunter un cas d\'utilisation';
		default:
			return '대출 이용 사례';
	}
};
var $author$project$Strings$Translations$borrow_use_case_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Settle in any asset supported by the protocol';
		case 1:
			return 'Instalarse en cualquier activo soportado por el protocolo';
		case 2:
			return '通过Compound协议，以协议支持的任一计价资产结算';
		case 3:
			return 'Installez-vous dans n\'importe quel actif pris en charge par le protocole';
		default:
			return '프로토콜에서 지원하는 자산으로 정산 가능';
	}
};
var $author$project$Strings$Translations$developers_header = function (lang) {
	switch (lang) {
		case 0:
			return 'Supercharge your application with interest and liquidity';
		case 1:
			return 'Recargue su aplicación con intereses y liquidez';
		case 2:
			return '用利息和流动性，赋能你的Application';
		case 3:
			return 'Boostez votre demande d\'intérêts et de liquidités';
		default:
			return '여러분의 애플리케이션에 이자와 유동성을 제공해보세요.';
	}
};
var $author$project$Strings$Translations$discord = function (lang) {
	switch (lang) {
		case 0:
			return 'Discord';
		case 1:
			return 'Discord';
		case 2:
			return 'Discord';
		case 3:
			return 'Discorde';
		default:
			return 'Discord';
	}
};
var $author$project$LandingSite$DevelopersMarketing$emptyTokenData = {
	dK: $author$project$Decimal$zero,
	dL: $author$project$Decimal$zero,
	dM: $author$project$Decimal$zero,
	dN: $author$project$Decimal$zero,
	dO: $author$project$Decimal$zero,
	dP: $author$project$Decimal$zero,
	dV: $elm$core$Maybe$Nothing,
	dW: $author$project$Decimal$zero,
	cR: $elm$core$Maybe$Nothing,
	g1: $elm$core$Maybe$Just(
		$author$project$Decimal$fromInt(1))
};
var $author$project$Preferences$calculateEuroValue = function (usdValue) {
	var _v0 = $author$project$Decimal$fromFloat(1.08);
	if (!_v0.$) {
		var euroDivisor = _v0.a;
		return A2($author$project$Decimal$fastdiv, usdValue, euroDivisor);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Preferences$calculateGbpValue = function (usdValue) {
	var _v0 = $author$project$Decimal$fromFloat(1.3);
	if (!_v0.$) {
		var gbpDivisor = _v0.a;
		return A2($author$project$Decimal$fastdiv, usdValue, gbpDivisor);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$NumberFormatter$formatEthToZeroDecimals = function (decimalValue) {
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return signString + ('Ξ' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, absoluteDecimalValue));
};
var $author$project$Utils$NumberFormatter$formatEuroInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '€', decimalValue);
};
var $author$project$Utils$NumberFormatter$formatGbpInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '£', decimalValue);
};
var $author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '$', decimalValue);
};
var $author$project$Preferences$getUsdAndEthValuesToDisplay = F2(
	function (maybeEtherPrice, valueToDisplay) {
		var _v0 = _Utils_Tuple2(valueToDisplay, maybeEtherPrice);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var ethValue_ = _v0.a.a;
				var etherPrice = _v0.b.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						A2($author$project$Decimal$mul, etherPrice, ethValue_)),
					$elm$core$Maybe$Just(ethValue_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		} else {
			if (!_v0.b.$) {
				var usdValue_ = _v0.a.a;
				var etherPrice_ = _v0.b.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(usdValue_),
					A2($author$project$Decimal$fastdiv, usdValue_, etherPrice_));
			} else {
				var usdValue_ = _v0.a.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(usdValue_),
					$elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Preferences$formatMarketSize = F3(
	function (displayCurrency, maybeEtherPrice, valueToDisplay) {
		var _v0 = A2($author$project$Preferences$getUsdAndEthValuesToDisplay, maybeEtherPrice, valueToDisplay);
		var usdValue = _v0.a;
		var ethValue = _v0.b;
		switch (displayCurrency) {
			case 0:
				return A2($elm$core$Maybe$map, $author$project$Utils$NumberFormatter$formatEthToZeroDecimals, ethValue);
			case 1:
				return A2($elm$core$Maybe$map, $author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions, usdValue);
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbpInThousandsOrMillions,
					A2($elm$core$Maybe$andThen, $author$project$Preferences$calculateGbpValue, usdValue));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatEuroInThousandsOrMillions,
					A2($elm$core$Maybe$andThen, $author$project$Preferences$calculateEuroValue, usdValue));
		}
	});
var $author$project$Utils$NumberFormatter$formatRate = function (dec) {
	var rounded = A2($author$project$Decimal$round, -2, dec);
	return $author$project$Decimal$toString(rounded) + '%';
};
var $author$project$Preferences$getPlaceholderPrefCurrency = function (displayCurrency) {
	switch (displayCurrency) {
		case 0:
			return 'Ξ –';
		case 1:
			return '$ –';
		case 2:
			return '£ –';
		default:
			return '€ –';
	}
};
var $author$project$Strings$Translations$how_does_it_work = function (lang) {
	switch (lang) {
		case 0:
			return 'How does it work?';
		case 1:
			return 'Desbloquear liquidez';
		case 2:
			return '系统是如何工作的？';
		case 3:
			return 'Libérez la liquidité';
		default:
			return '동작 방식';
	}
};
var $author$project$Strings$Translations$how_does_it_work_action = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow Function';
		case 1:
			return 'Ver mercados';
		case 2:
			return '查看市场';
		case 3:
			return 'Voir les marchés';
		default:
			return '대출 함수';
	}
};
var $author$project$Strings$Translations$how_does_it_work_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrowing assets from the Compound Protocol has no time-duration; balances can be repayed at anytime, while interest is accumulating per block on the Ethereum network.';
		case 1:
			return 'Sin comisiones comerciales, sin deslizamientos, sin problemas. Aprovechar el Protocolo Compuesto significa que tiene acceso a un grupo de liquidez global por activo.';
		case 2:
			return '向Compound协议借款无需定义时限，借款随时可还。借款利息在以太坊上以区块为准，时刻记录。';
		case 3:
			return 'Pas de frais de transaction, pas de glissement, pas de problème. L\'utilisation du protocole composé signifie que vous avez accès à un pool de liquidité mondial par actif.';
		default:
			return 'Compound 프로토콜에서 제공하는 자산 대출은 대출 기간이 정해져있지 않습니다. 대출 이자는 이더리움 네트워크 블록 당 누적되며 잔액은 언제든지 상환할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$how_does_it_work_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Use supplied balances as collateral to borrow against';
		case 1:
			return 'Utilice los saldos suministrados como garantía para contraer préstamos';
		case 2:
			return '存入资产作为抵押，';
		case 3:
			return 'Utilisez les soldes fournis en garantie pour emprunter contre';
		default:
			return '공급한 잔액을 대출에 대한 담보로 사용';
	}
};
var $author$project$Strings$Translations$interest_use_case = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest use case';
		case 1:
			return 'Caso de uso de interés';
		case 2:
			return '用例：资产生息';
		case 3:
			return 'Cas d\'utilisation d\'intérêt';
		default:
			return '이자 이용 사례';
	}
};
var $author$project$Strings$Translations$interest_use_case_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Earn interest while assets are in cold storage';
		case 1:
			return 'Gane intereses mientras los activos están en almacenamiento en frío';
		case 2:
			return '资产在冷储存状态亦可获得利息收益';
		case 3:
			return 'Gagnez des intérêts pendant que les actifs sont en chambre froide';
		default:
			return '콜드 저장소 안에 자산이 보관되어 있는 동안 이자 수익이 발생합니다.';
	}
};
var $author$project$Strings$Translations$problem = function (lang) {
	switch (lang) {
		case 0:
			return 'Problem';
		case 1:
			return 'Problema';
		case 2:
			return '问题';
		case 3:
			return 'Problème';
		default:
			return '문제점';
	}
};
var $author$project$Strings$Translations$problem_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'While safe, when your assets are in cold storage they are dormant and not being utilized to maximum efficiency.';
		case 1:
			return 'Si bien son seguros, cuando sus activos están en almacenamiento en frío, están inactivos y no se utilizan con la máxima eficiencia.';
		case 2:
			return '资产置于冷储存中时，虽安全，资产却处于休眠状态，无法最大程度地发挥作用。';
		case 3:
			return 'Bien que sûrs, lorsque vos actifs sont en chambre froide, ils sont dormants et ne sont pas utilisés à une efficacité maximale.';
		default:
			return '안전하지만 자산이 콜드 저장소에 보관되어 있으면 이 자산은 휴면 상태에 빠지기 때문에 효율을 극대화할 수 없습니다.';
	}
};
var $author$project$Strings$Translations$problem_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'OTC trading desks serve their clients and counterparties by enabling them to frictionlessly trade in size; this requires OTC desks to constantly re-balance their inventory across a range of volatile assets, in order to respond to incoming trade requests.';
		case 1:
			return 'Las mesas de operaciones OTC sirven a sus clientes y contrapartes al permitirles comerciar sin fricción en tamaño; Esto requiere que los mostradores OTC reequilibren constantemente su inventario en una gama de activos volátiles, a fin de responder lo más posible a las solicitudes comerciales entrantes.';
		case 2:
			return 'OTC服务商为买卖双方客户提供服务，匹配交易规模和时间等需求，保证交易顺利达成；OTC服务商要不断调整波动资产的头寸，以配合交易需求。';
		case 3:
			return 'Les bureaux de négociation de gré à gré servent leurs clients et leurs contreparties en leur permettant de négocier sans problème de taille; cela nécessite que les bureaux de gré à gré rééquilibrent constamment leur inventaire sur une gamme d\'actifs volatils, afin d\'être aussi réactifs que possible aux demandes commerciales entrantes.';
		default:
			return 'OTC 거래 데스크는 고객과 거래 상대방이 아무런 문제없이 거래를 진행할 수 있게 도와줍니다. OTC 데스크는 거래 요청에 대응하기 위해 자산 변동성에 따라 자신들의 재고를 계속해서 조정해야 합니다.';
	}
};
var $author$project$LandingSite$DevelopersMarketing$projectCard = F2(
	function (imageUrl, projectName) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('developers__project-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__project-card__image'),
							$author$project$Utils$CompoundHtmlAttributes$src(imageUrl)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__project-card__project')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(projectName)
						]))
				]));
	});
var $author$project$LandingSite$DevelopersMarketing$projects = _List_fromArray(
	[
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/multis.svg', 'Multis'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/argent.svg', 'Argent'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/dharma.svg', 'Dharma'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/pool-together.svg', 'Pool Together'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/coinbase-wallet.svg', 'Coinbase Wallet'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/instadapp.svg', 'InstaDapp'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/linen.svg', 'Linen'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/zengo.svg', 'ZenGo'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/imToken.svg', 'imToken'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/exodus.svg', 'Exodus'),
		A2($author$project$LandingSite$DevelopersMarketing$projectCard, '/images/set.svg', 'TokenSets')
	]);
var $author$project$Strings$Translations$solution = function (lang) {
	switch (lang) {
		case 0:
			return 'Solution';
		case 1:
			return 'Solución';
		case 2:
			return '解决方案';
		case 3:
			return 'Solution';
		default:
			return '해결 방법';
	}
};
var $author$project$Strings$Translations$solution_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'By holding cTokens in custody, your customers gain the benefit of earning interest on the underlying assets, while still keeping their assets safely offline.';
		case 1:
			return 'Al mantener a cTokens bajo custodia, sus clientes obtienen el beneficio de ganar intereses sobre los activos subyacentes, mientras mantienen sus activos sin conexión.';
		case 2:
			return '将cTokens置于托管中，用户即可基于其资产获得利息，资产本身也处于安全的冷储存状态。';
		case 3:
			return 'En gardant cTokens en garde à vue, vos clients ont l\'avantage de gagner des intérêts sur les actifs sous-jacents, tout en conservant leurs actifs en toute sécurité hors ligne.';
		default:
			return 'cTokens 형태로 보유하고 있으면, 오프라인에서 안전하게 자산이 유지되는 동안 기초 자산에서 발생하는 이자 수익 혜택을 누릴 수 있습니다.';
	}
};
var $author$project$Strings$Translations$solution_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'By holding stablecoins in Compound, OTC traders have instant borrowing access to any asset that the Compound protocol supports, with minimal exposure to price volatility. They can settle trades in any of these assets immediately, and repay borrowed assets at anytime.';
		case 1:
			return 'Al mantener las monedas estables en Compuesto, los operadores OTC tienen acceso de préstamo instantáneo a cualquier activo que admita el protocolo Compuesto, con una exposición mínima a la volatilidad de los precios. Pueden liquidar transacciones en cualquiera de estos activos de inmediato y reembolsar los activos prestados en cualquier momento.';
		case 2:
			return '通过在Compound中持有稳定币，OTC服务商可立即借入协议支持的任何资产，让价格波动的风险维持在最小范围；所借资产可以随时交易，亦可随时归还。';
		case 3:
			return 'En détenant des pièces stables dans Compound, les traders OTC ont un accès d\'emprunt instantané à tout actif pris en charge par le protocole Compound, avec une exposition minimale à la volatilité des prix. Ils peuvent régler les transactions sur l\'un de ces actifs immédiatement et rembourser les actifs empruntés à tout moment.';
		default:
			return 'OTC 트레이더는 Compound에 스테이블 코인을 보유함으로써 Compound 프로토콜이 지원하는 자산에 대한 대출을 가격 변동성을 최소화한 상태에서 즉시 제공할 수 있습니다. 그들은 이들 자산에 대한 거래를 바로 정산할 수 있으며 언제든지 대출한 자산을 상환할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$start_building = function (lang) {
	switch (lang) {
		case 0:
			return 'Start building';
		case 1:
			return 'Comienza a construir';
		case 2:
			return '开始吧';
		case 3:
			return 'Commencez à construire';
		default:
			return 'Compound 통합';
	}
};
var $author$project$Strings$Translations$start_building_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Help create the future of finance on Compound';
		case 1:
			return 'Ayuda a crear el futuro de las finanzas en Compuesto';
		case 2:
			return '一起构建Compound Finance的未来';
		case 3:
			return 'Aidez à créer l\'avenir de la finance sur Compound';
		default:
			return 'Compound와 함께 금융의 미래를 만들어보세요.';
	}
};
var $author$project$Strings$Translations$start_building_today = function (lang) {
	switch (lang) {
		case 0:
			return 'Start building today';
		case 1:
			return 'Comienza a construir hoy';
		case 2:
			return '即刻加入';
		case 3:
			return 'Commencez à construire aujourd\'hui';
		default:
			return '지금 바로 Compound 통합을 시작해보세요';
	}
};
var $author$project$LandingSite$DevelopersMarketing$tokenCard = F7(
	function (imageUrl, tokenName, tokenSymbol, cardValue, cardLabel, backgroundColor, valueColor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card developers__token-card--' + backgroundColor)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__token')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__token__image'),
									$author$project$Utils$CompoundHtmlAttributes$src(imageUrl)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__token__text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__token__text__name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(tokenName)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__token__text__symbol')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(tokenSymbol)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__data__value developers__token-card__data__value--' + valueColor)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(cardValue)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('developers__token-card__data__label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(cardLabel)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$unlock_liquidity = function (lang) {
	switch (lang) {
		case 0:
			return 'Unlock liquidity';
		case 1:
			return 'Desbloquear liquidez';
		case 2:
			return '释放流动性';
		case 3:
			return 'Libérez la liquidité';
		default:
			return '풍부한 유동성';
	}
};
var $author$project$Strings$Translations$unlock_liquidity_action = function (lang) {
	switch (lang) {
		case 0:
			return 'View markets';
		case 1:
			return 'Ver mercados';
		case 2:
			return '查看市场';
		case 3:
			return 'Voir les marchés';
		default:
			return '마켓 보기';
	}
};
var $author$project$Strings$Translations$unlock_liquidity_description = function (lang) {
	switch (lang) {
		case 0:
			return 'No trading fees, no slippage, no problem. Tapping into the Compound Protocol means you have access to a global liquidity pool per asset.';
		case 1:
			return 'Sin comisiones comerciales, sin deslizamientos, sin problemas. Aprovechar el Protocolo Compuesto significa que tiene acceso a un grupo de liquidez global por activo.';
		case 2:
			return '没有交易费，没有滑点，没有难题。使用Compound协议，全球流动资金池随时可用';
		case 3:
			return 'Pas de frais de transaction, pas de glissement, pas de problème. L\'utilisation du protocole composé signifie que vous avez accès à un pool de liquidité mondial par actif.';
		default:
			return '거래 수수료 무료. 슬리피지 없음. Compound 프로토콜을 이용한다는 것은 자산에 대한 글로벌 유동성 풀에 접근할 수 있다는 것을 의미합니다.';
	}
};
var $author$project$Strings$Translations$unlock_liquidity_subheader = function (lang) {
	switch (lang) {
		case 0:
			return 'Access on-demand liquidity in any Compound market';
		case 1:
			return 'Acceda a la liquidez bajo demanda en cualquier mercado compuesto';
		case 2:
			return '在Compound市场中按需释放流动性';
		case 3:
			return 'Accédez à la liquidité à la demande sur n\'importe quel marché composé';
		default:
			return '모든 Compound 마켓에서 언제든지 거래할 수 있는 유동성 제공';
	}
};
var $author$project$Strings$Translations$view_docs = function (lang) {
	switch (lang) {
		case 0:
			return 'View docs';
		case 1:
			return 'Ver documentos';
		case 2:
			return '查看文档';
		case 3:
			return 'Afficher les documents';
		default:
			return '문서보기';
	}
};
var $author$project$LandingSite$DevelopersMarketing$view = F3(
	function (userLanguage, maybeCTokenResponse, _v0) {
		var tokenData = function () {
			if (!maybeCTokenResponse.$) {
				var cToken = maybeCTokenResponse.a.kG;
				return function (tokenData_) {
					var _v5 = tokenData_.cR;
					if (!_v5.$) {
						var price = _v5.a;
						return _Utils_update(
							tokenData_,
							{
								dV: $elm$core$Maybe$Just(
									A2($author$project$Decimal$mul, tokenData_.dW, price))
							});
					} else {
						return tokenData_;
					}
				}(
					A3(
						$elm$core$List$foldl,
						F2(
							function (_v3, accum) {
								var cash = _v3.kH;
								var supply_rate = _v3.mZ;
								var underlying_symbol = _v3.j4;
								var underlying_price = _v3.j3;
								switch (underlying_symbol) {
									case 'ETH':
										return _Utils_update(
											accum,
											{dM: cash, dN: supply_rate});
									case 'DAI':
										return _Utils_update(
											accum,
											{dK: cash, dL: supply_rate, dW: underlying_price});
									case 'USDC':
										return _Utils_update(
											accum,
											{
												dO: cash,
												dP: supply_rate,
												cR: A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, underlying_price)
											});
									default:
										return accum;
								}
							}),
						$author$project$LandingSite$DevelopersMarketing$emptyTokenData,
						cToken));
			} else {
				return $author$project$LandingSite$DevelopersMarketing$emptyTokenData;
			}
		}();
		var marketTotalDollarFormatter = F2(
			function (price, tokenValue) {
				var _v1 = A3($author$project$Preferences$formatMarketSize, 1, price, tokenValue);
				if (!_v1.$) {
					var string = _v1.a;
					return string;
				} else {
					return $author$project$Preferences$getPlaceholderPrefCurrency(1);
				}
			});
		var apyFormatter = function (rate) {
			return $author$project$Utils$NumberFormatter$formatRate(
				A2(
					$author$project$Decimal$mul,
					$author$project$Decimal$fromInt(100),
					rate));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('developers')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__pattern')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__ctoken')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 developers__part-one__header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__header__text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$developers_header(userLanguage))
														])),
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__header__buttons')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$class('button hollow developers__part-one__header__buttons__button developers__part-one__header__buttons__button--docs'),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$docs(userLanguage))
																])),
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$class('button hollow developers__part-one__header__buttons__button developers__part-one__header__buttons__button--discord'),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.finance/discord')),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$discord(userLanguage))
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-one__section-two')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-two__cards')
														]),
													_List_fromArray(
														[
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_USDC.svg',
															'USD Coin',
															'USDC',
															apyFormatter(tokenData.dP),
															$author$project$Strings$Translations$apy(userLanguage),
															'dark',
															'blue'),
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_DAI.svg',
															'Dai',
															'DAI',
															apyFormatter(tokenData.dL),
															$author$project$Strings$Translations$apy(userLanguage),
															'dark',
															'yellow'),
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_ETH.svg',
															'Ether',
															'ETH',
															apyFormatter(tokenData.dN),
															$author$project$Strings$Translations$apy(userLanguage),
															'dark',
															'light-blue')
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-two__details')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('big developers__header')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$add_interest(userLanguage))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$add_interest_subheader(userLanguage))
																])),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__description')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$add_interest_description(userLanguage))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	A2(
																		$elm$core$List$cons,
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																		A2(
																			$author$project$Utils$CompoundHtmlAttributes$href,
																			0,
																			$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$add_interest_action(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																		]),
																	_List_Nil)
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-one__section-three')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-three__details')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('big developers__header')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$asset_movement(userLanguage))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$asset_movement_subheader(userLanguage))
																])),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__description')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$asset_movement_description(userLanguage))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	A2(
																		$elm$core$List$cons,
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																		A2(
																			$author$project$Utils$CompoundHtmlAttributes$href,
																			0,
																			$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$CTokens))),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$asset_movement_action(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																		]),
																	_List_Nil)
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 developers__part-one__section-three__illo-view')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-three__illo-view__illo'),
															$author$project$Utils$CompoundHtmlAttributes$src('/images/interest-illo.svg')
														]),
													_List_Nil)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-four')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-four__details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('big developers__header')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$interest_use_case(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$h2,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$interest_use_case_subheader(userLanguage))
																		]))
																]))
														]))
												])),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('developers__part-one__section-four__diagram'),
													$author$project$Utils$CompoundHtmlAttributes$src('/images/use-case-interest.png')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-one__section-four__problem-solution')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$img,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__icon'),
																					$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-problem.svg')
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__text')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$problem(userLanguage))
																				]))
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__description')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$problem_1(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$img,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__icon'),
																					$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-solution.svg')
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__text')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$solution(userLanguage))
																				]))
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__description')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$solution_1(userLanguage))
																		]))
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-two__section-one')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-one__details')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('big developers__header developers__header--light')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$unlock_liquidity(userLanguage))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader developers__subheader--dark')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$unlock_liquidity_subheader(userLanguage))
																])),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__description developers__description--light')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$unlock_liquidity_description(userLanguage))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	A2(
																		$elm$core$List$cons,
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																		A2(
																			$author$project$Utils$CompoundHtmlAttributes$href,
																			0,
																			$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$unlock_liquidity_action(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																		]),
																	_List_Nil)
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 developers__part-two__section-one__cards-view')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-one__cards-view__cards')
														]),
													_List_fromArray(
														[
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_ETH.svg',
															'Ether',
															'ETH',
															A2(
																marketTotalDollarFormatter,
																tokenData.cR,
																$author$project$Preferences$EthValue(tokenData.dM)),
															$author$project$Strings$Translations$available_liquidity(userLanguage),
															'light',
															'light-blue'),
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_USDC.svg',
															'USD Coin',
															'USDC',
															A2(
																marketTotalDollarFormatter,
																tokenData.g1,
																$author$project$Preferences$EthValue(tokenData.dO)),
															$author$project$Strings$Translations$available_liquidity(userLanguage),
															'light',
															'blue'),
															A7(
															$author$project$LandingSite$DevelopersMarketing$tokenCard,
															'/images/asset_DAI.svg',
															'Dai',
															'DAI',
															A2(
																marketTotalDollarFormatter,
																tokenData.dV,
																$author$project$Preferences$EthValue(tokenData.dK)),
															$author$project$Strings$Translations$available_liquidity(userLanguage),
															'light',
															'yellow')
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-two__section-two')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-two__illo'),
															$author$project$Utils$CompoundHtmlAttributes$src('/images/balance-illo.svg')
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-two__details')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('big developers__header developers__header--light')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$how_does_it_work(userLanguage))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader developers__subheader--dark')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$how_does_it_work_subheader(userLanguage))
																])),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__description developers__description--light')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$how_does_it_work_description(userLanguage))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$a,
																	A2(
																		$elm$core$List$cons,
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																		A2(
																			$author$project$Utils$CompoundHtmlAttributes$href,
																			0,
																			$author$project$LandingSite$Page$getHrefUrl(
																				A2(
																					$author$project$LandingSite$Page$Docs,
																					1,
																					$elm$core$Maybe$Just('borrow'))))),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$how_does_it_work_action(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																		]),
																	_List_Nil)
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-three')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-three__details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('big developers__header developers__header--light')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$borrow_use_case(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$h2,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader developers__subheader--dark')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$borrow_use_case_subheader(userLanguage))
																		]))
																]))
														]))
												])),
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('developers__part-two__section-three__diagram'),
													$author$project$Utils$CompoundHtmlAttributes$src('/images/use-case-borrow.png')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row developers__part-one__section-four__problem-solution')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$img,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__icon'),
																					$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-problem.svg')
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__text developers__statement-view__title-row__text--dark')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$problem(userLanguage))
																				]))
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__description developers__description--light')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$problem_2(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$img,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__icon'),
																					$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-solution.svg')
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('developers__statement-view__title-row__text developers__statement-view__title-row__text--dark')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$solution(userLanguage))
																				]))
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__description developers__description--light')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$solution_2(userLanguage))
																		]))
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-one')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-one__details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('big developers__header developers__header--light')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$start_building(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$h2,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('developers__subheader developers__subheader--dark')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$start_building_subheader(userLanguage))
																		]))
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-two')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-two__projects')
												]),
											$author$project$LandingSite$DevelopersMarketing$projects),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-two__main-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-two__main-card__content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h3,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$start_building_today(userLanguage))
																])),
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$class('button'),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_docs(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('developers__part-three__section-two__projects')
												]),
											$author$project$LandingSite$DevelopersMarketing$projects)
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Docs$ToggleMobileNavMsg = function (a) {
	return {$: 4, a: a};
};
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$comment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Comment),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {hC: s.hC + (newOffset - s.i8), d: s.d, j: s.j, i8: newOffset, mB: s.mB, mJ: s.mJ};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.i8, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.mJ);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.mB, s.hC - (floatOffset + s.i8), invalid, s.d));
		} else {
			if (_Utils_eq(s.i8, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.i8, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.i8, floatOffset, s.mJ));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.i8, s.mJ)) {
			var zeroOffset = s.i8 + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.mJ) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lF,
				c.lr,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.mJ),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.mJ) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lF,
				c.l6,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.mJ),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.mJ) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.lF,
				c.ks,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.mJ),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.lF,
				c.ia,
				c.lC,
				c.ll,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.lF,
				c.ia,
				c.lC,
				c.ll,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.i8, s.mJ),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				ks: $elm$core$Result$Err(invalid),
				ia: expecting,
				ll: $elm$core$Result$Err(invalid),
				lr: $elm$core$Result$Err(invalid),
				lC: $elm$core$Result$Ok($elm$core$Basics$identity),
				lF: invalid,
				l6: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $author$project$SyntaxHighlight$HCode = $elm$core$Basics$identity;
var $author$project$SyntaxHighlight$Style$Style1 = 2;
var $author$project$SyntaxHighlight$Style$Style2 = 3;
var $author$project$SyntaxHighlight$Style$Style3 = 4;
var $author$project$SyntaxHighlight$Style$Style4 = 5;
var $author$project$SyntaxHighlight$Style$Style5 = 6;
var $author$project$SyntaxHighlight$Style$Style6 = 7;
var $author$project$SyntaxHighlight$Style$Style7 = 8;
var $author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(6, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var $author$project$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {ln: fragments, lt: $elm$core$Maybe$Nothing};
};
var $author$project$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var $author$project$SyntaxHighlight$Style$Comment = 1;
var $author$project$SyntaxHighlight$Style$Default = 0;
var $author$project$SyntaxHighlight$Line$Helpers$toFragment = F2(
	function (toStyle, _v0) {
		var syntax = _v0.a;
		var text = _v0.b;
		switch (syntax.$) {
			case 0:
				return {kl: '', mv: 0, m8: text};
			case 1:
				return {kl: '', mv: 1, m8: text};
			case 2:
				return {kl: '', mv: 0, m8: text};
			default:
				var c = syntax.a;
				var _v2 = toStyle(c);
				var requiredStyle = _v2.a;
				var additionalClass = _v2.b;
				return {kl: additionalClass, mv: requiredStyle, m8: text};
		}
	});
var $author$project$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(
	function (toStyle, _v0, _v1) {
		var syntax = _v0.a;
		var text = _v0.b;
		var lines = _v1.a;
		var fragments = _v1.b;
		var maybeLastSyntax = _v1.c;
		if (_Utils_eq(syntax, $author$project$SyntaxHighlight$Language$Type$LineBreak)) {
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					$author$project$SyntaxHighlight$Line$Helpers$newLine(fragments),
					lines),
				_List_fromArray(
					[
						A2(
						$author$project$SyntaxHighlight$Line$Helpers$toFragment,
						toStyle,
						_Utils_Tuple2(syntax, text))
					]),
				$elm$core$Maybe$Nothing);
		} else {
			if (_Utils_eq(
				$elm$core$Maybe$Just(syntax),
				maybeLastSyntax)) {
				if (fragments.b) {
					var headFrag = fragments.a;
					var tailFrags = fragments.b;
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							_Utils_update(
								headFrag,
								{
									m8: _Utils_ap(text, headFrag.m8)
								}),
							tailFrags),
						maybeLastSyntax);
				} else {
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$SyntaxHighlight$Line$Helpers$toFragment,
								toStyle,
								_Utils_Tuple2(syntax, text)),
							fragments),
						maybeLastSyntax);
				}
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$SyntaxHighlight$Line$Helpers$toFragment,
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					$elm$core$Maybe$Just(syntax));
			}
		}
	});
var $author$project$SyntaxHighlight$Line$Helpers$toLines = F2(
	function (toStyle, revTokens) {
		return function (_v0) {
			var lines = _v0.a;
			var frags = _v0.b;
			return A2(
				$elm$core$List$cons,
				$author$project$SyntaxHighlight$Line$Helpers$newLine(frags),
				lines);
		}(
			A3(
				$elm$core$List$foldl,
				$author$project$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
				_Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing),
				revTokens));
	});
var $author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf(isNotRelevant)),
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $author$project$SyntaxHighlight$Language$Type$Normal = {$: 0};
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$SyntaxHighlight$Language$Javascript$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';', '.']));
var $author$project$SyntaxHighlight$Language$Javascript$isGroupChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$groupSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isGroupChar)));
var $author$project$SyntaxHighlight$Language$Javascript$isCommentChar = function (c) {
	return c === '/';
};
var $author$project$SyntaxHighlight$Language$Javascript$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%']));
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$SyntaxHighlight$Language$Javascript$punctuactorSet = A2($elm$core$Set$union, $author$project$SyntaxHighlight$Language$Javascript$operatorSet, $author$project$SyntaxHighlight$Language$Javascript$groupSet);
var $author$project$SyntaxHighlight$Language$Javascript$isPunctuaction = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$punctuactorSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar = function (c) {
	return (c === '\"') || ((c === '\'') || (c === '`'));
};
var $author$project$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var $author$project$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var $author$project$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return $author$project$SyntaxHighlight$Language$Helpers$isSpace(c) || $author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var $author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar = function (c) {
	return !($author$project$SyntaxHighlight$Language$Javascript$isPunctuaction(c) || ($author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar(c) || ($author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || $author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $author$project$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var $author$project$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var $author$project$SyntaxHighlight$Language$Javascript$Function = 5;
var $author$project$SyntaxHighlight$Language$Javascript$Keyword = 2;
var $author$project$SyntaxHighlight$Language$Javascript$LiteralKeyword = 6;
var $author$project$SyntaxHighlight$Language$Javascript$Param = 7;
var $author$project$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var $author$project$SyntaxHighlight$Language$Type$Comment = {$: 1};
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(
	function (isNotRelevant, previousParser) {
		return A2(
			$elm$parser$Parser$ignorer,
			previousParser,
			$elm$parser$Parser$chompWhile(isNotRelevant));
	});
var $author$project$SyntaxHighlight$Language$Javascript$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $author$project$SyntaxHighlight$Language$Helpers$addThen = F3(
	function (f, list, plist) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					_Utils_ap(n, list));
			},
			plist);
	});
var $author$project$SyntaxHighlight$Language$Helpers$consThen = F3(
	function (f, list, pn) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					A2($elm$core$List$cons, n, list));
			},
			pn);
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(
	function (options, revAList) {
		var defaultMap = options.hV;
		var isNotRelevant = options.iA;
		var end = options.h3;
		var innerParsers = options.iw;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							defaultMap(end),
							revAList)),
					$elm$parser$Parser$symbol(end)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$addThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(
	function (nestLevel, options, revAList) {
		var defaultMap = options.hV;
		var isNotRelevant = options.iA;
		var start = options.jJ;
		var end = options.h3;
		var innerParsers = options.iw;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : A3($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								defaultMap(end),
								revAList)),
						$elm$parser$Parser$symbol(end))),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$symbol(start))))),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$addThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(
	function (options, revAList) {
		var start = options.jJ;
		var end = options.h3;
		var isNotRelevant = options.iA;
		var _v0 = _Utils_Tuple2(
			$elm$core$String$uncons(options.jJ),
			$elm$core$String$uncons(options.h3));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
		} else {
			if (_v0.b.$ === 1) {
				var _v2 = _v0.b;
				return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
			} else {
				var _v3 = _v0.a.a;
				var startChar = _v3.a;
				var _v4 = _v0.b.a;
				var endChar = _v4.a;
				return options.iz ? A3(
					$author$project$SyntaxHighlight$Language$Helpers$delimitedNestable,
					1,
					_Utils_update(
						options,
						{
							iA: function (c) {
								return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
							}
						}),
					revAList) : A2(
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable,
					_Utils_update(
						options,
						{
							iA: function (c) {
								return isNotRelevant(c) && (!_Utils_eq(c, endChar));
							}
						}),
					revAList);
			}
		}
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var start = options.jJ;
	var isNotRelevant = options.iA;
	var defaultMap = options.hV;
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return A2(
				$author$project$SyntaxHighlight$Language$Helpers$delimitedHelp,
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				defaultMap(start)),
			$elm$parser$Parser$symbol(start)));
};
var $author$project$SyntaxHighlight$Language$Javascript$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $author$project$SyntaxHighlight$Language$Javascript$multilineComment = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	{
		hV: function (b) {
			return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b);
		},
		h3: '*/',
		iw: _List_fromArray(
			[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList]),
		iz: false,
		iA: function (c) {
			return !$author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		jJ: '/*'
	});
var $author$project$SyntaxHighlight$Language$Javascript$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$inlineComment, $author$project$SyntaxHighlight$Language$Javascript$multilineComment]));
var $author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$comment)
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						$elm$parser$Parser$map,
						$elm$parser$Parser$Loop,
						A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							$author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop)) : $elm$parser$Parser$succeed(
						$elm$parser$Parser$Loop(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || ($author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v1) {
						return A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$author$project$SyntaxHighlight$Language$Javascript$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$FunctionEval = 4;
var $author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop = F3(
	function (identifier, revTokens, thisRevToken) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(thisRevToken),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_ap(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
									thisRevToken),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$author$project$SyntaxHighlight$Language$Type$C(4),
										identifier),
									revTokens)));
					},
					$elm$parser$Parser$symbol('(')),
					$elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						_Utils_ap(
							thisRevToken,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, identifier),
								revTokens))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let']));
var $author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['await', 'break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected']));
var $author$project$SyntaxHighlight$Language$Javascript$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$keywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var $author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$keywordParser = F2(
	function (revTokens, n) {
		return ((n === 'function') || (n === 'static')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ((n === 'class') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(7),
					n),
				revTokens)) : ((n === 'constructor') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ($author$project$SyntaxHighlight$Language$Javascript$isKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(2),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(6),
					n),
				revTokens)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A2($author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop, n, revTokens))))))));
	});
var $author$project$SyntaxHighlight$Language$Javascript$Number = 0;
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.i8, s.mB, s.hC, s.mJ);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.mJ))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{hC: newCol, d: s.d, j: s.j, i8: newOffset, mB: newRow, mJ: s.mJ});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $elm$parser$Parser$ExpectingBinary = {$: 4};
var $elm$parser$Parser$ExpectingFloat = {$: 5};
var $elm$parser$Parser$ExpectingHex = {$: 2};
var $elm$parser$Parser$ExpectingNumber = {$: 6};
var $elm$parser$Parser$ExpectingOctal = {$: 3};
var $elm$parser$Parser$number = function (i) {
	return $elm$parser$Parser$Advanced$number(
		{
			ks: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingBinary, i.ks),
			ia: $elm$parser$Parser$ExpectingNumber,
			ll: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingFloat, i.ll),
			lr: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingHex, i.lr),
			lC: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingInt, i.lC),
			lF: $elm$parser$Parser$ExpectingNumber,
			l6: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingOctal, i.l6)
		});
};
var $author$project$SyntaxHighlight$Language$Helpers$num = $elm$parser$Parser$number(
	{
		ks: $elm$core$Maybe$Just(
			function (_v0) {
				return 0;
			}),
		ll: $elm$core$Maybe$Just(
			function (_v1) {
				return 0;
			}),
		lr: $elm$core$Maybe$Just(
			function (_v2) {
				return 0;
			}),
		lC: $elm$core$Maybe$Just(
			function (_v3) {
				return 0;
			}),
		l6: $elm$core$Maybe$Just(
			function (_v4) {
				return 0;
			})
	});
var $author$project$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$symbol('-')),
	$author$project$SyntaxHighlight$Language$Helpers$num);
var $author$project$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return 0;
	},
	$author$project$SyntaxHighlight$Language$Helpers$num);
var $author$project$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (_v0) {
				return 0;
			},
			$elm$parser$Parser$keyword('0x...')),
			A2(
			$elm$parser$Parser$map,
			function (_v1) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xMyAccount')),
			A2(
			$elm$parser$Parser$map,
			function (_v2) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xLiquidator')),
			A2(
			$elm$parser$Parser$map,
			function (_v3) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xBorrower')),
			A2(
			$elm$parser$Parser$map,
			function (_v4) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xPayer')),
			A2(
			$elm$parser$Parser$map,
			function (_v5) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xToken')),
			$author$project$SyntaxHighlight$Language$Helpers$negativeNumber,
			$elm$parser$Parser$backtrackable($author$project$SyntaxHighlight$Language$Helpers$positiveNumber)
		]));
var $author$project$SyntaxHighlight$Language$Javascript$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$number));
var $author$project$SyntaxHighlight$Language$Javascript$isOperatorChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$operatorSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isOperatorChar)));
var $author$project$SyntaxHighlight$Language$Javascript$String = 1;
var $author$project$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var $author$project$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['\'', '\"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var $author$project$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Helpers$escapableSet);
};
var $author$project$SyntaxHighlight$Language$Helpers$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\\'))),
	$elm$parser$Parser$chompIf($author$project$SyntaxHighlight$Language$Helpers$isEscapableChar));
var $author$project$SyntaxHighlight$Language$Javascript$jsEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$escapable));
var $author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter = {
	hV: function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	h3: '\'',
	iw: _List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList, $author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
	iz: false,
	iA: function (c) {
		return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	jJ: '\''
};
var $author$project$SyntaxHighlight$Language$Javascript$doubleQuote = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{h3: '\"', jJ: '\"'}));
var $author$project$SyntaxHighlight$Language$Javascript$quote = $author$project$SyntaxHighlight$Language$Helpers$delimited($author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter);
var $author$project$SyntaxHighlight$Language$Javascript$templateString = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{
			h3: '`',
			iw: _List_fromArray(
				[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList, $author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
			iA: function (c) {
				return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			jJ: '`'
		}));
var $author$project$SyntaxHighlight$Language$Javascript$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$quote, $author$project$SyntaxHighlight$Language$Javascript$doubleQuote, $author$project$SyntaxHighlight$Language$Javascript$templateString]));
var $author$project$SyntaxHighlight$Language$Javascript$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$author$project$SyntaxHighlight$Language$Javascript$operatorChar, $author$project$SyntaxHighlight$Language$Javascript$groupChar, $author$project$SyntaxHighlight$Language$Javascript$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$author$project$SyntaxHighlight$Language$Javascript$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $author$project$SyntaxHighlight$Language$Javascript$mainLoop);
var $author$project$SyntaxHighlight$Language$Javascript$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($author$project$SyntaxHighlight$Language$Javascript$toRevTokens),
	$elm$core$Result$map(
		$author$project$SyntaxHighlight$Line$Helpers$toLines($author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle)));
var $author$project$SyntaxHighlight$javascript = A2(
	$elm$core$Basics$composeR,
	$author$project$SyntaxHighlight$Language$Javascript$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$SyntaxHighlight$Line$Add = 1;
var $author$project$SyntaxHighlight$Line$Del = 2;
var $author$project$SyntaxHighlight$Line$Normal = 0;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var $author$project$SyntaxHighlight$View$fragmentView = function (_v0) {
	var text = _v0.m8;
	var requiredStyle = _v0.mv;
	var additionalClass = _v0.kl;
	return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						!(!requiredStyle)),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$SyntaxHighlight$View$lineView = F3(
	function (start, index, _v0) {
		var fragments = _v0.ln;
		var highlight = _v0.lt;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('elmsh-line', true),
							_Utils_Tuple2(
							'elmsh-hl',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'elmsh-add',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(1))),
							_Utils_Tuple2(
							'elmsh-del',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(2)))
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-elmsh-lc',
					$elm$core$String$fromInt(start + index))
				]),
			A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments));
	});
var $author$project$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elmsh')
			]),
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var highlight = _v0.lt;
					var fragments = _v0.ln;
					return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(2)))
										]))
								]),
							A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var $author$project$SyntaxHighlight$View$toBlockHtml = F2(
	function (maybeStart, lines) {
		if (maybeStart.$ === 1) {
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				_List_fromArray(
					[
						$author$project$SyntaxHighlight$View$toInlineHtml(lines)
					]));
		} else {
			var start = maybeStart.a;
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$code,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							$author$project$SyntaxHighlight$View$lineView(start),
							lines))));
		}
	});
var $author$project$SyntaxHighlight$toBlockHtml = F2(
	function (maybeStart, _v0) {
		var lines = _v0;
		return A2($author$project$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
	});
var $author$project$Utils$Highlighter$highlight = function (jsCode) {
	return A2(
		$elm$core$Result$withDefault,
		A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(jsCode)
				])),
		A2(
			$elm$core$Result$map,
			$author$project$SyntaxHighlight$toBlockHtml(
				$elm$core$Maybe$Just(1)),
			$author$project$SyntaxHighlight$javascript(jsCode)));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Utils$RenderHelper$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $author$project$Utils$RenderHelper$toVirtualDom = function (nodes) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Utils$RenderHelper$toVirtualDomEach, nodes))
		]);
};
var $author$project$Utils$RenderHelper$toVirtualDomEach = function (node) {
	_v0$2:
	while (true) {
		switch (node.$) {
			case 1:
				if ((node.c.b && (!node.c.a.$)) && (!node.c.b.b)) {
					switch (node.a) {
						case 'code':
							var attrs = node.b;
							var _v1 = node.c;
							var s = _v1.a.a;
							return $author$project$Utils$Highlighter$highlight(s);
						case 'span':
							if (((node.b.b && (node.b.a.a === 'class')) && (node.b.a.b === 'inline-code')) && (!node.b.b.b)) {
								var _v2 = node.b;
								var _v3 = _v2.a;
								var _v4 = node.c;
								var s = _v4.a.a;
								return A3(
									$elm$html$Html$node,
									'span',
									A2(
										$elm$core$List$map,
										$author$project$Utils$RenderHelper$toAttribute,
										_List_fromArray(
											[
												_Utils_Tuple2('class', 'inline-code')
											])),
									_List_fromArray(
										[
											$elm$html$Html$text(s)
										]));
							} else {
								break _v0$2;
							}
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			case 0:
				var s = node.a;
				var _v5 = A2($elm$core$String$endsWith, '[Optional]', s) ? _Utils_Tuple2(
					'optional',
					A3($elm$core$String$replace, '[Optional]', '', s)) : _Utils_Tuple2('', s);
				var className = _v5.a;
				var sanitized = _v5.b;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class(className)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(sanitized)
						]));
			default:
				return $elm$html$Html$text('');
		}
	}
	var name = node.a;
	var attrs = node.b;
	var children = node.c;
	return A3(
		$elm$html$Html$node,
		name,
		A2($elm$core$List$map, $author$project$Utils$RenderHelper$toAttribute, attrs),
		$author$project$Utils$RenderHelper$toVirtualDom(children));
};
var $author$project$LandingSite$DevelopersAPI$renderDescription = function (description) {
	return A2(
		$elm$core$Result$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$elm$core$Result$map,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('description')
					])),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$RenderHelper$toVirtualDom,
				$hecrj$html_parser$Html$Parser$run(description))));
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$LandingSite$DevelopersAPI$renderField = function (_v0) {
	var name = _v0.i5;
	var description = _v0.hY;
	var fieldType = _v0.d0;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(fieldType)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$LandingSite$DevelopersAPI$renderDescription(description)
					]))
			]));
};
var $author$project$LandingSite$DevelopersAPI$renderMessage = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$id(message.i5)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message.i5)
					])),
				$author$project$LandingSite$DevelopersAPI$renderDescription(message.hY),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('api-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Type')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Key')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Description')
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2($elm$core$List$map, $author$project$LandingSite$DevelopersAPI$renderField, message.d1))
					]))
			]));
};
var $author$project$LandingSite$DevelopersAPI$renderMethod = F2(
	function (messages, method) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				_List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (methodResponse) {
					return _Utils_Tuple2(
						$author$project$LandingSite$DevelopersAPI$renderMessage(methodResponse),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.d0;
							},
							methodResponse.d1));
				},
				A2($elm$core$Dict$get, method.jz, messages)));
		var responseMessageHtml = _v0.a;
		var responseMessageFieldTypes = _v0.b;
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				_List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (methodRequest) {
					return _Utils_Tuple2(
						$author$project$LandingSite$DevelopersAPI$renderMessage(methodRequest),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.d0;
							},
							methodRequest.d1));
				},
				A2($elm$core$Dict$get, method.jx, messages)));
		var requestMessageHtml = _v1.a;
		var requestMessageFieldTypes = _v1.b;
		var restMessagesHtml = function () {
			var usedFieldTypesSet = $elm$core$Set$fromList(
				_Utils_ap(requestMessageFieldTypes, responseMessageFieldTypes));
			var remainingMessages = A2(
				$elm$core$Dict$remove,
				method.jz,
				A2($elm$core$Dict$remove, method.jx, messages));
			var subFieldTypes = $elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					function (message) {
						return A2($elm$core$Set$member, message.i5, usedFieldTypesSet) ? $elm$core$Maybe$Just(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.d0;
								},
								message.d1)) : $elm$core$Maybe$Nothing;
					},
					$elm$core$Dict$values(remainingMessages)));
			var fullFieldTypesSet = $elm$core$Set$fromList(
				_Utils_ap(
					requestMessageFieldTypes,
					_Utils_ap(responseMessageFieldTypes, subFieldTypes)));
			var filteredMessages = A2(
				$elm$core$List$filter,
				function (message) {
					return A2($elm$core$Set$member, message.i5, fullFieldTypesSet);
				},
				$elm$core$Dict$values(remainingMessages));
			return A2($elm$core$List$map, $author$project$LandingSite$DevelopersAPI$renderMessage, filteredMessages);
		}();
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (rule) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('endpoint')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(rule.lV + ': ')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rule.mi)
									]))
							]));
				},
				method.mC),
			_List_fromArray(
				[
					requestMessageHtml,
					responseMessageHtml,
					A2($elm$html$Html$div, _List_Nil, restMessagesHtml)
				]));
	});
var $author$project$LandingSite$DevelopersAPI$serviceView = F2(
	function (messages, service) {
		var rest = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$author$project$LandingSite$DevelopersAPI$renderMethod(messages),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.i5;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$startsWith('post_'),
							$elm$core$Basics$not)),
					service.lW)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id(service.i5)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(service.i5)
							])),
						$author$project$LandingSite$DevelopersAPI$renderDescription(service.hY),
						A2($elm$html$Html$div, _List_Nil, rest)
					]))
			]);
	});
var $author$project$LandingSite$DevelopersAPI$docView = function (doc) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			$author$project$LandingSite$DevelopersAPI$serviceView(doc.i$),
			$elm$core$Dict$values(doc.jF)));
};
var $author$project$LandingSite$DevelopersAPI$docsView = F2(
	function (protoDoc, docs) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (docName) {
					var _v0 = A2($elm$core$Dict$get, docName, protoDoc);
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var doc = _v0.a;
						return $author$project$LandingSite$DevelopersAPI$docView(doc);
					}
				},
				docs));
	});
var $author$project$Strings$Translations$introduction = function (lang) {
	switch (lang) {
		case 0:
			return 'Introduction';
		case 1:
			return 'Introducción';
		case 2:
			return '介绍';
		case 3:
			return 'introduction';
		default:
			return '소개';
	}
};
var $author$project$LandingSite$Docs$protos = _List_fromArray(
	['account.proto', 'ctoken.proto', 'market_history_api.proto', 'governance.proto']);
var $author$project$LandingSite$Docs$apiContent = F2(
	function (userLanguage, protoDoc) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('compound-api')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Compound API')
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound API input and output formats are specified by '),
								A2(
								$elm$html$Html$a,
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://developers.google.com/protocol-buffers/'),
								_List_fromArray(
									[
										$elm$html$Html$text('Protocol Buffers')
									])),
								$elm$html$Html$text(', known colloquially as protobufs. Unlike typical protobufs endpoints, the Compound endpoints support JSON for input and output in addition to the protobufs binary format. To use JSON in both the input and the output, specify the headers '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\"Content-Type: application/json\"')
									])),
								$elm$html$Html$text('and '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\"Accept: application/json\"')
									])),
								$elm$html$Html$text('in the request.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('API keys are currently optional, and are included in the HTTP header '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('compound-api-key')
									])),
								$elm$html$Html$text('; you can request keys from Compound in the #development channel of our '),
								A2(
								$elm$html$Html$a,
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
								_List_fromArray(
									[
										$elm$html$Html$text('Discord')
									])),
								$elm$html$Html$text(' server. In the future, API keys will be required to access the API.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$LandingSite$DevelopersAPI$docsView, protoDoc, $author$project$LandingSite$Docs$protos)),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('SharedDataTypes')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Shared Data Types')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Custom data types that are shared between services.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('PaginationSummary')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pagination Summary ')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Used for paginating results.')
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('api-table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Type')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Key')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$LandingSite$DevelopersAPI$renderField(
												{hY: 'The current page number', d0: 'uint32', cU: '', i5: 'page_number'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{hY: 'The number of entries to show per page.', d0: 'uint32', cU: '', i5: 'page_size'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{hY: 'The number of items matching the request across all pages.', d0: 'uint32', cU: '', i5: 'total_entries'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{hY: 'The number of pages need to show total_entries at the given page_size.', d0: 'uint32', cU: '', i5: 'total_pages'})
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('Precise')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Precise ')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('For non-negative numbers only.')
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('api-table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Type')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Key')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$LandingSite$DevelopersAPI$renderField(
												{hY: 'The full UNSIGNED number in string form. max value is 2^257 - 1,aka 231584178474632390847141970017375815706539969331281128078915168015826259279871', d0: 'string', cU: '', i5: 'value'})
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$LandingSite$DevelopersAPI$listServiceView = F2(
	function (messages, service) {
		return _List_fromArray(
			[
				_Utils_Tuple2('#' + service.i5, service.i5)
			]);
	});
var $author$project$LandingSite$DevelopersAPI$navListView = function (doc) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			$author$project$LandingSite$DevelopersAPI$listServiceView(doc.i$),
			$elm$core$Dict$values(doc.jF)));
};
var $author$project$LandingSite$DevelopersAPI$navList = F2(
	function (protoDoc, docs) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (docName) {
					var _v0 = A2($elm$core$Dict$get, docName, protoDoc);
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var doc = _v0.a;
						return $author$project$LandingSite$DevelopersAPI$navListView(doc);
					}
				},
				docs));
	});
var $author$project$LandingSite$Docs$apiNavList = F2(
	function (userLanguage, protoDoc) {
		return _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'#compound-api',
					$author$project$Strings$Translations$introduction(userLanguage))
				]),
			_Utils_ap(
				A2($author$project$LandingSite$DevelopersAPI$navList, protoDoc, $author$project$LandingSite$Docs$protos),
				_List_fromArray(
					[
						_Utils_Tuple2('#SharedDataTypes', 'Shared Data Types')
					])));
	});
var $author$project$Strings$Translations$comptroller = function (lang) {
	switch (lang) {
		case 0:
			return 'Comptroller';
		case 1:
			return 'Contralor';
		case 2:
			return '审计官';
		case 3:
			return 'Contrôleur';
		default:
			return '감사관';
	}
};
var $author$project$Strings$Translations$ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens';
		case 1:
			return 'cTokens';
		case 2:
			return 'cTokens';
		case 3:
			return 'cTokens';
		default:
			return 'cTokens';
	}
};
var $author$project$LandingSite$Docs$CTokenDoc$doc = '\n<section id="introduction" name="Introduction">\n# cTokens\n\n## Introduction\n\nEach asset supported by the Compound Protocol is integrated through a cToken contract, which is an [EIP-20](https://eips.ethereum.org/EIPS/eip-20) compliant representation of balances supplied to the protocol. By minting cTokens, users (1) earn interest through the cToken\'s exchange rate, which increases in value relative to the underlying asset, and (2) gain the ability to use cTokens as collateral.\n\ncTokens are the primary means of interacting with the Compound Protocol; when a user mints, redeems, borrows, repays a borrow, liquidates a borrow, or transfers cTokens, she will do so using the cToken contract.\n\nThere are currently two types of cTokens: CErc20 and CEther. Though both types expose the EIP-20 interface, CErc20 wraps an underlying ERC-20 asset, while CEther simply wraps Ether itself. As such, the core functions which involve transferring an asset into the protocol have slightly different interfaces depending on the type, each of which is shown below.\n</section>\n\n<section id="mint" name="Mint">\n## Mint\nThe mint function transfers an asset into the protocol, which begins accumulating interest based on the current [Supply Rate](#supply-rate) for the asset. The user receives a quantity of cTokens equal to the underlying tokens supplied, divided by the current [Exchange Rate](#exchange-rate).\n\n#### CErc20\n\n```solc\nfunction mint(uint mintAmount) returns (uint)\n```\n\n* `msg.sender`: The account which shall supply the asset, and own the minted cTokens.\n* `mintAmount`: The amount of the asset to be supplied, in units of the underlying asset.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\nBefore supplying an asset, users must first [approve](https://eips.ethereum.org/EIPS/eip-20#approve) the cToken to access their token balance.\n\n#### CEther\n\n```solc\nfunction mint() payable\n```\n\n* `msg.value`: The amount of ether to be supplied, in wei.\n* `msg.sender`: The account which shall supply the ether, and own the minted cTokens.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n\n```solc\nErc20 underlying = Erc20(0xToken...);     // get a handle for the underlying asset contract\nCErc20 cToken = CErc20(0x3FDA...);        // get a handle for the corresponding cToken contract\nunderlying.approve(address(cToken), 100); // approve the transfer\nassert(cToken.mint(100) == 0);            // mint the cTokens and assert there is no error\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nawait cToken.methods.mint().send({from: myAccount, value: 50});\n```\n</section>\n\n<section id="redeem" name="Redeem">\n## Redeem\n\nThe redeem function converts a specified quantity of cTokens into the underlying asset, and returns them to the user. The amount of underlying tokens received is equal to the quantity of cTokens redeemed, multiplied by the current [Exchange Rate](#exchange-rate). The amount redeemed must be less than the user\'s [Account Liquidity](comptroller#account-liquidity) and the market\'s available liquidity.\n\n#### CErc20 / CEther\n\n```solc\nfunction redeem(uint redeemTokens) returns (uint)\n```\n\n* `msg.sender`: The account to which redeemed funds shall be transferred.\n* `redeemTokens`: The number of cTokens to be redeemed.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\n#### Solidity\n\n```solc\nCEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeem(7) == 0, "something went wrong");\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeem(1).send({from: ...});\n```\n</section>\n\n<section id="redeem-underlying" name="Redeem Underlying">\n## Redeem Underlying\n\nThe redeem underlying function converts cTokens into a specified quantity of the underlying asset, and returns them to the user. The amount of cTokens redeemed is equal to the quantity of underlying tokens received, divided by the current [Exchange Rate](#exchange-rate). The amount redeemed must be less than the user\'s [Account Liquidity](comptroller#account-liquidity) and the market\'s available liquidity.\n\n#### CErc20 / CEther\n```solc\nfunction redeemUnderlying(uint redeemAmount) returns (uint)\n```\n\n* `msg.sender`: The account to which redeemed funds shall be transferred.\n* `redeemAmount`: The amount of underlying to be redeemed.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\n#### Solidity\n```solc\nCEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeemUnderlying(50) == 0, "something went wrong");\n```\n\n#### Web3 1.0\n```js\nconst cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeemUnderlying(10).send({from: ...});\n```\n</section>\n\n<section id="borrow" name="Borrow">\n## Borrow\n\nThe borrow function transfers an asset from the protocol to the user, and creates a borrow balance which begins accumulating interest based on the [Borrow Rate](#borrow-rate) for the asset. The amount borrowed must be less than the user\'s [Account Liquidity](comptroller#account-liquidity) and the market\'s available liquidity.\n\nTo borrow Ether, the borrower must be \'payable\' (solidity).\n\n#### CErc20 / CEther\n\n```solc\nfunction borrow(uint borrowAmount) returns (uint)\n```\n\n* `msg.sender`: The account to which borrowed funds shall be transferred.\n* `borrowAmount` : The amount of the underlying asset to be borrowed.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\n#### Solidity\n\n```solc\nCErc20 cToken = CErc20(0x3FDA...);\nrequire(cToken.borrow(100) == 0, "got collateral?");\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nawait cToken.methods.borrow(50).send({from: 0xMyAccount});\n```\n</section>\n\n<section id="repay-borrow" name="Repay Borrow">\n## Repay Borrow\nThe repay function transfers an asset into the protocol, reducing the user\'s borrow balance.\n\n#### CErc20\n\n```solc\nfunction repayBorrow(uint repayAmount) returns (uint)\n```\n\n* `msg.sender`: The account which borrowed the asset, and shall repay the borrow.\n* `repayAmount`: The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. `2^256` - 1) can be used to repay the full amount.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\nBefore repaying an asset, users must first [approve](https://eips.ethereum.org/EIPS/eip-20#approve) the cToken to access their token balance.\n\n#### CEther\n\n```solc\nfunction repayBorrow() payable\n```\n\n* `msg.value`: The amount of ether to be repaid, in wei.\n* `msg.sender`: The account which borrowed the asset, and shall repay the borrow.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n\n```solc\nCEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrow.value(100)() == 0, "transfer approved?");\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CErc20.at(0x3FDA...);\ncToken.methods.repayBorrow(10000).send({from: ...});\n```\n</section>\n\n<section id="repay-borrow-behalf" name="Repay Borrow Behalf">\n## Repay Borrow Behalf\n\nThe repay function transfers an asset into the protocol, reducing the target user\'s borrow balance.\n\n#### CErc20\n\n```solc\nfunction repayBorrowBehalf(address borrower, uint repayAmount) returns (uint)\n```\n\n* `msg.sender`: The account which shall repay the borrow.\n* `borrower`: The account which borrowed the asset to be repaid.\n* `repayAmount`: The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. `2^256` - 1) can be used to repay the full amount.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\nBefore repaying an asset, users must first [approve](https://eips.ethereum.org/EIPS/eip-20#approve) the cToken to access their token balance.\n\n#### CEther\n```solc\nfunction repayBorrowBehalf(address borrower) payable\n```\n\n* `msg.value`: The amount of ether to be repaid, in wei.\n* `msg.sender`: The account which shall repay the borrow.\n* `borrower`: The account which borrowed the asset to be repaid.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n\n```solc\nCEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrowBehalf.value(100)(0xBorrower) == 0, "transfer approved?");\n```\n\n#### Web3 1.0\n```js\nconst cToken = CErc20.at(0x3FDA...);\nawait cToken.methods.repayBorrowBehalf(0xBorrower, 10000).send({from: 0xPayer});\n```\n</section>\n\n<section id="liquidate-borrow" name="Liquidate Borrow">\n## Liquidate Borrow\n\nA user who has negative [account liquidity](comptroller#account-liquidity) is subject to [liquidation](#liquidate-borrow) by other users of the protocol to return his/her account liquidity back to positive (i.e. above the collateral requirement). When a liquidation occurs, a liquidator may repay some or all of an outstanding borrow on behalf of a borrower and in return receive a discounted amount of collateral held by the borrower; this discount is defined as the liquidation incentive.\n\nA liquidator may close up to a certain fixed percentage (i.e. close factor) of any individual outstanding borrow of the underwater account. Unlike in v1, liquidators must interact with each cToken contract in which they wish to repay a borrow and seize another asset as collateral. When collateral is seized, the liquidator is transferred cTokens, which they may redeem the same as if they had supplied the asset themselves. Users must approve each cToken contract before calling liquidate (i.e. on the borrowed asset which they are repaying), as they are transferring funds into the contract.\n\n#### CErc20\n\n```solc\nfunction liquidateBorrow(address borrower, uint amount, address collateral) returns (uint)\n```\n\n* `msg.sender`: The account which shall liquidate the borrower by repaying their debt and seizing their collateral.\n* `borrower`: The account with negative [account liquidity](comptroller#account-liquidity) that shall be liquidated.\n* `repayAmount`: The amount of the borrowed asset to be repaid and converted into collateral, specified in units of the underlying borrowed asset.\n* `cTokenCollateral`: The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.\n* `RETURN`: 0 on success, otherwise an [Error code](#error-codes)\n\nBefore supplying an asset, users must first [approve](https://eips.ethereum.org/EIPS/eip-20#approve) the cToken to access their token balance.\n\n#### CEther\n\n```solc\nfunction liquidateBorrow(address borrower, address cTokenCollateral) payable\n```\n\n* `msg.value`: The amount of ether to be repaid and converted into collateral, in wei.\n* `msg.sender`: The account which shall liquidate the borrower by repaying their debt and seizing their collateral.\n* `borrower`: The account with negative [account liquidity](comptroller#account-liquidity) that shall be liquidated.\n* `cTokenCollateral`: The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n\n```solc\nCEther cToken = CEther(0x3FDB...);\nCErc20 cTokenCollateral = CErc20(0x3FDA...);\nrequire(cToken.liquidateBorrow.value(100)(0xBorrower, cTokenCollateral) == 0, "borrower underwater??");\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CErc20.at(0x3FDA...);\nconst cTokenCollateral = CEther.at(0x3FDB...);\nawait cToken.methods.liquidateBorrow(0xBorrower, 33, cTokenCollateral).send({from: 0xLiquidator});\n```\n</section>\n\n<section id="key-events" name="Key Events">\n## Key Events\n\n```pseudo-table:key-events-table\n| Event | Description |\n|-------|-------------|\n| `Mint(address minter, uint mintAmount, uint mintTokens)` | Emitted upon a successful [Mint](#mint). |\n| `Redeem(address redeemer, uint redeemAmount, uint redeemTokens)` | Emitted upon a successful [Redeem](#redeem). |\n| `Borrow(address borrower, uint borrowAmount, uint accountBorrows, uint totalBorrows)` | Emitted upon a successful [Borrow](#borrow). |\n| `RepayBorrow(address payer, address borrower, uint repayAmount, uint accountBorrows, uint totalBorrows)` | Emitted upon a successful [Repay Borrow](#repay-borrow). |\n| `LiquidateBorrow(address liquidator, address borrower, uint repayAmount, address cTokenCollateral, uint seizeTokens)` | Emitted upon a successful [Liquidate Borrow](#liquidate-borrow). |\n```\n</section>\n\n<section id="error-codes" name="Error Codes">\n## Error Codes\n\n```pseudo-table:errors\n| Code | Name | Description |\n|------|------|-------------|\n| 0    | `NO_ERROR` | Not a failure. |\n| 1    | `UNAUTHORIZED` | The sender is not authorized to perform this action. |\n| 2    | `BAD_INPUT` | An invalid argument was supplied by the caller. |\n| 3    | `COMPTROLLER_REJECTION` | The action would violate the comptroller policy. |\n| 4    | `COMPTROLLER_CALCULATION_ERROR` | An internal calculation has failed in the comptroller. |\n| 5    | `INTEREST_RATE_MODEL_ERROR` | The interest rate model returned an invalid value. |\n| 6    | `INVALID_ACCOUNT_PAIR` | The specified combination of accounts is invalid. |\n| 7    | `INVALID_CLOSE_AMOUNT_REQUESTED` | The amount to liquidate is invalid. |\n| 8    | `INVALID_COLLATERAL_FACTOR` | The collateral factor is invalid. |\n| 9    | `MATH_ERROR` | A math calculation error occurred. |\n| 10   | `MARKET_NOT_FRESH` | Interest has not been properly accrued. |\n| 11   | `MARKET_NOT_LISTED` | The market is not currently listed by its comptroller. |\n| 12   | `TOKEN_INSUFFICIENT_ALLOWANCE` | ERC-20 contract must *allow* Money Market contract to call `transferFrom`. The current allowance is either 0 or less than the requested supply, repayBorrow or liquidate amount. |\n| 13   | `TOKEN_INSUFFICIENT_BALANCE` | Caller does not have sufficient balance in the ERC-20 contract to complete the desired action. |\n| 14   | `TOKEN_INSUFFICIENT_CASH` | The market does not have a sufficient cash balance to complete the transaction. You may attempt this transaction again later. |\n| 15   | `TOKEN_TRANSFER_IN_FAILED` | Failure in ERC-20 when transfering token into the market. |\n| 16   | `TOKEN_TRANSFER_OUT_FAILED` | Failure in ERC-20 when transfering token out of the market. |\n```\n\n## Failure Info\n\n```pseudo-table:failure-infos\n| Code | Name |\n|------|------|\n| 0    | `ACCEPT_ADMIN_PENDING_ADMIN_CHECK` |\n| 1    | `ACCRUE_INTEREST_ACCUMULATED_INTEREST_CALCULATION_FAILED` |\n| 2    | `ACCRUE_INTEREST_BORROW_RATE_CALCULATION_FAILED` |\n| 3    | `ACCRUE_INTEREST_NEW_BORROW_INDEX_CALCULATION_FAILED` |\n| 4    | `ACCRUE_INTEREST_NEW_TOTAL_BORROWS_CALCULATION_FAILED` |\n| 5    | `ACCRUE_INTEREST_NEW_TOTAL_RESERVES_CALCULATION_FAILED` |\n| 6    | `ACCRUE_INTEREST_SIMPLE_INTEREST_FACTOR_CALCULATION_FAILED` |\n| 7    | `BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED` |\n| 8    | `BORROW_ACCRUE_INTEREST_FAILED` |\n| 9    | `BORROW_CASH_NOT_AVAILABLE` |\n| 10   | `BORROW_FRESHNESS_CHECK` |\n| 11   | `BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED` |\n| 12   | `BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED` |\n| 13   | `BORROW_MARKET_NOT_LISTED` |\n| 14   | `BORROW_COMPTROLLER_REJECTION` |\n| 15   | `LIQUIDATE_ACCRUE_BORROW_INTEREST_FAILED` |\n| 16   | `LIQUIDATE_ACCRUE_COLLATERAL_INTEREST_FAILED` |\n| 17   | `LIQUIDATE_COLLATERAL_FRESHNESS_CHECK` |\n| 18   | `LIQUIDATE_COMPTROLLER_REJECTION` |\n| 19   | `LIQUIDATE_COMPTROLLER_CALCULATE_AMOUNT_SEIZE_FAILED` |\n| 20   | `LIQUIDATE_CLOSE_AMOUNT_IS_UINT_MAX` |\n| 21   | `LIQUIDATE_CLOSE_AMOUNT_IS_ZERO` |\n| 22   | `LIQUIDATE_FRESHNESS_CHECK` |\n| 23   | `LIQUIDATE_LIQUIDATOR_IS_BORROWER` |\n| 24   | `LIQUIDATE_REPAY_BORROW_FRESH_FAILED` |\n| 25   | `LIQUIDATE_SEIZE_BALANCE_INCREMENT_FAILED` |\n| 26   | `LIQUIDATE_SEIZE_BALANCE_DECREMENT_FAILED` |\n| 27   | `LIQUIDATE_SEIZE_COMPTROLLER_REJECTION` |\n| 28   | `LIQUIDATE_SEIZE_LIQUIDATOR_IS_BORROWER` |\n| 29   | `LIQUIDATE_SEIZE_TOO_MUCH` |\n| 30   | `MINT_ACCRUE_INTEREST_FAILED` |\n| 31   | `MINT_COMPTROLLER_REJECTION` |\n| 32   | `MINT_EXCHANGE_CALCULATION_FAILED` |\n| 33   | `MINT_EXCHANGE_RATE_READ_FAILED` |\n| 34   | `MINT_FRESHNESS_CHECK` |\n| 35   | `MINT_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED` |\n| 36   | `MINT_NEW_TOTAL_SUPPLY_CALCULATION_FAILED` |\n| 37   | `MINT_TRANSFER_IN_FAILED` |\n| 38   | `MINT_TRANSFER_IN_NOT_POSSIBLE` |\n| 39   | `REDEEM_ACCRUE_INTEREST_FAILED` |\n| 40   | `REDEEM_COMPTROLLER_REJECTION` |\n| 41   | `REDEEM_EXCHANGE_TOKENS_CALCULATION_FAILED` |\n| 42   | `REDEEM_EXCHANGE_AMOUNT_CALCULATION_FAILED` |\n| 43   | `REDEEM_EXCHANGE_RATE_READ_FAILED` |\n| 44   | `REDEEM_FRESHNESS_CHECK` |\n| 45   | `REDEEM_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED` |\n| 46   | `REDEEM_NEW_TOTAL_SUPPLY_CALCULATION_FAILED` |\n| 47   | `REDEEM_TRANSFER_OUT_NOT_POSSIBLE` |\n| 48   | `REDUCE_RESERVES_ACCRUE_INTEREST_FAILED` |\n| 49   | `REDUCE_RESERVES_ADMIN_CHECK` |\n| 50   | `REDUCE_RESERVES_CASH_NOT_AVAILABLE` |\n| 51   | `REDUCE_RESERVES_FRESH_CHECK` |\n| 52   | `REDUCE_RESERVES_VALIDATION` |\n| 53   | `REPAY_BEHALF_ACCRUE_INTEREST_FAILED` |\n| 54   | `REPAY_BORROW_ACCRUE_INTEREST_FAILED` |\n| 55   | `REPAY_BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED` |\n| 56   | `REPAY_BORROW_COMPTROLLER_REJECTION` |\n| 57   | `REPAY_BORROW_FRESHNESS_CHECK` |\n| 58   | `REPAY_BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED` |\n| 59   | `REPAY_BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED` |\n| 60   | `REPAY_BORROW_TRANSFER_IN_NOT_POSSIBLE` |\n| 61   | `SET_COLLATERAL_FACTOR_OWNER_CHECK` |\n| 62   | `SET_COLLATERAL_FACTOR_VALIDATION` |\n| 63   | `SET_COMPTROLLER_OWNER_CHECK` |\n| 64   | `SET_INTEREST_RATE_MODEL_ACCRUE_INTEREST_FAILED` |\n| 65   | `SET_INTEREST_RATE_MODEL_FRESH_CHECK` |\n| 66   | `SET_INTEREST_RATE_MODEL_OWNER_CHECK` |\n| 67   | `SET_MAX_ASSETS_OWNER_CHECK` |\n| 68   | `SET_ORACLE_MARKET_NOT_LISTED` |\n| 69   | `SET_PENDING_ADMIN_OWNER_CHECK` |\n| 70   | `SET_RESERVE_FACTOR_ACCRUE_INTEREST_FAILED` |\n| 71   | `SET_RESERVE_FACTOR_ADMIN_CHECK` |\n| 72   | `SET_RESERVE_FACTOR_FRESH_CHECK` |\n| 73   | `SET_RESERVE_FACTOR_BOUNDS_CHECK` |\n| 74   | `TRANSFER_COMPTROLLER_REJECTION` |\n| 75   | `TRANSFER_NOT_ALLOWED` |\n| 76   | `TRANSFER_NOT_ENOUGH` |\n| 77   | `TRANSFER_TOO_MUCH` |\n```\n</section>\n\n<section id="exchange-rate" name="Exchange Rate">\n## Exchange Rate\nEach cToken is convertible into an ever increasing quantity of the underlying asset, as interest accrues in the market. The exchange rate between a cToken and the underlying asset is equal to:\n\n```solc\nexchangeRate = (getCash() + totalBorrows() - totalReserves()) / totalSupply()\n```\n\n#### CErc20 / CEther\n\n```solc\nfunction exchangeRateCurrent() returns (uint)\n```\n\n* `RETURN`: The current exchange rate as an unsigned integer, scaled by 1e18.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint exchangeRateMantissa = cToken.exchangeRateCurrent();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst exchangeRate = (await cToken.methods.exchangeRateCurrent().call()) / 1e18;\n```\n\nTip: note the use of `call` vs. `send` to invoke the function from off-chain without incurring gas costs.\n</section>\n\n<section id="get-cash" name="Get Cash">\n## Get Cash\nCash is the amount of underlying balance owned by this cToken contract. One may query the total amount of cash currently available to this market.\n\n#### CErc20 / CEther\n\n```solc\nfunction getCash() returns (uint)\n```\n\n* `RETURN`: The quantity of underlying asset owned by the contract.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint cash = cToken.getCash();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst cash = (await cToken.methods.getCash().call());\n```\n</section>\n\n<section id="total-borrows" name="Total Borrows">\n## Total Borrow\nTotal Borrows is the amount of underlying currently loaned out by the market, and the amount upon which interest is accumulated to suppliers of the market.\n\n#### CErc20 / CEther\n\n```solc\nfunction totalBorrowsCurrent() returns (uint)\n```\n\n* `RETURN`: The total amount of borrowed underlying, with interest.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.totalBorrowsCurrent();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst borrows = (await cToken.methods.totalBorrowsCurrent().call());\n```\n</section>\n\n<section id="borrow-balance" name="Borrow Balance">\n## Borrow Balance\nA user who borrows assets from the protocol is subject to accumulated interest based on the current [borrow rate](#borrow-rate). Interest is accumulated every block and integrations may use this function to obtain the current value of a user\'s borrow balance with interest.\n\n#### CErc20 / CEther\n\n```solc\nfunction borrowBalanceCurrent(address account) returns (uint)\n```\n\n* `account`: The account which borrowed the assets.\n* `RETURN`: The user\'s current borrow balance (with interest) in units of the underlying asset.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.borrowBalanceCurrent(msg.caller);\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst borrows = await cToken.methods.borrowBalanceCurrent(account).call();\n```\n</section>\n\n<section id="borrow-rate" name="Borrow Rate">\n## Borrow Rate\nAt any point in time one may query the contract to get the current borrow rate per block.\n\n#### CErc20 / CEther\n\n```solc\nfunction borrowRatePerBlock() returns (uint)\n```\n\n* `RETURN`: The current borrow rate as an unsigned integer, scaled by 1e18.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint borrowRateMantissa = cToken.borrowRatePerBlock();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst borrowRate = (await cToken.methods.borrowRatePerBlock().call()) / 1e18;\n```\n</section>\n\n<section id="total-supply" name="Total Supply">\n## Total Supply\nTotal Supply is the number of tokens currently in circulation in this cToken market. It is part of the EIP-20 interface of the cToken contract.\n\n#### CErc20 / CEther\n\n```solc\nfunction totalSupply() returns (uint)\n```\n\n* `RETURN`: The total number of tokens in circulation for the market.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.totalSupply();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst tokens = (await cToken.methods.totalSupply().call());\n```\n</section>\n\n<section id="underlying-balance" name="Underlying Balance">\n## Underlying Balance\nThe user\'s underlying balance, representing their assets in the protocol, is equal to the user\'s cToken balance multiplied by the [Exchange Rate](#exchange-rate).\n\n#### CErc20 / CEther\n\n```solc\nfunction balanceOfUnderlying(address account) returns (uint)\n```\n\n* `account`: The account to get the underlying balance of.\n* `RETURN`: The amount of underlying currently owned by the account.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.balanceOfUnderlying(msg.caller);\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst tokens = await cToken.methods.balanceOfUnderlying(account).call();\n```\n</section>\n\n<section id="supply-rate" name="Supply Rate">\n## Supply Rate\n\nAt any point in time one may query the contract to get the current supply rate per block. The supply rate is derived from the [borrow rate](#borrow-rate), [reserve factor](#reserve-factor) and the amount of [total borrows](#total-borrows).\n\n#### CErc20 / CEther\n\n```solc\nfunction supplyRatePerBlock() returns (uint)\n```\n\n* `RETURN`: The current supply rate as an unsigned integer, scaled by 1e18.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint supplyRateMantissa = cToken.supplyRatePerBlock();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst supplyRate = (await cToken.methods.supplyRatePerBlock().call()) / 1e18;\n```\n</section>\n\n<section id="total-reserves" name="Total Reserves">\n## Total Reserves\nReserves are an accounting entry in each cToken contract that represents a portion of historical interest set aside as [cash](#cash) which can be withdrawn or transferred through the protocol\'s governance. A small portion of borrower interest accrues into the protocol, determined by the [reserve factor](#reserve-factor).\n\n#### CErc20 / CEther\n\n```solc\nfunction totalReserves() returns (uint)\n```\n\n* `RETURN`: The total amount of reserves held in the market.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint reserves = cToken.totalReserves();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst reserves = (await cToken.methods.totalReserves().call());\n```\n</section>\n\n<section id="reserve-factor" name="Reserve Factor">\n## Reserve Factor\nThe reserve factor defines the portion of borrower interest that is converted into [reserves](#total-reserves).\n\n#### CErc20 / CEther\n\n```solc\nfunction reserveFactorMantissa() returns (uint)\n```\n\n* `RETURN`: The current reserve factor as an unsigned integer, scaled by 1e18.\n\n#### Solidity\n\n```solc\nCErc20 cToken = CToken(0x3FDA...);\nuint reserveFactorMantissa = cToken.reserveFactorMantissa();\n```\n\n#### Web3 1.0\n\n```js\nconst cToken = CEther.at(0x3FDB...);\nconst reserveFactor = (await cToken.methods.reserveFactorMantissa().call()) / 1e18;\n```\n</section>\n';
var $author$project$LandingSite$Docs$ComptrollerDoc$doc = '\n<section id="introduction" name="Introduction">\n# Comptroller\n\n## Introduction\nThe Comptroller is the risk management layer of the Compound protocol; it determines how much collateral a user is required to maintain, and whether (and by how much) a user can be liquidated. Each time a user interacts with a cToken, the Comptroller is asked to approve or deny the transaction.\n\nThe Comptroller maps user balances to prices (via the Price Oracle) to\nrisk weights (called [Collateral Factors](comptroller#collateral-factor)) to make its determinations. Users explicitly list which assets they would like included in their risk scoring, by calling [Enter Markets](comptroller#enter-markets) and [Exit Market](comptroller#exit-market).\n</section>\n\n<section id="architecture" name="Architecture">\n## Architecture\n\nThe Comptroller is implemented as an upgradeable proxy. The Unitroller proxies all logic to the Comptroller implementation, but storage values are set on the Unitroller. To call Comptroller functions, use the Comptroller ABI on the Unitroller address.\n</section>\n\n<section id="enter-markets" name="Enter Markets">\n## Enter Markets\nEnter into a list of markets - it is not an error to enter the same market more than once. In order to supply collateral or borrow in a market, it must be entered first.\n\n#### Comptroller\n```solc\nfunction enterMarkets(address[] calldata cTokens) returns (uint[] memory)\n```\n\n* `msg.sender`: The account which shall enter the given markets.\n* `cTokens`: The addresses of the cToken markets to enter.\n* `RETURN`: For each market, returns an error code indicating whether or not it was entered. Each is 0 on success, otherwise an [Error code](comptroller#error-codes).\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\nCToken[] memory cTokens = new CToken[](2);\ncTokens[0] = CErc20(0x3FDA...);\ncTokens[1] = CEther(0x3FDB...);\nuint[] memory errors = troll.enterMarkets(cTokens);\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst cTokens = [CErc20.at(0x3FDA...), CEther.at(0x3FDB...)];\nconst errors = await troll.methods.enterMarkets(cTokens).send({from: ...});\n```\n</section>\n\n<section id="exit-market" name="Exit Market">\n## Exit Market\n\nExit a market - it is not an error to exit a market which is not currently entered. Exited markets will not count towards account liquidity calculations.\n\n#### Comptroller\n```solc\nfunction exitMarket(address cToken) returns (uint)\n```\n\n* `msg.sender`: The account which shall exit the given market.\n* `cTokens`: The addresses of the cToken market to exit.\n* `RETURN`: 0 on success, otherwise an [Error code](comptroller#error-codes).\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\nuint error = troll.exitMarket(CToken(0x3FDA...));\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst errors = await troll.methods.exitMarket(CEther.at(0x3FDB...)).send({from: ...});\n```\n</section>\n\n<section id="get-assets-in" name="Get Assets In">\n## Get Assets In\n\nGet the list of markets an account is currently entered into. In order to supply collateral or borrow in a market, it must be entered first. Entered markets count towards [account liquidity](comptroller#account-liquidity) calculations.\n\n#### Comptroller\n```solc\nfunction getAssetsIn(address account) view returns (address[] memory)\n```\n\n* `account`: The account whose list of entered markets shall be queried.\n* `RETURN`: The address of each market which is currently entered into.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\naddress[] memory markets = troll.getAssetsIn(0xMyAccount);\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst markets = await troll.methods.getAssetsIn(cTokens).call();\n```\n</section>\n\n<section id="collateral-factor" name="Collateral Factor">\n## Collateral Factor\n\nA cToken\'s collateral factor can range from 0-90%, and represents the proportionate increase in liquidity (borrow limit) that an account receives by minting the cToken.\n\nGenerally, large or liquid assets have high collateral factors, while small or illiquid assets have low collateral factors. If an asset has a 0% collateral factor, it can\'t be used as collateral (or seized in liquidation), though it can still be borrowed.\n\n```note\nCollateral factors can be increased (or decreased) through Compound Governance, as market conditions change.\n```\n\n#### Comptroller\n```solc\nfunction markets(address cTokenAddress) view returns (bool, uint)\n```\n\n* `cTokenAddress`: The address of the cToken to check if listed and get the collateral factor for.\n* `RETURN`: Tuple of values (isListed, collateralFactorMantissa); isListed represents whether the comptroller recognizes this cToken; collateralFactorMantissa, scaled by 1e18, is multiplied by a supply balance to determine how much value can be borrowed.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\n(bool isListed, uint collateralFactorMantissa) = troll.markets(0x3FDA...);\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst result = await troll.methods.markets(0x3FDA...).call();\nconst {0: isListed, 1: collateralFactorMantissa} = result;\n```\n</section>\n\n<section id="account-liquidity" name="Get Account Liquidity">\n## Get Account Liquidity\n\nAccount Liquidity represents the USD value borrowable by a user, before it reaches liquidation. Users with a shortfall (negative liquidity) are subject to liquidation, and can’t withdraw or borrow assets until Account Liquidity is positive again.\n\nFor each market the user has [entered](comptroller#enter-markets) into, their supplied balance is multiplied by the market’s [collateral factor](comptroller#collateral-factor), and summed; borrow balances are then subtracted, to equal Account Liquidity. Borrowing an asset reduces Account Liquidity for each USD borrowed; withdrawing an asset reduces Account Liquidity by the asset’s collateral factor times each USD withdrawn.\n\nBecause the Compound Protocol exclusively uses unsigned integers, Account Liquidity returns either a surplus or shortfall.\n\n#### Comptroller\n```solc\nfunction getAccountLiquidity(address account) view returns (uint, uint, uint)\n```\n\n* `account`: The account whose liquidity shall be calculated.\n* `RETURN`: Tuple of values (error, liquidity, shortfall). The error shall be 0 on success, otherwise an [error code](comptroller#error-codes). A non-zero liquidity value indicates the account has available [account liquidity](comptroller#account-liquidity). A non-zero shortfall value indicates the account is currently below his/her collateral requirement and is subject to liquidation. At most one of liquidity or shortfall shall be non-zero.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\n(uint error, uint liquidity, uint shortfall) = troll.getAccountLiquidity(msg.caller);\nrequire(error == 0, "join the Discord");\nrequire(shortfall == 0, "account underwater");\nrequire(liquidity > 0, "account has excess collateral");\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst result = await troll.methods.getAccountLiquidity(0xBorrower).call();\nconst {0: error, 1: liquidity, 2: shortfall} = result;\n```\n</section>\n\n<section id="close-factor" name="Close Factor">\n## Close Factor\n\nThe percent, ranging from 0% to 100%, of a liquidatable account\'s borrow that can be repaid in a single liquidate transaction. If a user has multiple borrowed assets, the closeFactor applies to any single borrowed asset, not the aggregated value of a user’s outstanding borrowing.\n\n#### Comptroller\n```solc\nfunction closeFactorMantissa() view returns (uint)\n```\n\n* `RETURN`: The closeFactor, scaled by 1e18, is multiplied by an outstanding borrow balance to determine how much could be closed.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\nuint closeFactor = troll.closeFactorMantissa();\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst closeFactor = await troll.methods.closeFactoreMantissa().call();\n```\n</section>\n\n<section id="liquidation-incentive" name="Liquidation Incentive">\n## Liquidation Incentive\n\nThe additional collateral given to liquidators as an incentive to perform liquidation of underwater accounts. For example, if the liquidation incentive is 1.1, liquidators receive an extra 10% of the borrowers collateral for every unit they close.\n\n#### Comptroller\n```solc\nfunction liquidationIncentiveMantissa() view returns (uint)\n```\n\n* `RETURN`: The liquidationIncentive, scaled by 1e18, is multiplied by the closed borrow amount from the liquidator to determine how much collateral can be seized.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\nuint closeFactor = troll.liquidationIncentiveMantissa();\n```\n\n#### Web3 1.0\n```js\nconst troll = Comptroller.at(0xABCD...);\nconst closeFactor = await troll.methods.liquidationIncentiveMantissa().call();\n```\n</section>\n\n<section id="key-events" name="Key Events">\n## Key Events\n\n```pseudo-table:key-events-table\n| Event | Description |\n|-------|-------------|\n| `MarketEntered(CToken cToken, address account)` | Emitted upon a successful [Enter Market](comptroller#enter-markets). |\n| `MarketExited(CToken cToken, address account)` | Emitted upon a successful [Exit Market](comptroller#exit-market). |\n```\n</section>\n\n<section id="error-codes" name="Error Codes">\n## Error Codes\n\n```pseudo-table:errors\n| Code | Name | Description |\n|------|------|-------------|\n| 0    | `NO_ERROR` | Not a failure. |\n| 1    | `UNAUTHORIZED` | The sender is not authorized to perform this action. |\n| 2    | `COMPTROLLER_MISMATCH` | Liquidation cannot be performed in markets with different comptrollers. |\n| 3    | `INSUFFICIENT_SHORTFALL` | The account does not have sufficient shortfall to perform this action. |\n| 4    | `INSUFFICIENT_LIQUIDITY` | The account does not have sufficient liquidity to perform this action. |\n| 5    | `INVALID_CLOSE_FACTOR` | The close factor is not valid. |\n| 6    | `INVALID_COLLATERAL_FACTOR` | The collateral factor is not valid. |\n| 7    | `INVALID_LIQUIDATION_INCENTIVE` | The liquidation incentive is invalid. |\n| 8    | `MARKET_NOT_ENTERED` | The market has not been entered by the account. |\n| 9    | `MARKET_NOT_LISTED` | The market is not currently listed by the comptroller. |\n| 10   | `MARKET_ALREADY_LISTED` | An admin tried to list the same market more than once. |\n| 11   | `MATH_ERROR` | A math calculation error occurred. |\n| 12   | `NONZERO_BORROW_BALANCE` | The action cannot be performed since the account carries a borrow balance. |\n| 13   | `PRICE_ERROR` | The comptroller could not obtain a required price of an asset. |\n| 14   | `REJECTION` | The comptroller rejects the action requested by the market. |\n| 15   | `SNAPSHOT_ERROR` | The comptroller could not get the account borrows and exchange rate from the market. |\n| 16   | `TOO_MANY_ASSETS` | Attempted to enter more markets than are currently supported. |\n| 17   | `TOO_MUCH_REPAY` | Attempted to repay more than is allowed by the protocol. |\n```\n\n## Failure Info\n\n```pseudo-table:failure-infos\n| Code | Name |\n|------|------|\n| 0    | `ACCEPT_ADMIN_PENDING_ADMIN_CHECK` |\n| 1    | `ACCEPT_PENDING_IMPLEMENTATION_ADDRESS_CHECK` |\n| 2    | `EXIT_MARKET_BALANCE_OWED` |\n| 3    | `EXIT_MARKET_REJECTION` |\n| 4    | `SET_CLOSE_FACTOR_OWNER_CHECK` |\n| 5    | `SET_CLOSE_FACTOR_VALIDATION` |\n| 6    | `SET_COLLATERAL_FACTOR_OWNER_CHECK` |\n| 7    | `SET_COLLATERAL_FACTOR_NO_EXISTS` |\n| 8    | `SET_COLLATERAL_FACTOR_VALIDATION` |\n| 9    | `SET_COLLATERAL_FACTOR_WITHOUT_PRICE` |\n| 10   | `SET_IMPLEMENTATION_OWNER_CHECK` |\n| 11   | `SET_LIQUIDATION_INCENTIVE_OWNER_CHECK` |\n| 12   | `SET_LIQUIDATION_INCENTIVE_VALIDATION` |\n| 13   | `SET_MAX_ASSETS_OWNER_CHECK` |\n| 14   | `SET_PENDING_ADMIN_OWNER_CHECK` |\n| 15   | `SET_PENDING_IMPLEMENTATION_OWNER_CHECK` |\n| 16   | `SET_PRICE_ORACLE_OWNER_CHECK` |\n| 17   | `SUPPORT_MARKET_EXISTS` |\n| 18   | `SUPPORT_MARKET_OWNER_CHECK` |\n```\n</section>\n\n<section id="refresh-comp-speeds" name="COMP Distribution Speeds">\n## COMP Distribution Speeds\n\n### COMP Speed\nThe “COMP speed” unique to each market is an unsigned integer that specifies the amount of COMP that is distributed, per block, to suppliers and borrowers in each market. As market conditions change, COMP speeds are updated to ensure COMP is distributed proportional to the utility of each market. Any user can call the Comptroller’s `refreshCompSpeeds` method at any time in order to update market COMP speeds.\n\nThe following is the formula for calculating the rate that COMP is distributed to each supported market.\n\n```solc\ninterestPerBlock = cTokenBorrowRatePerBlock * cTokenTotalBorrows\n\nutility = interestPerBlock * assetPrice\n\nutilityFraction = utility / sumOfAllCOMPedMarketUtilities\n\nmarketCompSpeed = compRate * utilityFraction\n```\n\n#### Comptroller\n```solc\nfunction refreshCompSpeeds(address account) public\n```\n\n* `RETURN`: None\n* `events`: `CompSpeedUpdated` - An event is emitted for each cToken with the address of the cToken and the new COMP distribution speed per block.\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\ntroll.refreshCompSpeeds();\n```\n\n#### Web3 1.2.6\n```js\nconst comptroller = new web3.eth.Contract(comptrollerAbi, comptrollerAddress);\nawait comptroller.methods.refreshCompSpeeds().send({ from: sender });\n```\n\n### COMP Distributed Per Block (All Markets)\nThe Comptroller Storage contract’s `compRate` is an unsigned integer that indicates the rate at which the protocol distributes COMP to markets’ suppliers or borrowers, every Ethereum block. The value is the amount of COMP (in wei), per block, allocated for the markets. Note that not every market has COMP distributed to its participants (see Market Metadata).\n\nThe compRate indicates how much COMP goes to the suppliers or borrowers, so doubling this number shows how much COMP goes to all suppliers and borrowers combined. The code examples implement reading the amount of COMP distributed, per Ethereum block, to all markets.\n\n#### Comptroller\n```solc\nuint public compRate;\n```\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\n\n// COMP issued per block to suppliers OR borrowers * (1 * 10 ^ 18)\nuint compRate = troll.compRate();\n\n// Approximate COMP issued per day to suppliers OR borrowers * (1 * 10 ^ 18)\nuint compRatePerDay = compRate * 4 * 60 * 24;\n\n// Approximate COMP issued per day to suppliers AND borrowers * (1 * 10 ^ 18)\nuint compRatePerDayTotal = compRatePerDay * 2;\n```\n\n#### Web3 1.2.6\n```js\nconst comptroller = new web3.eth.Contract(comptrollerAbi, comptrollerAddress);\n\nlet compRate = await comptroller.methods.compRate().call();\ncompRate = compRate / 1e18;\n\n// COMP issued to suppliers OR borrowers\nconst compRatePerDay = compRate * 4 * 60 * 24;\n\n// COMP issued to suppliers AND borrowers\nconst compRatePerDayTotal = compRatePerDay * 2;\n```\n\n### COMP Distributed Per Block (Single Market)\nThe Comptroller Storage contract has a mapping called `compSpeeds`. It maps cToken addresses to an integer of each market’s COMP distribution per Ethereum block. The integer indicates the rate at which the protocol distributes COMP to markets’ suppliers or borrowers. The value is the amount of COMP (in wei), per block, allocated for the market. Note that not every market has COMP distributed to its participants (see Market Metadata).\n\nThe speed indicates how much COMP goes to the suppliers or the borrowers, so doubling this number shows how much COMP goes to market suppliers and borrowers combined. The code examples implement reading the amount of COMP distributed, per Ethereum block, to a single market.\n\n#### Comptroller\n```solc\nmapping(address => uint) public compSpeeds;\n```\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0x123...);\naddress cToken = 0xabc...;\n\n// COMP issued per block to suppliers OR borrowers * (1 * 10 ^ 18)\nuint compSpeed = troll.compSpeeds(cToken);\n\n// Approximate COMP issued per day to suppliers OR borrowers * (1 * 10 ^ 18)\nuint compSpeedPerDay = compSpeed * 4 * 60 * 24;\n\n// Approximate COMP issued per day to suppliers AND borrowers * (1 * 10 ^ 18)\nuint compSpeedPerDayTotal = compSpeedPerDay * 2;\n```\n\n#### Web3 1.2.6\n```js\nconst cTokenAddress = \'0xabc...\';\n\nconst comptroller = new web3.eth.Contract(comptrollerAbi, comptrollerAddress);\n\nlet compSpeed = await comptroller.methods.compSpeeds(cTokenAddress).call();\ncompSpeed = compSpeed / 1e18;\n\n// COMP issued to suppliers OR borrowers\nconst compSpeedPerDay = compSpeed * 4 * 60 * 24;\n\n// COMP issued to suppliers AND borrowers\nconst compSpeedPerDayTotal = compSpeedPerDay * 2;\n```\n</section>\n\n<section id="claim-comp" name="Claim COMP">\n## Claim COMP\nEvery Compound user accrues COMP for each block they are supplying to or borrowing from the protocol. The protocol automatically transfers accrued COMP to a user’s address when the total amount of COMP accrued to that address (in a market) is greater than the `claimCompThreshold`, and the address executes any of the `mint`, `borrow`, `transfer`, `liquidateBorrow`, `repayBorrow`, or `redeem` functions on that market. Separately, users may call the `claimComp` method on any cToken contract at any time for finer grained control over which markets to claim from.\n\n#### Comptroller\n```solc\n// Claim all the COMP accrued by holder in all markets\nfunction claimComp(address holder) public\n\n// Claim all the COMP accrued by holder in specific markets\nfunction claimComp(address holder, CToken[] memory cTokens) public\n\n// Claim all the COMP accrued by specific holders in specific markets for their supplies and/or borrows\nfunction claimComp(address[] memory holders, CToken[] memory cTokens, bool borrowers, bool suppliers) public\n```\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\ntroll.claimComp(0x1234...);\n```\n\n#### Web3 1.2.6\n```js\nconst comptroller = new web3.eth.Contract(comptrollerAbi, comptrollerAddress);\nawait comptroller.methods.claimComp("0x1234...").send({ from: sender });\n```\n</section>\n\n<section id="market-metadata" name="Market Metadata">\n## Market Metadata\n\nThe Comptroller contract has an array called `allMarkets` that contains the addresses of each cToken contract. Each address in the `allMarkets` array can be used to fetch a metadata struct in the Comptroller’s markets constant. See the [Comptroller Storage contract](https://github.com/compound-finance/compound-protocol/blob/master/contracts/ComptrollerStorage.sol) for the Market struct definition.\n\n#### Comptroller\n```solc\nCToken[] public allMarkets;\n```\n\n#### Solidity\n```solc\nComptroller troll = Comptroller(0xABCD...);\nCToken cTokens[] = troll.allMarkets();\n```\n\n#### Web3 1.2.6\n```js\nconst comptroller = new web3.eth.Contract(comptrollerAbi, comptrollerAddress);\nconst cTokens = await comptroller.methods.allMarkets().call();\nconst cToken = cTokens[0]; // address of a cToken\n```\n</section>\n    ';
var $author$project$LandingSite$Docs$GovernanceDoc$doc = '\n<section id="introduction" name="Introduction">\n# Governance\n\n## Introduction\n\nThe Compound protocol is governed and upgraded by COMP token-holders, using three distinct components; the COMP token, governance module (Governor Alpha), and Timelock. Together, these contracts allow the community to propose, vote, and implement changes through the administrative functions of a cToken or the Comptroller. Proposals can include changes like adjusting an interest rate model, to adding support for a new asset.\n\nAny address with more than 100,000 COMP delegated to it may propose governance actions, which are executable code. When a proposal is created, the community can submit their votes during a 3 day voting period. If a majority, and at least 400,000 votes are cast for the proposal, it is queued in the Timelock, and can be implemented after 2 days.\n\n![Governance Diagram](/images/gov_diagram.png)\n</section>\n\n<section id="comp" name="COMP">\n## COMP\n\nCOMP is an [ERC-20](https://github.com/ethereum/EIPs/blob/master/EIPS/eip-20.md) token that allows the owner to delegate voting rights to any address, including their own address. Changes to the owner’s token balance automatically adjust the voting rights of the delegate.\n</section>\n\n<section id="delegate" name="Delegate">\n## Delegate\n\nDelegate votes from the sender to the delegatee. Users can delegate to 1 address at a time, and the number of votes added to the delegatee’s vote count is equivalent to the balance of COMP in the user’s account. Votes are delegated from the current block and onward, until the sender delegates again, or transfers their COMP.\n\n#### COMP\n```solc\nfunction delegate(address delegatee)\n```\n\n* `delegatee`: The address in which the sender wishes to delegate their votes to.\n* `msg.sender`: The address of the COMP token holder that is attempting to delegate their votes.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nComp comp = Comp(0x123...); // contract address\ncomp.delegate(delegateeAddress);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = await comp.methods.delegate(delegateeAddress).send({ from: sender });\n```\n</section>\n\n<section id="delegate-by-signature" name="Delegate By Signature">\n## Delegate By Signature\n\nDelegate votes from the signatory to the delegatee. This method has the same purpose as Delegate but it instead enables offline signatures to participate in Compound governance vote delegation. For more details on how to create an offline signature, review [EIP-712](https://eips.ethereum.org/EIPS/eip-712).\n\n#### COMP\n```solc\nfunction delegateBySig(address delegatee, uint nonce, uint expiry, uint8 v, bytes32 r, bytes32 s)\n```\n\n* `delegatee`: The address in which the sender wishes to delegate their votes to.\n* `nonce`: The contract state required to match the signature. This can be retrieved from the contract’s public nonces mapping.\n* `expiry`: The time at which to expire the signature. A block timestamp as seconds since the unix epoch (uint).\n* `v`: The recovery byte of the signature.\n* `r`: Half of the ECDSA signature pair.\n* `s`: Half of the ECDSA signature pair.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nComp comp = Comp(0x123...); // contract address\ncomp.delegateBySig(delegateeAddress, nonce, expiry, v, r, s);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = await comp.methods.delegateBySig(delegateeAddress, nonce, expiry, v, r, s).send({});\n```\n</section>\n\n<section id="get-current-votes" name="Get Current Votes">\n## Get Current Votes\n\nGets the balance of votes for an account as of the current block.\n\n#### COMP\n```solc\nfunction getCurrentVotes(address account) returns (uint96)\n```\n\n* `account`: Address of the account in which to retrieve the number of votes.\n* `RETURN`: The number of votes (integer).\n\n#### Solidity\n```solc\nComp comp = Comp(0x123...); // contract address\nuint votes = comp.getCurrentVotes(0xabc...);\n```\n\n#### Web3 1.2.6\n```solc\nconst account = \'0x123...\'; // contract address\nconst votes = await comp.methods.getCurrentVotes(account).call();\n```\n</section>\n\n<section id="get-prior-votes" name="Get Prior Votes">\n## Get Prior Votes\n\nGets the prior number of votes for an account at a specific block number. The block number passed must be a finalized block or the function will revert.\n\n#### COMP\n```solc\nfunction getPriorVotes(address account, uint blockNumber) returns (uint96)\n```\n\n* `account`: Address of the account in which to retrieve the prior number of votes.\n* `blockNumber`: The block number at which to retrieve the prior number of votes.\n* `RETURN`: The number of prior votes.\n\n#### Solidity\n```solc\nComp comp = Comp(0x123...); // contract address\nuint priorVotes = comp.getPriorVotes(account, blockNumber);\n```\n\n#### Web3 1.2.6\n```js\nconst priorVotes = await comp.methods.getPriorVotes(account, blockNumber).call();\n```\n</section>\n\n<section id="governor-alpha" name="Governor Alpha">\n## Governor Alpha\n\nGovernor Alpha is the governance module of the protocol; it allows addresses with more than 100,000 COMP to propose changes to the protocol. Addresses that held voting weight, at the start of the proposal, invoked through the getpriorvotes function, can submit their votes during a 3 day voting period. If a majority, and at least 400,000 votes are cast for the proposal, it is queued in the Timelock, and can be implemented after 2 days.\n</section>\n\n<section id="quorum-votes" name="Quorum Votes">\n## Quorum Votes\n\nThe required minimum number of votes in support of a proposal for it to succeed.\n\n#### Governor Alpha\n```solc\nfunction quorumVotes() public pure returns (uint)\n```\n\n* `RETURN`: The minimum number of votes required for a proposal to succeed.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint quorum = gov.quorumVotes();\n```\n\n#### Web3 1.2.6\n```js\nconst quorum = await gov.methods.quorumVotes().call();\n```\n</section>\n\n<section id="proposal-threshold" name="Proposal Threshold">\n## Proposal Threshold\n\nThe minimum number of votes required for an account to create a proposal.\n\n#### Governor Alpha\n```solc\nfunction proposalThreshold() returns (uint)\n```\n\n* `RETURN`: The minimum number of votes required for an account to create a proposal.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint threshold = gov.proposalThreshold();\n```\n\n#### Web3 1.2.6\n```js\nconst threshold = await gov.methods.proposalThreshold().call();\n```\n</section>\n\n<section id="proposal-max-operations" name="Proposal Max Operations">\n## Proposal Max Operations\n\nThe maximum number of actions that can be included in a proposal. Actions are functions calls that will be made when a proposal succeeds and executes.\n\n#### Governor Alpha\n```solc\nfunction proposalMaxOperations() returns (uint)\n```\n\n* `RETURN`: The maximum number of actions that can be included in a proposal.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint operations = gov.proposalMaxOperations();\n```\n\n#### Web3 1.2.6\n```js\nconst operations = await gov.methods.proposalMaxOperations().call();\n```\n</section>\n\n<section id="voting-delay" name="Voting Delay">\n## Voting Delay\n\nThe number of Ethereum blocks to wait before voting on a proposal may begin. This value is added to the current block number when a proposal is created.\n\n#### Governor Alpha\n```solc\nfunction votingDelay() returns (uint)\n```\n\n* `RETURN`: Number of blocks to wait before voting on a proposal may begin.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint blocks = gov.votingDelay();\n```\n\n#### Web3 1.2.6\n```js\nconst blocks = await gov.methods.votingDelay().call();\n```\n</section>\n\n<section id="voting-period" name="Voting Period">\n## Voting Period\n\nThe duration of voting on a proposal, in Ethereum blocks.\n\n#### Governor Alpha\n```solc\nfunction votingPeriod() returns (uint)\n```\n\n* `RETURN`: The duration of voting on a proposal, in Ethereum blocks.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint blocks = gov.votingPeriod();\n```\n\n#### Web3 1.2.6\n```js\nconst blocks = await gov.methods.votingPeriod().call();\n```\n</section>\n\n<section id="propose" name="Propose">\n## Propose\n\nCreate a Proposal to change the protocol. E.g., A proposal can set a cToken\'s interest rate model or risk parameters on the Comptroller.\n\nProposals will be voted on by delegated voters. If there is sufficient support before the voting period ends, the proposal shall be automatically enacted. Enacted proposals are queued and executed in the Compound Timelock contract.\n\nThe sender must hold more COMP than the current proposal threshold (`proposalThreshold()`) as of the immediately previous block. If the threshold is 100,000 COMP, the sender must have been delegated more than 1% of all COMP in order to create a proposal. The proposal can have up to 10 actions (based on `proposalMaxOperations()`).\n\nThe proposer cannot create another proposal if they currently have a pending or active proposal. It is not possible to queue two identical actions in the same block (due to a restriction in the Timelock), therefore actions in a single proposal must be unique, and unique proposals that share an identical action must be queued in different blocks.\n\n#### Governor Alpha\n```solc\nfunction propose(address[] memory targets, uint[] memory values, string[] memory signatures, bytes[] memory calldatas, string memory description) returns (uint)\n```\n\n* `targets`: The ordered list of target addresses for calls to be made during proposal execution. This array must be the same length as all other array parameters in this function.\n* `values`: The ordered list of values (i.e. msg.value) to be passed to the calls made during proposal execution. This array must be the same length as all other array parameters in this function.\n* `signatures`: The ordered list of function signatures to be passed during execution. This array must be the same length as all other array parameters in this function.\n* `calldatas`: The ordered list of data to be passed to each individual function call during proposal execution. This array must be the same length as all other array parameters in this function.\n* `description`: A human readable description of the proposal and the changes it will enact.\n* `RETURN`: The ID of the newly created proposal.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint proposalId = gov.propose(targets, values, signatures, calldatas, description);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = gov.methods.propose(targets, values, signatures, calldatas, description).send({ from: sender });\n```\n</section>\n\n<section id="queue" name="Queue">\n## Queue\n\nAfter a proposal has succeeded, any address can call the queue method to move the proposal into the Timelock queue. A proposal can only be queued if it has succeeded.\n\n#### Governor Alpha\n```solc\nfunction queue(uint proposalId)\n```\n\n* `proposalId`: ID of a proposal that has succeeded.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\ngov.queue(proposalId);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = gov.methods.queue(proposalId).send({ from: sender });\n```\n</section>\n\n<section id="execute" name="Execute">\n## Execute\n\nAfter the Timelock delay period, any account may invoke the execute method to apply the changes from the proposal to the target contracts. This will invoke each of the actions described in the proposal.\n\nThis function is payable so the Timelock contract can invoke payable functions that were selected in the proposal. E.g., A proposal can add reserves to a market like cETH, set a cToken\'s interest rate model, or set risk parameters on the Comptroller.\n\n#### Governor Alpha\n```solc\nfunction execute(uint proposalId) payable returns (uint)\n```\n\n* `proposalId`: ID of a succeeded proposal to execute.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\ngov.execute(proposalId).value(999).gas(999)();\n```\n\n#### Web3 1.2.6\n```js\nconst tx = gov.methods.execute(proposalId).send({ from: sender, value: 1 });\n```\n</section>\n\n<section id="cancel" name="Cancel">\n## Cancel\n\nCancel a proposal that has not yet been executed. The Guardian is the only one who may execute this unless the proposer does not maintain the delegates required to create a proposal. If the proposer does not have more delegates than the proposal threshold, anyone can cancel the proposal.\n\n#### Governor Alpha\n```solc\nfunction cancel(uint proposalId)\n```\n\n* `proposalId`: ID of a proposal to cancel. The proposal cannot have already been executed.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\ngov.cancel(proposalId);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = gov.methods.cancel(proposalId).send({ from: sender });\n```\n</section>\n\n<section id="get-actions" name="Get Actions">\n## Get Actions\n\nGets the actions of a selected proposal. Pass a proposal ID and get the targets, values, signatures and calldatas of that proposal.\n\n#### Governor Alpha\n```solc\nfunction getActions(uint proposalId) returns (uint proposalId) public view returns (address[] memory targets, uint[] memory values, string[] memory signatures, bytes[] memory calldatas)\n```\n\n* `proposalId`: ID of a proposal in which to get its actions.\n* `RETURN`: Reverts if the proposal ID is invalid. If successful, the following 4 references are returned.\n1. Array of addresses of contracts the proposal calls.\n2. Array of unsigned integers the proposal uses as values.\n3. Array of strings of the proposal’s signatures.\n4. Array of calldata bytes of the proposal.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nuint proposalId = 123;\n(address[] memory targets, uint[] memory values, string[] memory signatures, bytes[] memory calldatas) = gov.getActions(proposalId);\n```\n\n#### Web3 1.2.6\n```js\nconst {0: targets, 1: values, 2: signatures, 3: calldatas} = gov.methods.getActions(proposalId).call();\n```\n</section>\n\n<section id="get-receipt" name="Get Receipt">\n## Get Receipt\n\nGets a proposal ballot receipt of the indicated voter.\n\n#### Governor Alpha\n```solc\nfunction getReceipt(uint proposalId, address voter) returns (Receipt memory)\n```\n\n* `proposalId`: ID of the proposal in which to get a voter’s ballot receipt.\n* `voter`: Address of the account of a proposal voter.\n* `RETURN`: Reverts on error. If successful, returns a Receipt struct for the ballot of the voter address.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nReceipt ballot = gov.getReceipt(proposalId, voterAddress);\n```\n\n#### Web3 1.2.6\n```js\nconst proposalId = 11;\nconst voterAddress = \'0x123...\';\nconst result = await gov.methods.getReceipt(proposalId, voterAddress).call();\nconst { hasVoted, support, votes } = result;\n```\n</section>\n\n<section id="state" name="State">\n## State\n\nGets the proposal state for the specified proposal. The return value, `ProposalState` is an enumerated type defined in the Governor Alpha contract.\n\n#### Governor Alpha\n```solc\nfunction state(uint proposalId) returns (ProposalState)\n```\n\n* `proposalId`: ID of a proposal in which to get its state.\n* `RETURN`: Enumerated type ProposalState. The types are Pending, Active, Canceled, Defeated, Succeeded, Queued, Expired, andExecuted.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\nGovernorAlpha.ProposalState state = gov.state(123);\n```\n\n#### Web3 1.2.6\n```js\nconst proposalStates = [\'Pending\', \'Active\', \'Canceled\', \'Defeated\', \'Succeeded\', \'Queued\', \'Expired\', \'Executed\'];\nconst proposalId = 123;\nresult = await gov.methods.state(proposalId).call();\nconst proposalState = proposalStates[result];\n```\n</section>\n\n<section id="cast-vote" name="Cast Vote">\n## Cast Vote\n\nCast a vote on a proposal. The account\'s voting weight is determined by the number of votes the account had delegated to it at the time the proposal state became active.\n\n#### Governor Alpha\n```solc\nfunction castVote(uint proposalId, bool support)\n```\n\n* `proposalId`: ID of a proposal in which to cast a vote.\n* `support`: A boolean of true for \'yes\' or false for \'no\' on the proposal vote.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\ngov.castVote(proposalId, true);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = gov.methods.castVote(proposalId, false).send({ from: sender });\n```\n</section>\n\n<section id="cast-vote-by-signature" name="Cast Vote By Signature">\n## Cast Vote By Signature\n\nCast a vote on a proposal. The account\'s voting weight is determined by the number of votes the account had delegated at the time that proposal state became active. This method has the same purpose as Cast Vote but it instead enables offline signatures to participate in Compound governance voting. For more details on how to create an offline signature, review [EIP-712](https://eips.ethereum.org/EIPS/eip-712).\n\n#### Governor Alpha\n```solc\nfunction castVoteBySig(uint proposalId, bool support, uint8 v, bytes32 r, bytes32 s)\n```\n\n* `proposalId`: ID of a proposal in which to cast a vote.\n* `support`: A boolean of true for \'yes\' or false for \'no\' on the proposal vote.\n* `v`: The recovery byte of the signature.\n* `r`: Half of the ECDSA signature pair.\n* `s`: Half of the ECDSA signature pair.\n* `RETURN`: No return, reverts on error.\n\n#### Solidity\n```solc\nGovernorAlpha gov = GovernorAlpha(0x123...); // contract address\ngov.castVoteBySig(proposalId, true, v, r, s);\n```\n\n#### Web3 1.2.6\n```js\nconst tx = await gov.methods.castVoteBySig(proposalId, false, v, r, s).send({});\n```\n</section>\n\n<section id="timelock" name="Timelock">\n## Timelock\n\nEach cToken contract and the Comptroller contract allow the Timelock address to modify them. The Timelock contract can modify system parameters, logic, and contracts in a \'time-delayed, opt-out\' upgrade pattern.\n\nThe Timelock has a hard-coded minimum delay of 2 days, which is the least amount of notice possible for a governance action. Each proposed action will be published at a minimum of 2 days in the future from the time of announcement. Major upgrades, such as changing the risk system, may have a 14 day delay.\n\nThe Timelock is controlled by the governance module; pending and completed governance actions can be monitored on the [Timelock Dashboard](https://app.compound.finance/timelock).\n</section>\n\n<section id="pause-guardian" name="Pause Guardian">\n## Pause Guardian\n\nThe Comptroller contract designates a Pause Guardian address capable of disabling protocol functionality. Used only in the event of an unforeseen vulnerability, the Pause Guardian has one and only one ability: to disable a select set of functions: Mint, Borrow, Transfer, and Liquidate. The Pause Guardian cannot unpause an action, nor can it ever prevent users from calling Redeem, or Repay Borrow to close positions and exit the protocol.\n\nCOMP token-holders designate the Pause Guardian address, which is currently held by Compound Labs, Inc.\n</section>\n    ';
var $author$project$LandingSite$Docs$OpenPriceFeedDoc$doc = '\n<section id="introduction" name="Introduction">\n# Open Price Feed\n\n## Introduction\nThe Open Price Feed allows Reporters to sign price data using a known public key, which Posters (any Ethereum address) can submit on-chain.\nThe protocol codebase is hosted on [GitHub](https://github.com/compound-finance/open-oracle), and maintained by the community.\n\nCoinbase Pro is the first Reporter using the Open Price Feed format, signing prices every few minutes for assets traded on the exchange.\nAdditional exchanges are developing their own Reporters for their own trading pairs, and new views can be deployed to use their prices.\n\n```pseudo-table:key-events-table\n| Reporter Endpoint | Reporter Key | Supported Tokens\n|----|-------|-------|\n| [Coinbase Pro](https://docs.pro.coinbase.com/#oracle) | `0xfCEAdAFab14d46e20144F48824d0C09B1a03F2BC` | `BTC`, `ETH`, `DAI`, `REP`, `ZRX`, `BAT`, `KNC`, `LINK`, `COMP`\n| [OKEx](https://www.okex.com/api/market/v3/oracle)* | `0x419c555b739212684432050b7ce459ea8e7b8bda` | `BTC`, `ETH`\n```\n\nThe above endpoints are also mirrored at `prices.compound.finance`.\n\n\u000D* Signing and publishing prices, but not yet a designated reporter in `UniswapAnchoredView`.\n\nThe Compound Protocol uses a View contract ("Price Feed") which verifies that reported prices fall within an acceptable bound of the time-weighted average price of the token/ETH pair on Uniswap v2, a sanity check referred to as the Anchor price.\nThe contracts can be found on-chain as follows:\n\n```pseudo-table:key-events-table\n| Contract name | address |\n|---------------|---------|\n| OpenOraclePriceData | [0xc629c26dced4277419cde234012f8160a0278a79](https://etherscan.io/address/0xc629c26dced4277419cde234012f8160a0278a79) |\n| UniswapAnchoredView | [0x9b8eb8b3d6e2e0db36f41455185fef7049a35cae](https://etherscan.io/address/0x9b8eb8b3d6e2e0db36f41455185fef7049a35cae) |\n```\n\n</section>\n\n<section id="architecture" name="Architecture">\n## Architecture\nThe Open Price Feed consists of two main contracts.\n* `OpenOraclePriceData` is a neutral price storage contract that stores prices signed by any address.\n* `UniswapAnchoredView` only stores prices that are within an acceptable bound of the Uniswap time-weighted average price and are signed by a reporter. Also contains logic that upscales the posted prices into the format that Compound\'s Comptroller expects.\n\nThis architecture allows multiple views to use the same underlying price data, but to verify the prices in their own way.\n\n</section>\n\n<section id="post-prices" name="Post Prices">\n## Post Prices\nPosts an array of prices to `OpenOraclePriceData` and saves them to `UniswapAnchoredView` if the prices are within a bound of the anchor price and are signed by a reporter. Prices are expected to be in USD with 6 decimals of precision.\n\n* `messages[]`: The array of prices to sign. Each message is a `bytes[]` with the format: `(string memory kind, uint64 timestamp, string memory key, uint64 value)`\n* `signatures[]`: An array of signatures corresponding to the messages. Each signature is a `bytes[]` with the format `(bytes32 r, bytes32 s, uint8 v)`.\n* `symbols[]`: An array of symbols corresponding to the price messages.\n\n```note\nPost prices manually from the browser with this [notebook](https://observablehq.com/@jflatow/compound-price-feed).\n```\n\n#### UniswapAnchoredView\n```solc\nfunction postPrices(bytes[] calldata messages, bytes[] calldata signatures, string[] calldata symbols)\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nconst res = await fetch("https://prices.compound.finance");\nconst {coinbase, okex} = await res.json();\nconst symbols = [\'BTC\', \'ETH\', \'DAI\', \'REP\', \'ZRX\', \'BAT\', \'KNC\', \'LINK\', \'COMP\'];\nawait view.methods.postPrices(coinbase.messages, coinbase.signatures, symbols).send({from: ...});\n```\n</section>\n\n<section id="price" name="Get Price">\n## Price\nGet the most recent price for a token in USD with 6 decimals of precision.\n* `symbol`: Symbol as a string\n\n#### UniswapAnchoredView\n```solc\nfunction price(string memory symbol) external view returns (uint)\n```\n\n#### Solidity\n```solc\nUniswapAnchoredView view = UniswapAnchoredView(0xABCD...)\nuint price = view.price("ETH");\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\n//eg: returns 200e6\nconst price = await view.methods.price("ETH").call();\n```\n</section>\n\n<section id="config" name="Get Config">\n## Config\n\nEach token the Open Price Feed supports needs corresponding configuration metadata. The configuration for each token is set in the constructor and is immutable.\n\nThe fields of the config are:\n* `cToken`: The address of the underlying token\'s corresponding cToken. This field is null for tokens that are not supported as cTokens.\n* `underlying`: Address of the token whose price is being reported.\n* `symbolHash`: The `keccak256` of the byte-encoded string of the token\'s symbol.\n* `baseUnit`: The number of decimals of precision that the underlying token has. Eg: USDC has 6 decimals.\n* `PriceSource`: An enum describing the whether or not to special case the prices for this token. `FIXED_ETH` is used to set the SAI price to a fixed amount of ETH, and `FIXED_USD` is used to peg stablecoin prices to $1. `REPORTER` is used for all other assets to indicate the reported prices and Uniswap anchoring should be used.\n* `fixedPrice`: The fixed dollar amount to use if `PriceSource` is `FIXED_USD` or the number of ETH in the case of `FIXED_ETH` (namely for SAI).\n* `uniswapMarket`: The token\'s market on Uniswap, used for price anchoring. Only filled if `PriceSource` is `REPORTER`.\n* `isUniswapReversed`: A boolean indicating the order of the market\'s reserves.\n\n#### UniswapAnchoredView\n```solc\n function getTokenConfigBySymbol(string memory symbol) public view returns (TokenConfig memory)\n function getTokenConfigBySymbolHash(bytes32 symbolHash) public view returns (TokenConfig memory)\n function getTokenConfigByCToken(address cToken) public view returns (TokenConfig memory)\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nconst config = await view.methods.getTokenConfigBySymbol("ETH").call();\n```\n\n#### Solidity\n```solc\nUniswapAnchoredView view = UniswapAnchoredView(0xABCD...)\nuint price = view.getTokenConfigBySymbol("ETH");\n```\n\n</section>\n\n<section id="invalidate" name="Invalidate Reporter">\n## Invalidate Reporter\n\nPosts a message signed by the reporter that invalidates the reporter\'s prices and causes the anchor price to be used directly instead. To be used in cases of emergency, if the reporter thinks their key may be compromised. Any Ethereum address can send the invalidation message.\n\n* `message`: The invalidation message\n* `signature`: A signature of the invalidation message\n\n####UniswapAnchoredView\n```solc\nfunction invalidateReporter(bytes memory message, bytes memory signature) external\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nawait view.methods.invalidateReporter(message, signature).call();\n```\n\n</section>\n\n<section id="reporter" name="Get Reporter">\n## Reporter\n\nGet the reporter\'s address. Currently Coinbase Pro\'s address.\n\n####UniswapAnchoredView\n```solc\nfunction reporter() returns (uint)\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nconst reporter = await view.methods.reporter().call();\n\n```\n\n#### Solidity\n```solc\nUniswapAnchoredView view = UniswapAnchoredView(0xABCD...)\nuint reporter = view.reporter();\n```\n\n</section>\n\n<section id="anchor-period" name="Get Anchor Period">\n## Anchor Period\n\nGet the anchor period, the minimum amount of time in seconds over which to take the time-weighted average price from Uniswap.\n\n####UniswapAnchoredView\n```solc\nfunction anchorPeriod() returns (uint)\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nconst anchorPeriod = await view.methods.anchorPeriod().call();\n```\n\n#### Solidity\n```solc\nUniswapAnchoredView view = UniswapAnchoredView(0xABCD...)\nuint anchorPeriod = view.anchorPeriod();\n```\n\n</section>\n\n<section id="anchor-bounds" name="Get Anchor Bounds">\n## Anchor Bounds\n\nGet the highest and lowest ratio of the reported price to the anchor price that will still trigger the price to be updated. Given in 18 decimals of precision (eg: 90% => 90e16).\n\n####UniswapAnchoredView\n```solc\nfunction upperBoundAnchorRatio() returns (uint)\nfunction lowerBoundAnchorRatio() returns (uint)\n```\n\n#### Web3 1.0\n```js\nconst view = UniswapAnchoredView.at(0xABCD...);\nconst upperBoundRatio = await view.methods.upperBoundAnchorRatio().call();\n\n```\n\n#### Solidity\n```solc\nUniswapAnchoredView view = UniswapAnchoredView(0xABCD...)\nuint upperBoundRatio = view.upperBoundAnchorRatio();\n```\n\n</section>\n    ';
var $author$project$Strings$Translations$docs_governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance';
		case 1:
			return 'Governance';
		case 2:
			return 'Governance';
		case 3:
			return 'Governance';
		default:
			return 'Governance';
	}
};
var $author$project$Strings$Translations$docs_open_price_feed = function (lang) {
	switch (lang) {
		case 0:
			return 'Open Price Feed';
		case 1:
			return 'Open Price Feed';
		case 2:
			return 'Open Price Feed';
		case 3:
			return 'Open Price Feed';
		default:
			return 'Open Price Feed';
	}
};
var $author$project$Utils$CompoundHtmlAttributes$Internal = 1;
var $author$project$LandingSite$Docs$CopyMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$Docs$SelectNetwork = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Bootstrap$Carousel$Config = $elm$core$Basics$identity;
var $author$project$Bootstrap$Carousel$config = F2(
	function (toMsg, attributes) {
		return {hm: attributes, e0: false, fx: false, ey: _List_Nil, dp: toMsg};
	});
var $author$project$Bootstrap$Carousel$SlideInternal$Config = $elm$core$Basics$identity;
var $author$project$Bootstrap$Carousel$Slide$config = F2(
	function (attributes, content) {
		return {hm: attributes, hv: $elm$core$Maybe$Nothing, kU: content};
	});
var $author$project$Bootstrap$Carousel$SlideInternal$Custom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Bootstrap$Carousel$Slide$customContent = function (html) {
	return $author$project$Bootstrap$Carousel$SlideInternal$Custom(
		{lv: html});
};
var $author$project$Utils$CompoundHtmlAttributes$property = F2(
	function (propertyName, propertyValue) {
		return A2($elm$html$Html$Attributes$attribute, propertyName, propertyValue);
	});
var $author$project$Bootstrap$Carousel$slides = F2(
	function (newSlides, _v0) {
		var settings = _v0;
		return _Utils_update(
			settings,
			{ey: newSlides});
	});
var $author$project$Bootstrap$Carousel$EndTransition = function (a) {
	return {$: 4, a: a};
};
var $author$project$Bootstrap$Carousel$SetHover = function (a) {
	return {$: 5, a: a};
};
var $author$project$Bootstrap$Carousel$controlNext = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('btn btn-link carousel-control-next'),
			A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
			$elm$html$Html$Events$onClick(
			$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Next))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-control-next-icon'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Next')
				]))
		]));
var $author$project$Bootstrap$Carousel$Prev = {$: 1};
var $author$project$Bootstrap$Carousel$controlPrev = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('btn btn-link carousel-control-prev'),
			$elm$html$Html$Events$onClick(
			$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Prev))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-control-prev-icon'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Previous')
				]))
		]));
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Bootstrap$Carousel$dirtyHack = function (size) {
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dirtyHack',
				A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'load',
							$elm$json$Json$Decode$succeed(
								$author$project$Bootstrap$Carousel$EndTransition(size))),
							$elm$html$Html$Attributes$src('https://package.elm-lang.org/assets/favicon.ico'),
							A2($elm$html$Html$Attributes$style, 'display', 'none')
						]),
					_List_Nil))
			]));
};
var $author$project$Bootstrap$Carousel$indicators = F2(
	function (size, activeIndex) {
		var item = function (n) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								_Utils_eq(n, activeIndex))
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Bootstrap$Carousel$StartTransition(
							$author$project$Bootstrap$Carousel$Number(n)))
					]),
				_List_Nil);
		};
		var items = A2(
			$elm$core$List$map,
			item,
			A2($elm$core$List$range, 0, size - 1));
		return A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-indicators')
				]),
			items);
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Bootstrap$Carousel$SlideInternal$addAttributes = F2(
	function (newAttributes, _v0) {
		var settings = _v0;
		return _Utils_update(
			settings,
			{
				hm: _Utils_ap(settings.hm, newAttributes)
			});
	});
var $author$project$Bootstrap$Carousel$transitionClassNames = F2(
	function (currentIndex, transition) {
		var base = 'carousel-item';
		var leftNext = {dZ: base + '-left', el: base + '-next'};
		var rightPrev = {dZ: base + '-right', el: base + '-prev'};
		switch (transition.$) {
			case 0:
				return leftNext;
			case 2:
				var n = transition.a;
				return (_Utils_cmp(n, currentIndex) > 0) ? leftNext : rightPrev;
			default:
				return rightPrev;
		}
	});
var $author$project$Bootstrap$Carousel$transitionClasses = F4(
	function (index, currentIndex, newIndex, tstage) {
		if (_Utils_eq(index, currentIndex)) {
			switch (tstage.$) {
				case 2:
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true)
						]);
				case 0:
					var transition = tstage.a;
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true)
						]);
				default:
					var transition = tstage.a;
					var _v1 = A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition);
					var directionalClassName = _v1.dZ;
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true),
							_Utils_Tuple2(directionalClassName, true)
						]);
			}
		} else {
			if (_Utils_eq(index, newIndex)) {
				switch (tstage.$) {
					case 2:
						return _List_Nil;
					case 0:
						var transition = tstage.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								function ($) {
									return $.el;
								}(
									A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition)),
								true)
							]);
					default:
						var transition = tstage.a;
						var _v3 = A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition);
						var directionalClassName = _v3.dZ;
						var orderClassName = _v3.el;
						return _List_fromArray(
							[
								_Utils_Tuple2(directionalClassName, true),
								_Utils_Tuple2(orderClassName, true)
							]);
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Bootstrap$Carousel$SlideInternal$view = function (_v0) {
	var attributes = _v0.hm;
	var content = _v0.kU;
	var caption = _v0.hv;
	var captionHtml = function () {
		if (caption.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var rec = caption.a;
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					rec.hm,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carousel-caption d-none d-md-block')
						])),
				rec.kL);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			attributes,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-item')
				])),
		function () {
			if (!content.$) {
				var rec = content.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_Utils_ap(
							rec.hm,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('d-block img-fluid'),
									$elm$html$Html$Attributes$src(rec.mJ)
								])),
						_List_Nil),
						captionHtml
					]);
			} else {
				var html = content.a.lv;
				return _List_fromArray(
					[html, captionHtml]);
			}
		}());
};
var $author$project$Bootstrap$Carousel$viewSlide = F3(
	function (model, index, slide) {
		var tstage = model.a;
		var currentIndex = model.b.a9;
		var size = model.b.by;
		var newIndex = A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size);
		return $author$project$Bootstrap$Carousel$SlideInternal$view(
			A2(
				$author$project$Bootstrap$Carousel$SlideInternal$addAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						A4($author$project$Bootstrap$Carousel$transitionClasses, index, currentIndex, newIndex, tstage))
					]),
				slide));
	});
var $author$project$Bootstrap$Carousel$view = F2(
	function (model, _v0) {
		var tstage = model.a;
		var hovering = model.b.cY;
		var currentIndex = model.b.a9;
		var wrap = model.b.bE;
		var settings = _v0;
		var slidesHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-inner'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox')
				]),
			A2(
				$elm$core$List$indexedMap,
				$author$project$Bootstrap$Carousel$viewSlide(model),
				settings.ey));
		var size = $elm$core$List$length(settings.ey);
		var indicatorsHtml = settings.fx ? A2(
			$author$project$Bootstrap$Carousel$indicators,
			size,
			A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size)) : $elm$html$Html$text('');
		var defaultCarouselAttributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel slide'),
					A2(
					$elm$html$Html$Events$on,
					'transitionend',
					$elm$json$Json$Decode$succeed(
						settings.dp(
							$author$project$Bootstrap$Carousel$EndTransition(size))))
				]),
			(hovering !== 2) ? _List_fromArray(
				[
					$elm$html$Html$Events$onMouseEnter(
					settings.dp(
						$author$project$Bootstrap$Carousel$SetHover(0))),
					$elm$html$Html$Events$onMouseLeave(
					settings.dp(
						$author$project$Bootstrap$Carousel$SetHover(1)))
				]) : _List_Nil);
		var controlsHtml = settings.e0 ? ((wrap || ((!(!currentIndex)) && (!_Utils_eq(currentIndex, size - 1)))) ? _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlPrev, $author$project$Bootstrap$Carousel$controlNext]) : ((!currentIndex) ? _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlNext]) : _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlPrev]))) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(settings.hm, defaultCarouselAttributes),
			A2(
				$elm$core$List$cons,
				slidesHtml,
				A2(
					$elm$core$List$map,
					$elm$html$Html$map(settings.dp),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Bootstrap$Carousel$dirtyHack(size),
								indicatorsHtml
							]),
						controlsHtml))));
	});
var $author$project$LandingSite$Docs$contractsView = F2(
	function (_v0, configs) {
		var networksCarouselState = _v0.aS;
		var selectedNetwork = _v0.ev;
		var networkSortOrder = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('mainnet', 1),
					_Utils_Tuple2('rinkeby', 2),
					_Utils_Tuple2('kovan', 3),
					_Utils_Tuple2('ropsten', 4),
					_Utils_Tuple2('goerli', 5)
				]));
		var networkList = _List_fromArray(
			[1, 4, 7, 3, 5]);
		var networkTabs = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, network) {
					var name = $author$project$Network$networkName(network);
					var active = _Utils_eq(network, selectedNetwork) ? ' tab-group__option--active' : '';
					return A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__option' + active),
								$elm$html$Html$Events$onClick(
								A2($author$project$LandingSite$Docs$SelectNetwork, network, index))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]));
				}),
			networkList);
		var nameToNetwork = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('mainnet', 1),
					_Utils_Tuple2('rinkeby', 4),
					_Utils_Tuple2('kovan', 7),
					_Utils_Tuple2('ropsten', 3),
					_Utils_Tuple2('goerli', 5)
				]));
		var configsSorter = F2(
			function (a, b) {
				var bValue = A2(
					$elm$core$Maybe$withDefault,
					999,
					A2($elm$core$Dict$get, b.a, networkSortOrder));
				var aValue = A2(
					$elm$core$Maybe$withDefault,
					999,
					A2($elm$core$Dict$get, a.a, networkSortOrder));
				return A2($elm$core$Basics$compare, aValue, bValue);
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('tab-group networks-tab-group')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__options')
							]),
						networkTabs),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__line')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('networks-carousel')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Bootstrap$Carousel$view,
						networksCarouselState,
						A2(
							$author$project$Bootstrap$Carousel$slides,
							_Utils_ap(
								_List_Nil,
								A2(
									$elm$core$List$filterMap,
									function (_v1) {
										var networkName = _v1.a;
										var maybeNetworkConfig = _v1.b;
										if (!maybeNetworkConfig.$) {
											var networkConfig = maybeNetworkConfig.a;
											var maybeNetwork = A2($elm$core$Dict$get, networkName, nameToNetwork);
											return $elm$core$Maybe$Just(
												A2(
													$author$project$Bootstrap$Carousel$Slide$config,
													_List_Nil,
													$author$project$Bootstrap$Carousel$Slide$customContent(
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('tab'),
																	A2($author$project$Utils$CompoundHtmlAttributes$property, 'data-network', networkName)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$table,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('networks-table')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$thead,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$tr,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Contract')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('ABI')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Address')
																								]))
																						]))
																				])),
																			A2(
																			$elm$html$Html$tbody,
																			_List_Nil,
																			_Utils_ap(
																				_List_Nil,
																				_Utils_ap(
																					A2(
																						$elm$core$List$map,
																						function (_v3) {
																							var cTokenSymbol = _v3.a;
																							var cTokenConfig = _v3.b;
																							var contractType = (cTokenSymbol === 'cETH') ? 'cEther' : 'cToken';
																							var addressString = $author$project$Eth$Ethereum$getContractAddressString(cTokenConfig.hd);
																							return A2(
																								$elm$html$Html$tr,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('ctoken-contract')
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$elm$html$Html$td,
																										_List_fromArray(
																											[
																												$author$project$Utils$CompoundHtmlAttributes$class('contract')
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + cTokenSymbol)
																													]),
																												_List_Nil),
																												A2(
																												$elm$html$Html$span,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('token-symbol')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(cTokenSymbol)
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('token-badge')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(contractType)
																													]))
																											])),
																										A2(
																										$elm$html$Html$td,
																										_List_fromArray(
																											[
																												$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$a,
																												A2(
																													$author$project$Utils$CompoundHtmlAttributes$href,
																													0,
																													$author$project$LandingSite$Page$getHrefUrl(
																														A2($author$project$LandingSite$Page$DocsABIView, networkName, cTokenSymbol))),
																												_List_fromArray(
																													[
																														$elm$html$Html$text('JSON')
																													]))
																											])),
																										A2(
																										$elm$html$Html$td,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$id(cTokenSymbol + '_contract_address'),
																														$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text(
																																A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																															])),
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text(addressString)
																															])),
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																$elm$html$Html$Events$onClick(
																																$author$project$LandingSite$Docs$CopyMsg(addressString))
																															]),
																														_List_Nil),
																														A4(
																														$author$project$Eth$Ethereum$etherscanLink,
																														maybeNetwork,
																														$author$project$Eth$Ethereum$TokenAddress(addressString),
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																	]),
																																_List_Nil)
																															]))
																													]))
																											]))
																									]));
																						},
																						$elm$core$Dict$toList(networkConfig.hu)),
																					_Utils_ap(
																						A2(
																							$elm$core$List$filterMap,
																							function (_v4) {
																								var contractName = _v4.a;
																								var contractAddress = _v4.b;
																								var addressString = $author$project$Eth$Ethereum$getContractAddressString(contractAddress);
																								switch (contractName) {
																									case 'Comptroller':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Comptroller')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DocsABIView, networkName, 'Comptroller'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Docs$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'Timelock':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Timelock')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DocsABIView, networkName, 'Timelock'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Docs$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'Comp':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('COMP')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DocsABIView, networkName, 'Comp'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Docs$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'GovernorAlpha':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Governance')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DocsABIView, networkName, 'GovernorAlpha'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Docs$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									default:
																										return $elm$core$Maybe$Nothing;
																								}
																							},
																							$elm$core$Dict$toList(networkConfig.hN)),
																						A2(
																							$elm$core$List$filterMap,
																							function (_v6) {
																								var modelRealName = _v6.a;
																								var modelConfig = _v6.b;
																								var userFriendlyRateModelName = (modelRealName === 'DSR_Updateable') ? 'DAI Rate Model' : ((modelRealName === 'Base200bps_Slope2000bps_Jump20000bps_Kink90') ? 'USDT Rate Model' : modelRealName);
																								var addressString = $author$project$Eth$Ethereum$getContractAddressString(modelConfig.hd);
																								return ((modelRealName === 'Base200bps_Slope222bps_Kink90_Jump40') || ((modelRealName === 'Base200bps_Slope2000bps_Jump20000bps_Kink90_bad') || ((modelRealName === 'Base200bps_Slope2000bps_Jump20000bps_Kink90_bad_2') || ((modelRealName === 'DSR_Kink_9000bps_Jump_12000bps_AssumedRF_500bps') || (modelRealName === 'DSR_Kink_9000bps_Jump_12000bps_AssumedRF_20000bps'))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
																									A2(
																										$elm$html$Html$tr,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$td,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('contract')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(userFriendlyRateModelName)
																													])),
																												A2(
																												$elm$html$Html$td,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$a,
																														A2(
																															$author$project$Utils$CompoundHtmlAttributes$href,
																															0,
																															$author$project$LandingSite$Page$getHrefUrl(
																																A2($author$project$LandingSite$Page$DocsABIView, networkName, modelRealName))),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('JSON')
																															]))
																													])),
																												A2(
																												$elm$html$Html$td,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$id(modelRealName + '_contract_address'),
																																$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																	]),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text(
																																		A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																	])),
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																	]),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text(addressString)
																																	])),
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																		$elm$html$Html$Events$onClick(
																																		$author$project$LandingSite$Docs$CopyMsg(addressString))
																																	]),
																																_List_Nil),
																																A4(
																																$author$project$Eth$Ethereum$etherscanLink,
																																maybeNetwork,
																																$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																			]),
																																		_List_Nil)
																																	]))
																															]))
																													]))
																											])));
																							},
																							$elm$core$Dict$toList(networkConfig.lD))))))
																		]))
																])))));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									A2(
										$elm$core$List$sortWith,
										configsSorter,
										$elm$core$Dict$toList(configs)))),
							A2(
								$author$project$Bootstrap$Carousel$config,
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Docs$NetworkCarouselMsg),
								_List_Nil)))
					]))
			]);
	});
var $author$project$Strings$Translations$docs_gas_costs_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
		case 1:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
		case 2:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
		case 3:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
		default:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'account liquidity';
		case 2:
			return 'account liquidity';
		case 3:
			return 'account liquidity';
		default:
			return 'account liquidity';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ', have gas costs that increase with the number of ';
		case 1:
			return ', have gas costs that increase with the number of ';
		case 2:
			return ', have gas costs that increase with the number of ';
		case 3:
			return ', have gas costs that increase with the number of ';
		default:
			return ', have gas costs that increase with the number of ';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'entered markets';
		case 1:
			return 'entered markets';
		case 2:
			return 'entered markets';
		case 3:
			return 'entered markets';
		default:
			return 'entered markets';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
		case 1:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
		case 2:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
		case 3:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
		default:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_link1 = function (lang) {
	switch (lang) {
		case 0:
			return '(Feb 2019)';
		case 1:
			return '(Feb 2019)';
		case 2:
			return '(Feb 2019)';
		case 3:
			return '(Feb 2019)';
		default:
			return '(Feb 2019)';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_link2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Github';
		case 1:
			return 'Github';
		case 2:
			return 'Github';
		case 3:
			return 'Github';
		default:
			return 'Github';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'These docs are a comprehensive guide to the Compound protocol, based on the Compound Whitepaper ';
		case 1:
			return 'These docs are a comprehensive guide to the Compound protocol, based on the Compound Whitepaper ';
		case 2:
			return 'These docs are a comprehensive guide to the Compound protocol, based on the Compound Whitepaper ';
		case 3:
			return 'These docs are a comprehensive guide to the Compound protocol, based on the Compound Whitepaper ';
		default:
			return 'These docs are a comprehensive guide to the Compound protocol, based on the Compound Whitepaper ';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_part2 = function (lang) {
	switch (lang) {
		case 0:
			return '. The protocol codebase is hosted on ';
		case 1:
			return '. The protocol codebase is hosted on ';
		case 2:
			return '. The protocol codebase is hosted on ';
		case 3:
			return '. The protocol codebase is hosted on ';
		default:
			return '. The protocol codebase is hosted on ';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ', and maintained by the community.';
		case 1:
			return ', and maintained by the community.';
		case 2:
			return ', and maintained by the community.';
		case 3:
			return ', and maintained by the community.';
		default:
			return ', and maintained by the community.';
	}
};
var $author$project$Strings$Translations$docs_guides = function (lang) {
	switch (lang) {
		case 0:
			return 'Guides';
		case 1:
			return 'Guides';
		case 2:
			return 'Guides';
		case 3:
			return 'Guides';
		default:
			return 'Guides';
	}
};
var $author$project$Strings$Translations$docs_guides_01 = function (lang) {
	switch (lang) {
		case 0:
			return 'Setting up an Ethereum Development Environment';
		case 1:
			return 'Setting up an Ethereum Development Environment';
		case 2:
			return 'Setting up an Ethereum Development Environment';
		case 3:
			return 'Setting up an Ethereum Development Environment';
		default:
			return 'Setting up an Ethereum Development Environment';
	}
};
var $author$project$Strings$Translations$docs_guides_02 = function (lang) {
	switch (lang) {
		case 0:
			return 'Supplying Assets to the Compound Protocol';
		case 1:
			return 'Supplying Assets to the Compound Protocol';
		case 2:
			return 'Supplying Assets to the Compound Protocol';
		case 3:
			return 'Supplying Assets to the Compound Protocol';
		default:
			return 'Supplying Assets to the Compound Protocol';
	}
};
var $author$project$Strings$Translations$docs_guides_03 = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrowing Assets from the Compound Protocol';
		case 1:
			return 'Borrowing Assets from the Compound Protocol';
		case 2:
			return 'Borrowing Assets from the Compound Protocol';
		case 3:
			return 'Borrowing Assets from the Compound Protocol';
		default:
			return 'Borrowing Assets from the Compound Protocol';
	}
};
var $author$project$Strings$Translations$docs_guides_04 = function (lang) {
	switch (lang) {
		case 0:
			return 'Create a Compound API with Infura';
		case 1:
			return 'Create a Compound API with Infura';
		case 2:
			return 'Create a Compound API with Infura';
		case 3:
			return 'Create a Compound API with Infura';
		default:
			return 'Create a Compound API with Infura';
	}
};
var $author$project$Strings$Translations$docs_guides_05 = function (lang) {
	switch (lang) {
		case 0:
			return 'Building a Governance Interface';
		case 1:
			return 'Building a Governance Interface';
		case 2:
			return 'Building a Governance Interface';
		case 3:
			return 'Building a Governance Interface';
		default:
			return 'Building a Governance Interface';
	}
};
var $author$project$Strings$Translations$docs_guides_06 = function (lang) {
	switch (lang) {
		case 0:
			return 'Delegation & Voting';
		case 1:
			return 'Delegation & Voting';
		case 2:
			return 'Delegation & Voting';
		case 3:
			return 'Delegation & Voting';
		default:
			return 'Delegation & Voting';
	}
};
var $author$project$Strings$Translations$docs_protocol_math_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound protocol contracts use a system of exponential math, ';
		case 1:
			return 'The Compound protocol contracts use a system of exponential math, ';
		case 2:
			return 'The Compound protocol contracts use a system of exponential math, ';
		case 3:
			return 'The Compound protocol contracts use a system of exponential math, ';
		default:
			return 'The Compound protocol contracts use a system of exponential math, ';
	}
};
var $author$project$Strings$Translations$docs_protocol_math_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return ', in order to represent fractional quantities with sufficient precision.';
		case 1:
			return ', in order to represent fractional quantities with sufficient precision.';
		case 2:
			return ', in order to represent fractional quantities with sufficient precision.';
		case 3:
			return ', in order to represent fractional quantities with sufficient precision.';
		default:
			return ', in order to represent fractional quantities with sufficient precision.';
	}
};
var $author$project$Strings$Translations$docs_protocol_math_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Most numbers are represented as a ';
		case 1:
			return 'Most numbers are represented as a ';
		case 2:
			return 'Most numbers are represented as a ';
		case 3:
			return 'Most numbers are represented as a ';
		default:
			return 'Most numbers are represented as a ';
	}
};
var $author$project$Strings$Translations$docs_protocol_math_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return ', an unsigned integer scaled by ';
		case 1:
			return ', an unsigned integer scaled by ';
		case 2:
			return ', an unsigned integer scaled by ';
		case 3:
			return ', an unsigned integer scaled by ';
		default:
			return ', an unsigned integer scaled by ';
	}
};
var $author$project$Strings$Translations$docs_protocol_math_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ', in order to perform basic math at a high level of precision.';
		case 1:
			return ', in order to perform basic math at a high level of precision.';
		case 2:
			return ', in order to perform basic math at a high level of precision.';
		case 3:
			return ', in order to perform basic math at a high level of precision.';
		default:
			return ', in order to perform basic math at a high level of precision.';
	}
};
var $author$project$Strings$Translations$docs_support_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Please join the #development room in the Compound community ';
		case 1:
			return 'Please join the #development room in the Compound community ';
		case 2:
			return 'Please join the #development room in the Compound community ';
		case 3:
			return 'Please join the #development room in the Compound community ';
		default:
			return 'Please join the #development room in the Compound community ';
	}
};
var $author$project$Strings$Translations$docs_support_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Discord';
		case 1:
			return 'Discord';
		case 2:
			return 'Discord';
		case 3:
			return 'Discord';
		default:
			return 'Discord';
	}
};
var $author$project$Strings$Translations$docs_support_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
		case 1:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
		case 2:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
		case 3:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
		default:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
	}
};
var $author$project$Strings$Translations$docs_supported_networks = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound Protocol is currently deployed on the following networks:';
		case 1:
			return 'The Compound Protocol is currently deployed on the following networks:';
		case 2:
			return 'The Compound Protocol is currently deployed on the following networks:';
		case 3:
			return 'The Compound Protocol is currently deployed on the following networks:';
		default:
			return 'The Compound Protocol is currently deployed on the following networks:';
	}
};
var $author$project$Strings$Translations$gas_costs = function (lang) {
	switch (lang) {
		case 0:
			return 'Gas Costs';
		case 1:
			return 'Costos de gas';
		case 2:
			return 'Gas 成本';
		case 3:
			return 'Coûts du gaz';
		default:
			return '가스 비용';
	}
};
var $author$project$LandingSite$Page$getWhitepaperUrl = '/documents/Compound.Whitepaper.pdf';
var $author$project$Strings$Translations$getting_started = function (lang) {
	switch (lang) {
		case 0:
			return 'Getting Started';
		case 1:
			return 'Empezando';
		case 2:
			return '开始';
		case 3:
			return 'Commencer';
		default:
			return '시작하기';
	}
};
var $author$project$Strings$Translations$math_calculating_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Calculating the APY Using Rate Per Block';
		case 1:
			return 'Calculating the APY Using Rate Per Block';
		case 2:
			return 'Calculating the APY Using Rate Per Block';
		case 3:
			return 'Calculating the APY Using Rate Per Block';
		default:
			return 'Calculating the APY Using Rate Per Block';
	}
};
var $author$project$Strings$Translations$math_calculating_apy_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Annual Percentage Yield (APY) for supplying or borrowing in each market can be calculated using the value of ';
		case 1:
			return 'The Annual Percentage Yield (APY) for supplying or borrowing in each market can be calculated using the value of ';
		case 2:
			return 'The Annual Percentage Yield (APY) for supplying or borrowing in each market can be calculated using the value of ';
		case 3:
			return 'The Annual Percentage Yield (APY) for supplying or borrowing in each market can be calculated using the value of ';
		default:
			return 'The Annual Percentage Yield (APY) for supplying or borrowing in each market can be calculated using the value of ';
	}
};
var $author$project$Strings$Translations$math_calculating_apy_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return ' (for supply APY) or ';
		case 1:
			return ' (for supply APY) or ';
		case 2:
			return ' (for supply APY) or ';
		case 3:
			return ' (for supply APY) or ';
		default:
			return ' (for supply APY) or ';
	}
};
var $author$project$Strings$Translations$math_calculating_apy_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' (for borrow APY) in this formula:';
		case 1:
			return ' (for borrow APY) in this formula:';
		case 2:
			return ' (for borrow APY) in this formula:';
		case 3:
			return ' (for borrow APY) in this formula:';
		default:
			return ' (for borrow APY) in this formula:';
	}
};
var $author$project$Strings$Translations$math_calculating_apy_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'Here is an example of calculating the supply and borrow APY with Web3.js JavaScript:';
		case 1:
			return 'Here is an example of calculating the supply and borrow APY with Web3.js JavaScript:';
		case 2:
			return 'Here is an example of calculating the supply and borrow APY with Web3.js JavaScript:';
		case 3:
			return 'Here is an example of calculating the supply and borrow APY with Web3.js JavaScript:';
		default:
			return 'Here is an example of calculating the supply and borrow APY with Web3.js JavaScript:';
	}
};
var $author$project$Strings$Translations$math_calculating_interest = function (lang) {
	switch (lang) {
		case 0:
			return 'Calculating Accrued Interest';
		case 1:
			return 'Calculating Accrued Interest';
		case 2:
			return 'Calculating Accrued Interest';
		case 3:
			return 'Calculating Accrued Interest';
		default:
			return 'Calculating Accrued Interest';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest rates for each market update on any block in which the ratio of borrowed assets to supplied assets in the market has changed. The amount interest rates are changed depends on the interest rate model smart contract implemented for the market, and the amount of change in the ratio of borrowed assets to supplied assets in the market.';
		case 1:
			return 'Interest rates for each market update on any block in which the ratio of borrowed assets to supplied assets in the market has changed. The amount interest rates are changed depends on the interest rate model smart contract implemented for the market, and the amount of change in the ratio of borrowed assets to supplied assets in the market.';
		case 2:
			return 'Interest rates for each market update on any block in which the ratio of borrowed assets to supplied assets in the market has changed. The amount interest rates are changed depends on the interest rate model smart contract implemented for the market, and the amount of change in the ratio of borrowed assets to supplied assets in the market.';
		case 3:
			return 'Interest rates for each market update on any block in which the ratio of borrowed assets to supplied assets in the market has changed. The amount interest rates are changed depends on the interest rate model smart contract implemented for the market, and the amount of change in the ratio of borrowed assets to supplied assets in the market.';
		default:
			return 'Interest rates for each market update on any block in which the ratio of borrowed assets to supplied assets in the market has changed. The amount interest rates are changed depends on the interest rate model smart contract implemented for the market, and the amount of change in the ratio of borrowed assets to supplied assets in the market.';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part10 = function (lang) {
	switch (lang) {
		case 0:
			return ' value may change at any time.';
		case 1:
			return ' value may change at any time.';
		case 2:
			return ' value may change at any time.';
		case 3:
			return ' value may change at any time.';
		default:
			return ' value may change at any time.';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'See the interest rate data visualization notebook on ';
		case 1:
			return 'See the interest rate data visualization notebook on ';
		case 2:
			return 'See the interest rate data visualization notebook on ';
		case 3:
			return 'See the interest rate data visualization notebook on ';
		default:
			return 'See the interest rate data visualization notebook on ';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part2a = function (lang) {
	switch (lang) {
		case 0:
			return ' to visualize which interest rate model is currently applied to each market.';
		case 1:
			return ' to visualize which interest rate model is currently applied to each market.';
		case 2:
			return ' to visualize which interest rate model is currently applied to each market.';
		case 3:
			return ' to visualize which interest rate model is currently applied to each market.';
		default:
			return ' to visualize which interest rate model is currently applied to each market.';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Historical interest rates can be retrieved from the ';
		case 1:
			return 'Historical interest rates can be retrieved from the ';
		case 2:
			return 'Historical interest rates can be retrieved from the ';
		case 3:
			return 'Historical interest rates can be retrieved from the ';
		default:
			return 'Historical interest rates can be retrieved from the ';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest accrues to all suppliers and borrowers in a market when any Ethereum address interacts with the market’s cToken contract, calling one of these functions: mint, redeem, borrow, or repay. Successful execution of one of these functions triggers the ';
		case 1:
			return 'Interest accrues to all suppliers and borrowers in a market when any Ethereum address interacts with the market’s cToken contract, calling one of these functions: mint, redeem, borrow, or repay. Successful execution of one of these functions triggers the ';
		case 2:
			return 'Interest accrues to all suppliers and borrowers in a market when any Ethereum address interacts with the market’s cToken contract, calling one of these functions: mint, redeem, borrow, or repay. Successful execution of one of these functions triggers the ';
		case 3:
			return 'Interest accrues to all suppliers and borrowers in a market when any Ethereum address interacts with the market’s cToken contract, calling one of these functions: mint, redeem, borrow, or repay. Successful execution of one of these functions triggers the ';
		default:
			return 'Interest accrues to all suppliers and borrowers in a market when any Ethereum address interacts with the market’s cToken contract, calling one of these functions: mint, redeem, borrow, or repay. Successful execution of one of these functions triggers the ';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' method, which causes interest to be added to the underlying balance of every supplier and borrower in the market. Interest accrues for the current block, as well as each prior block in which the ';
		case 1:
			return ' method, which causes interest to be added to the underlying balance of every supplier and borrower in the market. Interest accrues for the current block, as well as each prior block in which the ';
		case 2:
			return ' method, which causes interest to be added to the underlying balance of every supplier and borrower in the market. Interest accrues for the current block, as well as each prior block in which the ';
		case 3:
			return ' method, which causes interest to be added to the underlying balance of every supplier and borrower in the market. Interest accrues for the current block, as well as each prior block in which the ';
		default:
			return ' method, which causes interest to be added to the underlying balance of every supplier and borrower in the market. Interest accrues for the current block, as well as each prior block in which the ';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part6 = function (lang) {
	switch (lang) {
		case 0:
			return ' method was not triggered (no user interacted with the cToken contract). Interest compounds only during blocks in which the cToken contract has one of the aforementioned methods invoked.';
		case 1:
			return ' method was not triggered (no user interacted with the cToken contract). Interest compounds only during blocks in which the cToken contract has one of the aforementioned methods invoked.';
		case 2:
			return ' method was not triggered (no user interacted with the cToken contract). Interest compounds only during blocks in which the cToken contract has one of the aforementioned methods invoked.';
		case 3:
			return ' method was not triggered (no user interacted with the cToken contract). Interest compounds only during blocks in which the cToken contract has one of the aforementioned methods invoked.';
		default:
			return ' method was not triggered (no user interacted with the cToken contract). Interest compounds only during blocks in which the cToken contract has one of the aforementioned methods invoked.';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part7 = function (lang) {
	switch (lang) {
		case 0:
			return 'Here is an example of supply interest accrual:';
		case 1:
			return 'Here is an example of supply interest accrual:';
		case 2:
			return 'Here is an example of supply interest accrual:';
		case 3:
			return 'Here is an example of supply interest accrual:';
		default:
			return 'Here is an example of supply interest accrual:';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part8 = function (lang) {
	switch (lang) {
		case 0:
			return 'Alice supplies 1 ETH to the Compound protocol. At the time of supply, the ';
		case 1:
			return 'Alice supplies 1 ETH to the Compound protocol. At the time of supply, the ';
		case 2:
			return 'Alice supplies 1 ETH to the Compound protocol. At the time of supply, the ';
		case 3:
			return 'Alice supplies 1 ETH to the Compound protocol. At the time of supply, the ';
		default:
			return 'Alice supplies 1 ETH to the Compound protocol. At the time of supply, the ';
	}
};
var $author$project$Strings$Translations$math_calculating_interest_description_part9 = function (lang) {
	switch (lang) {
		case 0:
			return ' is 37893605 Wei, or 0.000000000037893605 ETH per block. No one interacts with the cEther contract for 3 Ethereum blocks. On the subsequent 4th block, Bob borrows some ETH. Alice’s underlying balance is now 1.000000000151574420 ETH (which is 37893605 Wei times 4 blocks, plus the original 1 ETH). Alice’s underlying ETH balance in subsequent blocks will have interest accrued based on the new value of 1.000000000151574420 ETH instead of the initial 1 ETH. Note that the ';
		case 1:
			return ' is 37893605 Wei, or 0.000000000037893605 ETH per block. No one interacts with the cEther contract for 3 Ethereum blocks. On the subsequent 4th block, Bob borrows some ETH. Alice’s underlying balance is now 1.000000000151574420 ETH (which is 37893605 Wei times 4 blocks, plus the original 1 ETH). Alice’s underlying ETH balance in subsequent blocks will have interest accrued based on the new value of 1.000000000151574420 ETH instead of the initial 1 ETH. Note that the ';
		case 2:
			return ' is 37893605 Wei, or 0.000000000037893605 ETH per block. No one interacts with the cEther contract for 3 Ethereum blocks. On the subsequent 4th block, Bob borrows some ETH. Alice’s underlying balance is now 1.000000000151574420 ETH (which is 37893605 Wei times 4 blocks, plus the original 1 ETH). Alice’s underlying ETH balance in subsequent blocks will have interest accrued based on the new value of 1.000000000151574420 ETH instead of the initial 1 ETH. Note that the ';
		case 3:
			return ' is 37893605 Wei, or 0.000000000037893605 ETH per block. No one interacts with the cEther contract for 3 Ethereum blocks. On the subsequent 4th block, Bob borrows some ETH. Alice’s underlying balance is now 1.000000000151574420 ETH (which is 37893605 Wei times 4 blocks, plus the original 1 ETH). Alice’s underlying ETH balance in subsequent blocks will have interest accrued based on the new value of 1.000000000151574420 ETH instead of the initial 1 ETH. Note that the ';
		default:
			return ' is 37893605 Wei, or 0.000000000037893605 ETH per block. No one interacts with the cEther contract for 3 Ethereum blocks. On the subsequent 4th block, Bob borrows some ETH. Alice’s underlying balance is now 1.000000000151574420 ETH (which is 37893605 Wei times 4 blocks, plus the original 1 ETH). Alice’s underlying ETH balance in subsequent blocks will have interest accrued based on the new value of 1.000000000151574420 ETH instead of the initial 1 ETH. Note that the ';
	}
};
var $author$project$Strings$Translations$math_decimals_in_ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'cToken and Underlying Decimals';
		case 1:
			return 'cToken and Underlying Decimals';
		case 2:
			return 'cToken and Underlying Decimals';
		case 3:
			return 'cToken and Underlying Decimals';
		default:
			return 'cToken and Underlying Decimals';
	}
};
var $author$project$Strings$Translations$math_decimals_in_ctokens_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Prices and exchange rates are scaled by the decimals unique to each asset; cTokens are ERC-20 tokens with 8 decimals, while their underlying tokens vary, and have a public member named ';
		case 1:
			return 'Prices and exchange rates are scaled by the decimals unique to each asset; cTokens are ERC-20 tokens with 8 decimals, while their underlying tokens vary, and have a public member named ';
		case 2:
			return 'Prices and exchange rates are scaled by the decimals unique to each asset; cTokens are ERC-20 tokens with 8 decimals, while their underlying tokens vary, and have a public member named ';
		case 3:
			return 'Prices and exchange rates are scaled by the decimals unique to each asset; cTokens are ERC-20 tokens with 8 decimals, while their underlying tokens vary, and have a public member named ';
		default:
			return 'Prices and exchange rates are scaled by the decimals unique to each asset; cTokens are ERC-20 tokens with 8 decimals, while their underlying tokens vary, and have a public member named ';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying = function (lang) {
	switch (lang) {
		case 0:
			return 'Interpreting Exchange Rates';
		case 1:
			return 'Interpreting Exchange Rates';
		case 2:
			return 'Interpreting Exchange Rates';
		case 3:
			return 'Interpreting Exchange Rates';
		default:
			return 'Interpreting Exchange Rates';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The cToken ';
		case 1:
			return 'The cToken ';
		case 2:
			return 'The cToken ';
		case 3:
			return 'The cToken ';
		default:
			return 'The cToken ';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part2 = function (lang) {
	switch (lang) {
		case 0:
			return ' is scaled by the difference in decimals between the cToken and the underlying asset.';
		case 1:
			return ' is scaled by the difference in decimals between the cToken and the underlying asset.';
		case 2:
			return ' is scaled by the difference in decimals between the cToken and the underlying asset.';
		case 3:
			return ' is scaled by the difference in decimals between the cToken and the underlying asset.';
		default:
			return ' is scaled by the difference in decimals between the cToken and the underlying asset.';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Here is an example of finding the value of 1 cBAT in BAT with Web3.js JavaScript.';
		case 1:
			return 'Here is an example of finding the value of 1 cBAT in BAT with Web3.js JavaScript.';
		case 2:
			return 'Here is an example of finding the value of 1 cBAT in BAT with Web3.js JavaScript.';
		case 3:
			return 'Here is an example of finding the value of 1 cBAT in BAT with Web3.js JavaScript.';
		default:
			return 'Here is an example of finding the value of 1 cBAT in BAT with Web3.js JavaScript.';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'There is no underlying contract for ETH, so to do this with cETH, set ';
		case 1:
			return 'There is no underlying contract for ETH, so to do this with cETH, set ';
		case 2:
			return 'There is no underlying contract for ETH, so to do this with cETH, set ';
		case 3:
			return 'There is no underlying contract for ETH, so to do this with cETH, set ';
		default:
			return 'There is no underlying contract for ETH, so to do this with cETH, set ';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' to 18.';
		case 1:
			return ' to 18.';
		case 2:
			return ' to 18.';
		case 3:
			return ' to 18.';
		default:
			return ' to 18.';
	}
};
var $author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part6 = function (lang) {
	switch (lang) {
		case 0:
			return 'To find the number of underlying tokens that can be redeemed for cTokens, divide the number of cTokens by the above value ';
		case 1:
			return 'To find the number of underlying tokens that can be redeemed for cTokens, divide the number of cTokens by the above value ';
		case 2:
			return 'To find the number of underlying tokens that can be redeemed for cTokens, divide the number of cTokens by the above value ';
		case 3:
			return 'To find the number of underlying tokens that can be redeemed for cTokens, divide the number of cTokens by the above value ';
		default:
			return 'To find the number of underlying tokens that can be redeemed for cTokens, divide the number of cTokens by the above value ';
	}
};
var $author$project$Strings$Translations$networks = function (lang) {
	switch (lang) {
		case 0:
			return 'Networks';
		case 1:
			return 'Redes';
		case 2:
			return '网络';
		case 3:
			return 'Réseaux';
		default:
			return '네트워크';
	}
};
var $author$project$Strings$Translations$protocol_math = function (lang) {
	switch (lang) {
		case 0:
			return 'Protocol Math';
		case 1:
			return 'Protocol Math';
		case 2:
			return '协议数学';
		case 3:
			return 'Protocole de mathématiques';
		default:
			return '프로토콜 수학';
	}
};
var $author$project$LandingSite$Docs$gettingStartedContent = F3(
	function (userLanguage, model, configs) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('getting-started')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$getting_started(userLanguage))
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_getting_started_intro_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 1, $author$project$LandingSite$Page$getWhitepaperUrl)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_getting_started_intro_link1(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_getting_started_intro_part2(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-protocol')),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_getting_started_intro_link2(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_getting_started_intro_part3(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_support_description_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw')),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_support_description_part2(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_support_description_part3(userLanguage))
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('guides')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_guides(userLanguage))
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/setting-up-an-ethereum-development-environment-7c387664c5fe')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_01(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/supplying-assets-to-the-compound-protocol-ec2cf5df5aa')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('02')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_02(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/borrowing-assets-from-compound-quick-start-guide-f5e69af4b8f4')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('03')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_03(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/compound-ethereum-api-with-infura-1f5c555fd4a2')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('04')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_04(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/building-a-governance-interface-474fc271588c')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('05')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_05(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/delegation-and-voting-with-eip-712-signatures-a636c9dfec5e')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('06')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_06(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('networks')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$networks(userLanguage))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_supported_networks(userLanguage))
								]))
						]),
					A2($author$project$LandingSite$Docs$contractsView, model, configs))),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('protocol-math')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$protocol_math(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_protocol_math_description_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-protocol/blob/master/contracts/Exponential.sol')),
								_List_fromArray(
									[
										$elm$html$Html$text('Exponential.sol')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_protocol_math_description_part2(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_protocol_math_description_part3(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('italic')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('mantissa')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_protocol_math_description_part4(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('1 * 10 ^ 18')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_protocol_math_description_part5(userLanguage))
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subsection')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_decimals_in_ctokens(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_decimals_in_ctokens_description_part1(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('italic')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('decimals')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('token-decimal-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cToken')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cToken Decimals')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Underlying')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Underlying Decimals')
													]))
											]))
									])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cETH')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('ETH')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('18')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cBAT')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('BAT')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('18')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cDAI')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('DAI')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('18')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cREP')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('REP')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('18')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cUSDC')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('USDC')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('6')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cUSDT')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('USDT')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('6')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cWBTC')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('WBTC')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('cZRX')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('8')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('ZRX')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('18')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subsection')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Docs,
											1,
											$elm$core$Maybe$Just('exchange-rate')))),
								_List_fromArray(
									[
										$elm$html$Html$text('Exchange Rate')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part2(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Utils$Highlighter$highlight('oneCTokenInUnderlying = exchangeRateCurrent / (1 * 10 ^ (18 + underlyingDecimals - cTokenDecimals))')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part3(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Utils$Highlighter$highlight('const cTokenDecimals = 8; // all cTokens have 8 decimal places\nconst underlying = new web3.eth.Contract(erc20Abi, batAddress);\nconst cToken = new web3.eth.Contract(cTokenAbi, cBatAddress);\nconst underlyingDecimals = await underlying.methods.decimals().call();\nconst exchangeRateCurrent = await cToken.methods.exchangeRateCurrent().call();\nconst mantissa = 18 + parseInt(underlyingDecimals) - cTokenDecimals;\nconst oneCTokenInUnderlying = exchangeRateCurrent / Math.pow(10, mantissa);\nconsole.log(\'1 cBAT can be redeemed for\', oneCTokenInUnderlying, \'BAT\');')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part4(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('underlyingDecimals')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part5(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_exchange_rate_ctoken_underlying_part6(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('oneCTokenInUnderlying')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Utils$Highlighter$highlight('underlyingTokens = cTokenAmount * oneCTokenInUnderlying')
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subsection')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part1(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part2(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://observablehq.com/@jflatow/compound-interest-rates')),
								_List_fromArray(
									[
										$elm$html$Html$text('Observable')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part2a(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part3(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Docs,
											5,
											$elm$core$Maybe$Just('MarketHistoryService')))),
								_List_fromArray(
									[
										$elm$html$Html$text('MarketHistoryService API')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part4(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('accrueInterest')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part5(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('accrueInterest')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part6(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part7(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part8(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('supplyRatePerBlock')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part9(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('supplyRatePerBlock')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_interest_description_part10(userLanguage))
							])),
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subsection')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_apy(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_apy_description_part1(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('supplyRatePerBlock')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_apy_description_part2(userLanguage)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('borrowRatePerBlock')
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_apy_description_part3(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Utils$Highlighter$highlight('Rate = cToken.supplyRatePerBlock(); // Integer\nRate = 37893566\nETH Mantissa = 1 * 10 ^ 18 (ETH has 18 decimal places)\nBlocks Per Day = 4 * 60 * 24 (based on 4 blocks occurring every minute)\nDays Per Year = 365\n\nAPY = ((((Rate / ETH Mantissa * Blocks Per Day + 1) ^ Days Per Year - 1)) - 1) * 100')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$math_calculating_apy_description_part4(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Utils$Highlighter$highlight('const ethMantissa = 1e18;\nconst blocksPerDay = 4 * 60 * 24;\nconst daysPerYear = 365;\n\nconst cToken = new web3.eth.Contract(cEthAbi, cEthAddress);\nconst supplyRatePerBlock = await cToken.methods.supplyRatePerBlock().call();\nconst borrowRatePerBlock = await cToken.methods.borrowRatePerBlock().call();\nconst supplyApy = (((Math.pow((supplyRatePerBlock / ethMantissa * blocksPerDay) + 1, daysPerYear - 1))) - 1) * 100;\nconst borrowApy = (((Math.pow((borrowRatePerBlock / ethMantissa * blocksPerDay) + 1, daysPerYear - 1))) - 1) * 100;\nconsole.log(`Supply APY for ETH ${supplyApy} %`);\nconsole.log(`Borrow APY for ETH ${borrowApy} %`);')
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('gas-costs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$gas_costs(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Docs,
											2,
											$elm$core$Maybe$Just('account-liquidity')))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_gas_costs_description_part2(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part3(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Docs,
											2,
											$elm$core$Maybe$Just('enter-markets')))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_gas_costs_description_part4(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part5(userLanguage))
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('costs-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Function')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Typical Gas Cost')
													]))
											]))
									])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Mint')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 150K, cDAI < 300k')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Redeem, Transfer')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 250K if borrowing, otherwise < 90K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 300K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Repay Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 90K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Liquidate Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 400K')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$LandingSite$Docs$gettingStartedNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#getting-started',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#guides',
			$author$project$Strings$Translations$docs_guides(userLanguage)),
			_Utils_Tuple2(
			'#networks',
			$author$project$Strings$Translations$networks(userLanguage)),
			_Utils_Tuple2(
			'#protocol-math',
			$author$project$Strings$Translations$protocol_math(userLanguage)),
			_Utils_Tuple2(
			'#gas-costs',
			$author$project$Strings$Translations$gas_costs(userLanguage))
		]);
};
var $author$project$Utils$Highlighter$highlighted = A2($elm$html$Html$span, _List_Nil, _List_Nil);
var $author$project$SyntaxHighlight$Language$Solidity$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'sol-n');
		case 1:
			return _Utils_Tuple2(3, 'sol-s');
		case 2:
			return _Utils_Tuple2(4, 'sol-k');
		case 3:
			return _Utils_Tuple2(5, 'sol-dk');
		case 4:
			return _Utils_Tuple2(6, 'sol-fe');
		case 5:
			return _Utils_Tuple2(6, 'sol-f');
		case 6:
			return _Utils_Tuple2(7, 'sol-lk');
		case 7:
			return _Utils_Tuple2(8, 'sol-p');
		default:
			return _Utils_Tuple2(6, 'sol-ce');
	}
};
var $author$project$SyntaxHighlight$Language$Solidity$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';', '.']));
var $author$project$SyntaxHighlight$Language$Solidity$isGroupChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$groupSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isGroupChar)));
var $author$project$SyntaxHighlight$Language$Solidity$isCommentChar = function (c) {
	return c === '/';
};
var $author$project$SyntaxHighlight$Language$Solidity$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%']));
var $author$project$SyntaxHighlight$Language$Solidity$punctuactorSet = A2($elm$core$Set$union, $author$project$SyntaxHighlight$Language$Solidity$operatorSet, $author$project$SyntaxHighlight$Language$Solidity$groupSet);
var $author$project$SyntaxHighlight$Language$Solidity$isPunctuaction = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$punctuactorSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$isStringLiteralChar = function (c) {
	return (c === '\"') || ((c === '\'') || (c === '`'));
};
var $author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar = function (c) {
	return !($author$project$SyntaxHighlight$Language$Solidity$isPunctuaction(c) || ($author$project$SyntaxHighlight$Language$Solidity$isStringLiteralChar(c) || ($author$project$SyntaxHighlight$Language$Solidity$isCommentChar(c) || $author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $author$project$SyntaxHighlight$Language$Solidity$DeclarationKeyword = 3;
var $author$project$SyntaxHighlight$Language$Solidity$Function = 5;
var $author$project$SyntaxHighlight$Language$Solidity$Keyword = 2;
var $author$project$SyntaxHighlight$Language$Solidity$LiteralKeyword = 6;
var $author$project$SyntaxHighlight$Language$Solidity$Param = 7;
var $author$project$SyntaxHighlight$Language$Solidity$ClassExtends = 8;
var $author$project$SyntaxHighlight$Language$Solidity$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $author$project$SyntaxHighlight$Language$Solidity$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $author$project$SyntaxHighlight$Language$Solidity$multilineComment = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	{
		hV: function (b) {
			return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b);
		},
		h3: '*/',
		iw: _List_fromArray(
			[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList]),
		iz: false,
		iA: function (c) {
			return !$author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		jJ: '/*'
	});
var $author$project$SyntaxHighlight$Language$Solidity$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$inlineComment, $author$project$SyntaxHighlight$Language$Solidity$multilineComment]));
var $author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$comment)
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$classExtendsLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						$elm$parser$Parser$map,
						$elm$parser$Parser$Loop,
						A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							$author$project$SyntaxHighlight$Language$Solidity$classExtendsLoop)) : $elm$parser$Parser$succeed(
						$elm$parser$Parser$Loop(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($author$project$SyntaxHighlight$Language$Solidity$isCommentChar(c) || ($author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v1) {
						return A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$author$project$SyntaxHighlight$Language$Solidity$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$FunctionEval = 4;
var $author$project$SyntaxHighlight$Language$Solidity$functionEvalLoop = F3(
	function (identifier, revTokens, thisRevToken) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(thisRevToken),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_ap(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
									thisRevToken),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$author$project$SyntaxHighlight$Language$Type$C(4),
										identifier),
									revTokens)));
					},
					$elm$parser$Parser$symbol('(')),
					$elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						_Utils_ap(
							thisRevToken,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, identifier),
								revTokens))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Solidity$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let', 'uint', 'address', 'bool']));
var $author$project$SyntaxHighlight$Language$Solidity$isDeclarationKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$declarationKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['assert', 'break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected', 'require', 'Comptroller', 'CErc20', 'CEther', 'CToken', 'Erc20', 'memory']));
var $author$project$SyntaxHighlight$Language$Solidity$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$keywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var $author$project$SyntaxHighlight$Language$Solidity$isLiteralKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$literalKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$keywordParser = F2(
	function (revTokens, n) {
		return ((n === 'function') || (n === 'static')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop) : ((n === 'class') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(7),
					n),
				revTokens)) : ((n === 'constructor') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop) : ($author$project$SyntaxHighlight$Language$Solidity$isKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(2),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Solidity$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Solidity$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(6),
					n),
				revTokens)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A2($author$project$SyntaxHighlight$Language$Solidity$functionEvalLoop, n, revTokens))))))));
	});
var $author$project$SyntaxHighlight$Language$Solidity$Number = 0;
var $author$project$SyntaxHighlight$Language$Solidity$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$number));
var $author$project$SyntaxHighlight$Language$Solidity$isOperatorChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$operatorSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isOperatorChar)));
var $author$project$SyntaxHighlight$Language$Solidity$String = 1;
var $author$project$SyntaxHighlight$Language$Solidity$solEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$escapable));
var $author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter = {
	hV: function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	h3: '\'',
	iw: _List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList, $author$project$SyntaxHighlight$Language$Solidity$solEscapable]),
	iz: false,
	iA: function (c) {
		return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	jJ: '\''
};
var $author$project$SyntaxHighlight$Language$Solidity$doubleQuote = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter,
		{h3: '\"', jJ: '\"'}));
var $author$project$SyntaxHighlight$Language$Solidity$quote = $author$project$SyntaxHighlight$Language$Helpers$delimited($author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter);
var $author$project$SyntaxHighlight$Language$Solidity$templateString = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter,
		{
			h3: '`',
			iw: _List_fromArray(
				[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList, $author$project$SyntaxHighlight$Language$Solidity$solEscapable]),
			iA: function (c) {
				return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			jJ: '`'
		}));
var $author$project$SyntaxHighlight$Language$Solidity$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$quote, $author$project$SyntaxHighlight$Language$Solidity$doubleQuote, $author$project$SyntaxHighlight$Language$Solidity$templateString]));
var $author$project$SyntaxHighlight$Language$Solidity$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$author$project$SyntaxHighlight$Language$Solidity$operatorChar, $author$project$SyntaxHighlight$Language$Solidity$groupChar, $author$project$SyntaxHighlight$Language$Solidity$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$author$project$SyntaxHighlight$Language$Solidity$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $author$project$SyntaxHighlight$Language$Solidity$mainLoop);
var $author$project$SyntaxHighlight$Language$Solidity$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($author$project$SyntaxHighlight$Language$Solidity$toRevTokens),
	$elm$core$Result$map(
		$author$project$SyntaxHighlight$Line$Helpers$toLines($author$project$SyntaxHighlight$Language$Solidity$syntaxToStyle)));
var $author$project$SyntaxHighlight$solidity = A2(
	$elm$core$Basics$composeR,
	$author$project$SyntaxHighlight$Language$Solidity$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $author$project$Utils$Highlighter$highlightSol = function (solCode) {
	return A2(
		$elm$core$Result$withDefault,
		A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(solCode)
				])),
		A2(
			$elm$core$Result$map,
			$author$project$SyntaxHighlight$toBlockHtml(
				$elm$core$Maybe$Just(1)),
			$author$project$SyntaxHighlight$solidity(solCode)));
};
var $author$project$LandingSite$Docs$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$LandingSite$Docs$Markdown$TableParser$dropTrailingPipe = function (string) {
	return A2($elm$core$String$endsWith, '|', string) ? A2($elm$core$String$dropRight, 1, string) : string;
};
var $author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp = function (_char) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			_char,
			$elm$parser$Parser$Expecting(_char)));
};
var $author$project$LandingSite$Docs$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed(
			function (rowString) {
				return A2(
					$elm$core$List$map,
					$elm$core$String$trim,
					A2(
						$elm$core$String$split,
						'|',
						$author$project$LandingSite$Docs$Markdown$TableParser$dropTrailingPipe(rowString)));
			}),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('\n')),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end')),
					A2(
					$elm$parser$Parser$Advanced$chompIf,
					function (c) {
						return c === '\n';
					},
					$elm$parser$Parser$Expecting('\\n'))
				]))));
var $author$project$LandingSite$Docs$Markdown$TableParser$bodyParserHelp = function (revRows) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$andThen,
				function (row) {
					return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
						$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, row, revRows)));
				},
				$author$project$LandingSite$Docs$Markdown$TableParser$rowParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v0) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(revRows));
				},
				$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(revRows));
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end')))
			]));
};
var $author$project$LandingSite$Docs$Markdown$TableParser$bodyParser = A2($elm$parser$Parser$Advanced$loop, _List_Nil, $author$project$LandingSite$Docs$Markdown$TableParser$bodyParserHelp);
var $author$project$LandingSite$Docs$Markdown$TableParser$DelimiterRow = $elm$core$Basics$identity;
var $author$project$LandingSite$Docs$Markdown$TableParser$oneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $author$project$LandingSite$Docs$Markdown$TableParser$requirePipeIfNotFirst = function (found) {
	return (found > 0) ? $author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('|') : $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $author$project$LandingSite$Docs$Markdown$TableParser$delimiterRowHelp = function (found) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v0) {
					return $elm$parser$Parser$Advanced$Done(found);
				},
				$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(found);
				},
				$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(found);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(found)),
						$author$project$LandingSite$Docs$Markdown$TableParser$tokenHelp('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed(
								$elm$parser$Parser$Advanced$Loop(found + 1)),
							$author$project$LandingSite$Docs$Markdown$TableParser$requirePipeIfNotFirst(found)),
						$elm$parser$Parser$Advanced$spaces),
					$author$project$LandingSite$Docs$Markdown$TableParser$oneOrMore(
						function (c) {
							return c === '-';
						})),
				$elm$parser$Parser$Advanced$spaces)
			]));
};
var $author$project$LandingSite$Docs$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var count = delimiterRow;
		return (count > 0) ? $elm$parser$Parser$Advanced$succeed(delimiterRow) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.'));
	},
	A2($elm$parser$Parser$Advanced$loop, 0, $author$project$LandingSite$Docs$Markdown$TableParser$delimiterRowHelp));
var $author$project$LandingSite$Docs$Markdown$TableParser$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (_v0) {
		var headers = _v0.a;
		var delimiterCount = _v0.b;
		var body = _v0.c;
		return _Utils_eq(
			$elm$core$List$length(headers),
			delimiterCount) ? $elm$parser$Parser$Advanced$succeed(
			A2(
				$author$project$LandingSite$Docs$Markdown$Table$Table,
				A2(
					$elm$core$List$map,
					function (headerCell) {
						return {kn: $elm$core$Maybe$Nothing, iD: headerCell};
					},
					headers),
				body)) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables must have the same number of header columns as delimiter columns'));
	},
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed(
					F3(
						function (headers, delimiters, body) {
							return _Utils_Tuple3(headers, delimiters, body);
						})),
				$author$project$LandingSite$Docs$Markdown$TableParser$rowParser),
			$author$project$LandingSite$Docs$Markdown$TableParser$delimiterRowParser),
		$author$project$LandingSite$Docs$Markdown$TableParser$bodyParser));
var $author$project$LandingSite$Render$render = F2(
	function (renderer, str) {
		var deadEndsToString = function (deadEnds) {
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
		};
		return A2(
			$elm$core$Result$withDefault,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(str)
						]))
				]),
			A2(
				$elm$core$Result$andThen,
				function (ast) {
					return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, renderer, ast);
				},
				A2(
					$elm$core$Result$mapError,
					deadEndsToString,
					$dillonkearns$elm_markdown$Markdown$Parser$parse(str))));
	});
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$LandingSite$Render$renderLink = F3(
	function (destination, maybeTitle, contents) {
		var titleAttrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (title) {
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$title(title)
						]);
				},
				maybeTitle));
		var _v0 = A2($elm$core$String$startsWith, '#', destination) ? _Utils_Tuple2(0, _List_Nil) : (A2($elm$core$String$startsWith, 'http', destination) ? _Utils_Tuple2(
			2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank')
				])) : _Utils_Tuple2(1, _List_Nil));
		var navigationType = _v0.a;
		var otherAttrs = _v0.b;
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				titleAttrs,
				_Utils_ap(
					otherAttrs,
					A2($author$project$Utils$CompoundHtmlAttributes$href, navigationType, destination))),
			contents);
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $dillonkearns$elm_markdown$Markdown$Html$tag = F2(
	function (expectedTag, a) {
		return F3(
			function (tagName, attributes, children) {
				return _Utils_eq(tagName, expectedTag) ? $elm$core$Result$Ok(a) : $elm$core$Result$Err('Expected ' + (expectedTag + (' but was ' + tagName)));
			});
	});
var $dillonkearns$elm_markdown$List$Helpers$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$withAttribute = F2(
	function (attributeName, _v0) {
		var renderer = _v0;
		return F3(
			function (tagName, attributes, innerBlocks) {
				return function () {
					var _v1 = A2(
						$dillonkearns$elm_markdown$List$Helpers$find,
						function (_v2) {
							var name = _v2.i5;
							var value = _v2.cA;
							return _Utils_eq(name, attributeName);
						},
						attributes);
					if (!_v1.$) {
						var value = _v1.a.cA;
						return $elm$core$Result$map(
							$elm$core$Basics$apR(value));
					} else {
						return function (_v3) {
							return $elm$core$Result$Err('Expecting attribute \"' + (attributeName + '\".'));
						};
					}
				}()(
					A3(renderer, tagName, attributes, innerBlocks));
			});
	});
var $author$project$LandingSite$Render$sectionHtml = $dillonkearns$elm_markdown$Markdown$Html$oneOf(
	_List_fromArray(
		[
			A2(
			$dillonkearns$elm_markdown$Markdown$Html$withAttribute,
			'id',
			A2(
				$dillonkearns$elm_markdown$Markdown$Html$tag,
				'section',
				F2(
					function (id, renderedChildren) {
						return A2(
							$elm$html$Html$section,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(id)
								]),
							renderedChildren);
					})))
		]));
var $elm$html$Html$sup = _VirtualDom_node('sup');
var $author$project$LandingSite$Render$renderContents = function (str) {
	return A2(
		$author$project$LandingSite$Render$render,
		$author$project$LandingSite$Render$cyclic$htmlRenderer(),
		str);
};
function $author$project$LandingSite$Render$cyclic$htmlRenderer() {
	return _Utils_update(
		$dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer,
		{
			hA: function (_v0) {
				var body = _v0.kx;
				var language = _v0.fC;
				if (!language.$) {
					switch (language.a) {
						case 'js':
							return $author$project$Utils$Highlighter$highlight(body);
						case 'javascript':
							return $author$project$Utils$Highlighter$highlight(body);
						case 'solc':
							return $author$project$Utils$Highlighter$highlightSol(body);
						case 'solidity':
							return $author$project$Utils$Highlighter$highlightSol(body);
						case 'note':
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('notice')
									]),
								$author$project$LandingSite$Render$renderContents(body));
						default:
							var languageString = language.a;
							if (A2($elm$core$String$startsWith, 'pseudo-table:', languageString)) {
								var tableClass = A3($elm$core$String$replace, 'pseudo-table:', '', languageString);
								var markdownTable = A2($elm$parser$Parser$Advanced$run, $author$project$LandingSite$Docs$Markdown$TableParser$parser, body);
								if (!markdownTable.$) {
									var _v3 = markdownTable.a;
									var headerColumns = _v3.a;
									var rows = _v3.b;
									return A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(tableClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$map,
															function (_v4) {
																var label = _v4.iD;
																var alignment = _v4.kn;
																return A2(
																	$elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(label)
																		]));
															},
															headerColumns))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (rowData) {
														return A2(
															$elm$html$Html$tr,
															_List_Nil,
															A2(
																$elm$core$List$map,
																function (rowColumnData) {
																	return A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		$author$project$LandingSite$Render$renderContents(rowColumnData));
																},
																rowData));
													},
													rows))
											]));
								} else {
									return A2(
										$elm$html$Html$pre,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(body)
											]));
								}
							} else {
								return A2(
									$elm$html$Html$pre,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(body)
										]));
							}
					}
				} else {
					return A2(
						$elm$html$Html$pre,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(body)
							]));
				}
			},
			hB: function (content) {
				switch (content) {
					case 'msg.value':
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-code')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(content),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('payable')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('payable')
										]))
								]));
					case '2^256':
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('2'),
									A2(
									$elm$html$Html$sup,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('256')
										]))
								]));
					default:
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-code')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(content)
								]));
				}
			},
			lp: function (headingMap) {
				var level = headingMap.lL;
				var children = headingMap.kL;
				switch (level) {
					case 0:
						return A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('big')
								]),
							children);
					case 1:
						return A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subheader')
								]),
							children);
					default:
						return $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer.lp(headingMap);
				}
			},
			lv: $author$project$LandingSite$Render$sectionHtml,
			iM: F2(
				function (link, content) {
					return A3($author$project$LandingSite$Render$renderLink, link.hZ, link.nb, content);
				}),
			j5: function (items) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (item) {
									var task = item.a;
									var children = item.b;
									var checkbox = function () {
										switch (task) {
											case 0:
												return $elm$html$Html$text('');
											case 1:
												return A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$disabled(true),
															$elm$html$Html$Attributes$checked(false),
															$elm$html$Html$Attributes$type_('checkbox')
														]),
													_List_Nil);
											default:
												return A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$disabled(true),
															$elm$html$Html$Attributes$checked(true),
															$elm$html$Html$Attributes$type_('checkbox')
														]),
													_List_Nil);
										}
									}();
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										A2($elm$core$List$cons, checkbox, children));
								},
								items))
						]));
			}
		});
}
var $author$project$LandingSite$Render$htmlRenderer = $author$project$LandingSite$Render$cyclic$htmlRenderer();
$author$project$LandingSite$Render$cyclic$htmlRenderer = function () {
	return $author$project$LandingSite$Render$htmlRenderer;
};
var $author$project$LandingSite$Render$empty0 = $elm$html$Html$text('');
var $author$project$LandingSite$Render$empty = function (x) {
	return $author$project$LandingSite$Render$empty0;
};
var $author$project$LandingSite$Render$empty2 = F2(
	function (x, y) {
		return $author$project$LandingSite$Render$empty0;
	});
var $author$project$LandingSite$Render$navRenderer = {
	kt: $author$project$LandingSite$Render$empty,
	hA: $author$project$LandingSite$Render$empty,
	hB: $author$project$LandingSite$Render$empty,
	k9: $author$project$LandingSite$Render$empty,
	lo: $author$project$LandingSite$Render$empty0,
	lp: $author$project$LandingSite$Render$empty,
	lv: $dillonkearns$elm_markdown$Markdown$Html$oneOf(
		_List_fromArray(
			[
				A2(
				$dillonkearns$elm_markdown$Markdown$Html$withAttribute,
				'name',
				A2(
					$dillonkearns$elm_markdown$Markdown$Html$withAttribute,
					'id',
					A2(
						$dillonkearns$elm_markdown$Markdown$Html$tag,
						'section',
						F3(
							function (id, name, renderedChildren) {
								return A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('section')
											]),
										A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#' + id)),
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]));
							}))))
			])),
	lw: $author$project$LandingSite$Render$empty,
	iM: $author$project$LandingSite$Render$empty2,
	mc: $author$project$LandingSite$Render$empty2,
	jg: $author$project$LandingSite$Render$empty,
	mN: $author$project$LandingSite$Render$empty,
	m0: $author$project$LandingSite$Render$empty,
	m1: $author$project$LandingSite$Render$empty,
	m2: $author$project$LandingSite$Render$empty,
	m3: $author$project$LandingSite$Render$empty,
	m4: $author$project$LandingSite$Render$empty2,
	m5: $author$project$LandingSite$Render$empty,
	m8: $author$project$LandingSite$Render$empty,
	m9: $author$project$LandingSite$Render$empty0,
	j5: $author$project$LandingSite$Render$empty
};
var $author$project$LandingSite$Render$renderNav = function (str) {
	return A2($author$project$LandingSite$Render$render, $author$project$LandingSite$Render$navRenderer, str);
};
var $author$project$Strings$Translations$security = function (lang) {
	switch (lang) {
		case 0:
			return 'Security';
		case 1:
			return 'Seguridad';
		case 2:
			return '安全';
		case 3:
			return 'Sécurité';
		default:
			return '보안';
	}
};
var $author$project$Strings$Translations$audits = function (lang) {
	switch (lang) {
		case 0:
			return 'Audits';
		case 1:
			return 'Audits';
		case 2:
			return 'Audits';
		case 3:
			return 'Audits';
		default:
			return 'Audits';
	}
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Strings$Translations$docs_security_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
		case 1:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
		case 2:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
		case 3:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
		default:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
	}
};
var $author$project$Strings$Translations$economic_security = function (lang) {
	switch (lang) {
		case 0:
			return 'Economic Security';
		case 1:
			return 'Economic Security';
		case 2:
			return 'Economic Security';
		case 3:
			return 'Economic Security';
		default:
			return 'Economic Security';
	}
};
var $author$project$Strings$Translations$formal_verification = function (lang) {
	switch (lang) {
		case 0:
			return 'Formal Verification';
		case 1:
			return 'Formal Verification';
		case 2:
			return 'Formal Verification';
		case 3:
			return 'Formal Verification';
		default:
			return 'Formal Verification';
	}
};
var $author$project$LandingSite$Page$getCertoraUrl = '/documents/Certora.pdf';
var $author$project$LandingSite$Docs$securityContent = F3(
	function (userLanguage, model, configs) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('security')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$security(userLanguage))
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_security_overview(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We believe that size, visibility, and time are the true test for the security of a smart contract; please exercise caution, and make your own determination of security and suitability.')
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('audits')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$audits(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound protocol has been reviewed & audited by '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.trailofbits.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits')
									])),
								$elm$html$Html$text(' and '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://openzeppelin.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/trailofbits/publications/blob/master/reviews/compound-2.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits - April 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('02')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - August 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/trailofbits/publications/blob/master/reviews/compound-3.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('03')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits - August 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-finance-patch-audit')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('04')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - Timelock & Pause Guardian')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-finance-mcd-dsr-integration/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('05')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - cDAI')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-alpha-governance-system-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('06')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - COMP & Governance')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/trailofbits/publications/blob/master/reviews/compound-governance.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('07')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits - February 2020')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-tether-integration-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('08')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - Tether')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-comp-distribution-system-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('09')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - COMP Distribution')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('formal-verification')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$formal_verification(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound protocol was developed with a specifications of security principles, and formally verified by '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.certora.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Certora')
									])),
								$elm$html$Html$text(' using Certora ASA (Accurate Static Analysis), which is integrated into Compound\'s continuous integration system.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 1, $author$project$LandingSite$Page$getCertoraUrl)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Certora Verification Summary')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('economic-security')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$economic_security(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://gauntlet.network/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Gauntlet')
									])),
								$elm$html$Html$text(' has constructed a simulation-based market stress-testing platform to evaluate the economic security of the Compound protocol, as it scales supported assets and volume.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://gauntlet.network/reports/compound')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Gauntlet Market Risk Assessment')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('bug-bounty')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Bug Bounty Program')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Security is core to our values, and we value the input of hackers acting in good faith to help us maintain the highest standard for the security and safety of the Ethereum ecosystem. The Compound protocol, while it has gone through professional audits and formal verification, depends on new technology that may contain undiscovered vulnerabilities.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Compound encourages the community to audit our contracts and security; we also encourage the responsible disclosure of any issues. This program is intended to recognize the value of working with the community of independent security researchers, and sets out our definition of good faith in the context of finding and reporting vulnerabilities, as well as what you can expect from us in return.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Rewards')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Compound offers substantial rewards for discoveries that can prevent the loss of assets, the freezing of assets, or harm to a user, commensurate with the severity and exploitability of the vulnerability. Compound will pay a reward of $500 to $150,000 for eligible discoveries according to the terms and conditions provided below.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Scope')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The primary scope of the bug bounty program is for vulnerabilities affecting the on-chain Compound Protocol, deployed to the Ethereum Mainnet, for contract addresses listed in this developer documentation.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This list may change as new contracts are deployed, or as existing contracts are removed from usage. Vulnerabilities in contracts built on top of the Protocol by third-party developers (such as smart contract wallets) are not in-scope, nor are vulnerabilities that require ownership of an admin key.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The secondary scope of the bug bounty program is for vulnerabilities affecting the Compound Interface hosted at app.compound.finance that could conceivably result in exploitation of user accounts.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Finally, test contracts (Rinkeby and other testnets) and staging servers are out of scope, unless the discovered vulnerability also affects the Compound Protocol or Interface, or could otherwise be exploited in a way that risks user funds.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Disclosure')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Submit all bug bounty disclosures to security@compound.finance. The disclosure must include clear and concise steps to reproduce the discovered vulnerability in either written or video format. Compound will follow up promptly with acknowledgement of the disclosure.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Terms and Conditions')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To be eligible for bug bounty reward consideration, you must:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Identify an original, previously unreported, non-public vulnerability within the scope of the Compound bug bounty program as described above.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Include sufficient detail in your disclosure to enable our engineers to quickly reproduce, understand, and fix the vulnerability.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Be at least 18 years of age.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Be reporting in an individual capacity, or if employed by a company, reporting with the company’s written approval to submit a disclosure to Compound.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not be subject to US sanctions or reside in a US-embargoed country.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not be a current or former Compound employee, vendor, contractor, or employee of a Compound vendor or contractor.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To encourage vulnerability research and to avoid any confusion between good-faith hacking and malicious attack, we require that you:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Play by the rules, including following the terms and conditions of this program and any other relevant agreements. If there is any inconsistency between this program and any other relevant agreements, the terms of this program will prevail.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Report any vulnerability you’ve discovered promptly.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Avoid violating the privacy of others, disrupting our systems, destroying data, or harming user experience.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Use only security@compound.finance to discuss vulnerabilities with us.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Keep the details of any discovered vulnerabilities confidential until they are fixed.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Perform testing only on in-scope systems, and respect systems and activities which are out-of-scope.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Only interact with accounts you own or with explicit permission from the account holder.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not engage in blackmail, extortion, or any other unlawful conduct.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('When working with us according to this program, you can expect us to:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Pay generous rewards for eligible discoveries based on the severity and exploitability of the discovery, at Compound’s sole discretion')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Extend Safe Harbor for your vulnerability research that is related to this program, meaning we will not threaten or bring any legal action against anyone who makes a good faith effort to comply with our bug bounty program.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Work with you to understand and validate your report, including a timely initial response to the submission.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Work to remediate discovered vulnerabilities in a timely manner.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Recognize your contribution to improving our security if you are the first to report a unique vulnerability, and your report triggers a code or configuration change.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('All reward determinations, including eligibility and payment amount, are made at Compound’s sole discretion. Compound reserves the right to reject submissions and alter the terms and conditions of this program.')
							]))
					]))
			]);
	});
var $author$project$Strings$Translations$bug_bounty = function (lang) {
	switch (lang) {
		case 0:
			return 'Bug Bounty';
		case 1:
			return 'Bug Bounty';
		case 2:
			return 'Bug Bounty';
		case 3:
			return 'Bug Bounty';
		default:
			return 'Bug Bounty';
	}
};
var $author$project$LandingSite$Docs$securityNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#security',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#audits',
			$author$project$Strings$Translations$audits(userLanguage)),
			_Utils_Tuple2(
			'#formal-verification',
			$author$project$Strings$Translations$formal_verification(userLanguage)),
			_Utils_Tuple2(
			'#economic-security',
			$author$project$Strings$Translations$economic_security(userLanguage)),
			_Utils_Tuple2(
			'#bug-bounty',
			$author$project$Strings$Translations$bug_bounty(userLanguage))
		]);
};
var $author$project$LandingSite$Docs$view = F4(
	function (userLanguagePassed, subPage, configs, model) {
		var userLanguage = 0;
		var renderedNavList = function () {
			switch (subPage) {
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$LandingSite$Render$renderNav($author$project$LandingSite$Docs$CTokenDoc$doc));
				case 2:
					return $elm$core$Maybe$Just(
						$author$project$LandingSite$Render$renderNav($author$project$LandingSite$Docs$ComptrollerDoc$doc));
				case 3:
					return $elm$core$Maybe$Just(
						$author$project$LandingSite$Render$renderNav($author$project$LandingSite$Docs$GovernanceDoc$doc));
				case 4:
					return $elm$core$Maybe$Just(
						$author$project$LandingSite$Render$renderNav($author$project$LandingSite$Docs$OpenPriceFeedDoc$doc));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var navList = function () {
			switch (subPage) {
				case 0:
					return $author$project$LandingSite$Docs$gettingStartedNavList(userLanguage);
				case 1:
					return _List_Nil;
				case 2:
					return _List_Nil;
				case 3:
					return _List_Nil;
				case 4:
					return _List_Nil;
				case 5:
					return A2($author$project$LandingSite$Docs$apiNavList, userLanguage, model.de);
				default:
					return $author$project$LandingSite$Docs$securityNavList(userLanguage);
			}
		}();
		var mobileNavListClass = function () {
			var _v4 = model.c7;
			if (_v4) {
				return ' active';
			} else {
				return '';
			}
		}();
		var content = function () {
			switch (subPage) {
				case 0:
					return A3($author$project$LandingSite$Docs$gettingStartedContent, userLanguage, model, configs);
				case 1:
					return $author$project$LandingSite$Render$renderContents($author$project$LandingSite$Docs$CTokenDoc$doc);
				case 2:
					return $author$project$LandingSite$Render$renderContents($author$project$LandingSite$Docs$ComptrollerDoc$doc);
				case 3:
					return $author$project$LandingSite$Render$renderContents($author$project$LandingSite$Docs$GovernanceDoc$doc);
				case 4:
					return $author$project$LandingSite$Render$renderContents($author$project$LandingSite$Docs$OpenPriceFeedDoc$doc);
				case 5:
					return A2($author$project$LandingSite$Docs$apiContent, userLanguage, model.de);
				default:
					return A3($author$project$LandingSite$Docs$securityContent, userLanguage, model, configs);
			}
		}();
		var _v0 = function () {
			var _default = {eJ: '', hM: '', e2: '', fj: '', fk: '', bu: '', gA: ''};
			switch (subPage) {
				case 0:
					return _Utils_update(
						_default,
						{fj: ' active'});
				case 1:
					return _Utils_update(
						_default,
						{e2: ' active'});
				case 2:
					return _Utils_update(
						_default,
						{hM: ' active'});
				case 3:
					return _Utils_update(
						_default,
						{fk: ' active'});
				case 4:
					return _Utils_update(
						_default,
						{bu: ' active'});
				case 5:
					return _Utils_update(
						_default,
						{eJ: ' active'});
				default:
					return _Utils_update(
						_default,
						{gA: ' active'});
			}
		}();
		var getStarted = _v0.fj;
		var ctokens = _v0.e2;
		var comptroller = _v0.hM;
		var governance = _v0.fk;
		var prices = _v0.bu;
		var api = _v0.eJ;
		var security = _v0.gA;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('documentation'),
					$author$project$Utils$CompoundHtmlAttributes$id('documentation')
				]),
			_List_fromArray(
				[
					$author$project$Utils$Highlighter$highlighted,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('docs-navigation'),
							$author$project$Utils$CompoundHtmlAttributes$class('docs-navigation')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large docs-navigation__content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + getStarted)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$getting_started(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + ctokens)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 1, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$ctokens(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + comptroller)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 2, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$comptroller(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + governance)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 3, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_governance(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + prices)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 4, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_open_price_feed(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + api)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 5, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$api(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(security)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 6, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$security(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('chevron-container'),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$Docs$ToggleMobileNavMsg(!model.c7))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('chevron' + mobileNavListClass)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('docs-navigation__content--mobile' + mobileNavListClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(getStarted),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$getting_started(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(ctokens),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 1, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$ctokens(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(comptroller),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 2, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$comptroller(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(governance),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 3, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_governance(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(prices),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 4, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_open_price_feed(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(api),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Docs$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 5, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$api(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(security)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Docs, 6, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$security(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('docs container-large')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('side-navigation col-sm-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$id('docs-side-navigation'),
													$author$project$Utils$CompoundHtmlAttributes$class('side-navigation__content')
												]),
											A2(
												$elm$core$Maybe$withDefault,
												A2(
													$elm$core$List$map,
													function (_v2) {
														var hrefText = _v2.a;
														var linkText = _v2.b;
														return A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('section')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 0, hrefText)),
															_List_fromArray(
																[
																	$elm$html$Html$text(linkText)
																]));
													},
													_Utils_ap(_List_Nil, navList)),
												renderedNavList))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-9 content')
										]),
									content)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$audited_and_verified = function (lang) {
	switch (lang) {
		case 0:
			return 'Audited and Verified';
		case 1:
			return 'Auditado y verificado';
		case 2:
			return '审核和验证';
		case 3:
			return 'Audité et vérifié';
		default:
			return '감사 및 검증';
	}
};
var $author$project$Strings$Translations$audited_and_verified_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The most secure protocol for money';
		case 1:
			return 'El protocolo más seguro para el dinero.';
		case 2:
			return '最安全的金钱协议';
		case 3:
			return 'Le protocole le plus sûr pour l\'argent';
		default:
			return '암호화폐를 위한 가장 안전한 프로토콜';
	}
};
var $author$project$Strings$Translations$backed_by = function (lang) {
	switch (lang) {
		case 0:
			return 'Backed by';
		case 1:
			return 'Respaldado por';
		case 2:
			return '受支持';
		case 3:
			return 'Soutenu par';
		default:
			return '투자자';
	}
};
var $author$project$Strings$Translations$backed_by_description = function (lang) {
	switch (lang) {
		case 0:
			return 'World-class investors';
		case 1:
			return 'Inversores de clase mundial';
		case 2:
			return '世界一流的投资者';
		case 3:
			return 'Des investisseurs de classe mondiale';
		default:
			return '월드 클래스 투자자';
	}
};
var $author$project$Strings$Translations$compound_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound is an algorithmic, autonomous interest rate protocol built for developers, to unlock a universe of open financial applications.';
		case 1:
			return 'Compound es un protocolo autónomo de código abierto creado para desarrolladores, para desbloquear un universo de nuevas aplicaciones financieras. Intereses y préstamos, para el sistema financiero abierto.';
		case 2:
			return 'Compound 是为开放金融系统而为开发者构建的开源协议，基于此可以开发一系列新的金融应用程序。';
		case 3:
			return 'Compound est un protocole algorithmique et autonome de taux d\'intérêt conçu pour les développeurs afin de déverrouiller un univers d\'applications financières ouvertes.';
		default:
			return 'Compound는 개방형 금융 애플리케이션에 대한 개발자의 접근성을 높이기 위해 구축된 알고리즘 방식의 자율 이자율 프로토콜입니다.';
	}
};
var $author$project$Strings$Translations$market_risk_assessment = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Risk Assessment';
		case 1:
			return 'Evaluación de riesgo de mercado';
		case 2:
			return '市场风险评估';
		case 3:
			return 'Évaluation des risques de marché';
		default:
			return '마켓 위험도 평가';
	}
};
var $author$project$Strings$Translations$carousel_prefix = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound protocol currently has ';
		case 1:
			return 'El Compound Protocol actualmente tiene';
		case 2:
			return 'Compound 协议目前有 ';
		case 3:
			return 'Le protocole composé a actuellement';
		default:
			return 'Compound 프로토콜은 현재 ';
	}
};
var $author$project$Strings$Translations$carousel_suffix_1 = function (lang) {
	switch (lang) {
		case 0:
			return ' of assets earning interest across ';
		case 1:
			return 'de activos que generan intereses en';
		case 2:
			return ' 赚取利息的资产 ';
		case 3:
			return 'des actifs générant des intérêts';
		default:
			return ' 이자 수익 기록 중 ';
	}
};
var $author$project$Strings$Translations$carousel_suffix_1_num_markets = F2(
	function (lang, numMarkets) {
		switch (lang) {
			case 0:
				return ' ' + (numMarkets + ' markets');
			case 1:
				return '' + (numMarkets + ' mercados');
			case 2:
				return '' + (numMarkets + '个市场');
			case 3:
				return '' + (numMarkets + ' marchés');
			default:
				return '' + (numMarkets + ' 개 마켓 합계 기준');
		}
	});
var $author$project$Strings$Translations$carousel_suffix_2 = F2(
	function (lang, cToken) {
		switch (lang) {
			case 0:
				return ' of ' + (cToken + ' earning  ');
			case 1:
				return 'de ' + (cToken + ' ganar');
			case 2:
				return ' ' + (cToken + ' 的收入  ');
			case 3:
				return 'de ' + (cToken + ' gains');
			default:
				return ' ' + (cToken + ' 수익 기록 중');
		}
	});
var $author$project$Utils$NumberFormatter$formatEth = function (decimalValue) {
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return signString + ('Ξ' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, $author$project$Utils$NumberFormatter$tokenDecimalPlaces, false, absoluteDecimalValue));
};
var $author$project$Utils$NumberFormatter$formatEuro = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('€' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Utils$NumberFormatter$formatGbp = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('£' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Utils$NumberFormatter$formatUsd = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('$' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Preferences$formatDisplayCurrency = F4(
	function (truncated, displayCurrency, maybeEtherPrice, valueToDisplay) {
		var _v0 = A2($author$project$Preferences$getUsdAndEthValuesToDisplay, maybeEtherPrice, valueToDisplay);
		var usdValue = _v0.a;
		var ethValue = _v0.b;
		switch (displayCurrency) {
			case 0:
				return A2($elm$core$Maybe$map, $author$project$Utils$NumberFormatter$formatEth, ethValue);
			case 1:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatUsd(truncated),
					usdValue);
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbp(truncated),
					A2($elm$core$Maybe$andThen, $author$project$Preferences$calculateGbpValue, usdValue));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatEuro(truncated),
					A2($elm$core$Maybe$andThen, $author$project$Preferences$calculateEuroValue, usdValue));
		}
	});
var $author$project$Strings$Translations$interest = function (lang) {
	switch (lang) {
		case 0:
			return 'interest';
		case 1:
			return 'interesar';
		case 2:
			return '利益';
		case 3:
			return 'l\'intérêt';
		default:
			return '이자율';
	}
};
var $author$project$Utils$LandingPricesHelper$usdPerEth = function (tokens) {
	var ethPerUsd = function () {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (token) {
					return token.j4 === 'USDC';
				},
				tokens));
		if (!_v0.$) {
			var usdc = _v0.a;
			return usdc.j3;
		} else {
			return $author$project$Decimal$zero;
		}
	}();
	return A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, ethPerUsd);
};
var $author$project$Utils$DigitAnimatorHelper$valueFormattedStringToRandomDigits = function (totalValueFormattedString) {
	return A2(
		$elm$core$List$map,
		function (character) {
			var charAsString = $elm$core$String$fromChar(character);
			var _v0 = function () {
				var _v1 = $elm$core$String$toInt(charAsString);
				if (!_v1.$) {
					var digitAsInt = _v1.a;
					var digitsRange = A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						$elm$core$List$reverse(
							A2($elm$core$List$range, 0, digitAsInt)));
					var digitClass = function () {
						switch (digitAsInt) {
							case 2:
								return ' digit-thousand';
							case 7:
								return ' digit-thousand';
							case 9:
								return ' digit-hundred';
							case 1:
								return ' digit-hundred';
							case 4:
								return ' digit-ten';
							case 5:
								return ' digit-ten';
							default:
								return ' digit-thousand';
						}
					}();
					return _Utils_Tuple3(
						'',
						digitClass,
						A2($elm$core$String$join, ' ', digitsRange));
				} else {
					return ((character === ',') || (character === '.')) ? _Utils_Tuple3(' comma', '', charAsString) : _Utils_Tuple3('', '', charAsString);
				}
			}();
			var digitExtraClass = _v0.a;
			var containerExtraClass = _v0.b;
			var textContent = _v0.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('digit' + digitExtraClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('digit-container' + (containerExtraClass + ' active'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(textContent)
							]))
					]));
		},
		$elm$core$String$toList(totalValueFormattedString));
};
var $author$project$LandingSite$Home$marketsCarousel = F5(
	function (userLanguage, latestTokens, aprFormatter, carouselState, shouldAnimate) {
		var total = A3(
			$elm$core$List$foldl,
			$author$project$Decimal$add,
			$author$project$Decimal$zero,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.nx;
				},
				latestTokens));
		var numberOfMarkets = $elm$core$List$length(latestTokens);
		var numberOfMarketsString = function () {
			if (!numberOfMarkets) {
				return '–';
			} else {
				return $elm$core$String$fromInt(numberOfMarkets);
			}
		}();
		var loadingFill = shouldAnimate ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('fill')
				]),
			_List_Nil) : $elm$html$Html$text('');
		var etherPrice = $author$project$Utils$LandingPricesHelper$usdPerEth(latestTokens);
		var templateDollarFormatter = F2(
			function (formatter, value) {
				var _v1 = A3(formatter, 1, etherPrice, value);
				if (!_v1.$) {
					var string = _v1.a;
					return string;
				} else {
					return $author$project$Preferences$getPlaceholderPrefCurrency(1);
				}
			});
		var marketTotalDollarFormatter = function (tokenValue) {
			return A2(
				templateDollarFormatter,
				$author$project$Preferences$formatDisplayCurrency(true),
				tokenValue);
		};
		var totalValueDigitsView = function (totalMarketsValue) {
			var totalValueFormattedString = marketTotalDollarFormatter(
				$author$project$Preferences$EthValue(totalMarketsValue));
			var digitsListView = A2($author$project$Decimal$eq, totalMarketsValue, $author$project$Decimal$zero) ? _List_fromArray(
				[
					$elm$html$Html$text(totalValueFormattedString)
				]) : $author$project$Utils$DigitAnimatorHelper$valueFormattedStringToRandomDigits(totalValueFormattedString);
			return A2($elm$html$Html$span, _List_Nil, digitsListView);
		};
		var carouselData = function () {
			var state = carouselState.b;
			return state;
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Bootstrap$Carousel$view,
					carouselState,
					A2(
						$author$project$Bootstrap$Carousel$slides,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Bootstrap$Carousel$Slide$config,
								_List_Nil,
								$author$project$Bootstrap$Carousel$Slide$customContent(
									A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$carousel_prefix(userLanguage)),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('totals')
													]),
												_List_fromArray(
													[
														totalValueDigitsView(total)
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$carousel_suffix_1(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('totals')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Strings$Translations$carousel_suffix_1_num_markets, userLanguage, numberOfMarketsString))
													]))
											])))),
							A2(
								$elm$core$List$map,
								function (cToken) {
									return A2(
										$author$project$Bootstrap$Carousel$Slide$config,
										_List_Nil,
										$author$project$Bootstrap$Carousel$Slide$customContent(
											A2(
												$elm$html$Html$h1,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$carousel_prefix(userLanguage)),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('totals')
															]),
														_List_fromArray(
															[
																totalValueDigitsView(cToken.nx)
															])),
														$elm$html$Html$text(
														A2($author$project$Strings$Translations$carousel_suffix_2, userLanguage, cToken.j4)),
														A2(
														$elm$html$Html$br,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide')
															]),
														_List_Nil),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('totals')
															]),
														_List_fromArray(
															[
																aprFormatter(cToken.mZ)
															])),
														$elm$html$Html$text(
														' ' + $author$project$Strings$Translations$interest(userLanguage))
													]))));
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.jS;
									},
									latestTokens))),
						A2(
							$author$project$Bootstrap$Carousel$config,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$CarouselMsg),
							_List_Nil))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('carousel-indicator')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small current-index')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'0' + $elm$core$String$fromInt(carouselData.a9 + 1))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('bar')
								]),
							_List_fromArray(
								[loadingFill])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small total-slides')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'0' + $elm$core$String$fromInt(numberOfMarkets + 1))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Home$Earn = 0;
var $author$project$LandingSite$Home$Manage = 1;
var $author$project$LandingSite$Home$SelectProjectCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Strings$Translations$anchorage = function (lang) {
	switch (lang) {
		case 0:
			return 'Anchorage';
		case 1:
			return 'Anchorage';
		case 2:
			return 'Anchorage';
		case 3:
			return 'Anchorage';
		default:
			return 'Anchorage';
	}
};
var $author$project$Strings$Translations$anchorage_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Safe crypto custody complete with trading, staking, and Compound governance.';
		case 1:
			return 'Custodia de cifrado segura completa con comercio, participación y gobierno compuesto.';
		case 2:
			return '安全的加密货币托管，包括交易，抵押和复合治理。';
		case 3:
			return 'Conservation sécurisée des cryptos avec négociation, jalonnement et gouvernance composée.';
		default:
			return '거래, 스테이킹, Compound 거버넌스를 지원하는 안전한 암호화폐 보관 서비스입니다.';
	}
};
var $author$project$Strings$Translations$argent = function (lang) {
	switch (lang) {
		case 0:
			return 'Argent';
		case 1:
			return 'Argent';
		case 2:
			return 'Argent';
		case 3:
			return 'Argent';
		default:
			return 'Argent';
	}
};
var $author$project$Strings$Translations$argent_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Easily earn interest & invest; securely store & send. No seed phrase. No gas.';
		case 1:
			return 'Obtenga fácilmente intereses e invierta; almacenar y enviar de forma segura. Sin frase simiente. No hay gasolina.';
		case 2:
			return '轻松赚取利息并进行投资；安全地存储和发送。没有种子词组。没气。';
		case 3:
			return 'Gagnez facilement des intérêts et investissez; stocker et envoyer en toute sécurité. Aucune phrase de départ. Pas de gaz.';
		default:
			return '간편한 이자 수익 & 투자; 안전한 보관 & 전송. 시드 구문과 가스 비용은 필요 없습니다.';
	}
};
var $author$project$Strings$Translations$bitgo = function (lang) {
	switch (lang) {
		case 0:
			return 'Bitgo';
		case 1:
			return 'Bitgo';
		case 2:
			return 'Bitgo';
		case 3:
			return 'Bitgo';
		default:
			return 'Bitgo';
	}
};
var $author$project$Strings$Translations$bitgo_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Full-service crypto custodian, with support for both cTokens and COMP.';
		case 1:
			return 'Servicio completo de cripto custodio, con soporte para cTokens y COMP.';
		case 2:
			return '全方位服务的加密货币托管人，同时支持cToken和COMP。';
		case 3:
			return 'Dépositaire de cryptographie à service complet, avec prise en charge des cTokens et COMP.';
		default:
			return 'cToken과 COMP를 모두 지원하는 풀 서비스 암호화 관리자.';
	}
};
var $author$project$Strings$Translations$coinbase_custody = function (lang) {
	switch (lang) {
		case 0:
			return 'Coinbase Custody';
		case 1:
			return 'Coinbase Custody';
		case 2:
			return 'Coinbase Custody';
		case 3:
			return 'Coinbase Custody';
		default:
			return 'Coinbase Custody';
	}
};
var $author$project$Strings$Translations$coinbase_custody_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Secure custody for COMP & cTokens, and native support for Compound governance.';
		case 1:
			return 'Custodia segura para COMP y cTokens, y soporte nativo para la gobernanza compuesta.';
		case 2:
			return '对COMP和cToken的安全保管，以及对化合物治理的本地支持。';
		case 3:
			return 'Garde sécurisée pour COMP & cTokens et prise en charge native de la gouvernance de Compound.';
		default:
			return 'COMP & cTokens를 안전하게 보관할 수 있고, Compound 거버넌스를 지원합니다.';
	}
};
var $author$project$Strings$Translations$cointracker = function (lang) {
	switch (lang) {
		case 0:
			return 'Cointracker';
		case 1:
			return 'Cointracker';
		case 2:
			return 'Cointracker';
		case 3:
			return 'Cointracker';
		default:
			return 'Cointracker';
	}
};
var $author$project$Strings$Translations$cointracker_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Portfolio tracker and tax calculator tool, import your Compound activity.';
		case 1:
			return 'Herramienta de seguimiento de cartera y calculadora de impuestos, importe su actividad compuesta.';
		case 2:
			return '投资组合跟踪器和税收计算器工具，导入您的复合活动。';
		case 3:
			return 'Outil de suivi de portefeuille et de calculateur de taxes, importez votre activité composée.';
		default:
			return 'Compound 활동을 가져올 수 있으며, 포트폴리오 추적기 및 세금 계산기 도구를 제공합니다.';
	}
};
var $author$project$Strings$Translations$compound_dashboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Dashboard';
		case 1:
			return 'Compound Dashboard';
		case 2:
			return 'Compound Dashboard';
		case 3:
			return 'Compound Dashboard';
		default:
			return 'Compound Dashboard';
	}
};
var $author$project$Strings$Translations$compound_dashboard_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A simple, full featured dashboard, from the developers of Compound.';
		case 1:
			return 'Un tablero simple, con todas las funciones, de los desarrolladores de Compound.';
		case 2:
			return 'Compound开发人员提供的简单，功能齐全的仪表板。';
		case 3:
			return 'Un tableau de bord simple et complet, développé par les développeurs de Compound.';
		default:
			return 'Compound에서 개발한 단순하고 완전한 기능을 갖춘 대시보드입니다.';
	}
};
var $author$project$Strings$Translations$crypto_tax_tools = function (lang) {
	switch (lang) {
		case 0:
			return 'CryptoTaxTools';
		case 1:
			return 'CryptoTaxTools';
		case 2:
			return 'CryptoTaxTools';
		case 3:
			return 'CryptoTaxTools';
		default:
			return 'CryptoTaxTools';
	}
};
var $author$project$Strings$Translations$crypto_tax_tools_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Get help with tax filing instructions based on your Compound activity.';
		case 1:
			return 'Obtenga ayuda con las instrucciones de presentación de impuestos basadas en su actividad de Compuesto.';
		case 2:
			return '根据您的“化合物”活动获取有关报税说明的帮助。';
		case 3:
			return 'Obtenez de l\'aide avec les instructions de déclaration de revenus en fonction de votre activité composée.';
		default:
			return 'Compound 활동 관련 세금 신고 방법에 대해 도움을 드립니다.';
	}
};
var $author$project$Strings$Translations$defi_saver = function (lang) {
	switch (lang) {
		case 0:
			return 'DeFi Saver';
		case 1:
			return 'DeFi Saver';
		case 2:
			return 'DeFi Saver';
		case 3:
			return 'DeFi Saver';
		default:
			return 'DeFi Saver';
	}
};
var $author$project$Strings$Translations$defi_saver_description = function (lang) {
	switch (lang) {
		case 0:
			return 'An alternative Compound dashboard with automated portfolio management.';
		case 1:
			return 'Un panel compuesto alternativo con gestión de cartera automatizada.';
		case 2:
			return '具有自动投资组合管理的替代化合物仪表板。';
		case 3:
			return 'Un tableau de bord composé alternatif avec gestion de portefeuille automatisée.';
		default:
			return '자동화 된 포트폴리오 관리 기능이있는 대체 복합 대시 보드';
	}
};
var $author$project$Strings$Translations$dharma = function (lang) {
	switch (lang) {
		case 0:
			return 'Dharma';
		case 1:
			return 'Dharma';
		case 2:
			return 'Dharma';
		case 3:
			return 'Dharma';
		default:
			return 'Dharma';
	}
};
var $author$project$Strings$Translations$dharma_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Dharma is the easiest way to save & send money from anywhere in the world.';
		case 1:
			return 'Dharma es la forma más fácil de ahorrar y enviar dinero desde cualquier parte del mundo.';
		case 2:
			return 'Dharma 是世界上最简单的省钱方法。';
		case 3:
			return 'Le Dharma est le moyen le plus simple d\'économiser et d\'envoyer de l\'argent de n\'importe où dans le monde.';
		default:
			return 'Dharma는 세계 어느 곳에서나 돈을 저축하고 송금할 수 있는 가장 쉬운 방법입니다.';
	}
};
var $author$project$Strings$Translations$donut = function (lang) {
	switch (lang) {
		case 0:
			return 'Donut';
		case 1:
			return 'Donut';
		case 2:
			return 'Donut';
		case 3:
			return 'Donut';
		default:
			return 'Donut';
	}
};
var $author$project$Strings$Translations$donut_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Invest your spare change in the decentralized future.';
		case 1:
			return 'Invierta su cambio de repuesto en el futuro descentralizado.';
		case 2:
			return '在分散的未来投资您的零钱。';
		case 3:
			return 'Investissez votre monnaie de rechange dans un avenir décentralisé.';
		default:
			return '여유 자금을 탈중앙화된 미래에 투자하세요.';
	}
};
var $author$project$Strings$Translations$eidoo = function (lang) {
	switch (lang) {
		case 0:
			return 'Eidoo';
		case 1:
			return 'Eidoo';
		case 2:
			return 'Eidoo';
		case 3:
			return 'Eidoo';
		default:
			return 'Eidoo';
	}
};
var $author$project$Strings$Translations$eidoo_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Buy, sell, trade and earn in-app, or pay with Eidoo Card worldwide.';
		case 1:
			return 'Descubra DeFi a pedido. Compre, venda, negocie y gane en la aplicación, o pague con Eidoo Card en todo el mundo.';
		case 2:
			return '按需发现DeFi。在全球范围内使用Eidoo卡购买，出售，交易和赚取应用内收入或付款。';
		case 3:
			return 'Découvrez DeFi sur demande. Achetez, vendez, échangez et gagnez dans l\'application ou payez avec la carte Eidoo dans le monde entier.';
		default:
			return '전 세계에서 Eidoo 카드를 통해 구매, 판매, 거래, 결제, 앱 내 이자 수익 등의 서비스를 이용할 수 있습니다.';
	}
};
var $author$project$Strings$Translations$exodus = function (lang) {
	switch (lang) {
		case 0:
			return 'Exodus';
		case 1:
			return 'Exodus';
		case 2:
			return 'Exodus';
		case 3:
			return 'Exodus';
		default:
			return 'Exodus';
	}
};
var $author$project$Strings$Translations$exodus_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Secure, Manage, and Exchange on desktop, mobile and hardware wallets.';
		case 1:
			return 'Asegure, administre e intercambie en billeteras de escritorio, móviles y hardware.';
		case 2:
			return '在桌面，移动和硬件钱包上进行安全，管理和交换。';
		case 3:
			return 'Sécurisez, gérez et échangez sur les portefeuilles de bureau, mobiles et matériels.';
		default:
			return '데스크탑, 모바일, 하드웨어 지갑에서 보안, 관리, 거래 기능을 제공합니다.';
	}
};
var $author$project$Strings$Translations$fireblocks = function (lang) {
	switch (lang) {
		case 0:
			return 'Fireblocks';
		case 1:
			return 'Fireblocks';
		case 2:
			return 'Fireblocks';
		case 3:
			return 'Fireblocks';
		default:
			return 'Fireblocks';
	}
};
var $author$project$Strings$Translations$fireblocks_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Safely move assets between exchanges, wallets & Compound.';
		case 1:
			return 'Mueva activos de manera segura entre intercambios, billeteras y compuestos.';
		case 2:
			return '在交易所，钱包和化合物之间安全地转移资产.';
		case 3:
			return 'Déplacer en toute sécurité des actifs entre bourses, portefeuilles et composés.';
		default:
			return '거래소, 지갑 & Compound 사이에 자산을 안전하게 이동시킬 수 있습니다.';
	}
};
var $author$project$Strings$Translations$imToken = function (lang) {
	switch (lang) {
		case 0:
			return 'imToken';
		case 1:
			return 'imToken';
		case 2:
			return 'imToken';
		case 3:
			return 'imToken';
		default:
			return 'imToken';
	}
};
var $author$project$Strings$Translations$imToken_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Fully-featured crypto wallet mobile app, integrating Compound.';
		case 1:
			return 'Aplicación móvil de billetera criptográfica con todas las funciones, integrando Compuesto.';
		case 2:
			return '功能齐全的加密钱包移动应用程序，集成了Compound。';
		case 3:
			return 'Application mobile de portefeuille cryptographique complète, intégrant Compound.';
		default:
			return 'Compound가 통합된 다양한 기능을 제공하는 암호화폐 모바일 앱입니다.';
	}
};
var $author$project$Strings$Translations$instadapp = function (lang) {
	switch (lang) {
		case 0:
			return 'InstaDapp';
		case 1:
			return 'InstaDapp';
		case 2:
			return 'InstaDapp';
		case 3:
			return 'InstaDapp';
		default:
			return 'InstaDapp';
	}
};
var $author$project$Strings$Translations$instadapp_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply, borrow, and migrate MakerDAO CDPs into Compound.';
		case 1:
			return 'Suministre, pida prestado y migre los CDP de MakerDAO a Compound.';
		case 2:
			return '供应，借贷并将 MakerDAO CDPs 迁移到 Compound 中。';
		case 3:
			return 'Fournir, emprunter et migrer des CDP MakerDAO vers Compound.';
		default:
			return '공급과 대출에 참여하고, MakerDAO CDP를 Compound로 이전하세요.';
	}
};
var $author$project$Strings$Translations$linen = function (lang) {
	switch (lang) {
		case 0:
			return 'Linen';
		case 1:
			return 'Linen';
		case 2:
			return 'Linen';
		case 3:
			return 'Linen';
		default:
			return 'Linen';
	}
};
var $author$project$Strings$Translations$linen_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A high interest crypto account & debit card, in a beautiful mobile app.';
		case 1:
			return 'Una cuenta criptográfica de alto interés y tarjeta de débito, en una hermosa aplicación móvil.';
		case 2:
			return '美丽的移动应用程序中的高利息加密帐户和借记卡。';
		case 3:
			return 'Un compte crypto à intérêt élevé et une carte de débit, dans une belle application mobile.';
		default:
			return '모바일 앱에서 높은 이자율을 제공하는 암호화폐 계정 & 직불 카드를 제공합니다.';
	}
};
var $author$project$Strings$Translations$lumina = function (lang) {
	switch (lang) {
		case 0:
			return 'Lumina';
		case 1:
			return 'Lumina';
		case 2:
			return 'Lumina';
		case 3:
			return 'Lumina';
		default:
			return 'Lumina';
	}
};
var $author$project$Strings$Translations$lumina_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Institutional-grade portfolio management and tax accounting, including Compound.';
		case 1:
			return 'Gestión de cartera de grado institucional y contabilidad fiscal, incluido el Compuesto.';
		case 2:
			return '机构级投资组合管理和税收会计，包括复合。';
		case 3:
			return 'Gestion de portefeuille de qualité institutionnelle et comptabilité fiscale, y compris composé.';
		default:
			return '기관급 포트폴리오 관리 및 세무 회계를 제공합니다.';
	}
};
var $author$project$Strings$Translations$matrixport = function (lang) {
	switch (lang) {
		case 0:
			return 'Matrixport';
		case 1:
			return 'Matrixport';
		case 2:
			return 'Matrixport';
		case 3:
			return 'Matrixport';
		default:
			return 'Matrixport';
	}
};
var $author$project$Strings$Translations$matrixport_description = function (lang) {
	switch (lang) {
		case 0:
			return 'One-stop digital assets financial services.';
		case 1:
			return 'Servicios financieros de activos digitales únicos.';
		case 2:
			return '一站式数字资产金融服务。';
		case 3:
			return 'Services financiers actifs numériques à guichet unique.';
		default:
			return '원 스톱 디지털 자산 금융 서비스.';
	}
};
var $author$project$Strings$Translations$multis = function (lang) {
	switch (lang) {
		case 0:
			return 'Multis';
		case 1:
			return 'Multis';
		case 2:
			return 'Multis';
		case 3:
			return 'Multis';
		default:
			return 'Multis';
	}
};
var $author$project$Strings$Translations$multis_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A simple and powerful interface designed for teams to manage a single account.';
		case 1:
			return 'Una interfaz simple y potente diseñada para que los equipos administren una sola cuenta.';
		case 2:
			return '一个为团队管理单个帐户而设计的简单而强大的界面。';
		case 3:
			return 'Une interface simple et puissante conçue pour que les équipes gèrent un seul compte.';
		default:
			return '단일 계정을 관리하는 팀을 위해 설계된 간단하고 강력한 인터페이스입니다.';
	}
};
var $author$project$Strings$Translations$pool_together = function (lang) {
	switch (lang) {
		case 0:
			return 'Pool Together';
		case 1:
			return 'Pool Together';
		case 2:
			return 'Pool Together';
		case 3:
			return 'Pool Together';
		default:
			return 'Pool Together';
	}
};
var $author$project$Strings$Translations$pool_together_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A no-loss lottery utilizing the interest earned in Compound as the prize.';
		case 1:
			return 'Una lotería sin pérdidas que utiliza el interés ganado en Compound como premio.';
		case 2:
			return '以 Compound 利息为奖品的无损失彩票。';
		case 3:
			return 'Une loterie sans perte utilisant les intérêts gagnés dans le composé comme prix.';
		default:
			return 'Compound에서 발생한 이자를 상금으로 제공하는 무손실 복권 서비스를 제공합니다.';
	}
};
var $author$project$Strings$Translations$product_showcase_earn = function (lang) {
	switch (lang) {
		case 0:
			return 'Earn';
		case 1:
			return 'Ganar';
		case 2:
			return '赚';
		case 3:
			return 'Gagner';
		default:
			return '이자 수익';
	}
};
var $author$project$Strings$Translations$product_showcase_institutions = function (lang) {
	switch (lang) {
		case 0:
			return 'Institutions';
		case 1:
			return 'Instituciones';
		case 2:
			return '机构';
		case 3:
			return 'Les institutions';
		default:
			return '기관';
	}
};
var $author$project$Strings$Translations$product_showcase_manage = function (lang) {
	switch (lang) {
		case 0:
			return 'Manage';
		case 1:
			return 'Gestionar';
		case 2:
			return '管理';
		case 3:
			return 'Gérer';
		default:
			return '관리';
	}
};
var $author$project$LandingSite$Home$projectCard = F4(
	function (projectUrl, projectName, projectTitle, projectDescription) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
						$author$project$Utils$CompoundHtmlAttributes$target('_blank')
					]),
				A2($author$project$Utils$CompoundHtmlAttributes$href, 2, projectUrl)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('icon icon--' + projectName)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(projectTitle)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-description')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(projectDescription)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-try')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('small')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Try')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
											$author$project$Utils$CompoundHtmlAttributes$class('arrow')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$token_sets = function (lang) {
	switch (lang) {
		case 0:
			return 'TokenSets';
		case 1:
			return 'TokenSets';
		case 2:
			return 'TokenSets';
		case 3:
			return 'TokenSets';
		default:
			return 'TokenSets';
	}
};
var $author$project$Strings$Translations$token_sets_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Automated trading strategies, using cTokens and Ethereum assets.';
		case 1:
			return 'Estrategias comerciales automatizadas, utilizando cTokens y activos de Ethereum.';
		case 2:
			return '使用cToken和以太坊资产的自动化交易策略。';
		case 3:
			return 'Stratégies de trading automatisées, utilisant les actifs cTokens et Ethereum.';
		default:
			return 'cToken과 이더리움 자산을 이용해 자동화된 거래 전략을 제공합니다.';
	}
};
var $author$project$Strings$Translations$token_tax = function (lang) {
	switch (lang) {
		case 0:
			return 'Tokentax';
		case 1:
			return 'Tokentax';
		case 2:
			return 'Tokentax';
		case 3:
			return 'Tokentax';
		default:
			return 'Tokentax';
	}
};
var $author$project$Strings$Translations$token_tax_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Tax software and cryptocurrency accounting firm, to help with your Compound activity.';
		case 1:
			return 'Software de impuestos y firma de contabilidad de criptomonedas, para ayudarlo con su actividad de Compuestos.';
		case 2:
			return '税务软件和加密货币会计公司，以帮助您进行复合活动。';
		case 3:
			return 'Logiciel fiscal et cabinet de comptabilité en crypto-monnaie, pour vous aider dans votre activité Composé.';
		default:
			return 'Compound 활동에 도움이 되는 세금 소프트웨어와 암호화폐 회계 서비스를 제공합니다.';
	}
};
var $author$project$Strings$Translations$zengo = function (lang) {
	switch (lang) {
		case 0:
			return 'ZenGo';
		case 1:
			return 'ZenGo';
		case 2:
			return 'ZenGo';
		case 3:
			return 'ZenGo';
		default:
			return 'ZenGo';
	}
};
var $author$project$Strings$Translations$zengo_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A keyless crypto wallet, built mobile-first, and supports Compound.';
		case 1:
			return 'Una billetera criptográfica sin llave, construida primero para dispositivos móviles y compatible con Compound.';
		case 2:
			return '一种无钥匙的加密钱包，首先构建为移动设备，并支持Compound。';
		case 3:
			return 'Un portefeuille crypto sans clé, conçu pour le mobile d\'abord, et prend en charge Compound.';
		default:
			return '모바일 중심으로 구축된 키가 없는 암호화 지갑이며 Compound를 지원합니다.';
	}
};
var $author$project$Strings$Translations$zerion = function (lang) {
	switch (lang) {
		case 0:
			return 'Zerion';
		case 1:
			return 'Zerion';
		case 2:
			return 'Zerion';
		case 3:
			return 'Zerion';
		default:
			return 'Zerion';
	}
};
var $author$project$Strings$Translations$zerion_description = function (lang) {
	switch (lang) {
		case 0:
			return 'An intuitive interface to blockchain-based protocols for decentralized finance.';
		case 1:
			return 'Una interfaz intuitiva para protocolos basados en blockchain para finanzas descentralizadas.';
		case 2:
			return '基于区块链的分布式融资协议的直观界面。';
		case 3:
			return 'Une interface intuitive pour les protocoles basés sur la blockchain pour la finance décentralisée.';
		default:
			return '탈중앙형 금융을 위한 블록체인 기반 프로토콜에 직관적인 인터페이스를 제공합니다.';
	}
};
var $author$project$LandingSite$Home$projectsCarousel = F2(
	function (userLanguage, _v0) {
		var projectsCarouselState = _v0.aY;
		var selectedProjectCategory = _v0.ew;
		var tabOptionClass = function (category) {
			return _Utils_eq(category, selectedProjectCategory) ? 'tab-group__option tab-group__option--active tab-group__option--active--green' : 'tab-group__option';
		};
		var slideClass = function (category) {
			return _Utils_eq(category, selectedProjectCategory) ? 'projects__carousel__slide projects__carousel__slide--active' : 'projects__carousel__slide';
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('projects')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('tab-group projects__tab-group')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('tab-group__options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class(
											tabOptionClass(2)),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$Home$SelectProjectCategory(2))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$product_showcase_institutions(userLanguage))
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class(
											tabOptionClass(0)),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$Home$SelectProjectCategory(0))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$product_showcase_earn(userLanguage))
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class(
											tabOptionClass(1)),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$Home$SelectProjectCategory(1))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$product_showcase_manage(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('tab-group__line')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 projects__carousel')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Bootstrap$Carousel$view,
									projectsCarouselState,
									A2(
										$author$project$Bootstrap$Carousel$slides,
										_List_fromArray(
											[
												A2(
												$author$project$Bootstrap$Carousel$Slide$config,
												_List_Nil,
												$author$project$Bootstrap$Carousel$Slide$customContent(
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class(
																slideClass(2))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('row')
																	]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://custody.coinbase.com',
																		'coinbase-custody',
																		$author$project$Strings$Translations$coinbase_custody(userLanguage),
																		$author$project$Strings$Translations$coinbase_custody_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://anchorage.com',
																		'anchorage',
																		$author$project$Strings$Translations$anchorage(userLanguage),
																		$author$project$Strings$Translations$anchorage_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.fireblocks.com',
																		'fireblocks',
																		$author$project$Strings$Translations$fireblocks(userLanguage),
																		$author$project$Strings$Translations$fireblocks_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.bitgo.com/',
																		'bitgo',
																		$author$project$Strings$Translations$bitgo(userLanguage),
																		$author$project$Strings$Translations$bitgo_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.lumina.app/',
																		'lumina',
																		$author$project$Strings$Translations$lumina(userLanguage),
																		$author$project$Strings$Translations$lumina_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://cryptotaxtools.com',
																		'cryptotax',
																		$author$project$Strings$Translations$crypto_tax_tools(userLanguage),
																		$author$project$Strings$Translations$crypto_tax_tools_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://tokentax.co',
																		'tokentax',
																		$author$project$Strings$Translations$token_tax(userLanguage),
																		$author$project$Strings$Translations$token_tax_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.cointracker.io',
																		'cointracker',
																		$author$project$Strings$Translations$cointracker(userLanguage),
																		$author$project$Strings$Translations$cointracker_description(userLanguage))
																	]))
															])))),
												A2(
												$author$project$Bootstrap$Carousel$Slide$config,
												_List_Nil,
												$author$project$Bootstrap$Carousel$Slide$customContent(
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class(
																slideClass(0))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('row')
																	]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.dharma.io/',
																		'dharma',
																		$author$project$Strings$Translations$dharma(userLanguage),
																		$author$project$Strings$Translations$dharma_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.argent.xyz/',
																		'argent',
																		$author$project$Strings$Translations$argent(userLanguage),
																		$author$project$Strings$Translations$argent_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://linen.app/',
																		'linen',
																		$author$project$Strings$Translations$linen(userLanguage),
																		$author$project$Strings$Translations$linen_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://zerion.io/en',
																		'zerion',
																		$author$project$Strings$Translations$zerion(userLanguage),
																		$author$project$Strings$Translations$zerion_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.pooltogether.us',
																		'pool-together',
																		$author$project$Strings$Translations$pool_together(userLanguage),
																		$author$project$Strings$Translations$pool_together_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://zengo.com',
																		'zengo',
																		$author$project$Strings$Translations$zengo(userLanguage),
																		$author$project$Strings$Translations$zengo_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://token.im/',
																		'imToken',
																		$author$project$Strings$Translations$imToken(userLanguage),
																		$author$project$Strings$Translations$imToken_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.donut.app/',
																		'donut',
																		$author$project$Strings$Translations$donut(userLanguage),
																		$author$project$Strings$Translations$donut_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.matrixport.com/',
																		'matrixport',
																		$author$project$Strings$Translations$matrixport(userLanguage),
																		$author$project$Strings$Translations$matrixport_description(userLanguage))
																	]))
															])))),
												A2(
												$author$project$Bootstrap$Carousel$Slide$config,
												_List_Nil,
												$author$project$Bootstrap$Carousel$Slide$customContent(
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class(
																slideClass(1))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('row')
																	]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://app.compound.finance/',
																		'compound',
																		$author$project$Strings$Translations$compound_dashboard(userLanguage),
																		$author$project$Strings$Translations$compound_dashboard_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://instadapp.io/compound/',
																		'instadapp',
																		$author$project$Strings$Translations$instadapp(userLanguage),
																		$author$project$Strings$Translations$instadapp_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.tokensets.com/set/ethrsiapy',
																		'token-sets',
																		$author$project$Strings$Translations$token_sets(userLanguage),
																		$author$project$Strings$Translations$token_sets_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://defisaver.com/compound/manage',
																		'defi-saver',
																		$author$project$Strings$Translations$defi_saver(userLanguage),
																		$author$project$Strings$Translations$defi_saver_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://www.exodus.io',
																		'exodus',
																		$author$project$Strings$Translations$exodus(userLanguage),
																		$author$project$Strings$Translations$exodus_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://multis.co/',
																		'multis',
																		$author$project$Strings$Translations$multis(userLanguage),
																		$author$project$Strings$Translations$multis_description(userLanguage)),
																		A4(
																		$author$project$LandingSite$Home$projectCard,
																		'https://eidoo.io/',
																		'eidoo',
																		$author$project$Strings$Translations$eidoo(userLanguage),
																		$author$project$Strings$Translations$eidoo_description(userLanguage))
																	]))
															]))))
											]),
										A2(
											$author$project$Bootstrap$Carousel$config,
											A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$ProjectsCarouselMsg),
											_List_Nil)))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$protocol_docs = function (lang) {
	switch (lang) {
		case 0:
			return 'Protocol Docs';
		case 1:
			return 'Documentos de protocolo';
		case 2:
			return '协议文件';
		case 3:
			return 'Documents de protocole';
		default:
			return '프로토콜 문서';
	}
};
var $author$project$Strings$Translations$protocol_security = function (lang) {
	switch (lang) {
		case 0:
			return 'Protocol Security';
		case 1:
			return 'Protocolo de seguridad';
		case 2:
			return '协议安全';
		case 3:
			return 'Sécurité du protocole';
		default:
			return '프로토콜 보안';
	}
};
var $author$project$LandingSite$Home$securityCard = F2(
	function (contentList, maybeContentClass) {
		var contentClass = A2($elm$core$Maybe$withDefault, '', maybeContentClass);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('security-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('security-panel__background')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('security-panel__content security-panel__content--' + contentClass)
								]),
							contentList)
						]))
				]));
	});
var $author$project$Strings$Translations$security_audit = function (lang) {
	switch (lang) {
		case 0:
			return 'Security Audit';
		case 1:
			return 'Auditoria de seguridad';
		case 2:
			return '安全审核';
		case 3:
			return 'Audit de sécurité';
		default:
			return '보안 감사';
	}
};
var $author$project$Strings$Translations$try_compound = function (lang) {
	switch (lang) {
		case 0:
			return 'Try Compound';
		case 1:
			return 'Probar Compound';
		case 2:
			return '体验 Compound';
		case 3:
			return 'Essayez le composé';
		default:
			return 'Compound 체험하기';
	}
};
var $author$project$Strings$Translations$try_compound_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Community-built interfaces integrating the protocol';
		case 1:
			return 'Interfaces construidas en la comunidad que integran el protocolo.';
		case 2:
			return '社区构建的集成协议的接口';
		case 3:
			return 'Interfaces communautaires intégrant le protocole';
		default:
			return '프로토콜이 통합된 커뮤니티 기반 인터페이스';
	}
};
var $author$project$LandingSite$Home$view = F3(
	function (userLanguage, maybeLatestTokens, model) {
		var latestTokens = function () {
			if (!maybeLatestTokens.$) {
				var tokens = maybeLatestTokens.a;
				return tokens.kG;
			} else {
				return _List_Nil;
			}
		}();
		var shouldAnimate = !$elm$core$List$isEmpty(latestTokens);
		var aprFormatter = function (rate) {
			return $elm$html$Html$text(
				$author$project$Utils$NumberFormatter$formatPercentage(rate));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('landing-overview')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$id('dot-grid')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('illo')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-10 text-left compound-data')
												]),
											_List_fromArray(
												[
													A5($author$project$LandingSite$Home$marketsCarousel, userLanguage, latestTokens, aprFormatter, model.bL, shouldAnimate)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 text-left compound-description')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$compound_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Docs, 0, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$protocol_docs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('try-compound')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large try-compound')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-5 text-left try-compound__header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$try_compound(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$try_compound_description(userLanguage))
														]))
												]))
										])),
									A2($author$project$LandingSite$Home$projectsCarousel, userLanguage, model),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-left')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-right')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('security-home')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$audited_and_verified(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$audited_and_verified_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															A2(
																$elm$core$List$cons,
																$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Docs, 6, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$protocol_security(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('audits')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2(
																	$author$project$LandingSite$Page$Docs,
																	6,
																	$elm$core$Maybe$Just('audits'))))),
													_List_fromArray(
														[
															A2(
															$author$project$LandingSite$Home$securityCard,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--oz')
																		]),
																	_List_Nil),
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$security_audit(userLanguage))
																]),
															$elm$core$Maybe$Nothing)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2(
																	$author$project$LandingSite$Page$Docs,
																	6,
																	$elm$core$Maybe$Just('audits'))))),
													_List_fromArray(
														[
															A2(
															$author$project$LandingSite$Home$securityCard,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--tob')
																		]),
																	_List_Nil),
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$security_audit(userLanguage))
																]),
															$elm$core$Maybe$Nothing)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2(
																	$author$project$LandingSite$Page$Docs,
																	6,
																	$elm$core$Maybe$Just('formal-verification'))))),
													_List_fromArray(
														[
															A2(
															$author$project$LandingSite$Home$securityCard,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--certora')
																		]),
																	_List_Nil),
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$formal_verification(userLanguage))
																]),
															$elm$core$Maybe$Nothing)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2(
																	$author$project$LandingSite$Page$Docs,
																	6,
																	$elm$core$Maybe$Just('economic-security'))))),
													_List_fromArray(
														[
															A2(
															$author$project$LandingSite$Home$securityCard,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--gauntlet')
																		]),
																	_List_Nil),
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$market_risk_assessment(userLanguage))
																]),
															$elm$core$Maybe$Nothing)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 col-xs-12'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2(
																	$author$project$LandingSite$Page$Docs,
																	6,
																	$elm$core$Maybe$Just('bug-bounty'))))),
													_List_fromArray(
														[
															A2(
															$author$project$LandingSite$Home$securityCard,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('audits__bug-bounty')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('audits__bug-bounty__image-section')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--bug-bounty')
																						]),
																					_List_Nil)
																				])),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('audits__bug-bounty__text-section')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('audits__bug-bounty__text-section__bounty')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('$')
																								])),
																							A2(
																							$elm$html$Html$h2,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('audits__bug-bounty__text-section__bounty__value')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text('150,000')
																								])),
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('00')
																								]))
																						])),
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$bug_bounty(userLanguage))
																				]))
																		]))
																]),
															$elm$core$Maybe$Just('bug-bounty'))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('investors-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 text-left')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('label big')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$backed_by(userLanguage))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('summary')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$backed_by_description(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('investors-section__investors')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('row')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://a16z.com/crypto/')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--a16z')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																])),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.baincapitalventures.com/')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--bain')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																])),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://ventures.coinbase.com')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--coinbase')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																])),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.paradigm.xyz')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--paradigm')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																])),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://polychain.capital')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--polychain')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																])),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-6'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.dcp.capital')),
															_List_fromArray(
																[
																	A2(
																	$author$project$LandingSite$Home$securityCard,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('security-panel__image security-panel__image--dragonfly')
																				]),
																			_List_Nil)
																		]),
																	$elm$core$Maybe$Nothing)
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$MarketDetail$BorrowTab = 1;
var $author$project$LandingSite$MarketDetail$SelectTab = function (a) {
	return {$: 0, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$Paint = function (a) {
	return {$: 0, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$PaintNone = {$: 4};
var $elm_community$typed_svg$TypedSvg$Types$Translate = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm_community$typed_svg$TypedSvg$Types$AnchorMiddle = 2;
var $author$project$LandingSite$MarketDetail$adjustedTextXOffset = F3(
	function (_v0, initialX, textHalfWidthInPx) {
		var fullWidth = _v0.bV;
		var padding = _v0.R;
		return ((initialX - textHalfWidthInPx) < 0) ? textHalfWidthInPx : ((_Utils_cmp(initialX + textHalfWidthInPx, fullWidth - (2 * padding)) > 0) ? ((fullWidth - (2 * padding)) - textHalfWidthInPx) : initialX);
	});
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Strings$Translations$borrow_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow APY';
		case 1:
			return 'Pedir prestado APY';
		case 2:
			return '借用APY';
		case 3:
			return 'Emprunter APY';
		default:
			return '대출 APY';
	}
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$circle = $elm_community$typed_svg$TypedSvg$Core$node('circle');
var $elm_community$typed_svg$TypedSvg$Attributes$class = function (names) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'class',
		A2($elm$core$String$join, ' ', names));
};
var $gampleman$elm_visualization$Scale$convert = F2(
	function (_v0, value) {
		var scale = _v0;
		return A3(scale.L, scale.ff, scale.bv, value);
	});
var $ryannhg$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$LandingSite$MarketDetail$dateFormat = A2(
	$ryannhg$date_format$DateFormat$format,
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$dayOfMonthNumber
		]),
	$elm$time$Time$utc);
var $elm_community$typed_svg$TypedSvg$g = $elm_community$typed_svg$TypedSvg$Core$node('g');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString = function (length) {
	switch (length.$) {
		case 0:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'cm';
		case 1:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'em';
		case 2:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'ex';
		case 3:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'in';
		case 4:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'mm';
		case 5:
			var x = length.a;
			return $elm$core$String$fromFloat(x);
		case 6:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pc';
		case 7:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + '%';
		case 8:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'pt';
		default:
			var x = length.a;
			return $elm$core$String$fromFloat(x) + 'px';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$height = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'height',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Types$Px = function (a) {
	return {$: 9, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$px = $elm_community$typed_svg$TypedSvg$Types$Px;
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$height = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$height(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$image = $elm_community$typed_svg$TypedSvg$Core$node('image');
var $elm_community$typed_svg$TypedSvg$line = $elm_community$typed_svg$TypedSvg$Core$node('line');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString = function (paint) {
	switch (paint.$) {
		case 0:
			var color = paint.a;
			return $avh4$elm_color$Color$toCssString(color);
		case 1:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['url(#', string, ')']));
		case 2:
			return 'context-fill';
		case 3:
			return 'context-stroke';
		default:
			return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$stroke = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('stroke'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $elm_community$typed_svg$TypedSvg$Attributes$strokeDasharray = $elm_community$typed_svg$TypedSvg$Core$attribute('stroke-dasharray');
var $author$project$Strings$Translations$supply_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply APY';
		case 1:
			return 'Suministro APY';
		case 2:
			return '存款年利率';
		case 3:
			return 'Supply APY';
		default:
			return '공급 APY';
	}
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$anchorAlignmentToString = function (anchorAlignment) {
	switch (anchorAlignment) {
		case 0:
			return 'inherit';
		case 1:
			return 'start';
		case 2:
			return 'middle';
		default:
			return 'end';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$textAnchor = function (anchorAlignment) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'text-anchor',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$anchorAlignmentToString(anchorAlignment));
};
var $elm_community$typed_svg$TypedSvg$text_ = $elm_community$typed_svg$TypedSvg$Core$node('text');
var $gampleman$elm_visualization$Scale$Scale = $elm$core$Basics$identity;
var $gampleman$elm_visualization$Scale$toRenderable = F2(
	function (toString, _v0) {
		var scale = _v0;
		return {
			L: F3(
				function (dmn, rng, value) {
					return A3(scale.L, dmn, rng, value) + (A2($elm$core$Basics$max, scale.eM - 1, 0) / 2);
				}),
			ff: scale.ff,
			bv: scale.bv,
			ck: F2(
				function (_v1, rng) {
					return rng;
				}),
			gS: F2(
				function (_v2, _v3) {
					return toString;
				}),
			z: F2(
				function (dmn, _v4) {
					return dmn;
				})
		};
	});
var $author$project$Strings$Translations$total_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Borrow';
		case 1:
			return 'Préstamo total';
		case 2:
			return '总借贷';
		case 3:
			return 'Emprunt total';
		default:
			return '대출 합계';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$width = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$width = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$width(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x1 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x1',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x1 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x1(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$x2 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'x2',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$x2 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$x2(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y1 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y1',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y1 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y1(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$Attributes$y2 = function (position) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'y2',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(position));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$y2 = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$y2(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $author$project$LandingSite$MarketDetail$activeCircle = F5(
	function (userLanguage, isSupply, graphConfig, _v0, doubleGraphHoverTime) {
		var barDatapoints = _v0.eO;
		var lineDatapoints = _v0.ea;
		var xScale = _v0.bF;
		var yLineScale = _v0.eF;
		var yBarScale = _v0.eE;
		if (!doubleGraphHoverTime.$) {
			var activeHoverTime = doubleGraphHoverTime.a;
			var maybeActiveRatePoint = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v7) {
						var date = _v7.a;
						return _Utils_eq(activeHoverTime, date);
					},
					lineDatapoints));
			var maybeActiveBarPoint = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v6) {
						var date = _v6.a;
						return _Utils_eq(activeHoverTime, date);
					},
					barDatapoints));
			var _v2 = _Utils_Tuple2(maybeActiveRatePoint, maybeActiveBarPoint);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var _v3 = _v2.a.a;
				var lineValue = _v3.b;
				var _v4 = _v2.b.a;
				var date = _v4.a;
				var barValue = _v4.b;
				var totalsValueText = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$fromFloat(barValue),
					A2(
						$elm$core$Maybe$map,
						$author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions,
						$author$project$Decimal$fromFloat(barValue)));
				var totalsText = isSupply ? $author$project$Strings$Translations$total_supply(userLanguage) : $author$project$Strings$Translations$total_borrow(userLanguage);
				var initialX = A2(
					$gampleman$elm_visualization$Scale$convert,
					A2($gampleman$elm_visualization$Scale$toRenderable, $author$project$LandingSite$MarketDetail$dateFormat, xScale),
					activeHoverTime);
				var rateTextOffset = A3($author$project$LandingSite$MarketDetail$adjustedTextXOffset, graphConfig, initialX, 10 * 3);
				var totalsTextOffset = A3($author$project$LandingSite$MarketDetail$adjustedTextXOffset, graphConfig, initialX, 12 * 3);
				var dotHeightWidth = 38;
				var dateTextOffset = A3($author$project$LandingSite$MarketDetail$adjustedTextXOffset, graphConfig, initialX, 10 * 2);
				var activeRateString = $author$project$Utils$NumberFormatter$formatRate(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						$author$project$Decimal$fromFloat(lineValue)));
				var _v5 = isSupply ? _Utils_Tuple2(
					'/images/line-graph-hover-icn-supply.svg',
					$author$project$Strings$Translations$supply_apy(userLanguage)) : _Utils_Tuple2(
					'/images/line-graph-hover-icn-borrow.svg',
					$author$project$Strings$Translations$borrow_apy(userLanguage));
				var imagePath = _v5.a;
				var rateText = _v5.b;
				return A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['double-graph-active-hover']))
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$typed_svg$TypedSvg$image,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
									(A2($gampleman$elm_visualization$Scale$convert, xScale, activeHoverTime) - (dotHeightWidth / 4)) - 2),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
									A2($gampleman$elm_visualization$Scale$convert, yLineScale, lineValue) - (dotHeightWidth / 2)),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(dotHeightWidth),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(dotHeightWidth),
									A2($elm_community$typed_svg$TypedSvg$Core$attribute, 'href', imagePath)
								]),
							_List_Nil),
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(rateTextOffset),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
									A2($gampleman$elm_visualization$Scale$convert, yLineScale, lineValue) - 20),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(rateText)
								])),
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(rateTextOffset),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
									A2($gampleman$elm_visualization$Scale$convert, yLineScale, lineValue) - 35),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2),
									$elm_community$typed_svg$TypedSvg$Attributes$class(
									_List_fromArray(
										['highlight large']))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(activeRateString)
								])),
							A2(
							$elm_community$typed_svg$TypedSvg$line,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1(
									A2($gampleman$elm_visualization$Scale$convert, xScale, date) + 7),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(
									A2($gampleman$elm_visualization$Scale$convert, yBarScale, barValue) - (2 * graphConfig.R)),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2(
									A2($gampleman$elm_visualization$Scale$convert, xScale, date) + 7),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(
									A2($gampleman$elm_visualization$Scale$convert, yBarScale, barValue) - 12),
									$elm_community$typed_svg$TypedSvg$Attributes$strokeDasharray('3,3'),
									$elm_community$typed_svg$TypedSvg$Attributes$stroke(
									$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$LineChart$Colors$gray))
								]),
							_List_Nil),
							A2(
							$elm_community$typed_svg$TypedSvg$line,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x1(
									A2($gampleman$elm_visualization$Scale$convert, xScale, date) + 7),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y1(
									A2($gampleman$elm_visualization$Scale$convert, yBarScale, barValue) - 48),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x2(
									A2($gampleman$elm_visualization$Scale$convert, xScale, date) + 7),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y2(
									A2($gampleman$elm_visualization$Scale$convert, yLineScale, lineValue) + (38 / 4)),
									$elm_community$typed_svg$TypedSvg$Attributes$strokeDasharray('3,3'),
									$elm_community$typed_svg$TypedSvg$Attributes$stroke(
									$elm_community$typed_svg$TypedSvg$Types$Paint($author$project$LineChart$Colors$gray))
								]),
							_List_Nil),
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(totalsTextOffset),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
									A2($gampleman$elm_visualization$Scale$convert, yBarScale, barValue) - 30),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2),
									$elm_community$typed_svg$TypedSvg$Attributes$class(
									_List_fromArray(
										['highlight large']))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalsValueText)
								])),
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(totalsTextOffset),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
									A2($gampleman$elm_visualization$Scale$convert, yBarScale, barValue) - 15),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalsText)
								])),
							A2(
							$elm_community$typed_svg$TypedSvg$text_,
							_List_fromArray(
								[
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(dateTextOffset),
									$elm_community$typed_svg$TypedSvg$Attributes$InPx$y((graphConfig.as - graphConfig.cD) + 15),
									$elm_community$typed_svg$TypedSvg$Attributes$textAnchor(2),
									$elm_community$typed_svg$TypedSvg$Attributes$class(
									_List_fromArray(
										['highlight']))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$LandingSite$MarketDetail$dateFormat(date))
								]))
						]));
			} else {
				return A2($elm_community$typed_svg$TypedSvg$circle, _List_Nil, _List_Nil);
			}
		} else {
			return A2($elm_community$typed_svg$TypedSvg$circle, _List_Nil, _List_Nil);
		}
	});
var $author$project$LineChart$Colors$borrow = A3($avh4$elm_color$Color$rgb255, 150, 105, 237);
var $author$project$LandingSite$MarketDetailHelper$buildInterestRateGraphData = F3(
	function (cTokenAddress, interestRateDataMap, formatter) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Eth$Ethereum$getContractAddressString(cTokenAddress),
			interestRateDataMap);
		if (!_v0.$) {
			var interestRateData = _v0.a;
			var tupleFirstComparison = F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						$elm$time$Time$posixToMillis(a.a),
						$elm$time$Time$posixToMillis(b.a));
				});
			return A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.a;
						var v = _v1.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(
								formatter(v)));
					},
					$elm$core$Dict$toList(interestRateData)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$LandingSite$MarketDetailHelper$buildMarketUsdTotalBorrowGraphData = F3(
	function (cTokenAddress, marketTotalsDataMap, pricesDataMap) {
		var cTokenAddressString = $author$project$Eth$Ethereum$getContractAddressString(cTokenAddress);
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Dict$get, cTokenAddressString, marketTotalsDataMap),
			A2($elm$core$Dict$get, cTokenAddressString, pricesDataMap));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var marketTotalsData = _v0.a.a;
			var pricesData = _v0.b.a;
			var tupleFirstComparison = F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						$elm$time$Time$posixToMillis(a.a),
						$elm$time$Time$posixToMillis(b.a));
				});
			var rawMarketTotals = A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v4) {
						var k = _v4.a;
						var v = _v4.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(v));
					},
					$elm$core$Dict$toList(marketTotalsData)));
			var prices = A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v3) {
						var k = _v3.a;
						var v = _v3.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(v));
					},
					$elm$core$Dict$toList(pricesData)));
			return A3(
				$elm$core$List$map2,
				F2(
					function (_v1, _v2) {
						var time = _v1.a;
						var marketTotal = _v1.b;
						var price = _v2.b;
						return _Utils_Tuple2(time, marketTotal * price);
					}),
				rawMarketTotals,
				prices);
		} else {
			return _List_Nil;
		}
	});
var $author$project$LandingSite$MarketDetailHelper$buildMarketUsdTotalSupplyGraphData = F4(
	function (cTokenAddress, marketTotalsDataMap, exchangeRatesDataMap, pricesDataMap) {
		var cTokenAddressString = $author$project$Eth$Ethereum$getContractAddressString(cTokenAddress);
		var _v0 = _Utils_Tuple3(
			A2($elm$core$Dict$get, cTokenAddressString, marketTotalsDataMap),
			A2($elm$core$Dict$get, cTokenAddressString, exchangeRatesDataMap),
			A2($elm$core$Dict$get, cTokenAddressString, pricesDataMap));
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var marketTotalsData = _v0.a.a;
			var exchangeRateData = _v0.b.a;
			var pricesData = _v0.c.a;
			var tupleFirstComparison = F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						$elm$time$Time$posixToMillis(a.a),
						$elm$time$Time$posixToMillis(b.a));
				});
			var rawMarketTotals = A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v6) {
						var k = _v6.a;
						var v = _v6.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(v));
					},
					$elm$core$Dict$toList(marketTotalsData)));
			var prices = A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v5) {
						var k = _v5.a;
						var v = _v5.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(v));
					},
					$elm$core$Dict$toList(pricesData)));
			var exchangeRates = A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v4) {
						var k = _v4.a;
						var v = _v4.b;
						return _Utils_Tuple2(
							$elm$time$Time$millisToPosix(k * 1000),
							$author$project$Decimal$toFloat(v));
					},
					$elm$core$Dict$toList(exchangeRateData)));
			return A4(
				$elm$core$List$map3,
				F3(
					function (_v1, _v2, _v3) {
						var time = _v1.a;
						var marketTotal = _v1.b;
						var exchangeRate = _v2.b;
						var price = _v3.b;
						return _Utils_Tuple2(time, (marketTotal * exchangeRate) * price);
					}),
				rawMarketTotals,
				exchangeRates,
				prices);
		} else {
			return _List_Nil;
		}
	});
var $gampleman$elm_visualization$Scale$bandwidth = function (_v0) {
	var scale = _v0;
	return scale.eM;
};
var $author$project$LandingSite$MarketDetail$DoubleGraphBarMouseOut = function (a) {
	return {$: 2, a: a};
};
var $elm$svg$Svg$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$LandingSite$MarketDetail$onBarMouseOut = function (date) {
	return $elm$svg$Svg$Events$onMouseOut(
		$author$project$LandingSite$MarketDetail$ForSelf(
			$author$project$LandingSite$MarketDetail$DoubleGraphBarMouseOut(date)));
};
var $author$project$LandingSite$MarketDetail$DoubleGraphBarMouseOver = function (a) {
	return {$: 1, a: a};
};
var $elm$svg$Svg$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$LandingSite$MarketDetail$onBarMouseOver = function (date) {
	return $elm$svg$Svg$Events$onMouseOver(
		$author$project$LandingSite$MarketDetail$ForSelf(
			$author$project$LandingSite$MarketDetail$DoubleGraphBarMouseOver(date)));
};
var $elm_community$typed_svg$TypedSvg$rect = $elm_community$typed_svg$TypedSvg$Core$node('rect');
var $author$project$LandingSite$MarketDetail$column = F4(
	function (_v0, doubleGraphHoverTime, _v1, _v2) {
		var fullHeight = _v0.as;
		var padding = _v0.R;
		var barGraphXAxisLabelHeight = _v0.cD;
		var xScale = _v1.bF;
		var yBarScale = _v1.eE;
		var date = _v2.a;
		var value = _v2.b;
		var isBarActive = function () {
			if (!doubleGraphHoverTime.$) {
				var activeHoverTime = doubleGraphHoverTime.a;
				return _Utils_eq(activeHoverTime, date);
			} else {
				return false;
			}
		}();
		var barClass = isBarActive ? 'bar-graph__bar bar-graph__bar--active' : 'bar-graph__bar';
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						[barClass]))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
							A2($gampleman$elm_visualization$Scale$convert, xScale, date)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(
							A2($gampleman$elm_visualization$Scale$convert, yBarScale, value)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
							$gampleman$elm_visualization$Scale$bandwidth(xScale)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(
							((fullHeight - barGraphXAxisLabelHeight) - A2($gampleman$elm_visualization$Scale$convert, yBarScale, value)) - (2 * padding))
						]),
					_List_Nil),
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
							A2($gampleman$elm_visualization$Scale$convert, xScale, date)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(0),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
							$gampleman$elm_visualization$Scale$bandwidth(xScale)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(fullHeight),
							$author$project$LandingSite$MarketDetail$onBarMouseOver(date),
							$author$project$LandingSite$MarketDetail$onBarMouseOut(date),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['transparent-bar']))
						]),
					_List_Nil)
				]));
	});
var $gampleman$elm_visualization$Scale$Band$normalizeConfig = function (_v0) {
	var paddingInner = _v0.me;
	var paddingOuter = _v0.mf;
	var align = _v0.hj;
	return {
		hj: A3($elm$core$Basics$clamp, 0, 1, align),
		me: A3($elm$core$Basics$clamp, 0, 1, paddingInner),
		mf: A3($elm$core$Basics$clamp, 0, 1, paddingOuter)
	};
};
var $gampleman$elm_visualization$Scale$Band$bandwidth = F3(
	function (cfg, domain, _v0) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var n = $elm$core$List$length(domain);
		var _v1 = (_Utils_cmp(d0, d1) < 0) ? _Utils_Tuple2(d0, d1) : _Utils_Tuple2(d1, d0);
		var start = _v1.a;
		var stop = _v1.b;
		var _v2 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v2.me;
		var paddingOuter = _v2.mf;
		var align = _v2.hj;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		return step * (1 - paddingInner);
	});
var $gampleman$elm_visualization$Scale$Band$computePositions = F4(
	function (index, cfg, n, _v0) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = $gampleman$elm_visualization$Scale$Band$normalizeConfig(cfg);
		var paddingInner = _v1.me;
		var paddingOuter = _v1.mf;
		var align = _v1.hj;
		var step = (stop - start) / A2($elm$core$Basics$max, 1, (n - paddingInner) + (paddingOuter * 2));
		var start2 = start + (((stop - start) - (step * (n - paddingInner))) * align);
		return _Utils_Tuple2(start2, step);
	});
var $gampleman$elm_visualization$Scale$Band$indexOfHelp = F3(
	function (index, value, list) {
		indexOfHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (_Utils_eq(value, x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$value = value,
						$temp$list = xs;
					index = $temp$index;
					value = $temp$value;
					list = $temp$list;
					continue indexOfHelp;
				}
			}
		}
	});
var $gampleman$elm_visualization$Scale$Band$indexOf = $gampleman$elm_visualization$Scale$Band$indexOfHelp(0);
var $gampleman$elm_visualization$Scale$Band$convert = F4(
	function (cfg, domain, _v0, value) {
		var start = _v0.a;
		var stop = _v0.b;
		var _v1 = A2($gampleman$elm_visualization$Scale$Band$indexOf, value, domain);
		if (!_v1.$) {
			var index = _v1.a;
			var n = $elm$core$List$length(domain);
			if (_Utils_cmp(start, stop) < 0) {
				var _v2 = A4(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					index,
					cfg,
					n,
					_Utils_Tuple2(start, stop));
				var start2 = _v2.a;
				var step = _v2.b;
				return start2 + (step * index);
			} else {
				var _v3 = A4(
					$gampleman$elm_visualization$Scale$Band$computePositions,
					index,
					cfg,
					n,
					_Utils_Tuple2(stop, start));
				var stop2 = _v3.a;
				var step = _v3.b;
				return stop2 + (step * ((n - index) - 1));
			}
		} else {
			return 0 / 0;
		}
	});
var $gampleman$elm_visualization$Scale$band = F3(
	function (config, range_, domain_) {
		return {
			eM: A3($gampleman$elm_visualization$Scale$Band$bandwidth, config, domain_, range_),
			L: $gampleman$elm_visualization$Scale$Band$convert(config),
			ff: domain_,
			bv: range_
		};
	});
var $gampleman$elm_visualization$Scale$defaultBandConfig = {hj: 0.5, me: 0.0, mf: 0.0};
var $author$project$LandingSite$MarketDetail$computeXScale = F2(
	function (_v0, datapoints) {
		var fullWidth = _v0.bV;
		var padding = _v0.R;
		return A3(
			$gampleman$elm_visualization$Scale$band,
			_Utils_update(
				$gampleman$elm_visualization$Scale$defaultBandConfig,
				{me: 0.1, mf: 0.2}),
			_Utils_Tuple2(0, fullWidth - (2 * padding)),
			A2($elm$core$List$map, $elm$core$Tuple$first, datapoints));
	});
var $gampleman$elm_visualization$Scale$Internal$bimap = F4(
	function (_v0, _v1, deinterpolate, reinterpolate) {
		var d0 = _v0.a;
		var d1 = _v0.b;
		var r0 = _v1.a;
		var r1 = _v1.b;
		var _v2 = (_Utils_cmp(d1, d0) < 0) ? _Utils_Tuple2(
			A2(deinterpolate, d1, d0),
			A2(reinterpolate, r1, r0)) : _Utils_Tuple2(
			A2(deinterpolate, d0, d1),
			A2(reinterpolate, r0, r1));
		var de = _v2.a;
		var re = _v2.b;
		return A2($elm$core$Basics$composeL, re, de);
	});
var $gampleman$elm_visualization$Scale$Linear$deinterpolate = F3(
	function (a, b, x) {
		var normalizedB = b - a;
		return (!normalizedB) ? 0 : ((x - a) / normalizedB);
	});
var $gampleman$elm_visualization$Scale$Internal$interpolateFloat = F3(
	function (from, to, time) {
		return from + ((to - from) * time);
	});
var $gampleman$elm_visualization$Scale$Linear$convert = F2(
	function (domain, range) {
		return A4($gampleman$elm_visualization$Scale$Internal$bimap, domain, range, $gampleman$elm_visualization$Scale$Linear$deinterpolate, $gampleman$elm_visualization$Scale$Internal$interpolateFloat);
	});
var $gampleman$elm_visualization$Scale$Linear$interpolate = $gampleman$elm_visualization$Scale$Internal$interpolateFloat;
var $gampleman$elm_visualization$Scale$Linear$invert = F2(
	function (domain, range) {
		return A4($gampleman$elm_visualization$Scale$Internal$bimap, range, domain, $gampleman$elm_visualization$Scale$Linear$deinterpolate, $gampleman$elm_visualization$Scale$Linear$interpolate);
	});
var $elm$core$Basics$e = _Basics_e;
var $gampleman$elm_visualization$Statistics$tickStep = F3(
	function (start, stop, count) {
		var step0 = $elm$core$Basics$abs(stop - start) / A2($elm$core$Basics$max, 0, count);
		var step1 = A2(
			$elm$core$Basics$pow,
			10,
			$elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Basics$e, step0) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
		var error = step0 / step1;
		var step2 = (_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(50)) > -1) ? (step1 * 10) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(10)) > -1) ? (step1 * 5) : ((_Utils_cmp(
			error,
			$elm$core$Basics$sqrt(2)) > -1) ? (step1 * 2) : step1));
		return (_Utils_cmp(stop, start) < 0) ? (-step2) : step2;
	});
var $gampleman$elm_visualization$Scale$Linear$nice = F2(
	function (_v0, count) {
		var start = _v0.a;
		var stop = _v0.b;
		var step0 = A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count);
		var step1 = A3(
			$gampleman$elm_visualization$Statistics$tickStep,
			$elm$core$Basics$floor(start / step0) * step0,
			$elm$core$Basics$ceiling(stop / step0) * step0,
			count);
		return _Utils_Tuple2(
			$elm$core$Basics$floor(start / step1) * step1,
			$elm$core$Basics$ceiling(stop / step1) * step1);
	});
var $gampleman$elm_visualization$Scale$Linear$rangeExtent = F2(
	function (d, r) {
		return r;
	});
var $gampleman$elm_visualization$Scale$Linear$exponent = function (x) {
	return (!x) ? 0 : ((x < 1) ? (1 + $gampleman$elm_visualization$Scale$Linear$exponent(x * 10)) : 0);
};
var $gampleman$elm_visualization$Scale$Linear$precisionFixed = function (step) {
	return A2(
		$elm$core$Basics$max,
		0,
		$gampleman$elm_visualization$Scale$Linear$exponent(
			$elm$core$Basics$abs(step)));
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $gampleman$elm_visualization$Scale$Internal$toFixed = F2(
	function (precision, value) {
		var power = A2($elm$core$Basics$pow, 10, precision);
		var pad = function (num) {
			_v0$2:
			while (true) {
				if (num.b) {
					if (num.b.b) {
						if (!num.b.b.b) {
							var x = num.a;
							var _v1 = num.b;
							var y = _v1.a;
							return _List_fromArray(
								[
									x,
									A3($elm$core$String$padRight, precision, '0', y)
								]);
						} else {
							break _v0$2;
						}
					} else {
						var val = num.a;
						return (precision > 0) ? _List_fromArray(
							[
								val,
								A3($elm$core$String$padRight, precision, '0', '')
							]) : _List_fromArray(
							[val]);
					}
				} else {
					break _v0$2;
				}
			}
			var val = num;
			return val;
		};
		return A2(
			$elm$core$String$join,
			'.',
			pad(
				A2(
					$elm$core$String$split,
					'.',
					$elm$core$String$fromFloat(
						$elm$core$Basics$round(value * power) / power))));
	});
var $gampleman$elm_visualization$Scale$Linear$tickFormat = F2(
	function (_v0, count) {
		var start = _v0.a;
		var stop = _v0.b;
		return $gampleman$elm_visualization$Scale$Internal$toFixed(
			$gampleman$elm_visualization$Scale$Linear$precisionFixed(
				A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count)));
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $gampleman$elm_visualization$Statistics$range = F3(
	function (start, stop, step) {
		var n = A2(
			$elm$core$Basics$max,
			0,
			0 | $elm$core$Basics$ceiling((stop - start) / step));
		var helper = F2(
			function (i, list) {
				return (i >= 0) ? A2(
					helper,
					i - 1,
					A2($elm$core$List$cons, start + (step * i), list)) : list;
			});
		return A2(helper, n - 1, _List_Nil);
	});
var $gampleman$elm_visualization$Statistics$ticks = F3(
	function (start, stop, count) {
		var step = A3($gampleman$elm_visualization$Statistics$tickStep, start, stop, count);
		var end = ($elm$core$Basics$floor(stop / step) * step) + (step / 2);
		var beg = $elm$core$Basics$ceiling(start / step) * step;
		return A3($gampleman$elm_visualization$Statistics$range, beg, end, step);
	});
var $gampleman$elm_visualization$Scale$Linear$ticks = F2(
	function (_v0, count) {
		var start = _v0.a;
		var end = _v0.b;
		return A3($gampleman$elm_visualization$Statistics$ticks, start, end, count);
	});
var $gampleman$elm_visualization$Scale$linear = F2(
	function (range_, domain_) {
		return {L: $gampleman$elm_visualization$Scale$Linear$convert, ff: domain_, d5: $gampleman$elm_visualization$Scale$Linear$invert, c8: $gampleman$elm_visualization$Scale$Linear$nice, bv: range_, ck: $gampleman$elm_visualization$Scale$Linear$rangeExtent, gS: $gampleman$elm_visualization$Scale$Linear$tickFormat, z: $gampleman$elm_visualization$Scale$Linear$ticks};
	});
var $author$project$LandingSite$MarketDetail$computeYBarScale = F2(
	function (_v0, datapoints) {
		var fullHeight = _v0.as;
		var padding = _v0.R;
		var barGraphHeight = _v0.eP;
		var barGraphXAxisLabelHeight = _v0.cD;
		var topBottomPadding = 2 * padding;
		var maxFloat = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, maxValue) {
					var value = _v1.b;
					return (_Utils_cmp(value, maxValue) > 0) ? value : maxValue;
				}),
			0,
			datapoints);
		var barGraphUpperYCoordinate = ((fullHeight - barGraphXAxisLabelHeight) - barGraphHeight) - topBottomPadding;
		var barGraphLowerYCoordinate = (fullHeight - barGraphXAxisLabelHeight) - topBottomPadding;
		return A2(
			$gampleman$elm_visualization$Scale$linear,
			_Utils_Tuple2(barGraphLowerYCoordinate, barGraphUpperYCoordinate),
			_Utils_Tuple2(0, maxFloat * 1.2));
	});
var $author$project$LandingSite$MarketDetail$computeYLineScale = F2(
	function (_v0, datapoints) {
		var padding = _v0.R;
		var lineGraphUpperLabelsHeight = _v0.fR;
		var lineGraphHeight = _v0.fQ;
		var topPadding = padding;
		var lineGraphUpperYCoordinate = lineGraphUpperLabelsHeight + topPadding;
		var lineGraphLowerYCoordinate = (lineGraphUpperLabelsHeight + lineGraphHeight) + topPadding;
		var _v1 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, _v3) {
					var value = _v2.b;
					var minValue = _v3.a;
					var maxValue = _v3.b;
					var newMinValue = (_Utils_cmp(value, minValue) < 0) ? value : minValue;
					var newMaxValue = (_Utils_cmp(value, maxValue) > 0) ? value : maxValue;
					return _Utils_Tuple2(newMinValue, newMaxValue);
				}),
			_Utils_Tuple2(0, 0),
			datapoints);
		var minFloat = _v1.a;
		var maxFloat = _v1.b;
		return A2(
			$gampleman$elm_visualization$Scale$linear,
			_Utils_Tuple2(lineGraphLowerYCoordinate, lineGraphUpperYCoordinate),
			_Utils_Tuple2(minFloat, maxFloat));
	});
var $folkertdev$one_true_path_experiment$SubPath$Empty = {$: 1};
var $folkertdev$one_true_path_experiment$SubPath$SubPath = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_deque$Deque$Deque = $elm$core$Basics$identity;
var $folkertdev$elm_deque$Internal$empty = {Q: _List_Nil, S: _List_Nil, G: 0, H: 0};
var $folkertdev$elm_deque$Deque$empty = $folkertdev$elm_deque$Internal$empty;
var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
	var sizeF = deque.G;
	var sizeR = deque.H;
	var front = deque.Q;
	var rear = deque.S;
	var size1 = ((sizeF + sizeR) / 2) | 0;
	var size2 = (sizeF + sizeR) - size1;
	var balanceConstant = 4;
	if ((sizeF + sizeR) < 2) {
		return deque;
	} else {
		if (_Utils_cmp(sizeF, (balanceConstant * sizeR) + 1) > 0) {
			var newRear = _Utils_ap(
				rear,
				$elm$core$List$reverse(
					A2($elm$core$List$drop, size1, front)));
			var newFront = A2($elm$core$List$take, size1, front);
			return {Q: newFront, S: newRear, G: size1, H: size2};
		} else {
			if (_Utils_cmp(sizeR, (balanceConstant * sizeF) + 1) > 0) {
				var newRear = A2($elm$core$List$take, size1, rear);
				var newFront = _Utils_ap(
					front,
					$elm$core$List$reverse(
						A2($elm$core$List$drop, size1, rear)));
				return {Q: newFront, S: newRear, G: size1, H: size2};
			} else {
				return deque;
			}
		}
	}
};
var $folkertdev$elm_deque$Internal$fromList = function (list) {
	return $folkertdev$elm_deque$Internal$rebalance(
		{
			Q: list,
			S: _List_Nil,
			G: $elm$core$List$length(list),
			H: 0
		});
};
var $folkertdev$elm_deque$Deque$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $folkertdev$elm_deque$Internal$fromList);
var $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath = {$: 4};
var $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc = function (a) {
	return {$: 3, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo = function (a) {
	return {$: 2, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$merge = F2(
	function (instruction1, instruction2) {
		var _v0 = _Utils_Tuple2(instruction1, instruction2);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath);
					} else {
						break _v0$5;
					}
			}
		}
		return $elm$core$Result$Err(
			_Utils_Tuple2(instruction1, instruction2));
	});
var $folkertdev$elm_deque$Internal$toList = function (deque) {
	return _Utils_ap(
		deque.Q,
		$elm$core$List$reverse(deque.S));
};
var $folkertdev$elm_deque$Deque$unwrap = function (_v0) {
	var boundedDeque = _v0;
	return boundedDeque;
};
var $folkertdev$elm_deque$Deque$toList = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$toList, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$one_true_path_experiment$SubPath$compressHelper = function (drawtos) {
	var folder = F2(
		function (instruction, _v3) {
			var previous = _v3.a;
			var accum = _v3.b;
			var _v2 = A2($folkertdev$one_true_path_experiment$LowLevel$Command$merge, previous, instruction);
			if (!_v2.$) {
				var merged = _v2.a;
				return _Utils_Tuple2(merged, accum);
			} else {
				return _Utils_Tuple2(
					instruction,
					A2($elm$core$List$cons, previous, accum));
			}
		});
	var _v0 = $folkertdev$elm_deque$Deque$toList(drawtos);
	if (!_v0.b) {
		return $folkertdev$elm_deque$Deque$empty;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return $folkertdev$elm_deque$Deque$fromList(
			$elm$core$List$reverse(
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$core$List$cons, a, b);
				}(
					A3(
						$elm$core$List$foldl,
						folder,
						_Utils_Tuple2(first, _List_Nil),
						rest))));
	}
};
var $folkertdev$one_true_path_experiment$SubPath$compress = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var data = subpath.a;
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			_Utils_update(
				data,
				{
					h0: $folkertdev$one_true_path_experiment$SubPath$compressHelper(data.h0)
				}));
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$DecimalPlaces = $elm$core$Basics$identity;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$defaultConfig = {dX: $elm$core$Maybe$Nothing, ei: false};
var $folkertdev$one_true_path_experiment$SubPath$optionFolder = F2(
	function (option, config) {
		if (!option.$) {
			var n = option.a;
			return _Utils_update(
				config,
				{
					dX: $elm$core$Maybe$Just(n)
				});
		} else {
			return _Utils_update(
				config,
				{ei: true});
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Absolute = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath = {$: 8};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo = function (drawto) {
	switch (drawto.$) {
		case 0:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo, 1, coordinates);
		case 1:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo, 1, coordinates);
		case 2:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo, 1, coordinates);
		case 3:
			var _arguments = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc, 1, _arguments);
		default:
			return $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath;
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo = function (_v0) {
	var target = _v0;
	return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo, 1, target);
};
var $folkertdev$one_true_path_experiment$SubPath$toLowLevel = function (subpath) {
	if (subpath.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var moveto = subpath.a.i3;
		var drawtos = subpath.a.h0;
		return $elm$core$Maybe$Just(
			{
				h0: A2(
					$elm$core$List$map,
					$folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo,
					$folkertdev$elm_deque$Deque$toList(drawtos)),
				i3: $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo(moveto)
			});
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig = {cT: $elm$core$String$fromFloat};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo = F2(
	function (n, value) {
		if (!n) {
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(value));
		} else {
			var sign = (value < 0.0) ? '-' : '';
			var exp = A2($elm$core$Basics$pow, 10, n);
			var raised = $elm$core$Basics$abs(
				$elm$core$Basics$round(value * exp));
			var decimals = raised % exp;
			return (!decimals) ? _Utils_ap(
				sign,
				$elm$core$String$fromInt((raised / exp) | 0)) : (sign + ($elm$core$String$fromInt((raised / exp) | 0) + ('.' + $elm$core$String$fromInt(decimals))));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder = F2(
	function (option, config) {
		var n = option;
		return _Utils_update(
			config,
			{
				cT: $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo(n)
			});
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions = A2($elm$core$List$foldl, $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder, $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig);
var $folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty = function (command) {
	switch (command.$) {
		case 0:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 1:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 2:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 3:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 4:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 5:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 6:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 7:
			var mode = command.a;
			var _arguments = command.b;
			return $elm$core$List$isEmpty(_arguments);
		default:
			return false;
	}
};
var $elm$core$Char$toLower = _Char_toLower;
var $elm$core$Char$toUpper = _Char_toUpper;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter = F2(
	function (mode, character) {
		if (mode === 1) {
			return $elm$core$String$fromChar(
				$elm$core$Char$toUpper(character));
		} else {
			return $elm$core$String$fromChar(
				$elm$core$Char$toLower(character));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate = F2(
	function (config, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return config.cT(x) + (',' + config.cT(y));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		var c3 = _v0.c;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + (A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c3))));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags = function (_v0) {
	var arcFlag = _v0.a;
	var direction = _v0.b;
	var _v1 = _Utils_Tuple2(arcFlag, direction);
	if (_v1.a === 1) {
		if (!_v1.b) {
			var _v2 = _v1.a;
			var _v3 = _v1.b;
			return _Utils_Tuple2(1, 0);
		} else {
			var _v6 = _v1.a;
			var _v7 = _v1.b;
			return _Utils_Tuple2(1, 1);
		}
	} else {
		if (!_v1.b) {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return _Utils_Tuple2(0, 0);
		} else {
			var _v8 = _v1.a;
			var _v9 = _v1.b;
			return _Utils_Tuple2(0, 1);
		}
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument = F2(
	function (config, _v0) {
		var radii = _v0.aZ;
		var xAxisRotate = _v0.aG;
		var arcFlag = _v0.eK;
		var direction = _v0.fd;
		var target = _v0.m6;
		var _v1 = $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags(
			_Utils_Tuple2(arcFlag, direction));
		var arc = _v1.a;
		var sweep = _v1.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, radii),
					$elm$core$String$fromFloat(xAxisRotate),
					$elm$core$String$fromInt(arc),
					$elm$core$String$fromInt(sweep),
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, target)
				]));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo = F2(
	function (config, command) {
		if ($folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty(command)) {
			return '';
		} else {
			switch (command.$) {
				case 0:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'L'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 1:
					var mode = command.a;
					var coordinates = command.b;
					return $elm$core$List$isEmpty(coordinates) ? '' : _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'H'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 2:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'V'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 3:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'C'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3(config),
								coordinates)));
				case 4:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'S'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 5:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'Q'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 6:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'T'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 7:
					var mode = command.a;
					var _arguments = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'A'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument(config),
								_arguments)));
				default:
					return 'Z';
			}
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo = F2(
	function (config, _v0) {
		var mode = _v0.a;
		var coordinate = _v0.b;
		if (mode === 1) {
			return 'M' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		} else {
			return 'm' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath = F2(
	function (config, _v0) {
		var moveto = _v0.i3;
		var drawtos = _v0.h0;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo, config, moveto) + (' ' + A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo(config),
				drawtos)));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith = F2(
	function (options, subpaths) {
		var config = $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions(options);
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath(config),
				subpaths));
	});
var $folkertdev$one_true_path_experiment$SubPath$toStringWith = F2(
	function (options, subpath) {
		var config = A3($elm$core$List$foldl, $folkertdev$one_true_path_experiment$SubPath$optionFolder, $folkertdev$one_true_path_experiment$SubPath$defaultConfig, options);
		var lowLevelOptions = function () {
			var _v0 = config.dX;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var n = _v0.a;
				return _List_fromArray(
					[
						$folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces(n)
					]);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith(lowLevelOptions),
					$elm$core$List$singleton),
				$folkertdev$one_true_path_experiment$SubPath$toLowLevel(
					(config.ei ? $folkertdev$one_true_path_experiment$SubPath$compress : $elm$core$Basics$identity)(subpath))));
	});
var $folkertdev$one_true_path_experiment$SubPath$toString = function (subpath) {
	return A2($folkertdev$one_true_path_experiment$SubPath$toStringWith, _List_Nil, subpath);
};
var $folkertdev$one_true_path_experiment$Path$toString = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$join(' '),
	$elm$core$List$map($folkertdev$one_true_path_experiment$SubPath$toString));
var $folkertdev$one_true_path_experiment$Path$element = F2(
	function (path, attributes) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$d(
					$folkertdev$one_true_path_experiment$Path$toString(path)),
				attributes),
			_List_Nil);
	});
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $gampleman$elm_visualization$Shape$Generators$line = F2(
	function (curve, data) {
		var makeCurves = F2(
			function (datum, _v3) {
				var prev = _v3.a;
				var list = _v3.b;
				var _v0 = _Utils_Tuple3(prev, datum, list);
				if (_v0.b.$ === 1) {
					var _v1 = _v0.b;
					var l = _v0.c;
					return _Utils_Tuple2(false, l);
				} else {
					if (!_v0.a) {
						var point = _v0.b.a;
						var l = _v0.c;
						return _Utils_Tuple2(
							true,
							A2(
								$elm$core$List$cons,
								_List_fromArray(
									[point]),
								l));
					} else {
						if (_v0.c.b) {
							var p1 = _v0.b.a;
							var _v2 = _v0.c;
							var ps = _v2.a;
							var l = _v2.b;
							return _Utils_Tuple2(
								true,
								A2(
									$elm$core$List$cons,
									A2($elm$core$List$cons, p1, ps),
									l));
						} else {
							var p1 = _v0.b.a;
							var l = _v0.c;
							return _Utils_Tuple2(
								true,
								A2(
									$elm$core$List$cons,
									_List_fromArray(
										[p1]),
									l));
						}
					}
				}
			});
		return A2(
			$elm$core$List$map,
			curve,
			A3(
				$elm$core$List$foldr,
				makeCurves,
				_Utils_Tuple2(false, _List_Nil),
				data).b);
	});
var $gampleman$elm_visualization$Shape$line = $gampleman$elm_visualization$Shape$Generators$line;
var $folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo = $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo;
var $folkertdev$one_true_path_experiment$SubPath$empty = $folkertdev$one_true_path_experiment$SubPath$Empty;
var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector2d$fromComponents = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$LowLevel$Command$lineTo = $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo;
var $folkertdev$one_true_path_experiment$Curve$monotonePoint = F4(
	function (_v0, _v1, t0, t1) {
		var x0 = _v0.a;
		var y0 = _v0.b;
		var x1 = _v1.a;
		var y1 = _v1.b;
		var dx = (x1 - x0) / 3;
		return _Utils_Tuple3(
			_Utils_Tuple2(x0 + dx, y0 + (dx * t0)),
			_Utils_Tuple2(x1 - dx, y1 - (dx * t1)),
			_Utils_Tuple2(x1, y1));
	});
var $ianmackenzie$elm_geometry$Vector2d$components = function (_v0) {
	var components_ = _v0;
	return components_;
};
var $ianmackenzie$elm_geometry$Vector2d$difference = F2(
	function (firstVector, secondVector) {
		var _v0 = $ianmackenzie$elm_geometry$Vector2d$components(secondVector);
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $ianmackenzie$elm_geometry$Vector2d$components(firstVector);
		var x1 = _v1.a;
		var y1 = _v1.b;
		return $ianmackenzie$elm_geometry$Vector2d$fromComponents(
			_Utils_Tuple2(x1 - x2, y1 - y2));
	});
var $folkertdev$one_true_path_experiment$Curve$slope2 = F3(
	function (p0, p1, t) {
		var _v0 = $ianmackenzie$elm_geometry$Vector2d$components(
			A2($ianmackenzie$elm_geometry$Vector2d$difference, p0, p1));
		var dx = _v0.a;
		var dy = _v0.b;
		return (!(!dx)) ? ((((3 * dy) / dx) - t) / 2) : t;
	});
var $folkertdev$one_true_path_experiment$Curve$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $folkertdev$one_true_path_experiment$Curve$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $folkertdev$one_true_path_experiment$Curve$slope3 = F3(
	function (p0, p1, p2) {
		var _v0 = $ianmackenzie$elm_geometry$Vector2d$components(
			A2($ianmackenzie$elm_geometry$Vector2d$difference, p2, p1));
		var dx2 = _v0.a;
		var dy2 = _v0.b;
		var _v1 = $ianmackenzie$elm_geometry$Vector2d$components(
			A2($ianmackenzie$elm_geometry$Vector2d$difference, p1, p0));
		var dx1 = _v1.a;
		var dy1 = _v1.b;
		var _v2 = _Utils_Tuple2(
			A2($folkertdev$one_true_path_experiment$Curve$toH, dx1, dx2),
			A2($folkertdev$one_true_path_experiment$Curve$toH, dx2, dx1));
		var s0h = _v2.a;
		var s1h = _v2.b;
		var s1 = dy2 / s1h;
		var s0 = dy1 / s0h;
		var p = ((s0 * dx2) + (s1 * dx1)) / (dx1 + dx2);
		return ($folkertdev$one_true_path_experiment$Curve$sign(s0) + $folkertdev$one_true_path_experiment$Curve$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
	});
var $folkertdev$one_true_path_experiment$Curve$monotoneXHelper = F3(
	function (acc, t0, remaininPoints) {
		monotoneXHelper:
		while (true) {
			if (remaininPoints.b && remaininPoints.b.b) {
				if (remaininPoints.b.b.b) {
					var p0 = remaininPoints.a;
					var _v1 = remaininPoints.b;
					var p1 = _v1.a;
					var _v2 = _v1.b;
					var p = _v2.a;
					var rest = _v2.b;
					var t1 = A3(
						$folkertdev$one_true_path_experiment$Curve$slope3,
						$ianmackenzie$elm_geometry$Vector2d$fromComponents(p0),
						$ianmackenzie$elm_geometry$Vector2d$fromComponents(p1),
						$ianmackenzie$elm_geometry$Vector2d$fromComponents(p));
					var $temp$acc = A2(
						$elm$core$List$cons,
						A4($folkertdev$one_true_path_experiment$Curve$monotonePoint, p0, p1, t0, t1),
						acc),
						$temp$t0 = t1,
						$temp$remaininPoints = A2(
						$elm$core$List$cons,
						p1,
						A2($elm$core$List$cons, p, rest));
					acc = $temp$acc;
					t0 = $temp$t0;
					remaininPoints = $temp$remaininPoints;
					continue monotoneXHelper;
				} else {
					var p0 = remaininPoints.a;
					var _v3 = remaininPoints.b;
					var p1 = _v3.a;
					var t1 = A3(
						$folkertdev$one_true_path_experiment$Curve$slope2,
						$ianmackenzie$elm_geometry$Vector2d$fromComponents(p0),
						$ianmackenzie$elm_geometry$Vector2d$fromComponents(p1),
						t0);
					return $elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							A4($folkertdev$one_true_path_experiment$Curve$monotonePoint, p0, p1, t0, t1),
							acc));
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$MoveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$with = F2(
	function (moveto, drawtos) {
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			{
				h0: $folkertdev$elm_deque$Deque$fromList(drawtos),
				i3: moveto
			});
	});
var $folkertdev$one_true_path_experiment$Curve$monotoneX = function (points) {
	if (points.b && points.b.b) {
		if (points.b.b.b) {
			var p0 = points.a;
			var _v1 = points.b;
			var p1 = _v1.a;
			var _v2 = _v1.b;
			var p = _v2.a;
			var rest = _v2.b;
			var t1 = A3(
				$folkertdev$one_true_path_experiment$Curve$slope3,
				$ianmackenzie$elm_geometry$Vector2d$fromComponents(p0),
				$ianmackenzie$elm_geometry$Vector2d$fromComponents(p1),
				$ianmackenzie$elm_geometry$Vector2d$fromComponents(p));
			var otherInstructions = A3(
				$folkertdev$one_true_path_experiment$Curve$monotoneXHelper,
				_List_Nil,
				t1,
				A2(
					$elm$core$List$cons,
					p1,
					A2($elm$core$List$cons, p, rest)));
			var initialInstruction = A4(
				$folkertdev$one_true_path_experiment$Curve$monotonePoint,
				p0,
				p1,
				A3(
					$folkertdev$one_true_path_experiment$Curve$slope2,
					$ianmackenzie$elm_geometry$Vector2d$fromComponents(p0),
					$ianmackenzie$elm_geometry$Vector2d$fromComponents(p1),
					t1),
				t1);
			return A2(
				$folkertdev$one_true_path_experiment$SubPath$with,
				$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0),
				_List_fromArray(
					[
						$folkertdev$one_true_path_experiment$LowLevel$Command$cubicCurveTo(
						A2($elm$core$List$cons, initialInstruction, otherInstructions))
					]));
		} else {
			var p0 = points.a;
			var _v3 = points.b;
			var p1 = _v3.a;
			return A2(
				$folkertdev$one_true_path_experiment$SubPath$with,
				$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(p0),
				_List_fromArray(
					[
						$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(
						_List_fromArray(
							[p1]))
					]));
		}
	} else {
		return $folkertdev$one_true_path_experiment$SubPath$empty;
	}
};
var $gampleman$elm_visualization$Shape$monotoneInXCurve = $folkertdev$one_true_path_experiment$Curve$monotoneX;
var $author$project$LandingSite$MarketDetail$interestRateline = function (_v0) {
	var lineDatapoints = _v0.ea;
	var xScale = _v0.bF;
	var yLineScale = _v0.eF;
	var halfBarWidth = $gampleman$elm_visualization$Scale$bandwidth(xScale) / 2;
	return A2(
		$gampleman$elm_visualization$Shape$line,
		$gampleman$elm_visualization$Shape$monotoneInXCurve,
		A2(
			$elm$core$List$map,
			function (_v1) {
				var date = _v1.a;
				var value = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						A2($gampleman$elm_visualization$Scale$convert, xScale, date) + halfBarWidth,
						A2($gampleman$elm_visualization$Scale$convert, yLineScale, value)));
			},
			lineDatapoints));
};
var $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth = function (length) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'stroke-width',
		$elm_community$typed_svg$TypedSvg$TypesToStrings$lengthToString(length));
};
var $elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth = function (value) {
	return $elm_community$typed_svg$TypedSvg$Attributes$strokeWidth(
		$elm_community$typed_svg$TypedSvg$Types$px(value));
};
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString = function (xform) {
	var tr = F2(
		function (name, args) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						'(',
						A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, args)),
						')'
					]));
		});
	switch (xform.$) {
		case 0:
			var a = xform.a;
			var b = xform.b;
			var c = xform.c;
			var d = xform.d;
			var e = xform.e;
			var f = xform.f;
			return A2(
				tr,
				'matrix',
				_List_fromArray(
					[a, b, c, d, e, f]));
		case 1:
			var a = xform.a;
			var x = xform.b;
			var y = xform.c;
			return A2(
				tr,
				'rotate',
				_List_fromArray(
					[a, x, y]));
		case 2:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'scale',
				_List_fromArray(
					[x, y]));
		case 3:
			var x = xform.a;
			return A2(
				tr,
				'skewX',
				_List_fromArray(
					[x]));
		case 4:
			var y = xform.a;
			return A2(
				tr,
				'skewY',
				_List_fromArray(
					[y]));
		default:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'translate',
				_List_fromArray(
					[x, y]));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$transform = function (transforms) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'transform',
		A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString, transforms)));
};
var $author$project$LandingSite$MarketDetail$transparentColumnForHover = F3(
	function (_v0, _v1, _v2) {
		var fullHeight = _v0.as;
		var xScale = _v1.bF;
		var date = _v2.a;
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(
					_List_fromArray(
						['bar-graph__bar']))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$rect,
					_List_fromArray(
						[
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$x(
							A2($gampleman$elm_visualization$Scale$convert, xScale, date)),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$y(0),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$width(
							$gampleman$elm_visualization$Scale$bandwidth(xScale) + 2),
							$elm_community$typed_svg$TypedSvg$Attributes$InPx$height(fullHeight),
							$author$project$LandingSite$MarketDetail$onBarMouseOver(date),
							$author$project$LandingSite$MarketDetail$onBarMouseOut(date),
							$elm_community$typed_svg$TypedSvg$Attributes$class(
							_List_fromArray(
								['transparent-bar']))
						]),
					_List_Nil)
				]));
	});
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $gampleman$elm_visualization$Scale$tickFormat = function (_v0) {
	var opts = _v0;
	return opts.gS(opts.ff);
};
var $gampleman$elm_visualization$Scale$ticks = F2(
	function (_v0, count) {
		var scale = _v0;
		return A2(scale.z, scale.ff, count);
	});
var $gampleman$elm_visualization$Axis$computeOptions = F2(
	function (attrs, scale) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (attr, _v1) {
					var babyOpts = _v1.a;
					var post = _v1.b;
					switch (attr.$) {
						case 2:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{ct: val}),
								post);
						case 3:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{cu: val}),
								post);
						case 4:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{a$: val}),
								post);
						case 5:
							var val = attr.a;
							return _Utils_Tuple2(
								_Utils_update(
									babyOpts,
									{dm: val}),
								post);
						default:
							return _Utils_Tuple2(
								babyOpts,
								A2($elm$core$List$cons, attr, post));
					}
				}),
			_Utils_Tuple2(
				{ct: 10, dm: 3, cu: 6, a$: 6},
				_List_Nil),
			attrs);
		var opts = _v0.a;
		var postList = _v0.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (attr, options) {
					switch (attr.$) {
						case 0:
							var val = attr.a;
							return _Utils_update(
								options,
								{z: val});
						case 1:
							var val = attr.a;
							return _Utils_update(
								options,
								{gS: val});
						default:
							return options;
					}
				}),
			{
				ct: opts.ct,
				gS: A2($gampleman$elm_visualization$Scale$tickFormat, scale, opts.ct),
				dm: opts.dm,
				cu: opts.cu,
				a$: opts.a$,
				z: A2($gampleman$elm_visualization$Scale$ticks, scale, opts.ct)
			},
			postList);
	});
var $elm$svg$Svg$Attributes$dy = _VirtualDom_attribute('dy');
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $gampleman$elm_visualization$Scale$rangeExtent = function (_v0) {
	var options = _v0;
	return A2(options.ck, options.ff, options.bv);
};
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $gampleman$elm_visualization$Axis$element = F4(
	function (_v0, k, displacement, textAnchorPosition) {
		var x = _v0.ab;
		var y = _v0.ad;
		var x1 = _v0.nQ;
		var x2 = _v0.nR;
		var y1 = _v0.nU;
		var y2 = _v0.nV;
		var translate = _v0.gX;
		var horizontal = _v0.fp;
		return F2(
			function (attrs, scale) {
				var rangeExtent = $gampleman$elm_visualization$Scale$rangeExtent(scale);
				var range1 = rangeExtent.b + 0.5;
				var range0 = rangeExtent.a + 0.5;
				var position = $gampleman$elm_visualization$Scale$convert(scale);
				var opts = A2($gampleman$elm_visualization$Axis$computeOptions, attrs, scale);
				var spacing = A2($elm$core$Basics$max, opts.cu, 0) + opts.dm;
				var drawTick = function (tick) {
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('tick'),
								$elm$svg$Svg$Attributes$transform(
								translate(
									position(tick)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke('#000'),
										x2(k * opts.cu),
										y1(0.5),
										y2(0.5)
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$text_,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('#000'),
										x(k * spacing),
										y(0.5),
										$elm$svg$Svg$Attributes$dy(displacement)
									]),
								_List_fromArray(
									[
										$elm$svg$Svg$text(
										opts.gS(tick))
									]))
							]));
				};
				var domainLine = horizontal ? ('M' + ($elm$core$String$fromFloat(k * opts.a$) + (',' + ($elm$core$String$fromFloat(range0) + ('H0.5V' + ($elm$core$String$fromFloat(range1) + ('H' + $elm$core$String$fromFloat(k * opts.a$)))))))) : ('M' + ($elm$core$String$fromFloat(range0) + (',' + ($elm$core$String$fromFloat(k * opts.a$) + ('V0.5H' + ($elm$core$String$fromFloat(range1) + ('V' + $elm$core$String$fromFloat(k * opts.a$))))))));
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$fontSize('10'),
							$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
							$elm$svg$Svg$Attributes$textAnchor(textAnchorPosition)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('domain'),
									$elm$svg$Svg$Attributes$stroke('#000'),
									$elm$svg$Svg$Attributes$d(domainLine)
								]),
							_List_Nil),
						A2($elm$core$List$map, drawTick, opts.z)));
			});
	});
var $gampleman$elm_visualization$Axis$verticalAttrs = {
	fp: false,
	gX: function (x) {
		return 'translate(' + ($elm$core$String$fromFloat(x) + ', 0)');
	},
	ab: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y, $elm$core$String$fromFloat),
	nQ: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y1, $elm$core$String$fromFloat),
	nR: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$y2, $elm$core$String$fromFloat),
	ad: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x, $elm$core$String$fromFloat),
	nU: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x1, $elm$core$String$fromFloat),
	nV: A2($elm$core$Basics$composeL, $elm$svg$Svg$Attributes$x2, $elm$core$String$fromFloat)
};
var $gampleman$elm_visualization$Axis$bottom = A4($gampleman$elm_visualization$Axis$element, $gampleman$elm_visualization$Axis$verticalAttrs, 1, '0.71em', 'middle');
var $gampleman$elm_visualization$Axis$TickCount = function (a) {
	return {$: 2, a: a};
};
var $gampleman$elm_visualization$Axis$tickCount = $gampleman$elm_visualization$Axis$TickCount;
var $gampleman$elm_visualization$Axis$TickSizeOuter = function (a) {
	return {$: 4, a: a};
};
var $gampleman$elm_visualization$Axis$tickSizeOuter = $gampleman$elm_visualization$Axis$TickSizeOuter;
var $author$project$LandingSite$MarketDetail$xAxis = function (_v0) {
	var xScale = _v0.bF;
	return A2(
		$gampleman$elm_visualization$Axis$bottom,
		_List_fromArray(
			[
				$gampleman$elm_visualization$Axis$tickCount(6),
				$gampleman$elm_visualization$Axis$tickSizeOuter(0)
			]),
		A2($gampleman$elm_visualization$Scale$toRenderable, $author$project$LandingSite$MarketDetail$dateFormat, xScale));
};
var $author$project$LandingSite$MarketDetail$doubleGraphView = F5(
	function (userLanguage, maybeCToken, activeTab, doubleGraphHoverTime, graphModel) {
		var graphConfig = {eP: 140, ho: 40, cD: 40, as: 340, bV: 1020, fQ: 80, fR: 40, R: 4};
		if (!maybeCToken.$) {
			var cToken = maybeCToken.a;
			var defaultTranslateForPadding = A2($elm_community$typed_svg$TypedSvg$Types$Translate, graphConfig.R, graphConfig.R);
			var _v1 = (!activeTab) ? {
				eN: 'bar-graph--supply',
				fm: A3($author$project$LandingSite$MarketDetailHelper$buildInterestRateGraphData, cToken.jY, graphModel.mX, $author$project$Utils$NumberFormatter$interestRateAsPercentage),
				fn: A4($author$project$LandingSite$MarketDetailHelper$buildMarketUsdTotalSupplyGraphData, cToken.jY, graphModel.nn, graphModel.lf, graphModel.jm),
				fP: $author$project$LineChart$Colors$supply
			} : {
				eN: 'bar-graph--borrow',
				fm: A3($author$project$LandingSite$MarketDetailHelper$buildInterestRateGraphData, cToken.jY, graphModel.ky, $author$project$Utils$NumberFormatter$interestRateAsPercentage),
				fn: A3($author$project$LandingSite$MarketDetailHelper$buildMarketUsdTotalBorrowGraphData, cToken.jY, graphModel.nm, graphModel.jm),
				fP: $author$project$LineChart$Colors$borrow
			};
			var historicTotalsData = _v1.fn;
			var barClass = _v1.eN;
			var historicRateData = _v1.fm;
			var lineColor = _v1.fP;
			var doubleGraphData = {
				eO: historicTotalsData,
				ea: historicRateData,
				bF: A2($author$project$LandingSite$MarketDetail$computeXScale, graphConfig, historicTotalsData),
				eE: A2($author$project$LandingSite$MarketDetail$computeYBarScale, graphConfig, historicTotalsData),
				eF: A2($author$project$LandingSite$MarketDetail$computeYLineScale, graphConfig, historicRateData)
			};
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$svg,
						_List_fromArray(
							[
								A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, graphConfig.bV, graphConfig.as),
								$elm_community$typed_svg$TypedSvg$Attributes$class(
								_List_fromArray(
									['bar-graph', barClass]))
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[
												A2($elm_community$typed_svg$TypedSvg$Types$Translate, graphConfig.R - 1, graphConfig.as - graphConfig.R)
											])),
										$elm_community$typed_svg$TypedSvg$Attributes$class(
										_List_fromArray(
											['bar-graph__x-axis']))
									]),
								_List_fromArray(
									[
										$author$project$LandingSite$MarketDetail$xAxis(doubleGraphData)
									])),
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[defaultTranslateForPadding])),
										$elm_community$typed_svg$TypedSvg$Attributes$class(
										_List_fromArray(
											['series line-graph']))
									]),
								_List_fromArray(
									[
										A2(
										$folkertdev$one_true_path_experiment$Path$element,
										$author$project$LandingSite$MarketDetail$interestRateline(doubleGraphData),
										_List_fromArray(
											[
												$elm_community$typed_svg$TypedSvg$Attributes$stroke(
												$elm_community$typed_svg$TypedSvg$Types$Paint(lineColor)),
												$elm_community$typed_svg$TypedSvg$Attributes$InPx$strokeWidth(4),
												$elm_community$typed_svg$TypedSvg$Attributes$fill($elm_community$typed_svg$TypedSvg$Types$PaintNone)
											]))
									])),
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[defaultTranslateForPadding])),
										$elm_community$typed_svg$TypedSvg$Attributes$class(
										_List_fromArray(
											['series']))
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$LandingSite$MarketDetail$column, graphConfig, doubleGraphHoverTime, doubleGraphData),
									historicTotalsData)),
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[defaultTranslateForPadding]))
									]),
								_List_fromArray(
									[
										A5($author$project$LandingSite$MarketDetail$activeCircle, userLanguage, !activeTab, graphConfig, doubleGraphData, doubleGraphHoverTime)
									])),
								A2(
								$elm_community$typed_svg$TypedSvg$g,
								_List_fromArray(
									[
										$elm_community$typed_svg$TypedSvg$Attributes$transform(
										_List_fromArray(
											[defaultTranslateForPadding])),
										$elm_community$typed_svg$TypedSvg$Attributes$class(
										_List_fromArray(
											['series']))
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$LandingSite$MarketDetail$transparentColumnForHover, graphConfig, doubleGraphData),
									historicTotalsData))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm_community$typed_svg$TypedSvg$svg,
						_List_fromArray(
							[
								A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, graphConfig.bV, graphConfig.as),
								$elm_community$typed_svg$TypedSvg$Attributes$class(
								_List_fromArray(
									['bar-graph', 'bar-graph--supply']))
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$LineChart$Colors$black = A3($avh4$elm_color$Color$rgb255, 0, 0, 0);
var $author$project$Strings$Translations$interest_rate_model = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest Rate Model';
		case 1:
			return 'Modelo de tasa de interés';
		case 2:
			return '利率模型';
		case 3:
			return 'Modèle de taux d\'intérêt';
		default:
			return '이자율 모델';
	}
};
var $author$project$Strings$Translations$current = function (lang) {
	switch (lang) {
		case 0:
			return 'Current';
		case 1:
			return 'Actual';
		case 2:
			return '当前';
		case 3:
			return 'Courant';
		default:
			return '현재 이용률';
	}
};
var $author$project$LandingSite$MarketDetail$DragAt = function (a) {
	return {$: 4, a: a};
};
var $author$project$LandingSite$MarketDetail$DragEnd = function (a) {
	return {$: 5, a: a};
};
var $author$project$LandingSite$MarketDetail$DragStart = function (a) {
	return {$: 3, a: a};
};
var $author$project$LineChart$Events$custom = $author$project$Internal$Events$custom;
var $author$project$Internal$Events$distanceY = F3(
	function (system, searched, dot) {
		return $elm$core$Basics$abs(
			A2($author$project$LineChart$Coordinate$toSvgY, system, dot.ad) - A2($author$project$LineChart$Coordinate$toSvgY, system, searched.ad));
	});
var $author$project$Internal$Events$distance = F3(
	function (system, searched, dot) {
		return $elm$core$Basics$sqrt(
			A2(
				$elm$core$Basics$pow,
				A3($author$project$Internal$Events$distanceX, system, searched, dot),
				2) + A2(
				$elm$core$Basics$pow,
				A3($author$project$Internal$Events$distanceY, system, searched, dot),
				2));
	});
var $author$project$Internal$Events$getNearestHelp = F3(
	function (points, system, searched) {
		var distance_ = A2($author$project$Internal$Events$distance, system, searched);
		var getClosest = F2(
			function (point, closest) {
				return (_Utils_cmp(
					distance_(closest.mj),
					distance_(point.mj)) < 0) ? closest : point;
			});
		return A2(
			$author$project$Internal$Utils$withFirst,
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.lH;
				},
				points),
			$elm$core$List$foldl(getClosest));
	});
var $author$project$Internal$Events$getNearest = F3(
	function (points, system, searchedSvg) {
		var searched = A2($author$project$LineChart$Coordinate$toData, system, searchedSvg);
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.nF;
			},
			A3($author$project$Internal$Events$getNearestHelp, points, system, searched));
	});
var $author$project$LineChart$Events$getNearest = $author$project$Internal$Events$getNearest;
var $author$project$Internal$Events$onMouseDown = $author$project$Internal$Events$on('mousedown');
var $author$project$LineChart$Events$onMouseDown = $author$project$Internal$Events$onMouseDown;
var $author$project$LineChart$Events$onMouseMove = $author$project$Internal$Events$onMouseMove;
var $author$project$Internal$Events$onMouseUp = $author$project$Internal$Events$on('mouseup');
var $author$project$LineChart$Events$onMouseUp = $author$project$Internal$Events$onMouseUp;
var $author$project$LandingSite$MarketDetail$eventsConfig = $author$project$LineChart$Events$custom(
	_List_fromArray(
		[
			A2(
			$author$project$LineChart$Events$onMouseDown,
			A2($elm$core$Basics$composeL, $author$project$LandingSite$MarketDetail$ForSelf, $author$project$LandingSite$MarketDetail$DragStart),
			$author$project$LineChart$Events$getNearest),
			A2(
			$author$project$LineChart$Events$onMouseMove,
			A2($elm$core$Basics$composeL, $author$project$LandingSite$MarketDetail$ForSelf, $author$project$LandingSite$MarketDetail$DragAt),
			$author$project$LineChart$Events$getNearest),
			A2(
			$author$project$LineChart$Events$onMouseUp,
			A2($elm$core$Basics$composeL, $author$project$LandingSite$MarketDetail$ForSelf, $author$project$LandingSite$MarketDetail$DragEnd),
			$author$project$LineChart$Events$getNearest)
		]));
var $author$project$LineChart$Colors$grayLightest = A3($avh4$elm_color$Color$rgb255, 243, 243, 243);
var $author$project$Internal$Svg$rectangle = F6(
	function (system, userAttributes, x1, x2, y1, y2) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray))
				]),
			userAttributes,
			_List_Nil);
		return A3(
			$author$project$Internal$Path$view,
			system,
			attributes,
			_List_fromArray(
				[
					$author$project$Internal$Path$Move(
					{ab: x1, ad: y1}),
					$author$project$Internal$Path$Line(
					{ab: x1, ad: y2}),
					$author$project$Internal$Path$Line(
					{ab: x2, ad: y2}),
					$author$project$Internal$Path$Line(
					{ab: x2, ad: y1})
				]));
	});
var $author$project$LineChart$Junk$rectangle = F2(
	function (system, attributes) {
		return A2(
			$author$project$Internal$Svg$rectangle,
			system,
			A2(
				$elm$core$List$cons,
				$author$project$LineChart$Junk$withinChartArea(system),
				attributes));
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$Internal$Dots$Disconnected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Dots$disconnected = F2(
	function (radius, border) {
		return A2(
			$author$project$Internal$Dots$style,
			radius,
			$author$project$Internal$Dots$Disconnected(border));
	});
var $author$project$LineChart$Dots$disconnected = $author$project$Internal$Dots$disconnected;
var $author$project$LandingSite$MarketDetail$dotIsActive = F2(
	function (activeUtilizationPoint, dataPoint) {
		return _Utils_eq(activeUtilizationPoint, dataPoint.aC);
	});
var $author$project$LandingSite$MarketDetail$testDotsConfig = function (activeUtilizationPoint) {
	var styleHover = A2($author$project$LineChart$Dots$disconnected, 16, 3);
	var styleDefault = A2($author$project$LineChart$Dots$disconnected, 0, 0);
	var styleIndividual = function (dataPoint) {
		return A2($author$project$LandingSite$MarketDetail$dotIsActive, activeUtilizationPoint, dataPoint) ? styleHover : styleDefault;
	};
	var styleLegend = function (data) {
		return A2(
			$elm$core$List$any,
			$author$project$LandingSite$MarketDetail$dotIsActive(activeUtilizationPoint),
			data) ? styleHover : styleDefault;
	};
	return $author$project$LineChart$Dots$customAny(
		{fy: styleIndividual, fG: styleLegend});
};
var $author$project$LineChart$Junk$verticalCustom = F2(
	function (system, attributes) {
		return A2(
			$author$project$Internal$Svg$vertical,
			system,
			A2(
				$elm$core$List$cons,
				$author$project$LineChart$Junk$withinChartArea(system),
				attributes));
	});
var $author$project$LandingSite$MarketDetail$internestRateModelChartConfig = F3(
	function (userLanguage, selectedToken, model) {
		var borrowRatesDict = model.cG;
		var supplyRatesDict = model.dk;
		var computedUtilizationRate = $author$project$LandingSite$MarketDetailHelper$computeUtilizationRate(selectedToken);
		var activeUtilizationPoint = function () {
			var _v3 = _Utils_Tuple2(model.aP, model.b1);
			if (!_v3.a.$) {
				var dataPoint = _v3.a.a;
				return dataPoint.aC;
			} else {
				if (!_v3.b.$) {
					var _v4 = _v3.a;
					var restingPoint = _v3.b.a;
					return restingPoint;
				} else {
					return computedUtilizationRate;
				}
			}
		}();
		var activeUtilizationString = $author$project$Utils$NumberFormatter$formatRate(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Decimal$zero,
				$author$project$Decimal$fromFloat(activeUtilizationPoint)));
		var borrowRate = A2(
			$elm$core$Maybe$withDefault,
			0.0,
			A2($elm$core$Dict$get, activeUtilizationPoint, borrowRatesDict));
		var supplyRate = A2(
			$elm$core$Maybe$withDefault,
			0.0,
			A2($elm$core$Dict$get, activeUtilizationPoint, supplyRatesDict));
		return {
			hl: $author$project$LineChart$Area$default,
			kT: $author$project$LineChart$Container$custom(
				{
					dE: _List_Nil,
					dF: _List_Nil,
					ir: 'line-chart-area',
					eb: A4($author$project$LineChart$Container$Margin, 15, 8, 10, 8),
					by: $author$project$LineChart$Container$relative
				}),
			k5: $author$project$LandingSite$MarketDetail$testDotsConfig(activeUtilizationPoint),
			le: $author$project$LandingSite$MarketDetail$eventsConfig,
			bj: A2($author$project$LineChart$Grid$dots, 1, $author$project$LineChart$Colors$transparent),
			ix: $author$project$LineChart$Interpolation$linear,
			bk: $author$project$LineChart$Axis$Intersection$default,
			lI: $author$project$LineChart$Junk$custom(
				function (system) {
					var yMax = system.g7.ed;
					var supplyRateString = A2($myrho$elm_round$Round$round, 2, supplyRate);
					var borrowRateString = A2($myrho$elm_round$Round$round, 2, borrowRate);
					var _v0 = _Utils_Tuple2(supplyRate - (yMax * 0.11), supplyRate - (yMax * 0.04));
					var supplyRateLabelMinY = _v0.a;
					var supplyRateLabelMaxY = _v0.b;
					var _v1 = _Utils_Tuple2(borrowRate + (yMax * 0.11), borrowRate + (yMax * 0.04));
					var borrowRateLabelMinY = _v1.a;
					var borrowRateLabelMaxY = _v1.b;
					var _v2 = _Utils_Tuple2(activeUtilizationPoint - 7.0, activeUtilizationPoint + 7.0);
					var activePointLabelMinX = _v2.a;
					var activePointLabelMaxX = _v2.b;
					return {
						eG: _List_fromArray(
							[
								A8($author$project$LineChart$Junk$labelAt, system, activeUtilizationPoint, yMax, 0, -12, 'middle', $author$project$LineChart$Colors$black, activeUtilizationString),
								A2(
								$elm$svg$Svg$g,
								_List_fromArray(
									[
										$author$project$LineChart$Junk$transform(
										_List_fromArray(
											[
												A3($author$project$LineChart$Junk$move, system, computedUtilizationRate, yMax - (yMax * 0.15)),
												A2($author$project$LineChart$Junk$offset, 0, 0)
											])),
										$elm$svg$Svg$Attributes$style('text-anchor: middle;')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$text_,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('util-rate-label'),
												$elm$svg$Svg$Attributes$style('pointer-events: none;')
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$tspan,
												_List_Nil,
												_List_fromArray(
													[
														$elm$svg$Svg$text(
														$author$project$Strings$Translations$current(userLanguage))
													]))
											]))
									])),
								A6(
								$author$project$LineChart$Junk$rectangle,
								system,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('rgba(255,255,255,0.9)')
									]),
								activePointLabelMinX,
								activePointLabelMaxX,
								borrowRateLabelMinY,
								borrowRateLabelMaxY),
								A8($author$project$LineChart$Junk$labelAt, system, activeUtilizationPoint, borrowRate, 0, -16, 'middle', $author$project$LineChart$Colors$borrow, borrowRateString + '%'),
								A6(
								$author$project$LineChart$Junk$rectangle,
								system,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill('rgba(255,255,255,0.9)')
									]),
								activePointLabelMinX,
								activePointLabelMaxX,
								supplyRateLabelMinY,
								supplyRateLabelMaxY),
								A8($author$project$LineChart$Junk$labelAt, system, activeUtilizationPoint, supplyRate, 0, 26, 'middle', $author$project$LineChart$Colors$supply, supplyRateString + '%')
							]),
						cE: _List_fromArray(
							[
								A5(
								$author$project$LineChart$Junk$verticalCustom,
								system,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke(
										$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$grayLightest))
									]),
								activeUtilizationPoint,
								borrowRate + (yMax * 0.12),
								yMax),
								A5(
								$author$project$LineChart$Junk$verticalCustom,
								system,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke(
										$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$grayLightest))
									]),
								activeUtilizationPoint,
								supplyRate,
								borrowRate),
								A5(
								$author$project$LineChart$Junk$verticalCustom,
								system,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$stroke(
										$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$black))
									]),
								computedUtilizationRate,
								yMax - (yMax * 0.1),
								yMax - (yMax * 0.02))
							]),
						lv: _List_Nil
					};
				}),
			iG: $author$project$LineChart$Legends$none,
			c3: $author$project$LineChart$Line$wider(4),
			ab: A2(
				$author$project$LineChart$Axis$none,
				465,
				function ($) {
					return $.aC;
				}),
			ad: A2(
				$author$project$LineChart$Axis$none,
				350,
				function ($) {
					return $.jt;
				})
		};
	});
var $author$project$Strings$Translations$utilization_vs_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Utilization vs. APY';
		case 1:
			return 'Utilización vs. APY';
		case 2:
			return '利用率与APY';
		case 3:
			return 'Utilisation vs APY';
		default:
			return '이용률 vs. APY';
	}
};
var $author$project$LandingSite$MarketDetail$interestRateModel = F3(
	function (userLanguage, maybeSelectedToken, model) {
		var utilizationRates = model.dx;
		var borrowRates = model.cF;
		var supplyRates = model.dj;
		if (!maybeSelectedToken.$) {
			var selectedToken = maybeSelectedToken.a;
			var chartLines = _List_fromArray(
				[
					A4($author$project$LineChart$line, $author$project$LineChart$Colors$black, $author$project$LineChart$Dots$circle, 'Utilization', utilizationRates),
					A4($author$project$LineChart$line, $author$project$LineChart$Colors$borrow, $author$project$LineChart$Dots$circle, 'Borrow', borrowRates),
					A4($author$project$LineChart$line, $author$project$LineChart$Colors$supply, $author$project$LineChart$Dots$circle, 'Supply', supplyRates)
				]);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$interest_rate_model(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('chart-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$utilization_vs_apy(userLanguage))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('interest-rate-chart')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('chart formula-graph')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$LineChart$viewCustom,
												A3($author$project$LandingSite$MarketDetail$internestRateModelChartConfig, userLanguage, selectedToken, model),
												chartLines)
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$interest_rate_model(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('chart-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$utilization_vs_apy(userLanguage))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('interest-rate-chart')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('formula-graph formula-graph--loading')
											]),
										_List_Nil)
									]))
							]))
					]));
		}
	});
var $author$project$Strings$Translations$collateral_factor = function (lang) {
	switch (lang) {
		case 0:
			return 'Collateral Factor';
		case 1:
			return 'Factor colateral';
		case 2:
			return '抵押因素';
		case 3:
			return 'Facteur de garantie';
		default:
			return '담보 비율';
	}
};
var $author$project$Strings$Translations$ctoken_minted = F2(
	function (lang, cToken) {
		switch (lang) {
			case 0:
				return '' + (cToken + ' Minted');
			case 1:
				return '' + (cToken + ' acuñada');
			case 2:
				return '' + (cToken + '记念');
			case 3:
				return '' + (cToken + ' Frappé');
			default:
				return '채굴된 ' + (cToken + '');
		}
	});
var $author$project$Strings$Translations$exchange_rate = function (lang) {
	switch (lang) {
		case 0:
			return 'Exchange Rate';
		case 1:
			return 'Tipo de cambio';
		case 2:
			return '兑换率';
		case 3:
			return 'Taux de change';
		default:
			return '교환 비율';
	}
};
var $author$project$Utils$NumberFormatter$formatCollateralFactor = function (decimalValue) {
	return A3(
		$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		0,
		false,
		$author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue)) + '%';
};
var $author$project$Utils$NumberFormatter$formatTokenBalanceInNumberSpec = function (decimalValue) {
	var roundedDecimals = A2(
		$author$project$Decimal$lt,
		decimalValue,
		$author$project$Decimal$fromInt(10)) ? 4 : (A2(
		$author$project$Decimal$lt,
		decimalValue,
		$author$project$Decimal$fromInt(1000)) ? 2 : 0);
	var roundedValue = A2($author$project$Decimal$truncate, -roundedDecimals, decimalValue);
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return _Utils_ap(
		signString,
		A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, roundedDecimals, true, absoluteDecimalValue));
};
var $author$project$Utils$NumberFormatter$formatTokenBalanceInNumberSpecWithSymbol = F2(
	function (decimalValue, symbol) {
		return $author$project$Utils$NumberFormatter$formatTokenBalanceInNumberSpec(decimalValue) + (' ' + symbol);
	});
var $author$project$Strings$Translations$interest_per_day = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest Paid/Day';
		case 1:
			return 'Intereses pagados / día';
		case 2:
			return '每日已支付的利息';
		case 3:
			return 'Intérêts payés / jour';
		default:
			return '납입된 이자/일';
	}
};
var $author$project$Strings$Translations$market_details = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Details';
		case 1:
			return 'Detalles del mercado';
		case 2:
			return '市场详情';
		case 3:
			return 'Détails du marché';
		default:
			return '마켓 세부 사항';
	}
};
var $author$project$Strings$Translations$market_liquidity = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Liquidity';
		case 1:
			return 'Liquidez de mercado';
		case 2:
			return '市场流动性';
		case 3:
			return 'Liquidité du marché';
		default:
			return '마켓 유동성';
	}
};
var $author$project$Strings$Translations$price = function (lang) {
	switch (lang) {
		case 0:
			return 'Price';
		case 1:
			return 'Precio';
		case 2:
			return '价格';
		case 3:
			return 'Prix';
		default:
			return '가격';
	}
};
var $author$project$Strings$Translations$reserve_factor = function (lang) {
	switch (lang) {
		case 0:
			return 'Reserve Factor';
		case 1:
			return 'Factor de reserva';
		case 2:
			return '储量因素';
		case 3:
			return 'Facteur de réserve';
		default:
			return 'Reserve Factor';
	}
};
var $author$project$Strings$Translations$reserves = function (lang) {
	switch (lang) {
		case 0:
			return 'Reserves';
		case 1:
			return 'Reservas';
		case 2:
			return '储备金';
		case 3:
			return 'Réserves';
		default:
			return '준비금';
	}
};
var $author$project$LandingSite$MarketDetail$marketDetails = F4(
	function (userLanguage, latestTokens, maybeSelectedToken, underlyingSymbol) {
		if (!maybeSelectedToken.$) {
			var selectedToken = maybeSelectedToken.a;
			var underlyingTokenFormatter = function (value) {
				return A2($author$project$Utils$NumberFormatter$formatTokenBalanceInNumberSpecWithSymbol, value, selectedToken.j4);
			};
			var maybeEtherPrice = A2(
				$elm$core$Maybe$andThen,
				function (tokens) {
					return $author$project$Utils$LandingPricesHelper$usdPerEth(tokens.kG);
				},
				latestTokens);
			var priceFormatter = function (ethValue) {
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Preferences$getPlaceholderPrefCurrency(1),
					A4(
						$author$project$Preferences$formatDisplayCurrency,
						false,
						1,
						maybeEtherPrice,
						$author$project$Preferences$EthValue(ethValue)));
			};
			var interestPaidPerDaySpan = function () {
				var maybeInterestPerDayInAssetTerms = A2(
					$author$project$Decimal$fastdiv,
					A2($author$project$Decimal$mul, selectedToken.kA, selectedToken.no),
					$author$project$Decimal$fromInt(365));
				var interestPerDayString = A2(
					$elm$core$Maybe$withDefault,
					'—',
					A2(
						$elm$core$Maybe$map,
						function (interestPerDayInAssetTerms) {
							return priceFormatter(interestPerDayInAssetTerms);
						},
						maybeInterestPerDayInAssetTerms));
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(interestPerDayString)
						]));
			}();
			var exchangeRateFormatter = function (exchangeRate) {
				return A2(
					$elm$core$Maybe$withDefault,
					'–',
					A2(
						$elm$core$Maybe$map,
						function (result) {
							return '1 ' + (selectedToken.j4 + (' = ' + ($author$project$Decimal$toString(result) + (' ' + selectedToken.jS))));
						},
						A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, exchangeRate)));
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$market_details(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('form')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$price(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														priceFormatter(selectedToken.j3))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$market_liquidity(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														underlyingTokenFormatter(selectedToken.kH))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$number_suppliers(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(selectedToken.l4))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$number_borrowers(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(selectedToken.l3))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$interest_per_day(userLanguage))
													])),
												interestPaidPerDaySpan
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$reserves(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														underlyingTokenFormatter(selectedToken.my))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$reserve_factor(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$NumberFormatter$formatCollateralFactor(selectedToken.mx))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$collateral_factor(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$NumberFormatter$formatCollateralFactor(selectedToken.kN))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Strings$Translations$ctoken_minted, userLanguage, selectedToken.jS))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Utils$NumberFormatter$formatTokenBalanceInNumberSpecWithSymbol, selectedToken.nw, ''))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$exchange_rate(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														exchangeRateFormatter(selectedToken.lg))
													]))
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$market_details(userLanguage))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('form')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$price(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$market_liquidity(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$number_suppliers(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$number_borrowers(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$interest_per_day(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$reserves(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$reserve_factor(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$collateral_factor(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Strings$Translations$ctoken_minted, userLanguage, 'c' + underlyingSymbol))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('calculation')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('description')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$exchange_rate(userLanguage))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('value--loading')
													]),
												_List_Nil)
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Strings$Translations$distribution_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Distribution APY';
		case 1:
			return 'Distribución APY';
		case 2:
			return '分销APY';
		case 3:
			return 'Distribution APY';
		default:
			return '유통 APY';
	}
};
var $author$project$Strings$Translations$net_rate = function (lang) {
	switch (lang) {
		case 0:
			return 'Net Rate';
		case 1:
			return 'Tasa neta';
		case 2:
			return '净费率';
		case 3:
			return 'Taux net';
		default:
			return '순 요율';
	}
};
var $author$project$Strings$Translations$net_rate_description = function (lang) {
	switch (lang) {
		case 0:
			return 'This rate blends the Supply or Borrow APY with the COMP Distribution APY based on the current price of COMP.';
		case 1:
			return 'Esta tasa combina el APY de suministro / préstamo con el APY de distribución COMP basado en el precio actual de COMP.';
		case 2:
			return '该费率根据COMP的当前价格将供应/借出APY与COMP分配APY混合在一起。';
		case 3:
			return 'Ce taux combine l\'APY d\'approvisionnement / d\'emprunt avec l\'APY de distribution COMP basé sur le prix actuel de COMP.';
		default:
			return '이 요율은 현재 COMP 가격을 기준으로 공급 / 차입 APY와 COMP 배포 APY를 혼합합니다.';
	}
};
var $author$project$LandingSite$MarketDetail$ratesAndTotalsViews = F4(
	function (userLanguage, maybeEtherPrice, maybeSelectedToken, _v0) {
		var activeTab = _v0.bG;
		var maybeCompDistributionResponse = _v0.ee;
		var totalsDollarFormatter = function (value) {
			var _v3 = A3($author$project$Preferences$formatMarketSize, 1, maybeEtherPrice, value);
			if (!_v3.$) {
				var string = _v3.a;
				return $elm$html$Html$text(string);
			} else {
				return $elm$html$Html$text(
					$author$project$Preferences$getPlaceholderPrefCurrency(1));
			}
		};
		var marketTotalColumn = function () {
			var headerLabel = (!activeTab) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$total_supply(userLanguage))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$total_borrow(userLanguage))
					]));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('balance')
					]),
				_List_fromArray(
					[
						headerLabel,
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('subtitle subtitle--loading')
								]),
							_List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (selectedToken) {
								return (!activeTab) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											totalsDollarFormatter(
											$author$project$Preferences$EthValue(selectedToken.nx))
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											totalsDollarFormatter(
											$author$project$Preferences$EthValue(selectedToken.no))
										]));
							},
							maybeSelectedToken))
					]));
		}();
		var etherPriceOrZero = A2($elm$core$Maybe$withDefault, $author$project$Decimal$zero, maybeEtherPrice);
		var apyFormatter = function (rate) {
			return $elm$html$Html$text(
				$author$project$Utils$NumberFormatter$formatRate(
					A2(
						$author$project$Decimal$mul,
						$author$project$Decimal$fromInt(100),
						rate)));
		};
		var compDistributionColumn = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('balance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('icon COMP')
								]),
							_List_Nil),
							$elm$html$Html$text(
							$author$project$Strings$Translations$distribution_apy(userLanguage))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subtitle subtitle--loading')
							]),
						_List_Nil),
					A3(
						$author$project$Functions$map2,
						maybeSelectedToken,
						maybeCompDistributionResponse,
						F2(
							function (selectedToken, compDistribution) {
								var maybeCompMarket = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (market) {
											return _Utils_eq(market.jS, selectedToken.jS);
										},
										compDistribution.iN));
								var distributionAPYs = function () {
									if (!maybeCompMarket.$) {
										var market = maybeCompMarket.a;
										return A3($author$project$Utils$CompHelper$calculateDistributionAPY, etherPriceOrZero, selectedToken, market);
									} else {
										return {hq: $author$project$Decimal$zero, jP: $author$project$Decimal$zero};
									}
								}();
								return (!activeTab) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(distributionAPYs.jP)
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(distributionAPYs.hq)
										]));
							})))
				]));
		var netRateColumn = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('balance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('tooltip')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('underlined-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$net_rate(userLanguage))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text tooltip__text--left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text__headline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$net_rate(userLanguage))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('tooltip__text__subtext tooltip__text__subtext--grey')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$net_rate_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subtitle subtitle--loading')
							]),
						_List_Nil),
					A3(
						$author$project$Functions$map2,
						maybeSelectedToken,
						maybeCompDistributionResponse,
						F2(
							function (selectedToken, compDistribution) {
								var maybeCompMarket = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (market) {
											return _Utils_eq(market.jS, selectedToken.jS);
										},
										compDistribution.iN));
								var distributionAPYs = function () {
									if (!maybeCompMarket.$) {
										var market = maybeCompMarket.a;
										return A3($author$project$Utils$CompHelper$calculateDistributionAPY, etherPriceOrZero, selectedToken, market);
									} else {
										return {hq: $author$project$Decimal$zero, jP: $author$project$Decimal$zero};
									}
								}();
								return (!activeTab) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(
											A2($author$project$Decimal$add, selectedToken.mZ, distributionAPYs.jP))
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(
											A2($author$project$Decimal$sub, selectedToken.kA, distributionAPYs.hq))
										]));
							})))
				]));
		var supplyBorrowApyColumn = function () {
			var underlyingSymbol = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.j4;
					},
					maybeSelectedToken));
			var headerLabel = (!activeTab) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('icon ' + underlyingSymbol)
							]),
						_List_Nil),
						$elm$html$Html$text(
						$author$project$Strings$Translations$supply_apy(userLanguage))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('icon ' + underlyingSymbol)
							]),
						_List_Nil),
						$elm$html$Html$text(
						$author$project$Strings$Translations$borrow_apy(userLanguage))
					]));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('balance')
					]),
				_List_fromArray(
					[
						headerLabel,
						A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('subtitle subtitle--loading')
								]),
							_List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (selectedToken) {
								return (!activeTab) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(selectedToken.mZ)
										])) : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('subtitle')
										]),
									_List_fromArray(
										[
											apyFormatter(selectedToken.kA)
										]));
							},
							maybeSelectedToken))
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[netRateColumn, supplyBorrowApyColumn, compDistributionColumn, marketTotalColumn]));
	});
var $author$project$LandingSite$MarketDetail$view = F4(
	function (userLanguage, latestTokens, graphModel, model) {
		var maybeSelectedUnderlyingSymbol = model.cc;
		var activeTab = model.bG;
		var doubleGraphHoverTime = model.bb;
		var maybeCompDistributionResponse = model.ee;
		var tabOptionClass = function (tab) {
			return _Utils_eq(tab, activeTab) ? ((!tab) ? 'tab-group__option tab-group__option--active tab-group__option--active--green' : 'tab-group__option tab-group__option--active tab-group__option--active--purple') : 'tab-group__option tab-group__option--landing-grey';
		};
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(maybeSelectedUnderlyingSymbol, latestTokens);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var underlyingSymbol = _v1.a.a;
				var tokens = _v1.b.a;
				return _Utils_Tuple2(
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (cToken) {
								return _Utils_eq(cToken.j4, underlyingSymbol);
							},
							tokens.kG)),
					$author$project$Utils$LandingPricesHelper$usdPerEth(tokens.kG));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var maybeSelectedCToken = _v0.a;
		var maybeEtherPrice = _v0.b;
		var selectedUnderlyingName = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, '', maybeSelectedUnderlyingSymbol),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.j2;
				},
				maybeSelectedCToken));
		var selectedUnderlyingSymbol = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, '', maybeSelectedUnderlyingSymbol),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.j4;
				},
				maybeSelectedCToken));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('MarketDetail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('breadcrumb')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class('breadcrumb__link'),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$markets(userLanguage))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('breadcrumb__separator')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('breadcrumb__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(selectedUnderlyingSymbol)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row align-between')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('identity')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon ' + selectedUnderlyingSymbol)
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('name')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(selectedUnderlyingName)
																]))
														]))
												])),
											A4($author$project$LandingSite$MarketDetail$ratesAndTotalsViews, userLanguage, maybeEtherPrice, maybeSelectedCToken, model)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('tab-group graph__tab-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('tab-group__options')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class(
															tabOptionClass(0)),
															$elm$html$Html$Events$onClick(
															$author$project$LandingSite$MarketDetail$ForSelf(
																$author$project$LandingSite$MarketDetail$SelectTab(0)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$supply(userLanguage))
														])),
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class(
															tabOptionClass(1)),
															$elm$html$Html$Events$onClick(
															$author$project$LandingSite$MarketDetail$ForSelf(
																$author$project$LandingSite$MarketDetail$SelectTab(1)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$borrow(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('tab-group__line')
												]),
											_List_Nil)
										])),
									A5($author$project$LandingSite$MarketDetail$doubleGraphView, userLanguage, maybeSelectedCToken, activeTab, doubleGraphHoverTime, graphModel)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A3($author$project$LandingSite$MarketDetail$interestRateModel, userLanguage, maybeSelectedCToken, model)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
														]),
													_List_fromArray(
														[
															A4($author$project$LandingSite$MarketDetail$marketDetails, userLanguage, latestTokens, maybeSelectedCToken, selectedUnderlyingSymbol)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$all_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'All Markets';
		case 1:
			return 'Todos los mercados';
		case 2:
			return '所有市场';
		case 3:
			return 'Tous les marchés';
		default:
			return '모든 마켓';
	}
};
var $author$project$LandingSite$Markets$deltaSpan = F2(
	function (delta, formatter) {
		var rounded = A2($author$project$Decimal$round, -2, delta);
		var _v0 = A2($author$project$Decimal$compare, rounded, $author$project$Decimal$zero);
		switch (_v0) {
			case 2:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change up')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'+' + formatter(rounded))
						]));
			case 0:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change down')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							formatter(rounded))
						]));
			default:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change neutral')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('–')
						]));
		}
	});
var $author$project$LandingSite$Markets$percentGrowth = F2(
	function (latest, historic) {
		var _v0 = A2($author$project$Decimal$fastdiv, latest, historic);
		if (!_v0.$) {
			var d = _v0.a;
			return A2(
				$author$project$Decimal$mul,
				$author$project$Decimal$fromInt(100),
				A2($author$project$Decimal$sub, d, $author$project$Decimal$one));
		} else {
			return $author$project$Decimal$zero;
		}
	});
var $author$project$LandingSite$Markets$assetRow = F2(
	function (dollarFormatter, _v0) {
		var latestToken = _v0.a;
		var maybeHistoricToken = _v0.b;
		var historicToken = function () {
			if (!maybeHistoricToken.$) {
				var t = maybeHistoricToken.a;
				return t;
			} else {
				return latestToken;
			}
		}();
		var supplyDeltaPercent = A2($author$project$LandingSite$Markets$percentGrowth, latestToken.nw, historicToken.nw);
		var supplyRateDelta = A2(
			$author$project$Decimal$mul,
			$author$project$Decimal$fromInt(100),
			A2($author$project$Decimal$sub, latestToken.mZ, historicToken.mZ));
		var changeSpanChooser = F2(
			function (deltaPercent, formatter) {
				return _Utils_eq(maybeHistoricToken, $elm$core$Maybe$Nothing) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
						]),
					_List_Nil) : A2($author$project$LandingSite$Markets$deltaSpan, deltaPercent, formatter);
			});
		var borrowRateDelta = A2(
			$author$project$Decimal$mul,
			$author$project$Decimal$fromInt(100),
			A2($author$project$Decimal$sub, latestToken.kA, historicToken.kA));
		var borrowDeltaPercent = A2($author$project$LandingSite$Markets$percentGrowth, latestToken.np, historicToken.np);
		var apyFormatter = function (rate) {
			return $elm$html$Html$text(
				$author$project$Utils$NumberFormatter$formatRate(
					A2(
						$author$project$Decimal$mul,
						$author$project$Decimal$fromInt(100),
						rate)));
		};
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('asset'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$MarketDetail(latestToken.j4)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-5 identity')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('icon ' + latestToken.j4)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(latestToken.j2)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('symbol')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(latestToken.j4)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(
									$author$project$Preferences$EthValue(latestToken.nx))
								])),
							A2(changeSpanChooser, supplyDeltaPercent, $author$project$Utils$NumberFormatter$formatRate)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									apyFormatter(latestToken.mZ)
								])),
							A2(changeSpanChooser, supplyRateDelta, $author$project$Decimal$toString)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(
									$author$project$Preferences$EthValue(latestToken.no))
								])),
							A2(changeSpanChooser, borrowDeltaPercent, $author$project$Utils$NumberFormatter$formatRate)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									apyFormatter(latestToken.kA)
								])),
							A2(changeSpanChooser, borrowRateDelta, $author$project$Decimal$toString)
						]))
				]));
	});
var $author$project$LandingSite$Markets$loadingAssetRow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('asset')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-5 identity')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('icon icon--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('name name--loading')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('symbol symbol--loading')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('gross-total gross-total--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('gross-total gross-total--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('gross-total gross-total--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('gross-total gross-total--loading')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
						]),
					_List_Nil)
				]))
		]));
var $author$project$LandingSite$Markets$Borrow = 1;
var $author$project$LandingSite$Markets$Supply = 0;
var $author$project$LandingSite$Markets$loadingMarketBars = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Utils$CompoundHtmlAttributes$class('market-bar market-bar--loading')
		]),
	_List_Nil);
var $author$project$Strings$Translations$top_3_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Top 3 Markets';
		case 1:
			return 'Los 3 principales mercados';
		case 2:
			return 'Top 3 市场';
		case 3:
			return '3 principaux marchés';
		default:
			return '마켓 Top 3';
	}
};
var $author$project$LandingSite$Markets$topMarketsBars = F4(
	function (userLanguage, cardType, topTokens, total) {
		var _v0 = function () {
			if (cardType === 1) {
				return _Utils_Tuple2(
					function ($) {
						return $.no;
					},
					'borrow');
			} else {
				return _Utils_Tuple2(
					function ($) {
						return $.nx;
					},
					'supply');
			}
		}();
		var totalValue = _v0.a;
		var classType = _v0.b;
		var percentOfTotal = function (token) {
			return $author$project$Utils$NumberFormatter$formatRate(
				A2(
					$author$project$Decimal$mul,
					$author$project$Decimal$fromInt(100),
					function () {
						var _v2 = A2(
							$author$project$Decimal$fastdiv,
							totalValue(token),
							total);
						if (!_v2.$) {
							var percent = _v2.a;
							return percent;
						} else {
							return $author$project$Decimal$zero;
						}
					}()));
		};
		var tokenBar = function (token) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('market-bar ' + classType)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(token.j4)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										percentOfTotal(token))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('bar ' + classType)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('fill ' + classType),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										percentOfTotal(token))
									]),
								_List_Nil)
							]))
					]));
		};
		var barsContent = $elm$core$List$isEmpty(topTokens) ? A2($elm$core$List$repeat, 3, $author$project$LandingSite$Markets$loadingMarketBars) : A2($elm$core$List$map, tokenBar, topTokens);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$top_3_markets(userLanguage))
						])),
				barsContent));
	});
var $author$project$Strings$Translations$twenty_four_hour_borrow = function (lang) {
	switch (lang) {
		case 0:
			return '24H Borrow Volume';
		case 1:
			return 'Volumen prestado las 24 horas';
		case 2:
			return '24小时借款量';
		case 3:
			return 'Volume d\'emprunt 24H';
		default:
			return '24H 대출 및 상환';
	}
};
var $author$project$Strings$Translations$twenty_four_hour_supply = function (lang) {
	switch (lang) {
		case 0:
			return '24H Supply Volume';
		case 1:
			return 'Volumen de suministro 24H';
		case 2:
			return '24小时供应量';
		case 3:
			return 'Volume d\'approvisionnement 24H';
		default:
			return '24H 공급';
	}
};
var $author$project$LandingSite$Markets$totalCard = F6(
	function (userLanguage, cardType, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter) {
		var reduceTotals = F2(
			function (tokens, valueFun) {
				return A3(
					$elm$core$List$foldl,
					$author$project$Decimal$add,
					$author$project$Decimal$zero,
					A2($elm$core$List$map, valueFun, tokens));
			});
		var currentValue = function (oldToken) {
			var todaysData = function () {
				var _v9 = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.i5, oldToken.i5);
						},
						latestTokens));
				if (!_v9.$) {
					var token = _v9.a;
					return token;
				} else {
					return oldToken;
				}
			}();
			if (!cardType) {
				return A2(
					$author$project$Decimal$round,
					-2,
					A2(
						$author$project$Decimal$mul,
						todaysData.j3,
						A2($author$project$Decimal$mul, todaysData.lg, oldToken.nw)));
			} else {
				return A2(
					$author$project$Decimal$round,
					-2,
					A2($author$project$Decimal$mul, todaysData.j3, oldToken.np));
			}
		};
		var maybeHistoricTotal = function () {
			if (!maybeHistoricTokens.$) {
				var historicTokens = maybeHistoricTokens.a;
				return $elm$core$Maybe$Just(
					A2(reduceTotals, historicTokens, currentValue));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			if (!cardType) {
				return _Utils_Tuple3(
					$author$project$Strings$Translations$total_supply(userLanguage),
					$author$project$Strings$Translations$number_suppliers(userLanguage),
					$author$project$Strings$Translations$twenty_four_hour_supply(userLanguage));
			} else {
				return _Utils_Tuple3(
					$author$project$Strings$Translations$total_borrow(userLanguage),
					$author$project$Strings$Translations$number_borrowers(userLanguage),
					$author$project$Strings$Translations$twenty_four_hour_borrow(userLanguage));
			}
		}();
		var header = _v0.a;
		var userCountText = _v0.b;
		var volumeText = _v0.c;
		var _v2 = function () {
			if (!cardType) {
				return _Utils_Tuple3(
					function ($) {
						return $.nx;
					},
					function ($) {
						return $.nB;
					},
					function ($) {
						return $.nw;
					});
			} else {
				return _Utils_Tuple3(
					function ($) {
						return $.no;
					},
					function ($) {
						return $.nA;
					},
					function ($) {
						return $.np;
					});
			}
		}();
		var valueKey = _v2.a;
		var userKey = _v2.b;
		var nativeAmountKey = _v2.c;
		var usersString = function () {
			if (!maybeMetadata.$) {
				var metadata = maybeMetadata.a;
				return $elm$core$String$fromInt(
					userKey(metadata));
			} else {
				return '-';
			}
		}();
		var totalUsersContent = _Utils_eq(maybeMetadata, $elm$core$Maybe$Nothing) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('text-large total total--loading')
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('text-large total')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(usersString)
				]));
		var tokenSorter = F2(
			function (a, b) {
				return A2(
					$author$project$Decimal$compare,
					valueKey(b),
					valueKey(a));
			});
		var topAssets = A2(
			$elm$core$List$take,
			3,
			A2($elm$core$List$sortWith, tokenSorter, latestTokens));
		var total = A2(reduceTotals, latestTokens, valueKey);
		var _v4 = function () {
			if (!maybeHistoricTotal.$) {
				var historicTotal = maybeHistoricTotal.a;
				return _Utils_Tuple2(
					A2($author$project$LandingSite$Markets$percentGrowth, total, historicTotal),
					dollarFormatter(
						$author$project$Preferences$EthValue(
							A2($author$project$Decimal$sub, total, historicTotal))));
			} else {
				return _Utils_Tuple2(
					$author$project$Decimal$zero,
					$elm$html$Html$text(
						$author$project$Preferences$getPlaceholderPrefCurrency(1)));
			}
		}();
		var delta = _v4.a;
		var twentyFourHourVolumeText = _v4.b;
		var volumeTotalContent = _Utils_eq(maybeHistoricTotal, $elm$core$Maybe$Nothing) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('text-large total total--loading')
				]),
			_List_Nil) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('text-large total')
				]),
			_List_fromArray(
				[twentyFourHourVolumeText]));
		var totalsHeading = $elm$core$List$isEmpty(latestTokens) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('grand-total grand-total--loading')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
					]),
				_List_Nil)
			]) : (_Utils_eq(maybeHistoricTotal, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						dollarFormatter(
						$author$project$Preferences$EthValue(total))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('change change--loading')
					]),
				_List_Nil)
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						dollarFormatter(
						$author$project$Preferences$EthValue(total))
					])),
				A2($author$project$LandingSite$Markets$deltaSpan, delta, $author$project$Utils$NumberFormatter$formatRate)
			]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(header)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('totals-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('text-largest')
								]),
							totalsHeading),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('bars-row')
								]),
							_List_fromArray(
								[
									A4($author$project$LandingSite$Markets$topMarketsBars, userLanguage, cardType, topAssets, total)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('demi row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(volumeText)
												])),
											volumeTotalContent
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(userCountText)
												])),
											totalUsersContent
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Markets$marketTotals = F5(
	function (userLanguage, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A6($author$project$LandingSite$Markets$totalCard, userLanguage, 0, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A6($author$project$LandingSite$Markets$totalCard, userLanguage, 1, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter)
						]))
				]));
	});
var $author$project$Strings$Translations$market_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Overview';
		case 1:
			return 'Visión general del mercado';
		case 2:
			return '市场概况';
		case 3:
			return 'Aperçu du marché';
		default:
			return '마켓 개요';
	}
};
var $author$project$LandingSite$Markets$view = F2(
	function (userLanguage, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.ax, model.lu);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var tokens = _v1.a.a;
					var oldTokens = _v1.b.a;
					return _Utils_Tuple3(
						tokens.kG,
						tokens.lU,
						$elm$core$Maybe$Just(oldTokens.kG));
				} else {
					var tokens = _v1.a.a;
					return _Utils_Tuple3(tokens.kG, tokens.lU, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple3(_List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var latestTokens = _v0.a;
		var maybeMetadata = _v0.b;
		var maybeHistoricTokens = _v0.c;
		var etherPrice = $author$project$Utils$LandingPricesHelper$usdPerEth(latestTokens);
		var templateDollarFormatter = F2(
			function (formatter, value) {
				var _v3 = A3(formatter, 1, etherPrice, value);
				if (!_v3.$) {
					var string = _v3.a;
					return $elm$html$Html$text(string);
				} else {
					return $elm$html$Html$text(
						$author$project$Preferences$getPlaceholderPrefCurrency(1));
				}
			});
		var assetRowDollarFormatter = function (tokenValue) {
			return A2(templateDollarFormatter, $author$project$Preferences$formatMarketSize, tokenValue);
		};
		var marketTotalDollarFormatter = function (tokenValue) {
			return A2(
				templateDollarFormatter,
				$author$project$Preferences$formatDisplayCurrency(false),
				tokenValue);
		};
		var historyDict = function () {
			if (!maybeHistoricTokens.$) {
				var historicTokens = maybeHistoricTokens.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (token) {
							return _Utils_Tuple2(token.jY, token);
						},
						historicTokens));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		var matchWithHistoric = function (cToken) {
			return _Utils_Tuple2(
				cToken,
				A2($elm$core$Dict$get, cToken.jY, historyDict));
		};
		var assetRows = $elm$core$List$isEmpty(latestTokens) ? A2($elm$core$List$repeat, 7, $author$project$LandingSite$Markets$loadingAssetRow) : A2(
			$elm$core$List$map,
			$author$project$LandingSite$Markets$assetRow(assetRowDollarFormatter),
			A2(
				$elm$core$List$map,
				matchWithHistoric,
				A2(
					$elm$core$List$sortWith,
					F2(
						function (a, b) {
							return A2(
								$author$project$Decimal$compare,
								function ($) {
									return $.nx;
								}(b),
								function ($) {
									return $.nx;
								}(a));
						}),
					latestTokens)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Markets')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$market_overview(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A5($author$project$LandingSite$Markets$marketTotals, userLanguage, latestTokens, maybeMetadata, maybeHistoricTokens, marketTotalDollarFormatter),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h4,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$all_markets(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-5')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$market(userLanguage))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$total_supply(userLanguage))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$supply_apy(userLanguage))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$total_borrow(userLanguage))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$borrow_apy(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('assets')
														]),
													assetRows)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Prices$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Prices$ToggleAccordianAtIndex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Strings$Translations$fixed = function (lang) {
	switch (lang) {
		case 0:
			return 'Fixed';
		case 1:
			return 'Fijo';
		case 2:
			return '固定';
		case 3:
			return 'Fixé';
		default:
			return '결정된';
	}
};
var $author$project$LandingSite$Prices$assetCard = F3(
	function (userLanguage, maybeCurrentTime, _v0) {
		var asset = _v0.a;
		var maybeHistoricAsset = _v0.b;
		var priceTime = function () {
			if ((asset.jS === 'USDC') || (asset.jS === 'USDT')) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$fixed(userLanguage))
								]))
						]));
			} else {
				var _v4 = _Utils_Tuple2(maybeCurrentTime, asset.mm);
				if ((!_v4.a.$) && (!_v4.b.$)) {
					var currentTime = _v4.a.a;
					var timestampInSeconds = _v4.b.a;
					var priceTimePosix = $elm$time$Time$millisToPosix(1000 * timestampInSeconds);
					var timeDifference = A2($author$project$Utils$Time$differenceInSeconds, priceTimePosix, currentTime);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext-section')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Utils$Time$distanceTimeInWords, userLanguage, timeDifference))
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}
		}();
		var percentGrowth = F2(
			function (latest, historic) {
				var _v3 = A2($author$project$Decimal$fastdiv, latest, historic);
				if (!_v3.$) {
					var d = _v3.a;
					return A2(
						$author$project$Decimal$mul,
						$author$project$Decimal$fromInt(100),
						A2($author$project$Decimal$sub, d, $author$project$Decimal$one));
				} else {
					return $author$project$Decimal$zero;
				}
			});
		var imageUrl = 'images/icn-' + ($elm$core$String$toLower(asset.jS) + '-96x96.svg');
		var deltaView = F2(
			function (delta, formatter) {
				var rounded = A2($author$project$Decimal$round, -2, delta);
				var _v2 = A2($author$project$Decimal$compare, rounded, $author$project$Decimal$zero);
				switch (_v2) {
					case 2:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext prices-card__subtext--green')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'+' + formatter(rounded))
								]));
					case 0:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext prices-card__subtext--red')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									formatter(rounded))
								]));
					default:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('0.00%')
								]));
				}
			});
		var percentChange = function () {
			if (!maybeHistoricAsset.$) {
				var historicAsset = maybeHistoricAsset.a;
				return A2(
					deltaView,
					A2(percentGrowth, asset.mk, historicAsset.mk),
					$author$project$Utils$NumberFormatter$formatRate);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 col-sm-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('prices-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(asset.jS)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($author$project$Utils$NumberFormatter$formatUsd, false, asset.mk))
												])),
											percentChange
										])),
									priceTime
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__icon'),
									$author$project$Utils$CompoundHtmlAttributes$src(imageUrl)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Strings$Translations$assets = function (lang) {
	switch (lang) {
		case 0:
			return 'Assets';
		case 1:
			return 'Bienes';
		case 2:
			return '资产';
		case 3:
			return 'Les atouts';
		default:
			return '자산';
	}
};
var $author$project$Strings$Translations$open_price_feed = function (lang) {
	switch (lang) {
		case 0:
			return 'Open Price Feed';
		case 1:
			return 'Feed de precio abierto';
		case 2:
			return '开盘价饲料';
		case 3:
			return 'Flux de prix ouvert';
		default:
			return '공개 가격 피드';
	}
};
var $author$project$Strings$Translations$open_price_feed_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The Open Price Feed is a system to allow various sources (i.e. reporters) to sign off-chain data about prices and allow any Ethereum account to move that data on-chain.';
		case 1:
			return 'Open Price Feed es un sistema que permite a varias fuentes (es decir, reporteros) firmar datos fuera de la cadena sobre precios y permitir que cualquier cuenta de Ethereum mueva esos datos dentro de la cadena.';
		case 2:
			return 'Open Price Feed是一个系统，允许各种来源（即报告者）签署有关价格的链下数据，并允许任何以太坊账户在链上移动该数据。';
		case 3:
			return 'L\'Open Price Feed est un système permettant à diverses sources (c\'est-à-dire aux journalistes) de signer des données hors chaîne sur les prix et de permettre à tout compte Ethereum de déplacer ces données en chaîne.';
		default:
			return 'Open Price Feed는 다양한 소스 (예 : 리포터)가 가격에 대한 오프 체인 데이터에 서명하고 이더 리움 계정이 해당 데이터를 온 체인으로 이동할 수 있도록하는 시스템입니다.';
	}
};
var $author$project$Strings$Translations$anchor = function (lang) {
	switch (lang) {
		case 0:
			return 'Anchor';
		case 1:
			return 'Ancla';
		case 2:
			return '锚';
		case 3:
			return 'Ancre';
		default:
			return '닻';
	}
};
var $author$project$Strings$Translations$prices = function (lang) {
	switch (lang) {
		case 0:
			return 'prices';
		case 1:
			return 'precios';
		case 2:
			return '价格';
		case 3:
			return 'des prix';
		default:
			return '물가';
	}
};
var $author$project$LandingSite$Prices$reporterCard = F4(
	function (userLanguage, reporterName, numberOfPrices, isAnchor) {
		var imageUrl = 'images/icn-' + (A3(
			$elm$core$String$replace,
			' ',
			'',
			$elm$core$String$toLower(reporterName)) + '-96x96.svg');
		var anchorText = isAnchor ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('prices-card__subtext')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Strings$Translations$anchor(userLanguage))
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 col-sm-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('prices-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(reporterName)
										])),
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('prices-card__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											numberOfPrices + (' ' + $author$project$Strings$Translations$prices(userLanguage)))
										])),
									anchorText
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('prices-card__icon'),
									$author$project$Utils$CompoundHtmlAttributes$src(imageUrl)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Strings$Translations$reporters = function (lang) {
	switch (lang) {
		case 0:
			return 'Reporters';
		case 1:
			return 'Reporteros';
		case 2:
			return '记者';
		case 3:
			return 'Reporters';
		default:
			return '기자';
	}
};
var $author$project$LandingSite$Prices$view = F5(
	function (userLanguage, maybeCurrentTime, network, maybeConfig, model) {
		var maybePriceFeed = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.iY;
			},
			maybeConfig);
		var faqDisplayActive = function (index) {
			var faqState = A2($elm$core$Array$get, index, model.bd);
			var faqAccordianClass = function () {
				if ((!faqState.$) && faqState.a) {
					return ' active';
				} else {
					return '';
				}
			}();
			return faqAccordianClass;
		};
		var contractLink = function () {
			if (!maybePriceFeed.$) {
				var priceFeed = maybePriceFeed.a;
				return A4(
					$author$project$Eth$Ethereum$etherscanLink,
					$elm$core$Maybe$Just(network),
					$author$project$Eth$Ethereum$EtherscanAddress(
						$author$project$Eth$Ethereum$getContractAddressString(priceFeed)),
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link--gray'),
							$author$project$Utils$CompoundHtmlAttributes$target('_blank')
						]),
					_List_Nil);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.lJ, model.cX);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var prices = _v1.a.a;
					var oldPrices = _v1.b.a;
					return _Utils_Tuple2(
						prices,
						$elm$core$Maybe$Just(oldPrices));
				} else {
					var prices = _v1.a.a;
					return _Utils_Tuple2(prices, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
			}
		}();
		var latestPrices = _v0.a;
		var maybeHistoricPrices = _v0.b;
		var historyDict = function () {
			if (!maybeHistoricPrices.$) {
				var historicPrices = maybeHistoricPrices.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (token) {
							return _Utils_Tuple2(token.jS, token);
						},
						historicPrices));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		var matchWithHistoric = function (token) {
			return _Utils_Tuple2(
				token,
				A2($elm$core$Dict$get, token.jS, historyDict));
		};
		var priceCards = A2(
			$elm$core$List$map,
			A2($author$project$LandingSite$Prices$assetCard, userLanguage, maybeCurrentTime),
			A2(
				$elm$core$List$map,
				matchWithHistoric,
				A2(
					$elm$core$List$sortBy,
					function (token) {
						return token.jS;
					},
					latestPrices)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Prices')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('header-view')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('header-view__header-line')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('header-view__header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$open_price_feed(userLanguage))
														])),
													contractLink
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('header-view__subheader')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$open_price_feed_description(userLanguage))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													A2(
														$elm$core$List$cons,
														$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2($author$project$LandingSite$Page$Docs, 4, $elm$core$Maybe$Nothing)))),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$view_docs(userLanguage))
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
															$author$project$Utils$CompoundHtmlAttributes$class('arrow')
														]),
													_List_Nil)
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('prices')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('section-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$assets(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									priceCards)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('reporters')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('section-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$reporters(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A4($author$project$LandingSite$Prices$reporterCard, userLanguage, 'Coinbase Pro', '10', false),
											A4($author$project$LandingSite$Prices$reporterCard, userLanguage, 'Uniswap', '10', true)
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('faq-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$learn_more(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('faq-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 faqs')
												]),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
												$elm$core$List$concat(
													A2(
														$elm$core$List$indexedMap,
														F2(
															function (index, _v2) {
																var header = _v2.a;
																var content = _v2.b;
																return _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$class('accordian__item')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class('accordian__item__header'),
																						$elm$html$Html$Events$onClick(
																						$author$project$LandingSite$Prices$ToggleAccordianAtIndex(index))
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$h3,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('accordian__item__text accordian__item__text--light')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(header)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class(
																								'accordian__plus accordian__plus--light' + faqDisplayActive(index))
																							]),
																						_List_fromArray(
																							[
																								A2($elm$html$Html$span, _List_Nil, _List_Nil),
																								A2($elm$html$Html$span, _List_Nil, _List_Nil)
																							]))
																					])),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class(
																						'accordian__item__description accordian__item__description--light' + faqDisplayActive(index))
																					]),
																				content)
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$id('line')
																			]),
																		_List_Nil)
																	]);
															}),
														$author$project$LandingSite$Prices$accordianData(userLanguage)))))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Main$viewPage = function (model) {
	var configs = model.dT;
	var latestTokens = model.ax;
	var network = model.bo;
	var page = model._;
	var pages = model.aV;
	var userLanguage = model.aB;
	var maybeConfig = $author$project$LandingSite$Main$getConfig(model);
	var backPage = A2(
		$elm$core$Maybe$withDefault,
		$author$project$LandingSite$Page$GovernanceHome,
		$elm$core$List$head(pages));
	var pageMainContent = function () {
		switch (page.$) {
			case 0:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingHomeTranslator,
					A3($author$project$LandingSite$Home$view, userLanguage, latestTokens, model.aw));
			case 1:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingAboutTranslator,
					A2($author$project$LandingSite$About$view, userLanguage, model.b6));
			case 2:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCompTranslator,
					A5($author$project$LandingSite$Comp$view, userLanguage, network, maybeConfig, latestTokens, model.bl));
			case 3:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCTokensTranslator,
					A5($author$project$LandingSite$CTokens$view, userLanguage, maybeConfig, latestTokens, model.bi, model.av));
			case 4:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingDevelopersTranslator,
					A3($author$project$LandingSite$DevelopersMarketing$view, userLanguage, latestTokens, model.c$));
			case 5:
				var subPage = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingDocsTranslator,
					A4($author$project$LandingSite$Docs$view, userLanguage, subPage, configs, model.bm));
			case 6:
				return $elm$html$Html$text('');
			case 7:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingMarketsTranslator,
					A2($author$project$LandingSite$Markets$view, userLanguage, model.ak));
			case 8:
				var underlyingSymbol = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingMarketDetailTranslator,
					A4($author$project$LandingSite$MarketDetail$view, userLanguage, model.ax, model.bi, model.aj));
			case 9:
				var address = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$accountProfileTranslator,
					A7($author$project$Governance$AccountProfile$view, userLanguage, backPage, address, model.ba, model.t, network, model.bf));
			case 10:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$governanceHomeTranslator,
					A4($author$project$Governance$Home$view, userLanguage, model.ba, model.t, model.bX));
			case 11:
				var proposalId = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$proposalDetailTranslator,
					A7($author$project$Governance$ProposalDetail$view, userLanguage, network, backPage, proposalId, model.ba, model.t, model.bh));
			case 12:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$proposalOverviewTranslator,
					A4($author$project$Governance$ProposalOverview$view, userLanguage, model.ba, model.t, model.bZ));
			case 13:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$governanceLeaderboardTranslator,
					A2($author$project$Governance$Leaderboard$view, userLanguage, model.bY));
			default:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingPricesTranslator,
					A5($author$project$LandingSite$Prices$view, userLanguage, model.t, network, maybeConfig, model.al));
		}
	}();
	return pageMainContent;
};
var $author$project$LandingSite$Main$view = function (model) {
	var page = model._;
	var network = model.bo;
	var userLanguage = model.aB;
	var mobileMenuShowing = model.c6;
	var _v0 = model.cO;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var targetNetwork = _v1.a;
		var contractName = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					A3($author$project$LandingSite$AbiViewer$view, targetNetwork, contractName, model.eY)
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCommonTranslator,
					A3($author$project$LandingSite$CommonViews$pageHeader, userLanguage, page, mobileMenuShowing)),
					$author$project$LandingSite$Main$viewPage(model),
					A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCommonTranslator,
					A3($author$project$LandingSite$CommonViews$pageFooter, userLanguage, network, model.b7))
				]));
	}
};
var $author$project$LandingSite$Main$main = $elm$browser$Browser$element(
	{lB: $author$project$LandingSite$Main$init, mV: $author$project$LandingSite$Main$subscriptions, nC: $author$project$LandingSite$Main$update, j7: $author$project$LandingSite$Main$view});
_Platform_export({'LandingSite':{'Main':{'init':$author$project$LandingSite$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (targetNetwork) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (protoDocJson) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (path) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (language) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (configurations) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (configAbiFiles) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (apiBaseUrlMap) {
															return $elm$json$Json$Decode$succeed(
																{o: apiBaseUrlMap, eX: configAbiFiles, eZ: configurations, fC: language, gl: path, cj: protoDocJson, gP: targetNetwork});
														},
														A2($elm$json$Json$Decode$field, 'apiBaseUrlMap', $elm$json$Json$Decode$value));
												},
												A2($elm$json$Json$Decode$field, 'configAbiFiles', $elm$json$Json$Decode$value));
										},
										A2($elm$json$Json$Decode$field, 'configurations', $elm$json$Json$Decode$value));
								},
								A2($elm$json$Json$Decode$field, 'language', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'path', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'protoDocJson', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'targetNetwork', $elm$json$Json$Decode$string)))(0)}}});}(this));